(function() {
  'use strict';

  angular
    .module('quantumUiAngular', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ngRoute',
      'ui.bootstrap',
      'toastr',
      'ngtimeago',
      'ui.select',
      'mgo-angular-wizard',
      'angular.filter',
      'angularValidator',
      'leaflet-directive',
      'angular-ladda',
      'xml',
      'ngCsvImport',
      'ngAudio',
      'ngBootstrap',
      'angularjs-dropdown-multiselect',
      'checklist-model',
      'ngCsv',
      'ng.deviceDetector',
      'angularUtils.directives.dirPagination',
      'ngIdle',
      'chart.js',
      "uiCropper",
      'ngFileUpload',
      'ngFileSaver'
    ]);

})();

(function() {
  'use strict';

  angular
      .module('quantumUiAngular')
      .service('userAuth', userAuth);

  /** @ngInject */
  function userAuth($location, $log, $rootScope) {
  //function userAuth($location, $log, $rootScope, $cookies) {

    var user = {};

    user.data = {}

    user.debugMode = function() {
      user.data.debugMode = true;
    }

    user.logout = function() {
      user.data = {}
      $rootScope.$emit('loggedOut', true)
      //$cookies.remove('user')
      $location.path("/login");
    }

    return user

  }

})();

(function() {
  'use strict';

  angular
      .module('quantumUiAngular')
      .service('systemStatus', systemStatus);

  /** @ngInject */
  function systemStatus($rootScope, $interval, quantumApi, $log, userAuth, $window, devMode) {
  //function systemStatus($rootScope, $interval, quantumApi, $log, $cookies) {
    var vm = this;
    var socket
    var watchdogInterval
    var watchdogCounter = 0
    var status = {};

    function createWebSocket(path) {
      var websocket = null
      var protocolPrefix = ($window.location.protocol === 'https:') ? 'wss:' : 'ws:';
      if (devMode.enabled) {
        websocket = new WebSocket(protocolPrefix + '//admin:admin@'+devMode.serverIp + path);
      } else {
        websocket = new WebSocket(protocolPrefix + '//admin:admin@' + location.hostname + path);
      }
      return websocket
    }

    // Still used for inital load
    status.refreshSystemStatus = function() {
      status.alarmSummary = quantumApi.alarmSummary.get()
      quantumApi.systemStatus.get(function(data) {
        status.data.server_time = data.server_time
        status.data.lockdown_status = data.lockdown_status,
        status.data.system_error = data.system_error,
        status.data.active_leave = data.active_leave,
        status.data.active_onetime_schedule = data.active_onetime_schedule,
        status.data.low_battery = data.low_battery,
        status.data.missing_device = data.missing_device,
        status.data.repeater_error = data.repeater_error,
        status.data.offset = data.offset,
        status.data.broadcast_active = data.broadcast_active,
        status.data.repeater_enroll_active = data.repeater_enroll_active,
        status.data.connected = (watchdogCounter > 6 ? false :true),
        status.data.install_complete = data.install_complete
        status.data.allegion_error = data.allegion_error
        status.data.unmonitored_hardware = data.unmonitored_hardware
        $rootScope.$emit('statusUpdate', true)
      })

      quantumApi.alarmActive.query(function(data){
        status.data.active_alarm = data
      })
    }

    status.data = {
      "server_time":Date.now(),
      "lockdown_status":false,
      "system_error":[],
      "active_alarm":[],
      "active_leave":[],
      "repeater_error":[],
      "active_onetime_schedule":[],
      "low_battery":[],
      "missing_device":[],
      "connected":true,
      "install_complete":true,
      "unmonitored_hardware":false
    };

    //status.refreshSystemStatus()

    // // Catch a login from cookie
    // if (typeof $cookies.get('user') != 'undefined') {
    //   status.refreshInterval = $interval(status.refreshSystemStatus, 2000)
    // }

    function watchdogCheck() {
      watchdogCounter ++
      if (watchdogCounter > 3) {
        stopService()
        startService()
      }
      if (watchdogCounter > 6) {
        status.data.connected = false
        $rootScope.$emit('statusUpdate', true)
      } else {
        // Clear the modal
        if (!status.data.connected) {
          $rootScope.$emit('statusUpdate', true)
        }
        status.data.connected = true
      }
    }

    function systemStatusParser(data) {
      status.data.server_time = data.server_time
      status.data.lockdown_status = data.lockdown_status,
      status.data.system_error = data.system_error,
      status.data.active_leave = data.active_leave,
      status.data.active_onetime_schedule = data.active_onetime_schedule,
      status.data.low_battery = data.low_battery,
      status.data.missing_device = data.missing_device,
      status.data.repeater_error = data.repeater_error,
      status.data.offset = data.offset,
      status.data.broadcast_active = data.broadcast_active,
      status.data.repeater_enroll_active = data.repeater_enroll_active,
      status.data.install_complete = data.install_complete,
      status.data.allegion_error = data.allegion_error,
      status.data.unmonitored_hardware = data.unmonitored_hardware
      // Server not running warning
      if (!data.server_running) {
        status.data.system_error.unshift({"error_description": "Server Not Running", "id": 0, "ip_address": "N/A", "name": "Quantum Server"})
      }
    }

    function socketMsgParser(msg) {
      msg = angular.fromJson(msg)
      if (userAuth.data.debugMode) {
        $log.info(msg)
      }
      status.data.connected = true
      watchdogCounter = 0
      if (msg.action == "heart_beat") {
        status.data.server_time = msg.data.server_time
      } else if (msg.action == "event") {
        $rootScope.$emit('newEvent', msg.data)
      } else if (msg.action == "active_alarm") {
        status.data.active_alarm = msg.data
        $rootScope.$emit('statusUpdate', true)
      } else if (msg.action == "alarm_summary") {
        status.alarmSummary = msg.data
        $rootScope.$emit('statusUpdate', true)
      } else if (msg.action == "system_status"){
        systemStatusParser(msg.data)
        $rootScope.$emit('statusUpdate', true)
      } else if (msg.action == "new_code") {
        $rootScope.$emit('cardEnrollData', msg.data.code)
      } else if (msg.action == "register_device") {
        $rootScope.$emit('deviceRegistration', msg.data)
      } else if (msg.action == "fingerprint") {
        $rootScope.$emit('fingerprint', msg.data)
      } else if (msg.action == "request_reply") {
        $rootScope.$emit('requestReply', {eventId:msg.event_id, payload:msg.data})
      }
    }

    function startService() {
      watchdogInterval = $interval(watchdogCheck, 5000)
      // Inital Load from API
      status.refreshSystemStatus()
      // New WS Communication
      socket = createWebSocket('/websocket')
      socket.onmessage = function(msg){
        socketMsgParser(msg.data)
      }
    }

    vm.loggedInListener = $rootScope.$on('loggedIn', function(){
      startService()
    })

    function stopService() {
      $interval.cancel(watchdogInterval);
      if (socket) {
        socket.close()
      }
      socket = null
    }

    vm.loggedOutListener = $rootScope.$on('loggedOut', function(){
      stopService()
    })

    return status

  }

})();

(function() {
  'use strict';

  angular
      .module('quantumUiAngular')
      .service('quantumApi', quantumApi);

  /** @ngInject */
  function quantumApi($resource, $http, $window, $document, devMode, FileSaver) {

    // Well, this escalated quickly...
    // TODO: Make this, uh, better?

    var api = {};

    var baseUrl = null
    if (devMode.enabled) {
      baseUrl = 'http://'+devMode.serverIp+'/api/v1'
    } else {
      baseUrl = '/api/v1'
    }

    // Events API Endpoint
    api.events = $resource(baseUrl + '/event/:afterId',
      {
        afterId: '@after_id'
      },
      {
        'get':    {method:'GET', isArray:false},
        'query':  {method:'GET', isArray:true},
        'save':   {method:'POST'},
        'delete': {method:'DELETE'}
      }
    )

    // Door API Endpoint
    api.door = $resource(baseUrl + '/door/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'},
      'override': {
          method:'PUT',
          params: {id: '@id'},
          url:baseUrl + '/door/:id/override'
        },
      'reboot': {
          method:'PUT',
          params: {id: '@id'},
          url:baseUrl + '/door/:id/remote-reboot'
        },
      'newDoors': {
          method:'GET',
          url:baseUrl + '/door/new',
          isArray:true
        },
        'lockdownToggle': {
            method:'put',
            url:baseUrl + '/door/lockdown'
          }
    }
  )

    // Staff Door Acces Group API Endpoint
    api.doorAccessGroup = $resource(baseUrl + '/door-access-group/:id',{},
      {
        'get':    {method:'GET', isArray:false},
        'query':  {method:'GET', isArray:true},
        'save':   {method:'POST'},
        'update': {method:'PUT'},
        'delete': {method:'DELETE'}
      }
    )

    api.ioRepeater = $resource(baseUrl + '/io-repeater/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update':   {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.schedule = $resource(baseUrl + '/schedule/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'delete': {method:'DELETE'}
    })

    api.escalation = $resource(baseUrl + '/escalation/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.hardwareEscalationGroup = $resource(baseUrl + '/hardware-escalation-group/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.area = $resource(baseUrl + '/area/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.apartment = $resource(baseUrl + '/apartment/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.staff = $resource(baseUrl + '/staff/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'},
      'usedCodes': {
          method:'get',
          url:baseUrl + '/staff/used-codes'
        },
        'getFilters': {
          method:'get',
          url:baseUrl + '/staff/:id/report-filter'
        },
        'saveFilters': {
          method:'put',
          url:baseUrl + '/staff/:id/report-filter'
        },
        'getMapSettings': {
          method:'get',
          url:baseUrl + '/staff/:id/map-settings'
        },
        'saveMapSettings': {
          method:'put',
          url:baseUrl + '/staff/:id/map-settings'
        }
    })

    api.family = $resource(baseUrl + '/staff/:id/family',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.resident = $resource(baseUrl + '/resident/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'},
      'insights': {
        method:'put',
        url:baseUrl + '/resident/:id/get-care'
      }
    })

    api.residentDoorPermission = $resource(baseUrl + '/resident-door-access-permission',{},
    {
      'query':  {method:'GET', isArray:true}
    })

    api.quantumDevice = $resource(baseUrl + '/fixed-device/quantum/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.quantumDeviceReplace = $resource(baseUrl + '/fixed-device/quantum/replace/:id',{},
    {
      'update': {method:'PUT'}
    })

    api.systemMonitor = $resource(baseUrl + '/system-monitor/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.enrollmentStation = $resource(baseUrl + '/enrollment-station/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.enrollmentStationTransmitter = $resource(baseUrl + '/enrollment-station/transmitter/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.systemStatus = $resource(baseUrl + '/system-status',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.integratedDevice = $resource(baseUrl + '/fixed-device/integrated/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.alarm = $resource(baseUrl + '/alarm/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'},
      'snooze': {method:'PUT', url:baseUrl + '/alarm/:id/snooze'}
    })

    api.alarmActive = $resource(baseUrl + '/alarm/active',{},
    {
      'query':  {method:'GET', isArray:true}
    })

    api.checkin = $resource(baseUrl + '/checkin',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.corridorLightControler = $resource(baseUrl + '/corridor-light/controller',{},
    {
      'query':    {method:'GET', isArray:true}
    })

    api.corridorLightColor = $resource(baseUrl + '/corridor-light/color',{},
    {
      'query':    {method:'GET', isArray:true}
    })

    api.scheduleWeeklyStaff = $resource(baseUrl + '/schedule-weekly-staff/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.scheduleWeeklyWanderer = $resource(baseUrl + '/schedule-weekly-wander/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })
    api.scheduleWeeklyAccessControl = $resource(baseUrl + '/schedule-weekly-access-control/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })
    api.scheduleIoRepeater = $resource(baseUrl + '/schedule-io-repeater/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })
    api.scheduleCheckIn = $resource(baseUrl + '/schedule-check-in/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.inovonicsRepeater = $resource(baseUrl + '/inovonics/repeater/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'},
      'setNid': {
        method:'put',
        url:baseUrl + '/inovonics/set-repeater-nid/:id'
      },
      'getStatus': {
        method:'put',
        url:baseUrl + '/inovonics/get-repeater-status/:id'
      },
      'replaceRepeater': {
        method:'put',
        url:baseUrl + '/inovonics/replace-repeater/:id'
      }
    })

    api.inovonicsRepeaterEnroll = $resource(baseUrl + '/inovonics/repeater/enroll',{},
    {
      'get':    {method:'GET', isArray:false},
      'update': {method:'PUT'}
    })

    api.inovonicsLocation = $resource(baseUrl + '/inovonics/locations/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.inovonicsDeviceData = $resource(baseUrl + '/inovonics/device-data',{},
    {
      'get':  {method:'GET', isArray:false}
    })

    api.scheduleOnetime = $resource(baseUrl + '/schedule-one-time/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.scheduledLeave = $resource(baseUrl + '/scheduled-leave/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.staffAccessGroup = $resource(baseUrl + '/staff-access-group/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.alertDevice = $resource(baseUrl + '/alert-device/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.inputInterface = $resource(baseUrl + '/input-interface/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.outputInterface = $resource(baseUrl + '/output-interface/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.uiMessage = $resource(baseUrl + '/ui-message/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.eventMessage = $resource(baseUrl + '/event-message/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.siteInfo = $resource(baseUrl + '/site-info',{},
    {
      'get':    {method:'GET', isArray:false},
      'update': {method:'PUT'}
    })

    api.systemSettings = $resource(baseUrl + '/system-settings',{},
    {
      'get':    {method:'GET', isArray:false},
      'update': {method:'PUT'}
    })

    api.inputType = $resource(baseUrl + '/input',{},
    {
      'query':    {method:'GET', isArray:true}
    })

    api.outputType = $resource(baseUrl + '/output',{},
    {
      'query':    {method:'GET', isArray:true}
    })

    api.interfaceType = $resource(baseUrl + '/interface-type',{},
    {
      'query':    {method:'GET', isArray:true}
    })

    api.inputSystem = $resource(baseUrl + '/input-system',{},
    {
      'query':    {method:'GET', isArray:true}
    })

    api.license = $resource(baseUrl + '/license',{},
    {
      'query':    {method:'GET', isArray:true},
      'get':    {method:'GET', isArray:false},
      'update': {method:'PUT'}
    })

    api.login = $resource(baseUrl + '/login',{},
    {
      'save':    {method:'POST'}
    })

    api.newPhone  = $resource(baseUrl + '/new-phone',{},
    {
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'}
    })

    api.user  = $resource(baseUrl + '/user',{},
    {
      'query':  {method:'GET', isArray:true}
    })

    api.userKick  = $resource(baseUrl + '/user/:id/kick',{},
    {
      'delete':  {method:'DELETE'}
    })

    api.mobileHistory = $resource(baseUrl + '/user-history',{},
    {
      'query':    {method:'GET', isArray:true}
    })

    api.mobileLogoutTypes = $resource(baseUrl + '/logout-method',{},
    {
      'query':    {method:'GET', isArray:true}
    })

    api.duplicateNames = $resource(baseUrl + '/report/duplicate-names',{},
    {
      'query':    {method:'GET', isArray:true}
    })

    api.untestedDevice = $resource(baseUrl + '/report/alarm-validate',{},
    {
      'get':    {method:'GET', isArray:false}
    })

    api.care = $resource(baseUrl + '/care/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.staffGroup = $resource(baseUrl + '/staff-group/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.alarmHistoryReport = $resource(baseUrl + '/report/alarm-history',{},
    {
      'request':   {method:'POST'}
    })

    api.eventHistoryReport = $resource(baseUrl + '/report/event',{},
    {
      'request':   {method:'POST', isArray:false}
    })

    api.reportFilter = $resource(baseUrl + '/report/report-filters',{},
    {
      'get':   {method:'GET', isArray:false}
    })

    api.eventHistoryReportDownload = $resource(baseUrl + '/download/event-report',{},
    {
      'request':   {method:'POST', isArray:false}
    })

    api.installReport = $resource(baseUrl + '/install/request-install-docs',{},
    {
      'request':   {method:'POST', isArray:false}
    })

    api.eventNote = $resource(baseUrl + '/event-note/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.careLevel = $resource(baseUrl + '/care-level/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.carePlan = $resource(baseUrl + '/care-plan/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.careWarning = $resource(baseUrl + '/care-warning/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.careReport = $resource(baseUrl + '/report/cares',{},
    {
      'request':   {method:'POST'}
    })

    api.staffCareReport = $resource(baseUrl + '/report/staff-data',{},
    {
      'request':   {method:'POST'}
    })

    api.allegionNewHardware = $resource(baseUrl + '/new-allegion-hardware',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.allegionGateway = $resource(baseUrl + '/allegion/gateway/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.allegionLock = $resource(baseUrl + '/allegion/lock/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.allegionAccessGroup = $resource(baseUrl + '/allegion-access-group/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.allegionCurrentFirmware = $resource(baseUrl + '/allegion-firmware',{},
    {
      'query':  {method:'GET', isArray:true}
    })

    api.updateQuantumFirmware = $resource(baseUrl + '/hardware-update/:id',{},
    {
      'update':  {method:'PUT'}
    })

    api.map = $resource(baseUrl + '/map/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.bridge = $resource(baseUrl + '/bridge/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.bridge = $resource(baseUrl + '/bridge/:id',{},
    {
      'get':    {method:'GET', isArray:false},
      'query':  {method:'GET', isArray:true},
      'save':   {method:'POST'},
      'update': {method:'PUT'},
      'delete': {method:'DELETE'}
    })

    api.alarmSummary = $resource(baseUrl + '/report/twenty-four-hour-summary',{},
    {
      'get':    {method:'GET', isArray:false}
    })

    api.conversation = $resource(baseUrl + '/conversation/:id',{},
        {
          'get':    {method:'GET', isArray:false},
          'query':  {method:'GET', isArray:true},
          'save':   {method:'POST'},
          'update': {method:'PUT'},
          'delete': {method:'DELETE'},
          'check': {
            method:'GET',
            url:baseUrl +'/conversation/new-message'
          },
          'createMessage': {
            method:'POST',
            url:baseUrl +'/conversation/create-message'
          }
        }
      )

      api.transmitterTrack = $resource(baseUrl + '/tag-track',{},
      {
        'query':    {method:'GET', isArray:true},
        'get': {
          method:'POST',
          url:baseUrl +'/report/tag-track'
        }
      })

      api.transmitterTestReport = $resource(baseUrl + '/report/daily-tag',{},
      {
        'save':    {method:'POST', isArray:true}
      })

      api.transmitterTestDetailsReport = $resource(baseUrl + '/report/tag-test-per-day',{},
      {
        'save':    {method:'POST', isArray:true}
      })

    // Ugly, but it works.
    api.getEventCsv = function(reqObj, fileName) {
      return $http({method: 'POST', url: baseUrl + '/download/event-report', data:reqObj}).
      success(function(csvDataString){
        if ($window.navigator.msSaveOrOpenBlob) {
            var blob = new Blob([csvDataString]);  //csv data string as an array.
            // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
            $window.navigator.msSaveBlob(blob, fileName);
        } else {
            var anchor = angular.element('<a/>');
            anchor.css({display: 'none'}); // Make sure it's not visible
            angular.element($document.body).append(anchor); // Attach to document for FireFox

            anchor.attr({
                href: 'data:attachment/csv;charset=utf-8,' + encodeURI(csvDataString),
                target: '_blank',
                download: fileName
        })[0].click();
        anchor.remove();
        }
      })
    }

    api.getAlarmCsv = function(reqObj, fileName) {
      return $http({method: 'POST', url: baseUrl + '/download/alarm-history', data:reqObj, responseType: "arraybuffer"})
      .success(function(data) {
            FileSaver.saveAs(new Blob([data],{type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}), fileName);
        })
    }

    // Ugly, but it works.
    api.getCareCsv = function(reqObj, fileName) {
      return $http({method: 'POST', url: baseUrl + '/download/care-report', data:reqObj}).
      success(function(csvDataString){
        if ($window.navigator.msSaveOrOpenBlob) {
            var blob = new Blob([csvDataString]);  //csv data string as an array.
            // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
            $window.navigator.msSaveBlob(blob, fileName);
        } else {
            var anchor = angular.element('<a/>');
            anchor.css({display: 'none'}); // Make sure it's not visible
            angular.element($document.body).append(anchor); // Attach to document for FireFox

            anchor.attr({
                href: 'data:attachment/csv;charset=utf-8,' + encodeURI(csvDataString),
                target: '_blank',
                download: fileName
        })[0].click();
        anchor.remove();
        }
      })
    }

    api.getStaffCareCsv = function(reqObj, fileName) {
      return $http({method: 'POST', url: baseUrl + '/download/staff-care-alarm', data:reqObj}).
      success(function(csvDataString){
        if ($window.navigator.msSaveOrOpenBlob) {
            var blob = new Blob([csvDataString]);  //csv data string as an array.
            // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
            $window.navigator.msSaveBlob(blob, fileName);
        } else {
            var anchor = angular.element('<a/>');
            anchor.css({display: 'none'}); // Make sure it's not visible
            angular.element($document.body).append(anchor); // Attach to document for FireFox

            anchor.attr({
                href: 'data:attachment/csv;charset=utf-8,' + encodeURI(csvDataString),
                target: '_blank',
                download: fileName
        })[0].click();
        anchor.remove();
        }
      })
    }

    return api

  }

})();

(function() {
  'use strict';

  angular
      .module('quantumUiAngular')
      .service('navItems', navItems);

  /** @ngInject */
  function navItems(userAuth) {

    // So, this exists to filter the menus based on access level and license

    var navItems = {};

    function init() {
      navItems.leftNavigationItems = []
      // Right Nav Does not Support Flyouts, Supports FA Icons, Functions
      navItems.rightNavigationItems = []
    }

    navItems.rebuild = function() {
      init()
      // Dashboard Access
      if (userAuth.data.access_level.dashboard) {
        navItems.leftNavigationItems.push(
          {"name":"Dashboard", "link":"/"}
        )
        if (userAuth.data.system_license.map_active) {
          navItems.leftNavigationItems.push(
            {"name":"Map", "link":"/map"}
          )
        }
      }

      // Door Controls/Door Access
      if (userAuth.data.access_level.door_control && (userAuth.data.system_license.access_control || userAuth.data.system_license.wanderer_monitoring)) {
        if (!userAuth.data.system_license.allegion_active) {
            navItems.leftNavigationItems.push(
              {"name":"Door Control", "link":"#", "subNav":[
                {"name":"Door Status & Override", "link":"door-status"},
                {"name":"Door Access Groups", "link":"#", "flyout":[
                  {"name":"Create a Door Access Group", "link":"door-access-create"},
                  {"name":"Change a Door Access Group", "link":"door-access-change"},
                  {"name":"Remove a Door Access Group", "link":"door-access-remove"}
                ]}
              ]
            }
          )
        } else {
            navItems.leftNavigationItems.push(
              {"name":"Door Control", "link":"#", "subNav":[
                {"name":"Door Status & Override", "link":"door-status"},
                {"name":"Allegion Door Status & Override", "link":"door-status-allegion"},
                {"name":"Door Access Groups", "link":"#", "flyout":[
                  {"name":"Create a Door Access Group", "link":"door-access-create"},
                  {"name":"Change a Door Access Group", "link":"door-access-change"},
                  {"name":"Remove a Door Access Group", "link":"door-access-remove"}
                ]},
                {"name":"Allegion Door Access Groups", "link":"#", "flyout":[
                  {"name":"Create a Door Access Group", "link":"door-access-allegion-create"},
                  {"name":"Change a Door Access Group", "link":"door-access-allegion-change"},
                  {"name":"Remove a Door Access Group", "link":"door-access-allegion-remove"}
                ]}
              ]
            }
          )
        }
      }

      // Schedules
      if ((userAuth.data.access_level.door_schedule || userAuth.data.access_level.resident_edit) && (userAuth.data.system_license.access_control || userAuth.data.system_license.wanderer_monitoring || userAuth.data.system_license.nurse_call)) {
        var scheduleKey = navItems.leftNavigationItems.push(
          {"name":"Schedules", "link":"#", "subNav":[]}
        )
      }

      // Door Schedules
      if ((userAuth.data.system_license.access_control || userAuth.data.system_license.wanderer_monitoring) && userAuth.data.access_level.door_schedule) {
        navItems.leftNavigationItems[scheduleKey - 1].subNav.push(
          {"name":"One Time Schedules", "link":"#", "flyout":[
            {"name":"Create Access Control Door Unlock Schedule", "link":"schedule-onetime-access"},
            {"name":"Create Wanderer Door Lock Schedule", "link":"schedule-onetime-wanderer"},
            {"name":"Remove a One Time Schedule", "link":"schedule-onetime-remove"}
          ]},
          {"name":"Weekly Access Control Door Unlock", "link":"#", "flyout":[
            {"name":"Create Schedule", "link":"schedule-weekly-access-control-create"},
            {"name":"Change Schedule", "link":"schedule-weekly-access-control-change"},
            {"name":"Remove Schedule", "link":"schedule-weekly-access-control-remove"}
          ]},
          {"name":"Weekly Wanderer Door Lock", "link":"#", "flyout":[
            {"name":"Create Schedule", "link":"schedule-weekly-wanderer-create"},
            {"name":"Change Schedule", "link":"schedule-weekly-wanderer-change"},
            {"name":"Remove Schedule", "link":"schedule-weekly-wanderer-remove"}
          ]},
          {"name":"Weekly Door Access Schedules", "link":"#", "flyout":[
            {"name":"Create Schedule", "link":"schedule-weekly-staff-create"},
            {"name":"Change Schedule", "link":"schedule-weekly-staff-change"},
            {"name":"Remove Schedule", "link":"schedule-weekly-staff-remove"}
          ]}
        )
      }

      if ((userAuth.data.access_level.door_schedule || userAuth.data.access_level.resident_edit) && (userAuth.data.system_license.access_control || userAuth.data.system_license.wanderer_monitoring || userAuth.data.system_license.nurse_call)) {
        navItems.leftNavigationItems[scheduleKey - 1].subNav.push(
          {"name":"Fixed Device Schedules", "link":"#", "flyout":[
            {"name":"Create Schedule", "link":"schedule-io-repeater-create"},
            {"name":"Change Schedule", "link":"schedule-io-repeater-change"},
            {"name":"Remove Schedule", "link":"schedule-io-repeater-remove"}
          ]}
        )
      }

      if (userAuth.data.system_license.nurse_call && userAuth.data.access_level.resident_edit) {
        navItems.leftNavigationItems[scheduleKey - 1].subNav.push(
          {"name":"Check-In Schedules", "link":"#", "flyout":[
            {"name":"Create Schedule", "link":"schedule-check-in-create"},
            {"name":"Change Schedule", "link":"schedule-check-in-change"},
            {"name":"Remove Schedule", "link":"schedule-check-in-remove"}
          ]}
        )
      }

      // Resident
      if ((userAuth.data.access_level.resident_view || userAuth.data.access_level.resident_edit) && (userAuth.data.system_license.nurse_call || userAuth.data.system_license.wanderer_monitoring || userAuth.data.system_license.access_control)) {
        var residentKey = navItems.leftNavigationItems.push(
          {"name":"Residents", "link":"#", "subNav":[]}
        )
      }

      if ((userAuth.data.access_level.resident_view) && (userAuth.data.system_license.nurse_call || userAuth.data.system_license.wanderer_monitoring || userAuth.data.system_license.access_control)) {
        navItems.leftNavigationItems[residentKey - 1].subNav.push(
          {"name":"Resident Status", "link":"resident-status"}
        )
      }

      if ((userAuth.data.access_level.resident_edit) && (userAuth.data.system_license.nurse_call || userAuth.data.system_license.wanderer_monitoring || userAuth.data.system_license.access_control)) {
        navItems.leftNavigationItems[residentKey - 1].subNav.push(
          {"name":"Admit a Resident", "link":"resident-admit"},
          {"name":"Change Resident Information", "link":"resident-change"},
          {"name":"Discharge a Resident", "link":"resident-discharge"}
        )
      }

      if (userAuth.data.access_level.resident_edit && userAuth.data.system_license.wanderer_monitoring) {
        navItems.leftNavigationItems[residentKey - 1].subNav.push(
          {"name":"Turn Off a Wanderer Transmitter", "link":"resident-transmitter-power"}
        )
      }

      if (userAuth.data.access_level.resident_edit && (userAuth.data.system_license.wanderer_monitoring || userAuth.data.system_license.access_control)) {
        navItems.leftNavigationItems[residentKey - 1].subNav.push(
          {"name":"Family Door Access", "link":"#", "flyout":[
            {"name":"Add a Family Member", "link":"family-create"},
            {"name":"Change a Family Member", "link":"family-change"},
            {"name":"Remove a Family Member", "link":"family-remove"}
          ]}
        )
      }

      if (userAuth.data.access_level.resident_edit && userAuth.data.system_license.wanderer_monitoring) {
        navItems.leftNavigationItems[residentKey - 1].subNav.push(
          {"name":"Scheduled Leaves", "link":"#", "flyout":[
            {"name":"Schedule a Leave", "link":"resident-scheduled-leave-create"},
            {"name":"Cancel a Leave", "link":"resident-scheduled-leave-remove"}
          ]}
        )
      }

      // Fixed Devices
      if ((userAuth.data.access_level.resident_view || userAuth.data.access_level.resident_edit) && userAuth.data.system_license.nurse_call) {
        var fixedDeviceKey = navItems.leftNavigationItems.push(
          {"name":"Fixed Devices", "link":"#", "subNav":[]}
        )
      }

      if (userAuth.data.access_level.resident_view && userAuth.data.system_license.nurse_call) {
        navItems.leftNavigationItems[fixedDeviceKey - 1].subNav.push(
          {"name":"Device Status", "link":"fixed-device-status"}
        )
      }

      if (userAuth.data.access_level.resident_edit && userAuth.data.system_license.nurse_call) {
        navItems.leftNavigationItems[fixedDeviceKey - 1].subNav.push(
          {"name":"Quantum Devices", "link":"#", "flyout":[
            {"name":"Add a Device", "link":"fixed-quantum-device-create"},
            {"name":"Change a Device", "link":"fixed-quantum-device-change"},
            {"name":"Replace a Device", "link":"fixed-quantum-device-replace"},
            {"name":"Remove a Device", "link":"fixed-quantum-device-remove"}
          ]}
        )
      }

      if (userAuth.data.access_level.resident_edit && (userAuth.data.system_license.nurse_call && userAuth.data.system_license.integration)) {
        navItems.leftNavigationItems[fixedDeviceKey - 1].subNav.push(
          {"name":"Integrated Devices", "link":"#", "flyout":[
            {"name":"Manage Devices", "link":"fixed-integrated-device-change"},
            {"name":"Manage Third Party Devices", "link":"fixed-third-party-device-change"}
          ]}
        )
      }

      // Staff
      if (userAuth.data.access_level.staff_view || userAuth.data.access_level.staff_edit) {
        var staffKey = navItems.leftNavigationItems.push(
          {"name":"Staff", "link":"#", "subNav":[]}
        )
      }

      if (userAuth.data.access_level.staff_view) {
        navItems.leftNavigationItems[staffKey - 1].subNav.push(
          {"name":"Staff Status", "link":"staff-status"}
        )
      }

      if (userAuth.data.access_level.staff_edit) {
        navItems.leftNavigationItems[staffKey - 1].subNav.push(
          {"name":"Add a Staff Member", "link":"staff-create"},
          {"name":"Change Staff Information", "link":"staff-change"},
          {"name":"Remove a Staff Member", "link":"staff-remove"}
        )
      }

      if (userAuth.data.access_level.staff_view) {
        navItems.leftNavigationItems[staffKey - 1].subNav.push(
          {"name":"Send a Message", "link":"staff-send-message"}
        )
      }

      if (userAuth.data.access_level.staff_edit) {
        navItems.leftNavigationItems[staffKey - 1].subNav.push(
          // {"name":"Staff Messenger", "link":"staff-messenger"},
          {"name":"Staff Messenger Groups", "link":"#", "flyout":[
            {"name":"Add a Group", "link":"staff-messenger-group-create"},
            {"name":"Change a Group", "link":"staff-messenger-group-change"},
            {"name":"Remove a Group", "link":"staff-messenger-group-remove"}
          ]}
        )
      }

      // Site
      if (userAuth.data.access_level.resident_edit && (userAuth.data.system_license.nurse_call || userAuth.data.system_license.wanderer_monitoring)) {
        navItems.leftNavigationItems.push(
          {"name":"Site", "link":"#", "subNav":[
            {"name":"Area Management", "link":"area"},
            {"name":"Room Management", "link":"apartment"}
          ]}
        )
      }


      // Reports
      if (userAuth.data.access_level.resident_reports || userAuth.data.access_level.system_reports) {
        var reportKey = navItems.leftNavigationItems.push(
          {"name":"Reports", "link":"#", "subNav":[]}
        )
      }

      if (userAuth.data.access_level.resident_reports) {
        var residentReports = []
        residentReports.push({"name":"Alarm Report", "link":"report-alarm-history"})
        if (userAuth.data.system_license.care_package) {
          residentReports.push({"name":"Care Report", "link":"report-care"})
        }
        residentReports.push({"name":"Event Report", "link":"report-daily-event"})
        if (userAuth.data.system_license.nurse_call && userAuth.data.system_license.resident_checkin) {
          residentReports.push({"name":"Daily Check-in Report", "link":"report-daily-checkin"})
        }
        if (userAuth.data.system_license.wanderer_monitoring) {
          residentReports.push({"name":"Transmitter Test Report", "link":"report-transmitter-test"})
        }
        navItems.leftNavigationItems[reportKey - 1].subNav.push(
          {"name":"Resident Reports", "link":"#", "flyout":residentReports}
        )
      }

      if (userAuth.data.access_level.system_reports) {
        var staffReports = []
        staffReports.push({"name":"Credential Report", "link":"report-credential"})
        if (userAuth.data.system_license.care_package) {
          staffReports.push({"name":"Staff Care Report", "link":"report-staff-care"})
        }
        if (userAuth.data.access_level.system_reports && userAuth.data.system_license.mobile_users) {
          staffReports.push({"name":"Mobile User Report", "link":"report-active-mobile-users"})
        }

        navItems.leftNavigationItems[reportKey - 1].subNav.push(
          {"name":"Staff Reports", "link":"#", "flyout":staffReports}
        )
        navItems.leftNavigationItems[reportKey - 1].subNav.push(
          {"name":"System Reports", "link":"#", "flyout":[
            {"name":"Serial Number Report", "link":"report-serial-number"},
            {"name":"Door Configuration Report", "link":"report-door-configuration"},
            {"name":"Identically Named Device Report", "link":"report-duplicate-name"},
            {"name":"Untested Device Report", "link":"report-untested-device"},
            {"name":"Transmitter History Report", "link":"report-transmitter-history"},
            {"name":"System Status Report", "link":"report-system-status"}
          ]}
        )
      }

      // Right Menu Items
      if (userAuth.data.access_level.system_config || userAuth.data.access_level.operator_admin) {
        navItems.rightNavigationItems.push(
          {"icon":"fa fa-gear", "link":"map", "subNav":[
            {"name":"System Setup", "link":"admin-system-setup"}
          ]}
        )
      }

      // Normal User Menu
      navItems.rightNavigationItems.push(
        {"name":userAuth.data.full_name, "link":"#", "subNav":[
          {"name":"Software License", "link":"display-eula"},
          {"name":"Operator's Manual", "link":"../assets/manual/quantum_manual_6_2.pdf", "download":true},
          {"name":"Logout", "link":"", "function":function(){
            userAuth.logout()
          }}
        ]}
      )

    }

    // Run on page load - build navigation if cookie set and no login function runs
    if (userAuth.data.id) {
      navItems.rebuild()
    }

    return navItems

  }

})();

(function() {
  'use strict';

  angular
      .module('quantumUiAngular')
      .service('messengerEngine', messengerEngine);

  /** @ngInject */
  function messengerEngine(quantumApi) {
    // Init the service
    var messengerEngineObject = {}
    // Caching for staff and groups
    var staffDetailsCache = {}
    var staffLookupInProgress = []
    var groupDetailsCache = {}
    var groupLookupInProgress = []

    // Caching the user list
    messengerEngineObject.users = []

    messengerEngineObject.unreadMessageCount = 0
    messengerEngineObject.conversations = []

    messengerEngineObject.checkForMessages = function() {
      quantumApi.conversation.check(function(data) {
        data = angular.fromJson(data)
        if (data.unreadMessageCount) {
          if (data.unreadMessageCount > messengerEngineObject.unreadMessageCount) {
            // For the UI, Display an unread messages icon
            messengerEngineObject.unreadMessageCount = data.unreadMessageCount
            // Play Received Tone
            // Sync Msg State
            messengerEngineObject.loadMessageState()
          }
        } else {
          messengerEngineObject.unreadMessageCount = 0
        }
      })
    }

    messengerEngineObject.loadMessageState = function() {
      quantumApi.conversation.query(function(data){
        messengerEngineObject.conversations = data
      })
    }

    // Look up users by id and cache them for future use
    messengerEngineObject.lookupStaffId = function(staffId) {
      // End it now if the staff ID is undefined....
      if (!staffId) {
        return
      }
      // Check the cache first and make sure we're not waiting for the api request to return the user
      if (!staffDetailsCache[staffId] && staffLookupInProgress.indexOf(staffId) == -1) {
        staffLookupInProgress.push(staffId)
        quantumApi.staff.get({id:staffId}).$promise
        .then(function(data){
          staffDetailsCache[staffId] = data
          return data
        })
      } else {
        // If they're in the cache, just return that
        return staffDetailsCache[staffId]
      }
    }

    // Look up users by id and cache them for future use
    messengerEngineObject.lookupGroupId = function(groupId) {
      // End it now if the staff ID is undefined....
      if (!groupId) {
        return
      }
      // Check the cache first and make sure we're not waiting for the api request to return the user
      if (!groupDetailsCache[groupId] && groupLookupInProgress.indexOf(groupId) == -1) {
        groupLookupInProgress.push(groupId)
        quantumApi.staffGroup.get({id:groupId}).$promise
        .then(function(data){
          groupDetailsCache[groupId] = data
          return data
        })
      } else {
        // If they're in the cache, just return that
        return groupDetailsCache[groupId]
      }
    }

    messengerEngineObject.getUnreadMessageCount = function() {
      return messengerEngineObject.unreadMessageCount
    }

    messengerEngineObject.refreshStaffList = function() {
      quantumApi.staff.activeUsers().$promise
      .then(function(data){
        messengerEngineObject.users = data
      })
    }

    return messengerEngineObject

  }

})();

(function() {
  'use strict';

  angular
      .module('quantumUiAngular')
      .service('inovonics', inovonics);

  /** @ngInject */
  function inovonics($log, $q, $rootScope, $http, userAuth, x2js, quantumApi, devMode) {

    var inovonics = {};

    var eventListener

    inovonics.inovonics_pti = quantumApi.inovonicsDeviceData.get()

    var socket
    var acg_ip = userAuth.data.acg_ip
    var proxyPath

    if (devMode.enabled) {
      proxyPath = 'http://'+devMode.acgIp+'/api/v1/inovonics_proxy.php'
    } else {
      proxyPath = '/api/v1/inovonics_proxy.php'
    }

    // Used when the ACG IP Changes in the system settings
    inovonics.updateAcgIp = function() {
      acg_ip = userAuth.data.acg_ip
    }

    inovonics.makeXmlSafe = function(input) {
      return input.replace(/[&\<\>]/g, "")
    }

    // Websockets
    // Device Registration Websockets
    inovonics.openRegistration = function(){
      // ACG Codebase
      if (!userAuth.data.network_coordinator_in_use) {
        if (socket) {
          socket.close()
          socket = null
        }

        socket = new WebSocket("ws://Admin:Admin@"+acg_ip+"/PSIA/Metadata/stream?Registration=true");

        socket.onmessage = function(msg){

          var registrationData = x2js.xml_str2json(msg.data)
          registrationData = registrationData.Registration.EventData

          var device_object = {
            id:null,
            sara_device:false,
            serial_number: parseInt(registrationData.DeviceID),
            pti: parseInt(registrationData.PTI),
            acg_id:null,
            device_data:inovonics.inovonics_pti[registrationData.PTI]
          }

          $rootScope.$emit("inovonicsRegistration", device_object)

        }
      } else {
        // Network Coordinator Codebase
        eventListener = $rootScope.$on('deviceRegistration', function(event, data){
          if (!data.assigned) {
            var device_object = {
              id:null,
              sara_device:false,
              serial_number: parseInt(data.serial_number),
              pti: data.pti,
              acg_id:null,
              device_data:data.device_data
            }
            $rootScope.$emit("inovonicsRegistration", device_object)
          }
        })

      }

    }

    inovonics.closeRegistration = function() {
      if (!userAuth.data.network_coordinator_in_use) {
        socket.close()
        socket = null
      } else {
        eventListener()
      }
    }

    // Location Websocket
    inovonics.openLocation = function(){
      if (!userAuth.data.network_coordinator_in_use) {
        if (socket) {
          socket.close()
          socket = null
        }

        socket = new WebSocket("ws://Admin:Admin@"+acg_ip+"/PSIA/Metadata/stream?SoftPoint=true");

        socket.onmessage = function(msg){
          var locationData = (x2js.xml_str2json(msg.data)).SoftPointEvent.EventData.Receivers
          $rootScope.$emit("inovonicsLocation", locationData)
        }
      } else {
        eventListener = $rootScope.$on('fingerprint', function(event, data){
          $rootScope.$emit("inovonicsLocation", data)
        })
      }

    }

    inovonics.closeLocation = function() {
      if (!userAuth.data.network_coordinator_in_use) {
        socket.close()
        socket = null
      } else {
        eventListener()
      }
    }

    // Rest API
    // Device Registration
    inovonics.writeDevice = function(device) {
      var xml = "<ZoneInfo><DeviceID>" + device.serial_number + "</DeviceID><PTI>" + device.pti + "</PTI><MID>" + device.device_data.mid + "</MID><Description>" + device.serial_number + "</Description><SupervisionWindow>" + device.device_data.supervision + "</SupervisionWindow><Locatable>"+ (device.device_data.fixed ? "false" : "true") +"</Locatable></ZoneInfo>";
      return $http.post(proxyPath, xml, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/AreaControl/PartitionMembers/Zones/ZoneInfoList'}})
      .then(function(response){
        return x2js.xml_str2json(response.data)
      }, function(err) {
        var errorObj = {"data":x2js.xml_str2json(err.data)}
        var errors = [{"message":"Failed to Write to ACG"}]
        errorObj.data.errors = errors
        return $q.reject(errorObj)
      })
    }

    inovonics.removeDevice = function(acgId) {
      return $http.delete(proxyPath, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/AreaControl/PartitionMembers/Zones/ZoneInfoList/'+acgId}})
      .then(function(response){
        return x2js.xml_str2json(response.data)
      }, function(err) {
        var errorObj = {"data":x2js.xml_str2json(err.data)}
        var errors = [{"message":"Failed to Remove From ACG"}]
        errorObj.data.errors = errors
        return $q.reject(errorObj)
      })
    }

    // Network
    inovonics.getNid = function() {
      return $http.get(proxyPath, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/System/RFNetwork'}})
      .then(function(response){
        return parseInt((x2js.xml_str2json(response.data)).RFNetwork.NID)
      }, function(err) {
        var errorObj = {"data":x2js.xml_str2json(err.data)}
        var errors = [{"message":"Failed to Remove From ACG"}]
        errorObj.data.errors = errors
        return $q.reject(errorObj)
      })
    }

    inovonics.setNid = function(nid) {
      var xml = "<RFNetwork><NID>"+nid+"</NID></RFNetwork>";
      return $http.put(proxyPath, xml, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/System/RFNetwork'}})
      .then(function(response){
        return x2js.xml_str2json(response.data)
      }, function(err) {
        var errorObj = {"data":x2js.xml_str2json(err.data)}
        var errors = [{"message":"Failed to Write to ACG"}]
        errorObj.data.errors = errors
        return $q.reject(errorObj)
      })
    }

    // Location Pendant
    inovonics.getLocationPendant = function() {
      return $http.get(proxyPath, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/AreaControl/PartitionMembers/Zones/ZoneInfoList'}})
      .then(function(response){
        var responseJson = x2js.xml_str2json(response.data)
        var locationPendantObject
        angular.forEach(responseJson.ZoneInfoList.ZoneInfo, function(device) {
          if (device.IsSPDevice == 'true') {
            locationPendantObject = {
              id:null,
              serial_number: parseInt(device.DeviceID),
              pti: parseInt(device.PTI),
              acg_id:parseInt(device.ID),
              device_data:inovonics.inovonics_pti[device.PTI]
            }
          }
        })
        return locationPendantObject
      }, function(err) {
        var errorObj = {"data":x2js.xml_str2json(err.data)}
        var errors = [{"message":"Failed to Get Location Pendant"}]
        errorObj.data.errors = errors
        return $q.reject(errorObj)
      })
    }

    // Device Registration
    inovonics.setLocationPendant = function(device) {
      var xml = "<ZoneInfo><DeviceID>" + device.serial_number + "</DeviceID><PTI>" + device.pti + "</PTI><MID>" + device.device_data.mid + "</MID><Description>" + device.serial_number + "</Description><SupervisionWindow>" + device.device_data.supervision + "</SupervisionWindow><Locatable>false</Locatable><IsSPDevice>true</IsSPDevice></ZoneInfo>";
      return $http.post(proxyPath, xml, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/AreaControl/PartitionMembers/Zones/ZoneInfoList'}})
      .then(function(response){
        return x2js.xml_str2json(response.data)
      }, function(err) {
        var errorObj = {"data":x2js.xml_str2json(err.data)}
        var errors = [{"message":"Failed to Write to ACG"}]
        errorObj.data.errors = errors
        return $q.reject(errorObj)
      })
    }

    //Locations
    inovonics.getFingerprints = function(acgPartitionId) {
      return $http.get(proxyPath, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/AreaControl/SoftPointList'}})
      .then(function(response){
        var locations = (x2js.xml_str2json(response.data)).SoftPointList.SoftPoint
        var matchingLocations = []
        angular.forEach(locations, function(location) {
          if (acgPartitionId == location.PartitionID) {
            matchingLocations.push(location)
          }
        })
        return matchingLocations
      }, function(err) {
        var errorObj = {"data":x2js.xml_str2json(err.data)}
        var errors = [{"message":"Failed to Get Fingerprints"}]
        errorObj.data.errors = errors
        return $q.reject(errorObj)
      })
    }

    inovonics.saveFingerprint = function(fingerprint) {
      var xml = '<SoftPoint><PartitionID>'+fingerprint.PartitionID+'</PartitionID><Receivers><DeviceID1>'+fingerprint.Receivers.DeviceID1+'</DeviceID1><Rssi1>'+fingerprint.Receivers.Rssi1+'</Rssi1><DeviceID2>'+fingerprint.Receivers.DeviceID2+'</DeviceID2><Rssi2>'+fingerprint.Receivers.Rssi2+'</Rssi2><DeviceID3>'+fingerprint.Receivers.DeviceID3+'</DeviceID3><Rssi3>'+fingerprint.Receivers.Rssi3+'</Rssi3><DeviceID4>'+fingerprint.Receivers.DeviceID4+'</DeviceID4><Rssi4>'+fingerprint.Receivers.Rssi4+'</Rssi4><DeviceID5>'+fingerprint.Receivers.DeviceID5+'</DeviceID5><Rssi5>'+fingerprint.Receivers.Rssi5+'</Rssi5><DeviceID6>'+fingerprint.Receivers.DeviceID6+'</DeviceID6><Rssi6>'+fingerprint.Receivers.Rssi6+'</Rssi6><DeviceID7>'+fingerprint.Receivers.DeviceID7+'</DeviceID7><Rssi7>'+fingerprint.Receivers.Rssi7+'</Rssi7><DeviceID8>'+fingerprint.Receivers.DeviceID8+'</DeviceID8><Rssi8>'+fingerprint.Receivers.Rssi8+'</Rssi8></Receivers></SoftPoint>'
      return $http.post(proxyPath, xml, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/AreaControl/SoftPointList'}})
      .then(function(response){
        return (x2js.xml_str2json(response.data))
      }, function(err) {
        var errorObj = {"data":x2js.xml_str2json(err.data)}
        var errors = [{"message":"Failed to Write to ACG"}]
        errorObj.data.errors = errors
        return $q.reject(errorObj)
      })
    }

    inovonics.deleteFingerprint = function(fingerprintId) {
      return $http.delete(proxyPath, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/AreaControl/SoftPointList/'+fingerprintId}})
      .then(function(response){
        return (x2js.xml_str2json(response.data))
      }, function(err) {
        var errorObj = {"data":x2js.xml_str2json(err.data)}
        var errors = [{"message":"Failed to Write to ACG"}]
        errorObj.data.errors = errors
        return $q.reject(errorObj)
      })
    }

    inovonics.saveLocation = function(locationName) {
      var xml = '<PartitionInfo><Description>'+inovonics.makeXmlSafe(locationName)+'</Description><IsMobile>true</IsMobile></PartitionInfo>'
      return $http.post(proxyPath, xml, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/AreaControl/Partitions/PartitionInfoList'}})
      .then(function(response){
        return (x2js.xml_str2json(response.data)).ResponseStatus
      }, function(err) {
        var errorObj = {"data":x2js.xml_str2json(err.data)}
        var errors = [{"message":"Failed to Write to ACG"}]
        errorObj.data.errors = errors
        return $q.reject(errorObj)
      })
    }

    inovonics.updateLocation = function(locationId, locationName) {
      var xml = '<PartitionInfo><Description>'+inovonics.makeXmlSafe(locationName)+'</Description></PartitionInfo>'
      return $http.put(proxyPath, xml, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/AreaControl/Partitions/PartitionInfoList/'+locationId}})
      .then(function(response){
        return (x2js.xml_str2json(response.data)).ResponseStatus
      }, function(err) {
        var errorObj = {"data":x2js.xml_str2json(err.data)}
        var errors = [{"message":"Failed to Write to ACG"}]
        errorObj.data.errors = errors
        return $q.reject(errorObj)
      })
    }

    inovonics.deleteLocation = function(acgPartitionId) {
      // I like Inovonics a lot. However, this is stupid...
      // TODO: Use list slcicing to prevent breaking the ACG on a crazy long list...
      var deferred = $q.defer()
      var matchingFingerprints = []

      //Get the list of all fingerprints
      $http.get(proxyPath, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/AreaControl/SoftPointList'}})
      .then(function(response){
        var locations = (x2js.xml_str2json(response.data)).SoftPointList.SoftPoint
        // Find the fingerprints associated with a partition ID
        angular.forEach(locations, function(location) {
          if (acgPartitionId == location.PartitionID) {
            matchingFingerprints.push(location)
          }
        })
      })
      // Delete All Associated Fingerprints
      .then(function() {
        var promises = []
        angular.forEach(matchingFingerprints, function(fingerprint) {
          promises.push($http.delete(proxyPath, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/AreaControl/SoftPointList/'+fingerprint.ID}}))
        })
        return $q.all(promises)
      })
      // Delete the Partition
      .then(function(){
        return $http.delete(proxyPath, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/AreaControl/Partitions/PartitionInfoList/' + acgPartitionId}})
      })
      // Finish the promise
      .then(function(){
        deferred.resolve()
      })
      .catch(function(){
        deferred.reject()
      })
      return deferred.promise
    }

    // Repeaters
    inovonics.getRepeaters = function() {
      return $http.get(proxyPath, {headers: {'X-Proxy-URL':'http://'+acg_ip+'/PSIA/AreaControl/PartitionMembers/Zones/ZoneInfoList'}})
      .then(function(response){
        var repeaters = (x2js.xml_str2json(response.data)).ZoneInfoList.ZoneInfo
        var repeaterList = []
        angular.forEach(repeaters, function(repeater) {
          if (repeater.MID == 1) {
            repeaterList.push(repeater)
          }
        })
        return repeaterList
      }, function(err) {
        var errorObj = {"data":x2js.xml_str2json(err.data)}
        var errors = [{"message":"Failed to Remove From ACG"}]
        errorObj.data.errors = errors
        return $q.reject(errorObj)
      })
    }

    // Use this to simulate a device registration. Submit serial number and pti and it emit a registration message
    inovonics.deviceSim = function(serial, pti) {
      var device_object = {
        id:null,
        serial_number: serial,
        pti: parseInt(pti),
        acg_id:null,
        device_data:inovonics.inovonics_pti[pti]
      }
      $rootScope.$emit("inovonicsRegistration", device_object)
    }

    return inovonics

  }

})();

(function() {
 'use strict';

 angular
   .module('quantumUiAngular')
   .factory('httpRequestInterceptor', function(userAuth) {

   return {
      request: function (config) {
      config.headers['Auth-Token'] = userAuth.data.token;
      return config;
      }
    };
   })

})();

(function() {
  'use strict';

  angular
      .module('quantumUiAngular')
      .service('devMode', devMode);

  /** @ngInject */
  function devMode($log) {
    // Sets Static IPs for internal development

    var devMode = {};

    devMode.enabled = false
    devMode.serverIp = "10.0.6.10"
    devMode.acgIp = "10.0.6.11"

    if (devMode.enabled) {
      $log.log("Development Mode Enabled")
    }

    return devMode

  }

})();

(function() {
  'use strict';

  angular
      .module('quantumUiAngular')
      .service('customFilters', customFilters);

  /** @ngInject */
  function customFilters(quantumApi, userAuth) {

    var customFilter = {};

    // So Custom Report Filters are Schemaless
    // Drew just opened up the database to accept any JSON object
    // This service is here to try to force some schema around the whole thing
    // and provide a single source of truth to the app

    customFilter.data = {}

    // Ensures all of the keys are as in the object that we would expect
    quantumApi.staff.getFilters({id:userAuth.data.id}).$promise
    .then(function(data){
      var changed = false
      customFilter.data = data.filter
      if (!customFilter.data) {
        customFilter.data = {}
        changed = true
      }
      if (!customFilter.data.alarm_history) {
        customFilter.data.alarm_history = []
        changed = true
      }
      if (!customFilter.data.staff_care) {
        customFilter.data.staff_care = []
        changed = true
      }
      if (!customFilter.data.care) {
        customFilter.data.care = []
        changed = true
      }
      if (changed) {
        customFilter.saveFilters()
      }
    })

    customFilter.saveFilters = function() {
      quantumApi.staff.saveFilters({id:userAuth.data.id},{filter:customFilter.data})
    }


    return customFilter

  }

})();

angular
  .module('quantumUiAngular')
  .filter('removeId', function() {
  return function(items, idToRemove) {
    var filtered = [];
    if (idToRemove) {
      angular.forEach(items, function(item) {
        if (item.id != idToRemove) {
          filtered.push(item);
        }
      });
    }
    return filtered;
  }
});

angular
  .module('quantumUiAngular')
  .filter('objectIdSearch', function() {
  return function(items, array) {
    var filtered = [];
    if (array) {
      angular.forEach(items, function(item) {
        if (array.indexOf(item.id) != -1) {
          filtered.push(item);
        }
      });
    }
    return filtered;
  }
});

angular
  .module('quantumUiAngular')
  .filter('naturalSort',function(){
    function naturalSort (a, b) {
        var re = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?$|^0x[0-9a-f]+$|[0-9]+)/gi,
            sre = /(^[ ]*|[ ]*$)/g,
            dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
            hre = /^0x[0-9a-f]+$/i,
            ore = /^0/,
            i = function(s) { return naturalSort.insensitive && (''+s).toLowerCase() || ''+s },
            // convert all to strings strip whitespace
            x = i(a).replace(sre, '') || '',
            y = i(b).replace(sre, '') || '',
            // chunk/tokenize
            xN = x.replace(re, '\0$1\0').replace(/\0$/,'').replace(/^\0/,'').split('\0'),
            yN = y.replace(re, '\0$1\0').replace(/\0$/,'').replace(/^\0/,'').split('\0'),
            // numeric, hex or date detection
            xD = parseInt(x.match(hre)) || (xN.length != 1 && x.match(dre) && Date.parse(x)),
            yD = parseInt(y.match(hre)) || xD && y.match(dre) && Date.parse(y) || null,
            oFxNcL, oFyNcL;
        // first try and sort Hex codes or Dates
        if (yD)
            if ( xD < yD ) return -1;
        else if ( xD > yD ) return 1;
        // natural sorting through split numeric strings and default strings
        for(var cLoc=0, numS=Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
            // find floats not starting with '0', string or 0 if not defined (Clint Priest)
            oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
            oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
            // handle numeric vs string comparison - number < string - (Kyle Adams)
            if (isNaN(oFxNcL) !== isNaN(oFyNcL)) { return (isNaN(oFxNcL)) ? 1 : -1; }
            // rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
            else if (typeof oFxNcL !== typeof oFyNcL) {
                oFxNcL += '';
                oFyNcL += '';
            }
            if (oFxNcL < oFyNcL) return -1;
            if (oFxNcL > oFyNcL) return 1;
        }
        return 0;
    }
    return function(arrInput, name) {
        var arr = arrInput.sort(function(a, b) {
          var sorter
          if (name.indexOf('.') === -1) {
            sorter = naturalSort(a[name],b[name]);
          } else {
            var obj = name.split(".")[0]
            var prop = name.split(".")[1]
            if (!a[obj] && !b[obj]) {
              return 0
            } else if (!a[obj] && b[obj]) {
              return 1
            } else if (a[obj] && !b[obj]) {
              return -1
            } else {
              sorter = naturalSort(a[obj][prop],b[obj][prop])
            }
          }
            return sorter
        });
        return arr;
    }
});

angular
  .module('quantumUiAngular')
  .filter('multiSelect', function() {
  return function(items, filters) {
    var newFilterArray = []
    var newItemArray = []

    var checkBool = function(bool) {
      return bool
    }

    angular.forEach(filters, function(value, key) {
      newFilterArray[key] = []
    })
    angular.forEach(filters, function(filterArray, key) {
      angular.forEach(filterArray, function(filterItem) {
        newFilterArray[key].push(filterItem.id)
      })
    })


    // Itterate items
    angular.forEach(items, function(item) {
      var itemKeysValid = []
      // Itterate the keys of the items
      angular.forEach(item, function(value, key) {
        // Verify that the key is one we're filtering on and has items in it
        if (newFilterArray[key] && newFilterArray[key].length) {
          // If the key is valid and check to make sure
          if (newFilterArray[key].indexOf(value) != -1) {
            itemKeysValid.push(true)
          } else {
            itemKeysValid.push(false)
          }
        }
      })
      // If it's not filtered, push into the array
      if (!itemKeysValid.length || itemKeysValid.every(checkBool)) {
        newItemArray.push(item)
      }
    })

    return newItemArray;
  }
});

angular
  .module('quantumUiAngular')
  .filter('intervalParser', function() {
  return function(object) {
    var output;

    var days = ["Monday", "Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"]

    var hour
    var minute
    var amOrPm

    if (object.hour == 0) {
      hour = 12
      amOrPm = "AM"
    } else if ( object.hour < 12) {
      hour = object.hour
      amOrPm = "AM"
    } else if ( object.hour == 12) {
      hour = object.hour
      amOrPm = "PM"
    } else {
      hour = (object.hour - 12)
      amOrPm = "PM"
    }

    if (object.minute < 10) {
      minute = "0" + object.minute
    } else {
      minute = object.minute
    }

    var day = days[object.day]

    output = day + " " + hour + ":" + minute + " " + amOrPm

    return output;
  }
});

angular
  .module('quantumUiAngular')
  .filter('findObject', function() {
  return function(array, id) {
    var objectsFound = []
      angular.forEach(array, function(object){
        if (object.id == id) {
          objectsFound.push(object)
        }
      })
      return objectsFound;
    }
});

angular
  .module('quantumUiAngular')
  .filter('apartmentSearch', function() {
  return function(residents, apartments) {
    if (apartments) {
      angular.forEach(residents, function(resident) {
        angular.forEach(apartments, function(apartment){
          if (apartment.id == resident.apartment) {
            resident.apartment_name = apartment.name
          }
        })
      });
    }
    return residents;
  }
});

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('quantumWarningBar', quantumWarningBar);

  /** @ngInject */
  function quantumWarningBar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveWarningBar/warningBar.html',
      scope: {},
      controller: WarningBarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function WarningBarController($log, systemStatus, $location, userAuth) {
      var vm = this;

      vm.systemStatus = systemStatus;
      vm.userAuth = userAuth

      vm.activateSystemRedirect = function() {
        $location.path('admin-system-config')
      }

      vm.systemStatusRedirect = function() {
        $location.path('report-system-status')
      }

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('quantumUnmonitoredHardwareTable', quantumUnmonitoredHardwareTable);

  /** @ngInject */
  function quantumUnmonitoredHardwareTable() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveUnmonitoredHardwareTable/unmonitoredHardware.html',
      scope: {},
      controller: unmonitoredHardwareController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function unmonitoredHardwareController($location, systemStatus) {
      var vm = this;

      vm.systemStatus = systemStatus;

    }
  }

})();

angular
  .module('quantumUiAngular')
  .controller('quantumUiAngular').directive('uiSelectSingleRequired', function() {
    return {
      require: 'ngModel',
      link: function(scope, elm, attrs, ctrl) {

        var reqMsg = angular.element("<label class='control-label'>This field is required.</label>")
        var parentElm = angular.element(elm).parent()

        ctrl.$validators.uiSelectSingleRequired = function(modelValue) {
          return (modelValue != null);
        };

        function checkValid() {
          if (scope.inputCtrl.$dirty && !scope.inputCtrl.$valid) {
            angular.element(elm).after(reqMsg)
            parentElm.addClass('has-error');
          } else {
            reqMsg.remove()
            parentElm.removeClass('has-error');
          }
        }

        scope.inputCtrl = ctrl;
        scope.$watch('inputCtrl.$valid', checkValid)
        scope.$watch('inputCtrl.$dirty', checkValid)

      }
    };
  }
);

angular
  .module('quantumUiAngular')
  .controller('quantumUiAngular').directive('uiSelectRequired', function() {
    return {
      require: 'ngModel',
      link: function(scope, elm, attrs, ctrl) {

        var reqMsg = angular.element("<label class='control-label'>This field is required.</label>")
        var parentElm = angular.element(elm).parent()

        ctrl.$validators.uiSelectRequired = function(modelValue) {
          if (!attrs.disabled) {
            if (modelValue) {
              return (modelValue.length != 0);
            } else {
              return false
            }
          } else {
            return true
          }
        };

        function checkValid() {
          if (scope.inputCtrl.$dirty && !scope.inputCtrl.$valid) {
            angular.element(elm).after(reqMsg)
            parentElm.addClass('has-error');
          } else {
            reqMsg.remove()
            parentElm.removeClass('has-error');
          }
        }

        scope.inputCtrl = ctrl;
        scope.$watch('inputCtrl.$valid', checkValid)
        scope.$watch('inputCtrl.$dirty', checkValid)
        attrs.$observe("disabled", ctrl.$validate)
      }
    };
  }
);

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('quantumSidebar', quantumSidebar);

  /** @ngInject */
  function quantumSidebar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveSidebar/sidebar.html',
      scope: {},
      controller: SidebarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SidebarController($log, systemStatus) {
      var vm = this;

      vm.systemStatus = systemStatus;

      vm.statusClear = function() {
        return (vm.systemStatus.data.active_alarm.length == false) && (vm.systemStatus.data.missing_device.length == false) && (vm.systemStatus.data.low_battery.length == false) && (vm.systemStatus.data.repeater_error.length == false) && (vm.systemStatus.data.active_leave.length == false)
      }

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('quantumScheduleTable', quantumScheduleTable);

  /** @ngInject */
  function quantumScheduleTable() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveScheduleTable/scheduleTable.html',
      scope: {},
      controller: scheduleTableController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function scheduleTableController($location, systemStatus) {
      var vm = this;

      vm.systemStatus = systemStatus;

      vm.showId = $location.path() === "/report-system-status"

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('quantumRepeaterErrorTable', quantumRepeaterErrorTable);

  /** @ngInject */
  function quantumRepeaterErrorTable() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveRepeaterErrorTable/repeaterErrorTable.html',
      scope: {},
      controller: repeaterErrorTableController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function repeaterErrorTableController($location, systemStatus) {
      var vm = this;

      vm.systemStatus = systemStatus;

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('quantumMissingDeviceTable', quantumMissingDeviceTable);

  /** @ngInject */
  function quantumMissingDeviceTable() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveMissingDeviceTable/missingDeviceTable.html',
      scope: {},
      controller: missingDeviceTableController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function missingDeviceTableController(systemStatus) {
      var vm = this;

      vm.systemStatus = systemStatus;

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('quantumNavbar', quantumNavbar);

  /** @ngInject */
  function quantumNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveNavbar/navbar.html',
      scope: {},
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($log, userAuth, navItems) {
      var vm = this;
      vm.navItems = navItems
      vm.isCollapsed = false;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('ignoreMouseNumber', ignoreMouseNumber);

  /** @ngInject */
  function ignoreMouseNumber() {

    return {
      restrict: 'A',
      link: function (scope, element) {
        element.bind('mousewheel', function (event) {
          event.preventDefault();
        });
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('quantumLowBattTable', quantumLowBattTable);

  /** @ngInject */
  function quantumLowBattTable() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveLowBattTable/lowBattTable.html',
      scope: {},
      controller: lowBattTableController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function lowBattTableController($location, systemStatus) {
      var vm = this;

      vm.systemStatus = systemStatus;

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('intervalPicker', intervalPicker);

  /** @ngInject */
  function intervalPicker() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveIntervalPicker/intervalPicker.html',
      scope: {
        interval: '=interval',
        disableDay: '=disableDay'
      },
      controller: IntervalPickerController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    // With apologies...

    /** @ngInject */
    function IntervalPickerController($log, $scope) {
      // Set Up Local Vars
      var vm = this;
      var amHours = [{"label":"1","value":1},{"label":"2","value":2},{"label":"3","value":3},{"label":"4","value":4},{"label":"5","value":5},{"label":"6","value":6},{"label":"7","value":7},{"label":"8","value":8},{"label":"9","value":9},{"label":"10","value":10},{"label":"11","value":11},{"label":"12","value":0}]
      var pmHours = [{"label":"1","value":13},{"label":"2","value":14},{"label":"3","value":15},{"label":"4","value":16},{"label":"5","value":17},{"label":"6","value":18},{"label":"7","value":19},{"label":"8","value":20},{"label":"9","value":21},{"label":"10","value":22},{"label":"11","value":23},{"label":"12","value":12}]

      // Return correct dropdown data based on am/pm
      vm.hours = function() {
        if (vm.interval.hour < 12) {
          vm.pm = false
          return amHours
        } else {
          vm.pm = true
          return pmHours
        }
      }

      vm.minutes = [{"value":0,"label":"00"},{"value":5,"label":"05"},{"value":10,"label":"10"},{"value":15,"label":"15"},{"value":20,"label":"20"},{"value":25,"label":"25"},{"value":30,"label":"30"},{"value":35,"label":"35"},{"value":40,"label":"40"},{"value":45,"label":"45"},{"value":50,"label":"50"},{"value":55,"label":"55"}]
      vm.amOrPm = [{"label":"AM", "value":false},{"label":"PM", "value":true}]
      vm.days = [{"label":"Monday", "value":0},{"label":"Tuesday", "value":1},{"label":"Wednesday", "value":2},{"label":"Thursday", "value":3},{"label":"Friday", "value":4},{"label":"Saturday", "value":5},{"label":"Sunday", "value":6}]

      $scope.$watch('vm.pm', function(pm, oldValue) {
        //Ignore the inital load
        if (pm !== oldValue) {
          if (pm && vm.interval.hour < 12) {
            vm.interval.hour = vm.interval.hour + 12
          } else if (vm.interval.hour >= 12) {
            vm.interval.hour = vm.interval.hour - 12
          }
        }
      })
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('quantumLeaveTable', quantumLeaveTable);

  /** @ngInject */
  function quantumLeaveTable() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveLeaveTable/leaveTable.html',
      scope: {},
      controller: leaveTableController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function leaveTableController($location, systemStatus) {
      var vm = this;

      vm.systemStatus = systemStatus;

      // Show the Db ID if on the system status report
      vm.showId = $location.path() === "/report-system-status"

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('quantumEventTable', quantumEventTable);

  /** @ngInject */
  function quantumEventTable() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveEventTable/eventTable.html',
      scope: {},
      controller: alarmTableController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function alarmTableController($rootScope, $log, $interval, $timeout, $scope, quantumApi, userAuth, systemStatus) {
      var vm = this;
      var totalEvents = 10
      var clickCounter = 0

      vm.systemStatus = systemStatus
      vm.eventList = []
      vm.eventSearch = ""
      vm.debugMode = false


      // Initial Load of events on view load
      function loadEvents() {
        quantumApi.events.get(function(events){
          angular.forEach(events.events, function(event) {
            vm.eventList.push(event)
            // Drop off old events
            if (vm.eventList.length > totalEvents) {
              vm.eventList.pop()
            }
          })
        })
      }

      loadEvents()

      var eventListener = $rootScope.$on('newEvent', function(event, data){
        vm.eventList.unshift(data)
        if (vm.eventList.length > totalEvents) {
          vm.eventList.pop()
        }
      })

      // das clickengear - Debug Mode - Loads in 30 events and sets the search visible
      vm.enableDebug = function() {
        if (userAuth.data.id == 2) {
          if (!userAuth.data.debugMode && clickCounter < 4) {
            clickCounter ++
          } else {
            vm.debugMode = true
            totalEvents = 30
            userAuth.debugMode()
          }
        }
      }

      vm.enableDebug()

      // When navigating away, cancel the intercal
      $scope.$on('$destroy', function () {
        eventListener()
      });

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('allegionErrorTable', allegionErrorTable);

  /** @ngInject */
  function allegionErrorTable() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveAllegionErrorTable/allegionErrorTable.html',
      scope: {},
      controller: allegionTableController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function allegionTableController($location, systemStatus) {
      var vm = this;

      vm.systemStatus = systemStatus;

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('quantumErrorTable', quantumErrorTable);

  /** @ngInject */
  function quantumErrorTable() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveErrorTable/errorTable.html',
      scope: {},
      controller: errorTableController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function errorTableController($location, systemStatus) {
      var vm = this;

      vm.systemStatus = systemStatus;

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('quantumAlarmTable', quantumAlarmTable);

  /** @ngInject */
  function quantumAlarmTable() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveAlarmTable/alarmTable.html',
      scope: {},
      controller: alarmTableController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function alarmTableController(systemStatus, quantumApi, $uibModal, $scope, $interval, moment, toastr, $log, userAuth) {
      var vm = this;
      var interval
      var selectedAlarmId

      vm.userAuth = userAuth

      vm.systemStatus = systemStatus;

      vm.snoozeObject = {
        snooze_time:60,
        password:""
      }

      vm.popoverIsOpen = false

      // Modal Setup
      vm.openModal = function(selectedAlarm){
        selectedAlarmId = selectedAlarm.id
        vm.selectedAlarm = null
        loadData()
        interval = $interval(loadData, 3000)
        vm.modalInstance = $uibModal.open({
            templateUrl: 'alarmModal.html',
            scope: $scope,
            size: 'lg'
        })
        vm.modalInstance.result
        .finally(function(){
          selectedAlarmId = null
          $interval.cancel(interval);
        })
      }

      // Snooze
      vm.snoozeDurations = [{"label":"1 Hour", "value":60}, {"label":"2 Hours", "value":120}, {"label":"3 Hours", "value":180}, {"label":"4 Hours", "value":240}]

      vm.snoozeInit = function() {
        vm.snoozeObject.snooze_time = 60
        vm.snoozeObject.password = ""
      }

      vm.snoozeInit()

      vm.snooze = function() {
        quantumApi.alarm.snooze({'id':selectedAlarmId}, vm.snoozeObject).$promise
        .then(function(){
          toastr.success("Alarm Snoozed Successfully","Success!")
          vm.snoozeInit()
          vm.popoverIsOpen = false
          loadData()
        })
        .catch(function(err){
          toastr.warning("Failed to Snooze Alarm","Incorrect Password")
          $log.info(err)
        })
      }

      vm.clearSnooze = function() {
        quantumApi.alarm.snooze({'id':selectedAlarmId}, {snooze_time:null, password:null}).$promise
        .then(function(){
          toastr.success("Snooze Cleared Successfully", "Success!")
          loadData()
        })
      }


      function loadData(){
        quantumApi.alarm.get({'id':selectedAlarmId},function(data){
          if (!angular.equals(data, vm.selectedAlarm)) {
            vm.selectedAlarm = data
          }
        })
      }

      // Make it pretty
      vm.humanizeDuration = function(duration) {
        return moment.duration(duration, "seconds").humanize()
      }

      vm.calculateDuration = function(startTime) {
        var currentTimeMoment = moment(systemStatus.data.server_time)
        var startTimeMoment = moment(startTime)
        var timeDiv = currentTimeMoment.diff(startTimeMoment)
        return vm.humanizeDuration(timeDiv/1000)
      }

      vm.closeModal = function(){
          vm.modalInstance.dismiss();
      };

      $scope.$on('$destroy', function() {
        $interval.cancel(interval);
      })


    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .directive('quantumButtonbar', quantumButtonbar);

  /** @ngInject */
  function quantumButtonbar(systemStatus) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveButtonbar/buttonbar.html',
      scope: {},
      controller: SidebarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SidebarController($log, toastr, ngAudio, $rootScope, userAuth, $scope, $uibModal, quantumApi, $timeout) {
      // Not sure if this is the right place to put the alarm enunciation and server connection popup, but here it is...
      var vm = this;
      var connectionStatus
      vm.sound = ngAudio.load("assets/sounds/alarm.mp3");
      vm.sound.loop = true
      vm.systemStatus = systemStatus;
      vm.userAuth = userAuth

      //TODO Fix Logout Bug

      function refreshSystemUpdate() {

        // Update the disconnect modal (Error Connecting to Server)
        if (!vm.systemStatus.data.connected && (vm.systemStatus.data.connected != connectionStatus)) {
          vm.modalInstance = $uibModal.open({
              templateUrl: 'connectionModal.html',
              scope: $scope,
              size: 'md',
              backdrop: 'static'
          });
          connectionStatus = vm.systemStatus.data.connected
        } else if (vm.systemStatus.data.connected && (vm.systemStatus.data.connected != connectionStatus)) {
          if (vm.modalInstance) {
            vm.modalInstance.dismiss();
          }
          connectionStatus = vm.systemStatus.data.connected
        }

        var activeAlarms = []
        angular.forEach(vm.systemStatus.data.active_alarm, function(alarm) {
          if (!alarm.is_snoozed) {
            activeAlarms.push(alarm)
          }
        })

        if (activeAlarms.length && userAuth.data.enunciate){
          if (vm.sound.paused || typeof vm.sound.paused === "undefined"){
            vm.sound.play()
          }
        } else if(!activeAlarms.length && userAuth.data.enunciate) {
          vm.sound.pause()
        }
      }

      vm.statusUpdate = $rootScope.$on('statusUpdate', function(){
        $timeout(refreshSystemUpdate,0)
      })

      vm.lockdownToggle = function(password) {
        quantumApi.door.lockdownToggle({'password':password, lockdown:!systemStatus.data.lockdown_status}).$promise
        .catch(function(){
          toastr.warning("Please Try Again", "Incorrect Password")
        })
        .finally(function(){
          vm.password = ''
        })
      }

      $scope.$on('$destroy', function() {
        vm.sound.destroy()
      })

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('StaffStatusController', StaffStatusController);

  /** @ngInject */
  function StaffStatusController($scope, $rootScope, $interval, quantumApi, $filter) {
    var vm = this;
    var previousList
    var changesMade

    vm.orderByKey = "last_name"
    vm.orderReverse = false
    vm.initalLoadComplete = false

    vm.searchFilter = ""

    function getStaffStatus(){
      quantumApi.staff.query(function(data){
        vm.initalLoadComplete = true
        // Change detection and sorting in the controller for performance issues
        if (!angular.equals(data, previousList)) {
          changesMade = true
        }

        previousList = angular.copy(data)

        if (changesMade) {
          vm.staff = $filter('naturalSort')(data, vm.orderByKey)
          changesMade = false
        }
      })
    }

    vm.resort = function() {
      vm.staff = $filter('naturalSort')(vm.staff, vm.orderByKey)
    }

    // Initial Load
    getStaffStatus()

    // Interval for fetching Staff Status. We'll use websockets someday...
    vm.refreshInterval = $interval(getStaffStatus, 3000)

    // When navigating away, cancel the intercal
    $scope.$on('$destroy', function () { $interval.cancel(vm.refreshInterval); });

    // Raw Card Info
    // Listeer for raw card data coming from enrollment station with card reader
    // Comes from the websocket initiate in the system status service
    var cardDataListener = $rootScope.$on('cardEnrollData', function(event, data){
      vm.searchFilter = data
    })

    // Site name for csv filename
    quantumApi.siteInfo.get(function(data){
      vm.siteName = data.name.replace(/\s+/g, '_')
    })

    vm.cleanCsv = function() {
      var results = []

      angular.forEach(vm.staff, function(staff) {
        var staffObj = {
          first_name:staff.first_name,
          last_name:staff.last_name,
          keypad_code:staff.keypad ? staff.keypad:"Not Assigned",
          keycard_code:staff.keycard ? staff.keycard:"Not Assigned",
          enrolled_code:staff.raw_card_data ? "Enrolled":"Not Enrolled",
          type:staff.corporate_id ? "Corporate" : "Local"
        }
        results.push(staffObj)
      })

      return results
    }

    vm.csvHeaders = ["First Name", "Last Name", "Keypad Code", "Keycard Code", "Enrolled Code", "Staff Type"]


    // Clean Up the connection to the acg and the event listeners on destroy
    $scope.$on('$destroy', function() {
      $scope.$on('$destroy', cardDataListener())
    })

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('StaffSendMessageController', StaffSendMessageController);

  /** @ngInject */
  function StaffSendMessageController(quantumApi, $interval, $scope) {
    var vm = this;
    var interval
    vm.interfaces = []
    vm.messageResults = []

    // Associate the alert Devices to their interfaces for headings
    vm.alertDevices = quantumApi.alertDevice.query(function(){
      associateInterfaces()
    })

    function associateInterfaces() {
      quantumApi.outputInterface.query(function(data){
        angular.forEach(data, function(value) {
          value.alert_devices = []
          angular.forEach(vm.alertDevices, function(device) {
            if (device.interface_id == value.id) {
              value.alert_devices.push(device)
            }
          })
          vm.interfaces.push(value)
        })
      })
    }

  vm.initForm = function() {
    vm.formData = {
      selectedAlertDevices: [],
      msg: null
    }
  }

  vm.initForm()

  vm.submitMsg = function() {
    angular.forEach(vm.formData.selectedAlertDevices, function(value) {
      var msgObject = {
        "interface_id": value.interface_id,
        "message_text": vm.formData.msg,
        "alert_device": value.contact_value,
        "response": null
      }
      quantumApi.uiMessage.save(msgObject).$promise
      .then(function(data){
        msgObject.msgId = data.id
        msgObject.timeout = 0
        vm.messageResults.unshift(msgObject)
      })
    })
    vm.initForm()
  }

  function checkForMsg() {
    angular.forEach(vm.messageResults, function(message) {
      // Hit the api to see if it's been sent
      // Timeout at 30 Seconds
      if (message.timeout > 15) {
        message.response = "Timeout: No Response From Server"
      }
      if (!message.response) {
        quantumApi.uiMessage.get({'id':message.msgId}).$promise
        .then(function(data){
          // move it to completed
          if (data.response) {
            message.response = data.response
          } else {
            message.timeout ++
          }
        })
      }
    })
  }

  interval = $interval(checkForMsg, 2000)

  // Clean Up the connection to the acg and the event listeners on destroy
  $scope.$on('$destroy', function() {
    $interval.cancel(interval);
  })

}

})();

(function() {
  'use strict';
  angular
    .module('quantumUiAngular')
    .controller('StaffMessengerGroupController', StaffMessengerGroupController);

  /** @ngInject */
  function StaffMessengerGroupController($log, $timeout, WizardHandler, toastr, quantumApi) {
    var vm = this;

    function initForm() {
      vm.existingGroups = []
      // Pull Data from the API
      quantumApi.staff.query(function(data){
        vm.staff = []
        angular.forEach(data, function(staff) {
          if (staff.active && staff.mobile_access){
            vm.staff.push(staff)
          }
        })
      })

       quantumApi.staffGroup.query(function(data){
         angular.forEach(data, function(group) {
           if (group.active) {
             vm.existingGroups.push(group)
           }
         })
       })
      // Init the Ladda
      vm.laddaEnabled = false
      // Init the Radio Buttons
      vm.selector = false
      // Default Form Data
      vm.formData = {
        "name":"",
        "doors_in_group":false
      }
      if (vm.form){
        vm.form.$setPristine()
        WizardHandler.wizard('accessGroup').reset()
      }
    }

    initForm()

    // Load Data from Selection Page
    vm.loadSelectedData = function(selectedOption) {
      vm.formData = quantumApi.staffGroup.get({id:selectedOption.id})
    }

    // Step Validation
    vm.stepSelectValid = function(){
      vm.form.group_selector.$dirty = true;
      return (!vm.selector == false)
    }

    // Step Validation
    vm.stepInfoValid = function(){
      vm.form.name.$dirty = true;
      vm.form.staff_data.$dirty = true;
      return vm.form.name.$valid && vm.form.staff_data.$valid
    }

    // Submit Form
    vm.submitWizardCreate = function(){
      // HTTP Request Goes Here
      vm.laddaEnabled = true
      quantumApi.staffGroup.save(vm.formData, function(){
        toastr.success('Door Group Created', 'Success!');
        initForm()
      }, function(response){
        // Error Status Returned from the Server
        angular.forEach(response.data.errors, function(value) {
          $log.info(value.message + " " + value.property)
        })
        toastr.warning('Unable to Create Door Group', 'Error!');
        initForm()
      })
    }

    vm.submitWizardChange = function(){
      vm.laddaEnabled = true
      quantumApi.staffGroup.update({id: vm.formData.id}, vm.formData, function() {
        toastr.success('Door Group Change', 'Success!');
        initForm()
      }, function(response){
        // Error Status Returned from the Server
        angular.forEach(response.data.errors, function(value) {
          $log.info(value.message + " " + value.property)
        })
        toastr.warning('Unable to Change Door Group', 'Error!');
        initForm()
      })
    }

    vm.submitWizardRemove = function(){
      vm.laddaEnabled = true
      quantumApi.staffGroup.remove({id: vm.formData.id}, function() {
        toastr.success('Door Group Removed', 'Success!');
        initForm()
      }, function(response){
        // Error Status Returned from the Server
        angular.forEach(response.data.errors, function(value) {
          $log.info(value.message + " " + value.property)
        })
        toastr.warning('Unable to Remove Door Group', 'Error!');
        initForm()
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('StaffMessengerController', StaffMessengerController);

  /** @ngInject */
  function StaffMessengerController($log, toastr, quantumApi, $q, messengerEngine) {
    var vm = this;

    vm.selectedConversation = null
    vm.previousConversations = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.ladda = false

    messengerEngine.loadMessageState()

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevConversation, nextConversation) {
      if (event.which == 38 && prevConversation) {
        event.preventDefault()
        vm.selectedConversation = prevConversation
      } else if (event.which == 40 && nextConversation) {
        event.preventDefault()
        vm.selectedConversation = nextConversation
      }
    }

    vm.getConversations = function() {
      vm.conversations = quantumApi.conversation.query(function(data){
        vm.previousConversations = angular.copy(data)
      })
      vm.selectedConversation = null
    }

    vm.getConversations()

    vm.addConversation = function() {
      vm.conversations.push({
        id:null,
        name:"New conversation",
        checkin_staff:[]
      })
      vm.selectedConversation = vm.conversations[vm.conversations.length - 1]
    }

    vm.removeConversation = function(index, conversation) {
        if (angular.equals(conversation, vm.selectedConversation)) {
          vm.selectedConversation = null
        }
        if (conversation.id && conversation.id != 1) {
          conversation.deleted = true
        } else if (!conversation.id) {
          vm.conversations.splice(index,1)
        }

    }

    vm.conversationsValid = function(){
      var val = true
      angular.forEach(vm.conversations, function(conversation){
        if (!conversation.name) {
          val = false
        }
      })
      return val
    }

    vm.conversationValid = function(group) {
      return true
    }


    vm.saveConversations = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.conversations, function(conversation, key) {
        if (conversation.id && !conversation.deleted) {
          if (!angular.equals(conversation, vm.previousConversations[key])) {
            promises.push(quantumApi.conversation.update({id:conversation.id},conversation).$promise)
          }
        } else if (conversation.deleted) {
          promises.push(quantumApi.conversation.delete({id:conversation.id},conversation).$promise)
        } else {
          promises.push(quantumApi.conversation.save(conversation).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getConversations()
        toastr.success("Conversations Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Conversations", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('StaffController', StaffController);

  /** @ngInject */
  function StaffController($rootScope, $scope, $log, WizardHandler, toastr, quantumApi, moment, systemStatus, $location, userAuth) {
    var vm = this;

    vm.userAuth = userAuth

    vm.systemLicense = userAuth.data.system_license
    vm.allegionAccessGroups = quantumApi.allegionAccessGroup.query()

    vm.systemStatus = systemStatus
    var curTime = moment.utc(vm.systemStatus.data.server_time)
    var keycardEnrolled = []
    var keypadEnrolled = []
    var rawCardEnrolled = []
    var usernamesEnrolled = []
    vm.selector = null
    vm.accessExpiration = false
    vm.staff = []
    vm.selectStepSubmitted = false
    vm.initalLoadComplete = false

    // Password Reset Options
    vm.passwordOptions = [{
      "label":"Keep Current Password",
      "value":false
    },{
      "label":"Reset Password",
      "value":true
    }]

    vm.resetPassword = false
    vm.passwordResetChange = function(value) {
      if (!value) {
        vm.formData.password = null
      }
    }

    // This flipping date picker...
    var rounding = 5 * 60 * 1000;
    vm.offset = "-0"+Math.abs(vm.systemStatus.data.offset)+"00"

    vm.datepickerOptions = {
      autoApply: true,
      opens: 'embed',
      timePicker: true,
      timePickerIncrement: 5,
      format: 'MM/DD/YYYY h:mm A',
      minDate: moment(Math.ceil((+moment(curTime.zone(vm.offset))) / rounding) * rounding),
      validationOptions: {
        interval: 1,
        unit: "hours",
        message: "End Date Must be at Least 1 Hour After Start Date"
      }
    }

    vm.scheduleChange = function() {
      if (vm.date && vm.accessExpiration) {
        vm.formData.start_date = vm.date.startDate,
        vm.formData.end_date = vm.date.endDate
      } else {
        vm.formData.start_date = null,
        vm.formData.end_date = null
      }
    }
    // End Datepicker

    vm.staffAccessChange = function(){
      if (vm.formData.access_group == 0) {
        vm.formData.user_name = null
        vm.formData.password = null
        vm.formData.auto_logout = 0
      }
    }

    vm.doorAccessChange = function(){
      if (vm.formData.door_access_level == 0) {
        vm.formData.keycard = null
        vm.formData.keypad = null
        vm.formData.raw_card_data = null
        vm.formData.start_date = null
        vm.formData.send_date = null
        vm.formData.door_groups = []
        vm.formData.schedules = []
        vm.accessExpiration = false
      }
    }



    vm.doorAccessLevels =[
      {
        id: 0,
        lable: 'No Access',
        value: 0
      },
      {
        id: 1,
        lable: 'Bypass Only (Resident Not Present)',
        value: 1
      },
      {
        id: 2,
        lable: 'Bypass Only (At Any Time)',
        value: 2
      },
      {
        id: 3,
        lable: 'Bypass and Reset Resident Alarms',
        value: 3
      }
    ]

    vm.autoLogoutTimes =[
      {
        id:0,
        lable: 'Disabled',
        value: 0
      },
      {
        id:5,
        lable: '5 Minutes',
        value: 5
      },
      {
        id:10,
        lable: '10 Minutes',
        value: 10
      },
      {
        id:15,
        lable: '15 Minutes',
        value: 15
      },
      {
        id:30,
        lable: '30 Minutes',
        value: 30
      }
    ]

    quantumApi.staffAccessGroup.query(function(data){
      vm.staffAccessGroups = []
      angular.forEach(data, function(value) {
        if (userAuth.data.ui_access_group == 1 && value.id == 1) {
          vm.staffAccessGroups.push(value)
        } else if (value.id != 1) {
          vm.staffAccessGroups.push(value)
        }

      })
    })
    vm.doorAccessGroups = quantumApi.doorAccessGroup.query()
    vm.doorAccessSchedules = quantumApi.scheduleWeeklyStaff.query()

    function initForm() {
      vm.selectStepSubmitted = false
      vm.selector = false
      vm.resetPassword = false
      vm.staff = []
      // Get the staff and the enrolled keycards
      quantumApi.staff.query(function(data){
        angular.forEach(data, function(user) {
          // Don't make corp staff availble for editing
          if (!user.corporate_id) {
            vm.staff.push(user)
          }
          usernamesEnrolled.push(user.user_name)
        })
        vm.initalLoadComplete = true
      })

      quantumApi.staff.usedCodes(function(data){
        keycardEnrolled = data.used_wiegand
        keypadEnrolled = data.used_keypad_codes
        rawCardEnrolled = data.used_raw_codes
      })

      vm.date = {
        endDate: moment(Math.ceil((+moment(curTime.zone(vm.offset))) / rounding) * rounding).zone(vm.offset).add(1,'h'),
        startDate: moment(Math.ceil((+moment(curTime.zone(vm.offset))) / rounding) * rounding).zone(vm.offset)
      }

      vm.formData = {
        "id": null,
        // Basic Info
        "first_name": null,
        "last_name": null,
        "email": null,
        "receive_system_status":false,
        "receive_tag_test":false,
        // Software Access
        "access_group": 0,
        "user_name": null,
        "password":null,
        "auto_logout": 0,
        "mobile_access": false,
        // Door Access
        "door_access_level": 0,
        "keycard": null,
        "keypad": null,
        "raw_card_data":null,
        "start_date": null,
        "end_date": null,
        "door_groups": [],
        "allegion_door_groups": [],
        "schedules": [],
        // Ignore...
        "active": true,
        "last_location_id": null,
        "last_location_name": null,
        "location_time": null,
        "corporate_id":null
      }
    }

    initForm()


  vm.loadStaffEvent = function(staff) {
    angular.copy(vm.selector, vm.formData)
    if (staff.start_date) {
      vm.accessExpiration = true
      vm.date = {
        endDate: staff.end_date,
        startDate: staff.start_date
      }
    } else {
      vm.accessExpiration = false
    }
  }

  vm.systemStatusChecker = function(emailAddress) {
    if (!emailAddress) {
      vm.formData.receive_system_status = false
    }
  }

  // Raw Card Info
  // Listeer for raw card data coming from enrollment station with card reader
  // Comes from the websocket initiate in the system status service
  var cardDataListener = $rootScope.$on('cardEnrollData', function(event, data){
    if (vm.formData.door_access_level != 0) {
      vm.formData.raw_card_data = data
      vm.form.rawcard.$dirty = true;
    }
  })

  // Clean Up the connection to the acg and the event listeners on destroy
  $scope.$on('$destroy', function() {
    $scope.$on('$destroy', cardDataListener())
  })

    // Step Validation
    vm.stepUserValid = function(){
      vm.form.first_name.$dirty = true;
      vm.form.last_name.$dirty = true;
      return vm.form.first_name.$valid && vm.form.last_name.$valid
    }

    vm.stepUiValid = function(){
      if (vm.formData.access_group == 0 && !vm.formData.mobile_access) {
        return true
      } else {
        vm.form.user_name.$dirty = true;
        if ($location.path() == "/staff-change" && (!vm.resetPassword && vm.selector.user_name)) {
          return vm.form.user_name.$valid
        } else {
          vm.form.user_password.$dirty = true;
          return vm.form.user_name.$valid = true && vm.form.user_password.$valid
        }
      }
    }

    vm.validateUsername = function(userName) {
      if (usernamesEnrolled.indexOf(userName) != -1 && userName != vm.selector.user_name) {
        return false
      } else {
        return true
      }
    }

    vm.validateUsernameMsg = function(userName) {
      if (usernamesEnrolled.indexOf(userName) != -1) {
        return "Username Already Exists"
      }
      return true
    }

    vm.stepDoorValid = function(){
      if (vm.formData.door_access_level == 0) {
        return true
      } else {
        vm.form.keycard.$dirty = true;
        vm.form.keypad.$dirty = true;
        vm.form.rawcard.$dirty = true;
        vm.form.door_access_groups.$dirty = true;
        vm.form.door_access_schedules.$dirty = true;
        if (!userAuth.data.system_license.allegion_active){
          return vm.form.keycard.$valid && vm.form.keypad.$valid && vm.validateDoorGroup() && vm.form.rawcard.$valid && vm.validateDoorSchedule()
        } else {
          vm.form.allegion_door_access_groups.$dirty = true;
          return vm.form.keycard.$valid && vm.form.keypad.$valid && vm.form.rawcard.$valid && vm.validateDoorSchedule() && vm.validateDoorGroup()
        }
      }
    }

    vm.stepSelectValid = function() {
      vm.selectStepSubmitted = true
      return vm.selector != false
    }


    // Door Validation

    vm.validateKeycard = function(keycard) {
      if (!keycard && keycard != 0) {
        if (vm.formData.keycard || vm.formData.keypad || vm.formData.raw_card_data) {
          return true
        } else {
          return false
        }
      } else if (keycardEnrolled.indexOf(keycard) != -1 && keycard != vm.selector.keycard) {
        return false
      } else if (keycard < 10000 || keycard > 65535) {
        return false
      }
      else {
        return true
      }
    }

    vm.validateKeycardMsg = function(keycard) {
      if (!keycard && keycard != 0) {
        return "Keycard or Keypad Code Required"
      } else if (keycardEnrolled.indexOf(keycard) != -1) {
        return "Keycard Already Exists"
      } else if (!keycard < 10000 || !keycard > 65535) {
        return "Keycard Must be Between 10000 and 65534"
      }
      return true
    }

    vm.validateKeypad = function(keypad) {
      if (!keypad && keypad != 0) {
        if (vm.formData.keycard || vm.formData.keypad || vm.formData.raw_card_data) {
          return true
        } else {
          return false
        }
      } else if (keypadEnrolled.indexOf(keypad) != -1 && keypad != vm.selector.keypad) {
        return false
      } else if (keypad < 1000 || keypad > 9999) {
        return false
      }
      else {
        return true
      }
    }

    vm.validateKeypadMsg = function(keypad) {
      if (!keypad && keypad != 0) {
        return "Keycard or Keypad Code Required"
      } else if (keypadEnrolled.indexOf(keypad) != -1) {
        return "Keypad Code Already Enrolled"
      } else if (!keypad < 1000 || !keypad > 9999) {
        return "Keypad Code Must be Between 1000 and 9999"
      }
    }

    vm.validateRawCard = function(enrolled) {
      if (!enrolled) {
        if (vm.formData.keycard || vm.formData.keypad || vm.formData.raw_card_data) {
          return true
        } else {
          return false
        }
      } else if (rawCardEnrolled.indexOf(enrolled) != -1 && enrolled != vm.selector.raw_card_data) {
        return false
      }
      else {
        return true
      }
    }

    vm.validateRawCardMsg = function(enrolled) {
      if (!enrolled) {
        return "Keycard or Keypad Code Required"
      } else if (rawCardEnrolled.indexOf(enrolled) != -1) {
        return "Keypad Code Already Enrolled"
      }
    }

    vm.validateDoorGroup = function() {
      if (userAuth.data.system_license.allegion_active){
        return vm.formData.door_groups.length > 0 || vm.formData.allegion_door_groups.length > 0
      } else {
        return vm.formData.door_groups.length > 0
      }
    }

    vm.validateDoorSchedule = function() {
      if (userAuth.data.system_license.allegion_active && vm.formData.door_groups.length) {
        return vm.formData.schedules.length > 0
      } else if (!userAuth.data.system_license.allegion_active) {
        return vm.formData.schedules.length > 0
      } else {
        return true
      }
    }

    vm.submitCreate = function(){
      // HTTP Request Goes Here
      quantumApi.staff.save(vm.formData).$promise
      .then(function(){
        toastr.success('Staff Member Created', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Create Staff Member', 'Error!')
      })
      .finally(function(){
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('staffCreate').reset()
      })
    }

    vm.submitChange = function(){
      // HTTP Request Goes Here
      quantumApi.staff.update({id: vm.formData.id},vm.formData).$promise
      .then(function(){
        toastr.success('Staff Member Changed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Change Staff Member', 'Error!')
      })
      .finally(function(){
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('staffCreate').reset()
      })
    }

    vm.submitRemove= function(){
      // HTTP Request Goes Here
      quantumApi.staff.remove({id: vm.formData.id}).$promise
      .then(function(){
        toastr.success('Staff Member Removed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Remove Staff Member', 'Error!')
      })
      .finally(function(){
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('staffRemove').reset()
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ApartmentController', ApartmentController);

  /** @ngInject */
  function ApartmentController($log, $q, quantumApi, toastr, userAuth) {
    var vm = this;

    vm.userAuth = userAuth
    vm.selectedApartment = null
    vm.previousApartments = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.staff = []
    vm.ladda = false

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevApt, nextApt) {
      if (event.which == 38 && prevApt) {
        event.preventDefault()
        vm.selectedApartment = prevApt
      } else if (event.which == 40 && nextApt) {
        event.preventDefault()
        vm.selectedApartment = nextApt
      }
    }

    // Populate only IO Repeater/Checkin Schedules
    quantumApi.schedule.query(function(data){
      vm.schedules = []
      angular.forEach(data, function(schedule) {
        if (schedule.type == 3) {
          vm.schedules.push(schedule)
        }
      })
    })
    vm.areas = quantumApi.area.query()

    vm.getApartments = function() {
      vm.apartments = quantumApi.apartment.query(function(data){
        vm.previousApartments = angular.copy(data)
      })
      vm.selectedApartment = null
    }

    vm.getApartments()

    vm.addApartment = function() {
      vm.apartments.push({
        id: null,
        name: "",
        room_phone: "",
        area: 1,
        checkin_active: false,
        common_area: false,
        checkin_schedule: [],
        assigned_devices: []
      })
      vm.selectedApartment = vm.apartments[vm.apartments.length - 1]
    }

    vm.removeApartment = function(index, apartment) {
      if (!apartment.assigned_devices.length) {
        if (angular.equals(apartment, vm.selectedApartment)) {
          vm.selectedApartment = null
        }
        if (apartment.id) {
          apartment.deleted = true
        } else if (!apartment.id) {
          vm.apartments.splice(index,1)
        }
      }
    }

    vm.apartmentsValid = function(){
      var val = true
      angular.forEach(vm.apartments, function(apartment){
        if (!apartment.name || (apartment.checkin_active && ! apartment.checkin_schedule.length)) {
          val = false
        }
      })
      return val
    }

    vm.apartmentValid = function(apartment){
      var val = true
      if (!apartment.name || (apartment.checkin_active && ! apartment.checkin_schedule.length)) {
        val = false
      }
      return val
    }


    vm.saveApartments = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.apartments, function(apartment, key) {
        if (apartment.id && !apartment.deleted) {
          // Only save modified apartments
          if (!angular.equals(apartment, vm.previousApartments[key])) {
            promises.push(quantumApi.apartment.update({id:apartment.id},apartment).$promise)
          }
        } else if (apartment.deleted) {
          promises.push(quantumApi.apartment.delete({id:apartment.id},apartment).$promise)
        } else {
          promises.push(quantumApi.apartment.save(apartment).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getApartments()
        toastr.success("Apartments Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AreaController', AreaController);

  /** @ngInject */
  function AreaController($q, quantumApi, toastr, $log, userAuth) {
    var vm = this;

    vm.userAuth = userAuth
    vm.selectedArea = null
    vm.previousAreas = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.staff = []
    vm.ladda = false
    vm.apartments = quantumApi.apartment.query()
    vm.corridorControllers = quantumApi.corridorLightControler.query()
    vm.corridorColors = quantumApi.corridorLightColor.query()

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevArea, nextArea) {
      if (event.which == 38 && prevArea) {
        event.preventDefault()
        vm.selectedArea = prevArea
      } else if (event.which == 40 && nextArea) {
        event.preventDefault()
        vm.selectedArea = nextArea
      }
    }

    vm.assignedApt = function(areaId, count) {
      var aptsAssigned = []
      angular.forEach(vm.apartments, function(apartment) {
        if (areaId == apartment.area) {
          aptsAssigned.push(apartment)
        }
      })
      if (count) {
        return aptsAssigned.length
      } else {
        return aptsAssigned
      }
    }


    quantumApi.staff.query(function(staffData){
      angular.forEach(staffData, function(staffMember){
        if (staffMember.email) {
          vm.staff.push(staffMember)
        }
      })
    })

    vm.getAreas = function() {
      vm.areas = quantumApi.area.query(function(data) {
        vm.previousAreas = angular.copy(data)
      })
      vm.selectedArea = null
    }

    vm.getAreas()

    vm.addArea = function() {
      vm.areas.push({
        id:null,
        name:"New Area",
        checkin_staff:[],
        "corridor_light": {
          "active": false,
          "address": null,
          "controller": null,
          "rate": "Constant",
          "relay": null
        }
      })
      vm.selectedArea = vm.areas[vm.areas.length - 1]
    }

    vm.removeArea = function(index, area) {
        if (angular.equals(area, vm.selectedArea)) {
          vm.selectedArea = null
        }
        if (area.id && (area.id != 1 && vm.assignedApt(area.id, true) == 0)) {
          area.deleted = true
        } else if (!area.id) {
          vm.areas.splice(index,1)
        }
    }

    // Number range utility. TODO: I should probably make this a filter...
    vm.range = function(low, high) {
      var range = [];
      for(var i=low; i<=high; i++) {
        range.push(i);
      }
      return range
    }

    // For setting values when the inactive button is clicked
    vm.corridorLightActive = function(area, active) {
      area.corridor_light.active = active
      if (!active) {
        area.corridor_light.controller = null
        area.corridor_light.address = null
        area.corridor_light.relay = null
        area.corridor_light.rate = "Constant"
      } else {
        area.corridor_light.controller = vm.corridorControllers[0].id
        if (vm.interfaceType(area.corridor_light.controller) == 17) {
          area.corridor_light.address = 1
        } else {
          area.corridor_light.address = 0
        }
        area.corridor_light.relay = vm.corridorColors[0].relay
        area.corridor_light.rate = "Constant"
      }
    }

    vm.interfaceType = function(selectedInterface) {
      var type = null
      angular.forEach(vm.corridorControllers, function(controller) {
        if (selectedInterface == controller.id) {
          type = controller.connection_type
        }
      })
      return type
    }

    vm.resetCorridorLight = function(area) {
      if (vm.interfaceType(area.corridor_light.controller) == 17) {
        area.corridor_light.address = 1
        area.corridor_light.relay = vm.corridorColors[0].relay
        area.corridor_light.rate = "Constant"
      } else {
        area.corridor_light.address = 0
        area.corridor_light.relay = vm.corridorColors[0].relay
        area.corridor_light.rate = "Constant"
      }
    }

    quantumApi.systemSettings.get(function(data){
      vm.maxAddress = data.max_address_value
    })

    vm.areasValid = function(){
      var val = true
      angular.forEach(vm.areas, function(area){
        if (!area.name) {
          val = false
        }
      })
      return val
    }


    vm.saveAreas = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.areas, function(area, key) {
        if (area.id && !area.deleted) {
          if (!angular.equals(area, vm.previousAreas[key])) {
            promises.push(quantumApi.area.update({id:area.id},area).$promise)
          }
        } else if (area.deleted) {
          promises.push(quantumApi.area.delete({id:area.id},area).$promise)
        } else {
          promises.push(quantumApi.area.save(area).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getAreas()
        toastr.success("Areas Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        vm.ladda = false
      })
    }



  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ScheduleWeeklyWandererController', ScheduleWeeklyWandererController);

  /** @ngInject */
  function ScheduleWeeklyWandererController($log, WizardHandler, toastr, quantumApi) {
    var vm = this;

    vm.selector == false
    vm.scheduleLoaded = false

    quantumApi.door.query(function(data){
      var doorArray = []
      // Filter out access Control Doors
      angular.forEach(data, function(door) {
        if (!door.use) {
          doorArray.push(door)
        }
        vm.doors = doorArray
      })
    })

    function initForm() {
      vm.schedules = quantumApi.scheduleWeeklyWanderer.query()
      vm.scheduleLoaded = false
      vm.selector = false
      vm.formData = {
        "id":null,
        "name":"",
        "doors":[],
        "schedule_intervals":[
          {
            "start":{
              "day":0,
              "hour":9,
              "minute":0
            },
            "end":{
              "day":0,
              "hour":10,
              "minute":0
            }
          }
        ]
      }
    }

    initForm()

    vm.loadSelectedData = function(schedule) {
      vm.scheduleLoaded = true
      vm.formData = quantumApi.scheduleWeeklyWanderer.get({id:schedule.id})
    }

    vm.removeInterval = function(interval) {
      var index = vm.formData.schedule_intervals.indexOf(interval);
      vm.formData.schedule_intervals.splice(index, 1);
    }

    vm.addInterval = function() {
      var last_interval = {}
      angular.copy(vm.formData.schedule_intervals[vm.formData.schedule_intervals.length-1], last_interval)
      if (last_interval.start.day < 6) {
        last_interval.start.day++
      } else {
        last_interval.start.day = 0
      }

      if (last_interval.end.day < 6) {
        last_interval.end.day++
      } else {
        last_interval.end.day = 0
      }

      vm.formData.schedule_intervals.push(last_interval)

    }

    // Validators
    vm.stepSelectValid = function(){
      vm.form.group_selector.$dirty = true;
      return (!vm.selector == false)
    }

    vm.stepInfoValid = function(){
      vm.form.door_group_name.$dirty = true;
      vm.form.doors_in_group.$dirty = true;
      return vm.form.door_group_name.$valid && vm.form.doors_in_group.$valid
    }

    // Submit Form
    vm.submitCreate = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleWeeklyWanderer.save(vm.formData).$promise
      .then(function(){
        toastr.success('Wanderer Lock Schedule Created', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Create Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

    // Submit Form
    vm.submitChange = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleWeeklyWanderer.update({id:vm.formData.id},vm.formData).$promise
      .then(function(){
        toastr.success('Wanderer Lock Schedule Changed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Change Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

    // Submit Form
    vm.submitRemove = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleWeeklyWanderer.delete({id:vm.formData.id}).$promise
      .then(function(){
        toastr.success('Wanderer Lock Schedule Removed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Remove Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ScheduleWeeklyStaffController', ScheduleWeeklyStaffController);

  /** @ngInject */
  function ScheduleWeeklyStaffController($log, WizardHandler, toastr, quantumApi) {
    var vm = this;

    vm.selector == false
    vm.scheduleLoaded = false

    function initForm() {
      vm.schedules = quantumApi.scheduleWeeklyStaff.query()
      vm.scheduleLoaded = false
      vm.selector = false
      vm.formData = {
        "id":null,
        "name":"",
        "in_use":null,
        "schedule_intervals":[
          {
            "start":{
              "day":0,
              "hour":9,
              "minute":0
            },
            "end":{
              "day":0,
              "hour":10,
              "minute":0
            }
          }
        ]
      }
    }

    initForm()

    vm.loadSelectedData = function(schedule) {
      vm.scheduleLoaded = true
      vm.formData = quantumApi.scheduleWeeklyStaff.get({id:schedule.id})
    }

    vm.removeInterval = function(interval) {
      var index = vm.formData.schedule_intervals.indexOf(interval);
      vm.formData.schedule_intervals.splice(index, 1);
    }

    vm.addInterval = function() {
      var last_interval = {}
      angular.copy(vm.formData.schedule_intervals[vm.formData.schedule_intervals.length-1], last_interval)
      if (last_interval.start.day < 6) {
        last_interval.start.day++
      } else {
        last_interval.start.day = 0
      }

      if (last_interval.end.day < 6) {
        last_interval.end.day++
      } else {
        last_interval.end.day = 0
      }

      vm.formData.schedule_intervals.push(last_interval)

    }

    // Validators
    vm.stepSelectValid = function(){
      vm.form.group_selector.$dirty = true;
      return (!vm.selector == false)
    }

    vm.stepInfoValid = function(){
      vm.form.door_group_name.$dirty = true;
      return vm.form.door_group_name.$valid
    }

    // Submit Form
    vm.submitCreate = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleWeeklyStaff.save(vm.formData).$promise
      .then(function(){
        toastr.success('Schedule Created', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Create Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

    // Submit Form
    vm.submitChange = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleWeeklyStaff.update({id:vm.formData.id},vm.formData).$promise
      .then(function(){
        toastr.success('Schedule Changed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Change Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

    // Submit Form
    vm.submitRemove = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleWeeklyStaff.delete({id:vm.formData.id}).$promise
      .then(function(){
        toastr.success('Schedule Removed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Remove Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ScheduleWeeklyAccessControlController', ScheduleWeeklyAccessControlController);

  /** @ngInject */
  function ScheduleWeeklyAccessControlController($log, WizardHandler, toastr, quantumApi) {
    var vm = this;

    vm.selector == false
    vm.scheduleLoaded = false

    quantumApi.door.query(function(data){
      var doorArray = []
      // Filter out access Control Doors
      angular.forEach(data, function(door) {
        if (door.use) {
          doorArray.push(door)
        }
        vm.doors = doorArray
      })
    })

    function initForm() {
      vm.schedules = quantumApi.scheduleWeeklyAccessControl.query()
      vm.scheduleLoaded = false
      vm.selector = false
      vm.formData = {
        "id":null,
        "name":"",
        "doors":[],
        "schedule_intervals":[
          {
            "start":{
              "day":0,
              "hour":9,
              "minute":0
            },
            "end":{
              "day":0,
              "hour":10,
              "minute":0
            }
          }
        ]
      }
    }

    initForm()

    vm.loadSelectedData = function(schedule) {
      vm.scheduleLoaded = true
      vm.formData = quantumApi.scheduleWeeklyAccessControl.get({id:schedule.id})
    }

    vm.removeInterval = function(interval) {
      var index = vm.formData.schedule_intervals.indexOf(interval);
      vm.formData.schedule_intervals.splice(index, 1);
    }

    vm.addInterval = function() {
      var last_interval = {}
      angular.copy(vm.formData.schedule_intervals[vm.formData.schedule_intervals.length-1], last_interval)
      if (last_interval.start.day < 6) {
        last_interval.start.day++
      } else {
        last_interval.start.day = 0
      }

      if (last_interval.end.day < 6) {
        last_interval.end.day++
      } else {
        last_interval.end.day = 0
      }

      vm.formData.schedule_intervals.push(last_interval)

    }

    // Validators
    vm.stepSelectValid = function(){
      vm.form.group_selector.$dirty = true;
      return (!vm.selector == false)
    }

    vm.stepInfoValid = function(){
      vm.form.door_group_name.$dirty = true;
      vm.form.doors_in_group.$dirty = true;
      return vm.form.door_group_name.$valid && vm.form.doors_in_group.$valid
    }

    // Submit Form
    vm.submitCreate = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleWeeklyAccessControl.save(vm.formData).$promise
      .then(function(){
        toastr.success('Access Control Unlock Schedule Created', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Create Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

    // Submit Form
    vm.submitChange = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleWeeklyAccessControl.update({id:vm.formData.id},vm.formData).$promise
      .then(function(){
        toastr.success('Access Control Unlock Schedule Changed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Change Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

    // Submit Form
    vm.submitRemove = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleWeeklyAccessControl.delete({id:vm.formData.id}).$promise
      .then(function(){
        toastr.success('Access Control Unlock Schedule Removed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Remove Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ScheduleOnetimeController', ScheduleOnetimeController);

  /** @ngInject */
  function ScheduleOnetimeController($log, WizardHandler, toastr, moment, quantumApi, $location, systemStatus) {
    var vm = this;

    vm.systemStatus = systemStatus
    var curTime = moment.utc(vm.systemStatus.data.server_time)

    var accessControl = ($location.path() == "/schedule-onetime-access")

    quantumApi.door.query(function(data){
      var doorArray = []
      // Filter for access control doors or randering doors based on route and door.use being greater than 0
      // 0 == Wandering Only Door
      angular.forEach(data, function(door) {
        if (accessControl && door.use) {
          doorArray.push(door)
        } else if (!accessControl && !door.use) {
          doorArray.push(door)
        }
        vm.doors = doorArray
      })
    })

    // This flipping date picker...
    var rounding = 5 * 60 * 1000;
    // Time is hard :(
    vm.offset = "-0"+Math.abs(vm.systemStatus.data.offset)+"00"

    vm.datepickerOptions = {
      autoApply: true,
      opens: 'embed',
      timePicker: true,
      timePickerIncrement: 5,
      format: 'MM/DD/YYYY h:mm A',
      minDate: moment(Math.ceil((+moment(curTime.zone(vm.offset))) / rounding) * rounding),
      validationOptions: {
        interval: 5,
        unit: "minutes",
        message: "End Date Must be at Least 5 Minutes After Start Date"
      }
    }

    vm.scheduleChange = function() {
      if (vm.date) {
        vm.formData.start_date = vm.date.startDate,
        vm.formData.end_date = vm.date.endDate
      }
    }

    function initForm() {
      vm.schedules = quantumApi.scheduleOnetime.query()
      vm.selector = null
      vm.formData = {
        "id":null,
        "name":"",
        "wandering_enabled":true,
        "door_id":null,
        "start_date":null,
        "end_date":null
      }
      vm.date = {
        endDate: moment(Math.ceil((+curTime.zone(vm.offset)) / rounding) * rounding).add(1,'h').zone(vm.offset),
        startDate: moment(Math.ceil((+curTime.zone(vm.offset)) / rounding) * rounding).zone(vm.offset)
      }
    }

    initForm()

	// Step Validation
    vm.stepInfoValid = function(){
      vm.form.scheduleName.$dirty = true;
      vm.form.timeInterval.$dirty = true;
      return vm.form.scheduleName.$valid && vm.form.timeInterval.$valid
    }

    vm.stepDoorValid = function(){
      vm.form.group_selector.$dirty = true;
      return (vm.formData.door_id != null)
    }

    vm.stepSelectValid = function(){
      vm.form.group_selector.$dirty = true;
      return (vm.selector != null)
    }

    vm.submitCreate = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleOnetime.save(vm.formData).$promise
      .then(function(){
        toastr.success('One Time Schedule Created', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Create Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

    // Submit Form
    vm.submitRemove = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleOnetime.delete({id:vm.selector.id}).$promise
      .then(function(){
        toastr.success('One Time Schedule Removed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Remove Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ScheduleIoRepeaterController', ScheduleIoRepeaterController);

  /** @ngInject */
  function ScheduleIoRepeaterController($log, WizardHandler, toastr, quantumApi) {
    var vm = this;

    vm.selector == false
    vm.scheduleLoaded = false

    function initForm() {
      vm.schedules = quantumApi.scheduleIoRepeater.query()
      vm.scheduleLoaded = false
      vm.selector = false
      vm.formData = {
        "id":null,
        "name":"",
        "in_use":false,
        "schedule_intervals":[
          {
            "start":{
              "day":0,
              "hour":9,
              "minute":0
            },
            "end":{
              "day":0,
              "hour":10,
              "minute":0
            }
          }
        ]
      }
    }

    initForm()

    vm.loadSelectedData = function(schedule) {
      vm.scheduleLoaded = true
      vm.formData = quantumApi.scheduleIoRepeater.get({id:schedule.id})
    }

    vm.removeInterval = function(interval) {
      var index = vm.formData.schedule_intervals.indexOf(interval);
      vm.formData.schedule_intervals.splice(index, 1);
    }

    vm.addInterval = function() {
      var last_interval = {}
      angular.copy(vm.formData.schedule_intervals[vm.formData.schedule_intervals.length-1], last_interval)
      if (last_interval.start.day < 6) {
        last_interval.start.day++
      } else {
        last_interval.start.day = 0
      }

      if (last_interval.end.day < 6) {
        last_interval.end.day++
      } else {
        last_interval.end.day = 0
      }

      vm.formData.schedule_intervals.push(last_interval)

    }

    // Validators
    vm.stepSelectValid = function(){
      vm.form.group_selector.$dirty = true;
      return (!vm.selector == false)
    }

    vm.stepInfoValid = function(){
      vm.form.door_group_name.$dirty = true;
      return vm.form.door_group_name.$valid
    }

    // Submit Form
    vm.submitCreate = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleIoRepeater.save(vm.formData).$promise
      .then(function(){
        toastr.success('Fixed Device Schedule Created', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Create Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

    // Submit Form
    vm.submitChange = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleIoRepeater.update({id:vm.formData.id},vm.formData).$promise
      .then(function(){
        toastr.success('Fixed Device Schedule Changed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Change Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

    // Submit Form
    vm.submitRemove = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleIoRepeater.delete({id:vm.formData.id}).$promise
      .then(function(){
        toastr.success('Fixed Device Schedule Removed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Remove Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ScheduleCheckInController', ScheduleCheckInController);

  /** @ngInject */
  function ScheduleCheckInController($log, WizardHandler, toastr, quantumApi) {
    var vm = this;

    vm.selector == false
    vm.scheduleLoaded = false

    function initForm() {
      vm.schedules = quantumApi.scheduleCheckIn.query()
      vm.scheduleLoaded = false
      vm.selector = false
      vm.formData = {
        "id":null,
        "name":"",
        "in_use":false,
        "schedule_intervals":[
          {
            "start":{
              "day":0,
              "hour":7,
              "minute":0
            },
            "end":{
              "day":0,
              "hour":10,
              "minute":0
            }
          },
          {
            "start":{
              "day":1,
              "hour":7,
              "minute":0
            },
            "end":{
              "day":1,
              "hour":10,
              "minute":0
            }
          },
          {
            "start":{
              "day":2,
              "hour":7,
              "minute":0
            },
            "end":{
              "day":2,
              "hour":10,
              "minute":0
            }
          },
          {
            "start":{
              "day":3,
              "hour":7,
              "minute":0
            },
            "end":{
              "day":3,
              "hour":10,
              "minute":0
            }
          },
          {
            "start":{
              "day":4,
              "hour":7,
              "minute":0
            },
            "end":{
              "day":4,
              "hour":10,
              "minute":0
            }
          },
          {
            "start":{
              "day":5,
              "hour":7,
              "minute":0
            },
            "end":{
              "day":5,
              "hour":10,
              "minute":0
            }
          },
          {
            "start":{
              "day":6,
              "hour":7,
              "minute":0
            },
            "end":{
              "day":6,
              "hour":10,
              "minute":0
            }
          }
        ]
      }
    }

    initForm()

    vm.loadSelectedData = function(schedule) {
      vm.scheduleLoaded = true
      vm.formData = quantumApi.scheduleCheckIn.get({id:schedule.id})
    }

    vm.removeInterval = function(interval) {
      var index = vm.formData.schedule_intervals.indexOf(interval);
      vm.formData.schedule_intervals.splice(index, 1);
    }

    vm.addInterval = function() {
      var last_interval = {}
      angular.copy(vm.formData.schedule_intervals[vm.formData.schedule_intervals.length-1], last_interval)
      if (last_interval.start.day < 6) {
        last_interval.start.day++
      } else {
        last_interval.start.day = 0
      }

      if (last_interval.end.day < 6) {
        last_interval.end.day++
      } else {
        last_interval.end.day = 0
      }

      vm.formData.schedule_intervals.push(last_interval)

    }

    // Validators
    vm.stepSelectValid = function(){
      vm.form.group_selector.$dirty = true;
      return (!vm.selector == false)
    }

    vm.stepInfoValid = function(){
      vm.form.door_group_name.$dirty = true;
      return vm.form.door_group_name.$valid
    }

    // Submit Form
    vm.submitCreate = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleCheckIn.save(vm.formData).$promise
      .then(function(){
        toastr.success('Check-In Schedule Created', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Create Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

    // Submit Form
    vm.submitChange = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleCheckIn.update({id:vm.formData.id},vm.formData).$promise
      .then(function(){
        toastr.success('Check-In Schedule Changed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Change Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

    // Submit Form
    vm.submitRemove = function(){
      vm.ladda = true
      // HTTP Request Goes Here
      quantumApi.scheduleCheckIn.delete({id:vm.formData.id}).$promise
      .then(function(){
        toastr.success('Check-In Schedule Removed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Remove Schedule', 'Error!')
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ResidentTransmitterPowerController', ResidentTransmitterPowerController);

  /** @ngInject */
  function ResidentTransmitterPowerController($log, WizardHandler, toastr, $scope, $interval, quantumApi) {
    var vm = this;
    var wandererInterval
    var timeoutInterval
    var timeoutCounter = 0
    vm.wandererTransmitterEnrollment = []
    vm.selectStepSubmitted = false
    vm.ladda = false

    function initForm() {
      vm.wandererTransmitterEnrollment = []
      vm.selectStepSubmitted = false
      vm.formData = {
        "wanderer_trasmitter":null
      }
    }

    // Checks the tag enrollment station for tags
    var wandererListerner = function() {
      quantumApi.enrollmentStationTransmitter.query(function(data){

        // Check for duplicates
        var transmittersRegistered = []
        angular.forEach(vm.wandererTransmitterEnrollment, function(transmitter) {
          transmittersRegistered.push(transmitter.serial_number)
        })

        // Push any new transmitters on the station/update existing transmitters
        angular.forEach(data, function(transmitter){
          var index = transmittersRegistered.indexOf(transmitter.serial_number)
          // New transmitter condition
          if (index === -1) {
            quantumApi.transmitterTrack.get({tag_id:transmitter.serial_number}).$promise
            .then(function(data){
              transmitter.days_in_use = data.minutes_in_use / 24 / 60
              vm.wandererTransmitterEnrollment.unshift(transmitter)
            })
          // Previously low battery condition
          // This is to prevent updating any "good battery" status devices
          // is required due to the transmitter "Warm up" period
          } else if (vm.wandererTransmitterEnrollment[index].battery_low == true && transmitter.battery_low == false) {
            vm.wandererTransmitterEnrollment[index].battery_low = false
          }
        })
      })
    }

    initForm()
    // Start polling for transmitters.
    wandererListerner()
    wandererInterval = $interval(wandererListerner, 1000)

	// Step Validation
    vm.stepOneValid = function(){
      vm.selectStepSubmitted = true
      return vm.formData.wanderer_transmitter != null
    }

    // Turn Off Procedure
    function pollForTurnoff() {
      quantumApi.enrollmentStationTransmitter.get({'id':vm.formData.wanderer_transmitter.id}).$promise
      .then(function(data){
        if (data.turn_off_complete) {
          timeoutCounter = 0
          $interval.cancel(timeoutInterval)
          initForm()
          vm.form.$setPristine()
          WizardHandler.wizard('wizard').reset()
          toastr.success('Wanderer Transmitter Turned Off', 'Success!');
          vm.ladda = false
        } else if (timeoutCounter > 30) {
          vm.formData.wanderer_transmitter.initiate_turn_off = false
          quantumApi.enrollmentStationTransmitter.update({'id':vm.formData.wanderer_transmitter.id}, vm.formData.wanderer_transmitter)
          timeoutCounter = 0
          $interval.cancel(timeoutInterval)
          initForm()
          vm.form.$setPristine()
          WizardHandler.wizard('wizard').reset()
          toastr.warning('Failed to Turn Off Transmitter', 'Error!');
          vm.ladda = false
        } else {
          timeoutCounter ++
        }
      })

    }

    vm.countActiveTransmitters = function(transmitters) {
      var activeTransmitters = []
      angular.forEach(transmitters, function(transmitter) {
        if (!transmitter.turn_off_complete) {
          activeTransmitters.push(transmitter)
        }
      })
      return activeTransmitters.length
    }

    vm.submitWizard = function(){
      vm.ladda = true
      vm.formData.wanderer_transmitter.initiate_turn_off = true
       quantumApi.enrollmentStationTransmitter.update({'id':vm.formData.wanderer_transmitter.id}, vm.formData.wanderer_transmitter).$promise
      .then(function(){
        timeoutInterval = $interval(pollForTurnoff, 1000)
      })
    }

    // Clean Up the connection to the acg and the event listeners on destroy
    $scope.$on('$destroy', function() {
      $interval.cancel(wandererInterval);
    })

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ResidentScheduledLeaveController', ResidentScheduledLeaveController);

  /** @ngInject */
  function ResidentScheduledLeaveController($log, WizardHandler, toastr, moment, quantumApi, $q, systemStatus) {
    var vm = this;

    vm.systemStatus = systemStatus
    var curTime = moment.utc(vm.systemStatus.data.server_time)

    vm.residents = []
    quantumApi.systemSettings.get().$promise
    .then(function(systemData){
      var callButtonLeave = systemData.call_button_leave
      quantumApi.resident.query(function(data){
        angular.forEach(data, function(resident) {
          if (resident.wanderer_transmitter || (resident.call_button && callButtonLeave)) {
            vm.residents.push(resident)
          }
        })
      })
    })

    vm.apartmentData = quantumApi.apartment.query()

    // This flipping date picker...
    var rounding = 5 * 60 * 1000;
    // Time is hard :(
    vm.offset = "-0"+Math.abs(vm.systemStatus.data.offset)+"00"

    vm.datepickerOptions = {
      autoApply: true,
      opens: 'embed',
      timePicker: true,
      timePickerIncrement: 5,
      format: 'MM/DD/YYYY h:mm A',
      minDate: moment(Math.ceil((+moment(curTime.zone(vm.offset))) / rounding) * rounding),
      validationOptions: {
        interval: 1,
        unit: "hours",
        message: "End Date Must be at Least 1 Hour After Start Date"
      }
    }

    vm.scheduleChange = function() {
      if (vm.date) {
        vm.formData.start_date = vm.date.startDate,
        vm.formData.end_date = vm.date.endDate
      }
    }

    function initForm() {
      quantumApi.scheduledLeave.query(function(data){
        vm.schedules = []
        angular.forEach(data, function(data) {
          if (!data.completed) {
            vm.schedules.push(data)
          }
        })
      })
      vm.selectStepSubmitted = false
      vm.selector = null
      vm.date = {
        endDate: moment(Math.ceil((+moment(curTime.zone(vm.offset))) / rounding) * rounding).zone(vm.offset).add(1,'h'),
        startDate: moment(Math.ceil((+moment(curTime.zone(vm.offset))) / rounding) * rounding).zone(vm.offset)
      }
      vm.formData = {
        "start_date":vm.date.startDate,
        "end_date":vm.date.endDate,
        "residenta":null
      }
    }

    initForm()

	// Step Validation

    vm.stepScheduleValid = function(){
      vm.form.timeInterval.$dirty = true;
      return vm.form.timeInterval.$valid
    }

    vm.stepResidentsValid = function(){
      vm.selectStepSubmitted = true
      return vm.formData.residents.length != 0
    }

    vm.stepSelectValid = function(){
      vm.form.group_selector.$dirty = true
      return vm.selector != null
    }

    vm.submitCreate = function(){
      var promises = []

      angular.forEach(vm.formData.residents, function(data) {
        var postData = {
          "id":null,
          "start_date": vm.formData.start_date,
          "end_date": vm.formData.end_date,
          "resident_id":data,
          "returned_time":null,
          "completed": null,
          "active":null
        }
        promises.push(quantumApi.scheduledLeave.save(postData).$promise)
      })

      $q.all(promises)
      .then(function(){
        toastr.success('Scheduled Leave Created', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Create Leave', 'Error!')
      })
      .finally(function(){
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

    // Submit Form
    vm.submitRemove = function(){
      // HTTP Request Goes Here
      quantumApi.scheduledLeave.delete({id:vm.selector.id}).$promise
      .then(function(){
        toastr.success('Scheduled Leave Removed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Remove Leave', 'Error!')
      })
      .finally(function(){
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('scheduleCreate').reset()
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ResidentStatusController', ResidentStatusController);

  /** @ngInject */
  function ResidentStatusController($scope, $rootScope, $interval, quantumApi, $filter) {
    var vm = this;
    var previousList
    var changesMade = false

    vm.orderByKey = "last_name"
    vm.orderReverse = false
    vm.initalLoadComplete = false

    vm.apartments = quantumApi.apartment.query()
    vm.family = quantumApi.family.query()

    vm.searchFilter = ""

    function getResidentStatus(){
      quantumApi.resident.query(function(data){
        vm.initalLoadComplete = true
        // Change detection and sorting in the controller for performance issues
        if (!angular.equals(data, previousList)) {
          changesMade = true
        }

        previousList = angular.copy(data)

        if (changesMade) {
          vm.residents = $filter('naturalSort')(data, vm.orderByKey)
          changesMade = false
        }
      })
    }

    vm.resort = function() {
      vm.residents = $filter('naturalSort')(vm.residents, vm.orderByKey)
    }

    // Initial Load
    getResidentStatus()

    // Interval for fetching Resident Status. We'll use websockets someday...
    vm.refreshInterval = $interval(getResidentStatus, 5000)

    // When navigating away, cancel the intercal
    $scope.$on('$destroy', function () { $interval.cancel(vm.refreshInterval); });

    // Raw Card Info
    // Listeer for raw card data coming from enrollment station with card reader
    // Comes from the websocket initiate in the system status service
    var cardDataListener = $rootScope.$on('cardEnrollData', function(event, data){
      vm.searchFilter = data
    })

    // Site name for csv filename
    quantumApi.siteInfo.get(function(data){
      vm.siteName = data.name.replace(/\s+/g, '_')
    })

    vm.cleanCsv = function() {
      var results = []

      angular.forEach(vm.residents, function(resident) {
        var residentObj = {
          first_name:resident.first_name,
          last_name:resident.last_name,
          apartment:resident.apartment_name,
          call_button_serial:resident.call_button ? resident.call_button.serial_number : "Not Assigned",
          call_button_missing:resident.call_button ? resident.call_button.missing ? "Missing":"Ok" : "Not Assigned",
          call_button_low_battery:resident.call_button ? resident.call_button.low_battery ? "Low":"Ok" : "Not Assigned",
          fall_dettection_serial:resident.fall_detection ? resident.fall_detection.serial_number : "Not Assigned",
          fall_dettection_missing:resident.fall_detection ? resident.fall_detection.missing ? "Missing":"Ok":"Not Assigned",
          fall_dettection_low_battery:resident.fall_detection ? resident.fall_detection.low_battery ? "Low":"Ok":"Not Assigned",
          wanderer_transmitter_serial:resident.wanderer_transmitter ? resident.wanderer_transmitter.serial_number : "Not Assigned",
          wanderer_transmitter_missing:resident.wanderer_transmitter ? resident.wanderer_transmitter.missing ? "Missing":"Ok":"Not Assigned",
          wanderer_transmitter_low_battery:resident.wanderer_transmitter ? resident.wanderer_transmitter.low_battery ? "Low":"Ok":"Not Assigned",
          keypad_code:resident.resident_door_access ? resident.resident_door_access.keypad ? resident.resident_door_access.keypad:"Not Assigned":"Not Assigned",
          keycard_code:resident.resident_door_access ? resident.resident_door_access.keycard ? resident.resident_door_access.keycard:"Not Assigned":"Not Assigned",
          enrolled_code:resident.resident_door_access ? resident.resident_door_access.raw_card_data ? "Enrolled":"Not Enrolled":"Not Assigned"
        }
        results.push(residentObj)
      })

      return results
    }

    vm.csvHeaders = ["First Name", "Last Name", "Apartment", "Call Button Serial Number", "Call Button Missing", "Call Button Low Battery", "Fall Detection Serial Number", "Fall Detection Missing", "Fall Detection Low Battery", "Wanderer Transmitter Serial Number","Wanderer Transmitter Missing","Wanderer Transmitter Low Battery", "Keypad Code", "Keycard Code", "Enrolled Code"]

    // Clean Up the connection to the acg and the event listeners on destroy
    $scope.$on('$destroy', function() {
      $scope.$on('$destroy', cardDataListener())
    })

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ResidentController', ResidentController);

  //Egads, this is a fun one...

  /** @ngInject */
  function ResidentController($log, $scope, $rootScope, $interval, $location, $q, WizardHandler, toastr, quantumApi, userAuth, inovonics) {
    var vm = this;
    var currentStep
    var wandererInterval
    // Lists for validation
    var keycardEnrolled = []
    var keypadEnrolled = []
    var rawCardEnrolled = []

    vm.userAuth = userAuth

    // License Information for hiding what's not needed
    vm.systemLicense = userAuth.data.system_license

    // API Data
    vm.escalationData = quantumApi.escalation.query()
    vm.allegionAccessGroups = quantumApi.allegionAccessGroup.query()
    vm.apartmentData = []

    // We now have "common area" apartments
    quantumApi.apartment.query().$promise
    .then(function(data){
      angular.forEach(data, function(apartment) {
        if(!apartment.common_area) {
          vm.apartmentData.push(apartment)
        }
      })
    })

    vm.doorPermissions = quantumApi.residentDoorPermission.query()

    vm.carePlans = quantumApi.carePlan.query()

    // Keep Track of the Step Selected
    vm.selectedStepName = null

    // Use this to compare the copy with the source for detecting changes
    vm.selectedResident = null

    vm.initalLoadComplete = false

    // There's no Key in the API to indicate door access. Fake it here.
    vm.allowDoorAccess = false

    vm.doorAccessLevels = [
      {"label":"No Access", "value":false},
      {"label":"Allow Access", "value":true}
    ]

    // Load in door access group
    vm.doorAccessGroups = quantumApi.doorAccessGroup.query()
    vm.doorAccessSchedules = quantumApi.scheduleWeeklyStaff.query()

    function initForm() {
      quantumApi.staff.usedCodes(function(data){
        keycardEnrolled = data.used_wiegand
        keypadEnrolled = data.used_keypad_codes
        rawCardEnrolled = data.used_raw_codes
      })
      // Empty Form Data
      vm.formData = {
        "first_name":"",
        "last_name":"",
        "phone_number":"",
        "apartment":null,
        "notes":null,
        "escalations":false,
        "call_button":null,
        "fall_detection":null,
        "wanderer_transmitter":null,
        "door_access_permission": 1,
        "resident_door_access":null
      }
      // Keeping track of the incoming device registrations
      vm.callButtonEnrollment = []
      vm.fallDetectionEnrollment = []
      vm.wandererTransmitterEnrollment = []

      // Clear Selector Validation
      vm.selectStepSubmitted = false;
      //Init the Search Filter
      vm.searchFilter = ""
      // Init the Radio Buttons
      vm.selector = false
      // Clear out any resident selection
      vm.selectedResident = null
      // (re)load Existing Residents
      if ($location.path() == '/resident-change' || $location.path() == '/resident-discharge') {
        vm.existingResidents = quantumApi.resident.query(function(){
          vm.initalLoadComplete = true
        })
      }
    }

    initForm()

    vm.clearSupEscalation = function($event) {
      $event.stopPropagation();
      vm.formData.supervisory_escalation = null
    }

    vm.clearCarePlan = function($event) {
      $event.stopPropagation();
      vm.formData.care_plan = null
    }

    // --- Inovonics Enrollment ---
    // Verify Nurse Call License Before Staring Inovonics Up
    if (vm.systemLicense.nurse_call) {
      // Listen for the registration events emitted from the inovonics service
      // Must call inovonics.openRegistration() for this to be active
      var inovonicsListener = $rootScope.$on('inovonicsRegistration', function(event, data){
        // Search for duplicate registrations
        var registeredDevices = []
        angular.forEach(vm.callButtonEnrollment, function(data){
          registeredDevices.push(data.serial_number)
        })
        angular.forEach(vm.fallDetectionEnrollment, function(data){
          registeredDevices.push(data.serial_number)
        })

        // Verify Unique device
        if (registeredDevices.indexOf(data.serial_number) === -1) {
          // Figure out where we are in the wizard and push to that array. I wish there was a better way to get the step other than title
          // Filter by the fixed device flag and filter out FDUs
          if (currentStep == "Call Button" && data.device_data.fixed == 0 && data.pti != 5) {
            if(data.pti == 93) {
              data.fall_active = true
            } else {
              data.fall_active = false
            }
            vm.callButtonEnrollment.unshift(data)
            vm.formData.call_button = vm.callButtonEnrollment[0]
          // Filter everything but FDUs
          // We're using the EOL UT exclusivly for FDUs Hence the PTI of 5
          } else if (currentStep == "Fall Detection" && data.pti === 5) {
            vm.fallDetectionEnrollment.unshift(data)
            vm.formData.fall_detection = vm.fallDetectionEnrollment[0]
          }
          $scope.$apply()
        }
      })

      // Clean Up the connection to the acg and the event listeners on destroy
      $scope.$on('$destroy', function() {
        inovonics.closeRegistration()
        $scope.$on('$destroy', inovonicsListener())
        $interval.cancel(wandererInterval);
      })

      // Start Up the Websocker
      inovonics.openRegistration()
    }

    // --- Quantum Tag Enrollment ---

    // Checks the tag enrollment station for tags
    var wandererListerner = function() {
      quantumApi.enrollmentStationTransmitter.query(function(data){

        // Check for duplicates
        var transmittersRegistered = []
        angular.forEach(vm.wandererTransmitterEnrollment, function(transmitter) {
          transmittersRegistered.push(transmitter.serial_number)
        })

        // Push any new transmitters on the station/update existing transmitters
        angular.forEach(data, function(transmitter){
          // This ID coming from the enrollment station isn't what we need for this page. Null it out for the sake of the back end
          transmitter.id = null
          var index = transmittersRegistered.indexOf(transmitter.serial_number)
          // New transmitter condition
          if (index === -1) {
            quantumApi.transmitterTrack.get({tag_id:transmitter.serial_number}).$promise
            .then(function(data){
              transmitter.days_in_use = data.minutes_in_use / 24 / 60
              vm.wandererTransmitterEnrollment.unshift(transmitter)
            })
          // Previously low battery condition
          // This is to prevent updating any "good battery" status devices
          // is required due to the transmitter "Warm up" period
          } else if (vm.wandererTransmitterEnrollment[index].battery_low == true) {
            vm.wandererTransmitterEnrollment[index] = transmitter
          }
        })
      })
    }

    // Detect wizard change events
    $scope.$on('wizard:stepChanged', function(event){
      // Track the Current Step (Used for Inovonics)
      currentStep = event.targetScope.selectedStep.title
      // Start and stop the Quantum Tag Enrollment
      if (currentStep == "Wanderer Transmitter") {
        // Start the Interval
        wandererInterval = $interval(wandererListerner, 500)
      } else {
        // Stop the interval if active
        if (wandererInterval) {
          $interval.cancel(wandererInterval)
        }
      }
    })

    // Load Data from Selection Page
    vm.loadSelectedData = function(selectedOption) {
      vm.selectedResident = selectedOption
      angular.copy(selectedOption, vm.formData)

      // This is an oddball way of dealing with equality for the ng-model radio button auto select...
      // There's probably a better way, but it works.
      if (selectedOption.call_button) {
        vm.formData.call_button = selectedOption.call_button
      }
      if (selectedOption.fall_detection) {
        vm.formData.fall_detection = selectedOption.fall_detection
      }
      if (selectedOption.wanderer_transmitter) {
        vm.formData.wanderer_transmitter = selectedOption.wanderer_transmitter
      }

    }

    // Door Access
    // Set the door access object if access is enabled.
    vm.doorAccessChange = function() {
      if (vm.formData.door_access_permission == 3) {
        vm.formData.resident_door_access = {
          "id": null,
          "keypad": null,
          "keycard": null,
          "raw_card_data": null,
          "resident_id": null,
          "access_level": 1,
          "door_groups": [],
          "schedules": []
        }
      } else {
        vm.formData.resident_door_access = null
      }
    }

    // Called when assigning a wanderer transmitter. Prevents assignment of credentials to wanderers.
    vm.disableDoorAccess = function() {
      // Resident has access to their room and alligion locks only - no WM doors
      if (userAuth.data.system_license.allegion_active) {
        if (vm.formData.resident_door_access) {
          vm.formData.resident_door_access.door_groups = []
          vm.formData.resident_door_access.schedules = []
        }
      } else {
        vm.resident_door_access = null
        vm.allowDoorAccess = false
      }
    }

	// --Step Validation--
    vm.stepSelectValid = function(){
      // Due to the search filter, some odd things happen with the form when there's no data displayed.
      // This is a workaround for that...
      vm.selectStepSubmitted = true;
      return (!vm.selector == false)
    }

    vm.stepInfoValid = function(){
      vm.form.first_name.$setDirty();
      vm.form.last_name.$setDirty();
      vm.form.apartment.$setDirty();
      vm.form.escalations.$setDirty();
      return vm.form.first_name.$valid && vm.form.last_name.$valid && vm.form.apartment.$valid && vm.form.escalations.$valid
    }

    vm.deviceAssignmentValidation = function() {
      return !vm.formData.call_button && !vm.formData.fall_detection && !vm.formData.wanderer_transmitter && vm.formData.door_access_permission == 1
    }

    // Raw Card Info
    // Listeer for raw card data coming from enrollment station with card reader
    // Comes from the websocket initiate in the system status service
    var cardDataListener = $rootScope.$on('cardEnrollData', function(event, data){
      if (vm.formData.resident_door_access) {
        vm.formData.resident_door_access.raw_card_data = data
        vm.form.rawcard.$dirty = true;
      }
    })

    // Clean Up the connection to the acg and the event listeners on destroy
    $scope.$on('$destroy', function() {
      $scope.$on('$destroy', cardDataListener())
    })

    // Door Validation

    vm.stepDoorValid = function(){
      if (vm.formData.door_access_permission == 3) {
        vm.form.keycard.$dirty = true;
        vm.form.keypad.$dirty = true;
        vm.form.rawcard.$dirty = true;
        if (!vm.formData.wanderer_transmitter) {
          vm.form.door_access_schedules.$dirty = true;
        }
        if (userAuth.data.system_license.allegion_active) {
          return vm.form.keycard.$valid && vm.form.keypad.$valid && vm.form.rawcard.$valid && vm.validateDoorSchedule()
        } else {
          vm.form.door_access_groups.$dirty = true;
          return vm.form.keycard.$valid && vm.form.keypad.$valid && vm.form.door_access_groups.$valid  && vm.form.rawcard.$valid && vm.validateDoorSchedule()
        }
      } else {
        return true
      }
    }

    vm.validateKeycard = function(keycard) {
      if (!keycard && keycard != 0) {
        if (vm.formData.resident_door_access.keycard || vm.formData.resident_door_access.keypad || vm.formData.resident_door_access.raw_card_data) {
          return true
        } else {
          return false
        }
      } else if (keycardEnrolled.indexOf(keycard) != -1) {
        if (vm.selectedResident) {
          if (vm.selectedResident.resident_door_access) {
            if (keycard == vm.selectedResident.resident_door_access.keycard) {
              return true
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else if (keycard < 10000 || keycard > 65535) {
        return false
      }
      else {
        return true
      }
    }

    vm.validateKeycardMsg = function(keycard) {
      if (!keycard && keycard != 0) {
        return "Keycard or Keypad Code Required"
      } else if (keycardEnrolled.indexOf(keycard) != -1) {
        return "Keycard Already Enrolled"
      } else if (!keycard < 10000 || !keycard > 65535) {
        return "Keycard Must be Between 10000 and 65534"
      }
      return true
    }

    vm.validateKeypad = function(keypad) {
      if (!keypad && keypad != 0) {
        if (vm.formData.resident_door_access.keycard || vm.formData.resident_door_access.keypad || vm.formData.resident_door_access.raw_card_data) {
          return true
        } else {
          return false
        }
      } else if (keypadEnrolled.indexOf(keypad) != -1) {
        if (vm.selectedResident) {
          if (vm.selectedResident.resident_door_access) {
            if (keypad == vm.selectedResident.resident_door_access.keypad) {
              return true
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else if (keypad < 1000 || keypad > 9999) {
        return false
      }
      else {
        return true
      }
    }

    vm.validateKeypadMsg = function(keypad) {
      if (!keypad && keypad != 0) {
        return "Keycard or Keypad Code Required"
      } else if (keypadEnrolled.indexOf(keypad) != -1) {
        return "Keypad Code Already Enrolled"
      } else if (!keypad < 1000 || !keypad > 9999) {
        return "Keypad Code Must be Between 1000 and 9999"
      }
    }

    vm.validateRawCard = function(enrolled) {
      if (!enrolled) {
        if (vm.formData.resident_door_access.keycard || vm.formData.resident_door_access.keypad || vm.formData.resident_door_access.raw_card_data) {
          return true
        } else {
          return false
        }
      } else if (rawCardEnrolled.indexOf(enrolled) != -1) {
        if (vm.selectedResident) {
          if (vm.selectedResident.resident_door_access) {
            if (enrolled == vm.selectedResident.resident_door_access.raw_card_data) {
              return true
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      }
      else {
        return true
      }
    }

    vm.validateRawCardMsg = function(enrolled) {
      if (!enrolled) {
        return "Keycard or Keypad Code Required"
      } else if (rawCardEnrolled.indexOf(enrolled) != -1) {
        return "Keypad Code Already Enrolled"
      }
    }

    vm.validateDoorSchedule = function() {
      if (userAuth.data.system_license.allegion_active && vm.formData.resident_door_access.door_groups.length) {
        return vm.formData.resident_door_access.schedules.length > 0
      } else if (!userAuth.data.system_license.allegion_active) {
        return vm.formData.resident_door_access.schedules.length > 0
      } else {
        return true
      }
    }

    // --Submitted Forms--

    // Used to Clean Up the ACG If anything Bad Happens Along the Way
    function removeAcgDevices(submittedAcgIds) {
      angular.forEach(submittedAcgIds, function(acgId){
        inovonics.removeDevice(acgId)
      })
    }

    // Hey, look who learned how to use promises!
    vm.submitAdmitWizard = function(){
      var promises = []
      var submittedAcgIds = []

      // Set the spinner
      vm.ladda = true

      // Only if ACG is active
      if (!userAuth.data.network_coordinator_in_use) {
        if (vm.formData.call_button) {
          promises.push(
            inovonics.writeDevice(vm.formData.call_button)
              .then(function(data){
                vm.formData.call_button.acg_id = parseInt(data.ResponseStatus.id)
                submittedAcgIds.push(data.ResponseStatus.id)
              })
            )
        }

        if (vm.formData.fall_detection){
          promises.push(
            inovonics.writeDevice(vm.formData.fall_detection)
            .then(function(data){
              vm.formData.fall_detection.acg_id = parseInt(data.ResponseStatus.id)
              submittedAcgIds.push(data.ResponseStatus.id)
            })
          )
        }
      }

      $q.all(promises)
      .then(function(){
        return quantumApi.resident.save(vm.formData).$promise
      })
      .then(function(){
        toastr.success('Resident Admitted', 'Success!');
      })
      .catch(function(err){
        $log.info(err.data)
        toastr.warning('Failed to Admit Resident', 'Error!');
        removeAcgDevices(submittedAcgIds)
      }).finally(function(){
        // Reset the Form
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('resident').reset()
      })
    }

    vm.submitChangeWizard = function(){
      var promises = []
      var oldDevices = []

      vm.ladda = true

      if (!userAuth.data.network_coordinator_in_use) {
        // Add Call Button
        if (vm.formData.call_button && !vm.selectedResident.call_button) {
          promises.push(
            inovonics.writeDevice(vm.formData.call_button).then(function(data){
              vm.formData.call_button.acg_id = parseInt(data.ResponseStatus.id)
            })
          )
        // Remove Call Button
        } else if (!vm.formData.call_button && vm.selectedResident.call_button) {
          promises.push(inovonics.removeDevice(vm.selectedResident.call_button.acg_id))
        // Replace Call Button
        } else if (vm.formData.call_button != vm.selectedResident.call_button) {
          oldDevices.push(vm.selectedResident.call_button.acg_id)
          promises.push(inovonics.writeDevice(vm.formData.call_button)
          .then(function(data){
            vm.formData.call_button.acg_id = parseInt(data.ResponseStatus.id)
          }))
        }

      // Add Fall Detection
      if (vm.formData.fall_detection && !vm.selectedResident.fall_detection) {
        promises.push(
          inovonics.writeDevice(vm.formData.fall_detection).then(function(data){
            vm.formData.fall_detection.acg_id = parseInt(data.ResponseStatus.id)
          })
        )
        // Remove Fall Detection
      } else if (!vm.formData.fall_detection && vm.selectedResident.fall_detection) {
          promises.push(inovonics.removeDevice(vm.selectedResident.fall_detection.acg_id))
        // Replace Fall Detection
      } else if (vm.formData.fall_detection != vm.selectedResident.fall_detection) {
        oldDevices.push(vm.selectedResident.fall_detection.acg_id)
        promises.push(inovonics.writeDevice(vm.formData.fall_detection)
        .then(function(data){
          vm.formData.fall_detection.acg_id = parseInt(data.ResponseStatus.id)
        }))
      }
    }

    //Remove Door Access if Wanderer Transmitter Assigned

    if (vm.formData.wanderer_transmitter) {
      vm.formData.resident_door_access = null
      vm.formData.door_access_permission = 1
    }

      $q.all(promises)
      .then(function(){
        return quantumApi.resident.update({id: vm.formData.id}, vm.formData).$promise
      })
      .then(function(){
        toastr.success('Resident Changed', 'Success!');
      })
      .then(function(){
        removeAcgDevices(oldDevices)
      })
      .catch(function(err) {
        $log.info(err.data)
        toastr.warning('Failed to Change Resident', 'Error!');
      }).finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('resident').reset()
      })
    }

    vm.submitDischargeWizard = function(){
      var promises = []
      // HTTP Request Goes Here
      $log.log(vm.formData)
      vm.ladda = true

      // Only Used for ACG
      if (!userAuth.data.network_coordinator_in_use) {
        if (vm.formData.call_button) {
          promises.push(inovonics.removeDevice(vm.formData.call_button.acg_id))
        }

        if (vm.formData.fall_detection) {
          promises.push(inovonics.removeDevice(vm.formData.fall_detection.acg_id))
        }
      }

      $q.all(promises)
      .then(function(){
        return quantumApi.resident.remove({id: vm.formData.id}).$promise
      })
      .then(function(){
        toastr.success('Resident Discharged', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Discharge Resident', 'Error!');
      })
      .finally(function(){
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('resident').reset()
      })

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ResidentInsightController', ResidentInsightController);

  /** @ngInject */
  function ResidentInsightController(moment, quantumApi, $routeParams, $timeout, userAuth) {
    var vm = this;

    var residentId = parseInt($routeParams.id)

    vm.userAuth = userAuth
    vm.careWarnings = quantumApi.careWarning.query()
    vm.doorPermissions = quantumApi.residentDoorPermission.query()
    vm.doorAccessGroups = quantumApi.doorAccessGroup.query()
    vm.doorAccessSchedules = quantumApi.scheduleWeeklyStaff.query()

    vm.warningById = function(warningType) {
      var warningToReturn = null
      angular.forEach(vm.careWarnings, function(warning) {
        if (warning.id == warningType) {
          warningToReturn = warning.name
        }
      })
      return warningToReturn
    }

    vm.careLevels = quantumApi.careLevel.query()

    vm.levelById = function(levelId) {
      var levelToReturn = null
      angular.forEach(vm.careLevels, function(level) {
        if (level.id == levelId) {
          levelToReturn = level.name
        }
      })
      return levelToReturn
    }

    quantumApi.family.query(function(data){
      vm.family = data
      vm.associatedFamily = []
      angular.forEach(vm.family, function(familyMember) {
        if (familyMember.associated_residents.indexOf(residentId) != -1) {
          vm.associatedFamily.push(familyMember)
        }
      })
    })

    vm.generateChartMeta = function() {
      vm.chartOverrides = []
      vm.chartOverrides.push({label: "Total Cares", type:'line'})
      angular.forEach(vm.reportData.level_series, function(value) {
        vm.chartOverrides.push({label: value, type: 'bar'})
      })
    }

    vm.totalArray = function(array) {
      var total = 0
      angular.forEach(array, function(value) {
        total = total + value
      })
      return total
    }

    vm.higestFromArrays = function(valueArray, labelArray) {
      var highestValue = 0
      var selectedKey = null
      angular.forEach(valueArray, function(value, key) {
        if (value > highestValue) {
          highestValue = value
          selectedKey = key
        }
      })
      return labelArray[selectedKey]
    }

    vm.datepickerOptions = {
      autoApply: true,
      timePicker: true,
      timePickerIncrement: 5,
      format: 'MM/DD/YYYY',
      dateLimit: { days: 365 },
      ranges: {
        'Today': [moment().startOf('day'), moment().add(1, 'days').startOf('day')],
        'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().startOf('day')],
        'Last 7 Days': [moment().subtract(7, 'days').startOf('day'), moment().startOf('day')],
        'Last 30 Days': [moment().subtract(30, 'days').startOf('day'), moment().startOf('day')],
        'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').startOf('day')],
        'Last Month': [moment().subtract(1, 'month').startOf('month').startOf('day'), moment().subtract(1, 'month').endOf('month').startOf('day')],
        'This Year': [moment().startOf('year').startOf('day'), moment().endOf('year').startOf('day')]
      },
      opens: 'left',
      drops: 'down'
    }

    // Timepicker Defaults
    vm.date = {
      "startDate": moment().utc().startOf('day'),
      "endDate": moment().utc().add(1, 'days').startOf('day')
    }

    vm.getData = function() {
      if (!vm.loading) {
        vm.loading = true
        quantumApi.resident.get({id:residentId}).$promise
        .then(function(data) {
          vm.residentData = data
          if (data.wanderer_transmitter) {
            quantumApi.transmitterTrack.get({tag_id:data.wanderer_transmitter.serial_number}).$promise
            .then(function(data) {
              vm.residentData.wanderer_transmitter.days_in_use = data.minutes_in_use / 60 / 24
            })
          }
        })
        quantumApi.resident.insights({id:residentId},{"start_time":vm.date.startDate, "end_time":vm.date.endDate}, function(data){
          vm.reportData = data
          // Combine the total care data and the the seperated dat
          vm.reportData.dailyChartData = data.level_count_dated
          vm.reportData.dailyChartData.unshift(data.care_count_dated)
          // Sort ot the overrides for line vs bar
          vm.generateChartMeta()
          vm.initalLoadComplete = true
          vm.loading = false
        })
      }
    }
    // Load if the care license is off and the date picker doesn't fire it off automatically
    if (!vm.userAuth.data.system_license.care_package) {
      vm.getData()
    }

    // Make it pretty
    vm.humanizeDuration = function(duration) {
      if(duration) {
        return moment.duration(duration, "seconds").humanize()
      }
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ReportTransmitterTestController', ReportTransmitterTestController);

  /** @ngInject */
  function ReportTransmitterTestController(moment, quantumApi, $interval, $scope) {
    var vm = this;
    var lastDate = null

    vm.checkinData = null
    vm.loadComplete = false
    vm.hideCheckedIn = false

    vm.selectedDate = function(){
      return moment(vm.date.startDate).format('M-D-YYYY')
    }

    vm.date = {
      "startDate": moment(),
      "endDate": moment()
    }

    vm.maxDate = moment()

    vm.getStaffName = function(staff_id) {
      var staffReturend
      angular.forEach(vm.staff, function(staff) {
        if (staff.id == staff_id) {
          staffReturend = staff.first_name + " " + staff.last_name
        }
      })
      return staffReturend
    }

    vm.loadReports = function(number,fromDatePicker) {
      // That datepicker double submits
      if (!fromDatePicker || lastDate != vm.date.startDate) {
        lastDate = vm.date.startDate
        vm.loadComplete = false
        //vm.checkinData = null
        quantumApi.transmitterTestReport.save(
          {"date": moment(vm.date.startDate).format('MM-DD-YYYY')},
          function(data){
            vm.residentTests = data
          }
        )

        quantumApi.transmitterTestDetailsReport.save(
          {"date": moment(vm.date.startDate).format('MM-DD-YYYY')},
          function(data){
            vm.residentTestDetails = data
            angular.forEach(vm.residentTestDetails, function(report) {
              report.staff_name = vm.getStaffName(report.staff_id)
            })
          }
        )

      }
    }

    vm.transmitterErrors = function(tests) {
      var errors = false
      angular.forEach(tests, function(test) {
        if (!test.found || test.low_battery) {
          errors = true
        }
      })
      return errors || tests.length < 1
    }

    quantumApi.resident.query().$promise
    .then(function(data){
      vm.residents = data
    })
    .then(function(){
      return quantumApi.staff.query()
    })
    .then(function(data){
      vm.staff = data
      vm.loadReports()
    })



    // Interval for fetching Resident Status. We'll use websockets someday...
    vm.refreshInterval = $interval(vm.loadReports, 10000)

    // When navigating away, cancel the intercal
    $scope.$on('$destroy', function () { $interval.cancel(vm.refreshInterval); });



  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ReportUntestedDeviceController', ReportUntestedDeviceController);

  /** @ngInject */
  function ReportUntestedDeviceController(quantumApi) {
    var vm = this;

    vm.untestedDevices = null

    vm.quantumDevices = quantumApi.quantumDevice.query()

    quantumApi.untestedDevice.get(function(data){
      vm.untestedDevice = data
    })

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ReportTransmitterHistoryController', ReportTransmitterHistoryController);

  /** @ngInject */
  function ReportTransmitterHistoryController(quantumApi, $uibModal, $scope) {
    var vm = this;

    vm.transmitters = quantumApi.transmitterTrack.query()

    vm.loadTransmitter = function(transmitter_id){
      vm.selectedTransmitter = quantumApi.transmitterTrack.get({tag_id:transmitter_id})

      vm.modalInstance = $uibModal.open({
        templateUrl: 'alarmModal.html',
        scope: $scope,
        size: 'lg'
      })

    }

    vm.closeModal = function(){
      vm.modalInstance.dismiss();
      vm.selectedTransmitter = null
    };

    // Modal Setup



  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ReportSystemStatusController', ReportSystemStatusController);

  /** @ngInject */
  function ReportSystemStatusController() {

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ReportStaffCareController', ReportStaffCareController);

  /** @ngInject */
  function ReportStaffCareController(moment, quantumApi, $uibModal, $scope, $filter, systemStatus, userAuth, customFilters) {
    var vm = this;

    vm.filterData = quantumApi.reportFilter.get()
    vm.customFilters = customFilters

    // Modal Setup
    vm.openModal = function(selectedCare){
      vm.selectedCare = selectedCare
      vm.modalInstance = $uibModal.open({
        templateUrl: 'careModal.html',
        scope: $scope,
        size: 'lg'
      });
    }

    vm.closeModal = function(){
        vm.modalInstance.dismiss();
    };

    // Site name for csv filename
    quantumApi.siteInfo.get(function(data){
      vm.siteName = data.name.replace(/\s+/g, '_')
    })

    // Default Ordering
    vm.currentPage = 1
    vm.orderByKey = 'completed_time'
    vm.orderReverse = false

    vm.systemStatus = systemStatus

    vm.chartDatasetOverride = [
      {
        label: "Total Cares",
        type: 'bar'
      },
      {
        label: "Average Response Min",
        type: 'line'
      }
    ]

    vm.chartSeries = ['Total Cares']

    vm.datepickerOptions = {
      autoApply: true,
      timePicker: true,
      timePickerIncrement: 5,
      format: 'MM/DD/YYYY',
      dateLimit: { days: 365 },
      ranges: {
        'Today': [moment().startOf('day'), moment().add(1, 'days').startOf('day')],
        'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().startOf('day')],
        'Last 7 Days': [moment().subtract(7, 'days').startOf('day'), moment().startOf('day')],
        'Last 30 Days': [moment().subtract(30, 'days').startOf('day'), moment().startOf('day')],
        'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').startOf('day')],
        'Last Month': [moment().subtract(1, 'month').startOf('month').startOf('day'), moment().subtract(1, 'month').endOf('month').startOf('day')],
        'This Year': [moment().startOf('year').startOf('day'), moment().endOf('year').startOf('day')]
      },
      opens: 'left',
      drops: 'down'
    }

    // Timepicker Defaults
    vm.date = {
      "startDate": moment().utc().startOf('day'),
      "endDate": moment().utc().add(1, 'days').startOf('day')
    }

    vm.clearFilers = function() {
      vm.filters = {
        care:[],
        resident:[],
        staff:[],
        care_level:[],
        care_plan:[],
        area:[],
        apartment:[],
        has_alarm:1
      }
      vm.maxDuration = null
      vm.minDuration = null
      vm.getData()
    }

    vm.filters = {
      care:[],
      resident:[],
      staff:[],
      care_level:[],
      care_plan:[],
      area:[],
      apartment:[],
      has_alarm:1
    }

    // Filter Saver

    vm.addCustomFilter = function(filterName) {
      var filterObject = {
        name:filterName,
        filters:vm.filters,
        minDuration:vm.minDuration,
        maxDuration:vm.maxDuration
      }
      vm.customFilters.data.staff_care.unshift(filterObject)
      vm.customFilters.saveFilters()
      vm.filterName = null
    }

    vm.removeFilter = function(result) {
      angular.forEach(vm.customFilters.data.staff_care, function(filter, key) {
        if (angular.equals(filter, result)) {
          vm.customFilters.data.staff_care.splice(key,1)
        }
      })
      vm.customFilters.saveFilters()
    }

    vm.loadFilter = function(result) {
      vm.filters = result.filters
      vm.minDuration = result.minDuration
      vm.maxDuration = result.maxDuration
      vm.getData()
      vm.closeFilterModal()
    }

    vm.openFilterModal = function(){
      vm.filterModalInstance = $uibModal.open({
        templateUrl: 'customFilterModal.html',
        scope: $scope,
        size: 'lg'
      });
    }

    vm.closeFilterModal = function(){
        vm.filterModalInstance.dismiss();
    };

    // For getting the filters into a usable state
    function returnIdArray(filterArray) {
      var idArray = []
      angular.forEach(filterArray, function(value) {
        idArray.push(value.id)
      })
      return idArray
    }

    // Make it pretty
    vm.humanizeDuration = function(duration) {
      if(duration) {
        return moment.duration(duration, "minutes").humanize()
      }
    }

    vm.getData = function() {
      if (!vm.loading) {
        vm.loading = true

        var reqObj = {
         "start_time":vm.date.startDate,
         "end_time":vm.date.endDate,
         "page":vm.currentPage,
         "sort":{"sort_by":vm.orderByKey,"sort_asc":vm.orderReverse},
         "apartment_filter":returnIdArray(vm.filters.apartment),
         "area_filter":returnIdArray(vm.filters.area),
         "care_plan_filter":returnIdArray(vm.filters.care_plan),
         "care_level_filter":returnIdArray(vm.filters.care_level),
         "care_filter":returnIdArray(vm.filters.care),
         "staff_filter":returnIdArray(vm.filters.staff),
         "resident_filter":returnIdArray(vm.filters.resident),
         "alarm_association_filter":vm.filters.has_alarm,
         "alarm_duration_min":vm.minDuration * 60,
         "alarm_duration_max":vm.maxDuration * 60
        }
        quantumApi.staffCareReport.request(reqObj, function(data){
          vm.reportData = data
          vm.initalLoadComplete = true
          vm.loading = false
        })
      }
    }


    vm.getCsv = function() {
      var filename = vm.siteName+"_staff_care_report.csv"
      var reqObj = {
       "start_time":vm.date.startDate,
       "end_time":vm.date.endDate,
       "page":vm.currentPage,
       "sort":{"sort_by":vm.orderByKey,"sort_asc":vm.orderReverse},
       "apartment_filter":returnIdArray(vm.filters.apartment),
       "area_filter":returnIdArray(vm.filters.area),
       "care_plan_filter":returnIdArray(vm.filters.care_plan),
       "care_level_filter":returnIdArray(vm.filters.care_level),
       "care_filter":returnIdArray(vm.filters.care),
       "staff_filter":returnIdArray(vm.filters.staff),
       "resident_filter":returnIdArray(vm.filters.resident),
       "alarm_association_filter":vm.filters.has_alarm,
       "alarm_duration_min":vm.minDuration * 60,
       "alarm_duration_max":vm.maxDuration * 60
      }
      vm.csvLadda = true
      quantumApi.getStaffCareCsv(reqObj, filename)
      .then(function(){
        vm.csvLadda = false
      })
    }

    $scope.$watch('vm.minDuration', function () {
      vm.getData()
    });

    $scope.$watch('vm.maxDuration', function () {
      vm.getData()
    });


  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ReportSerialNumberController', ReportSerialNumberController);

  /** @ngInject */
  function ReportSerialNumberController(quantumApi) {
    var vm = this;

    // Quantum Fixed Devices
    var quantumPullCords = []
    var quantumOtherFixedDevices = []

    vm.wandererTransmitters = []
    vm.callButtons = []
    vm.fallDetection = []

    // Site name for csv filename
    quantumApi.siteInfo.get(function(data){
      vm.siteName = data.name.replace(/\s+/g, '_')
    })

    quantumApi.quantumDevice.query(function(data){
      angular.forEach(data, function(device){
        // Pull Cords
        if (device.pti == 12) {
          var deviceIndex
          angular.forEach(device.sub_devices, function(subDevice){
            if (subDevice.input == 1) {
              deviceIndex = quantumPullCords.push(subDevice)
              quantumPullCords[deviceIndex - 1].staff_assist = false
              quantumPullCords[deviceIndex - 1].serial_number = device.serial_number
              quantumPullCords[deviceIndex - 1].device_type = device.device_data.device_description
            }
            if (subDevice.input == 2 && subDevice.active) {
              quantumPullCords[deviceIndex - 1].staff_assist = true
            }
          })
        // Everything Else
        } else {
          deviceIndex = quantumOtherFixedDevices.push(device)
          quantumOtherFixedDevices[deviceIndex - 1].names = []

          angular.forEach(device.sub_devices, function(subDevice){
            if (subDevice.active) {
              quantumOtherFixedDevices[deviceIndex - 1].names.push(subDevice.name)
            }
          })
        }
      })
      vm.quantumPullCords = quantumPullCords
      vm.quantumOtherFixedDevices = quantumOtherFixedDevices
    })

    // Mobile Devices
    vm.residents = quantumApi.resident.query(function(data){
      angular.forEach(data, function(value) {
        if (value.wanderer_transmitter) {
          vm.wandererTransmitters.push(value.wanderer_transmitter)
        }
        if (value.call_button) {
          vm.callButtons.push(value.call_button)
        }
        if (value.fall_detection) {
          vm.fallDetection.push(value.fall_detection)
        }
      })
    })

    // Hardware
    vm.inovoincsRepeaters = quantumApi.inovonicsRepeater.query()
    vm.doors = quantumApi.door.query()
    vm.ioRepeaters = quantumApi.ioRepeater.query()
    vm.enrollmentStations = quantumApi.enrollmentStation.query()
    vm.systemMonitors = quantumApi.systemMonitor.query()

    // Make the CSV Export Pretty
    vm.cleanCsv = function() {
      var cleanData = []
      // Pull Cords
      angular.forEach(vm.quantumPullCords, function(pullcord) {
        var row = {}
        row.serial_number = pullcord.serial_number
        row.name = pullcord.name
        row.device_type = pullcord.device_type
        row.staff_assist = pullcord.staff_assist ? "Yes" : "No"
        cleanData.push(row)
      })

      angular.forEach(vm.quantumOtherFixedDevices, function(device) {
        var row = {}
        row.serial_number = device.serial_number
        row.name = device.names
        row.device_type = device.device_data.device_description
        cleanData.push(row)
      })

      angular.forEach(vm.residents, function(resident) {
        if (resident.call_button) {
          var row = {}
          row.serial_number = resident.call_button.serial_number
          row.name = ""
          row.device_type = "Quantum Call Button"
          cleanData.push(row)
        }
      })

      angular.forEach(vm.residents, function(resident) {
        if (resident.wanderer_transmitter) {
          var row = {}
          row.serial_number = resident.wanderer_transmitter.serial_number
          row.name = ""
          row.device_type = "Quantum Wanderer Transmitter"
          cleanData.push(row)
        }
      })

      angular.forEach(vm.residents, function(resident) {
        if (resident.fall_detection) {
          var row = {}
          row.serial_number = resident.fall_detection.serial_number
          row.name = ""
          row.device_type = "Quantum Fall Detection Unit"
          cleanData.push(row)
        }
      })

      angular.forEach(vm.doors, function(door) {
        var row = {}
        row.serial_number = door.serial_number
        row.name = door.name
        row.device_type = "Quantum Door Controller"
        cleanData.push(row)
      })

      angular.forEach(vm.inovoincsRepeaters, function(repeater) {
        var row = {}
        row.serial_number = repeater.serial_number
        row.name = repeater.name
        row.device_type = "Inovonics Repeater"
        cleanData.push(row)
      })

      angular.forEach(vm.ioRepeaters, function(repeater) {
        var row = {}
        row.serial_number = repeater.serial_number
        row.name = repeater.name
        row.device_type = "Quantum IO Repeater"
        cleanData.push(row)
      })

      angular.forEach(vm.enrollmentStations, function(enrollmentStation) {
        var row = {}
        row.serial_number = enrollmentStation.serial_number
        row.name = enrollmentStation.name
        row.device_type = "Quantum Enrollment Station"
        cleanData.push(row)
      })

      angular.forEach(vm.systemMonitors, function(systemMonitors) {
        var row = {}
        row.serial_number = systemMonitors.serial_number
        row.name = systemMonitors.name
        row.device_type = "Quantum System Monitor"
        cleanData.push(row)
      })

      return cleanData
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ReportDuplicateNameController', ReportDuplicateNameController);

  /** @ngInject */
  function ReportDuplicateNameController(quantumApi) {
    var vm = this;

    vm.duplicateDevices = []

    vm.quantumDevices = quantumApi.quantumDevice.query()

    quantumApi.duplicateNames.query(function(data){
      vm.duplicateDevices = data
    })

    vm.getSerials = function(deviceIds) {
      var serialNumbers = []
       angular.forEach(deviceIds, function(deviceId) {
         angular.forEach(vm.quantumDevices, function(quantumDevice) {
           if (quantumDevice.acg_id == deviceId) {
             serialNumbers.push(quantumDevice.serial_number + " - " + quantumDevice.device_data.device_description)
           }
         })
       })
      return serialNumbers
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ReportDoorConfigurationController', ReportDoorConfigurationController);

  /** @ngInject */
  function ReportDoorConfigurationController(quantumApi) {
    var vm = this;

    vm.returnName = function(array, id) {
      var finalValue = "None"
      angular.forEach(array, function(value) {
        if (id == value.id) {
          finalValue = value.name
        }
      })
      return finalValue
    }

    vm.sounderTones = [
      {
        'id':1,
        'name':"Constant"
      },
      {
        'id':2,
        'name':"Slow"
      },
      {
        'id':3,
        'name':"Fast"
      },
      {
        'id':4,
        'name':"Slow Multi-Tone"
      },
      {
        'id':5,
        'name':"Fast Multi-Tone"
      }
    ]

    vm.doorUses = [
      {
        'id':0,
        'name':"Wanderer Monitoring"
      },
      {
        'id':1,
        'name':"Access Control"
      },
      {
        'id':2,
        'name':"Access Control and Wanderer Monitoring"
      }
    ]

    vm.inputTypes = quantumApi.inputType.query()
    vm.outputTypes = quantumApi.outputType.query()

    quantumApi.door.query(function(data){
      vm.doors = []
      angular.forEach(data, function(value) {
        quantumApi.door.get({id:value.id}).$promise
        .then(function(door){
          vm.doors.push(door)
        })
      })
    })


  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ReportDailyEventController', ReportDailyEventController);

  /** @ngInject */
  function ReportDailyEventController(moment, quantumApi, $filter, systemStatus, $scope, $uibModal, $log, userAuth) {
    var vm = this;
    // Deal with timepicker problems

    vm.systemStatus = systemStatus
    vm.initalLoadComplete = false
    vm.loading = false
    vm.currentPage = 1
    vm.orderByKey = 'event_time',
    vm.orderReverse = false
    vm.userAuth = userAuth

    vm.filterData = quantumApi.reportFilter.get()

    // Site name for csv filename
    quantumApi.siteInfo.get(function(data){
      vm.siteName = data.name.replace(/\s+/g, '_')
    })

    vm.date = {
      "startDate": moment().utc().startOf('day'),
      "endDate": moment().utc().add(1, 'days').startOf('day')
    }

    vm.maxDate = moment()

    // Modal Setup
    vm.openModal = function(selectedEvent){
      vm.selectedEvent = selectedEvent
      vm.selectedEventNotes = []
      quantumApi.eventNote.query({'id':selectedEvent.id}, function(data){
        angular.forEach(data, function(note) {
          if (!note.user_note) {
            if (note.old_object && note.new_object) {
              note.differences = vm.compareObj(note.old_object, note.new_object)
            }
          } else {
            note.differences = []
          }
          vm.selectedEventNotes.push(note)
        })
        vm.modalInstance = $uibModal.open({
          templateUrl: 'eventModal.html',
          scope: $scope,
          size: 'lg'
        });
      })
    }

    vm.closeModal = function(){
        vm.modalInstance.dismiss();
    };

    vm.compareObj = function(obj1,obj2){
       var differences = []
       if(angular.equals(obj1,obj2)){
         return false
       }else{
         angular.forEach(obj1, function(element,key){
           if(angular.isUndefined(obj2[key])){
             $log.log(key)
           }else{
             if(obj1[key] !== null && angular.isObject(obj1[key])){
               if(angular.equals(obj1[key],obj2[key])){
                 $log.log("Sub Objects are The Same")
               }else{
                 //console.log(vm.compareObj(obj1[key], obj2[key]))
                var differencesFound = vm.compareObj(obj1[key], obj2[key])
                angular.forEach(differencesFound, function(value) {
                  differences.push(value)
                })
               }
             }else{
               if(obj1[key] == obj2[key]){
                 $log.log("Value Same for key "+key)
               }else{
                 differences.push({"key":key, "oldValue":obj1[key],"newValue":obj2[key]})
               }
             }
           }
         })
         return differences
       }
     }


    vm.clearFilters = function() {
      vm.filters = {
        event:[],
        location:[],
        resident:[],
        staff:[]
      }
      vm.getData()
    }

    vm.datepickerOptions = {
      autoApply: true,
      timePicker: true,
      timePickerIncrement: 5,
      format: 'MM/DD/YYYY',
      dateLimit: { days: 400 },
      ranges: {
        'Today': [moment().startOf('day'), moment().add(1, 'days').startOf('day')],
        'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().startOf('day')],
        'Last 7 Days': [moment().subtract(7, 'days').startOf('day'), moment().startOf('day')],
        'Last 30 Days': [moment().subtract(30, 'days').startOf('day'), moment().startOf('day')],
        'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').startOf('day')],
        'Last Month': [moment().subtract(1, 'month').startOf('month').startOf('day'), moment().subtract(1, 'month').endOf('month').startOf('day')],
        'This Year': [moment().startOf('year').startOf('day'), moment().endOf('year').startOf('day')]
      },
      opens: 'left',
      drops: 'down'
    }

    function returnIdArray(filterArray) {
      var idArray = []
      angular.forEach(filterArray, function(value) {
        idArray.push(value.id)
      })
      return idArray
    }

    function returnLocationArray(filterArray) {
      var idArray = []
      angular.forEach(filterArray, function(value) {
        if(!value.id.is_fixed_device) {
          idArray.push(value.id.location_id)
        }
      })
      return idArray
    }

    function returnResidentArray(residents, locations) {
      var idArray = []
      angular.forEach(residents, function(value) {
        idArray.push(value.id)
      })
      angular.forEach(locations, function(value) {
        if (value.id.is_fixed_device) {
          idArray.push(value.id.resident_id)
        }
      })
      return idArray
    }

    vm.getData = function() {
      vm.loading = true
      var reqObj = {
        "start_time":vm.date.startDate,
        "end_time":vm.date.endDate,
        "page":vm.currentPage,
        "sort":{"sort_by":vm.orderByKey,"sort_asc":vm.orderReverse},
        "event_type_filter":returnIdArray(vm.filters.event),
        "event_staff_filter":returnIdArray(vm.filters.staff),
        "event_resident_filter":returnResidentArray(vm.filters.resident, vm.filters.location),
        "event_location_filter":returnLocationArray(vm.filters.location)
      }
      quantumApi.eventHistoryReport.request(reqObj, function(data){
        vm.events = data
        vm.initalLoadComplete = true
        vm.loading = false
        vm.load = false
      })
    }

    vm.getCsv = function() {
      var filename = vm.siteName+"_daily_event_"+vm.date.startDate+".csv"
      var reqObj = {
        "start_time":vm.date.startDate,
        "end_time":vm.date.endDate,
        "page":vm.currentPage,
        "sort":{"sort_by":vm.orderByKey,"sort_asc":vm.orderReverse},
        "event_type_filter":returnIdArray(vm.filters.event),
        "event_staff_filter":returnIdArray(vm.filters.staff),
        "event_resident_filter":returnResidentArray(vm.filters.resident, vm.filters.location),
        "event_location_filter":returnLocationArray(vm.filters.location)
      }
      vm.csvLadda = true
      quantumApi.getEventCsv(reqObj, filename)
      .then(function(){
        vm.csvLadda = false
      })
    }

    vm.clearFilters()


  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ReportDailyCheckinController', ReportDailyCheckinController);

  /** @ngInject */
  function ReportDailyCheckinController(moment, quantumApi, $scope, $interval) {
    var vm = this;

    var lastDate = null

    vm.checkinData = null
    vm.loadComplete = false
    vm.hideCheckedIn = false

    vm.selectedDate = function(){
      return moment(vm.date.startDate).format('M-D-YYYY')
    }

    vm.date = {
      "startDate": moment(),
      "endDate": moment()
    }

    vm.maxDate = moment()

    vm.getAreaName = function(area_id) {
      var areaName
      angular.forEach(vm.areas, function(area) {
        if (area.id == area_id) {
          areaName = area.name
        }
      })
      return areaName
    }

    vm.loadCheckin = function(number,fromDatePicker) {
      // That datepicker double submits
      if (!fromDatePicker || lastDate != vm.date.startDate) {
        lastDate = vm.date.startDate
        vm.loadComplete = false
        //vm.checkinData = null
        quantumApi.checkin.query(
          {"date": moment(vm.date.startDate).format('MM-DD-YYYY')},
          function(data){
            angular.forEach(data, function(checkinData) {
              angular.forEach(checkinData.missed_checkins, function(missedCheckins) {
                missedCheckins.area_name = vm.getAreaName(missedCheckins.area_id)
              })
            })
            vm.checkinData = data
            vm.loadComplete = true
          }
        )
      }
    }

    vm.missedCheckins = function(checkinEntries) {
      var missedCheckins = false
      angular.forEach(checkinEntries, function(entry) {
        if (entry.checked_in == false) {
          missedCheckins = true
        }
      })
      return missedCheckins
    }

    vm.areas = quantumApi.area.query(function(){
      vm.loadCheckin()
    })

    // Interval for fetching Resident Status. We'll use websockets someday...
    vm.refreshInterval = $interval(vm.loadCheckin, 10000)

    // When navigating away, cancel the intercal
    $scope.$on('$destroy', function () { $interval.cancel(vm.refreshInterval); });




  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ReportCredentialController', ReportCredentialController);

  /** @ngInject */
  function ReportCredentialController($scope, $rootScope, $interval, quantumApi, $filter, $q) {
    var vm = this;

    vm.orderByKey = "last_name"
    vm.orderReverse = false
    vm.initalLoadComplete = false
    vm.credentialHolders = []

    vm.searchFilter = ""

    // Site name for csv filename
    quantumApi.siteInfo.get(function(data){
      vm.siteName = data.name.replace(/\s+/g, '_')
    })

    function getStaffStatus(){
      var promises = []
      promises.push(
        quantumApi.staff.query(function(data){
          angular.forEach(data, function(staffMember) {
            staffMember.user_type = staffMember.corporate_id ? "Corporate" : "Staff"
            if (staffMember.keycard || staffMember.keypad || staffMember.raw_card_data) {
              staffMember.last_location_name = staffMember.location_name
              vm.credentialHolders.push(staffMember)
            }
          })

        }).$promise
      )

      promises.push(
        quantumApi.family.query(function(data){
          angular.forEach(data, function(familyMember) {
            familyMember.user_type = "Family"
            familyMember.last_location_name = familyMember.location_name
            vm.credentialHolders.push(familyMember)
          })

        }).$promise
      )

      promises.push(
        quantumApi.resident.query(function(data){
          angular.forEach(data, function(resident) {
            if (resident.resident_door_access) {
              var residentObject = {
                first_name:resident.first_name,
                last_name:resident.last_name,
                user_type:"Resident",
                keypad:resident.resident_door_access.keypad,
                keycard:resident.resident_door_access.keycard,
                raw_card_data:resident.resident_door_access.raw_card_data,
                last_location_name:resident.location,
                location_time:resident.location_time
              }
              vm.credentialHolders.push(residentObject)
            }
          })

        }).$promise
      )

      $q.all(promises)
      .then(function(){
        vm.credentialHolders = $filter('naturalSort')(vm.credentialHolders, vm.orderByKey)
        vm.initalLoadComplete = true
      })

    }

    vm.resort = function() {
      vm.credentialHolders = $filter('naturalSort')(vm.credentialHolders, vm.orderByKey)
    }

    // Initial Load
    getStaffStatus()

    // Make the CSV Export Pretty
    vm.cleanCsv = function(credentialHolders) {
      var cleanData = []
      angular.forEach(credentialHolders, function(credentialHolder) {
        var row = {
          "first_name":credentialHolder.first_name,
          "last_name":credentialHolder.last_name,
          "credential_type": credentialHolder.user_type,
          "keypad_code":credentialHolder.keypad,
          "keycard_code":credentialHolder.keycard,
          "last_known_location":credentialHolder.last_location_name,
          'located':(credentialHolder.location_time ? $filter('timeago')(credentialHolder.location_time) : null)
        }
        cleanData.push(row)
      })
      return cleanData
    }

    vm.csvHeaders = ["First Name", "Last Name", "Credential Type", "Keypad Code", "Keycard Code", "Last Known Location", 'Located']

    // Raw Card Info
    // Listeer for raw card data coming from enrollment station with card reader
    // Comes from the websocket initiate in the system status service
    var cardDataListener = $rootScope.$on('cardEnrollData', function(event, data){
      vm.searchFilter = data
    })

    // Clean Up the connection to the acg and the event listeners on destroy
    $scope.$on('$destroy', function() {
      $scope.$on('$destroy', cardDataListener())
    })

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ReportAlarmHistoryController', ReportAlarmHistoryController);

  /** @ngInject */
  function ReportAlarmHistoryController(moment, quantumApi, $uibModal, $scope, $filter, systemStatus, userAuth, customFilters) {
    var vm = this;

    vm.maxDuration = null
    vm.minDuration = null
    vm.orderByKey = 'alarm_start',
    vm.orderReverse = false

    vm.filterData = quantumApi.reportFilter.get()
    vm.customFilters = customFilters


    vm.alarmByHourKeys = ["12AM","1AM","2AM","3AM","4AM","5AM","6AM","7AM","8AM","9AM","10AM","11AM","12PM","1PM","2PM","3PM","4PM","5PM","6PM","7PM","8PM","9PM","10PM","11PM"]
    vm.currentPage = 1
    vm.chartDatasetOverride = [
      {
        label: "Total Alarms",
        type: 'bar'
      },
      {
        label: "Average Response Min",
        type: 'line'
      }
    ]


    vm.pieChartClick = function(data) {
      var eventType = vm.reportData.insight_data.alarm_type_keys[data[0]._index]
      var objToSelect
      angular.forEach(vm.filterData.events, function(event) {
        if (event.event == eventType) {
          objToSelect = event
        }
      })
      vm.filters.event = [{id:objToSelect.event_code}]
      vm.getData()
    }

    vm.pieChartClickArea = function(data) {
      var areaType = vm.reportData.insight_data.area_keys[data[0]._index]
      var objToSelect
      angular.forEach(vm.filterData.areas, function(area) {
        if (area.name == areaType) {
          objToSelect = area
        }
      })
      vm.filters.area = [{id:objToSelect.id}]
      vm.getData()
    }

    vm.setMostActive = function(mostActive) {
      if (mostActive.resident_id) {
        if (mostActive.is_fixed_device) {
          angular.forEach(vm.filterData.locations, function(value) {
            if (value.location_data.resident_id == mostActive.resident_id) {
              vm.filters.location = [{"id":value.location_data}]
            }
          })
        } else {
          vm.filters.resident = [{"id":mostActive.resident_id}]
        }
      } else {
        angular.forEach(vm.filterData.locations, function(value) {
          if (value.location_data.location_id == mostActive.location_id) {
            vm.filters.location = [{"id":value.location_data}]
          }
        })
      }
      vm.getData()
    }

    vm.setResponseLongest = function() {
      vm.orderByKey = 'duration'
      vm.orderReverse = false
      vm.getData()
    }

    vm.setTimeFilter = function(minTime, maxTime) {
      vm.minDuration = minTime
      vm.maxDuration = maxTime
      vm.getData()
    }

    // Selected alarm for the modal
    vm.selectedAlarm
    vm.loading = false
    vm.initalLoadComplete = false


    // Site name for csv filename
    quantumApi.siteInfo.get(function(data){
      vm.siteName = data.name.replace(/\s+/g, '_')
    })

    vm.systemStatus = systemStatus

    // Modal Setup
    vm.openModal = function(selectedAlarm){
      vm.selectedAlarm = quantumApi.alarm.get({'id':selectedAlarm.id})
        vm.modalInstance = $uibModal.open({
            templateUrl: 'alarmModal.html',
            scope: $scope,
            size: 'lg'
        });
    }

    vm.closeModal = function(){
        vm.modalInstance.dismiss();
    };

    vm.datepickerOptions = {
      autoApply: true,
      timePicker: true,
      timePickerIncrement: 5,
      format: 'MM/DD/YYYY',
      dateLimit: { days: 400 },
      ranges: {
        'Today': [moment().startOf('day'), moment().add(1, 'days').startOf('day')],
        'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().startOf('day')],
        'Last 7 Days': [moment().subtract(7, 'days').startOf('day'), moment().startOf('day')],
        'Last 30 Days': [moment().subtract(30, 'days').startOf('day'), moment().startOf('day')],
        'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').startOf('day')],
        'Last Month': [moment().subtract(1, 'month').startOf('month').startOf('day'), moment().subtract(1, 'month').endOf('month').startOf('day')],
        'This Year': [moment().startOf('year').startOf('day'), moment().endOf('year').startOf('day')]
      },
      opens: 'left',
      drops: 'down'
    }

    // Timepicker Defaults
    vm.date = {
      "startDate": moment().utc().startOf('day'),
      "endDate": moment().utc().add(1, 'days').startOf('day')
    }

    vm.clearFilers = function() {
      vm.filters = {
        event:[],
        location:[],
        resident:[],
        area:[],
        staff_name:[]
      }
      vm.minDuration = null
      vm.maxDuration = null
      vm.getData()
    }

    vm.filters = {
      event:[],
      location:[],
      resident:[],
      area:[],
      staff_name:[]
    }

    // Filter Saver

    vm.addCustomFilter = function(filterName) {
      var filterObject = {
        name:filterName,
        filters:vm.filters,
        minDuration:vm.minDuration,
        maxDuration:vm.maxDuration
      }
      vm.customFilters.data.alarm_history.unshift(filterObject)
      vm.customFilters.saveFilters()
      vm.filterName = null
    }

    vm.removeFilter = function(result) {
      angular.forEach(vm.customFilters.data.alarm_history, function(filter, key) {
        if (angular.equals(filter, result)) {
          vm.customFilters.data.alarm_history.splice(key,1)
        }
      })
      vm.customFilters.saveFilters()
    }

    vm.loadFilter = function(result) {
      vm.filters = result.filters
      vm.minDuration = result.minDuration
      vm.maxDuration = result.maxDuration
      vm.getData()
      vm.closeFilterModal()
    }

    vm.openFilterModal = function(){
      vm.filterModalInstance = $uibModal.open({
        templateUrl: 'customFilterModal.html',
        scope: $scope,
        size: 'lg'
      });
    }

    vm.closeFilterModal = function(){
        vm.filterModalInstance.dismiss();
    };


    function returnIdArray(filterArray) {
      var idArray = []
      angular.forEach(filterArray, function(value) {
        idArray.push(value.id)
      })
      return idArray
    }

    function returnLocationArray(filterArray) {
      var idArray = []
      angular.forEach(filterArray, function(value) {
        if(!value.id.is_fixed_device) {
          idArray.push(value.id.location_id)
        }
      })
      return idArray
    }

    function returnResidentArray(residents, locations) {
      var idArray = []
      angular.forEach(residents, function(value) {
        idArray.push(value.id)
      })
      angular.forEach(locations, function(value) {
        if (value.id.is_fixed_device) {
          idArray.push(value.id.resident_id)
        }
      })
      return idArray
    }

    vm.getData = function() {
      if (!vm.loading) {
        vm.loading = true
        var reqObj = {
          "start_time":vm.date.startDate,
          "end_time":vm.date.endDate,
          "page":vm.currentPage,
          "sort":{"sort_by":vm.orderByKey,"sort_asc":vm.orderReverse},
          "alarm_type_filter":returnIdArray(vm.filters.event),
          "alarm_area_filter":returnIdArray(vm.filters.area),
          "alarm_resident_filter":returnResidentArray(vm.filters.resident, vm.filters.location),
          "alarm_location_filter":returnLocationArray(vm.filters.location),
          "alarm_duration_min":vm.minDuration * 60,
          "alarm_duration_max":vm.maxDuration * 60
        }
        quantumApi.alarmHistoryReport.request(reqObj, function(data){
          vm.reportData = data
          vm.initalLoadComplete = true
          vm.loading = false
        })
      }
    }

    $scope.$watch('vm.minDuration', function () {
      vm.getData()
    });

    $scope.$watch('vm.maxDuration', function () {
      vm.getData()
    });

    // Make it pretty
    vm.humanizeDuration = function(duration) {
      if(duration) {
        return moment.duration(duration, "seconds").humanize()
      }
    }

    vm.getCsv = function() {
      var filename = vm.siteName+"_alarm_history.xlsx"
      var reqObj = {
        "start_time":vm.date.startDate,
        "end_time":vm.date.endDate,
        "page":vm.currentPage,
        "sort":{"sort_by":vm.orderByKey,"sort_asc":vm.orderReverse},
        "alarm_type_filter":returnIdArray(vm.filters.event),
        "alarm_area_filter":returnIdArray(vm.filters.area),
        "alarm_resident_filter":returnResidentArray(vm.filters.resident, vm.filters.location),
        "alarm_location_filter":returnLocationArray(vm.filters.location),
        "alarm_duration_min":vm.minDuration * 60,
        "alarm_duration_max":vm.maxDuration * 60
      }
      vm.csvLadda = true
      quantumApi.getAlarmCsv(reqObj, filename)
      .then(function(){
        vm.csvLadda = false
      })

    }

    vm.csvHeaders = ["Audit Time", "Alert Device", "Message", "Audit Result"]

    vm.cleanAuditCsv = function(audits) {
      var results = []
      angular.forEach(audits, function(audit) {
        var auditObj = {
          "time_of_event": $filter("date")(audit.time_handled, "medium", audit.offset),
          "alert_device": audit.alert_device_description,
          "message_sent": audit.message_text,
          "result": audit.message_result
        }
        results.push(auditObj)
      })
      return results
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ReportCareController', ReportCareController);

  /** @ngInject */
  function ReportCareController(moment, quantumApi, $uibModal, $scope, $filter, systemStatus, userAuth, customFilters) {
    var vm = this;

    vm.filterData = quantumApi.reportFilter.get()
    vm.customFilters = customFilters

    // Site name for csv filename
    quantumApi.siteInfo.get(function(data){
      vm.siteName = data.name.replace(/\s+/g, '_')
    })

    // Default Ordering
    vm.currentPage = 1
    vm.orderByKey = 'completed_time'
    vm.orderReverse = false

    vm.systemStatus = systemStatus

    // Modal Setup
    vm.openModal = function(selectedCare){
      vm.selectedCare = selectedCare
      vm.modalInstance = $uibModal.open({
        templateUrl: 'careModal.html',
        scope: $scope,
        size: 'lg'
      });
    }

    vm.closeModal = function(){
        vm.modalInstance.dismiss();
    };

    vm.chartSeries = ['Total Cares']

    vm.datepickerOptions = {
      autoApply: true,
      timePicker: true,
      timePickerIncrement: 5,
      format: 'MM/DD/YYYY',
      dateLimit: { days: 365 },
      ranges: {
        'Today': [moment().startOf('day'), moment().add(1, 'days').startOf('day')],
        'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().startOf('day')],
        'Last 7 Days': [moment().subtract(7, 'days').startOf('day'), moment().startOf('day')],
        'Last 30 Days': [moment().subtract(30, 'days').startOf('day'), moment().startOf('day')],
        'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').startOf('day')],
        'Last Month': [moment().subtract(1, 'month').startOf('month').startOf('day'), moment().subtract(1, 'month').endOf('month').startOf('day')],
        'This Year': [moment().startOf('year').startOf('day'), moment().endOf('year').startOf('day')]
      },
      opens: 'left',
      drops: 'down'
    }

    // Timepicker Defaults
    vm.date = {
      "startDate": moment().utc().startOf('day'),
      "endDate": moment().utc().add(1, 'days').startOf('day')
    }

    vm.clearFilers = function() {
      vm.filters = {
        care:[],
        resident:[],
        staff:[],
        care_level:[],
        care_plan:[],
        area:[],
        apartment:[],
        has_alarm:1
      }
      vm.getData()
    }

    vm.filters = {
      care:[],
      resident:[],
      staff:[],
      care_level:[],
      care_plan:[],
      area:[],
      apartment:[],
      has_alarm:1
    }

    // Filter Saver

    vm.addCustomFilter = function(filterName) {
      var filterObject = {
        name:filterName,
        filters:vm.filters
      }
      vm.customFilters.data.care.unshift(filterObject)
      vm.customFilters.saveFilters()
      vm.filterName = null
    }

    vm.removeFilter = function(result) {
      angular.forEach(vm.customFilters.data.care, function(filter, key) {
        if (angular.equals(filter, result)) {
          vm.customFilters.data.care.splice(key,1)
        }
      })
      vm.customFilters.saveFilters()
    }

    vm.loadFilter = function(result) {
      vm.filters = result.filters
      vm.getData()
      vm.closeFilterModal()
    }

    vm.openFilterModal = function(){
      vm.filterModalInstance = $uibModal.open({
        templateUrl: 'customFilterModal.html',
        scope: $scope,
        size: 'lg'
      });
    }

    vm.closeFilterModal = function(){
        vm.filterModalInstance.dismiss();
    };

    // For getting the filters into a usable state
    function returnIdArray(filterArray) {
      var idArray = []
      angular.forEach(filterArray, function(value) {
        idArray.push(value.id)
      })
      return idArray
    }

    vm.getData = function() {
      if (!vm.loading) {
        vm.loading = true

        var reqObj = {
         "start_time":vm.date.startDate,
         "end_time":vm.date.endDate,
         "page":vm.currentPage,
         "sort":{"sort_by":vm.orderByKey,"sort_asc":vm.orderReverse},
         "apartment_filter":returnIdArray(vm.filters.apartment),
         "area_filter":returnIdArray(vm.filters.area),
         "care_plan_filter":returnIdArray(vm.filters.care_plan),
         "care_level_filter":returnIdArray(vm.filters.care_level),
         "care_filter":returnIdArray(vm.filters.care),
         "staff_filter":returnIdArray(vm.filters.staff),
         "resident_filter":returnIdArray(vm.filters.resident),
         "alarm_association_filter":vm.filters.has_alarm
        }
        quantumApi.careReport.request(reqObj, function(data){
          vm.reportData = data
          vm.initalLoadComplete = true
          vm.loading = false
        })
      }
    }

    vm.getCsv = function() {
      var filename = vm.siteName+"_care_report.csv"
      var reqObj = {
       "start_time":vm.date.startDate,
       "end_time":vm.date.endDate,
       "page":vm.currentPage,
       "sort":{"sort_by":vm.orderByKey,"sort_asc":vm.orderReverse},
       "apartment_filter":returnIdArray(vm.filters.apartment),
       "area_filter":returnIdArray(vm.filters.area),
       "care_plan_filter":returnIdArray(vm.filters.care_plan),
       "care_level_filter":returnIdArray(vm.filters.care_level),
       "care_filter":returnIdArray(vm.filters.care),
       "staff_filter":returnIdArray(vm.filters.staff),
       "resident_filter":returnIdArray(vm.filters.resident),
       "alarm_association_filter":vm.filters.has_alarm
      }
      vm.csvLadda = true
      quantumApi.getCareCsv(reqObj, filename)
      .then(function(){
        vm.csvLadda = false
      })
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('ReportActiveMobileUsersController', ReportActiveMobileUsersController);

  /** @ngInject */
  function ReportActiveMobileUsersController(quantumApi, $interval, $scope, moment, systemStatus) {
    var vm = this;
    vm.systemStatus = systemStatus

    function getUserStatus() {
      vm.loadHistory()
      quantumApi.user.query(function(data){
        vm.users = data
      })
    }

    vm.alertDevices = quantumApi.alertDevice.query()
    vm.staff = quantumApi.staff.query()
    vm.mobileLogoutTypes = quantumApi.mobileLogoutTypes.query()

    vm.date = {
      "startDate": moment(),
      "endDate": moment()
    }

    vm.maxDate = moment()

    vm.getStaffMember = function(staffId) {
      var staffMember
      angular.forEach(vm.staff, function(staff) {
        if (staff.id == staffId) {
          staffMember = staff
        }
      })
      return staffMember
    }

    vm.getAlertDevice = function(alertDeviceId) {
      var alertDeviceReturn
      angular.forEach(vm.alertDevices, function(alertDevice) {
        if (alertDevice.id == alertDeviceId) {
          alertDeviceReturn = alertDevice
        }
      })
      return alertDeviceReturn
    }

    vm.getLogoutTyoe = function(logoutTypeId) {
      var logoutTypeReturn
      angular.forEach(vm.mobileLogoutTypes, function(logoutType) {
        if (logoutType.id == logoutTypeId) {
          logoutTypeReturn = logoutType
        }
      })
      return logoutTypeReturn
    }

    vm.kickUser = function(user) {
      quantumApi.userKick.delete({id:user.id}).$promise
      .then(function(){
        getUserStatus()
      })
    }

    vm.loadHistory = function() {
      quantumApi.mobileHistory.query({date:moment(vm.date.startDate).format('MM-DD-YYYY')}).$promise
      .then(function(data){
        vm.historyResults = data
      })
    }

    getUserStatus()

    vm.refreshInterval = $interval(getUserStatus, 2000)

    $scope.$on('$destroy', function () { $interval.cancel(vm.refreshInterval); });

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('MapController', MapController);

  /** @ngInject */
  function MapController($scope, leafletData, leafletBoundsHelpers, quantumApi, devMode, $interval, userAuth) {
    var vm = this;

    vm.maps = []

    if (devMode.enabled) {
      vm.mapPath = 'http://'+devMode.serverIp+'/uploads/maps/'
    } else {
      vm.mapPath = '/uploads/maps/'
    }

    vm.mapDefaults = {
        scrollWheelZoom: false,
        crs: 'Simple'
    }

    vm.selectedMapName = function(mapId) {
      var mapToReturn = "Unknown"
      angular.forEach(vm.maps, function(map) {
        if (map.id == mapId) {
          mapToReturn = map.name
        }
      })
      return mapToReturn
    }

    quantumApi.staff.getMapSettings({id:userAuth.data.id}).$promise
    .then(function(data){
      vm.mapPrefs = data
      vm.currentMap = data.general.map_id
    })
    .then(function(){
      quantumApi.map.query().$promise
      .then(function(data){
        angular.forEach(data, function(map) {
          var mapData =  {
            id: map.id,
            name: map.name,
            map_data: {
                baselayers: {
                    1: {
                        name: map.name,
                        type: 'imageOverlay',
                        url: vm.mapPath+map.filename,
                        bounds: [[-270, -480], [270, 480]],
                        layerParams: {
                          noWrap: true
                        }
                    }
                }
              }
          }
          vm.maps.push(mapData)
        })
        if(vm.mapPrefs.general.map_id == 0) {
          vm.currentMap = vm.maps[0].id
        } else {
          vm.currentMap = vm.mapPrefs.general.map_id
        }
      })
    })

    vm.setPreference = function(pref) {
      if (pref == 'see_all_doors') {
        vm.mapPrefs.door_options.see_all_doors = !vm.mapPrefs.door_options.see_all_doors
      }
      quantumApi.staff.saveMapSettings({id:userAuth.data.id}, vm.mapPrefs)
    }

    vm.center = {lat: 0, lng: 0, zoom: 0}

    vm.markerData = []

    vm.rebuildMarkers = function() {
      vm.markerData = []
      // Doors
      angular.forEach(vm.doorData, function(door) {
        if ((door.status.alarmed || door.status.breached || door.status.propped || door.status.egressed) && vm.currentMap == door.map_data.map_id) {
          // Door Alarms
          vm.markerData.push(
            {
              lat:door.map_data.lat,
              lng:door.map_data.long,
              message:"Door Alarm - " + door.name,
              icon: {
                type: 'extraMarker',
                icon: 'fa-exclamation-triangle',
                markerColor: 'red',
                prefix: 'fa',
                shape: 'circle'
              }
            }
          )
        } else if (!door.status.alarmed && vm.currentMap == door.map_data.map_id && vm.mapPrefs.door_options.see_all_doors) {
          // NOTE: REPLACE TRUE WITH ENABLE/DISABLE for All Doors
          // All Doors
          vm.markerData.push(
            {
              lat:door.map_data.lat,
              lng:door.map_data.long,
              message: door.name,
              icon: {
                type: 'extraMarker',
                icon: door.status.locked ? 'fa-lock':'fa-unlock',
                markerColor: door.status.locked ? 'orange':'green',
                prefix: 'fa',
                shape: 'circle'
              }
            }
          )
        }
      })
      // End Doors
    }

    function getDoorStatus() {
      quantumApi.door.query(function(data){
        vm.doorData = data
        vm.rebuildMarkers()
      })
    }

    //Inital Load
    getDoorStatus()

    // Interval for fetching Door Status. We'll use websockets someday...
    vm.refreshInterval = $interval(getDoorStatus, 1000)
    // When navigating away, cancel the interval
    $scope.$on('$destroy', function () { $interval.cancel(vm.refreshInterval); });


    vm.maxBounds = leafletBoundsHelpers.createBoundsFromArray([[-270, -480], [270, 480]]);

    vm.mapChange = function(mapId) {
      vm.mapPrefs.general.map_id  = mapId
      quantumApi.staff.saveMapSettings({id:userAuth.data.id}, vm.mapPrefs)
      vm.currentMap = mapId
      vm.rebuildMarkers()
      vm.center = {lat: 0, lng: 0, zoom: 0}
    }
  }
})();

(function() {
  'use strict';

// NOTE: Hey you, This is important. It's used by the root page. Don't trash it AGAIN...

  angular
    .module('quantumUiAngular')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController(userAuth, Idle, $scope) {
    var vm = this;

    vm.userAuth = userAuth

    // Idle Timeout
    $scope.$on('IdleTimeout', function() {
      userAuth.logout()
    })

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($location, userAuth, deviceDetector, $log, systemStatus, quantumApi, $cookies, $rootScope, toastr, navItems, Idle) {
    var vm = this;

    vm.deviceDetector = deviceDetector

    // On display of login page, log out any logged in user
    if ($location.path() === "/login") {
      userAuth.logout()
    }

    vm.unsupportedBrowser = deviceDetector.browser == "ie"

    vm.userData = {
      "username": "",
      "password": ""
    }

    vm.login = function(userData) {
      quantumApi.login.save({"username":userData.username, "password":userData.password}).$promise
      .then(function(data) {
        $rootScope.$emit('loggedIn', true) // Starts the system status refresh interval
        if (data.logout_timeout > 0) {
          Idle.setIdle(data.logout_timeout*60)
          Idle.watch()
        } else {
          Idle.unwatch()
        }
        userAuth.data = data
        //$cookies.putObject('user', data)
        $location.path('/dashboard')
        navItems.rebuild()
      })
      .catch(function(){
        toastr.warning("Failled to Log In", "Error!")
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('FixedIntegratedDeviceController', FixedIntegratedDeviceController);

  /** @ngInject */
  function FixedIntegratedDeviceController($log, $q, quantumApi, toastr, userAuth, $filter) {
    var vm = this;
    vm.previousDevices = []

    vm.selectedDevice = null
    vm.searchFilter = ""
    vm.filteredList = null
    vm.staff = []
    vm.ladda = false

    vm.escalations = quantumApi.escalation.query()
    vm.apartments = quantumApi.apartment.query()
    vm.corridorControllers = quantumApi.corridorLightControler.query()
    vm.corridorColors = quantumApi.corridorLightColor.query()

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevDevice, nextDevice) {
      if (event.which == 38 && prevDevice) {
        event.preventDefault()
        vm.selectedDevice = prevDevice
      } else if (event.which == 40 && nextDevice) {
        event.preventDefault()
        vm.selectedDevice = nextDevice
      }
    }

    vm.getDevices = function() {
      quantumApi.integratedDevice.query(function(data){
        vm.devices = $filter('naturalSort')(data, 'name')
        vm.previousDevices = angular.copy(data)
      })
      vm.selectedDevice = null
    }

    vm.getDevices()

    vm.deviceValid = function(device) {
      var valid = true
      if (!device.name || (!device.escalations.length && device.active)) {
        valid = false
      }
      return valid
    }

    vm.devicesValid = function(){
      var val = true
      angular.forEach(vm.devices, function(device){
        if (!device.name || (!device.escalations.length && device.active)) {
          val = false
        }
      })
      // Override When in Debug Mode
      if (userAuth.data.debugMode) {
        val = true
      }
      return val
    }


    // Utility Functions
    vm.clearApt = function($event) {
      $event.stopPropagation();
      vm.selectedDevice.apartment = null;
    };

    // Number range utility. TODO: I should probably make this a filter...
    vm.range = function(low, high) {
      var range = [];
      for(var i=low; i<=high; i++) {
        range.push(i);
      }
      return range
    }

    // For setting values when the inactive button is clicked
    vm.corridorLightActive = function(subDevice, active) {
      subDevice.corridor_light.active = active
      if (!active) {
        subDevice.corridor_light.controller = null
        subDevice.corridor_light.address = null
        subDevice.corridor_light.relay = null
        subDevice.corridor_light.rate = "Constant"
      } else {
        subDevice.corridor_light.controller = vm.corridorControllers[0].id
        if (vm.interfaceType(subDevice.corridor_light.controller) == 17) {
          subDevice.corridor_light.address = 1
        } else {
          subDevice.corridor_light.address = 0
        }
        subDevice.corridor_light.relay = vm.corridorColors[0].relay
        subDevice.corridor_light.rate = "Constant"
      }
    }

    vm.interfaceType = function(selectedInterface) {
      var type = null
      angular.forEach(vm.corridorControllers, function(controller) {
        if (selectedInterface == controller.id) {
          type = controller.connection_type
        }
      })
      return type
    }

    vm.resetCorridorLight = function(subDevice) {
      if (vm.interfaceType(subDevice.corridor_light.controller) == 17) {
        subDevice.corridor_light.address = 1
        subDevice.corridor_light.relay = vm.corridorColors[0].relay
        subDevice.corridor_light.rate = "Constant"
      } else {
        subDevice.corridor_light.address = 0
        subDevice.corridor_light.relay = vm.corridorColors[0].relay
        subDevice.corridor_light.rate = "Constant"
      }
    }

    quantumApi.systemSettings.get(function(data){
      vm.maxAddress = data.max_address_value
    })

    vm.saveDevices = function(){
      vm.ladda = true
      var promises = []

      angular.forEach(vm.devices, function(device, key) {
        if (!angular.equals(device, vm.previousDevices[key])) {
          promises.push(quantumApi.integratedDevice.update({id:device.id},device).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getDevices()
        toastr.success("Devices Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Error Saving Devices", "Error!")
        vm.ladda = false
      })
    }



  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('FixedSaraDeviceChangeController', FixedSaraDeviceChangeController);

  /** @ngInject */
  function FixedSaraDeviceChangeController($log, toastr, quantumApi, $q, inovonics, userAuth) {
    var vm = this;

    vm.selectedDevice = null
    vm.previousDevices = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.ladda = false
    vm.userAuth = userAuth

    vm.escalations = quantumApi.escalation.query()
    vm.apartments = quantumApi.apartment.query()
    vm.corridorControllers = quantumApi.corridorLightControler.query()
    vm.corridorColors = quantumApi.corridorLightColor.query()

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevDevice, nextDevice) {
      if (event.which == 38 && prevDevice) {
        event.preventDefault()
        vm.selectedDevice = prevDevice
      } else if (event.which == 40 && nextDevice) {
        event.preventDefault()
        vm.selectedDevice = nextDevice
      }
    }

    vm.getDevices = function() {
      vm.devices = []
      vm.previousDevices = []
      quantumApi.quantumDevice.query(function(data){
        angular.forEach(data, function(value) {
          if (value.sara_device) {
            vm.devices.push(value)
            vm.previousDevices.push(angular.copy(value))
          }
        })
      })
      vm.selectedDevice = null
    }

    vm.getDevices()

    vm.addDevice = function() {
      vm.devices.push({
        "acg_id": null,
        "device_data": {
          "device_type":"EN1941-XS",
          "device_description":"Third Party Pull Cord (1941XS)",
          "mid":178,
          "pti":254,
          "inputs":1,
          "input_list":{"1":"Pull Cord"},
          "supervision":72000,
          "supported":true,
          "latchable":false,
          "fixed":true,
          "quantum_device_type":3
        },
        "id": null,
        "pti": 254,
        "sara_device": true,
        "serial_number": null,
        "sub_devices": [
          {
            "id": null,
            "device_id": null,
            "name": null,
            "apartment": null,
            "resident_id": null,
            "latching": false,
            "active": true,
            "escalations": [],
            "schedule_id":null,
            "input": 1,
            "input_description": "Third Party Pull Cord (1941XS)",
            "corridor_light": {
              "active":false,
              "controller":null,
              "address":null,
              "relay":1,
              "rate":'Constant'
            }
          }
        ]
      })
      vm.selectedDevice = vm.devices[vm.devices.length - 1]
    }

    vm.removeDevice = function(index, device) {
        if (angular.equals(device, vm.selectedDevice)) {
          vm.selectedDevice = null
        }
        if (device.id && device.id != 1) {
          device.deleted = true
        } else if (!device.id) {
          vm.devices.splice(index,1)
        }

    }

    // For setting values when the inactive button is clicked
    vm.corridorLightActive = function(subDevice, active) {
      subDevice.corridor_light.active = active
      if (!active) {
        subDevice.corridor_light.controller = null
        subDevice.corridor_light.address = null
        subDevice.corridor_light.relay = null
        subDevice.corridor_light.rate = "Constant"
      } else {
        subDevice.corridor_light.controller = vm.corridorControllers[0].id
        if (vm.interfaceType(subDevice.corridor_light.controller) == 17) {
          subDevice.corridor_light.address = 1
        } else {
          subDevice.corridor_light.address = 0
        }
        subDevice.corridor_light.relay = vm.corridorColors[0].relay
        subDevice.corridor_light.rate = "Constant"
      }
    }

    vm.interfaceType = function(selectedInterface) {
      var type = null
      angular.forEach(vm.corridorControllers, function(controller) {
        if (selectedInterface == controller.id) {
          type = controller.connection_type
        }
      })
      return type
    }

    vm.resetCorridorLight = function(subDevice) {
      if (vm.interfaceType(subDevice.corridor_light.controller) == 17) {
        subDevice.corridor_light.address = 1
        subDevice.corridor_light.relay = vm.corridorColors[0].relay
        subDevice.corridor_light.rate = "Constant"
      } else {
        subDevice.corridor_light.address = 0
        subDevice.corridor_light.relay = vm.corridorColors[0].relay
        subDevice.corridor_light.rate = "Constant"
      }
    }

    quantumApi.systemSettings.get(function(data){
      vm.maxAddress = data.max_address_value
    })

    // Number range utility. TODO: I should probably make this a filter...
    vm.range = function(low, high) {
      var range = [];
      for(var i=low; i<=high; i++) {
        range.push(i);
      }
      return range
    }

    vm.devicesValid = function(){
      var val = true
      angular.forEach(vm.devices, function(device){
        if (!vm.deviceValid(device)) {
          val = false
        }
      })
      return val // Fix this
    }

    vm.deviceValid = function(device) {
      return device.sub_devices[0].escalations.length && device.serial_number && device.sub_devices[0].name
    }


    // Recusivly push devices
    vm.saveDevices = function(){
      vm.ladda = true
      var deviceArray = angular.copy(vm.devices)
      var previousDeviceArray = angular.copy(vm.previousDevices)

      processDevices()

      function processDevices() {
        if (deviceArray.length) {
          // Don't allow SNs to be updated
          // Prevents the need for messing with the acg

          // Update the device
          if (deviceArray[0].acg_id && !deviceArray[0].deleted) {
            if (!angular.equals(deviceArray[0], previousDeviceArray[0])) {
              quantumApi.quantumDevice.update({id:deviceArray[0].id},deviceArray[0]).$promise
              .catch(function(err){
                $log.info(err.data)
                toastr.warning('Failed to Remove Device', 'Error!')
              })
              .finally(function(){
                // Kick it Off Again
                deviceArray.shift()
                previousDeviceArray.shift()
                processDevices()
              })
            } else {
              // No change needed
              deviceArray.shift()
              previousDeviceArray.shift()
              processDevices()
            }
          } else if (deviceArray[0].deleted) {
            // Remove device
            // ACG
            if (!userAuth.data.network_coordinator_in_use) {
              // Remove device
              inovonics.removeDevice(deviceArray[0].acg_id)
              .then(function(){
                return quantumApi.quantumDevice.delete({id:deviceArray[0].id},deviceArray[0]).$promise
              })
              .catch(function(err){
                $log.info(err.data)
                toastr.warning('Failed to Remove Device', 'Error!')
              })
              .finally(function(){
                // Kick it Off Again
                deviceArray.shift()
                previousDeviceArray.shift()
                processDevices()
              })
            } else {
              // Network Coordinator
              quantumApi.quantumDevice.delete({id:deviceArray[0].id},deviceArray[0]).$promise
              .catch(function(err){
                $log.info(err.data)
                toastr.warning('Failed to Remove Device', 'Error!')
              })
              .finally(function(){
                // Kick it Off Again
                deviceArray.shift()
                previousDeviceArray.shift()
                processDevices()
              })
            }
          } else {
            // Add New Device
            if (!userAuth.data.network_coordinator_in_use) {
              // ACG
              inovonics.writeDevice(deviceArray[0])
              .then(function(data){
                deviceArray[0].acg_id = parseInt(data.ResponseStatus.id)
              })
              .then(function(){
                return quantumApi.quantumDevice.save(deviceArray[0]).$promise
              })
              .catch(function(err){
                $log.info(err.data)
                toastr.warning('Failed to Add Device', 'Error!')
                inovonics.removeDevice(deviceArray[0].acg_id)
              })
              .finally(function(){
                // Kick it Off Again
                deviceArray.shift()
                previousDeviceArray.shift()
                processDevices()
              })
            } else {
              // Network Coordinator
              quantumApi.quantumDevice.save(deviceArray[0]).$promise
              .catch(function(err){
                $log.info(err.data)
                toastr.warning('Failed to Add Device', 'Error!')
              })
              .finally(function(){
                // Kick it Off Again
                deviceArray.shift()
                previousDeviceArray.shift()
                processDevices()
              })
            }
          }
        } else {
          // We're done here...
          vm.ladda = false
          toastr.success('Thrid Party Devices Updated', 'Success!');
          vm.getDevices()
        }

      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('FixedQuantumDeviceController', FixedQuantumDeviceController);

  /** @ngInject */
  function FixedQuantumDeviceController($log, $scope, $rootScope, $location, WizardHandler, toastr, userAuth, inovonics, quantumApi) {
    var vm = this;
    var currentStep

    vm.ladda = false

    // All the API Calls
    vm.apartments = quantumApi.apartment.query()
    vm.escalations = quantumApi.escalation.query()
    vm.corridorControllers = quantumApi.corridorLightControler.query()
    vm.corridorColors = quantumApi.corridorLightColor.query()
    vm.schedules = quantumApi.scheduleIoRepeater.query()
    // License Information
    vm.systemLicense = userAuth.data.system_license
    vm.initalLoadComplete = false


    vm.enrolledDeviceSelected = null
    vm.replacementDeviceSelected = null

    function initForm() {
        vm.enrolledDevices = []
        vm.enrollStepSubmitted = false
        vm.replacementStepSubmitted = false
        vm.enrolledDeviceSelected = null
        // Load the device list for everything but adding
        if ($location.path() != '/fixed-quantum-device-add') {
          vm.existingDevices = []
          quantumApi.quantumDevice.query(function(device){
            angular.forEach(device, function(device) {
              if (!device.sara_device) {
                vm.existingDevices.push(device)
              }
            })
            vm.initalLoadComplete = true
          })
        }
    }

    initForm()

    // Okay, lets talk about Quantum fixed devices...
    // Really, Quantum fixed devices don't exist. Only the subdevices exist. The only thing that ties them together is the ACG ID.
    // So, I guess we're going to use that as the primary key...

    // --- Inovonics Enrollment ---
    // Verify Nurse Call License Before Staring Inovonics Up
    if (vm.systemLicense.nurse_call) {
      // Listen for the registration events emitted from the inovonics service
      // Must call inovonics.openRegistration() for this to be active
      var inovonicsListener = $rootScope.$on('inovonicsRegistration', function(event, data){
        // Search for duplicate registrations
        var registeredDevices = []
        angular.forEach(vm.enrolledDevices, function(data){
          registeredDevices.push(data.serial_number)
        })

        // Verify Unique device
        if (registeredDevices.indexOf(data.serial_number) === -1) {
          // Filter by the fixed device flag
          if (data.device_data.fixed == 1) {
            data.sub_devices = []
            var count = 1
            if (data.pti != 12) {
              angular.forEach(data.device_data.input_list, function(value, key) {
                // Push the subdevices into the array
                data.sub_devices.push(
                  {
                    "id": null,
                    "device_id": null,
                    "name": (count==1 ? "" : "Inactive"),
                    "apartment": null,
                    "resident_id": null,
                    "latching": false,
                    "active": (count==1 ? true : false),
                    "escalations": [],
                    "schedule_id":null,
                    "input": parseInt(key),
                    "input_description": value,
                    "corridor_light": {
                      "active":false,
                      "controller":null,
                      "address":null,
                      "relay":1,
                      "rate":'Constant'
                    }
                  }
                )
                count++
              })
            } else {
              count = 0
              angular.forEach(data.device_data.input_list, function(value, key) {
                // Push the subdevices for the pull cord into the array
                data.sub_devices.push(
                  {
                    "id": null,
                    "device_id": null,
                    "name": "",
                    "apartment": null,
                    "resident_id": null,
                    "latching": false,
                    "active": (count == 1 ? vm.systemLicense.staff_assist : true),
                    "escalations": [],
                    "schedule_id":null,
                    "input": parseInt(key),
                    "input_description": value,
                    "corridor_light": {
                      "active":false,
                      "controller":null,
                      "address":null,
                      "relay":1,
                      "rate":'Constant'
                    }
                  }
                )
                count++
              })
            }
            // If we're using the replace device wizard, things get moved around a bit.
            // Only push into the array if the device is the same type
            var index
            if ($location.path() == '/fixed-quantum-device-replace') {
              if (currentStep == "Enroll Device" && data.pti == vm.enrolledDeviceSelected.pti) {
                index = vm.enrolledDevices.unshift(data)
                if (!vm.replacementDeviceSelected) {
                  vm.replacementDeviceSelected = vm.enrolledDevices[index - 1]
                }
              }
            } else {
              index = vm.enrolledDevices.unshift(data)
              if (!vm.enrolledDeviceSelected) {
                vm.enrolledDeviceSelected = vm.enrolledDevices[index - 1]
              }
            }
          }
          $scope.$apply()
        }
      })

      // Clean Up the connection to the acg and the event listeners on destroy
      $scope.$on('$destroy', function() {
        inovonics.closeRegistration()
        $scope.$on('$destroy', inovonicsListener())
      })

      // Start Up the Websocker
      inovonics.openRegistration()
    }

    // Detect wizard change events
    $scope.$on('wizard:stepChanged', function(event){
      // Track the Current Step (Used for Inovonics)
      currentStep = event.targetScope.selectedStep.title
    })

    // -------Helper Functions--------

    // Number range utility. TODO: I should probably make this a filter...
    vm.range = function(low, high) {
      var range = [];
      for(var i=low; i<=high; i++) {
        range.push(i);
      }
      return range
    }

    // For setting values when the inactive button is clicked
    vm.subDeviceActive = function(subDevice, active) {
      subDevice.active = active
      if (!active) {
        subDevice.name = "Inactive"
        subDevice.escalations = []
        subDevice.latching = false
        subDevice.apartment = null
      } else {
        subDevice.name = ""
      }
    }

    // For setting values when the inactive button is clicked
    vm.staffAssistActive = function(subDevice, active) {
      subDevice.active = active
      if (!active) {
        subDevice.escalations = []
      }
    }

    // For setting values when the inactive button is clicked
    vm.corridorLightActive = function(subDevice, active) {
      subDevice.corridor_light.active = active
      if (!active) {
        subDevice.corridor_light.controller = null
        subDevice.corridor_light.address = null
        subDevice.corridor_light.relay = null
        subDevice.corridor_light.rate = "Constant"
      } else {
        subDevice.corridor_light.controller = vm.corridorControllers[0].id
        if (vm.interfaceType(subDevice.corridor_light.controller) == 17) {
          subDevice.corridor_light.address = 1
        } else {
          subDevice.corridor_light.address = 0
        }
        subDevice.corridor_light.relay = vm.corridorColors[0].relay
        subDevice.corridor_light.rate = "Constant"
      }
    }

    vm.interfaceType = function(selectedInterface) {
      var type = null
      angular.forEach(vm.corridorControllers, function(controller) {
        if (selectedInterface == controller.id) {
          type = controller.connection_type
        }
      })
      return type
    }

    vm.resetCorridorLight = function(subDevice) {
      if (vm.interfaceType(subDevice.corridor_light.controller) == 17) {
        subDevice.corridor_light.address = 1
        subDevice.corridor_light.relay = vm.corridorColors[0].relay
        subDevice.corridor_light.rate = "Constant"
      } else {
        subDevice.corridor_light.address = 0
        subDevice.corridor_light.relay = vm.corridorColors[0].relay
        subDevice.corridor_light.rate = "Constant"
      }
    }

    quantumApi.systemSettings.get(function(data){
      vm.maxAddress = data.max_address_value
    })

    vm.inputsFromDevice = function(device) {
      var inputList = []
      angular.forEach(device.sub_devices, function(subDevice) {
        if (subDevice.active) {
          inputList.push(subDevice.input_description+": "+subDevice.name)
        }
      })
      return inputList.join(', ')
    }

    vm.clearApt = function($event, device) {
      $event.stopPropagation();
      angular.forEach(device.sub_devices, function(subDevice) {
        subDevice.apartment = null
      })
    }

    vm.clearEscalation = function($event, device) {
      $event.stopPropagation();
      angular.forEach(device.sub_devices, function(subDevice) {
        subDevice.supervisory_escalation = null
      })
    }

    vm.clearAptSingle = function($event, subDevice) {
      $event.stopPropagation();
      subDevice.apartment = null
    }

    vm.clearEscalationSingle = function($event, subDevice) {
      $event.stopPropagation();
      subDevice.supervisory_escalation = null
    }

    vm.clearSchedule = function($event, subDevice) {
      $event.stopPropagation();
      subDevice.schedule_id = null
    }

    // In QA, they were making UTs into Pull Cords. Thanks QA...
    // Clear out the replacement devices on selection
    vm.loadEnrolledDevice = function() {
      vm.replacementDeviceSelected = null
      vm.enrolledDevices = []
    }

	// -------Step Validation---------
    vm.enrollStepVaild = function(){
      vm.enrollStepSubmitted = true
      return (vm.enrolledDeviceSelected != null)
    }

    vm.replaceStepVaild = function(){
      vm.replacementStepSubmitted = true
      return (vm.replacementDeviceSelected != null)
    }

    vm.infoStepVaild = function(){

      var isValid = true

      if (!vm.inputsActiveValid()){
        isValid = false
      }

      // Trip Validation for Pull Cords
      if (vm.enrolledDeviceSelected.pti == 12) {
        vm.form.pullcordName.$dirty = true;
        vm.form.escalations.$dirty = true;
        if (vm.enrolledDeviceSelected.sub_devices[1].active && vm.systemLicense.staff_assist) {
          vm.form.staffEscalations.$dirty = true;
        }

        if (!vm.enrolledDeviceSelected.sub_devices[0].name || !vm.enrolledDeviceSelected.sub_devices[0].escalations.length) {
          isValid = false
        }
        if (vm.enrolledDeviceSelected.sub_devices[1].active && !vm.enrolledDeviceSelected.sub_devices[1].escalations.length && vm.systemLicense.staff_assist) {
          isValid = false
        }
      // Trip Validation for Everything Else
      } else {
        angular.forEach(vm.enrolledDeviceSelected.sub_devices, function(device, key) {
          var namefield
          var escalationfield

          if (device.active) {
            if (!device.name || !device.escalations.length) {
              isValid = false
            }
            // Set the Fields Dirty for Validation
            // This is kinda gross...
            namefield = key+"-name"
            vm.form[namefield].$dirty = true;
            escalationfield = key+"-escalation"
            vm.form[escalationfield].$dirty = true;
          }
        })
      }
      return isValid
    }


    // Check to make sure that there's at least one active input.
    vm.inputsActiveValid = function() {
      var devicesVaild = false
      if (vm.enrolledDeviceSelected) {
        angular.forEach(vm.enrolledDeviceSelected.sub_devices, function(subDevice) {
          if (subDevice.active) {
            devicesVaild = true
          }
        })
      }
      return devicesVaild
    }

    vm.submitAddWizard = function(){
      vm.ladda = true

      // ACG Codebase
      if (!userAuth.data.network_coordinator_in_use) {
        inovonics.writeDevice(vm.enrolledDeviceSelected)
        .then(function(data) {
          $log.log(vm.enrolledDeviceSelected)
          vm.enrolledDeviceSelected.acg_id = parseInt(data.ResponseStatus.id)
        })
        .then(function(){
          return quantumApi.quantumDevice.save(vm.enrolledDeviceSelected).$promise
        })
        .then(function(){
          toastr.success('Quantum Device Added', 'Success!');
        })
        .catch(function(err){
          $log.info(err.data)
          toastr.warning('Failed to Add Device', 'Error!');
          inovonics.removeDevice(vm.enrolledDeviceSelected.acg_id)
        })
        .finally(function(){
          // Reset the Form
          vm.ladda = false
          initForm()
          vm.form.$setPristine()
          WizardHandler.wizard('fixedDevice').reset()
        })
      } else {
        quantumApi.quantumDevice.save(vm.enrolledDeviceSelected).$promise
        .then(function(){
          toastr.success('Quantum Device Added', 'Success!');
        })
        .catch(function(err){
          $log.info(err.data)
          toastr.warning('Failed to Add Device', 'Error!');
        })
        .finally(function(){
          // Reset the Form
          vm.ladda = false
          initForm()
          vm.form.$setPristine()
          WizardHandler.wizard('fixedDevice').reset()
        })
      }

      // Network Corrdinator

    }

    vm.submitChangeWizard = function(){
      // Same codbase between acg and network coordinator
      vm.ladda = true
      quantumApi.quantumDevice.update({id:vm.enrolledDeviceSelected.id},vm.enrolledDeviceSelected).$promise
      .then(function(){
        toastr.success('Quantum Device Changed', 'Success!');
      })
      .catch(function(err){
        $log.info(err.data)
        toastr.warning('Failed to Change Device', 'Error!');
      })
      .finally(function(){
        // Reset the Form
        vm.ladda = false
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('fixedDevice').reset()
      })

    }

    vm.submitReplaceWizard = function(){
      vm.ladda = true
      if (!userAuth.data.network_coordinator_in_use) {
        inovonics.writeDevice(vm.replacementDeviceSelected)
        .then(function(data){
          vm.replacementDeviceSelected.acg_id = parseInt(data.ResponseStatus.id)
          return quantumApi.quantumDeviceReplace.update({id:vm.enrolledDeviceSelected.id},vm.replacementDeviceSelected).$promise
        })
        .then(function(){
          return inovonics.removeDevice(vm.enrolledDeviceSelected.acg_id)
        })
        .then(function(){
          toastr.success('Quantum Device Replaced', 'Success!');
        })
        .catch(function(err){
          $log.info(err.data)
          toastr.warning('Failed to Replace Device', 'Error!');
        })
        .finally(function(){
          // Reset the Form
          vm.ladda = false
          initForm()
          vm.form.$setPristine()
          WizardHandler.wizard('fixedDevice').reset()
        })
      } else {
        // Network coordinator
        // As there is no "New" ACG_ID with network coordinator devices, we'll use the old one as generated by the system
        vm.replacementDeviceSelected.acg_id = vm.enrolledDeviceSelected.acg_id
        quantumApi.quantumDeviceReplace.update({id:vm.enrolledDeviceSelected.id},vm.replacementDeviceSelected).$promise
        .then(function(){
          toastr.success('Quantum Device Replaced', 'Success!');
        })
        .catch(function(err){
          $log.info(err.data)
          toastr.warning('Failed to Replace Device', 'Error!');
        })
        .finally(function(){
          // Reset the Form
          vm.ladda = false
          initForm()
          vm.form.$setPristine()
          WizardHandler.wizard('fixedDevice').reset()
        })
      }

    }

    vm.submitRemoveWizard = function(){
      vm.ladda = true
      if (!userAuth.data.network_coordinator_in_use) {
        inovonics.removeDevice(vm.enrolledDeviceSelected.acg_id)
        .then(function(){
          return quantumApi.quantumDevice.delete({id:vm.enrolledDeviceSelected.id}).$promise
        })
        .then(function(){
          toastr.success('Quantum Device Removed', 'Success!');
        })
        .catch(function(err){
          $log.info(err.data)
          // Remove it from Quantum even if it's not in acg
          toastr.warning('Failed to Remove Device', 'Error!');
        })
        .finally(function(){
          // Reset the Form
          vm.ladda = false
          initForm()
          vm.form.$setPristine()
          WizardHandler.wizard('fixedDevice').reset()
        })
      } else {
        quantumApi.quantumDevice.delete({id:vm.enrolledDeviceSelected.id}).$promise
        .then(function(){
          toastr.success('Quantum Device Removed', 'Success!');
        })
        .catch(function(err){
          $log.info(err.data)
          // Remove it from Quantum even if it's not in acg
          toastr.warning('Failed to Remove Device', 'Error!');
        })
        .finally(function(){
          // Reset the Form
          vm.ladda = false
          initForm()
          vm.form.$setPristine()
          WizardHandler.wizard('fixedDevice').reset()
        })
      }

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('FamilyController', FamilyController);

  /** @ngInject */
  function FamilyController($scope, $rootScope, $log, WizardHandler, toastr, quantumApi, moment, systemStatus, $location, userAuth) {
    var vm = this;

    vm.userAuth = userAuth

    vm.systemLicense = userAuth.data.system_license

    vm.systemStatus = systemStatus
    var curTime = moment.utc(vm.systemStatus.data.server_time)
    var keycardEnrolled = []
    var keypadEnrolled = []
    var rawCardEnrolled = []
    vm.selector = null
    vm.accessExpiration = false
    vm.familyMember = []
    vm.selectStepSubmitted = false
    vm.initalLoadComplete = false

    vm.residents = quantumApi.resident.query()
    vm.allegionAccessGroups = quantumApi.allegionAccessGroup.query()

    // Password Reset Options
    vm.passwordOptions = [{
      "label":"Keep Current Password",
      "value":false
    },{
      "label":"Reset Password",
      "value":true
    }]

    vm.resetPassword = false
    vm.passwordResetChange = function(value) {
      if (!value) {
        vm.formData.password = null
      }
    }

    // This flipping date picker...
    var rounding = 5 * 60 * 1000;
    vm.offset = "-0"+Math.abs(vm.systemStatus.data.offset)+"00"

    vm.datepickerOptions = {
      autoApply: true,
      opens: 'embed',
      timePicker: true,
      timePickerIncrement: 5,
      format: 'MM/DD/YYYY h:mm A',
      minDate: moment(Math.ceil((+moment(curTime.zone(vm.offset))) / rounding) * rounding),
      validationOptions: {
        interval: 1,
        unit: "hours",
        message: "End Date Must be at Least 1 Hour After Start Date"
      }
    }

    vm.scheduleChange = function() {
      if (vm.date && vm.accessExpiration) {
        vm.formData.start_date = vm.date.startDate,
        vm.formData.end_date = vm.date.endDate
      } else {
        vm.formData.start_date = null,
        vm.formData.end_date = null
      }
    }
    // End Datepicker

    vm.familyMemberAccessGroups = quantumApi.staffAccessGroup.query()
    vm.doorAccessGroups = quantumApi.doorAccessGroup.query()
    vm.doorAccessSchedules = quantumApi.scheduleWeeklyStaff.query()

    function initForm() {
      vm.selectStepSubmitted = false
      vm.selector = false
      vm.resetPassword = false
      // Get the familyMember and the enrolled keycards
      vm.familyMember = quantumApi.family.query(function(){
        vm.initalLoadComplete = true
      })

      quantumApi.staff.usedCodes(function(data){
        keycardEnrolled = data.used_wiegand
        keypadEnrolled = data.used_keypad_codes
        rawCardEnrolled = data.used_raw_codes
      })

      vm.date = {
        endDate: moment(Math.ceil((+moment(curTime.zone(vm.offset))) / rounding) * rounding).zone(vm.offset).add(1,'h'),
        startDate: moment(Math.ceil((+moment(curTime.zone(vm.offset))) / rounding) * rounding).zone(vm.offset)
      }

      vm.formData =   {
        "id": null,
        "first_name": null,
        "last_name": null,
        "email": null,
        "keycard": null,
        "keypad": null,
        "raw_card_data":null,
        "start_date": null,
        "end_date": null,
        "door_access_level":1,
        "last_location_id": null,
        "last_location_name": null,
        "location_time": "2016-11-10T18:01:38+00:00",
        "door_groups": [],
        "schedules": [],
        "allegion_door_groups": [],
        "associated_residents": [],
        "resident_bypass_allowed": false
      }
    }

    initForm()


  vm.loadFamilyMemberEvent = function(familyMember) {
    angular.copy(vm.selector, vm.formData)
    if (familyMember.start_date) {
      vm.accessExpiration = true
      vm.date = {
        endDate: familyMember.end_date,
        startDate: familyMember.start_date
      }
    } else {
      vm.accessExpiration = false
    }
  }

  // Raw Card Info
  // Listeer for raw card data coming from enrollment station with card reader
  // Comes from the websocket initiate in the system status service
  var cardDataListener = $rootScope.$on('cardEnrollData', function(event, data){
    if (vm.formData.door_access_level != 0) {
      vm.formData.raw_card_data = data
      vm.form.rawcard.$dirty = true;
    }
  })

  // Clean Up the connection to the acg and the event listeners on destroy
  $scope.$on('$destroy', function() {
    $scope.$on('$destroy', cardDataListener())
  })

    // Step Validation
    vm.stepUserValid = function(){
      vm.form.first_name.$dirty = true;
      vm.form.last_name.$dirty = true;
      vm.form.associated_residents.$dirty = true;
      return vm.form.first_name.$valid && vm.form.last_name.$valid && vm.form.associated_residents.$valid
    }


    vm.stepDoorValid = function(){
      if (vm.formData.door_access_level == 0) {
        return true
      } else {
        vm.form.keycard.$dirty = true;
        vm.form.keypad.$dirty = true;
        vm.form.rawcard.$dirty = true;
        vm.form.door_access_groups.$dirty = true;
        vm.form.door_access_schedules.$dirty = true;
        return vm.form.keycard.$valid && vm.form.keypad.$valid && vm.form.rawcard.$valid && vm.form.door_access_groups.$valid && vm.validateDoorSchedule()
      }
    }

    vm.stepSelectValid = function() {
      vm.selectStepSubmitted = true
      return vm.selector != false
    }



    // Door Validation

    vm.validateKeycard = function(keycard) {
      if (!keycard && keycard != 0) {
        if (vm.formData.keycard || vm.formData.keypad || vm.formData.raw_card_data) {
          return true
        } else {
          return false
        }
      } else if (keycardEnrolled.indexOf(keycard) != -1 && keycard != vm.selector.keycard) {
        return false
      } else if (keycard < 10000 || keycard > 65535) {
        return false
      }
      else {
        return true
      }
    }

    vm.validateKeycardMsg = function(keycard) {
      if (!keycard && keycard != 0) {
        return "Keycard or Keypad Code Required"
      } else if (keycardEnrolled.indexOf(keycard) != -1) {
        return "Keycard Already Exists"
      } else if (!keycard < 10000 || !keycard > 65535) {
        return "Keycard Must be Between 10000 and 65534"
      }
      return true
    }

    vm.validateKeypad = function(keypad) {
      if (!keypad && keypad != 0) {
        if (vm.formData.keycard || vm.formData.keypad || vm.formData.raw_card_data) {
          return true
        } else {
          return false
        }
      } else if (keypadEnrolled.indexOf(keypad) != -1 && keypad != vm.selector.keypad) {
        return false
      } else if (keypad < 1000 || keypad > 9999) {
        return false
      }
      else {
        return true
      }
    }

    vm.validateKeypadMsg = function(keypad) {
      if (!keypad && keypad != 0) {
        return "Keycard or Keypad Code Required"
      } else if (keypadEnrolled.indexOf(keypad) != -1) {
        return "Keypad Code Already Enrolled"
      } else if (!keypad < 1000 || !keypad > 9999) {
        return "Keypad Code Must be Between 1000 and 9999"
      }
    }

    vm.validateRawCard = function(enrolled) {
      if (!enrolled) {
        if (vm.formData.keycard || vm.formData.keypad || vm.formData.raw_card_data) {
          return true
        } else {
          return false
        }
      } else if (rawCardEnrolled.indexOf(enrolled) != -1 && enrolled != vm.selector.raw_card_data) {
        return false
      }
      else {
        return true
      }
    }

    vm.validateRawCardMsg = function(keypad) {
      if (!keypad) {
        return "Keycard or Keypad Code Required"
      } else if (rawCardEnrolled.indexOf(keypad) != -1) {
        return "Keypad Code Already Enrolled"
      }
    }

    vm.validateDoorSchedule = function() {
      if (userAuth.data.system_license.allegion_active && vm.formData.door_groups.length) {
        return vm.formData.schedules.length > 0
      } else if (!userAuth.data.system_license.allegion_active) {
        return vm.formData.schedules.length > 0
      } else {
        return true
      }
    }

    vm.submitCreate = function(){
      // HTTP Request Goes Here
      quantumApi.family.save(vm.formData).$promise
      .then(function(){
        toastr.success('Family Member Created', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Create Family Member', 'Error!')
      })
      .finally(function(){
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('familyMemberCreate').reset()
      })
    }

    vm.submitChange = function(){
      // HTTP Request Goes Here
      quantumApi.family.update({id: vm.formData.id},vm.formData).$promise
      .then(function(){
        toastr.success('Family Member Changed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Change Family Member', 'Error!')
      })
      .finally(function(){
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('familyMemberChange').reset()
      })
    }

    vm.submitRemove= function(){
      // HTTP Request Goes Here
      quantumApi.family.remove({id: vm.formData.id}).$promise
      .then(function(){
        toastr.success('Family Member Removed', 'Success!')
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning('Failed to Remove Family Member', 'Error!')
      })
      .finally(function(){
        initForm()
        vm.form.$setPristine()
        WizardHandler.wizard('familyMemberRemove').reset()
      })
    }

  }
})();

(function() {
  'use strict';
  angular
    .module('quantumUiAngular')
    .controller('DoorStatusAllegionController', DoorStatusAllegionController);

  /** @ngInject */
  function DoorStatusAllegionController($interval, $scope, $log, quantumApi, $rootScope) {
    var vm = this;

    vm.lockedLadda = false
    vm.unlockedLadda = false
    vm.momentaryLadda = false

    function getDoorStatus(websocket) {
      if (websocket) {
        vm.lockedLadda = false
        vm.unlockedLadda = false
        vm.momentaryLadda = false
      }

      quantumApi.allegionLock.query(function(data){
        vm.doorData = data
      })
    }

    var eventListener = $rootScope.$on('requestReply', function(){
      getDoorStatus(true)
    })

    // When navigating away, cancel the intercal
    $scope.$on('$destroy', function () {
      eventListener()
    });

    //Inital Load
    getDoorStatus()

    // Interval for fetching Door Status. We'll use websockets someday...
    vm.refreshInterval = $interval(getDoorStatus, 3000)


    vm.overrideLocked = function(door) {
      vm.lockedLadda = true
      var eventObj = {
        "hw_id": door.id,
        "event_code":"LLC",
        "staff_id":null,
        "resident_id":null,
        "payload":{"over_ride":false, "duration":0,"gateway_id":door.gateway_id,"link_id":door.link_id}
      }
      quantumApi.events.save(eventObj).$promise
      .then(function(data){
        vm.pendingAddRequestId = data.id
      })
    }

    vm.overrideUnlocked = function(door) {
      vm.unlockedLadda = true
      var eventObj = {
        "hw_id": door.id,
        "event_code":"LLC",
        "staff_id":null,
        "resident_id":null,
        "payload":{"over_ride":true, "duration":0,"gateway_id":door.gateway_id,"link_id":door.link_id}
      }
      quantumApi.events.save(eventObj).$promise
      .then(function(data){
        vm.pendingAddRequestId = data.id
      })
    }

    // Door Override Functions
    vm.overrideMomentary = function(door) {
      vm.momentaryLadda = true
      var eventObj = {
        "hw_id": door.id,
        "event_code":"LLC",
        "staff_id":null,
        "resident_id":null,
        "payload":{"over_ride":true, "duration":10,"gateway_id":door.gateway_id,"link_id":door.link_id}
      }
      quantumApi.events.save(eventObj).$promise
      .then(function(data){
        vm.pendingAddRequestId = data.id
      })
    }

    // When navigating away, cancel the intercal
    $scope.$on('$destroy', function () { $interval.cancel(vm.refreshInterval); });

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('FixedDeviceController', FixedDeviceController);

  /** @ngInject */
  function FixedDeviceController($q, $scope, $interval, quantumApi, inovonics, $filter) {
    var vm = this;

    //Track for Changes
    var previousQuantumDevices = []
    var previousIntegratedDevices = []
    var previousIODevices = []
    var changesMade = false

    vm.searchFilter = ""
    vm.orderByKey = "name"
    vm.orderReverse = false
    vm.initalLoadComplete = false

    vm.fixedDevices = []

    vm.apartments = quantumApi.apartment.query()

    // Load schedules and then kick it off
    quantumApi.scheduleIoRepeater.query(function(data){
      vm.schedules = data
    }).$promise
    .then(function(){
      return quantumApi.scheduleCheckIn.query(function(data){ vm.checkInSchedules = data }).$promise
    })
    .then(function(){
      getDeviceStatus()
    })

    vm.findById = function(id, array) {
      var objectToReturn
      angular.forEach(array, function(value) {
        if (value.id == id) {
          objectToReturn = value
        }
      })
      return objectToReturn
    }

    function getDeviceStatus(){
      var promises = []
      // Quantum Devices
      var fixedDevicesRefresh = []
      promises.push(
        quantumApi.quantumDevice.query(function(data){

          if (!angular.equals(data, previousQuantumDevices)) {
            changesMade = true
          }

          angular.copy(data, previousQuantumDevices)

          angular.forEach(data, function(device){
            angular.forEach(device.sub_devices, function(subDevice){
              if (subDevice.active) {
                var deviceIndex = fixedDevicesRefresh.push(subDevice)
                fixedDevicesRefresh[deviceIndex - 1].serial_number = device.serial_number
                fixedDevicesRefresh[deviceIndex - 1].input = inovonics.inovonics_pti[device.pti].input_list[subDevice.input]
                fixedDevicesRefresh[deviceIndex - 1].type = (device.sara_device ? "Third Party Pull Cord":"Quantum")
                fixedDevicesRefresh[deviceIndex - 1].schedule = (subDevice.schedule_id ? vm.findById(subDevice.schedule_id,vm.schedules).name:"None")
                fixedDevicesRefresh[deviceIndex - 1].low_battery = subDevice.low_battery
                fixedDevicesRefresh[deviceIndex - 1].missing = subDevice.missing
              }
            })
          })
        }).$promise
      )

      promises.push(
        quantumApi.integratedDevice.query(function(data){

          if (!angular.equals(data, previousIntegratedDevices)) {
            changesMade = true
          }
          angular.copy(data, previousIntegratedDevices)

          angular.forEach(data, function(device) {
            if (device.active) {
              var deviceIndex = fixedDevicesRefresh.push(device)
              fixedDevicesRefresh[deviceIndex - 1].input = "Integrated Input"
              fixedDevicesRefresh[deviceIndex - 1].type = "Integrated"
              fixedDevicesRefresh[deviceIndex - 1].serial_number = device.device_id
              fixedDevicesRefresh[deviceIndex - 1].schedule = "None"
            }
          })
        }).$promise
      )

      promises.push(
        quantumApi.ioRepeater.query({'id':'status'}, function(data){
          if (!angular.equals(data, previousIODevices)) {
            changesMade = true
          }
          angular.copy(data, previousIODevices)
          angular.forEach(data, function(device) {
            var deviceIndex = fixedDevicesRefresh.push(device)
            fixedDevicesRefresh[deviceIndex - 1].input = device.input
            fixedDevicesRefresh[deviceIndex - 1].type = "IO Repeater"
            fixedDevicesRefresh[deviceIndex - 1].serial_number = device.device_id
            fixedDevicesRefresh[deviceIndex - 1].schedule = device.input_type == 2 ? (device.schedule_id ? vm.findById(device.schedule_id,vm.checkInSchedules).name:"None") : (device.schedule_id ? vm.findById(device.schedule_id,vm.schedules).name:"None")
          })
        }).$promise
      )

      $q.all(promises).then(function() {
        // Do the naturalSort Here to prevent performance issues on large arrays
        if (changesMade) {
          vm.fixedDevices = $filter('naturalSort')(fixedDevicesRefresh, vm.orderByKey)
        }
        vm.initalLoadComplete = true
        changesMade = false
      })
    }

    vm.resort = function() {
      vm.fixedDevices = $filter('naturalSort')(vm.fixedDevices, vm.orderByKey)
    }


    // Interval for fetching Resident Status. We'll use websockets someday...
    vm.refreshInterval = $interval(getDeviceStatus, 4000)

    // Site name for csv filename
    quantumApi.siteInfo.get(function(data){
      vm.siteName = data.name.replace(/\s+/g, '_')
    })

    vm.cleanCsv = function() {
      var results = []

      angular.forEach(vm.fixedDevices, function(device) {
        var deviceObj = {
          device_name: device.name,
          device_serial_number: device.serial_number,
          device_apartment: device.apartment,
          device_missing: device.missing ? "Missing":"Ok",
          device_low_battery:device.low_battery ? "Low":"Ok",
          device_input:device.input,
          device_type:device.type,
          device_schedule:device.schedule ? device.schedule : "None"
        }
        results.push(deviceObj)
      })

      return results
    }

    vm.csvHeaders = ["Name", "Serial Number", "Apartment", "Missing", "Low Battery", "Input", "Type", "Schedule"]


    // When navigating away, cancel the intercal
    $scope.$on('$destroy', function () { $interval.cancel(vm.refreshInterval); });

  }
})();

(function() {
  'use strict';
  angular
    .module('quantumUiAngular')
    .controller('DoorStatusController', DoorStatusController);

  /** @ngInject */
  function DoorStatusController($interval, $scope, $log, quantumApi) {
    var vm = this;

    function getDoorStatus() {
      quantumApi.door.query(function(data){
        vm.doorData = data
      })
    }

    //Inital Load
    getDoorStatus()

    // Interval for fetching Door Status. We'll use websockets someday...
    vm.refreshInterval = $interval(getDoorStatus, 1000)

    // Door Override Functions
    vm.overrideOff = function(door_id) {
      quantumApi.door.override({id:door_id, override:0}, function(){
        getDoorStatus()
      });
    }

    vm.overrideLocked = function(door_id) {
      quantumApi.door.override({id:door_id, override:1}, function(){
        getDoorStatus()
      });
    }

    vm.overrideUnlocked = function(door_id) {
      quantumApi.door.override({id:door_id, override:2}, function(){
        getDoorStatus()
      });
    }

    // When navigating away, cancel the intercal
    $scope.$on('$destroy', function () { $interval.cancel(vm.refreshInterval); });

  }
})();

(function() {
  'use strict';
  angular
    .module('quantumUiAngular')
    .controller('DoorAccessAllegionController', DoorAccessAllegionController);

  /** @ngInject */
  function DoorAccessAllegionController($log, $timeout, WizardHandler, toastr, quantumApi) {
    var vm = this;

    function initForm() {
      // Pull Data from the API
      vm.doorData = quantumApi.allegionLock.query()
      vm.existingDoorAccess = quantumApi.allegionAccessGroup.query()
      // Init the Ladda
      vm.laddaEnabled = false
      // Init the Radio Buttons
      vm.selector = false
      // Default Form Data
      vm.formData = {
        "name":"",
        "doors_in_group":false
      }
      if (vm.form){
        vm.form.$setPristine()
        WizardHandler.wizard('accessGroup').reset()
      }
    }

    initForm()

    // Load Data from Selection Page
    vm.loadSelectedData = function(selectedOption) {
      vm.formData = selectedOption
    }

    // Step Validation
    vm.stepSelectValid = function(){
      vm.form.group_selector.$dirty = true;
      return (!vm.selector == false)
    }

    // Step Validation
    vm.stepInfoValid = function(){
      vm.form.name.$dirty = true;
      vm.form.doors_in_group.$dirty = true;
      return vm.form.name.$valid && vm.form.doors_in_group.$valid
    }

    // Submit Form
    vm.submitWizardCreate = function(){
      // HTTP Request Goes Here
      vm.laddaEnabled = true
      quantumApi.allegionAccessGroup.save(vm.formData, function(){
        toastr.success('Door Group Created', 'Success!');
        initForm()
      }, function(response){
        // Error Status Returned from the Server
        angular.forEach(response.data.errors, function(value) {
          $log.info(value.message + " " + value.property)
        })
        toastr.warning('Unable to Create Door Group', 'Error!');
        initForm()
      })
    }

    vm.submitWizardChange = function(){
      vm.laddaEnabled = true
      quantumApi.allegionAccessGroup.update({id: vm.formData.id}, vm.formData, function() {
        toastr.success('Door Group Change', 'Success!');
        initForm()
      }, function(response){
        // Error Status Returned from the Server
        angular.forEach(response.data.errors, function(value) {
          $log.info(value.message + " " + value.property)
        })
        toastr.warning('Unable to Change Door Group', 'Error!');
        initForm()
      })
    }

    vm.submitWizardRemove = function(){
      vm.laddaEnabled = true
      quantumApi.allegionAccessGroup.remove({id: vm.formData.id}, function() {
        toastr.success('Door Group Removed', 'Success!');
        initForm()
      }, function(response){
        // Error Status Returned from the Server
        angular.forEach(response.data.errors, function(value) {
          $log.info(value.message + " " + value.property)
        })
        toastr.warning('Unable to Remove Door Group', 'Error!');
        initForm()
      })
    }

  }
})();

(function() {
  'use strict';
  angular
    .module('quantumUiAngular')
    .controller('DoorAccessController', DoorAccessController);

  /** @ngInject */
  function DoorAccessController($log, $timeout, WizardHandler, toastr, quantumApi) {
    var vm = this;

    function initForm() {
      // Pull Data from the API
      vm.doorData = quantumApi.door.query()
      vm.existingDoorAccess = quantumApi.doorAccessGroup.query()
      // Init the Ladda
      vm.laddaEnabled = false
      // Init the Radio Buttons
      vm.selector = false
      // Default Form Data
      vm.formData = {
        "name":"",
        "doors_in_group":false
      }
      if (vm.form){
        vm.form.$setPristine()
        WizardHandler.wizard('accessGroup').reset()
      }
    }

    initForm()

    // Load Data from Selection Page
    vm.loadSelectedData = function(selectedOption) {
      vm.formData = selectedOption
    }

    // Step Validation
    vm.stepSelectValid = function(){
      vm.form.group_selector.$dirty = true;
      return (!vm.selector == false)
    }

    // Step Validation
    vm.stepInfoValid = function(){
      vm.form.name.$dirty = true;
      vm.form.doors_in_group.$dirty = true;
      return vm.form.name.$valid && vm.form.doors_in_group.$valid
    }

    // Submit Form
    vm.submitWizardCreate = function(){
      // HTTP Request Goes Here
      vm.laddaEnabled = true
      quantumApi.doorAccessGroup.save(vm.formData, function(){
        toastr.success('Door Group Created', 'Success!');
        initForm()
      }, function(response){
        // Error Status Returned from the Server
        angular.forEach(response.data.errors, function(value) {
          $log.info(value.message + " " + value.property)
        })
        toastr.warning('Unable to Create Door Group', 'Error!');
        initForm()
      })
    }

    vm.submitWizardChange = function(){
      vm.laddaEnabled = true
      quantumApi.doorAccessGroup.update({id: vm.formData.id}, vm.formData, function() {
        toastr.success('Door Group Change', 'Success!');
        initForm()
      }, function(response){
        // Error Status Returned from the Server
        angular.forEach(response.data.errors, function(value) {
          $log.info(value.message + " " + value.property)
        })
        toastr.warning('Unable to Change Door Group', 'Error!');
        initForm()
      })
    }

    vm.submitWizardRemove = function(){
      vm.laddaEnabled = true
      quantumApi.doorAccessGroup.remove({id: vm.formData.id}, function() {
        toastr.success('Door Group Removed', 'Success!');
        initForm()
      }, function(response){
        // Error Status Returned from the Server
        angular.forEach(response.data.errors, function(value) {
          $log.info(value.message + " " + value.property)
        })
        toastr.warning('Unable to Remove Door Group', 'Error!');
        initForm()
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('DisplayEulaController', DisplayEulaController);

  /** @ngInject */
  function DisplayEulaController() {
    //var vm = this;
  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('DashboardController', DashboardController);

  /** @ngInject */
  function DashboardController(systemStatus) {
    var vm = this;

    vm.systemStatus = systemStatus
  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminSaraPullcordImportController', AdminSaraPullcordImportController);

  /** @ngInject */
  function AdminSaraPullcordImportController($log, $scope, quantumApi, $rootScope, $filter, inovonics, $uibModal, userAuth) {
    var vm = this;

    vm.userAuth = userAuth

    vm.apartments = quantumApi.apartment.query()

    vm.submitting = false
    vm.escalations = quantumApi.escalation.query(function(data){
      vm.escalationIds = []
      angular.forEach(data, function(value) {
        vm.escalationIds.push(value.id)
      })
    }
    )
    vm.results = []
    vm.existingSerials = []

    vm.reset = function(){
      $rootScope.$broadcast('resetCsv',{});
      vm.results = []
    }

    // Verify Pullcord  Not Already Enrolled
    quantumApi.quantumDevice.query(function(data){
      angular.forEach(data, function(value) {
        vm.existingSerials.push(value.serial_number)
      })
    })

    vm.serialUnique = function(serialNumber) {
      return vm.existingSerials.indexOf(parseInt(serialNumber)) == -1
    }

    // Auto Apt Assign

    // Delete Modal Setup
    vm.autoAssignWarning = function(){
      vm.assignModalInstance = $uibModal.open({
          templateUrl: 'confirmModal.html',
          scope: $scope,
          size: 'md'
      });
    }

    vm.autoAssign = function(){
      angular.forEach(vm.csvResult, function(pullcord) {
        var pullcordName = pullcord.device_name.replace(/[^0-9]/g,'')
        angular.forEach(vm.apartments, function(apartment) {
          var aptName = apartment.name.replace(/[^0-9]/g,'')
          if (aptName == pullcordName) {
            pullcord.apt_id = apartment.id
          }
        })
      })
      vm.assignModalInstance.dismiss();
    }

    // Utility Functions
    vm.clearApt = function(item, $event) {
      item.apt_id = null;
      $event.stopPropagation();
    };

    // Validators
    vm.importValid = function() {
      var valid = true
      angular.forEach(vm.csvResult, function(row) {
        if (!vm.rowValid(row)) {
          valid = false
        }
      })

      return valid
    }

    vm.rowValid = function(row) {
      return row.serial_number && row.device_name && row.escalation_id && vm.serialUnique(row.serial_number) && (vm.escalationIds.indexOf(parseInt(row.escalation_id)) != -1)
    }

    // Submit Funciton
    vm.saveApartment = function() {
      // Build the array to submit (Make it API Friednly)
      var entryArray = []
      angular.forEach(vm.csvResult, function(pullcord) {

        var submitObject ={
          "acg_id": null,
          "device_data": {
            "device_type":"EN1941-XS",
            "device_description":"Third Party Pull Cord (1941XS)",
            "mid":178,
            "pti":254,
            "inputs":1,
            "input_list":{"1":"Pull Cord"},
            "supervision":72000,
            "supported":true,
            "latchable":false,
            "fixed":true,
            "quantum_device_type":3
          },
          "id": null,
          "pti": 254,
          "sara_device": true,
          "serial_number": parseInt(pullcord.serial_number),
          "sub_devices": [
            {
              "id": null,
              "device_id": null,
              "name": pullcord.device_name,
              "apartment": pullcord.apt_id ? pullcord.apt_id : null,
              "resident_id": null,
              "latching": false,
              "active": true,
              "escalations": [parseInt(pullcord.escalation_id)],
              "schedule_id":null,
              "input": 1,
              "input_description": "Third Party Pull Cord (1941XS)",
              "corridor_light": {
                "active":false,
                "controller":null,
                "address":null,
                "relay":1,
                "rate":'Constant'
              }
            }
          ]
        }

        entryArray.push(submitObject)
      })

      // So, I don't want to just blast all of this to the server and hope for the best
      // Let's handle it a little more sequentially

      vm.submitting = true
      var writeToApi = function() {
        if (entryArray.length) {
          if (!userAuth.data.network_coordinator_in_use) {
            // ACG
            inovonics.writeDevice(entryArray[0])
            .then(function(data){
              entryArray[0].acg_id = parseInt(data.ResponseStatus.id)
              return quantumApi.quantumDevice.save(entryArray[0]).$promise
            })
            .then(function(){
              vm.results.push({"pullcord":entryArray[0].sub_devices[0].name, "result":"Success"})
            })
            .catch(function(err){
              $log.info(err)
              try {
                vm.results.push({"pullcord":entryArray[0].sub_devices[0].name, "result":"Failed: " + err.data.errors[0].message})
              } catch(err) {
                vm.results.push({"pullcord":entryArray[0].sub_devices[0].name, "result":"Failed: " + err})
              }
              if (entryArray[0].acg_id) {
                inovonics.removeDevice(entryArray[0].acg_id)
              }
            })
            .finally(function(){
              entryArray.shift()
              // Loop back to the top
              writeToApi()
            })
          } else {
            // Network Coordinator
            quantumApi.quantumDevice.save(entryArray[0]).$promise
            .then(function(){
              vm.results.push({"pullcord":entryArray[0].sub_devices[0].name, "result":"Success"})
            })
            .catch(function(err){
              $log.info(err)
              try {
                vm.results.push({"pullcord":entryArray[0].sub_devices[0].name, "result":"Failed: " + err.data.errors[0].message})
              } catch(err) {
                vm.results.push({"pullcord":entryArray[0].sub_devices[0].name, "result":"Failed: " + err})
              }
              if (entryArray[0].acg_id) {
                inovonics.removeDevice(entryArray[0].acg_id)
              }
            })
            .finally(function(){
              entryArray.shift()
              // Loop back to the top
              writeToApi()
            })
          }
        } else {
          vm.submitting = false
        }
      }

      writeToApi()

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminSystemSetupController', AdminSystemSetupController);

  /** @ngInject */
  function AdminSystemSetupController($filter, userAuth) {
    var vm = this;

    vm.setupData = []

    // System
    if (userAuth.data.access_level.system_config) {
      vm.setupData.push({
        header: "System",
        icon: "fa-wrench",
        items: [
          {
            title: "System & Site Configuration",
            link: "admin-system-config",
            keywords: ["Wiegand", "ACG", "License", "Site", "House", "Mobile", "Global", "NOC", "Broadcast"]
          },
          {
            title: "Staff UI Access Groups",
            link: "admin-staff-access-group",
            keywords: ["Permissions"]
          },
          {
            title: "Integration Input Interfaces",
            link: "admin-input-interface",
            keywords: []
          },
          {
            title: "Quantum Upgrade Manager",
            link: "admin-quantum-upgrade-manager",
            keywords: ["Hardware"]
          },
          {
            title: "Map Configuration",
            link: "admin-map-config",
            keywords: []
          }
        ]
      })
    }

    // Imports and Utilities
    if (userAuth.data.access_level.system_config) {
      vm.setupData.push({
        header: "Imports & Utilities",
        icon: "fa-download",
        items: [
          {
            title: "Staff Credential Import",
            link: "admin-staff-import",
            keywords: ["Keycard", "Keypad"]
          },
          {
            title: "Apartment/Resident Import",
            link: "admin-resident-import",
            keywords: ["Nurse Call"]
          },
          {
            title: "Pull Cord Utility",
            link: "admin-pullcord-utility",
            keywords: ["Nurse Call"]
          },
          {
            title: "Third Party Pull Cord Import",
            link: "admin-third-party-pullcord-import",
            keywords: ["Nurse Call", "Integration"]
          },
          {
            title: "Inovonics Location Utility",
            link: "admin-inovonics-location-utility",
            keywords: ["Nurse Call"]
          }
        ]
      })
    }

    // Hardware Configuration
    if (userAuth.data.access_level.system_config) {
      vm.setupData.push({
        header: "Hardware Configuration",
        icon: "fa-lock",
        items: [
          {
            title: "Door Configuration",
            link: "admin-door-config",
            keywords: []
          },
          {
            title: "Enrollment Station Configuration",
            link: "admin-enrollment-station-config",
            keywords: []
          },
          {
            title: "I/O Repeater Configuration",
            link: "admin-io-repeater-config",
            keywords: []
          },
          {
            title: "System Monitor Configuration",
            link: "admin-system-monitor-config",
            keywords: []
          },
          {
            title: "Inovonics Repeater Configuration",
            link: "admin-inovonics-repeater-config",
            keywords: ["Nurse Call"]
          }
          // Bridge Config for 6.5
          // {
          //   title: "Bridge Configuration",
          //   link: "admin-bridge-config",
          //   keywords: ["WiFi", "BLE"]
          // }
        ]
      })
    }

    var hardwareConfig

    // Hardware Configuration
    if (userAuth.data.access_level.system_config || userAuth.data.access_level.operator_admin) {
      hardwareConfig = vm.setupData.push({
        header: "Alerting",
        icon: "fa-bell",
        items: []
      })
    }

    if (userAuth.data.access_level.system_config) {
      vm.setupData[hardwareConfig - 1].items.push({
        title: "Output Notification Interfaces",
        link: "admin-output-interface",
        hardware: ["Paging", "Email", "mobile"]
      })
    }

    if (userAuth.data.access_level.system_config || userAuth.data.access_level.operator_admin) {
      vm.setupData[hardwareConfig - 1].items.push({
          title: "Alert Devices",
          link: "admin-alert-device",
          hardware: ["Paging", "Email", "mobile"]
        },
        {
          title: "Escalations",
          link: "admin-escalation-config",
          hardware: ["Paging", "Email", "mobile"]
      })
    }

    if (userAuth.data.access_level.system_config) {
      vm.setupData[hardwareConfig - 1].items.push({
          title: "Hardware Escalation Groups",
          link: "admin-hardware-escalation-group",
          hardware: ["Door"]
        },
        {
          title: "Event Message Configuration",
          link: "admin-event-message-config",
          hardware: []
      })
    }

    var caresConfig
    // Hardware Configuration
    if ((userAuth.data.access_level.system_config || userAuth.data.access_level.operator_admin) && userAuth.data.system_license.care_package) {
      caresConfig = vm.setupData.push({
        header: "Cares",
        icon: "fa-medkit",
        items: []
      })
    }

    if ((userAuth.data.access_level.system_config || userAuth.data.access_level.operator_admin) && userAuth.data.system_license.care_package) {
      vm.setupData[caresConfig - 1].items.push(
        {
          title: "Available Cares",
          link: "admin-care-config",
          hardware: ["mobile", "cares", "reporting"]
        },
        {
          title: "Care Levels",
          link: "admin-care-level",
          hardware: ["mobile", "cares", "reporting"]
        },
        {
            title: "Care Plans",
            link: "admin-care-plan",
            hardware: ["mobile", "cares", "reporting"]
        }
      )
    }

    var allegionConfig
    // Hardware Configuration
    if (userAuth.data.access_level.system_config && userAuth.data.system_license.allegion_active) {
      allegionConfig = vm.setupData.push({
        header: "Alligion Configuration",
        icon: "fa-lock",
        items: []
      })
    }

    if (userAuth.data.access_level.system_config && userAuth.data.system_license.allegion_active) {
      vm.setupData[allegionConfig - 1].items.push(
        {
          title: "Allegion Hardware Configuration",
          link: "admin-allegion-management",
          hardware: ["allegion", "lock", "door"]
        }
      )
    }

    vm.totalHeadersOdd = function() {
      return false
      // return vm.setupData.length % 2 != 0
    }

    // Highlight Filter

    vm.highlightFilter = function(currentObject) {
      var result = false
      var itemObjects = []
      angular.forEach(vm.setupData, function(cat) {
        angular.forEach(cat.items, function(item) {
          itemObjects.push(item)
        })
      })
      var searchResults = $filter('filter')(itemObjects, vm.searchFilter)

      angular.forEach(searchResults, function(item) {
        if (angular.equals(item, currentObject)) {
          result = true
        }
      })
      return result
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminSystemMonitorConfigController', AdminSystemMonitorConfigController);

  /** @ngInject */
  function AdminSystemMonitorConfigController($log, toastr, quantumApi, $q, $location) {
    var vm = this;

    vm.selectedMonitor = null
    vm.searchFilter = ""
    vm.filteredList = null
    vm.staff = []
    vm.ladda = false
    vm.previousMonitors = []

    vm.exit = function() {
      $location.path("admin-system-setup")
    }

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevMonitor, nextMonitor) {
      if (event.which == 38 && prevMonitor) {
        event.preventDefault()
        vm.selectedMonitor = prevMonitor
      } else if (event.which == 40 && nextMonitor) {
        event.preventDefault()
        vm.selectedMonitor = nextMonitor
      }
    }

    vm.getMonitors = function() {
      vm.monitors = quantumApi.systemMonitor.query(function(data){
        vm.previousMonitors = angular.copy(data)
      })
      vm.selectedMonitor = null
    }

    vm.getMonitors()

    vm.addMonitor = function() {
      vm.monitors.push({
        id:null,
        name:"New monitor",
        checkin_staff:[]
      })
      vm.selectedMonitor = vm.monitors[vm.monitors.length - 1]
    }

    vm.removeMonitor = function(index, monitor) {
        if (angular.equals(monitor, vm.selectedMonitor)) {
          vm.selectedMonitor = null
        }
        if (monitor.id) {
          monitor.deleted = true
        } else if (!monitor.id) {
          vm.monitors.splice(index,1)
        }

    }

    vm.monitorsValid = function(){
      var val = true
      angular.forEach(vm.monitors, function(monitor){
        if (!monitor.name) {
          val = false
        }
      })
      return val
    }


    vm.saveMonitors = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.monitors, function(monitor, key) {
        if (monitor.id && !monitor.deleted) {
          if (!angular.equals(monitor, vm.previousMonitors[key])) {
            promises.push(quantumApi.systemMonitor.update({id:monitor.id},monitor).$promise)
          }
        } else if (monitor.deleted) {
          promises.push(quantumApi.systemMonitor.delete({id:monitor.id},monitor).$promise)
        } else {
          promises.push(quantumApi.systemMonitor.save(monitor).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getMonitors()
        toastr.success("System Monitors Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save System Monitors", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminSystemConfigController', AdminSystemConfigController);

  /** @ngInject */
  function AdminSystemConfigController($log, toastr, quantumApi, $q, inovonics, userAuth, navItems, $location, $scope, $rootScope) {
    var vm = this;

    // ACG Throws an Error if you submit the same Nid
    var receivedNid

    vm.selectedConfiguration = null
    vm.configurations = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.staff = []
    vm.ladda = false
    vm.userAuth = userAuth
    vm.mobileSoundsets = [{id:1, name:"Basic"}, {id:2, name:"Agressive"}]

    // Location Pendant
    vm.loadLocationPendant = function() {
      if (!userAuth.data.network_coordinator_in_use) {
        vm.pendantLoadComplete = false
        inovonics.getLocationPendant()
        .then(function(data){
          vm.pendantLoadComplete = true
          vm.locationPendant = data
        })
      } else {
        vm.pendantLoadComplete = true
      }
    }

    vm.loadLocationPendant()

    vm.removeLocationPendant  = function() {
      if (!userAuth.data.network_coordinator_in_use) {
        // ACG
        if (vm.locationPendant.acg_id) {
          vm.pendantLoadComplete = false
          inovonics.removeDevice(vm.locationPendant.acg_id)
          .then(function(){
            toastr.success("Location Pendant Removed", "Success!")
          })
          .catch(function(){
            toastr.warning("Failed to Remove Location Pendant", "Error!")
          })
          .finally(function(){
            vm.loadLocationPendant()
          })
        } else if (!vm.locationPendant.acg_id && vm.locationPendant) {
          vm.locationPendant = null
        }
      } else {
        // TODO: Network Coordinator Here

      }
    }

    // --- Inovonics Enrollment ---
    // Verify Nurse Call License Before Staring Inovonics Up
    if (vm.userAuth.data.system_license.nurse_call) {
      // Listen for the registration events emitted from the inovonics service
      // Must call inovonics.openRegistration() for this to be active
      var inovonicsListener = $rootScope.$on('inovonicsRegistration', function(event, data){
        if (!vm.locationPendant && data.device_data.fixed == 0 && data.pti != 5) {
          if (!userAuth.data.network_coordinator_in_use) {
            vm.locationPendant = data
          } else {
            angular.forEach(vm.configurations, function(configuration) {
              if (configuration.id == 1) {
                configuration.data.location_pendant = data.serial_number
              }
            })
          }
        }

        $scope.$apply()
      })

      // Clean Up the connection to the acg and the event listeners on destroy
      $scope.$on('$destroy', function() {
        inovonics.closeRegistration()
        $scope.$on('$destroy', inovonicsListener())
      })

      inovonics.openRegistration()
    }


    vm.timeZones = [{"label":"Eastern", "value":"America/New_York"}, {"label":"Central", "value":"America/Chicago"}, {"label":"Mountain", "value":"America/Denver"},  {"label":"Mountain (Arizona)", "value":"America/Phoenix"}, {"label":"Pacific", "value":"America/Los_Angeles"}]

    vm.netCoordConnections = [{"label":"Serial", "value":1}, {"label":"Network", "value":2}]

    vm.exit = function() {
      $location.path("admin-system-setup")
    }

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevConfiguration, nextConfiguration) {
      if (event.which == 38 && prevConfiguration) {
        event.preventDefault()
        vm.selectedConfiguration = prevConfiguration
      } else if (event.which == 40 && nextConfiguration) {
        event.preventDefault()
        vm.selectedConfiguration = nextConfiguration
      }
    }

    vm.getConfigurations = function() {
      vm.configurations = []
      quantumApi.systemSettings.get(function(data){
        vm.configurations.push({'id':1, 'name':'System Settings', 'order':1, 'data':data})
        vm.selectedConfiguration = vm.configurations[0]
        if (vm.userAuth.data.system_license.nurse_call && !userAuth.data.network_coordinator_in_use) {
          getNid()
        }

        // System Settings was getting a little long. Breaking it up logically.
        vm.configurations.push({'id':5, 'name':'Nurse Call Settings', 'order':2, 'data':vm.configurations[0].data})
        vm.configurations.push({'id':4, 'name':'Mobile Settings', 'order':3, 'data':vm.configurations[0].data})

        quantumApi.siteInfo.get(function(data){
          vm.configurations.push({'id':2, 'name':'Site Info', 'order':4, 'data':data})
        })

        quantumApi.license.query(function(data){
          vm.configurations.push({'id':3, 'name':'License', 'order':5, 'data':data})
        })

      })
    }

    vm.getConfigurations()

    vm.configurationsValid = function(){
      var val = true
      if (!vm.siteInfoValid() || !vm.systemSettingsValid()) {
        val = false
      }
      return val
    }

    vm.resendInstallReport = function() {
      quantumApi.installReport.save({}).$promise
      .then(function(){
        toastr.success("Report Sent Successfully", "Success!")
      })
    }

    vm.systemSettingsValid = function() {
      var valid = true
      angular.forEach(vm.configurations, function(configuration) {
        if (configuration.id == 1) {
          if (vm.userAuth.data.system_license.allegion_active && !configuration.data.allegion_net_ip) {
            valid = false
          }
          if (configuration.data.global_code && (configuration.data.global_code < 1000 || configuration.data.global_code > 9999) || configuration.data.global_code === 0) {
            valid = false
          }
          if ((configuration.data.mobile_reminder_interval < 0 || configuration.data.mobile_reminder_interval === null) || (!configuration.data.mobile_offline_reminder || configuration.data.mobile_offline_reminder === null)  || (!configuration.data.mobile_offline_disconnect || configuration.data.mobile_offline_disconnect === null) || (configuration.data.hardware_disappear_time < 1 || configuration.data.hardware_disappear_time === null) || (configuration.data.scheduled_start_grace < 1 || configuration.data.scheduled_start_grace === null) || (configuration.data.scheduled_end_grace < 1 || configuration.data.scheduled_end_grace === null) || (configuration.data.scheduled_end_grace < 1 || configuration.data.scheduled_end_grace === null)) {
            valid = false
          }
          if (configuration.data.network_coordinator_in_use && (configuration.data.apartment_location_pull_value < 0 || configuration.data.apartment_location_pull_value == null || configuration.data.common_location_pull_value < 0 || configuration.data.common_location_pull_value == null || configuration.data.filter_device_fingerprint_value < 0 || configuration.data.filter_device_fingerprint_value == null || configuration.data.number_location_per_pc < 0 || configuration.data.number_location_per_pc > 3 || configuration.data.number_location_per_pc == null || configuration.data.device_location_dampening_value < 0 || configuration.data.device_location_dampening_value > 20 || configuration.data.device_location_dampening_value == null || configuration.data.inovonics_nid < 0 || configuration.data.inovonics_nid > 31 || configuration.data.inovonics_nid == null || configuration.data.additional_locations < 0 || configuration.data.additional_locations > 4 || configuration.data.additional_locations == null || configuration.data.fingerprint_consideration_limit < 10 || configuration.data.fingerprint_consideration_limit > 200 || configuration.data.fingerprint_consideration_limit == null)) {
            valid = false
          }
        }
      })
      return valid
    }

    vm.siteInfoValid = function() {
      var valid = true
      angular.forEach(vm.configurations, function(configuration) {
        if (configuration.id == 2) {
          angular.forEach(configuration.data, function(value, key) {
            // 3.6 Filter out the non-reqired corp dash keys
            if (key != "corporate_server_version" && key != "corporate_server_address" && key != "contacted_portal" && key != "allegion_key" && key != "allegion_site_reference") {
              if (!value) {
                valid = false
              }
            } else if (key == "corporate_server_address") {
              if (value) {
                var expression = /http?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
                var regex = new RegExp(expression);
                if (!value.match(regex)) {
                  valid = false
                }
              }
            }
          })
        }
      })
      return valid
    }



    function getNid() {
      inovonics.getNid()
      .then(function(data){
        receivedNid = data
      })
    }

    // Disables Nurse Call Sub Options If Nurse Call is Off
    // This isn't great...
    vm.checkNurseCall = function(license) {
      if (license.object_key == "nurse_call" && !license.active) {
        angular.forEach(vm.configurations, function(configuration) {
          if (configuration.id == 3) {
            angular.forEach(configuration.data, function(license) {
              if (license.object_key == "corridor_light" || license.object_key == "staff_assist" || license.object_key == "integration" || license.object_key == "resident_checkin") {
                license.active = false
              }
            })
          }
        })
      }
    }

    // Hides Nurse Call Sub Options
    // This is also not great.
    vm.hideSublicense = function(license) {
      var nurseCallActive
      angular.forEach(vm.configurations, function(configuration) {
        if (configuration.id == 3) {
          angular.forEach(configuration.data, function(license) {
            if (license.object_key == "nurse_call") {
              nurseCallActive = license.active
            }
          })
        }
      })
      if (license) {
        if (license.object_key == "corridor_light" || license.object_key == "staff_assist" || license.object_key == "integration" || license.object_key == "resident_checkin" || license.object_key == "fall_detection") {
          return !nurseCallActive
        }
      }
    }


    vm.saveConfigurations = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.configurations, function(configuration) {
        if (configuration.id == 1) {
          // Make sure the Netwoork Coord or ACG IP Is Set Correctly First
          userAuth.data.network_coordinator_in_use = configuration.data.network_coordinator_in_use
          userAuth.data.acg_ip = configuration.data.acg_ip
          // Update the ACG in the inovonics service
          if (!userAuth.data.network_coordinator_in_use) {
            inovonics.updateAcgIp()
          }

          promises.push(quantumApi.systemSettings.update(configuration.data).$promise)
          if (vm.userAuth.data.system_license.nurse_call && !userAuth.data.network_coordinator_in_use && (receivedNid != configuration.data.inovonics_nid)) {
            promises.push(inovonics.setNid(configuration.data.inovonics_nid))
          }
        } else if (configuration.id == 2) {
          promises.push(quantumApi.siteInfo.update(configuration.data).$promise)
        } else if (configuration.id == 3) {
          promises.push(quantumApi.license.update(configuration.data).$promise)
          userAuth.data.system_license = []
          angular.forEach(configuration.data, function(license) {
            userAuth.data.system_license[license.object_key] = license.active
          })
          navItems.rebuild()
        }

      })

      if (vm.userAuth.data.system_license.nurse_call && !userAuth.data.network_coordinator_in_use && (vm.locationPendant && !vm.locationPendant.acg_id)) {
        promises.push(inovonics.setLocationPendant(vm.locationPendant))
      }

      $q.all(promises)
      .then(function(){
        vm.getConfigurations()
        vm.loadLocationPendant()
        toastr.success("Configurations Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        toastr.warning("Failed to Save Configurations<br>(Check ACG)", "Error!")
        $log.info(err)
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminStaffImportController', AdminStaffImportController);

  /** @ngInject */
  function AdminStaffImportController($log, $timeout, $rootScope, toastr, quantumApi) {
    var vm = this;

    vm.submitting = false

    vm.schedules = quantumApi.scheduleWeeklyStaff.query()
    vm.doorGroups = quantumApi.doorAccessGroup.query()
    vm.doorAccessLevels =[
      {
        id: 0,
        name: 'No Access',
        value: 0
      },
      {
        id: 1,
        name: 'Bypass Only (Resident Not Present)',
        value: 1
      },
      {
        id: 2,
        name: 'Bypass Only (At Any Time)',
        value: 2
      },
      {
        id: 3,
        name: 'Bypass and Reset Alarms',
        value: 3
      }
    ]
    vm.results = []

    vm.reset = function(){
      $rootScope.$broadcast('resetCsv',{});
      vm.results = []
    }

    // Load in the existing codes for duplication validation
    vm.loadExistingCodes = function() {
      quantumApi.staff.usedCodes(function(data){
        vm.existingCodes = []
        angular.forEach(data.used_wiegand, function(value) {
          vm.existingCodes.push(value.toString())
        })
        angular.forEach(data.used_keypad_codes, function(value) {
          vm.existingCodes.push(value.toString())
        })
      })
    }

    vm.loadExistingCodes()

    // Validators
    vm.importValid = function() {
      var valid = true
      angular.forEach(vm.csvResult, function(staff) {
        if (!vm.staffValid(staff)) {
          valid = false
        }
      })

      if (!vm.codesUnique()) {
        valid = false
      }

      return valid
    }

    vm.codesUnique = function(serial) {
      // Serial is an optional argument for highlighting an invalid option in the table
      // keybad is a bool indicating keypad or keycard type
      // Build the array of all call button serials
      var valid = true
      var codesArray = []
      // Copy over the existing codes in the system
      angular.copy(vm.existingCodes, codesArray)
      angular.forEach(vm.csvResult, function(staff) {
        // Keycard
        if (codesArray.indexOf(staff.keycard_code) == -1) {
          codesArray.push(staff.keycard_code)
        } else if (staff.keycard_code != "") {
          codesArray.push(staff.keycard_code)
          valid = false
        }
        // Keypad
        if (codesArray.indexOf(staff.keypad_code) == -1) {
          codesArray.push(staff.keypad_code)
        } else if (staff.keypad_code != "") {
          codesArray.push(staff.keypad_code)
          valid = false
        }
      })
      if (!serial) {
        return valid
      } else {
        return codesArray.indexOf(serial) != codesArray.lastIndexOf(serial)
      }
    }


    vm.codeValid = function(code, keypad) {
      var valid = true
      if (!keypad) {
        if (code < 10000 || code > 65534) {
          valid = false
        }
      } else {
        if(code < 1000 || code > 9999) {
          valid = false
        }
      }
      return valid
    }

    // Validate for All Needed Data
    vm.staffValid = function(staff) {
      var result = false

      // Required fields
      if (staff.first_name && staff.last_name && (staff.keycard_code || staff.keypad_code)) {
        result = true
      }

      // Valid Keycards
      if (staff.keycard_code) {
        if (staff.keycard_code < 10000 || staff.keycard_code > 65534 || isNaN(staff.keycard_code)) {
          result = false
        }
      }

      // Valid Keypad Codes
      if (staff.keypad_code) {
        if(staff.keypad_code < 1000 || staff.keypad_code > 9999 || isNaN(staff.keypad_code)) {
          result = false
        }
      }

      var groupFound = false

      angular.forEach(vm.doorGroups, function(group) {
        if (group.id == staff.door_access_group) {
          groupFound = true
        }
      })

      if (!groupFound) {
        return false
      }

      var scheduleFound = false

      angular.forEach(vm.schedules, function(schedule) {
        if (schedule.id == staff.door_access_schedule) {
          scheduleFound = true
        }
      })

      if (!scheduleFound) {
        return false
      }

      return result
    }

    // Submit Funciton
    vm.saveApartment = function() {
      // Build the array to submit (Make it API Friednly)
      var entryArray = []
      angular.forEach(vm.csvResult, function(staff) {
        var submitObject = {
          "id": null,
          // Basic Info
          "first_name": staff.first_name,
          "last_name": staff.last_name,
          "email": (staff.email ? staff.email : null),
          // TODO: "Added by" based on login? Push to backend?
          "added_by":null,
          // Software Access
          "access_group": 0,
          "user_name": null,
          "password":null,
          "auto_logout": 0,
          "mobile_access":false,
          // Door Access
          "door_access_level": parseInt(staff.door_access_level ? staff.door_access_level : 1),
          "keycard": parseInt(staff.keycard_code ? staff.keycard_code : null),
          "keypad": parseInt(staff.keypad_code ? staff.keypad_code : null),
          "start_date": null,
          "end_date": null,
          "door_groups": (staff.door_access_group ? [parseInt(staff.door_access_group)] : [1]),
          "schedules": (staff.door_access_schedule ? [parseInt(staff.door_access_schedule)] : [1]),
          // Ignore...
          "active": true,
          "last_location_id": null,
          "last_location_name": null,
          "location_time": null,
          "receive_system_status": false,
          'corporate_id':null
        }
        entryArray.push(submitObject)
      })

      // So, I don't want to just blast all of this to the server and hope for the best
      // Let's handle it a little more sequentially

      vm.submitting = true
      var writeToApi = function() {
        if (entryArray.length) {
          quantumApi.staff.save(entryArray[0]).$promise
          .then(function(){
            vm.results.push({"name":entryArray[0].first_name + " " + entryArray[0].last_name, "result":"Success"})
          })
          .catch(function(err){
            $log.info(err)
            try {
              vm.results.push({"name":entryArray[0].apartment.name, "result":"Failed: " + err.data.errors[0].message})
            } catch(err) {
              vm.results.push({"name":entryArray[0].apartment.name, "result":"Failed: " + err})
            }
          })
          .finally(function(){
            entryArray.shift()
            // Loop back to the top
            writeToApi()
          })
        } else {
          vm.submitting = false
          vm.loadExistingCodes()
        }
      }

      writeToApi()

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminStaffAccessGroupController', AdminStaffAccessGroupController);

  /** @ngInject */
  function AdminStaffAccessGroupController($log, toastr, quantumApi, $q, $location) {
    var vm = this;

    vm.selectedGroup = null
    vm.searchFilter = ""
    vm.filteredList = null
    vm.staff = []
    vm.ladda = false
    vm.previousGroups = []

    vm.exit = function() {
      $location.path("admin-system-setup")
    }


    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevGroup, nextGroup) {
      if (event.which == 38 && prevGroup) {
        event.preventDefault()
        vm.selectedGroup = prevGroup
      } else if (event.which == 40 && nextGroup) {
        event.preventDefault()
        vm.selectedGroup = nextGroup
      }
    }

    vm.getGroups = function() {
      vm.groups = quantumApi.staffAccessGroup.query(function(data){
        vm.previousGroups = angular.copy(data)
      })
      vm.selectedGroup = null
    }

    vm.getGroups()

    vm.addGroup = function() {
      vm.groups.push({
        id:null,
        name:"New group",
        properties: {
          "dashboard_access": true,
          "door_control_access": false,
          "facility_lockdown_access": false,
          "door_schedule_access": false,
          "resident_view_access": false,
          "resident_edit_access": false,
          "staff_view_access": false,
          "staff_edit_access": false,
          "resident_reports_access": false,
          "system_reports_access": false,
          "operator_admin":false,
          "system_config_access": false,
          "reset_alarms_access": false
        }
      })
      vm.selectedGroup = vm.groups[vm.groups.length - 1]
    }

    vm.removeGroup = function(index, group) {
        if (angular.equals(group, vm.selectedGroup)) {
          vm.selectedGroup = null
        }
        if (group.id && group.id != 1) {
          group.deleted = true
        } else if (!group.id) {
          vm.groups.splice(index,1)
        }
        vm.selectedGroup = null
    }

    vm.groupsValid = function(){
      var val = true
      angular.forEach(vm.groups, function(group){
        if (!group.name) {
          val = false
        }
      })
      return val
    }

    vm.saveGroups = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.groups, function(group, key) {
        if (group.id && !group.deleted && group.id > 2) {
          if (!angular.equals(group, vm.previousGroups[key])) {
            promises.push(quantumApi.staffAccessGroup.update({id:group.id},group).$promise)
          }
        } else if (group.deleted) {
          promises.push(quantumApi.staffAccessGroup.delete({id:group.id},group).$promise)
        } else if (!group.id && group.id !== 0) {
          promises.push(quantumApi.staffAccessGroup.save(group).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getGroups()
        toastr.success("Groups Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Groups", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminResidentImportController', AdminResidentImportController);

  /** @ngInject */
  function AdminResidentImportController($log, $timeout, $rootScope, toastr, quantumApi, inovonics, $filter, userAuth) {
    var vm = this;

    vm.submitting = false

    vm.escalations = quantumApi.escalation.query()
    vm.areas = quantumApi.area.query()
    vm.results = []
    vm.existingCallButtons = []
    vm.pendantTypes = [{"label":"EN1221","value":{"device_type":"EN1221S-60", "device_description":"Waterproof Pendant Transmitter (with 60 minute check-in)", "mid":178, "pti":29, "inputs":1, "input_list":{"1":"Pendant"}, "supervision":18000, "supported":true, "latchable":true, "fixed":false, "quantum_device_type":2}}, {"label":"EN1223-S", "value":{"device_type":"EN1223S", "device_description":"Single-Button Water-Resistant Pendant Transmitter", "mid":178, "pti":24, "inputs":1, "input_list":{"1":"Pendant"}, "supervision":900, "supported":true, "latchable":true, "fixed":false, "quantum_device_type":2}}]
    vm.pendantType = vm.pendantTypes[0].value

    vm.reset = function(){
      $rootScope.$broadcast('resetCsv',{});
      vm.results = []
    }

    // Verify Pendant Not Already Enrolled

    quantumApi.resident.query(function(data){
      vm.existingCallButtons = []
      angular.forEach(data, function(resident) {
        if (resident.call_button) {
          vm.existingCallButtons.push(resident.call_button.serial_number)
        }
      })
    })

    // Validators
    vm.importValid = function() {
      var valid = true
      angular.forEach(vm.csvResult, function(apartment) {
        if (!vm.apartmentValid(apartment) || !vm.callButtonEnrolled(apartment.call_button_serial) || !vm.callButtonEnrolled(apartment.spouse_call_button_serial)) {
          valid = false
        }
      })

      if (!vm.callButtonsUnique()) {
        valid = false
      }

      return valid
    }


    vm.callButtonsUnique = function(serial) {
      // Serial is an optional argument for hilighting an invalid option in the table
      // Build the array of all call button serials
      var valid = true
      var callButtonArray = []
      angular.forEach(vm.csvResult, function(apartment) {
        // Primary
        if (callButtonArray.indexOf(apartment.call_button_serial) == -1) {
          callButtonArray.push(apartment.call_button_serial)
        } else if (apartment.call_button_serial != "") {
          callButtonArray.push(apartment.call_button_serial)
          valid = false
        }

        // Spouse
        if (callButtonArray.indexOf(apartment.spouse_call_button_serial) == -1) {
          callButtonArray.push(apartment.spouse_call_button_serial)
        } else if (apartment.spouse_call_button_serial != "") {
          callButtonArray.push(apartment.spouse_call_button_serial)
          valid = false
        }
      })

      if (!serial) {
        return valid
      } else {
        return (callButtonArray.indexOf(serial) != callButtonArray.lastIndexOf(serial))
      }
    }

    vm.callButtonEnrolled = function(serial) {
      return (vm.existingCallButtons.indexOf(parseInt(serial)) == -1)
    }

    vm.apartmentVacant = function(apartment) {
      return (!apartment.first_name && !apartment.last_name && !apartment.call_button_serial && !apartment.escalation_id)
    }

    // Validate for All Needed Data
    vm.apartmentValid = function(apartment) {
      var result = false
        var apartmentArray = $filter('findObject')(vm.escalations, apartment.escalation_id)
        // Resident Record Found
      if (apartment.first_name || apartment.last_name || apartment.call_button_serial || apartment.escalation_id || apartment.spouse_first_name || apartment.spouse_first_name || apartment.spouse_call_button_serial) {
        if ((apartment.first_name && apartment.last_name && apartment.call_button_serial && apartment.escalation_id) && (apartmentArray.length) && !isNaN(apartment.call_button_serial)) {
          if (apartment.spouse_first_name || apartment.spouse_first_name || apartment.spouse_call_button_serial) {
            if (apartment.spouse_first_name && apartment.spouse_last_name && apartment.spouse_call_button_serial && !isNaN(apartment.spouse_call_button_serial)) {
              result = true
            }
          } else {
            result = true
          }
        }
      } else {
        result = true
      }

      // No Area Found
      if (apartment.area_id) {
        var areaArray = $filter('findObject')(vm.areas, apartment.area_id)
        if (!areaArray.length) {
          result = false
        }
      }

      // No Apartment Name Found
      if (!apartment.apartment_name) {
        result = false
      }

      return result
    }

    // Submit Funciton
    vm.saveApartment = function() {
      // Build the array to submit (Make it API Friednly)
      var entryArray = []
      angular.forEach(vm.csvResult, function(apartment) {
        var submitObject = {
          "apartment":{
            "id":null,
            "name":apartment.apartment_name,
            "room_phone":"",
            "area": (apartment.area_id ? parseInt(apartment.area_id):1),
            "checkin_active": false,
            "common_area": false,
            "checkin_schedule": []
          },
          "resident":null
        }
        if (apartment.call_button_serial) {
          submitObject.resident = {
            "first_name": apartment.first_name,
            "last_name": apartment.last_name,
            "apartment":null,
            "phone_number":"",
            "escalations":[parseInt(apartment.escalation_id)],
            "notes":null,
            "door_access_permission": 1,
            "call_button": {
              "device_data": vm.pendantType,
              "serial_number":parseInt(apartment.call_button_serial),
              "acg_id":null,
              "pti":vm.pendantType.pti
            },
            "fall_detection":null,
            "wanderer_transmitter":null,
            "resident_door_access":null
          }
        }
        if (apartment.spouse_call_button_serial) {
          submitObject.spouseResident = {
            "first_name": apartment.spouse_first_name,
            "last_name": apartment.spouse_last_name,
            "apartment":null,
            "phone_number":"",
            "escalations":[parseInt(apartment.escalation_id)],
            "notes":null,
            "door_access_permission": 1,
            "call_button": {
              "device_data": vm.pendantType,
              "serial_number":parseInt(apartment.spouse_call_button_serial),
              "acg_id":null,
              "pti":vm.pendantType.pti
            },
            "fall_detection":null,
            "wanderer_transmitter":null,
            "resident_door_access":null
          }
        }
        entryArray.push(submitObject)
      })

      // So, I don't want to just blast all of this to the server and hope for the best
      // Let's handle it a little more sequentially

      vm.submitting = true
      var writeToApi = function() {
        var aptId = null
        if (entryArray.length) {
          quantumApi.apartment.save(entryArray[0].apartment).$promise
          .then(function(data){
            aptId = parseInt(data.id)
            if (entryArray[0].resident) {
              entryArray[0].resident.apartment = aptId
              if (!userAuth.data.network_coordinator_in_use) {
                return inovonics.writeDevice(entryArray[0].resident.call_button)
              }
            }
          })
          .then(function(data){
            if (entryArray[0].resident) {
              if (!userAuth.data.network_coordinator_in_use) {
                entryArray[0].resident.call_button.acg_id = parseInt(data.ResponseStatus.id)
              }
              return quantumApi.resident.save(entryArray[0].resident).$promise
            }
          })
          .then(function(){
            if (entryArray[0].spouseResident) {
              entryArray[0].spouseResident.apartment = aptId
              if (!userAuth.data.network_coordinator_in_use) {
                return inovonics.writeDevice(entryArray[0].spouseResident.call_button)
              }
            }
          })
          .then(function(data){
            if (entryArray[0].spouseResident) {
              if (!userAuth.data.network_coordinator_in_use) {
                entryArray[0].spouseResident.call_button.acg_id = parseInt(data.ResponseStatus.id)
              }
              return quantumApi.resident.save(entryArray[0].spouseResident).$promise
            }
          })
          .then(function(){
            vm.results.push({"apartment":entryArray[0].apartment.name, "result":"Success"})
          })
          .catch(function(err){
            $log.info(err)
            try {
              vm.results.push({"apartment":entryArray[0].apartment.name, "result":"Failed: " + err.data.errors[0].message})
            } catch(err) {
              vm.results.push({"apartment":entryArray[0].apartment.name, "result":"Failed: " + err})
            }
            if (entryArray[0].resident.apartment) {
              quantumApi.apartment.delete({'id':entryArray[0].resident.apartment})
            }
            if (!userAuth.data.network_coordinator_in_use) {
              if (entryArray[0].resident.call_button.acg_id) {
                inovonics.removeDevice(entryArray[0].resident.call_button.acg_id)
              }
              if (entryArray[0].spouseResident.call_button.acg_id) {
                inovonics.removeDevice(entryArray[0].spouseResident.call_button.acg_id)
              }
            }
          })
          .finally(function(){
            entryArray.shift()
            // Loop back to the top
            writeToApi()
          })
        } else {
          vm.submitting = false
        }
      }

      writeToApi()

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminQuantumUpgradeManagerController', AdminQuantumUpgradeManagerController);

  /** @ngInject */
  function AdminQuantumUpgradeManagerController(quantumApi, toastr) {
    var vm = this;

    vm.updatesInProgress = []

    vm.doors = quantumApi.door.query()
    vm.ioRepeaters = quantumApi.ioRepeater.query()
    vm.enrollmentStations = quantumApi.enrollmentStation.query()
    vm.systemMonitors = quantumApi.systemMonitor.query()
    vm.systemSettings = quantumApi.systemSettings.get()
    vm.mobileDevices = []

    quantumApi.alertDevice.query().$promise
    .then(function(data){
      angular.forEach(data, function(device) {
        if (device.interface_type == "Quantum Mobile") {
          vm.mobileDevices.push(device)
        }
      })
    })

    vm.firmwareCheck = function(hardware) {
      var upgradedNeeded = true
      if (hardware.sw_version && vm.systemSettings.server_version) {
        if (vm.systemSettings.server_version.split('.')[0] == hardware.sw_version.split('.')[0] || hardware.sw_version.split('.')[0] < 6) {
          upgradedNeeded = false
        }
      }
      return upgradedNeeded
    }

    // https://github.com/substack/semver-compare
    vm.compareSymVer = function(a, b) {
      if(!a) {
        return -1
      }
      var pa = a.split('.');
      var pb = b.split('.');
      for (var i = 0; i < 3; i++) {
          var na = Number(pa[i]);
          var nb = Number(pb[i]);
          if (na > nb) return 1;
          if (nb > na) return -1;
          if (!isNaN(na) && isNaN(nb)) return 1;
          if (isNaN(na) && !isNaN(nb)) return -1;
      }
      return 0;
    }

    vm.updateFirmware = function(hw_id) {
      vm.updatesInProgress.push(hw_id)
      quantumApi.updateQuantumFirmware.update({id:hw_id}, {}).$promise
      .then(function(){
        toastr.success("Update Started", "Success!")
      })
      .catch(function(){
        toastr.warning("Failed to Start Update", "Error!")
      })
    }

    vm.disableUpdate = function(hw_id) {
      var disabled = false
      if (vm.updatesInProgress.includes(hw_id)) {
        disabled = true
      }
      return disabled
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminPullcordUtilityController', AdminPullcordUtilityController);

  /** @ngInject */
  function AdminPullcordUtilityController($scope, $rootScope, $log, userAuth, quantumApi, inovonics, toastr, $location) {
    var vm = this;

    // License Information for hiding what's not needed
    vm.systemLicense = userAuth.data.system_license
    // API Data
    vm.escalationData = quantumApi.escalation.query()
    vm.apartmentData = quantumApi.apartment.query()

    // Autofill
    vm.defaultEscalations = []
    vm.defaultStaffEscalation = []
    vm.prependText = ""
    vm.quickBtn1 = "Bath"
    vm.quickBtn2 = "Bed A"
    vm.quickBtn3 = "Bed B"
    vm.staffAssistActive = true

    // Defaults
    vm.registeredDevices = []

    vm.exit = function() {
      $location.path("admin-system-setup")
    }

    vm.initForm = function(){
      vm.registeredDevices = []
      vm.formData = []
    }

    vm.initForm()

    vm.removePullCord = function(index, device) {
      vm.registeredDevices.splice(vm.registeredDevices.indexOf(device.serial_number),1)
      vm.formData.splice(index,1)
    }

    vm.nameAutofill = function(device, item) {
      // Set the apartments for both the device and subdevice
      device.sub_devices[1].apartment = device.sub_devices[0].apartment

      if (!device.sub_devices[0].name) {

        var finalName = ""

        if (vm.prependText) {
          finalName = vm.prependText + " "
        }

        finalName = finalName + item.name

        if (vm.appendText) {
          finalName = finalName + " " + vm.appendText
        }

        device.sub_devices[0].name = finalName
        device.sub_devices[1].name = finalName
      }
    }

    vm.updateName = function(device) {
      device.sub_devices[1].name = device.sub_devices[0].name
    }

    vm.appendBtn = function(device, val){
      device.sub_devices[0].name = device.sub_devices[0].name + " " + val
      device.sub_devices[1].name = device.sub_devices[1].name + " " + val
    }

    vm.rowValid = function(device) {
      var valid = true

      // Thanks, Javascript...
      if (vm.staffAssistActive) {
        if (device.sub_devices[1].escalations) {
          if (!device.sub_devices[1].escalations.length) {
            valid = false
          }
        } else if (!device.sub_devices[1].escalations) {
          valid = false
        }
      }

      if (device.sub_devices[0].escalations) {
        if (!device.sub_devices[0].escalations.length) {
          valid = false
        }
      } else if (!device.sub_devices[0].escalations) {
        valid = false
      }

      if (!device.sub_devices[0].apartment || !device.sub_devices[0].name) {
        valid = false
      }

      return valid
    }

    vm.importValid = function(){
      var valid = true
      angular.forEach(vm.formData, function(device) {
        if (!vm.rowValid(device)) {
          valid = false
        }
      })
      return valid
    }


    inovonics.openRegistration()

    // --- Inovonics Enrollment ---
    // Verify Nurse Call License Before Staring Inovonics Up
    if (vm.systemLicense.nurse_call) {
      // Listen for the registration events emitted from the inovonics service
      // Must call inovonics.openRegistration() for this to be active
      var inovonicsListener = $rootScope.$on('inovonicsRegistration', function(event, data){
        // Search for duplicate registrations

        // Verify Unique device
        if (vm.registeredDevices.indexOf(data.serial_number) === -1) {
          // Figure out where we are in the wizard and push to that array.
          // Filter to Pull Cords Only
          if (data.pti == 12) {
            vm.registeredDevices.push(data.serial_number)
            vm.formData.push({
              "quantum_device": true,
              "serial_number": data.serial_number,
              "acg_id": null,
              "pti": data.pti,
              "device_data": data.device_data,
              "sara_device": false,
              "sub_devices": [
                {
                  "id": null,
                  "device_id": null,
                  "name": "",
                  "apartment": null,
                  "resident_id": null,
                  "latching": false,
                  "active": true,
                  "escalations": angular.copy(vm.defaultEscalations),
                  "schedule_id":null,
                  "input": 1,
                  "input_description": "Pull Cord",
                  "corridor_light": {
                    "active":false,
                    "controller":null,
                    "address":null,
                    "relay":1,
                    "rate":'Constant'
                  }
                },
                {
                  "id": null,
                  "device_id": null,
                  "name": "",
                  "apartment": null,
                  "resident_id": null,
                  "latching": false,
                  "active": vm.staffAssistActive,
                  "escalations": angular.copy(vm.defaultStaffEscalation),
                  "schedule_id":null,
                  "input": 2,
                  "input_description": "Staff Assist",
                  "corridor_light": {
                    "active":false,
                    "controller":null,
                    "address":null,
                    "relay":1,
                    "rate":'Constant'
                  }
                }
              ]
            })
          }
          $scope.$apply()
        }
      })

      // This is another one of those sequential writes/recursive functions.
      // Don't want to just blast it all in and hope for the best...
      vm.saveAreas = function() {

        var writeDevice = function() {
          if (vm.formData.length) {
            if (!userAuth.data.network_coordinator_in_use) {
              // ACG
              inovonics.writeDevice(vm.formData[0])
              .then(function(data) {
                $log.log(data)
                vm.formData[0].acg_id = parseInt(data.ResponseStatus.id)
              })
              .then(function(){
                return quantumApi.quantumDevice.save(vm.formData[0]).$promise
              })
              .catch(function(err){
                $log.info(err.data)
                toastr.warning('Failed to Add Device', 'Error!');
                inovonics.removeDevice(vm.formData[0].acg_id)
              })
              .finally(function(){
                // Reset the Form
                vm.ladda = false
                vm.formData.shift()
                writeDevice()
              })
            } else {
              // Network Coordinator
              quantumApi.quantumDevice.save(vm.formData[0]).$promise
              .catch(function(err){
                $log.info(err.data)
                toastr.warning('Failed to Add Device', 'Error!');
                inovonics.removeDevice(vm.formData[0].acg_id)
              })
              .finally(function(){
                // Reset the Form
                vm.ladda = false
                vm.formData.shift()
                writeDevice()
              })
            }
          } else {
            toastr.success('Quantum Devices Added', 'Success!');
            vm.initForm()
          }
        }

        // Kick it off
        writeDevice()

      }

      // Clean Up the connection to the acg and the event listeners on destroy
      $scope.$on('$destroy', function() {
        inovonics.closeRegistration()
        $scope.$on('$destroy', inovonicsListener())
      })
    }



  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminOutputInterfaceController', AdminOutputInterfaceController);

  /** @ngInject */
  function AdminOutputInterfaceController($log, toastr, quantumApi, $q, $location) {
    var vm = this;

    vm.selectedOutput = null
    vm.previousOutputs = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.ladda = false
    vm.interfaceTypes = quantumApi.interfaceType.query()

    vm.serialBaud = [{"label":300, "value":300}, {"label":600, "value":600}, {"label":1200, "value":1200}, {"label":2400, "value":2400}, {"label":4800, "value":4800}, {"label":9600, "value":9600}, {"label":14400, "value":14400}, {"label":19200, "value":19200}, {"label":28800, "value":28800}, {"label":38400, "value":38400}, {"label":57600, "value":57600}, {"label":115200, "value":115200}]
    vm.serialDataBits = [{"label":7, "value":7}, {"label":8, "value":8}]
    vm.serialStopBits = [{"label":0, "value":0}, {"label":1, "value":1}, {"label":2, "value":2}]
    vm.serialParity = [{"label":"None", "value":'N'}, {"label":"Even", "value":"E"}, {"label":"Odd", "value":"O"}]

    vm.networkInterfaces = [1,4,5,6,11,17]
    vm.serialInterfaces = [3,7]

    vm.physicalOutputTypes = function(interfaceType) {
      if (interfaceType == 2) {
        return "email"
      } else if (interfaceType == 13) {
        return "qmobile"
      } else if (interfaceType == 15 || interfaceType == 16) {
        return "twilio"
      } else if (vm.networkInterfaces.indexOf(interfaceType) > -1) {
        return "network"
      } else if (vm.serialInterfaces.indexOf(interfaceType) > -1) {
        return "serial"
      }
    }

    vm.exit = function() {
      $location.path("admin-system-setup")
    }


    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevOutput, nextOutput) {
      if (event.which == 38 && prevOutput) {
        event.preventDefault()
        vm.selectedOutput = prevOutput
      } else if (event.which == 40 && nextOutput) {
        event.preventDefault()
        vm.selectedOutput = nextOutput
      }
    }

    vm.getOutputs = function() {
      vm.outputs = quantumApi.outputInterface.query(function(data){
        vm.previousOutputs = angular.copy(data)
      })
      vm.selectedOutput = null
    }

    vm.getOutputs()

    vm.addOutput = function() {
      vm.outputs.push({
        "id": null,
        "connection_type": 2,
        "email_server": "",
        "email_port": 587,
        "email_user": "",
        "email_password": "",
        "email_from_address": "",
        "name": null,
        "com_port": 1,
        "baud_rate": 9600,
        "data_bits": 8,
        "stop_bits": 1,
        "parity": "N",
        "flow_control": "",
        "ip_address": "",
        "network_port": 6000,
        "in_use":null,
        "throttle":0,
        "interface_message_footer":null
      })
      vm.selectedOutput = vm.outputs[vm.outputs.length - 1]
    }

    vm.removeOutput = function(index, output) {
        if (angular.equals(output, vm.selectedOutput)) {
          vm.selectedOutput = null
        }
        if (output.id && !output.in_use) {
          output.deleted = true
        } else if (!output.id) {
          vm.outputs.splice(index,1)
        }

    }

    vm.outputsValid = function(){
      var val = true
      angular.forEach(vm.outputs, function(output){
        if (!output.name || !vm.outputValid(output)) {
          val = false
        }
      })
      return val
    }

    vm.outputValid = function(output) {
      if (typeof output.throttle == "undefined") {
        return false
      }
      if (vm.physicalOutputTypes(output.connection_type) == "email") {
         return (output.name != "" && output.email_server != "" && output.email_port > 0 && output.email_user != "" && output.email_password != "" && output.email_from_address != "")
      } else if (vm.physicalOutputTypes(output.connection_type) == "network") {
         return (output.ip_address != "" && output.network_port > 0)
      } else if(vm.physicalOutputTypes(output.connection_type) == "serial") {
        return (output.com_port > 0 && output.baud_rate > 0 && output.data_bits > 0 && (output.stop_bits === 0 || output.stop_bits === 1 || output.stop_bits === 2) && output.parity)
      } else if (vm.physicalOutputTypes(output.connection_type) == "twilio") {
        return (output.name != "" && output.email_user != "" && output.email_password != "" && output.email_from_address != "")
      } else if (vm.physicalOutputTypes(output.connection_type) == "qmobile") {
        return true
      }
    }


    vm.saveOutputs = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.outputs, function(output, key) {
        if (output.id && !output.deleted) {
          if (!angular.equals(output, vm.previousOutputs[key])) {
            promises.push(quantumApi.outputInterface.update({id:output.id},output).$promise)
          }
        } else if (output.deleted) {
          promises.push(quantumApi.outputInterface.delete({id:output.id},output).$promise)
        } else {
          promises.push(quantumApi.outputInterface.save(output).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getOutputs()
        toastr.success("Outputs Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Outputs", "Error!")
        vm.ladda = false
      })
    }

    vm.resetLights = function(output) {
      var eventObj = {
       "event_code":"CLA",
       "hw_id":null,
       "resident_id":null,
       "staff_id":null,
       "payload":{"id":output.id}
      }
      quantumApi.events.save(eventObj).$promise
      .then(function(){
        toastr.success("Reset Sent Successfully", "Success!")
      })
      .catch(function(){
        toastr.warning("Failed to Send Reset", "Error!")
      })
    }

    vm.allLightsOn = function(output) {
      var eventObj = {
       "event_code":"ALO",
       "hw_id":null,
       "resident_id":null,
       "staff_id":null,
       "payload":{"id":output.id}
      }
      quantumApi.events.save(eventObj).$promise
      .then(function(){
        toastr.success("Command Sent Successfully", "Success!")
      })
      .catch(function(){
        toastr.warning("Failed to Send Command", "Error!")
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminMapConfigController', AdminMapConfigController);

  /** @ngInject */
  function AdminMapConfigController($log, toastr, quantumApi, $q, $uibModal, $scope, Upload, $timeout, devMode, $location) {
    var vm = this;

    vm.selectedMap = null
    vm.previousMaps = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.ladda = false

    vm.exit = function() {
      $location.path("admin-system-setup")
    }

    if (devMode.enabled) {
      vm.mapPath = 'http://'+devMode.serverIp+'/uploads/maps/'
    } else {
      vm.mapPath = '/uploads/maps/'
    }

    vm.init = function() {
      vm.uploadData = {
        uploadMapName: "",
        tmpImage: null,
        croppedImg: null
      }
    }

    vm.init()

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevMap, nextMap) {
      if (event.which == 38 && prevMap) {
        event.preventDefault()
        vm.selectedMap = prevMap
      } else if (event.which == 40 && nextMap) {
        event.preventDefault()
        vm.selectedMap = nextMap
      }
    }

    // Add Map Modal
    vm.addMap = function(){
      vm.init()
      vm.addModalInstance = $uibModal.open({
          templateUrl: 'addModal.html',
          scope: $scope,
          size: 'md'
      })
    }

    vm.closeAddModal = function(){
      vm.addModalInstance.dismiss();
    };

    vm.getMaps = function() {
      vm.maps = quantumApi.map.query(function(data){
        vm.previousMaps = angular.copy(data)
      })
      vm.selectedMap = null
    }

    vm.getMaps()

    // Move Levels

    var renumberMaps = function(array) {
      angular.forEach(array, function(level, key) {
        level.sort_order = key +1
      })
    }

    vm.moveLevel = function(index, array, direction) {
      var f = null
      if (direction == 'up') {
        // remove `from` item and store it
        f = array.splice(index, 1)[0];
        // insert stored item into position `to`
        array.splice(index - 1, 0, f);
        renumberMaps(array)
      } else {
        // remove `from` item and store it
        f = array.splice(index, 1)[0];
        // insert stored item into position `to`
        array.splice(index + 1, 0, f);
        renumberMaps(array)
      }
    }


    vm.removeMap = function(index, map) {
        if (angular.equals(map, vm.selectedMap)) {
          vm.selectedMap = null
        }
        if (map.id && !map.in_use) {
          // Delete maps on save
          map.deleted = true
          // Move deleted maps to the end for the sake of sort order
          vm.maps.push(vm.maps.splice(index, 1)[0]);
          renumberMaps(vm.maps)
        } else if (!map.id && !map.in_use) {
          vm.maps.splice(index,1)
          renumberMaps(vm.maps)
        }

    }

    vm.mapsValid = function(){
      var val = true
      angular.forEach(vm.maps, function(map){
        if (!vm.mapValid(map)) {
          val = false
        }
      })
      return val
    }

    vm.mapValid = function(map) {
      var val = true
      if (!map.name) {
        val = false
      }
      return val
    }

    vm.uploadMap = function(selectedItem, mapImg) {
      // Move it to the end
      selectedItem.sort_order = vm.maps.length + 1
      var file = {}
      file.upload = Upload.upload({
        url: '/api/v1/map',
        data: {data:Upload.json(selectedItem), mapImg:Upload.dataUrltoBlob(mapImg, "map.png")}
      });

      file.upload.then(function (response) {
        $timeout(function () {
          file.result = response.data;
          toastr.success("Map Saved Successfully", "Success!")
          vm.closeAddModal()
          vm.getMaps()
        });
      }, function (response) {
        if (response.status > 0)
        toastr.warning("Failed to Save Maps", "Error!")
        vm.errorMsg = response.status + ': ' + response.data;
      }, function (evt) {
        // Math.min is to fix IE which reports 200% sometimes
        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      });
    }


    vm.saveMaps = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.maps, function(map, key) {
        if (map.id && !map.deleted) {
          if (!angular.equals(map, vm.previousMaps[key])) {
            promises.push(quantumApi.map.update({id:map.id},map).$promise)
          }
        } else if (map.deleted) {
          promises.push(quantumApi.map.delete({id:map.id},map).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getMaps()
        toastr.success("Maps Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Maps", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminIoRepeaterConfigController', AdminIoRepeaterConfigController);

  /** @ngInject */
  function AdminIoRepeaterConfigController(quantumApi, $uibModal, $scope, toastr) {
    var vm = this

    vm.selectedRepeater = null

    vm.apartments = quantumApi.apartment.query()
    vm.loadRepeaters = function() {
      vm.repeaters = quantumApi.ioRepeater.query()
    }

    // Modal Setup
    vm.removeRepeaterDialog = function(){
      vm.modalInstance = $uibModal.open({
          templateUrl: 'confirmModal.html',
          scope: $scope,
          size: 'md'
      });
    }

    vm.closeModal = function(){
      vm.modalInstance.dismiss();
      vm.selectedRepeater = null
    };

    vm.deleteRepeater = function() {
      vm.modalInstance.dismiss()
      quantumApi.ioRepeater.delete({'id':vm.selectedRepeater.id}).$promise
      .then(function(){
        toastr.success("IO Repeater Removed Sucesfully", "Success!")
        vm.loadRepeaters()
        vm.selectedRepeater = null
      })
    }

    // Utility Functions
    vm.clearApt = function($event, input) {
      $event.stopPropagation();
      input.apartment = null;
    };

    vm.loadRepeaters()

    vm.schedules = [
      {"id":null, "name":"No Schedule", "type":2}
    ]


    vm.checkInSchedules = quantumApi.scheduleCheckIn.query()

    quantumApi.schedule.query(function(scheduleArray){
      angular.forEach(scheduleArray, function(schedule){
        if (schedule.type == 2) {
          vm.schedules.push(schedule)
        }
      })
    })

    vm.escalations = quantumApi.escalation.query()

    vm.loadRepeater = function(id) {
      vm.selectedRepeater = quantumApi.ioRepeater.get({id:id})
    }

    vm.saveRepeater = function(){
      quantumApi.ioRepeater.update({id:vm.selectedRepeater.id},vm.selectedRepeater, function(){
        toastr.success("IO Repeater Updated Successfully", "Success")
        vm.selectedRepeater = null
        vm.loadRepeaters()
      })
    }

    // Figure out the availble inputs based on usage in the input and reset input array
    vm.avalibleInputs = function(currentInput) {
      var avalibleInputs = [1,2,3,4,5,6,7,8,9,10]
      if (vm.selectedRepeater) {
        angular.forEach(vm.selectedRepeater.inputs, function(input){
          var index = avalibleInputs.indexOf(input.input)
          if (index > -1 && currentInput != input.input) {
            avalibleInputs.splice(index, 1);
          }
          if (input.reset_input) {
            index = avalibleInputs.indexOf(input.reset_input)
            if (index > -1 && currentInput != input.reset_input) {
              avalibleInputs.splice(index, 1);
            }
          }
        })
      }
      return avalibleInputs
    }

    vm.addInput = function() {
      if (vm.avalibleInputs().length) {
        var nextInput = vm.avalibleInputs()[0]
        vm.selectedRepeater.inputs.push({"input":nextInput,"type":1,"state":0,"schedule_id":null,"start_debounce":0,"reset_debounce":2,"reset_input":null,"bypass_time":15,"name":"Unnamed Input","outputs":[],"escalations":[],"apartment":null})
      }
    }

    vm.removeInput = function(input) {
      vm.selectedInput = null
      var index = vm.selectedRepeater.inputs.indexOf(input);
      vm.selectedRepeater.inputs.splice(index, 1);
    }

    vm.setResetInput = function(inputObject) {
      var nextInput = vm.avalibleInputs()[0]
      if (!inputObject.type) {
        return nextInput
      } else {
        return null
      }
    }

    vm.setSchedule = function(input) {
      if (input.type == 2) {
        input.schedule_id = vm.checkInSchedules[0].id
      } else {
        input.schedule_id = null
      }
    }

    vm.clearRepeater = function() {
      vm.selectedRepeater = null
      vm.selectedInput = null
    }

    vm.inputsValid = function() {
      var valid = true
      angular.forEach(vm.selectedRepeater.inputs, function(input) {
        if (!vm.inputValid(input)) {
          valid = false
        }
      })
      return valid
    }

    vm.inputValid = function(input) {
      if (input.type == 2) {
        return input.schedule_id && input.apartment
      } else {
        return true
      }
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminInputInterfaceController', AdminInputInterfaceController);

  /** @ngInject */
  function AdminInputInterfaceController($log, toastr, quantumApi, $q, $location) {
    var vm = this;

    vm.selectedInput = null
    vm.previousInputs = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.ladda = false
    vm.interfaceTypes = quantumApi.interfaceType.query()
    vm.systemTypes = quantumApi.inputSystem.query()
    vm.escalations = quantumApi.escalation.query()

    vm.serialBaud = [{"label":300, "value":300}, {"label":600, "value":600}, {"label":1200, "value":1200}, {"label":2400, "value":2400}, {"label":4800, "value":4800}, {"label":9600, "value":9600}, {"label":14400, "value":14400}, {"label":19200, "value":19200}, {"label":28800, "value":28800}, {"label":38400, "value":38400}, {"label":57600, "value":57600}, {"label":115200, "value":115200}]
    vm.serialDataBits = [{"label":7, "value":7}, {"label":8, "value":8}]
    vm.serialStopBits = [{"label":0, "value":0}, {"label":1, "value":1}, {"label":2, "value":2}]
    vm.serialParity = [{"label":"None", "value":'N'}, {"label":"Even", "value":"E"}, {"label":"Odd", "value":"O"}]

    vm.networkInterfaces = [8, 10, 12, 14]
    vm.serialInterfaces = [9]

    vm.physicalInputTypes = function(interfaceType) {
      if (vm.networkInterfaces.indexOf(interfaceType) > -1) {
        return "network"
      } else if (vm.serialInterfaces.indexOf(interfaceType) > -1) {
        return "serial"
      }
    }

    vm.exit = function() {
      $location.path("admin-system-setup")
    }

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevInput, nextInput) {
      if (event.which == 38 && prevInput) {
        event.preventDefault()
        vm.selectedInput = prevInput
      } else if (event.which == 40 && nextInput) {
        event.preventDefault()
        vm.selectedInput = nextInput
      }
    }

    vm.getInputs = function() {
      vm.inputs = quantumApi.inputInterface.query(function(data){
        vm.previousInputs = angular.copy(data)
      })
      vm.selectedInput = null
    }

    vm.getInputs()

    vm.addInput = function() {
      vm.inputs.push({
        "id": null,
        "connection_type": 8,
        "email_server": "",
        "email_port": 587,
        "email_user": "",
        "email_password": "",
        "email_from_address": "",
        "name": null,
        "com_port": 1,
        "baud_rate": 9600,
        "data_bits": 8,
        "stop_bits": 1,
        "parity": "N",
        "flow_control": "",
        "ip_address": "",
        "network_port": 6000,
        "in_use":null,
        "default_escalation":null,
        "input_system":1
      })
      vm.selectedInput = vm.inputs[vm.inputs.length - 1]
    }

    vm.removeInput = function(index, input) {
        if (angular.equals(input, vm.selectedInput)) {
          vm.selectedInput = null
        }
        if (input.id && !input.in_use) {
          input.deleted = true
        } else if (!input.id) {
          vm.inputs.splice(index,1)
        }

    }

    vm.inputsValid = function(){
      var val = true
      angular.forEach(vm.inputs, function(input){
        if (!input.name || !vm.inputValid(input)) {
          val = false
        }
      })
      return val
    }

    vm.inputValid = function(input) {
      if (vm.physicalInputTypes(input.connection_type) == "email") {
         return (input.name != "" && input.email_server != "" && input.email_port > 0 && input.email_user != "" && input.email_password != "" && input.email_from_address != "" && input.default_escalation)
      } else if (vm.physicalInputTypes(input.connection_type) == "network") {
         return (input.network_port > 0 && input.default_escalation)
      } else if(vm.physicalInputTypes(input.connection_type) == "serial") {
        return (input.com_port > 0 && input.baud_rate > 0 && input.data_bits > 0 && (input.stop_bits === 0 || input.stop_bits === 1 || input.stop_bits === 2) && input.parity && input.default_escalation)
      }
    }


    vm.saveInputs = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.inputs, function(input, key) {
        if (input.id && !input.deleted) {
          if (!angular.equals(input, vm.previousInputs[key])) {
            promises.push(quantumApi.inputInterface.update({id:input.id},input).$promise)
          }
        } else if (input.deleted) {
          promises.push(quantumApi.inputInterface.delete({id:input.id},input).$promise)
        } else {
          promises.push(quantumApi.inputInterface.save(input).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getInputs()
        toastr.success("Inputs Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Inputs", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminInovonicsRepeaterConfigController', AdminInovonicsRepeaterConfigController);

  /** @ngInject */
  function AdminInovonicsRepeaterConfigController($log, toastr, quantumApi, $q, inovonics, $location, $interval, $scope, userAuth, $rootScope, $timeout, $uibModal) {
    var vm = this;
    var interval
    var repeaterTimeout

    vm.userAuth = userAuth
    vm.selectedRepeater = null
    vm.searchFilter = ""
    vm.filteredList = null
    vm.staff = []
    vm.ladda = false
    vm.enrollEnabled = false
    vm.previousRepeaters = []
    vm.setNidLadda = false
    vm.getStatusLadda = false

    // Add Modal Setup
    vm.replaceRepeater = function(selectedRepeater){
      vm.addModalInstance = $uibModal.open({
          templateUrl: 'addModal.html',
          scope: $scope,
          size: 'md'
      })
      vm.selectedReplaceRepeaterSerial = selectedRepeater.serial_number
      vm.selectedReplaceRepeater = angular.copy(selectedRepeater)
    }

    // Add Modal Setup
    vm.replaceRepeaterSave = function(){
      quantumApi.inovonicsRepeater.replaceRepeater({id:vm.selectedReplaceRepeater.id}, vm.selectedReplaceRepeater).$promise
      .then(function(){
        vm.closeAddModal()
        vm.getRepeaters()
      })
    }

    vm.closeAddModal = function(){
      vm.addModalInstance.dismiss();
    };

    var eventListener = $rootScope.$on('newEvent', function(event, data){
      if (data.event_code == "RCO" && (vm.setNidLadda || vm.getStatusLadda)) {
        $timeout.cancel(repeaterTimeout)
        toastr.success("Repeater Config Ok", "Success!")
        vm.setNidLadda = false
        vm.getStatusLadda = false
      }
    })

    function repeaterCommunicationTimout() {
      if (vm.setNidLadda || vm.getStatusLadda) {
        toastr.warning("No Communication from Repeater", "Error!")
        vm.setNidLadda = false
        vm.getStatusLadda = false
      }
    }

    // When navigating away, cancel the intercal
    $scope.$on('$destroy', function () {
      eventListener()
    });

    // Enrollment Status Funtions
    vm.loadEnrollmentStatus = function() {
      quantumApi.inovonicsRepeaterEnroll.get(function(data){
        vm.enrollEnabled = data.enrollment_status
      })
    }

    vm.loadEnrollmentStatus()

    vm.toggleEnrollmentStatus = function() {
      vm.enrollEnabled = !vm.enrollEnabled
      quantumApi.inovonicsRepeaterEnroll.update({'enrollment_status':vm.enrollEnabled})
    }

    function loadRepeaterStatus() {
      var newRepeaterArray = [] // Remove repeaters that were deleted on another client
      quantumApi.inovonicsRepeater.query(function(data){
        angular.forEach(data, function(newRepeater) {
          newRepeaterArray.push(newRepeater.id)
          var repeaterLocated = false
          angular.forEach(vm.repeaters, function(previousRepeater) {
            if (newRepeater.id == previousRepeater.id) {
              repeaterLocated = true
              previousRepeater.battery_low = newRepeater.battery_low
              previousRepeater.power_off = newRepeater.power_off
              previousRepeater.tampered = newRepeater.tampered
              previousRepeater.online = newRepeater.online
              previousRepeater.repeater_configured = newRepeater.repeater_configured
              previousRepeater.configured_nid = newRepeater.configured_nid
            }
          })
          // Update the "Previous repeaters" list for comparison saving
          angular.forEach(vm.previousRepeaters, function(previousRepeater) {
            if (newRepeater.id == previousRepeater.id) {
              previousRepeater.battery_low = newRepeater.battery_low
              previousRepeater.power_off = newRepeater.power_off
              previousRepeater.tampered = newRepeater.tampered
              previousRepeater.online = newRepeater.online
              previousRepeater.repeater_configured = newRepeater.repeater_configured
              previousRepeater.configured_nid = newRepeater.configured_nid
            }
          })

          // New repeater found
          if (!repeaterLocated) {
            vm.repeaters.push(newRepeater)
          }
        })
        // Remove deleted repeaters
        angular.forEach(vm.repeaters, function(previousRepeater, key) {
          if (newRepeaterArray.indexOf(previousRepeater.id) == -1) {
            vm.repeaters.splice(key, 1)
            vm.previousRepeaters.splice(key, 1)
          }
        })
      })
    }

    interval = $interval(loadRepeaterStatus, 3000)

    // So, we don't save the acg id of the repeater in our db... Oops...
    var repeaters

    vm.setNid = function(repeater) {
      repeaterTimeout = $timeout(repeaterCommunicationTimout, 6000)
      vm.setNidLadda = true
      quantumApi.inovonicsRepeater.setNid({id:repeater.id}, {})
    }

    vm.getStatus = function(repeater) {
      repeaterTimeout = $timeout(repeaterCommunicationTimout, 6000)
      vm.getStatusLadda = true
      quantumApi.inovonicsRepeater.getStatus({id:repeater.id}, {})
    }

    vm.exit = function() {
      $location.path("admin-system-setup")
    }

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevRepeater, nextRepeater) {
      if (event.which == 38 && prevRepeater) {
        event.preventDefault()
        vm.selectedRepeater = prevRepeater
      } else if (event.which == 40 && nextRepeater) {
        event.preventDefault()
        vm.selectedRepeater = nextRepeater
      }
    }

    vm.getRepeaters = function() {
      vm.repeaters = quantumApi.inovonicsRepeater.query(function(data){
        vm.previousRepeaters = angular.copy(data)
      })
      vm.selectedRepeater = null
    }

    vm.getRepeaters()

    vm.removeRepeater = function(index, repeater) {
      if (angular.equals(repeater, vm.selectedRepeater)) {
        vm.selectedRepeater = null
      }
      if (repeater.id) {
        repeater.deleted = true
      } else if (!repeater.id) {
        vm.repeaters.splice(index,1)
      }
    }

    vm.repeatersValid = function(){
      var val = true
      angular.forEach(vm.repeaters, function(repeater){
        if (!repeater.name) {
          val = false
        }
      })
      return val
    }

    inovonics.getRepeaters()
    .then(function(data){
      repeaters = data
    })

    function getRepeaterId (repeaterSerial) {
      var repeaterId = null
      angular.forEach(repeaters, function(repeater) {
        if (repeater.DeviceID == repeaterSerial) {
          repeaterId = repeater.ID
        }
      })
      return repeaterId
    }


    vm.saveRepeaters = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.repeaters, function(repeater, key) {
        if (repeater.id && !repeater.deleted) {
          if (!angular.equals(repeater, vm.previousRepeaters[key])) {
            promises.push(quantumApi.inovonicsRepeater.update({id:repeater.id},repeater).$promise)
          }
        } else if (repeater.deleted) {
          if (!userAuth.data.network_coordinator_in_use) {
            promises.push(inovonics.removeDevice(getRepeaterId(repeater.serial_number)))
          }
          promises.push(quantumApi.inovonicsRepeater.delete({id:repeater.id},repeater).$promise)
        } else {
          promises.push(quantumApi.inovonicsRepeater.save(repeater).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getRepeaters()
        toastr.success("Repeaters Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Repeaters", "Error!")
        vm.ladda = false
      })
    }

    $scope.$on('$destroy', function() {
      $interval.cancel(interval);
    })

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminInovonicsLocationUtilityController', AdminInovonicsLocationUtilityController);

  /** @ngInject */
  function AdminInovonicsLocationUtilityController($log, toastr, quantumApi, $location, $uibModal, $scope, inovonics, userAuth) {
    var vm = this;

    vm.selectedLocation = null
    vm.searchFilter = ""
    vm.locations = []
    vm.ladda = false
    vm.userAuth = userAuth

    // Modal Setup
    vm.removeLocationDialog = function(location){
      vm.selectedLocation = location
      vm.modalInstance = $uibModal.open({
          templateUrl: 'confirmModal.html',
          scope: $scope,
          size: 'md'
      });
    }

    vm.closeModal = function(){
      vm.modalInstance.dismiss();
      vm.selectedRepeater = null
    };


    vm.deleteLocation = function(location) {
      if (!userAuth.data.network_coordinator_in_use) {
        vm.ladda = true
        inovonics.deleteLocation(location.acg_partition_id)
        .then(function(){
          return quantumApi.inovonicsLocation.delete({'id':location.id}).$promise
        })
        .then(function(){
          vm.selectedLocation = null
          vm.closeModal()
          vm.getLocations()
        })
        .catch(function(){
          vm.closeModal()
          vm.getLocations()
          toastr.warning("Failed to Remove Location", "Error!")
        })
        .finally(function(){
          vm.ladda = false
        })
      } else {
        quantumApi.inovonicsLocation.delete({'id':location.id}).$promise
        .then(function(){
          vm.selectedLocation = null
          vm.closeModal()
          vm.getLocations()
        })
        .catch(function(){
          vm.closeModal()
          vm.getLocations()
          toastr.warning("Failed to Remove Location", "Error!")
        })
        .finally(function(){
          vm.ladda = false
        })
      }
    }


    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.getLocations = function() {
      quantumApi.inovonicsLocation.query(function(data){
        vm.locations = data
        vm.locations.shift()
      })
      vm.selectedLocation = null
    }

    vm.getLocations()


    vm.loadLocation = function(location){
      if (!userAuth.data.network_coordinator_in_use) {
        $location.url("admin-inovonics-location-utility/"+location.id)
      } else {
        $location.url("admin-inovonics-location-utility/nc/"+location.id)
      }
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminInovonicsLocationUtilityEditorNcController', AdminInovonicsLocationUtilityEditorNcController);

  /** @ngInject */
  function AdminInovonicsLocationUtilityEditorNcController($log, toastr, quantumApi, inovonics, $scope, $routeParams, $rootScope, $location, userAuth) {
    var vm = this;

    vm.enrollEnabled = false
    vm.selectedLocation = null
    vm.selectedFingerprint = null
    vm.searchFilter = ""
    vm.filteredList = null
    vm.ladda = false
    vm.userAuth = userAuth
    vm.apartments = quantumApi.apartment.query()

    vm.repeaters = quantumApi.inovonicsRepeater.query()

    vm.getLocation = function(locationID) {
      quantumApi.inovonicsLocation.get({'id':locationID}).$promise
      .then(function(data){
        vm.selectedLocation = data
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Load Location", "ACG Error")
      })
    }

    function init() {
      if ($routeParams.id == 'new') {
        vm.enrollEnabled = true
        vm.selectedLocation = {
          'id': null,
          'acg_partition_id': null,
          'name': '',
          'type': "Locations",
          'fingerprint': []
        }
        vm.selectedFingerprint = null
      } else {
        vm.getLocation($routeParams.id)
      }
    }

    init()

    vm.associateRepeater = function(repeaterId) {
      var repeater
      if (repeaterId == 1) {
        repeater = {
          name: "Network Coordinator",
          serial_number: "Unknown"
        }
      }
      angular.forEach(vm.repeaters, function(repeaterFound) {
        if (repeaterId == repeaterFound.id) {
          repeater = repeaterFound
        }
      })
      return repeater
    }

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.clearApt = function($event, selectedLocation) {
      $event.stopPropagation();
      selectedLocation.apartment_id = null
    }

    vm.cancel = function() {
      $location.url('/admin-inovonics-location-utility')
    }

    vm.keypress = function(event, prevFingerprint, nextFingerprint) {
      if (event.which == 38 && prevFingerprint) {
        event.preventDefault()
        vm.selectedFingerprint = prevFingerprint
      } else if (event.which == 40 && nextFingerprint) {
        event.preventDefault()
        vm.selectedFingerprint = nextFingerprint
      }
    }

    // -- Inovonics FP Websocket --
    inovonics.openLocation()

    // Clean Up the connection to the acg and the event listeners on destroy
    $scope.$on('$destroy', function() {
      inovonics.closeLocation()
      $scope.$on('$destroy', inovonicsListener())
    })

    var inovonicsListener = $rootScope.$on('inovonicsLocation', function(event, data){
      if (vm.enrollEnabled) {
        var index = vm.selectedLocation.fingerprint.push(data)
        vm.selectedFingerprint = vm.selectedLocation.fingerprint[index - 1]
      }
    })

    vm.removeFingerprint = function(index, fingerprint) {
        if (angular.equals(fingerprint, vm.selectedFingerprint)) {
          vm.selectedFingerprint = null
        }
        vm.selectedLocation.fingerprint.splice(index,1)
    }

    vm.fingerprintsValid = function(){
      if (vm.selectedLocation) {
        return (vm.selectedLocation.name != "")
      } else {
        return false
      }
    }



    vm.saveFingerprints = function(){
      vm.ladda = true

      // New Location
      if (!vm.selectedLocation.id) {
        return quantumApi.inovonicsLocation.save(vm.selectedLocation).$promise
        .then(function(){
          toastr.success("Location saved.", "Success!")
        })
        .catch(function(err){
          $log.info(err)
          toastr.warning("Failed to Save Location", "Error!")
        })
        .finally(function(){
          vm.ladda = false
          init()
        })

      } else {
        quantumApi.inovonicsLocation.update({'id':vm.selectedLocation.id},vm.selectedLocation).$promise
        .then(function(){
          toastr.success("Location saved.", "Success!")
        })
        .catch(function(err){
          $log.info(err)
          toastr.warning("Failed to Save Location", "Error!")
        })
        .finally(function(){
          vm.ladda = false
          init()
        })
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminInovonicsLocationUtilityEditorController', AdminInovonicsLocationUtilityEditorController);

  /** @ngInject */
  function AdminInovonicsLocationUtilityEditorController($log, toastr, quantumApi, inovonics, $scope, $routeParams, $rootScope, $location, $q) {
    var vm = this;
    vm.repeaters = quantumApi.inovonicsRepeater.query()

    vm.enrollEnabled = false
    vm.selectedLocation = null
    vm.selectedFingerprint = null
    vm.searchFilter = ""
    vm.filteredList = null
    vm.staff = []
    vm.ladda = false

    vm.getLocation = function(locationID) {
      quantumApi.inovonicsLocation.get({'id':locationID}).$promise
      .then(function(data){
        vm.selectedLocation = data
        // Fake it for the sake of the validator
        vm.selectedLocation.fingerprints = []
      })
      .then(function(){
        return inovonics.getFingerprints(vm.selectedLocation.acg_partition_id)
      })
      .then(function(data){
        vm.selectedLocation.fingerprints = data
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Load Location", "ACG Error")
      })
    }

    function init() {
      if ($routeParams.id == 'new') {
        vm.enrollEnabled = true
        vm.selectedLocation = {
          'id': null,
          'acg_partition_id': null,
          'name': '',
          'type': "Locations",
          'fingerprints': []
        }
        vm.selectedFingerprint = null
      } else {
        vm.getLocation($routeParams.id)
      }
    }

    init()

    vm.associateRepeater = function(repeaterSerial) {
      var repeaterName = "Unknown (or ACG)"
      angular.forEach(vm.repeaters, function(repeater) {
        if (repeaterSerial == repeater.serial_number) {
          repeaterName = repeater.name
        }
      })
      return repeaterName
    }

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.cancel = function() {
      $location.url('/admin-inovonics-location-utility')
    }

    vm.keypress = function(event, prevFingerprint, nextFingerprint) {
      if (event.which == 38 && prevFingerprint) {
        event.preventDefault()
        vm.selectedFingerprint = prevFingerprint
      } else if (event.which == 40 && nextFingerprint) {
        event.preventDefault()
        vm.selectedFingerprint = nextFingerprint
      }
    }

    // -- Inovonics FP Websocket --
    inovonics.openLocation()

    // Clean Up the connection to the acg and the event listeners on destroy
    $scope.$on('$destroy', function() {
      inovonics.closeLocation()
      $scope.$on('$destroy', inovonicsListener())
    })

    var inovonicsListener = $rootScope.$on('inovonicsLocation', function(event, data){
      if (vm.enrollEnabled) {
        var fpObject = {
          'ID': null,
          'PartitionID': vm.selectedLocation.acg_partition_id,
          'Receivers': data
        }
        var index = vm.selectedLocation.fingerprints.push(fpObject)
        vm.selectedFingerprint = vm.selectedLocation.fingerprints[index - 1]
      }
    })

    vm.addFingerprint = function() {
      vm.fingerprints.push({
        id:null,
        name:"New fingerprint",
        checkin_staff:[]
      })
      vm.selectedFingerprint = vm.fingerprints[vm.fingerprints.length - 1]
    }

    vm.removeFingerprint = function(index, fingerprint) {
        if (angular.equals(fingerprint, vm.selectedFingerprint)) {
          vm.selectedFingerprint = null
        }
        if (fingerprint.id && fingerprint.id != 1) {
          fingerprint.deleted = true
        } else if (!fingerprint.id) {
          vm.fingerprints.splice(index,1)
        }

    }

    vm.fingerprintsValid = function(){
      if (vm.selectedLocation) {
        return (vm.selectedLocation.name != "" && vm.selectedLocation.fingerprints.length)
      } else {
        return false
      }
    }

    // The ACG doesn't like all of the async requests all at once. Save them recursivly.
    function fingerprintSaver(fingerprints) {
      var deferred = $q.defer();
      var fingerprintArray = angular.copy(fingerprints)

      function acgSaveFingerprint() {
        if (fingerprintArray.length) {
          if (!fingerprintArray[0].deleted && !fingerprintArray[0].ID) {
            inovonics.saveFingerprint(fingerprintArray[0])
            .then(function(){
              fingerprintArray.shift()
              acgSaveFingerprint()
            })
            .catch(function(err){
              $log.info(err)
              deferred.reject()
            })
          } else if (fingerprintArray[0].deleted && fingerprintArray[0].ID) {
            inovonics.deleteFingerprint(fingerprintArray[0].ID)
            .then(function(){
              fingerprintArray.shift()
              acgSaveFingerprint()
            })
            .catch(function(err){
              $log.info(err)
              deferred.reject()
            })
          } else {
            fingerprintArray.shift()
            acgSaveFingerprint()
          }
        } else {
          deferred.resolve()
        }
      }

      acgSaveFingerprint()
      return deferred.promise
    }


    vm.saveFingerprints = function(){
      vm.ladda = true

      // New Location
      if (!vm.selectedLocation.id) {
        inovonics.saveLocation(vm.selectedLocation.name)
        .then(function(data){
          vm.selectedLocation.acg_partition_id = parseInt(data.id)
          angular.forEach(vm.selectedLocation.fingerprints, function(fingerprint) {
            fingerprint.PartitionID = data.id
          })
        })
        .then(function(){
          return fingerprintSaver(vm.selectedLocation.fingerprints)
        })
        .then(function(){
          return quantumApi.inovonicsLocation.save(vm.selectedLocation).$promise
        })
        .then(function(){
          toastr.success("Location saved.", "Success!")
        })
        .catch(function(err){
          $log.info(err)
          toastr.warning("Failed to Save Location", "Error!")
        })
        .finally(function(){
          vm.ladda = false
          init()
        })

      } else {

        inovonics.updateLocation(vm.selectedLocation.acg_partition_id, vm.selectedLocation.name)
        .then(function(){
          angular.forEach(vm.selectedLocation.fingerprints, function(fingerprint) {
            fingerprint.PartitionID = vm.selectedLocation.acg_partition_id
          })
        })
        .then(function(){
          return fingerprintSaver(vm.selectedLocation.fingerprints)
        })
        .then(function(){
          return quantumApi.inovonicsLocation.update({'id':vm.selectedLocation.id},vm.selectedLocation).$promise
        })
        .then(function(){
          toastr.success("Location saved.", "Success!")
        })
        .catch(function(err){
          $log.info(err)
          toastr.warning("Failed to Save Location", "Error!")
        })
        .finally(function(){
          vm.ladda = false
          init()
        })
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminHardwareEscalationGroupController', AdminHardwareEscalationGroupController);

  /** @ngInject */
  function AdminHardwareEscalationGroupController($log, toastr, quantumApi, $q, $location) {
    var vm = this;

    vm.selectedGroup = null
    vm.previousGroups = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.ladda = false
    vm.escalations = quantumApi.escalation.query()
    vm.doors = quantumApi.door.query()

    vm.exit = function() {
      $location.path("admin-system-setup")
    }

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevGroup, nextGroup) {
      if (event.which == 38 && prevGroup) {
        event.preventDefault()
        vm.selectedGroup = prevGroup
      } else if (event.which == 40 && nextGroup) {
        event.preventDefault()
        vm.selectedGroup = nextGroup
      }
    }

    vm.getGroups = function() {
      vm.groups = quantumApi.hardwareEscalationGroup.query(function(data){
        vm.previousGroups = angular.copy(data)
      })
      vm.selectedGroup = null
    }

    vm.getGroups()

    vm.addGroup = function() {
      vm.groups.push({
        id:null,
        name:"New group",
        escalations:[],
        supervisory_escalation:1, //TODO change this vm.escalations[0]
        hardware:[]
      })
      vm.selectedGroup = vm.groups[vm.groups.length - 1]
    }

    vm.removeGroup = function(index, group) {
        if (angular.equals(group, vm.selectedGroup)) {
          vm.selectedGroup = null
        }
        if (group.id) {
          group.deleted = true
        } else if (!group.id) {
          vm.groups.splice(index,1)
        }

    }

    vm.groupsValid = function(){
      var val = true
      angular.forEach(vm.groups, function(group){
        if (!group.name || !group.escalations.length || !group.hardware.length) {
          val = false
        }
      })
      return val
    }

    vm.groupValid = function(group) {
      return (group.name != '' && group.escalations.length && group.hardware.length)
    }


    vm.saveGroups = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.groups, function(group, key) {
        if (group.id && !group.deleted) {
          if (!angular.equals(group, vm.previousGroups[key])) {
            promises.push(quantumApi.hardwareEscalationGroup.update({id:group.id},group).$promise)
          }
        } else if (group.deleted) {
          promises.push(quantumApi.hardwareEscalationGroup.delete({id:group.id},group).$promise)
        } else {
          promises.push(quantumApi.hardwareEscalationGroup.save(group).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getGroups()
        toastr.success("Groups Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Groups", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminEventMessageConfigController', AdminEventMessageConfigController);

  /** @ngInject */
  function AdminEventMessageConfigController($log, toastr, quantumApi, $q, $location) {
    var vm = this;

    vm.selectedMessage = null
    vm.searchFilter = ""
    vm.filteredList = null
    vm.staff = []
    vm.ladda = false
    vm.previousMessages = []

    vm.doors = quantumApi.door.query(function(){
      // Fake the "All Doors"
      vm.doors.push({'id':-1, 'name':"All Doors"})
    })

    vm.exit = function() {
      $location.path("admin-system-setup")
    }

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevMessage, nextMessage) {
      if (event.which == 38 && prevMessage) {
        event.preventDefault()
        vm.selectedMessage = prevMessage
      } else if (event.which == 40 && nextMessage) {
        event.preventDefault()
        vm.selectedMessage = nextMessage
      }
    }

    vm.setAlarm = function() {
      vm.selectedMessage.is_alarm = true
      if (!vm.selectedMessage.alarm_details) {
        vm.selectedMessage.alarm_details = {
          "supervisory_alarm": false,
          "valid_hardware": [-1],
          "reset_events": []
        }
      }
    }

    vm.getMessages = function() {
      vm.messages = quantumApi.eventMessage.query(function(data){
        vm.previousMessages = angular.copy(data)
      })
      vm.selectedMessage = null
    }

    vm.getMessages()

    vm.addMessage = function() {
      vm.messages.push({
        id:null,
        name:"New message",
        checkin_staff:[]
      })
      vm.selectedMessage = vm.messages[vm.messages.length - 1]
    }

    vm.removeMessage = function(index, message) {
        if (angular.equals(message, vm.selectedMessage)) {
          vm.selectedMessage = null
        }
        if (message.id && message.id != 1) {
          message.deleted = true
        } else if (!message.id) {
          vm.messages.splice(index,1)
        }
    }

    // Prevent a message from being it's own reset event
    vm.messageFilter = function(messageList, messageToFilter) {
      var messages = []
      angular.forEach(messageList, function(message) {
        if (message.code != messageToFilter.code){
          messages.push(message)
        }
      })
      return messages
    }

    // Validate Each Message
    vm.messageValid = function(message){
      var validAlarm = true
      if (message.is_alarm) {
        if (!message.alarm_details.valid_hardware || !message.alarm_details.reset_events) {
          validAlarm = false
        } else if (!message.alarm_details.valid_hardware.length || !message.alarm_details.reset_events.length) {
          validAlarm = false
        }
      }
      return validAlarm && message.event_message != ""
    }

    vm.allValid = function() {
      var valid = true
      angular.forEach(vm.messages, function(message) {
        if (!vm.messageValid(message)) {
          valid = false
        }
      })
      return valid
    }

    vm.saveMessages = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.messages, function(message, key) {
        if (message.id && !message.deleted) {
          if (!angular.equals(message, vm.previousMessages[key])) {
            promises.push(quantumApi.eventMessage.update({id:message.id},message).$promise)
          }
        } else if (message.deleted) {
          promises.push(quantumApi.eventMessage.delete({id:message.id},message).$promise)
        } else {
          promises.push(quantumApi.eventMessage.save(message).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getMessages()
        toastr.success("Messages Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminEscalationConfigController', AdminEscalationConfigController);

  /** @ngInject */
  function AdminEscalationConfigController($log, toastr, quantumApi, $uibModal, $location, $scope) {
    var vm = this;

    vm.selectedEscalation = null
    vm.searchFilter = ""
    vm.escalations = []
    vm.ladda = false

    // Modal Setup
    vm.removeEscalationDialog = function(escalation){
      if (!escalation.in_use) {
        vm.selectedEscalation = escalation
        vm.modalInstance = $uibModal.open({
          templateUrl: 'confirmModal.html',
          scope: $scope,
          size: 'md'
        });
      }
    }

    vm.closeModal = function(){
      vm.modalInstance.dismiss();
      vm.selectedRepeater = null
    };


    vm.deleteEscalation = function(escalation) {
      vm.ladda = true
      quantumApi.escalation.delete({'id':escalation.id}).$promise
      .then(function(){
        vm.selectedEscalation = null
        vm.closeModal()
        vm.getEscalations()
        toastr.success("Escalation Removed Successfully", "Success!")
      })
      .catch(function(){
        vm.closeModal()
        vm.getEscalations()
        toastr.warning("Failed to Remove Escalation", "Error!")
      })
      .finally(function(){
        vm.ladda = false
      })
    }


    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.getEscalations = function() {
      vm.escalations = quantumApi.escalation.query()
      vm.selectedEscalation = null
    }

    vm.getEscalations()


    vm.loadEscalation = function(escalation){
      $location.url("admin-escalation-config/"+escalation.id)
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminEscalationConfigEditorController', AdminEscalationConfigEditorController);

  /** @ngInject */
  function AdminEscalationConfigEditorController($log, toastr, quantumApi, $q, $routeParams, $location, userAuth) {
    var vm = this;

    vm.selectedLevel = null
    vm.selectedEscalation = null
    vm.searchFilter = ""
    vm.filteredList = null
    vm.staff = []
    vm.ladda = false

    vm.alertDevices = quantumApi.alertDevice.query()
    vm.userAuth = userAuth


    vm.getEscalation = function(locationID) {
      quantumApi.escalation.get({'id':locationID}).$promise
      .then(function(data){
        vm.selectedEscalation = data
      })
    }

    vm.exit = function() {
      $location.url("/admin-escalation-config")
    }

    function init() {
      if ($routeParams.id == 'new') {
        vm.enrollEnabled = true
        vm.selectedEscalation = {
          "id": null,
          "name": "New Escalation",
          "notes": null,
          "in_use": null,
          "data": [
            {
              "escalation_level": 1,
              "times_to_send": 1,
              "time_between_send": 5,
              "alert_devices": [],
              "backup_alert_devices": []
            }
          ]
        }
      } else {
        vm.getEscalation($routeParams.id)
      }
    }

    init()

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevLevel, nextLevel) {
      if (event.which == 38 && prevLevel) {
        event.preventDefault()
        vm.selectedLevel = prevLevel
      } else if (event.which == 40 && nextLevel) {
        event.preventDefault()
        vm.selectedLevel = nextLevel
      }
    }

    vm.getAlertDevice = function(alertDeviceId) {
      var deviceSelected
      angular.forEach(vm.alertDevices, function(device) {
        if (device.id == alertDeviceId) {
          deviceSelected = device
        }
      })
      return deviceSelected
    }

    vm.nonMobileDevices = function() {
      var devices = []
      angular.forEach(vm.alertDevices, function(device) {
        if (device.interface_type != "Quantum Mobile") {
          devices.push(device)
        }
      })
      return devices
    }

    vm.onlyMobileDevices = function(alertDevices) {
      var result = true
      if (!alertDevices.length) {
        result = false
      }
      angular.forEach(alertDevices, function(device) {
        if (vm.getAlertDevice(device).interface_type != "Quantum Mobile") {
          result = false
        }
      })
      return result
    }

    vm.changeDevices = function(alertDevices) {
      if(!vm.onlyMobileDevices(alertDevices)) {
        vm.selectedLevel.backup_alert_devices = null
      }
    }

    vm.addLevel = function() {
      vm.selectedEscalation.data.push({
        "escalation_level": vm.selectedEscalation.data.length + 1,
        "times_to_send": 5,
        "time_between_send": 5,
        "alert_devices": [],
        "backup_alert_devices": []
      })
      vm.selectedLevel = vm.selectedEscalation.data[vm.selectedEscalation.data.length - 1]
    }

    var renumberLevels = function(array) {
      angular.forEach(array, function(level, key) {
        level.escalation_level = key +1
      })
    }

    vm.moveLevel = function(index, array, direction) {
      var f = null
      if (direction == 'up') {
        // remove `from` item and store it
        f = array.data.splice(index, 1)[0];
        // insert stored item into position `to`
        array.data.splice(index - 1, 0, f);
        renumberLevels(array.data)
      } else {
        // remove `from` item and store it
        f = array.data.splice(index, 1)[0];
        // insert stored item into position `to`
        array.data.splice(index + 1, 0, f);
        renumberLevels(array.data)
      }
    }

    vm.removeLevel = function(index, level) {
        if (angular.equals(level, vm.selectedLevel)) {
          vm.selectedLevel = null
        }
        if (level.escalation_level != 1) {
          vm.selectedEscalation.data.splice(index,1)
          angular.forEach(vm.selectedEscalation.data, function(level, key) {
            level.escalation_level = key + 1
          })
        }

    }

    vm.levelsValid = function(){
      var val = true
      if (vm.selectedEscalation) {
        if (!vm.selectedEscalation.name) {
          val = false
        }
        angular.forEach(vm.selectedEscalation.data, function(level){
          if (!vm.levelValid(level)) {
            val = false
          }
        })
      }
      return val
    }

    vm.levelValid = function(level){
      if (vm.onlyMobileDevices(level.alert_devices)) {
        return (level.alert_devices.length > 0 && level.backup_alert_devices.length > 0 && level.time_between_send > 0 && level.times_to_send > 0)
      } else {
        return (level.alert_devices.length > 0 && level.time_between_send > 0 && level.times_to_send > 0)
      }
    }


    vm.saveLevels = function(){
      vm.ladda = true
      var promises = []

      if (vm.selectedEscalation.id) {
        promises.push(quantumApi.escalation.update({id:vm.selectedEscalation.id},vm.selectedEscalation).$promise)
      } else {
        promises.push(quantumApi.escalation.save(vm.selectedEscalation).$promise)
      }

      $q.all(promises)
      .then(function(){
        vm.getEscalation($routeParams.id)
        toastr.success("Escalation Saved Successfully", "Success!")
        vm.ladda = false
        vm.exit()
      })
      .catch(function(err){
        vm.ladda = false
        $log.info(err)
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminEnrollmentStationConfigController', AdminEnrollmentStationConfigController);

  /** @ngInject */
  function AdminEnrollmentStationConfigController($log, toastr, quantumApi, $q, $location) {
    var vm = this;

    vm.selectedStation = null
    vm.searchFilter = ""
    vm.filteredList = null
    vm.staff = []
    vm.ladda = false
    vm.previousStations = []

    vm.exit = function() {
      $location.path("admin-system-setup")
    }


    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevStation, nextStation) {
      if (event.which == 38 && prevStation) {
        event.preventDefault()
        vm.selectedStation = prevStation
      } else if (event.which == 40 && nextStation) {
        event.preventDefault()
        vm.selectedStation = nextStation
      }
    }

    vm.getStations = function() {
      vm.stations = quantumApi.enrollmentStation.query(function(data){
        vm.previousStations = angular.copy(data)
      })
      vm.selectedStation = null
    }

    vm.getStations()

    vm.addStation = function() {
      vm.stations.push({
        id:null,
        name:"New station",
        checkin_staff:[]
      })
      vm.selectedStation = vm.stations[vm.stations.length - 1]
    }

    vm.removeStation = function(index, station) {
        if (angular.equals(station, vm.selectedStation)) {
          vm.selectedStation = null
        }
        if (station.id) {
          station.deleted = true
        } else if (!station.id) {
          vm.stations.splice(index,1)
        }

    }

    vm.stationsValid = function(){
      var val = true
      angular.forEach(vm.stations, function(station){
        if (!station.name) {
          val = false
        }
      })
      return val
    }


    vm.saveStations = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.stations, function(station, key) {
        if (station.id && !station.deleted) {
          if (!angular.equals(station, vm.previousStations[key])) {
            promises.push(quantumApi.enrollmentStation.update({id:station.id},station).$promise)
          }
        } else if (station.deleted) {
          promises.push(quantumApi.enrollmentStation.delete({id:station.id},station).$promise)
        } else {
          promises.push(quantumApi.enrollmentStation.save(station).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getStations()
        toastr.success("Enrollment Stations Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Enrollment Stations", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminDoorConfigController', AdminDoorConfigController);

  /** @ngInject */
  function AdminDoorConfigController($log, toastr, quantumApi, $location, $uibModal, $scope) {
    var vm = this;

    vm.selectedDoor = null
    vm.searchFilter = ""
    vm.doors = []
    vm.ladda = false
    vm.doorPendingReboot = null

    // Add Modal Setup
    vm.addDoorDialog = function(){
      vm.addModalInstance = $uibModal.open({
          templateUrl: 'addModal.html',
          scope: $scope,
          size: 'md'
      })
      vm.newDoors = quantumApi.door.newDoors()
    }

    vm.closeAddModal = function(){
      vm.addModalInstance.dismiss();
    };


    vm.addDoor = function(serialNumber) {
      $location.url("admin-door-config/new/"+serialNumber)
    }

    // Delete Modal Setup
    vm.removeDoorDialog = function(door){
      vm.selectedDoor = door
      vm.deleteModalInstance = $uibModal.open({
          templateUrl: 'confirmModal.html',
          scope: $scope,
          size: 'md'
      });
    }

    vm.closeModal = function(){
      vm.deleteModalInstance.dismiss();
      vm.selectedRepeater = null
    };


    vm.deleteDoor = function(door) {
      vm.ladda = true
      quantumApi.door.delete({'id':door.id}).$promise
      .then(function(){
        vm.selectedDoor = null
        vm.closeModal()
        vm.getDoors()
      })
      .catch(function(){
        vm.closeModal()
        vm.getDoors()
        toastr.warning("Failed to Remove Door", "Error!")
      })
      .finally(function(){
        vm.ladda = false
      })
    }


    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.getDoors = function() {
      vm.doors = quantumApi.door.query()
      vm.selectedDoor = null
    }

    vm.getDoors()

    vm.prettyDoorUse = function(use) {
      if (use == 0) {
        return "Wanderer Monitoring"
      } else if (use == 1) {
        return "Access Control"
      } else if (use == 2) {
        return "Access Control and Wanderer Monitoring"
      }
    }

    vm.rebootDoor = function(doorId) {
      if (doorId != vm.doorPendingReboot) {
        vm.doorPendingReboot = doorId
      } else if (doorId == vm.doorPendingReboot) {
        vm.doorPendingReboot = null
        toastr.success("Reboot Initiated", "Door Reboot")
        quantumApi.door.reboot({id:doorId}, {reboot:true})
      }
    }


    vm.loadDoor = function(door){
      $location.url("admin-door-config/"+door.id)
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminDoorConfigEditorController', AdminDoorConfigEditorController);

  /** @ngInject */
  function AdminDoorConfigEditorController($log, toastr, quantumApi, $routeParams, $location, $uibModal, $scope, leafletData, leafletBoundsHelpers, devMode, userAuth) {
    var vm = this;
    vm.userAuth = userAuth

    // Check the License and Add Options if Needed
    var accessAndWanderer = [
      {
        'id':0,
        'name':"Wanderer Monitoring"
      },
      {
        'id':1,
        'name':"Access Control"
      },
      {
        'id':2,
        'name':"Access Control and Wanderer Monitoring"
      }
    ]

    vm.selectedProperty = null
    vm.searchFilter = ""
    vm.filteredList = null
    vm.staff = []
    vm.ladda = false
    vm.doorUses = [
      {
        'id':1,
        'name':"Access Control"
      }
    ]

    vm.sounderTones = [
      {
        'id':1,
        'name':"Constant"
      },
      {
        'id':2,
        'name':"Slow"
      },
      {
        'id':3,
        'name':"Fast"
      },
      {
        'id':4,
        'name':"Slow Multi-Tone"
      },
      {
        'id':5,
        'name':"Fast Multi-Tone"
      }
    ]

    vm.outputs = [
      {
        'id':1,
        'name':"Output 1"
      },
      {
        'id':2,
        'name':"Output 2"
      },
      {
        'id':3,
        'name':"Output 3"
      },
      {
        'id':4,
        'name':"Output 4"
      },
      {
        'id':5,
        'name':"Output 5"
      }
    ]

    vm.inputTypes = quantumApi.inputType.query()
    vm.outputTypes = quantumApi.outputType.query()

    vm.schedules = [
      {"id":null, "name":"No Schedule", "type":2}
    ]

    quantumApi.schedule.query(function(scheduleArray){
      angular.forEach(scheduleArray, function(schedule){
        if (schedule.type == 2) {
          vm.schedules.push(schedule)
        }
      })
    })

    vm.getDoor = function(doorId) {
    quantumApi.door.get({'id':doorId}).$promise
      .then(function(data){
        vm.selectedDoor = data
      })
      // Generate the door use array based on license
      .then(function() {
        return quantumApi.license.query().$promise
      })
      .then(function(licenseData){
        var licensesAvalible
        angular.forEach(licenseData, function(license) {
          if (license.object_key == "wanderer_monitoring") {
            licensesAvalible = license.available
          }
        })
        if (licensesAvalible > 0 || vm.selectedDoor.use == 0 || vm.selectedDoor.use == 2) {
          vm.doorUses = accessAndWanderer
        }
      })
      .then(function(){
        quantumApi.map.query().$promise
        .then(function(data){
          angular.forEach(data, function(map) {
            var mapData =  {
              id: map.id,
              name: map.name,
              map_data: {
                  baselayers: {
                      1: {
                          name: map.name,
                          type: 'imageOverlay',
                          url: vm.mapPath+map.filename,
                          bounds: [[-270, -480], [270, 480]],
                          layerParams: {
                            noWrap: true
                          }
                      }
                  }
                },
              marker_data: [
                {
                  lat:vm.selectedDoor.map_data.lat,
                  lng:vm.selectedDoor.map_data.long,
                  icon: {
                    type: 'extraMarker',
                    icon: 'fa-bullseye',
                    markerColor: 'green',
                    prefix: 'fa',
                    shape: 'circle'
                  }
                }
              ]
            }
            vm.maps.push(mapData)
          })
        })
      })
      vm.selectedProperty = {'type':'config'}
    }

    function init() {
      if ($routeParams.serialNumber) {
        vm.selectedDoor = {
          "id": null,
          "name": "New Door",
          "serial_number": $routeParams.serialNumber,
          "ip_address": null,
          "use": 1,
          "status": null,
          "settings": {
            "part_of_lockdown": true,
            "alarm_range": 65,
            "schedule_check_interval": 10,
            "propped_door_time": 0,
            "bypass_time": 15,
            "doorbell_debounce": 2,
            "SDC_lock": false,
            "disappear_time": 10,
            "buzzer_volume": 130,
            "loiter_time": 0,
            "min_temp": null,
            "max_temp": null
          },
          "map_data": {
            "lat": 0,
            "long": 0,
            "map_id": 0
          },
          "input": [
            {
              "type_id": 1,
              "id": null,
              "input_number": 1,
              "normally_closed": false,
              "pir": false,
              "notes": null,
              "schedule_id": null
            }
          ],
          "output": [],
          "monitor_sanity":true
        }
        // License check
        quantumApi.license.query().$promise
        .then(function(licenseData){
          var licensesAvalible
          angular.forEach(licenseData, function(license) {
            if (license.object_key == "wanderer_monitoring") {
              licensesAvalible = license.available
            }
          })
          if (licensesAvalible > 0) {
            vm.doorUses = accessAndWanderer
          }
        })
        // Load the Default View
        vm.selectedProperty = {'type':'config'}
        // Load the getMapSettings
        quantumApi.map.query().$promise
        .then(function(data){
          angular.forEach(data, function(map) {
            var mapData =  {
              id: map.id,
              name: map.name,
              map_data: {
                  baselayers: {
                      1: {
                          name: map.name,
                          type: 'imageOverlay',
                          url: vm.mapPath+map.filename,
                          bounds: [[-270, -480], [270, 480]],
                          layerParams: {
                            noWrap: true
                          }
                      }
                  }
                },
              marker_data: [
                {
                  lat:vm.selectedDoor.map_data.lat,
                  lng:vm.selectedDoor.map_data.long,
                  icon: {
                    type: 'extraMarker',
                    icon: 'fa-bullseye',
                    markerColor: 'green',
                    prefix: 'fa',
                    shape: 'circle'
                  }
                }
              ]
            }
            vm.maps.push(mapData)
          })
        })

      } else if ($routeParams.id) {
        vm.getDoor($routeParams.id)
      }
    }

    init()

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    // UI Helper Functions
    // Figure out the availble inputs based on usage
    vm.avalibleInputs = function(currentInput) {
      var avalibleInputs = [1,2,3,4,5,6,7,8,9,10]
      if (vm.selectedDoor) {
        angular.forEach(vm.selectedDoor.input, function(input){
          var index = avalibleInputs.indexOf(input.input_number)
          if (index > -1 && currentInput != input.input_number) {
            avalibleInputs.splice(index, 1);
          }
        })
      }
      return avalibleInputs
    }

    vm.avalibleInputTypes = function(currentType) {
      var avalibleTypes = []
      var usedTypes = []
      angular.forEach(vm.selectedDoor.input, function(input) {
        usedTypes.push(input.type_id)
      })
      angular.forEach(vm.inputTypes, function(type) {
        if (usedTypes.indexOf(type.id) < 0 || type.id == currentType) {
          avalibleTypes.push(type)
        }
      })
      return avalibleTypes
    }

    vm.avalibleOutputTypes = function(currentType) {
      var avalibleTypes = []
      var usedTypes = []
      if (vm.selectedDoor) {
        angular.forEach(vm.selectedDoor.output, function(output) {
          usedTypes.push(output.type_id)
        })
      }
      angular.forEach(vm.outputTypes, function(type) {
        if (usedTypes.indexOf(type.id) < 0 || type.id == currentType) {
          avalibleTypes.push(type)
        }
      })
      return avalibleTypes
    }

    vm.addInput = function() {
      if (vm.avalibleInputs().length) {
        var inputIndex = vm.selectedDoor.input.push(
          {
            "type_id":vm.avalibleInputTypes()[0].id,
            "id":null,
            "input_number":vm.avalibleInputs()[0],
            "normally_closed":true,
            "pir":false,
            "notes":null,
            "schedule_id":null
          }
        )
        vm.selectedProperty = {'type':'input', 'data':vm.selectedDoor.input[inputIndex - 1]}
      }
    }

    vm.addOutput = function() {
      if (vm.avalibleOutputTypes().length) {
        var outputIndex = vm.selectedDoor.output.push(
          {
            "type_id": vm.avalibleOutputTypes()[0].id,
            "output_number": [],
            "sounder": false,
            "tone_id": 1,
            "momentary_duration": 0,
            "notes": null
          }
        )
        vm.selectedProperty = {'type':'output', 'data':vm.selectedDoor.output[outputIndex - 1]}
      }
    }

    vm.exit = function() {
      $location.url("/admin-door-config")
    }

    // Replace Door Modal Setup
    vm.replaceDoorDialog = function(){
      vm.replaceModalInstance = $uibModal.open({
          templateUrl: 'replaceModal.html',
          scope: $scope,
          size: 'md'
      })
      vm.newDoors = quantumApi.door.newDoors()
    }

    vm.closeReplaceModal = function(){
      vm.replaceModalInstance.dismiss();
    };


    vm.replaceDoor = function(serialNumber) {
      vm.selectedDoor.serial_number = serialNumber
      vm.closeReplaceModal()
    }

    // Copy Config Modal Setup
    vm.copyConfigDialog = function(){
      vm.copyModalInstance = $uibModal.open({
          templateUrl: 'copyModal.html',
          scope: $scope,
          size: 'md'
      })
      vm.existingDoors = quantumApi.door.query()
    }

    vm.closeCopyModal = function(){
      vm.copyModalInstance.dismiss();
    };


    vm.copyConfig = function(doorId) {
      quantumApi.door.get({'id':doorId}, function(data){
        // Check license before setting to wanderer door
        if (vm.doorUses.length > 1 && (data.use == 0 || data.use == 2)) {
          vm.selectedDoor.use = data.use
        } else {
          vm.selectedDoor.use = 1
        }
        vm.selectedDoor.settings = data.settings
        vm.selectedDoor.output = data.output
        vm.selectedDoor.input = data.input
      })
      vm.closeCopyModal()
    }

    vm.outputValid = function(output) {
      return (output.output_number.length > 0 || output.sounder)
    }

    vm.formValid = function() {
      var outputsValid = true
      angular.forEach(vm.selectedDoor.output, function(output) {
        if (!vm.outputValid(output)) {
          outputsValid = false
        }
      })
      return vm.form.$valid && (vm.selectedDoor.input.length > 0) && outputsValid
    }

    // --- START MAP ---

    vm.maps = []

    if (devMode.enabled) {
      vm.mapPath = 'http://'+devMode.serverIp+'/uploads/maps/'
    } else {
      vm.mapPath = '/uploads/maps/'
    }


    vm.maxBounds = leafletBoundsHelpers.createBoundsFromArray([[-270, -480], [270, 480]]);

    vm.mapDefaults = {
        scrollWheelZoom: false,
        crs: 'Simple'
    }

    vm.center = {lat: 0, lng: 0, zoom: 0}

    $scope.$on("leafletDirectiveMap.click", function(event, args){
      var leafEvent = args.leafletEvent;
      angular.forEach(vm.maps, function(map) {
        map.marker_data[0].lat = leafEvent.latlng.lat
        map.marker_data[0].lng = leafEvent.latlng.lng
      })
      vm.selectedDoor.map_data.lat = leafEvent.latlng.lat
      vm.selectedDoor.map_data.long = leafEvent.latlng.lng
    });

    // --- END MAP ---

    // Save

    vm.saveProperties = function(){
      vm.ladda = true

      if (vm.selectedDoor.id) {
        quantumApi.door.update({'id':vm.selectedDoor.id}, vm.selectedDoor).$promise
        .then(function(){
          vm.getDoor()
          toastr.success("Door Saved Successfully", "Success!")
          vm.ladda = false
        })
        .catch(function(err){
          $log.info(err)
          vm.ladda = false
          toastr.warning("Failed to Save Door", "Eror!")
        })
      } else {
        quantumApi.door.save({'id':vm.selectedDoor.id}, vm.selectedDoor).$promise
        .then(function(data){
          vm.getDoor()
          toastr.success("Door Saved Successfully", "Success!")
          vm.ladda = false
          $location.url("/admin-door-config/"+data.id)
        })
        .catch(function(err){
          $log.info(err)
          vm.ladda = false
          toastr.warning("Failed to Save Door", "Error!")
        })
      }


    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminCarePlanController', AdminCarePlanController);

  /** @ngInject */
  function AdminCarePlanController($log, toastr, quantumApi, $q, $location) {
    var vm = this;

    vm.selectedPlan = null
    vm.previousPlans = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.ladda = false

    vm.levels = quantumApi.careLevel.query()

    vm.levelById = function(levelId) {
      var levelToReturn
      angular.forEach(vm.levels, function(level) {
        if (level.id == levelId){
          levelToReturn = level
        }
      })
      return levelToReturn
    }

    quantumApi.staff.query(function(staffData){
      vm.staff = []
      angular.forEach(staffData, function(staffMember){
        if (staffMember.email) {
          vm.staff.push(staffMember)
        }
      })
    })

    vm.exit = function() {
      $location.path("admin-system-setup")
    }

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevPlan, nextPlan) {
      if (event.which == 38 && prevPlan) {
        event.preventDefault()
        vm.selectedPlan = prevPlan
      } else if (event.which == 40 && nextPlan) {
        event.preventDefault()
        vm.selectedPlan = nextPlan
      }
    }

    vm.getPlans = function() {
      vm.plans = []
      var promises = []
      quantumApi.carePlan.query(function(data){
        angular.forEach(data, function(plan) {
          if (plan.active) {
            promises.push(quantumApi.carePlan.get({id:plan.id}, function(plan){vm.plans.push(plan)}).$promise)
          }
        })
        $q.all(promises)
        .then(function(){
          vm.previousPlans = angular.copy(vm.plans)
          vm.selectedPlan = null
        })
      })
    }

    vm.getPlans()

    vm.addPlan = function() {
      var defaultObject = {
        "active": true,
        "id": null,
        "in_use": true,
        "level": [],
        "name": "New Care Plan",
        "staff": []
      }

      angular.forEach(vm.levels, function(level) {
        defaultObject.level.push({
          "cares": level.cares,
          "high_threshold": 0,
          "level_id": level.id,
          "low_threshold": 0
        })
      })

      vm.plans.push(defaultObject)
      vm.selectedPlan = vm.plans[vm.plans.length - 1]
    }

    vm.removePlan = function(index, plan) {
      if (!plan.in_use) {
        if (angular.equals(plan, vm.selectedPlan)) {
          vm.selectedPlan = null
        }
        if (plan.id) {
          plan.deleted = true
        } else if (!plan.id) {
          vm.plans.splice(index,1)
        }
      }
    }

    vm.plansValid = function(){
      var val = true
      angular.forEach(vm.plans, function(plan){
        if (!vm.planValid(plan)) {
          val = false
        }
      })
      return val
    }

    vm.planValid = function(plan) {
      var planValid = true
      if (!plan.name) {
        planValid = false
      }
      angular.forEach(plan.level, function(level) {
        if (level.low_threshold < 0 || level.high_threshold < 0 || level.low_threshold > level.high_threshold) {
          planValid = false
        }
      })

      return planValid
    }


    vm.savePlans = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.plans, function(plan, key) {
        if (plan.id && !plan.deleted) {
          if (!angular.equals(plan, vm.previousPlans[key])) {
            promises.push(quantumApi.carePlan.update({id:plan.id},plan).$promise)
          }
        } else if (plan.deleted) {
          promises.push(quantumApi.carePlan.delete({id:plan.id},plan).$promise)
        } else {
          promises.push(quantumApi.carePlan.save(plan).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getPlans()
        toastr.success("Plans Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Plans", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminCareLevelController', AdminCareLevelController);

  /** @ngInject */
  function AdminCareLevelController($log, toastr, quantumApi, $q, $location, $uibModal, $scope) {
    var vm = this;

    vm.selectedLevel = null
    vm.previousLevels = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.ladda = false
    vm.cares = []

    vm.exit = function() {
      $location.path("admin-system-setup")
    }

    vm.closeModal = function() {
      vm.assignModalInstance.dismiss();
    }

    vm.avaliableCares = function(currentCares) {
      var usedCares = []
      var avaliableCares = []
      angular.forEach(vm.levels, function(level) {
        if (!level.deleted) {
          usedCares = usedCares.concat(level.assigned_cares)
        }
      })
      angular.forEach(vm.cares, function(care) {
        if (usedCares.indexOf(care.id) == -1 || currentCares.indexOf(care.id) > -1) {
          avaliableCares.push(care)
        }
      })
      return avaliableCares
    }

    quantumApi.care.query(function(data){
      angular.forEach(data, function(care) {
        if (care.active) {
          vm.cares.push(care)
        }
      })
    })

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevLevel, nextLevel) {
      if (event.which == 38 && prevLevel) {
        event.preventDefault()
        vm.selectedLevel = prevLevel
      } else if (event.which == 40 && nextLevel) {
        event.preventDefault()
        vm.selectedLevel = nextLevel
      }
    }

    vm.getLevels = function() {
      vm.levels = []
      quantumApi.careLevel.query(function(data){
        angular.forEach(data, function(level) {
          if (level.active) {
            vm.levels.push(level)
          }
        })
        vm.previousLevels = angular.copy(vm.levels)
      })
      vm.selectedLevel = null
    }

    vm.getLevels()

    vm.addLevel = function() {
      vm.levels.push({
        "id":null,
        "assigned_cares":[],
        "name":"New Level"}
      )
      vm.selectedLevel = vm.levels[vm.levels.length - 1]
    }

    vm.removeLevel = function(index, level) {
        if (angular.equals(level, vm.selectedLevel)) {
          vm.selectedLevel = null
        }
        if (level.id) {
          level.deleted = true
        } else if (!level.id) {
          vm.levels.splice(index,1)
        }
        if (level.assigned_cares.length) {
          vm.assignModalInstance = $uibModal.open({
            templateUrl: 'deleteModal.html',
            scope: $scope,
            size: 'md'
          });
        }
    }

    vm.levelsValid = function(){
      var val = true
      angular.forEach(vm.levels, function(level){
        if (!vm.levelValid(level) && !level.deleted) {
          val = false
        }
      })
      return val
    }

    vm.levelValid = function(level) {
      return level.name != "" && level.assigned_cares.length
    }


    vm.saveLevels = function(){
      vm.ladda = true
      var promises = []
      var planAdded = false
      var firstRun = true
      angular.forEach(vm.levels, function(level, key) {
        if (level.id && !level.deleted) {
          if (!angular.equals(level, vm.previousLevels[key])) {
            promises.push(quantumApi.careLevel.update({id:level.id},level).$promise)
          }
          firstRun = false
        } else if (level.deleted) {
          promises.push(quantumApi.careLevel.delete({id:level.id},level).$promise)
          firstRun = false
        } else {
          planAdded = true
          promises.push(quantumApi.careLevel.save(level).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        if (planAdded && !firstRun) {
          vm.assignModalInstance = $uibModal.open({
              templateUrl: 'confirmModal.html',
              scope: $scope,
              size: 'md'
          });
        }
        vm.getLevels()
        toastr.success("Levels Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Levels", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminCareConfigController', AdminCareConfigController);

  /** @ngInject */
  function AdminCareConfigController($log, toastr, quantumApi, $q, $location) {
    var vm = this;

    vm.selectedCare = null
    vm.previousCares = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.ladda = false
    vm.cares = []

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.exit = function() {
      $location.path("admin-system-setup")
    }

    vm.keypress = function(event, prevCare, nextCare) {
      if (event.which == 38 && prevCare) {
        event.preventDefault()
        vm.selectedCare = prevCare
      } else if (event.which == 40 && nextCare) {
        event.preventDefault()
        vm.selectedCare = nextCare
      }
    }

    vm.getCares = function() {
      quantumApi.care.query(function(data){
        vm.cares = []
        angular.forEach(data, function(care) {
          if(care.active) {
            vm.cares.push(care)
          }
        })
        vm.previousCares = angular.copy(vm.cares)
      })
      vm.selectedCare = null
    }

    vm.getCares()

    vm.addCare = function() {
      vm.cares.push({
        id:null,
        name:"New care",
        expected_care_time:null
      })
      vm.selectedCare = vm.cares[vm.cares.length - 1]
    }

    vm.removeCare = function(index, care) {
        if (angular.equals(care, vm.selectedCare)) {
          vm.selectedCare = null
        }
        if (care.id) {
          care.deleted = true
        } else if (!care.id) {
          vm.cares.splice(index,1)
        }

    }

    vm.caresValid = function(){
      var val = true
      angular.forEach(vm.cares, function(care){
        if (!vm.careValid(care)) {
          val = false
        }
      })
      return val
    }

    vm.careValid = function(care) {
      return care.name && (care.expected_care_time == null || care.expected_care_time > 0)
    }


    vm.saveCares = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.cares, function(care, key) {
        if (care.id && !care.deleted) {
          if (!angular.equals(care, vm.previousCares[key])) {
            promises.push(quantumApi.care.update({id:care.id},care).$promise)
          }
        } else if (care.deleted) {
          promises.push(quantumApi.care.delete({id:care.id},care).$promise)
        } else {
          promises.push(quantumApi.care.save(care).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getCares()
        toastr.success("Cares Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Cares", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminBridgeConfigController', AdminBridgeConfigController);

  /** @ngInject */
  function AdminBridgeConfigController($log, toastr, quantumApi, $q) {
    var vm = this;

    vm.selectedBridge = null
    vm.previousBridges = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.ladda = false

    vm.areas = quantumApi.area.query()


    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevBridge, nextBridge) {
      if (event.which == 38 && prevBridge) {
        event.preventDefault()
        vm.selectedBridge = prevBridge
      } else if (event.which == 40 && nextBridge) {
        event.preventDefault()
        vm.selectedBridge = nextBridge
      }
    }

    vm.getBridges = function() {
      vm.bridges = quantumApi.bridge.query(function(data){
        vm.previousBridges = angular.copy(data)
      })
      vm.selectedBridge = null
    }

    vm.getBridges()

    vm.addBridge = function() {
      vm.bridges.push({
        id:null,
        name:"New bridge",
        checkin_staff:[]
      })
      vm.selectedBridge = vm.bridges[vm.bridges.length - 1]
    }

    vm.removeBridge = function(index, bridge) {
        if (angular.equals(bridge, vm.selectedBridge)) {
          vm.selectedBridge = null
        }
        if (bridge.id && bridge.id != 1) {
          bridge.deleted = true
        } else if (!bridge.id) {
          vm.bridges.splice(index,1)
        }

    }

    vm.bridgesValid = function(){
      var val = true
      angular.forEach(vm.bridges, function(bridge){
        if (!bridge.name) {
          val = false
        }
      })
      return val
    }

    vm.bridgeValid = function(group) {
      return group
    }


    vm.saveBridges = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.bridges, function(bridge, key) {
        if (bridge.id && !bridge.deleted) {
          if (!angular.equals(bridge, vm.previousBridges[key])) {
            promises.push(quantumApi.bridge.update({id:bridge.id},bridge).$promise)
          }
        } else if (bridge.deleted) {
          promises.push(quantumApi.bridge.delete({id:bridge.id},bridge).$promise)
        } else {
          promises.push(quantumApi.bridge.save(bridge).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getBridges()
        toastr.success("Bridges Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Bridges", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminAllegionManagementController', AdminAllegionManagementController);

  /** @ngInject */
  function AdminAllegionManagementController($log, toastr, quantumApi, $location, $uibModal, $scope) {
    var vm = this;

    vm.selectedGateway = null
    vm.searchFilter = ""
    vm.gateways = []
    vm.ladda = false
    vm.gatewayPendingReboot = null
    vm.gatewayToAdd = null
    vm.currentGweFirmware

    // Firmware Update

    quantumApi.allegionCurrentFirmware.query(function(data){
      angular.forEach(data, function(value) {
        // Inconsistance in the alligion api -  leading zeros in some routes and not others
        if (value.model == 'gwe') {
          if (value.version.charAt(0) == 0) {
            vm.currentGweFirmware = value.version.substring(1)
          } else {
            vm.currentGweFirmware = value.version
          }
        }
      })
    })

    vm.firmwareCheck = function(fwVer) {
      return fwVer != vm.currentGweFirmware
    }

    vm.updateFirmware = function(gwid) {
      var eventObj = {
        "hw_id": gwid,
        "event_code":"GFU",
        "staff_id":null,
        "resident_id":null,
        "payload":{}
      }
      quantumApi.events.save(eventObj).$promise
      .then(function(){
        toastr.success("Firmware Update Started", "Success!")
      })
      .catch(function(){
        toastr.warning("Failed to Update Firmware", "Error!")
      })
    }

    // Add Modal Setup
    vm.addGatewayDialog = function(){
      vm.addModalInstance = $uibModal.open({
          templateUrl: 'addModal.html',
          scope: $scope,
          size: 'md'
      })
      vm.newGateways = quantumApi.allegionNewHardware.query()
    }

    vm.closeAddModal = function(){
      vm.gatewayToAdd = null
      vm.addModalInstance.dismiss();
    };

    vm.configGateway = function(hw_address) {
      vm.gatewayToAdd = {
        hw_address: hw_address,
        name: null,
        ip_address: null
      }
    }

    vm.addGateway = function(gateway) {
      quantumApi.allegionGateway.save(gateway).$promise
      .then(function(){
        vm.gatewayToAdd = null
        vm.newGateways = quantumApi.allegionNewHardware.query()
        vm.getGateways()
        toastr.success("Gateway Added", "Success!")
      })
      .catch(function(){
        vm.newGateways = quantumApi.allegionNewHardware.query()
        vm.getGateways()
        toastr.warning("Failed to Add Gateway", "Error!")
      })
    }

    // Delete Modal Setup
    vm.removeGatewayDialog = function(gateway){
      if (!gateway.attached_locks.length){
        vm.selectedGateway = gateway
        vm.deleteModalInstance = $uibModal.open({
          templateUrl: 'confirmModal.html',
          scope: $scope,
          size: 'md'
        });
      }
    }

    vm.closeModal = function(){
      vm.deleteModalInstance.dismiss();
      vm.selectedRepeater = null
    };


    vm.deleteGateway = function(gateway) {
      vm.ladda = true
      quantumApi.allegionGateway.delete({'id':gateway.id}).$promise
      .then(function(){
        vm.selectedGateway = null
        vm.closeModal()
        vm.getGateways()
      })
      .catch(function(){
        vm.closeModal()
        vm.getGateways()
        toastr.warning("Failed to Remove Gateway", "Error!")
      })
      .finally(function(){
        vm.ladda = false
      })
    }


    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.getGateways = function() {
      vm.gateways = quantumApi.allegionGateway.query()
      vm.selectedGateway = null
    }

    vm.getGateways()

    vm.prettyGatewayUse = function(use) {
      if (use == 0) {
        return "Wanderer Monitoring"
      } else if (use == 1) {
        return "Access Control"
      } else if (use == 2) {
        return "Access Control and Wanderer Monitoring"
      }
    }


    vm.loadGateway = function(gateway){
      $location.url("admin-allegion-management/"+gateway.id)
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminAllegionManagementEditorController', AdminAllegionManagementEditorController);

  /** @ngInject */
  function AdminAllegionManagementEditorController($log, toastr, quantumApi, $q, $routeParams, $rootScope, $scope, $timeout, $uibModal, $location) {
    var vm = this;

    vm.selectedLock = null
    vm.previousLocks = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.ladda = false
    vm.currentNdeFirmware = null
    vm.selectedGateway = null

    var hwId = parseInt($routeParams.id)
    vm.pendingScanRequestId = null
    vm.pendingAddRequestId = null
    vm.apartments = quantumApi.apartment.query()

    // Firmware Update

    quantumApi.allegionCurrentFirmware.query(function(data){
      angular.forEach(data, function(value) {
        if (value.model == 'nde') {
          vm.currentNdeFirmware = value.version
        }
      })
    })

    vm.firmwareCheck = function() {
      var newFirmwareNeeded = false
      angular.forEach(vm.locks, function(value) {
        if (value.params.fwVer.main != vm.currentNdeFirmware) {
          newFirmwareNeeded = true
        }
      })
      return newFirmwareNeeded
    }

    vm.updateFirmware = function() {
      var eventObj = {
        "hw_id": hwId,
        "event_code":"LFU",
        "staff_id":null,
        "resident_id":null,
        "payload":{}
      }
      quantumApi.events.save(eventObj).$promise
      .then(function(){
        toastr.success("Firmware Update Started", "Success!")
      })
      .catch(function(){
        toastr.warning("Failed to Update Firmware", "Error!")
      })
    }

    // Utility Functions
    vm.clearApt = function($event) {
      $event.stopPropagation();
      vm.selectedLock.data.apartment_id = null;
    };

    vm.exit = function() {
      $location.path("admin-allegion-management")
    }

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevLock, nextLock) {
      if (event.which == 38 && prevLock) {
        event.preventDefault()
        vm.selectedLock.data = prevLock
      } else if (event.which == 40 && nextLock) {
        event.preventDefault()
        vm.selectedLock.data = nextLock
      }
    }

    vm.sendCreds = function(door) {
      vm.lockedLadda = true
      var eventObj = {
        "hw_id": door.id,
        "event_code":"SAL",
        "staff_id":null,
        "resident_id":null,
        "payload":{"link_id":door.link_id,"gateway_id":door.gateway_id}
      }
      quantumApi.events.save(eventObj).$promise
      .then(function(){
        toastr.success("Credentials Sent Successfully", "Success!")
      })
      .catch(function(){
        toastr.warning("Failed to Save Credentials", "Error!")
      })
    }

    vm.getLocks = function() {
      var finalLockArray = []
      var lockPromises =  []

      quantumApi.allegionGateway.get({id:hwId}, function(data){
        vm.selectedGateway = data
        angular.forEach(data.attached_locks, function(lock) {
          lockPromises.push(quantumApi.allegionLock.get({id:lock.id},function(data){finalLockArray.push(data)}).$promise)
        })

        $q.all(lockPromises)
        .then(function(){
          vm.previousLocks = angular.copy(finalLockArray)
          vm.locks = angular.copy(finalLockArray)
          vm.selectedLock = {'type':'gw', 'data':data}
        })

      })


    }

    vm.getLocks()

    // ---- START Add Lock from Gateway Scan ----

    vm.addLock = function() {
      vm.availableLocks = []
      quantumApi.events.save({"hw_id":hwId,"event_code":"GSR","staff_id":null,"resident_id":null}).$promise
      .then(function(data){
        vm.pendingScanRequestId = data.id
      })

      $timeout(scanTimeout, 12000)
    }

    var processGatewayResponse = function(gatewayResponse) {
      if (gatewayResponse.eventId == vm.pendingScanRequestId) {
        vm.pendingScanRequestId = null
        vm.availableLocks = gatewayResponse.payload.gatewayScanList
        vm.addModalInstance = $uibModal.open({
          backdrop: 'static',
          templateUrl: 'addModal.html',
          scope: $scope,
          size: 'md'
        })
      } else if (gatewayResponse.eventId == vm.pendingAddRequestId) {
        if (gatewayResponse.payload.success) {
          vm.pendingAddRequestId = null
          vm.addModalInstance.dismiss();
          toastr.success("Success!","Lock Added to Gateway Successfully")
          vm.getLocks()
        } else {
          vm.pendingAddRequestId = null
          toastr.warning("Error!","Unable to Add Lock to Gateway")
          vm.addModalInstance.dismiss();
        }
      }
    }

    var scanTimeout = function() {
      if(vm.pendingScanRequestId) {
        vm.pendingScanRequestId = null
        toastr.warning("Error!","No Response from Gateway")
      }
    }

    var eventListener = $rootScope.$on('requestReply', function(event, data){
      processGatewayResponse(data)
    })

    // When navigating away, cancel the intercal
    $scope.$on('$destroy', function () {
      eventListener()
    });

    vm.closeModal = function(){
      vm.availableLocks = []
      vm.addModalInstance.dismiss();
    };

    // ---- END Add Lock from Gateway Scan ----

    // ---- Save Lock to Gateway Scan ----

    var addTimeout = function() {
      if(vm.pendingAddRequestId) {
        vm.pendingAddRequestId = null
        toastr.warning("Error!","Unable to Add Lock to Gateway")
        vm.addModalInstance.dismiss();
      }
    }

    vm.addLocktoGateway = function(deviceObj, lock) {
      lock.adding = true
      // SAMPLE DATA
      vm.pendingAddRequestId = 1
      $timeout(addTimeout, 12000)
      var eventObj = {
        "hw_id": hwId,
        "event_code":"ADD",
        "staff_id":null,
        "resident_id":null,
        "payload": deviceObj
      }
      quantumApi.events.save(eventObj).$promise
      .then(function(data){
        vm.pendingAddRequestId = data.id
      })
    }

    // ---- END Lock to Gateway Scan ----

    vm.removeLock = function(index, lock) {
        if (angular.equals(lock, vm.selectedLock.data)) {
          vm.selectedLock.data = null
        }
        if (lock.id && lock.id != 1) {
          lock.deleted = true
        } else if (!lock.id) {
          vm.locks.splice(index,1)
        }
    }

    vm.locksValid = function(){
      var val = true
      angular.forEach(vm.locks, function(lock){
        if (!vm.lockValid(lock)) {
          val = false
        }
      })
      return val
    }

    vm.lockValid = function(lock) {
      return lock.name && lock.relock_time > 0
    }

    vm.gatewayValid = function() {
      return vm.selectedGateway.name
    }


    vm.saveLocks = function(){
      vm.ladda = true
      var promises = []
      promises.push(quantumApi.allegionGateway.update({id:vm.selectedGateway.id}, vm.selectedGateway).$promise)
      angular.forEach(vm.locks, function(lock, key) {
        if (lock.id && !lock.deleted) {
          if (!angular.equals(lock, vm.previousLocks[key])) {
            promises.push(quantumApi.allegionLock.update({id:lock.id},lock).$promise)
          }
        } else if (lock.deleted) {
          promises.push(quantumApi.allegionLock.delete({id:lock.id},lock).$promise)
        } else {
          promises.push(quantumApi.allegionLock.save(lock).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getLocks()
        toastr.success("Devices Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Devices", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .controller('AdminAlertDeviceController', AdminAlertDeviceController);

  /** @ngInject */
  function AdminAlertDeviceController($log, toastr, quantumApi, $q, $location) {
    var vm = this;

    vm.selectedDevice = null
    vm.searchFilter = ""
    vm.filteredList = null
    vm.staff = []
    vm.ladda = false
    vm.interfaces = []
    vm.previousDevices

    //Get the interfaces
    quantumApi.outputInterface.query(function(data){
      angular.forEach(data, function(outputInterface) {
        vm.interfaces.push(outputInterface)
      })
    })

    vm.avaliblePhones = quantumApi.newPhone.query()

    vm.exit = function() {
      $location.path("admin-system-setup")
    }

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    // Helper function to determine if the selected interface is a Quantum Mobile Interface
    vm.isMobile = function(alertDevice) {
      var isMobile = false
      angular.forEach(vm.interfaces, function(interfaceRecord) {
        if (interfaceRecord.id == alertDevice.interface_id) {
          if (interfaceRecord.connection_type == 13) {
            isMobile = true
          }
        }
      })
      return isMobile
    }

    vm.keypress = function(event, prevDevice, nextDevice) {
      if (event.which == 38 && prevDevice) {
        event.preventDefault()
        vm.selectedDevice = prevDevice
      } else if (event.which == 40 && nextDevice) {
        event.preventDefault()
        vm.selectedDevice = nextDevice
      }
    }

    vm.getDevices = function() {
      vm.devices = quantumApi.alertDevice.query(function(data){
        vm.previousDevices = angular.copy(data)
      })
      vm.avaliblePhones = quantumApi.newPhone.query()
      vm.selectedDevice = null
    }

    vm.getDevices()

    vm.addDevice = function() {
      vm.devices.push({
        "id": null,
        "interface_id": vm.interfaces[0].id,
        "name": "New Device",
        "contact_value": null,
        "in_use": null,
        "interface_type": null,
        "extension":"",
        "interface_name": null
      })
      vm.selectedDevice = vm.devices[vm.devices.length - 1]
    }

    vm.removeDevice = function(index, device) {
        if (angular.equals(device, vm.selectedDevice)) {
          vm.selectedDevice = null
        }
        if (device.id && !device.in_use) {
          device.deleted = true
        } else if (!device.id) {
          vm.devices.splice(index,1)
        }

    }

    vm.deviceValid = function(device){
      return (device.name && device.contact_value)
    }

    vm.devicesValid = function(){
      var val = true
      angular.forEach(vm.devices, function(device){
        if (!device.name || !device.contact_value) {
          val = false
        }
      })
      return val
    }


    vm.saveDevices = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.devices, function(device, key) {
        if (device.id && !device.deleted) {
          if (!angular.equals(device, vm.previousDevices[key])) {
            promises.push(quantumApi.alertDevice.update({id:device.id},device).$promise)
          }
        } else if (device.deleted) {
          promises.push(quantumApi.alertDevice.delete({id:device.id},device).$promise)
        } else {
          promises.push(quantumApi.alertDevice.save(device).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getDevices()
        toastr.success("Devices Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(error){
        $log.info(error)
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('quantumUiAngular')
  .run(runBlock);

  /** @ngInject */
  function runBlock($location, $rootScope, userAuth) {
  //function runBlock($location, $rootScope, userAuth, $cookies, Idle) {

    // if (typeof $cookies.get('user') != 'undefined') {
    //   userAuth.data = $cookies.getObject('user')
    //   if (userAuth.data.logout_timeout > 0) {
    //     Idle.setIdle(userAuth.data.logout_timeout*60)
    //     Idle.watch()
    //   }
    // }

    // Redirect when logged out
    var redirectCalback = $rootScope.$on( "$routeChangeStart", function() {
      if (!userAuth.data.id) {
        $location.path("/login");
      }
    })

    $rootScope.$on('$destroy', redirectCalback)

  }

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .config(routeConfig);

  function routeConfig($routeProvider) {
    $routeProvider
      // Default Routes
      .when('/', {
        templateUrl: 'app/dashboard/dashboard.html',
        controller: 'DashboardController',
        controllerAs: 'vm'
      })
      .when('/login', {
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'vm'
      })
      .when('/map',
        {templateUrl: 'app/map/map.html',
        controller: 'MapController',
        controllerAs: 'vm'
      })
      // Door Control
      .when('/door-status', {
        templateUrl: 'app/door-status/door-status.html',
        controller: 'DoorStatusController',
        controllerAs: 'vm'
      })
      .when('/door-status-allegion', {
        templateUrl: 'app/door-status-allegion/door-status-allegion.html',
        controller: 'DoorStatusAllegionController',
        controllerAs: 'vm'
      })
      .when('/door-access-create', {
        templateUrl: 'app/door-access/door-access-create.html',
        controller: 'DoorAccessController',
        controllerAs: 'vm'
      })
      .when('/door-access-change', {
        templateUrl: 'app/door-access/door-access-change.html',
        controller: 'DoorAccessController',
        controllerAs: 'vm'
      })
      .when('/door-access-remove', {
        templateUrl: 'app/door-access/door-access-remove.html',
        controller: 'DoorAccessController',
        controllerAs: 'vm'
      })
      .when('/door-access-allegion-create', {
        templateUrl: 'app/door-access-allegion/door-access-allegion-create.html',
        controller: 'DoorAccessAllegionController',
        controllerAs: 'vm'
      })
      .when('/door-access-allegion-change', {
        templateUrl: 'app/door-access-allegion/door-access-allegion-change.html',
        controller: 'DoorAccessAllegionController',
        controllerAs: 'vm'
      })
      .when('/door-access-allegion-remove', {
        templateUrl: 'app/door-access-allegion/door-access-allegion-remove.html',
        controller: 'DoorAccessAllegionController',
        controllerAs: 'vm'
      })
      // Schedules
      // One Time
      .when('/schedule-onetime-access',
        {templateUrl: 'app/schedule-onetime/schedule-onetime-access.html',
        controller: 'ScheduleOnetimeController',
        controllerAs: 'vm'
      })
      .when('/schedule-onetime-wanderer',
        {templateUrl: 'app/schedule-onetime/schedule-onetime-wanderer.html',
        controller: 'ScheduleOnetimeController',
        controllerAs: 'vm'
      })
      .when('/schedule-onetime-remove',
        {templateUrl: 'app/schedule-onetime/schedule-onetime-remove.html',
        controller: 'ScheduleOnetimeController',
        controllerAs: 'vm'
      })
      // Access Control
      .when('/schedule-weekly-access-control-create', {
        templateUrl: 'app/schedule-weekly-access-control/schedule-weekly-access-control-create.html',
        controller: 'ScheduleWeeklyAccessControlController',
        controllerAs: 'vm'
      })
      .when('/schedule-weekly-access-control-change', {
        templateUrl: 'app/schedule-weekly-access-control/schedule-weekly-access-control-change.html',
        controller: 'ScheduleWeeklyAccessControlController',
        controllerAs: 'vm'
      })
      .when('/schedule-weekly-access-control-remove', {
        templateUrl: 'app/schedule-weekly-access-control/schedule-weekly-access-control-remove.html',
        controller: 'ScheduleWeeklyAccessControlController',
        controllerAs: 'vm'
      })
      // Wanderer
      .when('/schedule-weekly-wanderer-create', {
        templateUrl: 'app/schedule-weekly-wanderer/schedule-weekly-wanderer-create.html',
        controller: 'ScheduleWeeklyWandererController',
        controllerAs: 'vm'
      })
      .when('/schedule-weekly-wanderer-change', {
        templateUrl: 'app/schedule-weekly-wanderer/schedule-weekly-wanderer-change.html',
        controller: 'ScheduleWeeklyWandererController',
        controllerAs: 'vm'
      })
      .when('/schedule-weekly-wanderer-remove', {
        templateUrl: 'app/schedule-weekly-wanderer/schedule-weekly-wanderer-remove.html',
        controller: 'ScheduleWeeklyWandererController',
        controllerAs: 'vm'
      })
      // Staff
      .when('/schedule-weekly-staff-create', {
        templateUrl: 'app/schedule-weekly-staff/schedule-weekly-staff-create.html',
        controller: 'ScheduleWeeklyStaffController',
        controllerAs: 'vm'
      })
      .when('/schedule-weekly-staff-change', {
        templateUrl: 'app/schedule-weekly-staff/schedule-weekly-staff-change.html',
        controller: 'ScheduleWeeklyStaffController',
        controllerAs: 'vm'
      })
      .when('/schedule-weekly-staff-remove', {
        templateUrl: 'app/schedule-weekly-staff/schedule-weekly-staff-remove.html',
        controller: 'ScheduleWeeklyStaffController',
        controllerAs: 'vm'
      })
      // IO Repeater
      .when('/schedule-io-repeater-create', {
        templateUrl: 'app/schedule-io-repeater/schedule-io-repeater-create.html',
        controller: 'ScheduleIoRepeaterController',
        controllerAs: 'vm'
      })
      .when('/schedule-io-repeater-change', {
        templateUrl: 'app/schedule-io-repeater/schedule-io-repeater-change.html',
        controller: 'ScheduleIoRepeaterController',
        controllerAs: 'vm'
      })
      .when('/schedule-io-repeater-remove', {
        templateUrl: 'app/schedule-io-repeater/schedule-io-repeater-remove.html',
        controller: 'ScheduleIoRepeaterController',
        controllerAs: 'vm'
      })
      // Check In
      .when('/schedule-check-in-create', {
        templateUrl: 'app/schedule-check-in/schedule-check-in-create.html',
        controller: 'ScheduleCheckInController',
        controllerAs: 'vm'
      })
      .when('/schedule-check-in-change', {
        templateUrl: 'app/schedule-check-in/schedule-check-in-change.html',
        controller: 'ScheduleCheckInController',
        controllerAs: 'vm'
      })
      .when('/schedule-check-in-remove', {
        templateUrl: 'app/schedule-check-in/schedule-check-in-remove.html',
        controller: 'ScheduleCheckInController',
        controllerAs: 'vm'
      })
      // Residents
      .when('/resident-status',
        {templateUrl: 'app/resident-status/resident-status.html',
        controller: 'ResidentStatusController',
        controllerAs: 'vm'
      })
      .when('/resident-insight/:id',
        {templateUrl: 'app/resident-insight/resident-insight.html',
        controller: 'ResidentInsightController',
        controllerAs: 'vm'
      })
      .when('/resident-admit',
        {templateUrl: 'app/resident/resident-admit.html',
        controller: 'ResidentController',
        controllerAs: 'vm'
      })
      .when('/resident-change',
        {templateUrl: 'app/resident/resident-change.html',
        controller: 'ResidentController',
        controllerAs: 'vm'
      })
      .when('/resident-discharge',
        {templateUrl: 'app/resident/resident-discharge.html',
        controller: 'ResidentController',
        controllerAs: 'vm'
      })
      .when('/family-create',
        {templateUrl: 'app/family/family-create.html',
        controller: 'FamilyController',
        controllerAs: 'vm'
      })
      .when('/family-change',
        {templateUrl: 'app/family/family-change.html',
        controller: 'FamilyController',
        controllerAs: 'vm'
      })
      .when('/family-remove',
        {templateUrl: 'app/family/family-remove.html',
        controller: 'FamilyController',
        controllerAs: 'vm'
      })
      .when('/resident-scheduled-leave-create',
        {templateUrl: 'app/resident-scheduled-leave/resident-scheduled-leave-create.html',
        controller: 'ResidentScheduledLeaveController',
        controllerAs: 'vm'
      })
      .when('/resident-scheduled-leave-remove',
        {templateUrl: 'app/resident-scheduled-leave/resident-scheduled-leave-remove.html',
        controller: 'ResidentScheduledLeaveController',
        controllerAs: 'vm'
      })
      .when('/resident-transmitter-power',
        {templateUrl: 'app/resident-transmitter-power/resident-transmitter-power.html',
        controller: 'ResidentTransmitterPowerController',
        controllerAs: 'vm'
      })
      // Fixed Device
      .when('/fixed-device-status',
        {templateUrl: 'app/fixed-device-status/fixed-device-status.html',
        controller: 'FixedDeviceController',
        controllerAs: 'vm'
      })
      .when('/fixed-quantum-device-create',
        {templateUrl: 'app/fixed-quantum-device/fixed-quantum-device-create.html',
        controller: 'FixedQuantumDeviceController',
        controllerAs: 'vm'
      })
      .when('/fixed-quantum-device-change',
        {templateUrl: 'app/fixed-quantum-device/fixed-quantum-device-change.html',
        controller: 'FixedQuantumDeviceController',
        controllerAs: 'vm'
      })
      .when('/fixed-quantum-device-replace',
        {templateUrl: 'app/fixed-quantum-device/fixed-quantum-device-replace.html',
        controller: 'FixedQuantumDeviceController',
        controllerAs: 'vm'
      })
      .when('/fixed-quantum-device-remove',
        {templateUrl: 'app/fixed-quantum-device/fixed-quantum-device-remove.html',
        controller: 'FixedQuantumDeviceController',
        controllerAs: 'vm'
      })
      .when('/fixed-integrated-device-change',
        {templateUrl: 'app/fixed-integrated-device/fixed-integrated-device.html',
        controller: 'FixedIntegratedDeviceController',
        controllerAs: 'vm'
      })
      .when('/fixed-third-party-device-change',
        {templateUrl: 'app/fixed-third-party-device-change/fixed-third-party-device-change.html',
        controller: 'FixedSaraDeviceChangeController',
        controllerAs: 'vm'
      })
      //Staff
      .when('/staff-status',
        {templateUrl: 'app/staff-status/staff-status.html',
        controller: 'StaffStatusController',
        controllerAs: 'vm'
      })
      .when('/staff-create',
        {templateUrl: 'app/staff/staff-create.html',
        controller: 'StaffController',
        controllerAs: 'vm'
      })
      .when('/staff-change',
        {templateUrl: 'app/staff/staff-change.html',
        controller: 'StaffController',
        controllerAs: 'vm'
      })
      .when('/staff-remove',
        {templateUrl: 'app/staff/staff-remove.html',
        controller: 'StaffController',
        controllerAs: 'vm'
      })
      .when('/staff-send-message',
        {templateUrl: 'app/staff-send-message/staff-send-message.html',
        controller: 'StaffSendMessageController',
        controllerAs: 'vm'
      })
      .when('/staff-messenger',
        {templateUrl: 'app/staff-messenger/staff-messenger.html',
        controller: 'StaffMessengerController',
        controllerAs: 'vm'
      })
      .when('/staff-messenger-group-create',
        {templateUrl: 'app/staff-messenger-group/staff-messenger-group-create.html',
        controller: 'StaffMessengerGroupController',
        controllerAs: 'vm'
      })
      .when('/staff-messenger-group-change',
        {templateUrl: 'app/staff-messenger-group/staff-messenger-group-change.html',
        controller: 'StaffMessengerGroupController',
        controllerAs: 'vm'
      })
      .when('/staff-messenger-group-remove',
        {templateUrl: 'app/staff-messenger-group/staff-messenger-group-remove.html',
        controller: 'StaffMessengerGroupController',
        controllerAs: 'vm'
      })
      //Site
      .when('/area',
        {templateUrl: 'app/site-area/area.html',
        controller: 'AreaController',
        controllerAs: 'vm'
      })
      .when('/apartment',
        {templateUrl: 'app/site-apartment/apartment.html',
        controller: 'ApartmentController',
        controllerAs: 'vm'
      })
      // Reports
      .when('/report-alarm-history', {
        templateUrl: 'app/report-alarm-history/report-alarm-history.html',
        controller: 'ReportAlarmHistoryController',
        controllerAs: 'vm'
      })
      .when('/report-care',
        {templateUrl: 'app/report-care/report-care.html',
        controller: 'ReportCareController',
        controllerAs: 'vm'
      })
      .when('/report-daily-event', {
        templateUrl: 'app/report-daily-event/report-daily-event.html',
        controller: 'ReportDailyEventController',
        controllerAs: 'vm'
      })
      .when('/report-daily-checkin', {
        templateUrl: 'app/report-daily-checkin/report-daily-checkin.html',
        controller: 'ReportDailyCheckinController',
        controllerAs: 'vm'
      })
      .when('/report-staff-care',
        {templateUrl: 'app/report-staff-care/report-staff-care.html',
        controller: 'ReportStaffCareController',
        controllerAs: 'vm'
      })
      .when('/report-credential',
        {templateUrl: 'app/report-credential/report-credential.html',
        controller: 'ReportCredentialController',
        controllerAs: 'vm'
      })
      .when('/report-door-configuration',
        {templateUrl: 'app/report-door-configuration/report-door-configuration.html',
        controller: 'ReportDoorConfigurationController',
        controllerAs: 'vm'
      })
      .when('/report-duplicate-name',
        {templateUrl: 'app/report-duplicate-name/report-duplicate-name.html',
        controller: 'ReportDuplicateNameController',
        controllerAs: 'vm'
      })
      .when('/report-untested-device',
        {templateUrl: 'app/report-untested-device/report-untested-device.html',
        controller: 'ReportUntestedDeviceController',
        controllerAs: 'vm'
      })
      .when('/report-serial-number',
        {templateUrl: 'app/report-serial-number/report-serial-number.html',
        controller: 'ReportSerialNumberController',
        controllerAs: 'vm'
      })
      .when('/report-transmitter-history',
        {templateUrl: 'app/report-transmitter-history/report-transmitter-history.html',
        controller: 'ReportTransmitterHistoryController',
        controllerAs: 'vm'
      })
      .when('/report-transmitter-test',
        {templateUrl: 'app/report-transmitter-test/report-transmitter-test.html',
        controller: 'ReportTransmitterTestController',
        controllerAs: 'vm'
      })
      .when('/report-system-status', {
        templateUrl: 'app/report-system-status/report-system-status.html',
        controller: 'ReportSystemStatusController',
        controllerAs: 'vm'
      })
      .when('/report-active-mobile-users',
        {templateUrl: 'app/report-active-mobile-users/report-active-mobile-users.html',
        controller: 'ReportActiveMobileUsersController',
        controllerAs: 'vm'
      })
      // Backend Admin
      // System
      .when('/admin-system-setup',
        {templateUrl: 'app/admin-system-setup/admin-system-setup.html',
        controller: 'AdminSystemSetupController',
        controllerAs: 'vm'
      })
      .when('/admin-system-config',
        {templateUrl: 'app/admin-system-config/admin-system-config.html',
        controller: 'AdminSystemConfigController',
        controllerAs: 'vm'
      })
      .when('/admin-staff-access-group',
        {templateUrl: 'app/admin-staff-access-group/admin-staff-access-group.html',
        controller: 'AdminStaffAccessGroupController',
        controllerAs: 'vm'
      })
      .when('/admin-input-interface',
        {templateUrl: 'app/admin-input-interface/admin-input-interface.html',
        controller: 'AdminInputInterfaceController',
        controllerAs: 'vm'
      })
      .when('/admin-quantum-upgrade-manager',
        {templateUrl: 'app/admin-quantum-upgrade-manager/admin-quantum-upgrade-manager.html',
        controller: 'AdminQuantumUpgradeManagerController',
        controllerAs: 'vm'
      })
      .when('/admin-map-config',
        {templateUrl: 'app/admin-map-config/admin-map-config.html',
        controller: 'AdminMapConfigController',
        controllerAs: 'vm'
      })
      // Imports
      .when('/admin-pullcord-utility',
        {templateUrl: 'app/admin-pullcord-utility/admin-pullcord-utility.html',
        controller: 'AdminPullcordUtilityController',
        controllerAs: 'vm'
      })
      .when('/admin-staff-import',
        {templateUrl: 'app/admin-staff-import/admin-staff-import.html',
        controller: 'AdminStaffImportController',
        controllerAs: 'vm'
      })
      .when('/admin-third-party-pullcord-import',
        {templateUrl: 'app/admin-third-party-pullcord-import/admin-third-party-pullcord-import.html',
        controller: 'AdminSaraPullcordImportController',
        controllerAs: 'vm'
      })
      .when('/admin-pullcord-import',
        {templateUrl: 'app/admin-pullcord-import/admin-pullcord-import.html',
        controller: 'AdminPullcordImportController',
        controllerAs: 'vm'
      })
      .when('/admin-resident-import',
        {templateUrl: 'app/admin-resident-import/admin-resident-import.html',
        controller: 'AdminResidentImportController',
        controllerAs: 'vm'
      })
      .when('/admin-inovonics-location-utility',
        {templateUrl: 'app/admin-inovonics-location-utility/admin-inovonics-location-utility.html',
        controller: 'AdminInovonicsLocationUtilityController',
        controllerAs: 'vm'
      })
      .when('/admin-inovonics-location-utility/:id',
        {templateUrl: 'app/admin-inovonics-location-utility/admin-inovonics-location-utility-editor.html',
        controller: 'AdminInovonicsLocationUtilityEditorController',
        controllerAs: 'vm'
      })
      .when('/admin-inovonics-location-utility/nc/:id',
        {templateUrl: 'app/admin-inovonics-location-utility/admin-inovonics-location-utility-nc-editor.html',
        controller: 'AdminInovonicsLocationUtilityEditorNcController',
        controllerAs: 'vm'
      })
      // Hardware
      .when('/admin-door-config',
        {templateUrl: 'app/admin-door-config/admin-door-config.html',
        controller: 'AdminDoorConfigController',
        controllerAs: 'vm'
      })
      .when('/admin-door-config/:id',
        {templateUrl: 'app/admin-door-config/admin-door-config-editor.html',
        controller: 'AdminDoorConfigEditorController',
        controllerAs: 'vm'
      })
      .when('/admin-door-config/new/:serialNumber',
        {templateUrl: 'app/admin-door-config/admin-door-config-editor.html',
        controller: 'AdminDoorConfigEditorController',
        controllerAs: 'vm'
      })
      .when('/admin-enrollment-station-config',
        {templateUrl: 'app/admin-enrollment-station-config/admin-enrollment-station-config.html',
        controller: 'AdminEnrollmentStationConfigController',
        controllerAs: 'vm'
      })
      .when('/admin-io-repeater-config',
        {templateUrl: 'app/admin-io-repeater-config/admin-io-repeater-config.html',
        controller: 'AdminIoRepeaterConfigController',
        controllerAs: 'vm'
      })
      .when('/admin-system-monitor-config',
        {templateUrl: 'app/admin-system-monitor-config/admin-system-monitor-config.html',
        controller: 'AdminSystemMonitorConfigController',
        controllerAs: 'vm'
      })
      .when('/admin-inovonics-repeater-config',
        {templateUrl: 'app/admin-inovonics-repeater-config/admin-inovonics-repeater-config.html',
        controller: 'AdminInovonicsRepeaterConfigController',
        controllerAs: 'vm'
      })
      .when('/admin-bridge-config',
        {templateUrl: 'app/admin-bridge-config/admin-bridge-config.html',
        controller: 'AdminBridgeConfigController',
        controllerAs: 'vm'
      })
      // Alerting
      .when('/admin-output-interface',
        {templateUrl: 'app/admin-output-interface/admin-output-interface.html',
        controller: 'AdminOutputInterfaceController',
        controllerAs: 'vm'
      })
      .when('/admin-alert-device',
        {templateUrl: 'app/admin-alert-device/admin-alert-device.html',
        controller: 'AdminAlertDeviceController',
        controllerAs: 'vm'
      })
      .when('/admin-escalation-config',
        {templateUrl: 'app/admin-escalation-config/admin-escalation-config.html',
        controller: 'AdminEscalationConfigController',
        controllerAs: 'vm'
      })
      .when('/admin-escalation-config/:id',
        {templateUrl: 'app/admin-escalation-config/admin-escalation-config-editor.html',
        controller: 'AdminEscalationConfigEditorController',
        controllerAs: 'vm'
      })
      .when('/admin-hardware-escalation-group',
        {templateUrl: 'app/admin-hardware-escalation-group/admin-hardware-escalation-group.html',
        controller: 'AdminHardwareEscalationGroupController',
        controllerAs: 'vm'
      })
      .when('/admin-event-message-config',
        {templateUrl: 'app/admin-event-message-config/admin-event-message-config.html',
        controller: 'AdminEventMessageConfigController',
        controllerAs: 'vm'
      })
      // Cares
      .when('/admin-care-plan',
        {templateUrl: 'app/admin-care-plan/admin-care-plan.html',
        controller: 'AdminCarePlanController',
        controllerAs: 'vm'
      })
      .when('/admin-care-level',
        {templateUrl: 'app/admin-care-level/admin-care-level.html',
        controller: 'AdminCareLevelController',
        controllerAs: 'vm'
      })
      .when('/admin-care-config',
        {templateUrl: 'app/admin-care-config/admin-care-config.html',
        controller: 'AdminCareConfigController',
        controllerAs: 'vm'
      })
      .when('/display-eula',
        {templateUrl: 'app/display-eula/display-eula.html',
        controller: 'DisplayEulaController',
        controllerAs: 'vm'
      })
      // allegion
      .when('/admin-allegion-management',
        {templateUrl: 'app/admin-allegion-management/admin-allegion-management.html',
        controller: 'AdminAllegionManagementController',
        controllerAs: 'vm'
      })
      .when('/admin-allegion-management/:id',
        {templateUrl: 'app/admin-allegion-management/admin-allegion-management-editor.html',
        controller: 'AdminAllegionManagementEditorController',
        controllerAs: 'vm'
      })
      .otherwise({
        redirectTo: '/'
      })
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('quantumUiAngular')
    .config(config);

  /** @ngInject */
  function config($logProvider, $locationProvider, toastrConfig, uiSelectConfig, laddaProvider, $httpProvider, IdleProvider, TitleProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Inject the Auth Token for Quantum API Requests
    $httpProvider.interceptors.push('httpRequestInterceptor');

    // Remove the hash
    $locationProvider.html5Mode(true);

    // Select2 Theme for UI-Select
    uiSelectConfig.theme = 'select2';
    uiSelectConfig.appendToBody = true

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 2000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;

    // Auto timeOut
    IdleProvider.idle(5)
    IdleProvider.timeout(5);
    TitleProvider.enabled(false);

    laddaProvider.setOption({ /* optional */
      style: 'slide-down',
      spinnerSize: 20
    })
  }

})();

angular.module("quantumUiAngular").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin-alert-device/admin-alert-device.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.devicesValid()\" ng-click=\"vm.saveDevices()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-mobile\"></i>Device List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addDevice()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Device Name</th></tr></thead><tbody><tr dir-paginate=\"device in (vm.filteredList = (vm.devices | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedDevice == device, \'danger\':!vm.deviceValid(device)}\" ng-if=\"!device.deleted\" ng-click=\"vm.selectedDevice = device\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedDevice) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedDevice) + 1])\"><td><i class=\"fa fa-minus-circle text-muted\" ng-class=\"{\'text-danger\':!device.in_use}\" ng-click=\"vm.removeDevice($index, device)\"></i> {{device.name}}</td></tr><tr><td colspan=\"2\" ng-if=\"!vm.filteredList.length\">No Results Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Device Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedDevice\">No Device Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedDevice\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Device Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedDevice.name\"></td></tr><tr><td>Device Interface</td><td><select class=\"form-control\" ng-model=\"vm.selectedDevice.interface_id\" ng-options=\"outputInterface.id as outputInterface.name for outputInterface in vm.interfaces\"></select></td></tr><tr ng-if=\"!vm.isMobile(vm.selectedDevice)\"><td>Device Address/Capcode</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedDevice.contact_value\"></td></tr><tr ng-if=\"vm.isMobile(vm.selectedDevice)\"><td>Mobile Device ID</td><td><select class=\"form-control\" ng-model=\"vm.selectedDevice.contact_value\"><option value=\"\" disabled=\"\">Select a Value</option><option value=\"{{phone.uuid}}\" ng-repeat=\"phone in vm.avaliblePhones\">{{phone.uuid}}</option><option value=\"{{vm.selectedDevice.contact_value}}\" ng-if=\"vm.selectedDevice.contact_value\">{{vm.selectedDevice.contact_value}}</option></select></td></tr><tr ng-if=\"vm.isMobile(vm.selectedDevice)\"><td>Phone Extension</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedDevice.extension\"></td></tr><tr ng-if=\"vm.isMobile(vm.selectedDevice)\"><td>Phone HW Serial Number</td><td>{{vm.selectedDevice.mobile_device_serial ? vm.selectedDevice.mobile_device_serial : \"Log in on Phone to Register\"}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-allegion-management/admin-allegion-management-editor.html","<script type=\"text/ng-template\" id=\"addModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\">Select Lock to Add</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <table class=\"table table-hover\"> <thead> <tr> <th> Lock Name </th> <th> Serial Number </th> <th> Type </th> <th> Signal Quailty </th> <th> Actions </th> </tr> </thead> <tbody> <tr ng-repeat=\"lock in vm.availableLocks\"> <td> <input type=\"text\" class=\"form-control\" placeholder=\"Lock Name\" ng-model=\"lock.quantumName\"> </td> <td> {{lock.mainSn}} </td> <td> {{lock.modelType | uppercase}} </td> <td> {{lock.signalQuality}} </td> <td> <button type=\"button\" class=\"btn btn-success\" ladda=\"lock.adding\" data-spinner-size=\"20\" ng-disabled=\"!lock.quantumName || vm.pendingAddRequestId\" name=\"button\" ng-click=\"vm.addLocktoGateway({device_id:lock.mainSn, name:lock.quantumName}, lock)\">Add</button> </td> </tr> </tbody> </table> </div> <div class=\"modal-footer\"> <button class=\"btn\" type=\"button\" ng-disabled=\"vm.pendingAddRequestId\" ng-click=\"vm.closeModal()\">Close</button> </div> </div></script><div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.locksValid() || !vm.gatewayValid()\" ng-click=\"vm.saveLocks()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-home\"></i>Lock List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.updateFirmware()\" ng-if=\"vm.firmwareCheck()\"><i class=\"fa fa-cloud-download\"></i></a> <a class=\"btn btn-mini\" ng-click=\"vm.addLock()\" ladda=\"vm.pendingScanRequestId\" data-spinner-size=\"20\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Configuration</th></tr></thead><tbody><tr ng-click=\"vm.selectedLock = {\'type\':\'gw\', \'data\':vm.selectedGateway}\" ng-class=\"{\'active\': vm.selectedLock.type == \'gw\', \'danger\':!vm.gatewayValid()}\"><td>Gateway Configuration</td></tr></tbody></table><table class=\"table table-hover\"><thead><tr><th>Associated Locks</th></tr></thead><tbody><tr dir-paginate=\"lock in (vm.filteredList = (vm.locks | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedLock.data == lock, \'danger\':!vm.lockValid(lock)}\" ng-if=\"!lock.deleted\" ng-click=\"vm.selectedLock = {\'type\':\'lock\', \'data\':lock}\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedLock) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedLock) + 1])\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeLock($index, lock)\"></i> {{lock.name}}</td></tr><tr ng-if=\"!vm.locks.length\"><td>No Results Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Configuration Editor</h3></div><div class=\"box-content\" ng-if=\"vm.selectedLock.type == \'gw\'\"><span ng-hide=\"vm.selectedLock\">No Lock Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedLock\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Gateway Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedLock.data.name\"></td></tr><tr><td>Gateway Online Status Monitoring</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedLock.data.monitor_sanity}\" ng-click=\"vm.selectedLock.data.monitor_sanity = false\">Disabled</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedLock.data.monitor_sanity}\" ng-click=\"vm.selectedLock.data.monitor_sanity = true\">Enabled</button></div></td></tr></tbody></table></div><div class=\"box-content\" ng-if=\"vm.selectedLock.type == \'lock\'\"><span ng-hide=\"vm.selectedLock\">No Lock Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedLock\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Lock Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedLock.data.name\"></td></tr><tr><td>Bypass Time</td><td><input type=\"number\" class=\"form-control\" ng-model=\"vm.selectedLock.data.relock_time\"></td></tr><tr><td>Apartment</td><td><ui-select name=\"output\" ng-model=\"vm.selectedLock.data.apartment_id\" style=\"width: 100%;\"><ui-select-match>{{$select.selected.name}} <button class=\"btn-clear pull-right\" ng-click=\"vm.clearApt($event)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"apartment.id as apartment in vm.apartments | filter:$select.search\">{{apartment.name}}</ui-select-choices></ui-select></td></tr><tr><td>Lock Online Status Monitoring</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedLock.data.monitor_sanity}\" ng-click=\"vm.selectedLock.data.monitor_sanity = false\">Disabled</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedLock.data.monitor_sanity}\" ng-click=\"vm.selectedLock.data.monitor_sanity = true\">Enabled</button></div></td></tr><tr><td>Actions</td><td><button class=\"btn-block btn btn-success\" ng-click=\"vm.sendCreds(vm.selectedLock.data)\">Send Credentials</button></td></tr></tbody></table></div></div><div class=\"box\" ng-if=\"vm.selectedLock.type == \'lock\'\"><div class=\"box-title\"><h3><i class=\"fa fa-bars\"></i> Lock Status</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedLock\">No Lock Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedLock\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Status Last Updated</td><td>{{vm.selectedLock.data.last_parameter_update | date:\'medium\'}}</td></tr><tr><td>Serial Number</td><td>{{vm.selectedLock.data.hw_address}}</td></tr><tr><td>Model</td><td>{{vm.selectedLock.data.model | uppercase}}</td></tr><tr><td>Battery Low</td><td>{{vm.selectedLock.data.status.battery_problem ? \"Yes\" : \"No\"}}</td></tr><tr><td>Door Locked</td><td>{{vm.selectedLock.data.status.door_locked ? \"Yes\" : \"No\"}}</td></tr><tr><td>Door Opened</td><td>{{vm.selectedLock.data.status.door_opened ? \"Yes\" : \"No\"}}</td></tr><tr><td>Online</td><td>{{vm.selectedLock.data.status.magnetic_tamper ? \"Yes\" : \"No\"}}</td></tr><tr><td>Override Enabled</td><td>{{vm.selectedLock.data.status.magnetic_tamper ? \"Yes\" : \"No\"}}</td></tr><tr><td>Signal Quality</td><td>{{vm.selectedLock.data.signal_quality | uppercase}}</td></tr><tr><td>Tamper</td><td>{{vm.selectedLock.data.status.tamper ? \"Yes\" : \"No\"}}</td></tr><tr><td>Magnetic Tamper</td><td>{{vm.selectedLock.data.status.magnetic_tamper ? \"Yes\" : \"No\"}}</td></tr><tr><td>Firmware Version</td><td>{{vm.selectedLock.data.params.fwVer.main}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-allegion-management/admin-allegion-management.html","<script type=\"text/ng-template\" id=\"addModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 ng-if=\"!vm.gatewayToAdd\" class=\"modal-title\">Select Gateway to Add</h4> <h4 ng-if=\"vm.gatewayToAdd\" class=\"modal-title\">Configure Gateway</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <table class=\"table table-hover\" ng-if=\"!vm.gatewayToAdd\"> <thead> <tr> <th> Serial Number </th> <th> Date Added </th> </tr> </thead> <tbody> <tr ng-repeat=\"gateway in vm.newGateways\" ng-if=\"gateway.hw_type == 9\" ng-click=\"vm.configGateway(gateway.hw_address)\"> <td> {{gateway.hw_address}} </td> <td> {{gateway.entered_on | date:\'medium\'}} </td> </tr> </tbody> </table> <div ng-if=\"vm.gatewayToAdd\"> <div class=\"form-group modal-input-padding\"> <label class=\"control-label col-sm-2\">Address</label> <div class=\"col-sm-10\"> <input type=\"text\" class=\"form-control\" disabled ng-model=\"vm.gatewayToAdd.hw_address\"> </div> </div> <div class=\"form-group modal-input-padding\"> <label class=\"control-label col-sm-2\">Name</label> <div class=\"col-sm-10\"> <input type=\"text\" class=\"form-control\" ng-model=\"vm.gatewayToAdd.name\"> </div> </div> <div class=\"form-group modal-input-padding\"> <label class=\"control-label col-sm-2\">IP Address</label> <div class=\"col-sm-10\"> <input type=\"text\" class=\"form-control\" ng-model=\"vm.gatewayToAdd.ip_address\"> </div> </div> <div class=\"clearfix\"></div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn\" type=\"button\" ng-click=\"vm.closeAddModal()\">Cancel</button> <button ng-if=\"vm.gatewayToAdd\" class=\"btn bnt-success\" type=\"button\" ng-click=\"vm.addGateway(vm.gatewayToAdd)\">Save</button> </div> </div></script><script type=\"text/ng-template\" id=\"confirmModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\">Delete Gateway?</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> Delete gateway {{vm.selectedGateway.name}}? This cannot be undone. </div> <div class=\"modal-footer\"> <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button> <button class=\"btn btn-primary\" type=\"button\" ladda=\"vm.ladda\" ng-click=\"vm.deleteGateway(vm.selectedGateway)\">OK</button> </div> </div></script><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bars\"></i> Gateway List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addGatewayDialog()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Gateway Name</th><th>Serial Number</th><th>IP Address</th><th>Firmware Version</th><th>Online Status</th></tr></thead><tbody><tr dir-paginate=\"gateway in vm.filteredGateways = (vm.gateways | orderBy:\'name\' | filter:vm.searchFilter | itemsPerPage:15)\" ng-if=\"gateway.id != 0\" ng-click=\"vm.loadGateway(gateway)\"><td><i class=\"fa fa-minus-circle\" ng-class=\"{\'text-danger\':!gateway.attached_locks.length}\" ng-click=\"vm.removeGatewayDialog(gateway); $event.stopPropagation();\"></i> {{gateway.name}}</td><td>{{gateway.hw_address}}</td><td>{{gateway.ip_address}}</td><td><a class=\"btn\" ng-click=\"vm.updateFirmware(gateway.id) ; $event.stopPropagation();\" ng-if=\"vm.firmwareCheck(gateway.fw_version) && gateway.fw_version\"><i class=\"fa fa-cloud-download\"></i></a> {{gateway.fw_version}}</td><td ng-class=\"{\'text-danger\':!gateway.online}\">{{!gateway.online ? \"Offline\" : \"Online\"}}</td></tr><tr ng-if=\"!vm.gateways.length\"><td colspan=\"4\">No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredGateways.length}} of {{vm.gateways.length}} Gateways</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/admin-bridge-config/admin-bridge-config.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.getBridges()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.bridgesValid()\" ng-click=\"vm.saveBridges()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-home\"></i>Bridge List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addBridge()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Bridge Name</th></tr></thead><tbody><tr dir-paginate=\"bridge in (vm.filteredList = (vm.bridges | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedBridge == bridge, \'danger\':!vm.bridgeValid(bridge)}\" ng-if=\"!bridge.deleted\" ng-click=\"vm.selectedBridge = bridge\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedBridge) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedBridge) + 1])\"><td><i class=\"fa fa-minus-circle\" ng-class=\"bridge.id == 1 ? \'text-muted\' : \'text-danger\'\" ng-click=\"vm.removeBridge($index, bridge)\"></i> {{bridge.name}}</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Bridge Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedBridge\">No Bridge Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedBridge\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Bridge Name</td><td><input ng-disabled=\"vm.selectedBridge.id == 1\" type=\"text\" class=\"form-control\" ng-model=\"vm.selectedBridge.name\"></td></tr><td>Email Check-in Report</td><td><ui-select name=\"output\" multiple=\"\" ng-model=\"vm.selectedBridge.checkin_staff\" style=\"width: 100%;\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"staff.id as staff in vm.staff | filter:$select.search\">{{staff.name}}</ui-select-choices></ui-select></td></tbody></table></div></div></div></div><pre>{{vm.avaliableMaps | json}}</pre><pre>{{vm.selectedBridge | json}}</pre>");
$templateCache.put("app/admin-care-level/admin-care-level.html","<script type=\"text/ng-template\" id=\"confirmModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\">Note</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> You have added a new care level. Please adjust your care plan threshholds for this new level. </div> <div class=\"modal-footer\"> <button class=\"btn btn-warning\" type=\"button\" ladda=\"vm.ladda\" ng-click=\"vm.closeModal()\">Ok</button> </div> </div></script><script type=\"text/ng-template\" id=\"deleteModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\">Note</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> Any cares assigned to this level will not be availble until re-assigned to another level. </div> <div class=\"modal-footer\"> <button class=\"btn btn-warning\" type=\"button\" ladda=\"vm.ladda\" ng-click=\"vm.closeModal()\">Ok</button> </div> </div></script><div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.levelsValid()\" ng-click=\"vm.saveLevels()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-home\"></i>Care Level List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addLevel()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Care Level Name</th></tr></thead><tbody><tr dir-paginate=\"level in (vm.filteredList = (vm.levels | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedLevel == level, \'danger\':!vm.levelValid(level)}\" ng-if=\"!level.deleted\" ng-click=\"vm.selectedLevel = level\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedLevel) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedLevel) + 1])\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeLevel($index, level)\"></i> {{level.name}}</td></tr><tr ng-if=\"!vm.levels.length\"><td colspan=\"2\">No Levels Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Level Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedLevel\">No Level Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedLevel\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Level Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedLevel.name\"></td></tr><tr><td class=\"col-md-2\">Cares in Level</td><td class=\"col-md-10\"><ui-select name=\"output\" multiple=\"\" ng-model=\"vm.selectedLevel.assigned_cares\" style=\"width: 100%;\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"care.id as care in vm.avaliableCares(vm.selectedLevel.assigned_cares) | filter:$select.search\">{{care.name}}</ui-select-choices></ui-select></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-care-config/admin-care-config.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.caresValid()\" ng-click=\"vm.saveCares()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-home\"></i>Care List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addCare()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Care Name</th></tr></thead><tbody><tr dir-paginate=\"care in (vm.filteredList = (vm.cares | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedCare == care, \'danger\':!vm.careValid(care)}\" ng-if=\"!care.deleted\" ng-click=\"vm.selectedCare = care\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedCare) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedCare) + 1])\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeCare($index, care)\"></i> {{care.name}}</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Care Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedCare\">No Care Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedCare\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Care Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedCare.name\"></td></tr><tr><td>Estimated Time of Care</td><td><input type=\"number\" class=\"form-control\" ng-model=\"vm.selectedCare.expected_care_time\"></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-care-plan/admin-care-plan.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.plansValid()\" ng-click=\"vm.savePlans()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-home\"></i>Plan List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addPlan()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Plan Name</th></tr></thead><tbody><tr dir-paginate=\"plan in (vm.filteredList = (vm.plans | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedPlan == plan, \'danger\':!vm.planValid(plan)}\" ng-if=\"!plan.deleted\" ng-click=\"vm.selectedPlan = plan\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedPlan) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedPlan) + 1])\"><td><i class=\"fa fa-minus-circle\" ng-class=\"plan.in_use ? \'text-muted\' : \'text-danger\'\" ng-click=\"vm.removePlan($index, plan)\"></i> {{plan.name}}</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Plan Details</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedPlan\">No Plan Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedPlan\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Plan Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedPlan.name\"></td></tr><tr><td>Threshold Alert Staff</td><td><ui-select name=\"output\" multiple=\"\" ng-model=\"vm.selectedPlan.staff\" style=\"width: 100%;\"><ui-select-match>{{$item.first_name}} {{$item.last_name}}</ui-select-match><ui-select-choices repeat=\"staff.id as staff in vm.staff | filter:$select.search\">{{staff.first_name}} {{staff.last_name}}</ui-select-choices></ui-select></td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Level Thresholds</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedPlan\">No Plan Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedPlan\"><thead><tr><th>Level</th><th>Minimum Cares</th><th>Maximum Cares</th></tr></thead><tbody><tr ng-repeat=\"level in vm.selectedPlan.level\"><td>{{vm.levelById(level.level_id).name}}</td><td><input type=\"number\" class=\"form-control\" ng-model=\"level.low_threshold\"></td><td><input type=\"number\" class=\"form-control\" ng-model=\"level.high_threshold\"></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-enrollment-station-config/admin-enrollment-station-config.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.stationsValid()\" ng-click=\"vm.saveStations()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-wifi\"></i>Enrollment Station List</h3></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Enrollment Station Name</th><th>Serial Number</th></tr></thead><tbody><tr dir-paginate=\"station in (vm.filteredList = (vm.stations | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedStation == station}\" ng-if=\"!station.deleted\" ng-click=\"vm.selectedStation = station\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedStation) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedStation) + 1])\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeStation($index, station)\"></i> {{station.name}}</td><td>{{station.serial_number}}</td></tr><tr><td colspan=\"2\" ng-if=\"!vm.filteredList.length\">No Results Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Enrollment Station Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedStation\">No Enrollment Station Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedStation\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Enrollment Station Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedStation.name\"></td></tr><tr><td>Serial Number</td><td>{{vm.selectedStation.serial_number}}</td></tr><tr><td>IP Address</td><td>{{vm.selectedStation.ip_address}}</td></tr><tr><td>Online Status Monitoring</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedStation.monitor_sanity}\" ng-click=\"vm.selectedStation.monitor_sanity = false\">Disabled</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedStation.monitor_sanity}\" ng-click=\"vm.selectedStation.monitor_sanity = true\">Enabled</button></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-escalation-config/admin-escalation-config-editor.html","<div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-wifi\"></i> Escalation Editor: {{vm.selectedEscalation.name}}</h3><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.levelsValid()\" ng-click=\"vm.saveLevels()\">Save</button></span></div><div class=\"box-content nopadding\"><div class=\"form-group\"><label class=\"control-label col-sm-2\">Escalation Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"repeater_name\" class=\"form-control\" ng-model=\"vm.selectedEscalation.name\"></div></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bell\"></i>Level List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addLevel()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Level</th></tr></thead><tbody><tr ng-repeat=\"level in (vm.filteredList = (vm.selectedEscalation.data | filter:vm.searchFilter))\" ng-class=\"{\'active\': vm.selectedLevel == level, \'danger\':!vm.levelValid(level)}\" ng-if=\"!level.deleted\" ng-click=\"vm.selectedLevel = level\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedLevel) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedLevel) + 1])\"><td><i class=\"fa fa-minus-circle\" ng-class=\"level.escalation_level == 1 ? \'text-muted\' : \'text-danger\'\" ng-click=\"vm.removeLevel($index, level)\"></i> Level {{$index + 1}} <span class=\"pull-right\"><i class=\"fa fa-arrow-up\" ng-if=\"!$first\" ng-click=\"vm.moveLevel($index, vm.selectedEscalation, \'up\')\"></i> <i class=\"fa fa-arrow-down\" ng-if=\"!$last\" ng-click=\"vm.moveLevel($index, vm.selectedEscalation, \'down\')\"></i></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Level Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedLevel\">No Level Selected</span><form angular-validator=\"\" name=\"vm.form\"><table class=\"table table-hover\" ng-if=\"vm.selectedLevel\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Level</td><td><input ng-disabled=\"\'true\'\" type=\"text\" class=\"form-control\" ng-model=\"vm.selectedLevel.escalation_level\"></td></tr><tr><td>Number of Repeats</td><td><input type=\"number\" ignore-mouse-number=\"\" min=\"1\" name=\"repeates\" class=\"form-control\" ng-model=\"vm.selectedLevel.times_to_send\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\" invalid-message=\"\'Must be a number greater than 1.\'\"></td></tr><tr><td>Minutes Between Repeats</td><td><input type=\"number\" ignore-mouse-number=\"\" min=\"1\" name=\"minutes\" class=\"form-control\" ng-model=\"vm.selectedLevel.time_between_send\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\" invalid-message=\"\'Must be a number greater than 1.\'\"></td></tr><tr><td>Alert Devices</td><td ng-if=\"vm.userAuth.data.system_license.mobile_users\"><ui-select name=\"output\" multiple=\"\" on-select=\"vm.changeDevices(vm.selectedLevel.alert_devices)\" on-remove=\"vm.changeDevices(vm.selectedLevel.alert_devices)\" ng-model=\"vm.selectedLevel.alert_devices\" style=\"width: 100%;\"><ui-select-match>{{$item.name}} - {{$item.interface_name}}</ui-select-match><ui-select-choices repeat=\"alertDevice.id as alertDevice in vm.alertDevices | filter:$select.search\">{{alertDevice.name}} - {{alertDevice.interface_name}}</ui-select-choices></ui-select></td><td ng-if=\"!vm.userAuth.data.system_license.mobile_users\"><ui-select name=\"output\" multiple=\"\" on-select=\"vm.changeDevices(vm.selectedLevel.alert_devices)\" on-remove=\"vm.changeDevices(vm.selectedLevel.alert_devices)\" ng-model=\"vm.selectedLevel.alert_devices\" style=\"width: 100%;\"><ui-select-match>{{$item.name}} - {{$item.interface_name}}</ui-select-match><ui-select-choices repeat=\"alertDevice.id as alertDevice in vm.nonMobileDevices() | filter:$select.search\">{{alertDevice.name}} - {{alertDevice.interface_name}}</ui-select-choices></ui-select></td></tr><tr ng-if=\"vm.onlyMobileDevices(vm.selectedLevel.alert_devices)\"><td>Backup Alert Devices</td><td><ui-select name=\"output\" multiple=\"\" ng-model=\"vm.selectedLevel.backup_alert_devices\" style=\"width: 100%;\"><ui-select-match>{{$item.name}} - {{$item.interface_name}}</ui-select-match><ui-select-choices repeat=\"alertDevice.id as alertDevice in vm.nonMobileDevices() | filter:$select.search\">{{alertDevice.name}} - {{alertDevice.interface_name}}</ui-select-choices></ui-select></td></tr></tbody></table></form></div></div></div></div>");
$templateCache.put("app/admin-escalation-config/admin-escalation-config.html","<script type=\"text/ng-template\" id=\"confirmModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\">Delete Escalation?</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> Delete escalation {{vm.selectedEscalation.name}}? This cannot be undone. </div> <div class=\"modal-footer\"> <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button> <button class=\"btn btn-primary\" type=\"button\" ladda=\"vm.ladda\" ng-click=\"vm.deleteEscalation(vm.selectedEscalation)\">OK</button> </div> </div></script><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bell\"></i> Escalation List</h3><div class=\"actions\"><a class=\"btn btn-mini\" href=\"/admin-escalation-config/new\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control ng-pristine ng-valid ng-isolate-scope ng-touched\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Escalation Name</th><th>In Use</th><th>Escalation ID</th></tr></thead><tbody><tr dir-paginate=\"escalation in vm.filteredEscalations = (vm.escalations | orderBy:\'name\' | filter:vm.searchFilter | itemsPerPage:15)\" ng-if=\"escalation.id != 0\" ng-click=\"vm.loadEscalation(escalation)\"><td><i class=\"fa fa-minus-circle text-muted\" ng-class=\"{\'text-danger\': !escalation.in_use}\" ng-click=\"vm.removeEscalationDialog(escalation); $event.stopPropagation();\"></i> {{escalation.name}}</td><td>{{(escalation.in_use ? \"Yes\" : \"No\")}}</td><td>{{escalation.id}}</td></tr><tr ng-if=\"!vm.escalations.length\"><td colspan=\"4\">No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredEscalations.length}} of {{vm.escalations.length}} Escalations</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/admin-door-config/admin-door-config-editor.html","<script type=\"text/ng-template\" id=\"replaceModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\">Choose New Door</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <table class=\"table table-hover\"> <thead> <tr> <th> Serial Number </th> <th> Date Added </th> </tr> </thead> <tbody> <tr ng-repeat=\"door in vm.newDoors\" ng-click=\"vm.replaceDoor(door.serial_number)\"> <td> {{door.serial_number}} </td> <td> {{door.entered_on | date:\'medium\'}} </td> </tr> </tbody> </table> </div> <div class=\"modal-footer\"> <button class=\"btn\" type=\"button\" ng-click=\"vm.closeReplaceModal()\">Cancel</button> </div> </div></script><script type=\"text/ng-template\" id=\"copyModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\">Choose Door to Copy From</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <table class=\"table table-hover\"> <thead> <tr> <th> Door Name </th> <th> Serial Number </th> </tr> </thead> <tbody> <tr ng-repeat=\"door in vm.existingDoors\" ng-click=\"vm.copyConfig(door.id)\"> <td> {{door.name}} </td> <td> {{door.serial_number}} </td> </tr> </tbody> </table> </div> <div class=\"modal-footer\"> <button class=\"btn\" type=\"button\" ng-click=\"vm.closeCopyModal()\">Cancel</button> </div> </div></script><div class=\"row\"><div class=\"col-sm-12\"><h3><i class=\"fa fa-bars\"></i> Configure {{vm.selectedDoor.name}} - {{vm.selectedDoor.serial_number}} <span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.formValid()\" ng-click=\"vm.saveProperties()\">Save</button></span></h3></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-wrench\"></i>Configuration List</h3><div class=\"actions\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a class=\"btn btn-mini\" uib-dropdown-toggle=\"\"><i class=\"fa fa-gear\"></i> <span class=\"caret\"></span></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li ng-if=\"vm.avalibleInputs().length\"><a href=\"#\" ng-click=\"vm.addInput()\">Add Input</a></li><li ng-if=\"vm.avalibleOutputTypes().length\"><a href=\"#\" ng-click=\"vm.addOutput()\">Add Output</a></li><li><a href=\"#\" ng-click=\"vm.replaceDoorDialog()\">Replace Door Controller</a></li><li><a href=\"#\" ng-click=\"vm.copyConfigDialog()\">Copy Configuration</a></li></ul></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Configuration</th></tr></thead><tbody><tr ng-class=\"{\'active\': vm.selectedProperty.type == \'config\'}\" ng-click=\"vm.selectedProperty = {\'type\':\'config\'}\"><td>General Configuration</td></tr><tr ng-class=\"{\'active\': vm.selectedProperty.type == \'wanderer\'}\" ng-click=\"vm.selectedProperty = {\'type\':\'wanderer\'}\" ng-if=\"vm.selectedDoor.use == 0 || vm.selectedDoor.use == 2\"><td>Wanderer Configuration</td></tr><tr ng-class=\"{\'active\': vm.selectedProperty.type == \'map\'}\" ng-click=\"vm.selectedProperty = {\'type\':\'map\'}\" ng-if=\"vm.userAuth.data.system_license.map_active\"><td>Map Placement</td></tr></tbody></table><table class=\"table table-hover\"><thead><tr><th>Input Function</th><th>Input</th></tr></thead><tbody><tr ng-repeat=\"input in vm.selectedDoor.input\" ng-class=\"{\'active\': vm.selectedProperty.data == input}\" ng-click=\"vm.selectedProperty = {\'type\':\'input\', \'data\':input}\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.selectedDoor.input.splice($index, 1); vm.selectedProperty = null\"></i> <span ng-repeat=\"type in vm.inputTypes | findObject:input.type_id\">{{type.name}}</span></td><td>{{input.input_number}}</td></tr><tr><td colspan=\"2\" ng-if=\"!vm.selectedDoor.input.length\">No Results Found</td></tr></tbody></table><table class=\"table table-hover\"><thead><tr><th>Output Function</th><th>Outputs</th></tr></thead><tbody><tr ng-repeat=\"output in vm.selectedDoor.output\" ng-class=\"{\'active\': vm.selectedProperty.data == output, \'danger\':!vm.outputValid(output)}\" ng-click=\"vm.selectedProperty = {\'type\':\'output\', \'data\':output}\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.selectedDoor.output.splice($index, 1); ; vm.selectedProperty = null\"></i> <span ng-repeat=\"type in vm.outputTypes | findObject:output.type_id\">{{type.name}}</span></td><td>{{output.output_number.join(\", \")}}{{output.output_number.length && output.sounder ? \",\":\"\"}} {{output.sounder ? \"Sounder\":\"\"}}</td></tr><tr><td colspan=\"2\" ng-if=\"!vm.selectedDoor.output.length\">No Results Found</td></tr></tbody></table></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Configuration Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedProperty\">No Property Selected</span><form angular-validator=\"\" name=\"vm.form\"><table class=\"table\" ng-if=\"vm.selectedProperty.type == \'config\'\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Door Name</td><td><input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.selectedDoor.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></td></tr><tr><td>Door Type</td><td><select class=\"form-control\" ng-model=\"vm.selectedDoor.use\" ng-options=\"use.id as use.name for use in vm.doorUses\"></select></td></tr><tr><td>Bypass Time (Seconds)</td><td><input type=\"number\" ignore-mouse-number=\"\" min=\"1\" name=\"bypass_time\" class=\"form-control\" ng-model=\"vm.selectedDoor.settings.bypass_time\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\" invalid-message=\"\'Must be a number greater than 1.\'\"></td></tr><tr><td>Propped Door Time (Seconds)</td><td><input type=\"number\" min=\"0\" ignore-mouse-number=\"\" name=\"propped_door_time\" class=\"form-control\" ng-model=\"vm.selectedDoor.settings.propped_door_time\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\" invalid-message=\"\'Must be a number.\'\"></td></tr><tr><td>Doorbell Debounce (Seconds)</td><td><input type=\"number\" min=\"0\" ignore-mouse-number=\"\" name=\"doorbell_debounce\" class=\"form-control\" ng-model=\"vm.selectedDoor.settings.doorbell_debounce\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\" invalid-message=\"\'Must be a number.\'\"></td></tr><tr><td>Buzzer Volume</td><td><input type=\"number\" min=\"0\" max=\"254\" ignore-mouse-number=\"\" name=\"buzzer_volume\" class=\"form-control\" ng-model=\"vm.selectedDoor.settings.buzzer_volume\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\" invalid-message=\"\'Must be a number between 0 and 254.\'\"></td></tr><tr><td>Included in Lockdown</td><td><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedDoor.settings.part_of_lockdown}\" ng-click=\"vm.selectedDoor.settings.part_of_lockdown = false\">Disabled</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedDoor.settings.part_of_lockdown}\" ng-click=\"vm.selectedDoor.settings.part_of_lockdown = true\">Enabled</button></div></td></tr><tr><td>Lockdown Minimum Temperature</td><td><input type=\"number\" ignore-mouse-number=\"\" name=\"min_temp\" class=\"form-control\" ng-model=\"vm.selectedDoor.settings.min_temp\"></td></tr><tr><td>Lockdown Maximum Temperature</td><td><input type=\"number\" ignore-mouse-number=\"\" name=\"max_temp\" class=\"form-control\" ng-model=\"vm.selectedDoor.settings.max_temp\"></td></tr><tr><td>Lock Type</td><td><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : !vm.selectedDoor.settings.SDC_lock}\" ng-click=\"vm.selectedDoor.settings.SDC_lock = false\">Generic</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedDoor.settings.SDC_lock}\" ng-click=\"vm.selectedDoor.settings.SDC_lock = true\">SDC Enhanced</button></div></td></tr><tr><td>Online Status Monitoring</td><td><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedDoor.settings.monitor_sanity}\" ng-click=\"vm.selectedDoor.settings.monitor_sanity = false\">Disabled</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedDoor.settings.monitor_sanity}\" ng-click=\"vm.selectedDoor.settings.monitor_sanity = true\">Enabled</button></div></td></tr></tbody></table><table class=\"table\" ng-if=\"vm.selectedProperty.type == \'wanderer\'\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Alarm Range</td><td><input type=\"number\" ignore-mouse-number=\"\" min=\"0\" name=\"alarm_range\" max=\"100\" class=\"form-control\" ng-model=\"vm.selectedDoor.settings.alarm_range\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\" invalid-message=\"\'Must be a number between 0 and 100.\'\"></td></tr><tr><td>Transmitter Disappear Time (Seconds)</td><td><input type=\"number\" min=\"5\" ignore-mouse-number=\"\" name=\"disappear_time\" class=\"form-control\" ng-model=\"vm.selectedDoor.settings.disappear_time\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\" invalid-message=\"\'Must be a number greater than 5.\'\"></td></tr><tr><td>Loiter Time (Seconds)</td><td><input type=\"number\" min=\"0\" ignore-mouse-number=\"\" name=\"loiter_time\" class=\"form-control\" ng-model=\"vm.selectedDoor.settings.loiter_time\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\" invalid-message=\"\'Must be a number.\'\"></td></tr></tbody></table><div ng-if=\"vm.selectedProperty.type == \'map\'\"><select class=\"form-control\" ng-model=\"vm.selectedDoor.map_data.map_id\" ng-options=\"map.id as map.name for map in vm.maps\" ng-change=\"vm.resetCenter()\"></select><div ng-repeat=\"map in vm.maps\" ng-if=\"map.id == vm.selectedDoor.map_data.map_id\"><leaflet defaults=\"vm.mapDefaults\" layers=\"map.map_data\" center=\"vm.center\" maxbounds=\"vm.maxBounds\" markers=\"map.marker_data\" width=\"100%\" height=\"600px\"></leaflet></div></div><table class=\"table\" ng-if=\"vm.selectedProperty.type == \'input\'\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Input Function</td><td><select class=\"form-control\" ng-model=\"vm.selectedProperty.data.type_id\" ng-options=\"input.id as input.name for input in vm.avalibleInputTypes(vm.selectedProperty.data.type_id)\"></select></td></tr><tr><td>Input Number</td><td><select class=\"form-control\" ng-model=\"vm.selectedProperty.data.input_number\" ng-options=\"input for input in vm.avalibleInputs(vm.selectedProperty.data.input_number)\"></select></td></tr><tr ng-if=\"vm.selectedProperty.data.type_id == 11 || vm.selectedProperty.data.type_id == 12\"><td>Schedule</td><td><select class=\"form-control\" ng-model=\"vm.selectedProperty.data.schedule_id\" ng-options=\"schedule.id as schedule.name for schedule in vm.schedules\"></select></td></tr><tr><td>State</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : !vm.selectedProperty.data.normally_closed}\" ng-click=\"vm.selectedProperty.data.normally_closed = false\">Normally Open</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedProperty.data.normally_closed}\" ng-click=\"vm.selectedProperty.data.normally_closed = true\">Normally Closed</button></div></td></tr><tr ng-if=\"vm.selectedProperty.data.type_id == 1\"><td>Type</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : !vm.selectedProperty.data.pir}\" ng-click=\"vm.selectedProperty.data.pir = false\">Reed Switch</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedProperty.data.pir}\" ng-click=\"vm.selectedProperty.data.pir = true\">PIR</button></div></td></tr><tr><td>Notes</td><td><textarea rows=\"4\" name=\"notes\" class=\"form-control\" ng-model=\"vm.selectedProperty.data.notes\"></textarea></td></tr></tbody></table><table class=\"table\" ng-if=\"vm.selectedProperty.type == \'output\'\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Output Function</td><td><select class=\"form-control\" ng-model=\"vm.selectedProperty.data.type_id\" ng-options=\"input.id as input.name for input in vm.avalibleOutputTypes(vm.selectedProperty.data.type_id)\"></select></td></tr><tr ng-if=\"vm.selectedProperty.data.type_id == 17\"><td>Momentary Duration</td><td><input type=\"number\" ignore-mouse-number=\"\" name=\"max_temp\" class=\"form-control\" ng-model=\"vm.selectedProperty.data.momentary_duration\"></td></tr><td>Outputs</td><td><ui-select name=\"output\" multiple=\"\" ng-model=\"vm.selectedProperty.data.output_number\" style=\"width: 100%;\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"output.id as output in vm.outputs | filter:$select.search\">{{output.name}}</ui-select-choices></ui-select></td><tr><td>Sounder</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedProperty.data.sounder}\" ng-click=\"vm.selectedProperty.data.sounder = false\">Disabled</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedProperty.data.sounder}\" ng-click=\"vm.selectedProperty.data.sounder = true\">Enabled</button></div></td></tr><tr ng-if=\"vm.selectedProperty.data.sounder\"><td>Sounder Tone</td><td><select class=\"form-control\" ng-model=\"vm.selectedProperty.data.tone_id\" ng-options=\"tone.id as tone.name for tone in vm.sounderTones\"></select></td></tr><tr><td>Notes</td><td><textarea rows=\"4\" name=\"notes\" class=\"form-control\" ng-model=\"vm.selectedProperty.data.notes\"></textarea></td></tr></tbody></table></form></div></div></div></div>");
$templateCache.put("app/admin-door-config/admin-door-config.html","<script type=\"text/ng-template\" id=\"addModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\">Select Door to Add</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <table class=\"table table-hover\"> <thead> <tr> <th> Serial Number </th> <th> Date Added </th> </tr> </thead> <tbody> <tr ng-repeat=\"door in vm.newDoors\" ng-click=\"vm.addDoor(door.serial_number)\"> <td> {{door.serial_number}} </td> <td> {{door.entered_on | date:\'medium\'}} </td> </tr> </tbody> </table> </div> <div class=\"modal-footer\"> <button class=\"btn\" type=\"button\" ng-click=\"vm.closeAddModal()\">Cancel</button> </div> </div></script><script type=\"text/ng-template\" id=\"confirmModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\">Delete Door?</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> Delete door {{vm.selectedDoor.name}}? This cannot be undone. </div> <div class=\"modal-footer\"> <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button> <button class=\"btn btn-primary\" type=\"button\" ladda=\"vm.ladda\" ng-click=\"vm.deleteDoor(vm.selectedDoor)\">OK</button> </div> </div></script><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bars\"></i> Door List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addDoorDialog()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Door Name</th><th>Serial Number</th><th>IP Address</th><th>Door Use</th><th>Actions</th></tr></thead><tbody><tr dir-paginate=\"door in vm.filteredDoors = (vm.doors | orderBy:\'name\' | filter:vm.searchFilter | itemsPerPage:15)\" ng-if=\"door.id != 0\" ng-click=\"vm.loadDoor(door)\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeDoorDialog(door); $event.stopPropagation();\"></i> {{door.name}}</td><td>{{door.serial_number}}</td><td>{{door.ip_address}}</td><td>{{vm.prettyDoorUse(door.use)}}</td><td><button type=\"button\" class=\"btn btn-small btn-warning\" ng-class=\"{\'btn-danger\':door.id == vm.doorPendingReboot}\" name=\"button\" ng-click=\"vm.rebootDoor(door.id); $event.stopPropagation();\">{{door.id != vm.doorPendingReboot ? \"Reboot\" : \"Sure?\"}}</button></td></tr><tr ng-if=\"!vm.doors.length\"><td colspan=\"4\">No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredDoors.length}} of {{vm.doors.length}} Doors</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/admin-event-message-config/admin-event-message-config.html","<script type=\"text/ng-template\" id=\"messageTemplate.html\"><div style=\"vertical-align: top;display: inline-block;width: auto;white-space: normal; zoom: 1;\"> <p> <br />DEVICE_NAME<br /> <em>Fixed Device Name or IO Input Name</em> </p> <p> APARTMENT<br /> <em>Associated Apartment Name</em> </p> <p>RESIDENT_ID<br /> <em>Resident Database ID</em> </p> <p> RESIDENT_NAME<br /> <em>Resident Name</em> </p> <p> RESIDENT_INITIALS<br /> <em>Resident Initials - Use for Email/Twilio</em> </p> <p>LOCATION_ID<br /> <em>Door or Pendant Database ID</em> </p> <p> LOCATION_NAME<br /> <em>Door or Pendant Location Name</em> </p> <p> MORE_LOCATIONS<br /> <em>Additional Pendant Locations</em> </p> <p> SITE_NAME<br /> <em>Facility Name (From Site Info)</em> </p> <p> EVENT_CODE<br /> <em>Three Letter Code for the Event</em> </p> <p> EVENT_MESSAGE<br /> <em>Text of Default Event Message</em> </p> </div></script><div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" ng-disabled=\"!vm.allValid()\" data-spinner-size=\"20\" ng-click=\"vm.saveMessages()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bars\"></i>Events</h3></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Event Message</th><th>Event Code</th></tr></thead><tbody><tr dir-paginate=\"message in (vm.filteredList = (vm.messages | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedMessage == message, \'danger\':!vm.messageValid(message)}\" ng-if=\"!message.deleted\" ng-click=\"vm.selectedMessage = message\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedMessage) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedMessage) + 1])\"><td>{{message.event_message}}</td><td>{{message.code}}</td></tr><tr><td colspan=\"2\" ng-if=\"!vm.filteredList.length\">No Results Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Alarm Status</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedMessage\">No Message Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedMessage\"><thead><tr><th class=\"col-md-3\">Property</th><th class=\"col-md-9\">Value</th></tr></thead><tbody><tr><td>Alarm Event</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedMessage.is_alarm}\" ng-click=\"vm.selectedMessage.is_alarm = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedMessage.is_alarm}\" ng-click=\"vm.setAlarm(vm.selectedMessage)\">Active</button></div></td></tr><tr ng-if=\"vm.selectedMessage.is_alarm\"><td>Hardware Active</td><td><ui-select name=\"hardware\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.selectedMessage.alarm_details.valid_hardware\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doors | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></td></tr><tr ng-if=\"vm.selectedMessage.is_alarm\"><td>Reset Events</td><td><ui-select name=\"reset_events\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.selectedMessage.alarm_details.reset_events\"><ui-select-match>{{$item.code}}</ui-select-match><ui-select-choices repeat=\"item.code as item in vm.messageFilter(vm.messages, vm.selectedMessage) | filter:$select.search\">{{item.code}} - {{item.event_message}}</ui-select-choices></ui-select></td></tr><tr ng-if=\"vm.selectedMessage.is_alarm\"><td>Escalation Type</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : vm.selectedMessage.alarm_details.supervisory_alarm}\" ng-click=\"vm.selectedMessage.alarm_details.supervisory_alarm = true\">Supervisory</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : !vm.selectedMessage.alarm_details.supervisory_alarm}\" ng-click=\"vm.selectedMessage.alarm_details.supervisory_alarm = false\">Normal</button></div></td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title\"><span class=\"pull-right\"><h3 uib-popover-template=\"\'messageTemplate.html\'\" popover-placement=\"left\" popover-title=\"Available Replacement Keywords\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle pull-right\"></i></h3></span><h3><i class=\"fa fa-pencil-square-o\"></i> Message Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedMessage\">No Message Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedMessage\"><thead><tr><th class=\"col-md-3\">Interface</th><th class=\"col-md-9\">Message</th></tr></thead><tbody><tr><td>Dashbaord Display</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedMessage.event_message\"></td></tr><tr ng-repeat=\"interface in vm.selectedMessage.interface_data\"><td>{{interface.name}}</td><td><input type=\"text\" class=\"form-control\" ng-model=\"interface.message\"></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-hardware-escalation-group/admin-hardware-escalation-group.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.groupsValid()\" ng-click=\"vm.saveGroups()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bell\"></i>Group List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addGroup()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Group Name</th></tr></thead><tbody><tr dir-paginate=\"group in (vm.filteredList = (vm.groups | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedGroup == group, \'danger\':!vm.groupValid(group)}\" ng-if=\"!group.deleted\" ng-click=\"vm.selectedGroup = group\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedGroup) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedGroup) + 1])\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeGroup($index, group)\"></i> {{group.name}}</td></tr><tr><td colspan=\"2\" ng-if=\"!vm.filteredList.length\">No Results Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Group Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedGroup\">No Group Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedGroup\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Group Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedGroup.name\"></td></tr><tr><td>Escalations</td><td><ui-select name=\"output\" multiple=\"\" ng-model=\"vm.selectedGroup.escalations\" style=\"width: 100%;\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"escalation.id as escalation in vm.escalations | filter:$select.search\">{{escalation.name}}</ui-select-choices></ui-select></td></tr><tr><td>Supervisory Escalations</td><td><select class=\"form-control\" ng-model=\"vm.selectedGroup.supervisory_escalation\" ng-options=\"escalation.id as escalation.name for escalation in vm.escalations\"></select></td></tr><tr><td>Hardware in Group</td><td><ui-select name=\"output\" multiple=\"\" ng-model=\"vm.selectedGroup.hardware\" style=\"width: 100%;\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"door.id as door in vm.doors | filter:$select.search\">{{door.name}}</ui-select-choices></ui-select></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-inovonics-location-utility/admin-inovonics-location-utility-editor.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.cancel()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.fingerprintsValid()\" ng-click=\"vm.saveFingerprints()\">Save</button></span></div></div><div class=\"box\"><div class=\"box-title\"><div class=\"form-group\"><h4><span class=\"col-sm-2\">Location Name</span></h4><div class=\"col-sm-10\"><input type=\"text\" name=\"repeater_name\" class=\"form-control\" ng-model=\"vm.selectedLocation.name\"></div></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-map-marker\"></i>Fingerprint List</h3><div class=\"actions\"><h3>Enroll <a href=\"#\" ng-click=\"vm.enrollEnabled = !vm.enrollEnabled\"><i class=\"fa\" ng-class=\"!vm.enrollEnabled ? \'text-danger fa-toggle-off\' : \'text-success fa-toggle-on\'\"></i></a></h3></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Fingerprint Name</th></tr></thead><tbody><tr ng-repeat=\"fingerprint in (vm.filteredList = (vm.selectedLocation.fingerprints | filter:vm.searchFilter))\" ng-class=\"{\'active\': vm.selectedFingerprint == fingerprint}\" ng-if=\"!fingerprint.deleted\" ng-click=\"vm.selectedFingerprint = fingerprint\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedFingerprint) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedFingerprint) + 1])\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"fingerprint.deleted = true\"></i> <span ng-if=\"!fingerprint.ID\">New</span> Fingerprint {{fingerprint.ID}}</td></tr><tr ng-if=\"!vm.selectedLocation.fingerprints.length\"><td>No Fingerprints Found</td></tr></tbody></table></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Fingerprint Viewer</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedFingerprint\">No Fingerprint Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedFingerprint\"><thead><tr><th>Repeater Serial</th><th>Repeater Name</th><th>Signal Strengh</th></tr></thead><tbody><tr><td ng-if=\"vm.selectedFingerprint.Receivers.DeviceID1 != 0\">{{vm.selectedFingerprint.Receivers.DeviceID1}}</td><td>{{vm.associateRepeater(vm.selectedFingerprint.Receivers.DeviceID1)}}</td><td>{{vm.selectedFingerprint.Receivers.Rssi1}}</td></tr><tr ng-if=\"vm.selectedFingerprint.Receivers.DeviceID2 != 0\"><td>{{vm.selectedFingerprint.Receivers.DeviceID2}}</td><td>{{vm.associateRepeater(vm.selectedFingerprint.Receivers.DeviceID2)}}</td><td>{{vm.selectedFingerprint.Receivers.Rssi2}}</td></tr><tr ng-if=\"vm.selectedFingerprint.Receivers.DeviceID3 != 0\"><td>{{vm.selectedFingerprint.Receivers.DeviceID3}}</td><td>{{vm.associateRepeater(vm.selectedFingerprint.Receivers.DeviceID3)}}</td><td>{{vm.selectedFingerprint.Receivers.Rssi3}}</td></tr><tr ng-if=\"vm.selectedFingerprint.Receivers.DeviceID4 != 0\"><td>{{vm.selectedFingerprint.Receivers.DeviceID4}}</td><td>{{vm.associateRepeater(vm.selectedFingerprint.Receivers.DeviceID4)}}</td><td>{{vm.selectedFingerprint.Receivers.Rssi4}}</td></tr><tr ng-if=\"vm.selectedFingerprint.Receivers.DeviceID5 != 0\"><td>{{vm.selectedFingerprint.Receivers.DeviceID5}}</td><td>{{vm.associateRepeater(vm.selectedFingerprint.Receivers.DeviceID5)}}</td><td>{{vm.selectedFingerprint.Receivers.Rssi5}}</td></tr><tr ng-if=\"vm.selectedFingerprint.Receivers.DeviceID6 != 0\"><td>{{vm.selectedFingerprint.Receivers.DeviceID6}}</td><td>{{vm.associateRepeater(vm.selectedFingerprint.Receivers.DeviceID6)}}</td><td>{{vm.selectedFingerprint.Receivers.Rssi6}}</td></tr><tr ng-if=\"vm.selectedFingerprint.Receivers.DeviceID7 != 0\"><td>{{vm.selectedFingerprint.Receivers.DeviceID7}}</td><td>{{vm.associateRepeater(vm.selectedFingerprint.Receivers.DeviceID7)}}</td><td>{{vm.selectedFingerprint.Receivers.Rssi7}}</td></tr><tr ng-if=\"vm.selectedFingerprint.Receivers.DeviceID8 != 0\"><td>{{vm.selectedFingerprint.Receivers.DeviceID8}}</td><td>{{vm.associateRepeater(vm.selectedFingerprint.Receivers.DeviceID8)}}</td><td>{{vm.selectedFingerprint.Receivers.Rssi8}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-inovonics-location-utility/admin-inovonics-location-utility-nc-editor.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.cancel()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.fingerprintsValid()\" ng-click=\"vm.saveFingerprints()\">Save</button></span></div></div><div class=\"box\"><div class=\"box-title\"><div class=\"form-group\"><h4><span class=\"col-sm-2\">Location Name</span></h4><div class=\"col-sm-10\"><input type=\"text\" name=\"repeater_name\" class=\"form-control\" ng-model=\"vm.selectedLocation.name\"></div></div><div class=\"clearfix\"></div><div class=\"form-group\"><h4><span class=\"col-sm-2\">Associated Apartment</span></h4><div class=\"col-sm-10\"><ui-select name=\"apartment\" ng-model=\"vm.selectedLocation.apartment_id\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearApt($event, vm.selectedLocation)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"apartment.id as apartment in vm.apartments | filter:$select.search\">{{apartment.name}}</ui-select-choices></ui-select></div></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-map-marker\"></i>Fingerprint List</h3><div class=\"actions\"><h3>Enroll <a href=\"#\" ng-click=\"vm.enrollEnabled = !vm.enrollEnabled\"><i class=\"fa\" ng-class=\"!vm.enrollEnabled ? \'text-danger fa-toggle-off\' : \'text-success fa-toggle-on\'\"></i></a></h3></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Fingerprint Name</th></tr></thead><tbody><tr ng-repeat=\"fingerprint in (vm.filteredList = (vm.selectedLocation.fingerprint | filter:vm.searchFilter))\" ng-class=\"{\'active\': vm.selectedFingerprint == fingerprint}\" ng-if=\"!fingerprint.deleted\" ng-click=\"vm.selectedFingerprint = fingerprint\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedFingerprint) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedFingerprint) + 1])\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeFingerprint($index, fingerprint)\"></i> <span ng-if=\"!fingerprint[0].fingerprint_id\">New</span> Fingerprint {{fingerprint[0].fingerprint_id}}</td></tr><tr ng-if=\"!vm.selectedLocation.fingerprint.length\"><td>No Fingerprints Found</td></tr></tbody></table>{{vm.selectedLocation.fingerprint.length}} Fingerprints</div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Fingerprint Viewer</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedFingerprint\">No Fingerprint Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedFingerprint\"><thead><tr><th>Repeater Serial</th><th>Repeater Name</th><th>Signal Strengh</th></tr></thead><tbody><tr ng-repeat=\"fingerprint in vm.selectedFingerprint\"><td>{{vm.associateRepeater(fingerprint.repeater_id).serial_number}}</td><td>{{vm.associateRepeater(fingerprint.repeater_id).name}}</td><td>{{fingerprint.sig_strength}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-inovonics-location-utility/admin-inovonics-location-utility.html","<script type=\"text/ng-template\" id=\"confirmModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\">Delete Location?</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> Delete location {{vm.selectedLocation.name}}? This cannot be undone. </div> <div class=\"modal-footer\"> <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button> <button class=\"btn btn-primary\" type=\"button\" ladda=\"vm.ladda\" ng-click=\"vm.deleteLocation(vm.selectedLocation)\">OK</button> </div> </div></script><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-map-marker\"></i> Location List</h3><div class=\"actions\" ng-if=\"!vm.userAuth.data.network_coordinator_in_use\"><a class=\"btn btn-mini\" href=\"/admin-inovonics-location-utility/new\"><i class=\"fa fa-plus\"></i></a></div><div class=\"actions\" ng-if=\"vm.userAuth.data.network_coordinator_in_use\"><a class=\"btn btn-mini\" href=\"/admin-inovonics-location-utility/nc/new\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Location Name</th><th>Quantum ID</th><th>Inovonics Partition ID</th></tr></thead><tbody><tr dir-paginate=\"location in vm.filteredLocations = (vm.locations | orderBy:\'name\' | filter:vm.searchFilter | itemsPerPage:15)\" ng-click=\"vm.loadLocation(location)\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeLocationDialog(location); $event.stopPropagation();\"></i> {{location.name}}</td><td>{{location.id}}</td><td>{{location.acg_partition_id}}</td></tr><tr ng-if=\"!vm.locations.length\"><td colspan=\"4\">No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredLocations.length}} of {{vm.locations.length}} Locations</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/admin-inovonics-repeater-config/admin-inovonics-repeater-config.html","<script type=\"text/ng-template\" id=\"addModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\">Replace Repeater {{vm.selectedReplaceRepeaterSerial}}</h4> </div> <!-- /.modal-header --> <div class=\"modal-header\"> <div class=\"form-group\"> <label class=\"control-label col-sm-4\">New Serial Number</label> <div class=\"col-sm-8\"> <input type=\"number\" class=\"form-control\" ng-model=\"vm.selectedReplaceRepeater.serial_number\"> </div> </div> </div> <div class=\"clearfix\"></div> <div class=\"modal-footer\"> <button class=\"btn\" type=\"button\" ng-click=\"vm.closeAddModal()\">Cancel</button> <button class=\"btn\" type=\"button\" ng-click=\"vm.replaceRepeaterSave()\">Save</button> </div> </div></script><div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.repeatersValid()\" ng-click=\"vm.saveRepeaters()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-wifi\"></i>Inovonics Repeater List</h3><div class=\"actions\"><h3>Enroll <a href=\"#\" ng-click=\"vm.toggleEnrollmentStatus()\"><i class=\"fa\" ng-class=\"!vm.enrollEnabled ? \'text-danger fa-toggle-off\' : \'text-success fa-toggle-on\'\"></i></a></h3></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><div class=\"cover\" ng-show=\"vm.setNidLadda || vm.getStatusLadda\"></div><table class=\"table table-hover\"><thead><tr><th>Repeater Name</th><th>Serial Number</th><th>Status</th></tr></thead><tbody><tr dir-paginate=\"repeater in (vm.filteredList = (vm.repeaters | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedRepeater == repeater}\" ng-if=\"!repeater.deleted\" ng-click=\"vm.selectedRepeater = repeater\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedRepeater) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedRepeater) + 1])\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeRepeater($index, repeater)\"></i> {{repeater.name}}</td><td>{{repeater.serial_number}}</td><td><span ng-if=\"!repeater.repeater_configured\"><i class=\"fa fa-times text-warning\"></i></span> <span ng-if=\"repeater.repeater_configured\"><i class=\"fa fa-check-circle-o text-success\"></i></span></td></tr><tr><td colspan=\"3\" ng-if=\"!vm.filteredList.length\">No Results Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Inovonics Repeater Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedRepeater\">No Repeater Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedRepeater\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Repeater Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedRepeater.name\"></td></tr><tr ng-if=\"vm.userAuth.data.network_coordinator_in_use\"><td>Repeater Tools</td><td><span class=\"col-sm-4\"><button class=\"btn btn-block\" ng-disabled=\"vm.selectedRepeater.repeater_configured\" type=\"button\" name=\"button\" ng-click=\"vm.setNid(vm.selectedRepeater)\" ladda=\"vm.setNidLadda\">Set NID</button></span><span class=\"col-sm-4\"><button class=\"btn btn-block\" type=\"button\" name=\"button\" ng-click=\"vm.getStatus(vm.selectedRepeater)\" ladda=\"vm.getStatusLadda\">Check Status</button></span><span class=\"col-sm-4\"><button class=\"btn btn-block\" type=\"button\" name=\"button\" ng-click=\"vm.replaceRepeater(vm.selectedRepeater)\" ladda=\"vm.getStatusLadda\">Replace Repeater</button></span></td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bars\"></i> Repeater Status</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedRepeater\">No Repeater Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedRepeater\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Repeater NID</td><td>{{vm.selectedRepeater.configured_nid ? vm.selectedRepeater.configured_nid : \"Not Set\"}}</td></tr><tr><td>Configured</td><td>{{vm.selectedRepeater.repeater_configured ? \"OK\" : \"Alert\"}}</td></tr><tr><td>Online</td><td>{{vm.selectedRepeater.online ? \"Alert\" : \"OK\"}}</td></tr><tr><td>Tampered</td><td>{{vm.selectedRepeater.tampered ? \"Alert\" : \"OK\"}}</td></tr><tr><td>Battery Low</td><td>{{vm.selectedRepeater.battery_low ? \"Alert\" : \"OK\"}}</td></tr><tr><td>Power Status</td><td>{{vm.selectedRepeater.power_off ? \"Alert\" : \"OK\"}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-input-interface/admin-input-interface.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.inputsValid()\" ng-click=\"vm.saveInputs()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-download\"></i>Interface List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addInput()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Input Name</th></tr></thead><tbody><tr dir-paginate=\"input in (vm.filteredList = (vm.inputs | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedInput == input, \'danger\':!vm.inputValid(input)}\" ng-if=\"!input.deleted\" ng-click=\"vm.selectedInput = input\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedInput) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedInput) + 1])\"><td><i class=\"fa fa-minus-circle text-muted\" ng-class=\"{\'text-danger\':!input.in_use}\" ng-click=\"vm.removeInput($index, input)\"></i> {{input.name}}</td></tr><tr><td colspan=\"2\" ng-if=\"!vm.filteredList.length\">No Results Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Interface Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedInput\">No Input Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedInput\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Interface Name</td><td><input type=\"text\" ng-disabled=\"vm.selectedInput.id\" class=\"form-control\" ng-model=\"vm.selectedInput.name\"></td></tr><tr><td>Interface Type</td><td><select class=\"form-control\" ng-disabled=\"vm.selectedInput.id\" ng-model=\"vm.selectedInput.connection_type\" ng-options=\"inputInterface.id as inputInterface.name for inputInterface in vm.interfaceTypes | filter:{output_interface:\'false\'}\"></select></td></tr><tr ng-if=\"vm.selectedInput.connection_type != 8\"><td>System Type</td><td><select class=\"form-control\" ng-disabled=\"vm.selectedInput.id\" ng-model=\"vm.selectedInput.input_system\" ng-options=\"system.id as system.name for system in vm.systemTypes\"></select></td></tr><tr ng-if=\"vm.physicalInputTypes(vm.selectedInput.connection_type) == \'email\'\"><td>Email Server</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedInput.email_server\"></td></tr><tr ng-if=\"vm.physicalInputTypes(vm.selectedInput.connection_type) == \'email\'\"><td>Email Port</td><td><input type=\"number\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedInput.email_port\"></td></tr><tr ng-if=\"vm.physicalInputTypes(vm.selectedInput.connection_type) == \'email\'\"><td>Email From Address</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedInput.email_from_address\"></td></tr><tr ng-if=\"vm.physicalInputTypes(vm.selectedInput.connection_type) == \'email\'\"><td>Email Username</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedInput.email_user\"></td></tr><tr ng-if=\"vm.physicalInputTypes(vm.selectedInput.connection_type) == \'email\'\"><td>Email Password</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedInput.email_password\"></td></tr><tr ng-if=\"vm.physicalInputTypes(vm.selectedInput.connection_type) == \'network\'\"><td>Network Port</td><td><input type=\"number\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedInput.network_port\"></td></tr><tr ng-if=\"vm.physicalInputTypes(vm.selectedInput.connection_type) == \'serial\'\"><td>COM Port</td><td><input type=\"number\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedInput.com_port\"></td></tr><tr ng-if=\"vm.physicalInputTypes(vm.selectedInput.connection_type) == \'serial\'\"><td>Baud</td><td><select class=\"form-control\" ng-model=\"vm.selectedInput.baud_rate\" ng-options=\"baud.value as baud.label for baud in vm.serialBaud\"></select></td></tr><tr ng-if=\"vm.physicalInputTypes(vm.selectedInput.connection_type) == \'serial\'\"><td>Data Bits</td><td><select class=\"form-control\" ng-model=\"vm.selectedInput.data_bits\" ng-options=\"bit.value as bit.label for bit in vm.serialDataBits\"></select></td></tr><tr ng-if=\"vm.physicalInputTypes(vm.selectedInput.connection_type) == \'serial\'\"><td>Stop Bits</td><td><select class=\"form-control\" ng-model=\"vm.selectedInput.stop_bits\" ng-options=\"bit.value as bit.label for bit in vm.serialStopBits\"></select></td></tr><tr ng-if=\"vm.physicalInputTypes(vm.selectedInput.connection_type) == \'serial\'\"><td>Parity Bits</td><td><select class=\"form-control\" ng-model=\"vm.selectedInput.parity\" ng-options=\"parity.value as parity.label for parity in vm.serialParity\"></select></td></tr><tr><td>Default Escalation</td><td><select class=\"form-control\" ng-model=\"vm.selectedInput.default_escalation\" ng-options=\"escalation.id as escalation.name for escalation in vm.escalations\"></select></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-io-repeater-config/admin-io-repeater-config.html","<script type=\"text/ng-template\" id=\"confirmModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\">Delete Repeater?</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> Delete repeater {{vm.selectedRepeater.name}}? This cannot be undone. </div> <div class=\"modal-footer\"> <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.deleteRepeater()\">OK</button> </div> </div></script><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-wifi\"></i> I/O Repeater{{vm.selectedRepeater ? \":\" : \"s\"}} {{vm.selectedRepeater.serial_number}}</h3><span class=\"pull-right\" ng-if=\"vm.selectedRepeater\"><button class=\"btn\" ng-click=\"vm.clearRepeater()\">Cancel</button> <button class=\"btn btn-success\" ng-disabled=\"!vm.inputsValid()\" ng-click=\"vm.saveRepeater()\">Save</button></span></div><div class=\"box-content nopadding\"><table ng-if=\"!vm.selectedRepeater\" class=\"table table-hover table-nomargin\"><thead><tr><th>Repeater Name</th><th>Serial Number</th><th>IP Address</th><th>Database ID</th></tr></thead><tbody><tr ng-repeat=\"repeater in vm.repeaters\" ng-click=\"vm.loadRepeater(repeater.id)\" style=\"cursor: pointer;\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeRepeaterDialog()\"></i> {{repeater.name}}</td><td>{{repeater.serial_number}}</td><td>{{repeater.ip_address}}</td><td>{{repeater.id}}</td></tr><tr ng-if=\"!vm.repeaters.length\"><td colspan=\"4\">No Results Found</td></tr></tbody></table><div ng-if=\"vm.selectedRepeater\"><div class=\"form-group\"><h5>Repeater Name</h5><input type=\"text\" name=\"repeater_name\" class=\"form-control\" ng-model=\"vm.selectedRepeater.name\"></div><div class=\"form-group\"><h5>Online Status Monitoring</h5><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedRepeater.monitor_sanity}\" ng-click=\"vm.selectedRepeater.monitor_sanity = false\">Disabled</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedRepeater.monitor_sanity}\" ng-click=\"vm.selectedRepeater.monitor_sanity = true\">Enabled</button></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-sign-in\"></i>Input List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addInput()\" ng-if=\"vm.avalibleInputs().length\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><span ng-hide=\"vm.selectedRepeater.inputs.length\">No Inputs Available</span><table ng-show=\"vm.selectedRepeater.inputs.length\" class=\"table table-hover\"><thead><tr><th>Input Number</th><th>Input Name</th></tr></thead><tbody><tr ng-repeat=\"input in vm.selectedRepeater.inputs | orderBy:\'input\'\" ng-click=\"vm.selectedInput = input.input\" ng-class=\"{\'danger\':!vm.inputValid(input)}\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeInput(input)\"></i> Input {{input.input}}</td><td>{{input.name}}</td></tr></tbody></table></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Input Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedInput\">No Input Selected</span><table class=\"table table-hover\" ng-repeat=\"input in vm.selectedRepeater.inputs\" ng-if=\"input.input == vm.selectedInput\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Input Number</td><td><select class=\"form-control\" ng-model=\"input.input\" ng-options=\"input for input in vm.avalibleInputs(input.input)\" ng-change=\"vm.selectedInput = input.input\"></select></td></tr><tr><td>Input Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"input.name\"></td></tr><tr ng-if=\"input.type != 3\"><td>Apartment</td><td><ui-select name=\"output\" ng-model=\"input.apartment\" style=\"width: 100%;\"><ui-select-match>{{$select.selected.name}} <button class=\"btn-clear pull-right\" ng-click=\"vm.clearApt($event, input)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"apartment.id as apartment in vm.apartments | filter:$select.search\">{{apartment.name}}</ui-select-choices></ui-select></td></tr><tr><td>Input Type</td><td><select class=\"form-control\" ng-disabled=\"!vm.avalibleInputs().length && !input.type\" ng-model=\"input.type\" ng-options=\"item.value as item.lable for item in [{lable: \'Momentary\', value: 1 },{ lable: \'Latching\', value: 0 }, {lable: \'Check-In\', value: 2 }, {lable: \'Lockdown\', value: 3 }]\" ng-change=\"input.reset_input = vm.setResetInput(input); vm.setSchedule(input)\"></select></td></tr><tr ng-if=\"!input.type\"><td>Reset Input</td><td><select class=\"form-control\" ng-model=\"input.reset_input\" ng-options=\"input for input in vm.avalibleInputs(input.reset_input)\"></select></td></tr><tr><td>State</td><td><select class=\"form-control\" ng-model=\"input.state\" ng-options=\"item.value as item.lable for item in [{lable: \'Normally Open\', value: 0 },{ lable: \'Normally Closed\', value: 1 }]\"></select></td></tr><tr ng-if=\"input.type != 2 && input.type != 3\"><td>Schedule</td><td><select class=\"form-control\" ng-model=\"input.schedule_id\" ng-options=\"schedule.id as schedule.name for schedule in vm.schedules\"></select></td></tr><tr ng-if=\"input.type == 2\"><td>Check In Schedule</td><td><select class=\"form-control\" ng-model=\"input.schedule_id\" ng-options=\"schedule.id as schedule.name for schedule in vm.checkInSchedules\"></select></td></tr><tr ng-if=\"input.type != 2 && input.type != 3\"><td>Alarm Start Debounce (Seconds)</td><td><input type=\"number\" step=\"0.01\" min=\"0\" class=\"form-control\" ng-model=\"input.start_debounce\"></td></tr><tr ng-if=\"input.type != 2 && input.type != 3\"><td>Reset Debounce (Seconds)</td><td><input type=\"number\" step=\"0.01\" min=\"0\" class=\"form-control\" ng-model=\"input.reset_debounce\"></td></tr><tr ng-if=\"input.type != 2 && input.type != 3\"><td>Bypass Time</td><td><input type=\"number\" step=\"0.01\" min=\"0\" class=\"form-control\" ng-model=\"input.bypass_time\"></td></tr><tr ng-if=\"input.type != 2 && input.type != 3\"><td>Escalations</td><td><ui-select name=\"output\" multiple=\"\" ng-model=\"input.escalations\" style=\"width: 100%;\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalations | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></td></tr><tr ng-if=\"input.type != 2 && input.type != 3\"><td>Outputs</td><td><ui-select name=\"output\" multiple=\"\" ng-if=\"input.outputs\" ng-model=\"input.outputs\" style=\"width: 100%;\"><ui-select-match>{{$item}}</ui-select-match><ui-select-choices repeat=\"item in [1,2,3,4,5] | filter:$select.search\">{{item}}</ui-select-choices></ui-select></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/admin-output-interface/admin-output-interface.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.outputsValid()\" ng-click=\"vm.saveOutputs()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-home\"></i>Interface List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addOutput()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Output Name</th></tr></thead><tbody><tr dir-paginate=\"output in (vm.filteredList = (vm.outputs | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedOutput == output, \'danger\':!vm.outputValid(output)}\" ng-if=\"!output.deleted\" ng-click=\"vm.selectedOutput = output\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedOutput) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedOutput) + 1])\"><td><i class=\"fa fa-minus-circle text-muted\" ng-class=\"{\'text-danger\':!output.in_use}\" ng-click=\"vm.removeOutput($index, output)\"></i> {{output.name}}</td></tr><tr><td colspan=\"2\" ng-if=\"!vm.filteredList.length\">No Results Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Interface Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedOutput\">No Output Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedOutput\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Interface Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedOutput.name\"></td></tr><tr><td>Interface Type</td><td><select class=\"form-control\" ng-disabled=\"vm.selectedOutput.id\" ng-model=\"vm.selectedOutput.connection_type\" ng-options=\"outputInterface.id as outputInterface.name for outputInterface in vm.interfaceTypes | filter:{output_interface:\'true\'}\"></select></td></tr><tr ng-if=\"vm.selectedOutput.connection_type != 11 && vm.selectedOutput.connection_type != 13 && vm.selectedOutput.connection_type != 17\"><td>Output Throttle (Seconds)</td><td><input type=\"number\" ignore-mouse-number=\"\" min=\"0\" max=\"99\" class=\"form-control\" ng-model=\"vm.selectedOutput.throttle\"></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'email\'\"><td>Email Server</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedOutput.email_server\"></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'email\'\"><td>Email Port</td><td><input type=\"number\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedOutput.email_port\"></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'email\'\"><td>Email From Address</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedOutput.email_from_address\"></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'email\'\"><td>Email Username</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedOutput.email_user\"></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'email\'\"><td>Email Password</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedOutput.email_password\"></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'twilio\'\"><td>Twilio Phone Number</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedOutput.email_from_address\"></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'twilio\'\"><td>Twilio Account SID</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedOutput.email_user\"></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'twilio\'\"><td>Twilio Token</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedOutput.email_password\"></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'network\'\"><td>IP Address</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedOutput.ip_address\"></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'network\'\"><td>Network Port</td><td><input type=\"number\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedOutput.network_port\"></td></tr><tr ng-if=\"vm.selectedOutput.connection_type == 17\"><td>Actions</td><td><button class=\"btn bnt-block bnt-warning\" type=\"button\" name=\"button\" ng-click=\"vm.allLightsOn(vm.selectedOutput)\">All Lights On</button> <button class=\"btn bnt-block bnt-warning\" type=\"button\" name=\"button\" ng-click=\"vm.resetLights(vm.selectedOutput)\">Clear All Lights</button></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'serial\'\"><td>COM Port</td><td><input type=\"number\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedOutput.com_port\"></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'serial\'\"><td>Baud</td><td><select class=\"form-control\" ng-model=\"vm.selectedOutput.baud_rate\" ng-options=\"baud.value as baud.label for baud in vm.serialBaud\"></select></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'serial\'\"><td>Data Bits</td><td><select class=\"form-control\" ng-model=\"vm.selectedOutput.data_bits\" ng-options=\"bit.value as bit.label for bit in vm.serialDataBits\"></select></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'serial\'\"><td>Stop Bits</td><td><select class=\"form-control\" ng-model=\"vm.selectedOutput.stop_bits\" ng-options=\"bit.value as bit.label for bit in vm.serialStopBits\"></select></td></tr><tr ng-if=\"vm.physicalOutputTypes(vm.selectedOutput.connection_type) == \'serial\'\"><td>Parity Bits</td><td><select class=\"form-control\" ng-model=\"vm.selectedOutput.parity\" ng-options=\"parity.value as parity.label for parity in vm.serialParity\"></select></td></tr><tr ng-if=\"vm.selectedOutput.connection_type != 11 && vm.selectedOutput.connection_type != 13 && vm.selectedOutput.connection_type != 17\"><td>Message Footer</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedOutput.interface_message_footer\"></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-map-config/admin-map-config.html","<script type=\"text/ng-template\" id=\"addModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\">Add a Map</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <div class=\"form-group\"> <input type=\"text\" class=\"form-control\" ng-model=\"vm.uploadData.uploadMapName\" placeholder=\"Map Name\"> </div> <div ng-if=\"!vm.uploadData.tmpImage\" class=\"form-group\"> Upload Image <div ngf-drop ngf-select ng-model=\"vm.uploadData.tmpImage\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"false\" ngf-allow-dir=\"false\" accept=\"image/*\" ngf-pattern=\"\'image/*\'\">Drop Image Here (JPG/PNG)</div> <div ng-if=\"!vm.picFile\" ngf-no-file-drop>File Drag/Drop is not supported for this browser</div> </div> <!-- Poster --> <div class=\"form-group\" ng-if=\"vm.uploadData.tmpImage\"> Crop Image <div class=\"cropArea\"> <ui-cropper image=\"vm.uploadData.tmpImage\" result-image-size=\"1920\" area-type=\"rectangle\" init-max-area=\"true\" result-image=\"vm.uploadData.croppedImg\"></ui-cropper> </div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn\" type=\"button\" ng-click=\"vm.closeAddModal()\">Cancel</button> <button class=\"btn\" type=\"button\" ng-disabled=\"!vm.uploadData.uploadMapName || !vm.uploadData.croppedImg\" ng-click=\"vm.uploadMap({\'name\':vm.uploadData.uploadMapName}, vm.uploadData.croppedImg)\">Save</button> </div> </div></script><div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.mapsValid()\" ng-click=\"vm.saveMaps()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-home\"></i>Map List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addMap()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Map Name</th></tr></thead><tbody><tr dir-paginate=\"map in (vm.filteredList = (vm.maps | filter:vm.searchFilter)) | orderBy:\'sort_order\' | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedMap == map, \'danger\':!vm.mapValid(map)}\" ng-if=\"!map.deleted\" ng-click=\"vm.selectedMap = map\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedMap) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedMap) + 1])\"><td><i class=\"fa fa-minus-circle text-muted\" ng-class=\"{\'text-danger\': !map.in_use}\" ng-click=\"vm.removeMap($index, map)\"></i> {{map.name}} <span class=\"pull-right\"><i class=\"fa fa-arrow-up\" ng-if=\"!$first\" ng-click=\"vm.moveLevel($index, vm.maps, \'up\')\"></i> <i class=\"fa fa-arrow-down\" ng-if=\"!$last\" ng-click=\"vm.moveLevel($index, vm.maps, \'down\')\"></i></span></td></tr><tr><td colspan=\"2\" ng-if=\"!vm.filteredList.length\">No Results Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Map Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedMap\">No Map Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedMap\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Map Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedMap.name\"></td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Map Preview</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedMap\">No Map Selected</span> <img ng-hide=\"!vm.selectedMap\" class=\"img-responsive\" src=\"{{vm.mapPath + vm.selectedMap.filename}}\"></div></div></div></div>");
$templateCache.put("app/admin-quantum-upgrade-manager/admin-quantum-upgrade-manager.html","<div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.doors.length}} Quantum Door Controllers</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.drOrderByKey = \'serial_number\'; vm.drOrderReverse = !vm.drOrderReverse\">Serial Number <span ng-show=\"vm.drOrderByKey == \'serial_number\' && !vm.drOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.drOrderByKey == \'serial_number\' && vm.drOrderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.drOrderByKey = \'name\'; vm.drOrderReverse = !vm.drOrderReverse\">Device Name <span ng-show=\"vm.drOrderByKey == \'name\' && !vm.drOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.drOrderByKey == \'name\' && vm.drOrderReverse\" class=\"fa fa-caret-up\"></span></th><th>S/W Version</th></tr></thead><tbody><tr ng-repeat=\"door in vm.doors | orderBy:vm.drOrderByKey | orderBy:\'+\':vm.drOrderReverse\"><td>{{door.serial_number}}</td><td>{{door.name}}</td><td>{{door.sw_version ? door.sw_version:\"Unknown\"}} <button class=\"btn\" ng-disabled=\"vm.disableUpdate(door.id)\" ng-click=\"vm.updateFirmware(door.id)\" ng-if=\"vm.firmwareCheck(door) && door.sw_version\"><i class=\"fa fa-cloud-download\"></i></button></td></tr><tr ng-if=\"!vm.doors.length\"><td colspan=\"3\">No Results Found</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.ioRepeaters.length}} Quantum IO Repeaters</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.qrptOrderByKey = \'serial_number\'; vm.qrptOrderReverse = !vm.qrptOrderReverse\">Serial Number <span ng-show=\"vm.qrptOrderByKey == \'serial_number\' && !vm.qrptOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.qrptOrderByKey == \'serial_number\' && vm.qrptOrderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.qrptOrderByKey = \'name\'; vm.qrptOrderReverse = !vm.qrptOrderReverse\">Device Name <span ng-show=\"vm.qrptOrderByKey == \'name\' && !vm.qrptOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.qrptOrderByKey == \'name\' && vm.qrptOrderReverse\" class=\"fa fa-caret-up\"></span></th><th>S/W Version</th></tr></thead><tbody><tr ng-repeat=\"repeater in vm.ioRepeaters | orderBy:vm.qrptOrderByKey | orderBy:\'+\':vm.qrptOrderReverse\"><td>{{repeater.serial_number}}</td><td>{{repeater.name}}</td><td>{{repeater.sw_version ? repeater.sw_version:\"Unknown\"}} <button class=\"btn\" ng-disabled=\"vm.disableUpdate(repeater.id)\" ng-click=\"vm.updateFirmware(repeater.id)\" ng-if=\"vm.firmwareCheck(repeater) && repeater.sw_version\"><i class=\"fa fa-cloud-download\"></i></button></td></tr><tr ng-if=\"!vm.ioRepeaters.length\"><td colspan=\"3\">No Results Found</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.enrollmentStations.length}} Quantum Tag Enrollment Stations</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.esOrderByKey = \'serial_number\'; vm.esOrderReverse = !vm.esOrderReverse\">Serial Number <span ng-show=\"vm.esOrderByKey == \'serial_number\' && !vm.esOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.esOrderByKey == \'serial_number\' && vm.esOrderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.esOrderByKey = \'name\'; vm.esOrderReverse = !vm.esOrderReverse\">Device Name <span ng-show=\"vm.esOrderByKey == \'name\' && !vm.esOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.esOrderByKey == \'name\' && vm.esOrderReverse\" class=\"fa fa-caret-up\"></span></th><th>S/W Version</th></tr></thead><tbody><tr ng-repeat=\"enrollmentStation in vm.enrollmentStations | orderBy:vm.esOrderByKey | orderBy:\'+\':vm.esOrderReverse\"><td>{{enrollmentStation.serial_number}}</td><td>{{enrollmentStation.name}}</td><td>{{enrollmentStation.sw_version ? enrollmentStation.sw_version:\"Unknown\"}} <button ng-disabled=\"vm.disableUpdate(enrollmentStation.id)\" class=\"btn\" ng-click=\"vm.updateFirmware(enrollmentStation.id)\" ng-if=\"vm.firmwareCheck(enrollmentStation) && enrollmentStation.sw_version\"><i class=\"fa fa-cloud-download\"></i></button></td></tr><tr ng-if=\"!vm.enrollmentStations.length\"><td colspan=\"3\">No Results Found</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.systemMonitors.length}} Quantum System Monitors</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.smOrderByKey = \'serial_number\'; vm.smOrderReverse = !vm.smOrderReverse\">Serial Number <span ng-show=\"vm.smOrderByKey == \'serial_number\' && !vm.smOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.smOrderByKey == \'serial_number\' && vm.smOrderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.smOrderByKey = \'name\'; vm.smOrderReverse = !vm.smOrderReverse\">Device Name <span ng-show=\"vm.smOrderByKey == \'name\' && !vm.smOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.smOrderByKey == \'name\' && vm.smOrderReverse\" class=\"fa fa-caret-up\"></span></th><th>S/W Version</th></tr></thead><tbody><tr ng-repeat=\"systemMonitor in vm.systemMonitors | orderBy:vm.smOrderByKey | orderBy:\'+\':vm.smOrderReverse\"><td>{{systemMonitor.serial_number}}</td><td>{{systemMonitor.name}}</td><td>{{systemMonitor.sw_version ? systemMonitor.sw_version:\"Unknown\"}} <button ng-disabled=\"vm.disableUpdate(systemMonitor.id)\" class=\"btn\" ng-click=\"vm.updateFirmware(systemMonitor.id)\" ng-if=\"vm.firmwareCheck(systemMonitor) && systemMonitor.sw_version\"><i class=\"fa fa-cloud-download\"></i></button></td></tr><tr ng-if=\"!vm.systemMonitors.length\"><td colspan=\"3\">No Results Found</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.mobileDevices.length}} Quantum Mobile Devices</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.smOrderByKey = \'name\'; vm.smOrderReverse = !vm.smOrderReverse\">Device Name <span ng-show=\"vm.smOrderByKey == \'name\' && !vm.smOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.smOrderByKey == \'name\' && vm.smOrderReverse\" class=\"fa fa-caret-up\"></span></th><th>S/W Version</th><th>Phone HW Serial</th><th>Phone Manufacturer</th><th>Phone Model</th><th>Phone OS Version</th></tr></thead><tbody><tr ng-repeat=\"device in vm.mobileDevices | orderBy:vm.smOrderByKey | orderBy:\'+\':vm.smOrderReverse\"><td>{{device.name}}</td><td><i ng-if=\"vm.compareSymVer(device.version, vm.systemSettings.expected_mobile_version) < 0\" class=\"fa fa-exclamation-triangle\" style=\"color: #e51400\"></i> {{device.version ? device.version:\"Unknown\"}}</td><td>{{device.mobile_device_serial}}</td><td>{{device.mobile_device_manufacturer}}</td><td>{{device.mobile_device_model}}</td><td>{{device.mobile_os_version}}</td></tr><tr ng-if=\"!vm.mobileDevices.length\"><td colspan=\"3\">No Results Found</td></tr></tbody></table></div></div>");
$templateCache.put("app/admin-pullcord-utility/admin-pullcord-utility.html","<div class=\"box\"><div class=\"box-title\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.importValid()\" ng-click=\"vm.saveAreas()\">Save</button></span><h3><i class=\"fa fa-bars\"></i> Pull Cord Utility</h3></div><div class=\"box-content nopadding\"><table class=\"table\"><h4>Default Options</h4><thead><tr><th class=\"col-md-1\">Prepend</th><th class=\"col-md-2\">Quick Button 1</th><th class=\"col-md-2\">Quick Button 2</th><th class=\"col-md-2\">Quick Button 3</th><th class=\"col-md-2\">Escalation</th><th class=\"col-md-1\">Staff Assist</th><th class=\"col-md-2\" ng-if=\"vm.staffAssistActive\">Staff Assist Escalation</th></tr></thead><tbody><tr><td><input class=\"form-control\" ng-model=\"vm.prependText\"></td><td><input class=\"form-control\" ng-model=\"vm.quickBtn1\"></td><td><input class=\"form-control\" ng-model=\"vm.quickBtn2\"></td><td><input class=\"form-control\" ng-model=\"vm.quickBtn3\"></td><td><ui-select name=\"escalations\" multiple=\"\" ng-model=\"vm.defaultEscalations\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalationData | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></td><td><select ng-disabled=\"vm.formData.length\" ng-change=\"vm.defaultStaffEscalation = []\" class=\"form-control\" ng-model=\"vm.staffAssistActive\" ng-options=\"item.value as item.key for item in [{key:\'Yes\', value:true}, {key:\'No\', value:false}]\"></select></td><td ng-if=\"vm.staffAssistActive\"><ui-select name=\"escalations\" multiple=\"\" ng-model=\"vm.defaultStaffEscalation\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalationData | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></td></tr></tbody></table><h4>Pull Cord List</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th class=\"col-md-1\">Serial</th><th class=\"col-md-1\">Apartment</th><th class=\"col-md-2\">Device Name</th><th class=\"col-md-2\">Escalation Groups</th><th class=\"col-md-2\" ng-if=\"vm.staffAssistActive\">Staff Assist Escalation</th><th class=\"col-md-3\">Quick Text</th></tr></thead><tbody><tr ng-if=\"!vm.formData.length\"><td colspan=\"6\">Reset Pullcord to Enroll</td></tr><tr ng-repeat=\"device in vm.formData\" ng-class=\"{\'danger\':!vm.rowValid(device)}\"><td><h5><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removePullCord(vm.formData.indexOf(device), device)\"></i> {{device.serial_number}}</h5></td><td><ui-select name=\"apartment\" ui-select-single-required=\"\" ng-model=\"device.sub_devices[0].apartment\" on-select=\"vm.nameAutofill(device, $item)\"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"apartment.id as apartment in vm.apartmentData | filter:$select.search\">{{apartment.name}}</ui-select-choices></ui-select></td><td><input class=\"form-control\" ng-model=\"device.sub_devices[0].name\" ng-change=\"vm.updateName(device)\"></td><td><ui-select name=\"escalations\" multiple=\"\" ui-select-required=\"\" ng-model=\"device.sub_devices[0].escalations\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalationData | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></td><td ng-if=\"vm.staffAssistActive\"><ui-select name=\"escalations\" multiple=\"\" ui-select-required=\"\" ng-model=\"device.sub_devices[1].escalations\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalationData | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></td><td><button ng-if=\"vm.quickBtn1\" type=\"button\" class=\"btn\" ng-click=\"vm.appendBtn(device, vm.quickBtn1)\">{{vm.quickBtn1}}</button> <button ng-if=\"vm.quickBtn2\" type=\"button\" class=\"btn\" ng-click=\"vm.appendBtn(device, vm.quickBtn2)\">{{vm.quickBtn2}}</button> <button ng-if=\"vm.quickBtn3\" type=\"button\" class=\"btn\" ng-click=\"vm.appendBtn(device, vm.quickBtn3)\">{{vm.quickBtn3}}</button></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin-resident-import/admin-resident-import.html","<div class=\"col-sm-12\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-arrow-circle-down\"></i> <span>Apartment & Resident Import</span></h3><span class=\"pull-right\">Pendant Type:<select ng-model=\"vm.pendantType\" ng-options=\"item.value as item.label for item in vm.pendantTypes\"></select><button class=\"btn btn-success\" ladda=\"vm.submitting\" data-spinner-size=\"20\" ng-disabled=\"!csv.content || !vm.importValid()\" ng-click=\"vm.saveApartment()\" ng-if=\"!vm.results.length || vm.submitting\">Save</button> <button class=\"btn btn-success\" ng-click=\"vm.reset()\" ng-if=\"vm.results.length && !vm.submitting\">Import Another</button></span></div><div class=\"box-content nopadding\"><ng-csv-import class=\"search-box\" content=\"csv.content\" header=\"true\" separator=\"\',\'\" result=\"vm.csvResult\" accept=\"csv.accept\"></ng-csv-import><div class=\"col-sm-7\" ng-if=\"!vm.csvResult\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-book\"></i> <span>Instructions for Use</span></h3></div><div class=\"box-content\"><h4>Notes</h4><ol><li><strong>Do not change the header row of the CSV template or the import will fail</strong></li><li><strong>If a line of the import fails, DO NOT re-import the entire sheet. This will cause duplicate entries. Fix that line in manually.</strong></li></ol><h4>CSV Preparation</h4><ol><li>Set Up Your Escalations and Areas First</li><li><a href=\"../assets/csv/resident_import.csv\" target=\"_self\">Click Here to Download the CSV file template</a></li><li>Fill the apartment column with all of the site\'s apartment names</li><li>Reference the area table to the right and fill the area column</li><li>If the area is left blank, the area will default to the \"All Areas\" area</li><li>If you\'re assigning a resident to the apartment, fill out the first name, last name, call button, and escalation fields</li><li>Refer to the table to the right for the escalation ID</li><li>If the apartment is vacant, leave all fields blank except for apartment</li><li>Save file to csv</li></ol><h4>Import file</h4><ol><li>Select the pendant type in the selector in the top right</li><li>Click the select file button above and chose the file</li><li>Review the data for errors and click save</li><li>Rows that need correction will be red</li></ol></div></div></div><div class=\"col-sm-5\" ng-if=\"!vm.csvResult\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bars\"></i> <span>Available Areas</span></h3></div><div class=\"box-content\"><table class=\"table\"><thead><tr><th>Area ID</th><th>Area Name</th></tr></thead><tbody><tr ng-repeat=\"area in vm.areas\"><td>{{area.id}}</td><td>{{area.name}}</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bars\"></i> <span>Available Escalations</span></h3></div><div class=\"box-content\"><table class=\"table\"><thead><tr><th>Escalation ID</th><th>Escalation Name</th></tr></thead><tbody><tr ng-repeat=\"escalation in vm.escalations\"><td>{{escalation.id}}</td><td>{{escalation.name}}</td></tr></tbody></table></div></div></div><table class=\"table\" ng-if=\"vm.csvResult && !vm.results.length\"><thead><tr><th>Apartment</th><th>Area</th><th>Resident Name</th><th>Resident Call Button</th><th>Spouse/Roomate Name</th><th>Spouse/Roomate Call Button</th><th>Escalation Name</th></tr></thead><tbody><tr ng-repeat=\"item in vm.csvResult\" ng-class=\"{\'danger\':!vm.apartmentValid(item)}\"><td>{{item.apartment_name}}</td><td><span ng-repeat=\"area in vm.areas | findObject:item.area_id as filtered\">{{area.name}}</span> <span ng-if=\"!item.area_id\" ng-repeat=\"area in vm.areas | findObject:\'1\'\">{{area.name}}</span> <span class=\"text-danger\" ng-if=\"item.area_id && !filtered.length\">Invalid Area ID</span></td><td ng-if=\"vm.apartmentVacant(item)\" colspan=\"4\">Vacant</td><td ng-if=\"!vm.apartmentVacant(item)\">{{item.first_name}} {{item.last_name}}</td><td ng-if=\"!vm.apartmentVacant(item)\"><i class=\"fa fa-warning\" style=\"color: #e51400\" ng-if=\"item.call_button_serial && (!vm.callButtonEnrolled(item.call_button_serial) && vm.callButtonsUnique(item.call_button_serial) && !isNaN(parseInt(item.call_button_serial)))\"></i>{{item.call_button_serial}}</td><td ng-if=\"!vm.apartmentVacant(item)\">{{item.spouse_first_name}} {{item.spouse_last_name}}</td><td ng-if=\"!vm.apartmentVacant(item)\"><i class=\"fa fa-warning\" style=\"color: #e51400\" ng-if=\"item.spouse_call_button_serial && (!vm.callButtonEnrolled(item.spouse_call_button_serial) && vm.callButtonsUnique(item.spouse_call_button_serial) && !isNaN(parseInt(item.spouse_call_button_serial)))\"></i>{{item.spouse_call_button_serial}}</td><td ng-if=\"!vm.apartmentVacant(item)\"><span ng-repeat=\"escalation in vm.escalations | findObject:item.escalation_id as filtered\">{{escalation.name}}</span> <span class=\"text-danger\" ng-if=\"item.escalation_id && !filtered.length\">Invalid Escalation ID</span></td></tr></tbody></table><div class=\"col-sm-12\" ng-if=\"vm.results.length\"><div class=\"box\"><div class=\"box-title\"><h3 ng-if=\"vm.submitting\"><i class=\"fa fa-spinner fa-pulse\"></i> <span>Importing...</span></h3><h3 ng-if=\"!vm.submitting\"><i class=\"fa fa-bars\"></i> <span>Import Results</span></h3></div><div class=\"box-content\"><table class=\"table\"><thead><tr><th>Apartment</th><th>Results</th></tr></thead><tbody><tr ng-repeat=\"result in vm.results\"><td>{{result.apartment}}</td><td>{{result.result}}</td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/admin-staff-access-group/admin-staff-access-group.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.groupsValid()\" ng-click=\"vm.saveGroups()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-users\"></i>Group List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addGroup()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Group Name</th></tr></thead><tbody><tr dir-paginate=\"group in (vm.filteredList = (vm.groups | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedGroup == group}\" ng-if=\"!group.deleted && group.id !== 2 && group.id !== 1 && group.id !== 0\" ng-click=\"vm.selectedGroup = group\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedGroup) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedGroup) + 1])\"><td><i class=\"fa fa-minus-circle\" ng-class=\"group.id == 1 ? \'text-muted\' : \'text-danger\'\" ng-click=\"vm.removeGroup($index, group)\"></i> {{group.name}}</td></tr><tr><td colspan=\"2\" ng-if=\"vm.filteredList.length < 4\">No Results Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Group Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedGroup\">No Group Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedGroup\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Group Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedGroup.name\"></td></tr><tr><td>Door Control</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedGroup.properties.door_control_access}\" ng-click=\"vm.selectedGroup.properties.door_control_access = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedGroup.properties.door_control_access}\" ng-click=\"vm.selectedGroup.properties.door_control_access = true\">Active</button></div></td></tr><tr><td>Door Lockdown</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedGroup.properties.facility_lockdown_access}\" ng-click=\"vm.selectedGroup.properties.facility_lockdown_access = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedGroup.properties.facility_lockdown_access}\" ng-click=\"vm.selectedGroup.properties.facility_lockdown_access = true\">Active</button></div></td></tr><tr><td>Door Schedules</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedGroup.properties.door_schedule_access}\" ng-click=\"vm.selectedGroup.properties.door_schedule_access = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedGroup.properties.door_schedule_access}\" ng-click=\"vm.selectedGroup.properties.door_schedule_access = true\">Active</button></div></td></tr><tr><td>Resident View</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedGroup.properties.resident_view_access}\" ng-click=\"vm.selectedGroup.properties.resident_view_access = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedGroup.properties.resident_view_access}\" ng-click=\"vm.selectedGroup.properties.resident_view_access = true\">Active</button></div></td></tr><tr><td>Resident Edit</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedGroup.properties.resident_edit_access}\" ng-click=\"vm.selectedGroup.properties.resident_edit_access = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedGroup.properties.resident_edit_access}\" ng-click=\"vm.selectedGroup.properties.resident_edit_access = true\">Active</button></div></td></tr><tr><td>Resident Reports</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedGroup.properties.resident_reports_access}\" ng-click=\"vm.selectedGroup.properties.resident_reports_access = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedGroup.properties.resident_reports_access}\" ng-click=\"vm.selectedGroup.properties.resident_reports_access = true\">Active</button></div></td></tr><tr><td>Staff View</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedGroup.properties.staff_view_access}\" ng-click=\"vm.selectedGroup.properties.staff_view_access = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedGroup.properties.staff_view_access}\" ng-click=\"vm.selectedGroup.properties.staff_view_access = true\">Active</button></div></td></tr><tr><td>Staff Edit</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedGroup.properties.staff_edit_access}\" ng-click=\"vm.selectedGroup.properties.staff_edit_access = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedGroup.properties.staff_edit_access}\" ng-click=\"vm.selectedGroup.properties.staff_edit_access = true\">Active</button></div></td></tr><tr><td>Staff and System Reports</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedGroup.properties.system_reports_access}\" ng-click=\"vm.selectedGroup.properties.system_reports_access = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedGroup.properties.system_reports_access}\" ng-click=\"vm.selectedGroup.properties.system_reports_access = true\">Active</button></div></td></tr><tr><td>Operator Admin</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedGroup.properties.operator_admin}\" ng-click=\"vm.selectedGroup.properties.operator_admin = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedGroup.properties.operator_admin}\" ng-click=\"vm.selectedGroup.properties.operator_admin = true\">Active</button></div></td></tr><tr><td>System Config</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedGroup.properties.system_config_access}\" ng-click=\"vm.selectedGroup.properties.system_config_access = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedGroup.properties.system_config_access}\" ng-click=\"vm.selectedGroup.properties.system_config_access = true\">Active</button></div></td></tr><tr><td>Snooze Alarms</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedGroup.properties.reset_alarms_access}\" ng-click=\"vm.selectedGroup.properties.reset_alarms_access = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedGroup.properties.reset_alarms_access}\" ng-click=\"vm.selectedGroup.properties.reset_alarms_access = true\">Active</button></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-staff-import/admin-staff-import.html","<div class=\"col-sm-12\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-arrow-circle-down\"></i> <span>Staff Credential Import</span></h3><span class=\"pull-right\"><button class=\"btn btn-success\" ladda=\"vm.submitting\" data-spinner-size=\"20\" ng-disabled=\"!csv.content || !vm.importValid()\" ng-click=\"vm.saveApartment()\" ng-if=\"!vm.results.length || vm.submitting\">Save</button> <button class=\"btn btn-success\" ng-click=\"vm.reset()\" ng-if=\"vm.results.length && !vm.submitting\">Import Another</button></span></div><div class=\"box-content nopadding\"><ng-csv-import class=\"search-box\" content=\"csv.content\" header=\"true\" separator=\"\',\'\" result=\"vm.csvResult\" accept=\"csv.accept\"></ng-csv-import><div class=\"col-sm-7\" ng-if=\"!vm.csvResult\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-book\"></i> <span>Instructions for Use</span></h3></div><div class=\"box-content\"><h4>Notes</h4><ol><li><strong>Do not change the header row of the CSV template or the import will fail</strong></li><li><strong>If a line of the import fails, DO NOT re-import the entire sheet. This will cause duplicate entries. Fix that line in manually.</strong></li></ol><h4>CSV Preperation</h4><ol><li>Set Up Your Door Access Groups and Staff Schedules First</li><li><a href=\"../assets/csv/staff_import.csv\" target=\"_self\">Click Here to Download the CSV file template</a></li><li>Fill the first and last name field; email is optional</li><li>Fill in the 5 digit keycard code and/or 4 digit keypad code</li><li>Fill in the Door Access Level (1-3)<ol><li>Bypass Only (Resident Not Present)</li><li>Bypass Only (At Any Time)</li><li>Bypass and Reset Alarms</li></ol></li><li>Reference the tables to the right to fill in the Access Group and Schedule<br><em>Leave Blank for All Doors / All Access</em></li></ol><h4>Import file</h4><ol><li>Click the select file button above and chose the file</li><li>Review the data for errors and click save</li><li>Rows that need correction will be red</li></ol></div></div></div><div class=\"col-sm-5\" ng-if=\"!vm.csvResult\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bars\"></i> <span>Available Door Groups</span></h3></div><div class=\"box-content\"><table class=\"table\"><thead><tr><th>Group ID</th><th>Group Name</th></tr></thead><tbody><tr ng-repeat=\"doorGroup in vm.doorGroups\"><td>{{doorGroup.id}}</td><td>{{doorGroup.name}}</td></tr></tbody></table></div></div></div><div class=\"col-sm-5\" ng-if=\"!vm.csvResult\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bars\"></i> <span>Available Door Schedules</span></h3></div><div class=\"box-content\"><table class=\"table\"><thead><tr><th>Schedule ID</th><th>Schedule Name</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules\"><td>{{schedule.id}}</td><td>{{schedule.name}}</td></tr></tbody></table></div></div></div><table class=\"table\" ng-if=\"vm.csvResult && !vm.results.length\"><thead><tr><th>Staff Name</th><th>Email</th><th>Keycard Code</th><th>Keypad Code</th><th>Access Level</th><th>Access Group</th><th>Access Schedule</th></tr></thead><tbody><tr ng-repeat=\"item in vm.csvResult\" ng-class=\"{\'danger\':!vm.staffValid(item)}\"><td>{{item.first_name}} {{item.last_name}}</td><td>{{item.email}}</td><td><span ng-class=\"{\'text-danger\':vm.codesUnique(item.keycard_code) || !vm.codeValid(item.keycard_code, false)}\">{{item.keycard_code}}</span></td><td><span ng-class=\"{\'text-danger\':vm.codesUnique(item.keypad_code) || !vm.codeValid(item.keypad_code, true)}\">{{item.keypad_code}}</span></td><td><span ng-repeat=\"group in vm.doorAccessLevels | findObject:item.door_access_level as filteredLevel\">{{group.name}}</span> <span ng-if=\"!item.door_access_level\" ng-repeat=\"group in vm.doorAccessLevels | findObject:\'1\'\">{{group.name}}</span> <span class=\"text-danger\" ng-if=\"item.door_access_level && !filteredLevel.length\">Invalid Access Level</span></td><td><span ng-repeat=\"group in vm.doorGroups | findObject:item.door_access_group as filteredGroup\">{{group.name}}</span> <span ng-if=\"!item.door_access_group\" ng-repeat=\"group in vm.doorGroups | findObject:\'1\'\">{{group.name}}</span> <span class=\"text-danger\" ng-if=\"item.door_access_group && !filteredGroup.length\">Invalid Group ID</span></td><td><span ng-repeat=\"schedule in vm.schedules | findObject:item.door_access_schedule as filteredSchedule\">{{schedule.name}}</span> <span ng-if=\"!item.door_access_schedule\" ng-repeat=\"schedule in vm.schedules | findObject:\'1\'\">{{schedule.name}}</span> <span class=\"text-danger\" ng-if=\"item.door_access_schedule && !filteredSchedule.length\">Invalid Schedule ID</span></td></tr></tbody></table><div class=\"col-sm-12\" ng-if=\"vm.results.length\"><div class=\"box\"><div class=\"box-title\"><h3 ng-if=\"vm.submitting\"><i class=\"fa fa-spinner fa-pulse\"></i> <span>Importing...</span></h3><h3 ng-if=\"!vm.submitting\"><i class=\"fa fa-bars\"></i> <span>Import Results</span></h3></div><div class=\"box-content\"><table class=\"table\"><thead><tr><th>Apartment</th><th>Results</th></tr></thead><tbody><tr ng-repeat=\"result in vm.results\"><td>{{result.name}}</td><td>{{result.result}}</td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/admin-system-config/admin-system-config.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.configurationsValid()\" ng-click=\"vm.saveConfigurations()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-wrench\"></i>Configuration List</h3></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Configuration Name</th></tr></thead><tbody><tr ng-repeat=\"configuration in (vm.filteredList = (vm.configurations | filter:vm.searchFilter)) | orderBy:\'order\'\" ng-class=\"{\'active\': vm.selectedConfiguration == configuration, \'danger\':((!vm.siteInfoValid() && configuration.id == 2) || (!vm.systemSettingsValid() && configuration.id == 1))}\" ng-click=\"vm.selectedConfiguration = configuration\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedConfiguration) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedConfiguration) + 1])\" ng-hide=\"(configuration.id == 3 && (!vm.userAuth.data.debugMode || vm.userAuth.data.id != 2))\"><td>{{configuration.name}}</td></tr></tbody></table></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Configuration Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedConfiguration\">No Configuration Selected</span><table class=\"table\" ng-if=\"vm.selectedConfiguration\" ng-show=\"vm.selectedConfiguration.id == 1\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Install Complete</td><td><div class=\"col-sm-6\"><button ng-disabled=\"vm.selectedConfiguration.data.install_complete\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.install_complete}\" ng-click=\"vm.selectedConfiguration.data.install_complete = false\">Not Complete</button></div><div class=\"col-sm-6\"><button uib-popover=\"Sends reports to JNL for review.\" popover-trigger=\"\'mouseenter\'\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.install_complete}\" ng-click=\"vm.selectedConfiguration.data.install_complete = true\">Complete</button></div></td></tr><tr ng-if=\"vm.userAuth.data.debugMode\"><td>Resend Install Report</td><td><button class=\"btn-block btn\" ng-click=\"vm.resendInstallReport()\">Resend Install Report</button></td></tr><tr><td>Time Zone</td><td><select class=\"form-control\" ng-disabled=\"vm.selectedInput.id\" ng-model=\"vm.selectedConfiguration.data.time_zone\" ng-options=\"zone.value as zone.label for zone in vm.timeZones\"></select></td></tr><tr ng-hide=\"(!vm.userAuth.data.debugMode || vm.userAuth.data.id != 2)\"><td>Wiegand Site</td><td><input type=\"number\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.site_id\"></td></tr><tr><td>Global Access Code (1000 - 9999)</td><td><input type=\"number\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.global_code\"></td></tr><tr><td>Credentials Enabled During Lockdown</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.allow_staff_during_lockdown}\" ng-click=\"vm.selectedConfiguration.data.allow_staff_during_lockdown = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.allow_staff_during_lockdown}\" ng-click=\"vm.selectedConfiguration.data.allow_staff_during_lockdown = true\">Active</button></div></td></tr><tr><td>Hardware Disappear Time (Seconds)</td><td><input type=\"number\" class=\"form-control\" ignore-mouse-number=\"\" ng-model=\"vm.selectedConfiguration.data.hardware_disappear_time\"></td></tr><tr><td>Schedule Leave Start Grace (Minutes)</td><td><input type=\"number\" class=\"form-control\" ignore-mouse-number=\"\" ng-model=\"vm.selectedConfiguration.data.scheduled_start_grace\"></td></tr><tr><td>Schedule Leave End Grace (Minutes)</td><td><input type=\"number\" class=\"form-control\" ignore-mouse-number=\"\" ng-model=\"vm.selectedConfiguration.data.scheduled_end_grace\"></td></tr><tr><td>Schedule Leave for Call Buttons</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.call_button_leave}\" ng-click=\"vm.selectedConfiguration.data.call_button_leave = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.call_button_leave}\" ng-click=\"vm.selectedConfiguration.data.call_button_leave = true\">Active</button></div></td></tr><tr><td>Weather Monitoring</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.weather_active}\" ng-click=\"vm.selectedConfiguration.data.weather_active = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.weather_active}\" ng-click=\"vm.selectedConfiguration.data.weather_active = true\">Active</button></div></td></tr><tr><td>Quantum Broadcast</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.broadcast_active}\" ng-click=\"vm.selectedConfiguration.data.broadcast_active = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.broadcast_active}\" ng-click=\"vm.selectedConfiguration.data.broadcast_active = true\">Active</button></div></td></tr><tr ng-if=\"vm.userAuth.data.system_license.allegion_active\"><td>Allegion Network Server IP</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.allegion_net_ip\"></td></tr><tr><td>Server Version</td><td>{{vm.selectedConfiguration.data.server_version}}</td></tr><tr><td>API Version</td><td>{{vm.selectedConfiguration.data.api_version}}</td></tr><tr><td>Mobile Version</td><td>{{vm.selectedConfiguration.data.expected_mobile_version}}</td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"vm.selectedConfiguration\" ng-show=\"vm.selectedConfiguration.id == 5\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Controller Type</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : !vm.selectedConfiguration.data.network_coordinator_in_use}\" ng-click=\"vm.selectedConfiguration.data.network_coordinator_in_use = false\">ACG</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.network_coordinator_in_use}\" ng-click=\"vm.selectedConfiguration.data.network_coordinator_in_use = true\">Net Coord</button></div></td></tr><tr ng-if=\"vm.selectedConfiguration.data.network_coordinator_in_use\"><td>Connection Type</td><td><select class=\"form-control\" ng-disabled=\"vm.selectedInput.id\" ng-model=\"vm.selectedConfiguration.data.network_coordinator_connection_type\" ng-options=\"connection.value as connection.label for connection in vm.netCoordConnections\"></select></td></tr><tr ng-if=\"!vm.selectedConfiguration.data.network_coordinator_in_use\"><td>Inovonics ACG IP</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.acg_ip\"></td></tr><tr ng-if=\"vm.selectedConfiguration.data.network_coordinator_in_use\"><td>Network Coordinator Port</td><td><input type=\"number\" min=\"1\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.network_coordinator_port_number\"></td></tr><tr><td>Inovonics NID</td><td><input type=\"number\" min=\"1\" max=\"31\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.inovonics_nid\"></td></tr><tr ng-if=\"vm.userAuth.data.system_license.nurse_call && !vm.userAuth.data.network_coordinator_in_use\"><td>Inovonics Location Pendant</td><td><div class=\"input-group\"><input type=\"text\" disabled=\"\" ng-model=\"vm.locationPendant.serial_number\" placeholder=\"Reset to Enroll\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.removeLocationPendant()\"><i class=\"fa text-muted\" ng-class=\"{ \'fa-times\': vm.pendantLoadComplete, \'fa-spinner\': !vm.pendantLoadComplete, \'fa-spin\': !vm.pendantLoadComplete}\"></i></button></div></div></td></tr><tr ng-if=\"vm.selectedConfiguration.data.network_coordinator_in_use\"><td>Location Active</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.nurse_call_location_active}\" ng-click=\"vm.selectedConfiguration.data.nurse_call_location_active = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.nurse_call_location_active}\" ng-click=\"vm.selectedConfiguration.data.nurse_call_location_active = true\">Active</button></div></td></tr><tr ng-if=\"vm.selectedConfiguration.data.network_coordinator_in_use\"><td>Generate Locations From Devices</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.pull_cord_locations}\" ng-click=\"vm.selectedConfiguration.data.pull_cord_locations = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.pull_cord_locations}\" ng-click=\"vm.selectedConfiguration.data.pull_cord_locations = true\">Active</button></div></td></tr><tr ng-if=\"vm.selectedConfiguration.data.pull_cord_locations && vm.selectedConfiguration.data.network_coordinator_in_use\"><td>Device Generated Fingerprint Filter Value (0 - 70)</td><td><input type=\"number\" min=\"0\" max=\"70\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.filter_device_fingerprint_value\"></td></tr><tr ng-if=\"vm.selectedConfiguration.data.pull_cord_locations && vm.selectedConfiguration.data.network_coordinator_in_use\"><td>Number of Locations Generated by Fixed Devices (0 - 3)</td><td><input type=\"number\" min=\"0\" max=\"3\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.number_location_per_pc\"></td></tr><tr ng-if=\"vm.selectedConfiguration.data.network_coordinator_in_use\"><td>Device Generated Fingerprint Dampening (0 - 20)</td><td><input type=\"number\" min=\"0\" max=\"20\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.device_location_dampening_value\"></td></tr><tr ng-if=\"vm.selectedConfiguration.data.network_coordinator_in_use\"><td>Ignore Device Generated Fingerprint</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.ignore_device_locations}\" ng-click=\"vm.selectedConfiguration.data.ignore_device_locations = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.ignore_device_locations}\" ng-click=\"vm.selectedConfiguration.data.ignore_device_locations = true\">Active</button></div></td></tr><tr ng-if=\"vm.selectedConfiguration.data.network_coordinator_in_use\"><td>Location Weighting</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.location_weighting}\" ng-click=\"vm.selectedConfiguration.data.location_weighting = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.location_weighting}\" ng-click=\"vm.selectedConfiguration.data.location_weighting = true\">Active</button></div></td></tr><tr ng-if=\"vm.selectedConfiguration.data.network_coordinator_in_use\"><td>Apartment Location Pull (0 - 100)</td><td><input type=\"number\" min=\"0\" max=\"100\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.apartment_location_pull_value\"></td></tr><tr ng-if=\"vm.selectedConfiguration.data.network_coordinator_in_use\"><td>Common Location Pull (0 - 100)</td><td><input type=\"number\" min=\"0\" max=\"100\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.common_location_pull_value\"></td></tr><tr ng-if=\"vm.selectedConfiguration.data.network_coordinator_in_use\"><td>Fingerprint Limiter</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.fingerprint_limiter}\" ng-click=\"vm.selectedConfiguration.data.fingerprint_limiter = false; vm.selectedConfiguration.data.fingerprint_consideration_limit = 200\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.fingerprint_limiter}\" ng-click=\"vm.selectedConfiguration.data.fingerprint_limiter = true\">Active</button></div></td></tr><tr ng-if=\"vm.selectedConfiguration.data.network_coordinator_in_use && vm.selectedConfiguration.data.fingerprint_limiter\"><td>Fingerprints Consideration Limit (10 - 200)</td><td><input type=\"number\" min=\"10\" max=\"200\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.fingerprint_consideration_limit\"></td></tr><tr ng-if=\"vm.selectedConfiguration.data.network_coordinator_in_use\"><td>Additional Locations Returned (0 - 4)</td><td><input type=\"number\" min=\"0\" max=\"4\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.additional_locations\"></td></tr><tr ng-if=\"vm.userAuth.data.system_license.nurse_call && vm.userAuth.data.network_coordinator_in_use\"><td>Inovonics Location Pendant</td><td><div class=\"input-group\"><input type=\"text\" disabled=\"\" ng-model=\"vm.selectedConfiguration.data.location_pendant\" placeholder=\"Reset to Enroll\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.selectedConfiguration.data.location_pendant = null\"><i class=\"fa text-muted\" ng-class=\"{ \'fa-times\': vm.pendantLoadComplete, \'fa-spinner\': !vm.pendantLoadComplete, \'fa-spin\': !vm.pendantLoadComplete}\"></i></button></div></div></td></tr><tr><td>Dome Light Max Address</td><td><input type=\"number\" min=\"1\" max=\"2056\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.max_address_value\"></td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"vm.selectedConfiguration\" ng-show=\"vm.selectedConfiguration.id == 4\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Mobile Soundset</td><td><select class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.mobile_sound\" ng-options=\"set.id as set.name for set in vm.mobileSoundsets\"></select></td></tr><tr><td>Mobile Offiline Disconnect (Seconds)</td><td><input type=\"number\" class=\"form-control\" ignore-mouse-number=\"\" ng-model=\"vm.selectedConfiguration.data.mobile_offline_disconnect\"></td></tr><tr><td>Mobile Offline Reminder (Seconds)</td><td><input type=\"number\" class=\"form-control\" ignore-mouse-number=\"\" ng-model=\"vm.selectedConfiguration.data.mobile_offline_reminder\"></td></tr><tr><td>Mobile Claim Timeout (Seconds)</td><td><input type=\"number\" class=\"form-control\" ignore-mouse-number=\"\" ng-model=\"vm.selectedConfiguration.data.mobile_claim_timeout\"></td></tr><tr><td>Mobile Reminder Interval (Seconds)</td><td><input type=\"number\" class=\"form-control\" ignore-mouse-number=\"\" ng-model=\"vm.selectedConfiguration.data.mobile_reminder_interval\"></td></tr><tr><td>Mobile Messenger</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.mobile_messaging}\" ng-click=\"vm.selectedConfiguration.data.mobile_messaging = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.mobile_messaging}\" ng-click=\"vm.selectedConfiguration.data.mobile_messaging = true\">Active</button></div></td></tr><tr><td>Staff Extention List</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.mobile_call_sheet}\" ng-click=\"vm.selectedConfiguration.data.mobile_call_sheet = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.mobile_call_sheet}\" ng-click=\"vm.selectedConfiguration.data.mobile_call_sheet = true\">Active</button></div></td></tr><tr ng-if=\"vm.userAuth.data.system_license.care_package\"><td>Mobile Cares</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.cares_in_use}\" ng-click=\"vm.selectedConfiguration.data.cares_in_use = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.cares_in_use}\" ng-click=\"vm.selectedConfiguration.data.cares_in_use = true\">Active</button></div></td></tr><tr ng-if=\"vm.selectedConfiguration.data.cares_in_use && vm.userAuth.data.system_license.care_package\"><td>Mobile Cares Required</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.cares_required}\" ng-click=\"vm.selectedConfiguration.data.cares_required = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.cares_required}\" ng-click=\"vm.selectedConfiguration.data.cares_required = true\">Active</button></div></td></tr><tr ng-if=\"vm.selectedConfiguration.data.cares_in_use && vm.userAuth.data.system_license.care_package\"><td>Mobile Cares Without Alarm</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedConfiguration.data.cares_without_alarm}\" ng-click=\"vm.selectedConfiguration.data.cares_without_alarm = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedConfiguration.data.cares_without_alarm}\" ng-click=\"vm.selectedConfiguration.data.cares_without_alarm = true\">Active</button></div></td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"vm.selectedConfiguration\" ng-show=\"vm.selectedConfiguration.id == 2\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>NOC Site ID</td><td><input ng-disabled=\"!vm.userAuth.data.debugMode\" type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.given_id\"></td></tr><tr><td>Site Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.name\"></td></tr><tr><td>Street Address</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.street_address\"></td></tr><tr><td>City</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.city\"></td></tr><tr><td>State</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.state\"></td></tr><tr><td>Zip</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.zip\"></td></tr><tr><td>Main Contact</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.main_contact\"></td></tr><tr><td>Main Phone</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.main_contact_phone\"></td></tr><tr><td>Server Location</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.server_location\"></td></tr><tr><td>Paging Location</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.paging_location\"></td></tr><tr><td>Site Notes</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.site_notes\"></td></tr><tr><td>Corporate Server Address</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.corporate_server_address\"></td></tr><tr><td>Corporate API Version</td><td><input ng-disabled=\"!vm.userAuth.data.debugMode\" type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConfiguration.data.corporate_server_version\"></td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"vm.selectedConfiguration\" ng-show=\"vm.selectedConfiguration.id == 3\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr ng-repeat=\"license in vm.selectedConfiguration.data\" ng-if=\"license.object_key == \'wanderer_monitoring\'\"><td>Total Wandering Doors</td><td><input type=\"number\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"license.value\"></td></tr><tr ng-repeat=\"license in vm.selectedConfiguration.data\" ng-if=\"license.object_key == \'mobile_users\'\"><td>Total Mobile Users</td><td><input type=\"number\" ignore-mouse-number=\"\" class=\"form-control\" ng-model=\"license.value\"></td></tr><tr ng-repeat=\"license in vm.selectedConfiguration.data\" ng-hide=\"vm.hideSublicense(license)\"><td>{{license.name}}</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !license.active}\" ng-click=\"license.active = false; vm.checkNurseCall(license)\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : license.active}\" ng-click=\"license.active = true\">Active</button></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-system-monitor-config/admin-system-monitor-config.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.exit()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.monitorsValid()\" ng-click=\"vm.saveMonitors()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-server\"></i>System Monitor List</h3></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>System Monitor Name</th><th>Serial Number</th></tr></thead><tbody><tr dir-paginate=\"monitor in (vm.filteredList = (vm.monitors | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedMonitor == monitor}\" ng-if=\"!monitor.deleted\" ng-click=\"vm.selectedMonitor = monitor\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedMonitor) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedMonitor) + 1])\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeMonitor($index, monitor)\"></i> {{monitor.name}}</td><td>{{monitor.serial_number}}</td></tr><tr><td colspan=\"2\" ng-if=\"!vm.filteredList.length\">No Results Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> System Monitor Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedMonitor\">No System Monitor Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedMonitor\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>System Monitor Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedMonitor.name\"></td></tr><tr><td>Serial Number</td><td>{{vm.selectedMonitor.serial_number}}</td></tr><tr><td>IP Address</td><td>{{vm.selectedMonitor.ip_address}}</td></tr><tr><td>Online Status Monitoring</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedMonitor.monitor_sanity}\" ng-click=\"vm.selectedMonitor.monitor_sanity = false\">Disabled</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedMonitor.monitor_sanity}\" ng-click=\"vm.selectedMonitor.monitor_sanity = true\">Enabled</button></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin-system-setup/admin-system-setup.html","<div class=\"col-md-12\"><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><div class=\"box box-color box-bordered\" ng-class=\"{\'col-md-12\':vm.totalHeadersOdd(), \'col-md-6\':!vm.totalHeadersOdd()}\" ng-repeat=\"category in vm.setupData\"><div class=\"box-title\"><h3><i class=\"fa\" ng-class=\"category.icon\"></i> {{category.header}}</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover\"><tbody><tr ng-repeat=\"item in category.items\" ng-class=\"{\'darken-cell\': !vm.highlightFilter(item)}\"><td><a ng-href=\"{{item.link}}\">{{item.title}}</a></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin-third-party-pullcord-import/admin-third-party-pullcord-import.html","<script type=\"text/ng-template\" id=\"confirmModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\">Warning!</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> Apartment assignments may not be accurate. Please review each pull cord for accuracy. </div> <div class=\"modal-footer\"> <button class=\"btn\" type=\"button\" ladda=\"vm.ladda\" ng-click=\"vm.assignModalInstance.dismiss()\">Cancel</button> <button class=\"btn btn-warning\" type=\"button\" ladda=\"vm.ladda\" ng-click=\"vm.autoAssign()\">I Understand</button> </div> </div></script><div class=\"col-sm-12\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-arrow-circle-down\"></i> <span>Third Party Pull Cord Import</span></h3><span class=\"pull-right\"><button class=\"btn btn-info\" ng-if=\"csv.content && !(vm.results.length && !vm.submitting)\" ng-click=\"vm.autoAssignWarning()\">Assign Apartments</button> <button class=\"btn btn-success\" ladda=\"vm.submitting\" data-spinner-size=\"20\" ng-disabled=\"!csv.content || !vm.importValid()\" ng-click=\"vm.saveApartment()\" ng-if=\"!vm.results.length || vm.submitting\">Save</button> <button class=\"btn btn-success\" ng-click=\"vm.reset()\" ng-if=\"vm.results.length && !vm.submitting\">Import Another</button></span></div><div class=\"box-content nopadding\"><ng-csv-import class=\"search-box\" content=\"csv.content\" header=\"true\" separator=\"\',\'\" result=\"vm.csvResult\" accept=\"csv.accept\"></ng-csv-import><div class=\"col-sm-7\" ng-if=\"!vm.csvResult\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-book\"></i> <span>Instructions for Use</span></h3></div><div class=\"box-content\"><h4>Notes</h4><ol><li><strong>Do not change the header row of the CSV template or the import will fail</strong></li><li><strong>If a line of the import fails, DO NOT re-import the entire sheet. This will cause duplicate entries. Fix that line in manually.</strong></li></ol><h4>CSV Preparation</h4><ol><li>Set Up Your Escalations First</li><li><a href=\"../assets/csv/third_party_pullcord_import.csv\" target=\"_self\">Click Here to Download the CSV file template</a></li><li>Fill in the Serial Number and Device Name</li><li>If The Device Needs to Be Added to An Apartment, This must be done manually, one by one in the front end.</li><li>Refer to the table to the right for the escalation ID</li><li>Save file to csv</li></ol><h4>Import file</h4><ol><li>Click the select file button above and chose the file</li><li>Review the data for errors and click save</li><li>Rows that need correction will be red</li></ol></div></div></div><div class=\"col-sm-5\" ng-if=\"!vm.csvResult\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bars\"></i> <span>Available Escalations</span></h3></div><div class=\"box-content\"><table class=\"table\"><thead><tr><th>Escalation ID</th><th>Escalation Name</th></tr></thead><tbody><tr ng-repeat=\"escalation in vm.escalations\"><td>{{escalation.id}}</td><td>{{escalation.name}}</td></tr></tbody></table></div></div></div><table class=\"table\" ng-if=\"vm.csvResult && !vm.results.length\"><thead><tr><th>Serial Number</th><th>Device Name</th><th>Escalation</th><th class=\"col-md-2\">Apartment</th></tr></thead><tbody><tr ng-repeat=\"item in vm.csvResult\" ng-class=\"{\'danger\':!vm.rowValid(item)}\"><td>{{item.serial_number}}</td><td>{{item.device_name}}</td><td><span ng-repeat=\"escalation in vm.escalations | findObject:item.escalation_id as filtered\">{{escalation.name}}</span> <span class=\"text-danger\" ng-if=\"item.escalation_id && !filtered.length\">Invalid Escalation ID</span></td><td><ui-select name=\"output\" ng-model=\"item.apt_id\" style=\"width: 100%;\"><ui-select-match>{{$select.selected.name}} <button class=\"btn-clear pull-right\" ng-click=\"vm.clearApt(item, $event)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"apartment.id as apartment in vm.apartments | filter:$select.search\">{{apartment.name}}</ui-select-choices></ui-select></td></tr></tbody></table><div class=\"col-sm-12\" ng-if=\"vm.results.length\"><div class=\"box\"><div class=\"box-title\"><h3 ng-if=\"vm.submitting\"><i class=\"fa fa-spinner fa-pulse\"></i> <span>Importing...</span></h3><h3 ng-if=\"!vm.submitting\"><i class=\"fa fa-bars\"></i> <span>Import Results</span></h3></div><div class=\"box-content\"><table class=\"table\"><thead><tr><th>Pullcord</th><th>Results</th></tr></thead><tbody><tr ng-repeat=\"result in vm.results\"><td>{{result.pullcord}}</td><td>{{result.result}}</td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/dashboard.html","<quantum-alarm-table ng-show=\"vm.systemStatus.data.active_alarm.length\"></quantum-alarm-table><quantum-leave-table ng-show=\"vm.systemStatus.data.active_leave.length\"></quantum-leave-table><quantum-schedule-table ng-show=\"vm.systemStatus.data.active_onetime_schedule.length\"></quantum-schedule-table><quantum-event-table></quantum-event-table>");
$templateCache.put("app/display-eula/display-eula.html","<div class=\"box box-color box-bordered\"><div class=\"box-title\"><h3><i class=\"fa fa-bars\"></i> Software License Agreement</h3></div><div class=\"box-content\"><ol><li>This is an agreement between Licensor and Licensee, who is being licensed to use the named Software.</li><li>Licensee acknowledges that this is only a limited nonexclusive license. Licensor is and remains the owner of all titles, rights, and interests in the Software.</li><li>Licensee will not make copies of the Software or allow copies of the Software to be made by others, unless authorized by this License Agreement.</li><li>This Software is subject to a limited warranty. (Software Only) Licensor warrants to Licensee that, the Software will perform according to its printed documentation, and to the best of Licensor’s knowledge Licensee’s use of this Software according to the printed documentation is not an infringement of any third party’s intellectual property rights. To the extent permitted by law, THE ABOVE-STATED LIMITED WARRANTY REPLACES ALL OTHER WARRANTIES, EXPRESS OR IMPLIED, AND LICENSOR DISCLAIMS ALL IMPLIED WARRANTIES INCLUDING ANY IMPLIED WARRANTY OF TITLE, MERCHANTABILITY, NONINFRINGEMENT, OR OF FITNESS FOR A PARTICULAR PURPOSE. No agent of Licensor is authorized to make any other warranties or to modify this limited warranty. Licensee has specific legal rights pursuant to this warranty and, depending on Licensee’s jurisdiction, may have additional rights.</li><li>Notwithstanding the foregoing, LICENSOR IS NOT LIABLE TO LICENSEE FOR ANY DAMAGES, INCLUDING COMPENSATORY, SPECIAL, INCIDENTAL, EXEMPLARY, PUNITIVE, OR CONSEQUENTIAL DAMAGES, CONNECTED WITH OR RESULTING FROM THIS LICENSE AGREEMENT OR LICENSEE’S USE OF THIS SOFTWARE. Licensee’s jurisdiction may not allow such a limitation of damages, so this limitation may not apply.</li><li>Licensee agrees to defend and indemnify Licensor and hold Licensor harmless from all claims, losses, damages, complaints, or expenses connected with or resulting from Licensee’s business operations.</li><li>Licensor has the right to terminate this License Agreement and Licensee’s right to use this Software upon any material breach by Licensee.</li><li>Licensee agrees to return to Licensor or to destroy all copies of the Software upon termination of the License.</li><li>This License Agreement is the entire and exclusive agreement between Licensor and Licensee regarding this Software. This License Agreement replaces and supersedes all prior negotiations, dealings, and agreements between Licensor and Licensee regarding this Software.</li><li>This License Agreement is governed by the law of Wisconsin applicable to Wisconsin contracts.</li><li>This License Agreement is valid without Licensor’s signature. It becomes effective upon the earlier of Licensee’s signature or Licensee’s use of the Software.</li></ol></div></div>");
$templateCache.put("app/door-access-allegion/door-access-allegion-change.html","<wizard on-finish=\"vm.submitWizardChange()\" name=\"accessGroup\" header-icon=\"fa-lock\" header-text=\"Change an Allegion Door Access Group\" ladda-enabled=\"vm.laddaEnabled\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Group\" canexit=\"vm.stepSelectValid\"><h4>Select an Access Group</h4><p class=\"text-danger\" ng-if=\"(vm.selector == false) && vm.form.group_selector.$dirty\">Group selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Group Name</th></tr></thead><tbody><tr ng-repeat=\"group in vm.existingDoorAccess\" ng-if=\"group.id != 1000\"><td ng-class=\"{\'has-error\':(!vm.formData.doors_in_group && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"group\" ng-click=\"vm.loadSelectedData(group)\"> {{group.name}}</label></div></td></tr><tr ng-hide=\"vm.existingDoorAccess.length > 1\"><td>No Groups Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Group Information\" canexit=\"vm.stepInfoValid\"><h4>Door Access Group Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Door Group Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Doors in Group</label><div class=\"col-sm-10\"><ui-select name=\"doors_in_group\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.doors_in_group\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorData | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Door Access Group</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Door Group Name:</strong></label> <span id=\"name\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Doors in Group:</strong></label> <span ng-repeat=\"door in vm.doorData | objectIdSearch:vm.formData.doors_in_group\">{{door.name}}{{$last ? \'\' : \', \'}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/door-access-allegion/door-access-allegion-create.html","<wizard on-finish=\"vm.submitWizardCreate()\" name=\"accessGroup\" header-icon=\"fa-lock\" header-text=\"Create an Allegion Door Access Group\" ladda-enabled=\"vm.laddaEnabled\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Group Information\" canexit=\"vm.stepInfoValid\"><h4>Door Access Group Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Door Group Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.formData.name\" ng-value=\"group\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Doors in Group</label><div class=\"col-sm-10\"><ui-select name=\"doors_in_group\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.doors_in_group\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorData | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Door Access Group</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Door Group Name:</strong></label> <span id=\"name\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Doors in Group:</strong></label> <span ng-repeat=\"door in vm.doorData | objectIdSearch:vm.formData.doors_in_group\">{{door.name}}{{$last ? \'\' : \', \'}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/door-access-allegion/door-access-allegion-remove.html","<wizard on-finish=\"vm.submitWizardRemove()\" name=\"accessGroup\" header-icon=\"fa-lock\" header-text=\"Remove an Allegion Door Access Group\" ladda-enabled=\"vm.laddaEnabled\"><form name=\"vm.form\"><wz-step wz-title=\"Select Group\" canexit=\"vm.stepSelectValid\"><h4>Select an Access Group</h4><p class=\"text-danger\" ng-if=\"(vm.selector == false) && vm.form.group_selector.$dirty\">Group selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Group Name</th></tr></thead><tbody><tr ng-repeat=\"group in vm.existingDoorAccess\" ng-if=\"group.id != 1000\"><td ng-class=\"{\'has-error\':(!vm.formData.doors_in_group && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"group\" ng-click=\"vm.loadSelectedData(group)\"> {{group.name}}</label></div></td></tr><tr ng-hide=\"vm.existingDoorAccess.length > 1\"><td>No Groups Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Door Access Group</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Door Group Name:</strong></label> <span id=\"name\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Doors in Group:</strong></label> <span ng-repeat=\"door in vm.doorData | objectIdSearch:vm.formData.doors_in_group\">{{door.name}}{{$last ? \'\' : \', \'}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/door-access/door-access-change.html","<wizard on-finish=\"vm.submitWizardChange()\" name=\"accessGroup\" header-icon=\"fa-lock\" header-text=\"Change a Door Access Group\" ladda-enabled=\"vm.laddaEnabled\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Group\" canexit=\"vm.stepSelectValid\"><h4>Select an Access Group</h4><p class=\"text-danger\" ng-if=\"(vm.selector == false) && vm.form.group_selector.$dirty\">Group selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Group Name</th></tr></thead><tbody><tr ng-repeat=\"group in vm.existingDoorAccess\" ng-if=\"group.id != 1\"><td ng-class=\"{\'has-error\':(!vm.formData.doors_in_group && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"group\" ng-click=\"vm.loadSelectedData(group)\"> {{group.name}}</label></div></td></tr><tr ng-hide=\"vm.existingDoorAccess.length > 1\"><td>No Groups Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Group Information\" canexit=\"vm.stepInfoValid\"><h4>Door Access Group Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Door Group Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Doors in Group</label><div class=\"col-sm-10\"><ui-select name=\"doors_in_group\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.doors_in_group\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorData | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Door Access Group</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Door Group Name:</strong></label> <span id=\"name\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Doors in Group:</strong></label> <span ng-repeat=\"door in vm.doorData | objectIdSearch:vm.formData.doors_in_group\">{{door.name}}{{$last ? \'\' : \', \'}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/door-access/door-access-create.html","<wizard on-finish=\"vm.submitWizardCreate()\" name=\"accessGroup\" header-icon=\"fa-lock\" header-text=\"Create a Door Access Group\" ladda-enabled=\"vm.laddaEnabled\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Group Information\" canexit=\"vm.stepInfoValid\"><h4>Door Access Group Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Door Group Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.formData.name\" ng-value=\"group\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Doors in Group</label><div class=\"col-sm-10\"><ui-select name=\"doors_in_group\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.doors_in_group\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorData | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Door Access Group</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Door Group Name:</strong></label> <span id=\"name\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Doors in Group:</strong></label> <span ng-repeat=\"door in vm.doorData | objectIdSearch:vm.formData.doors_in_group\">{{door.name}}{{$last ? \'\' : \', \'}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/door-access/door-access-remove.html","<wizard on-finish=\"vm.submitWizardRemove()\" name=\"accessGroup\" header-icon=\"fa-lock\" header-text=\"Remove a Door Access Group\" ladda-enabled=\"vm.laddaEnabled\"><form name=\"vm.form\"><wz-step wz-title=\"Select Group\" canexit=\"vm.stepSelectValid\"><h4>Select an Access Group</h4><p class=\"text-danger\" ng-if=\"(vm.selector == false) && vm.form.group_selector.$dirty\">Group selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Group Name</th></tr></thead><tbody><tr ng-repeat=\"group in vm.existingDoorAccess\" ng-if=\"group.id != 1\"><td ng-class=\"{\'has-error\':(!vm.formData.doors_in_group && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"group\" ng-click=\"vm.loadSelectedData(group)\"> {{group.name}}</label></div></td></tr><tr ng-hide=\"vm.existingDoorAccess.length > 1\"><td>No Groups Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Door Access Group</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Door Group Name:</strong></label> <span id=\"name\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Doors in Group:</strong></label> <span ng-repeat=\"door in vm.doorData | objectIdSearch:vm.formData.doors_in_group\">{{door.name}}{{$last ? \'\' : \', \'}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/door-status-allegion/door-status-allegion.html","<div id=\"door_status_table\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bars\"></i> Allegion Door Status</h3></div><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.orderByKey = \'name\'; vm.orderReverse = !vm.orderReverse\">Door Name <span ng-show=\"vm.orderByKey == \'name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.override\'; vm.orderReverse = !vm.orderReverse\">Override <span ng-show=\"vm.orderByKey == \'status.override\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.override\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.alarmed\'; vm.orderReverse = !vm.orderReverse\">Door Alarm <span ng-show=\"vm.orderByKey == \'status.alarmed\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.alarmed\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.door_open\'; vm.orderReverse = !vm.orderReverse\">Door Position <span ng-show=\"vm.orderByKey == \'status.door_open\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.door_open\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.door_locked\'; vm.orderReverse = !vm.orderReverse\">Door Lock <span ng-show=\"vm.orderByKey == \'status.door_locked\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.door_locked\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.tamper\'; vm.orderReverse = !vm.orderReverse\">Tamper <span ng-show=\"vm.orderByKey == \'status.tamper\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.tamper\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.magnetic_tamper\'; vm.orderReverse = !vm.orderReverse\">Magnetic Tamper <span ng-show=\"vm.orderByKey == \'status.magnetic_tamper\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.magnetic_tamper\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.battery_problem\'; vm.orderReverse = !vm.orderReverse\">Battery <span ng-show=\"vm.orderByKey == \'status.battery_problem\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.battery_problem\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.online\'; vm.orderReverse = !vm.orderReverse\">Online Status <span ng-show=\"vm.orderByKey == \'status.online\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.online\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr dir-paginate=\"door in vm.filteredDoors = (vm.doorData | filter:vm.searchFilter | orderBy:vm.orderByKey | orderBy:\'+\':vm.orderReverse | itemsPerPage:15)\"><td><acronym title=\"ID: {{door.id}} - IP: {{ door.ip_address }}\">{{ door.name }}</acronym></td><td><div class=\"btn-group\" role=\"group\"><button class=\"btn btn-sm\" ladda=\"vm.lockedLadda\" ng-class=\"door.status.over_ride_enabled == \'locked\' ? \'btn-success\' : \'btn-default\'\" ng-click=\"vm.overrideLocked(door)\">Locked</button> <button class=\"btn btn-sm\" ladda=\"vm.unlockedLadda\" ng-class=\"door.status.over_ride_enabled == \'unlocked\' ? \'btn-danger\' : \'btn-default\'\" ng-click=\"vm.overrideUnlocked(door)\">Unlocked</button> <button class=\"btn btn-sm\" ladda=\"vm.momentaryLadda\" ng-class=\"door.status.over_ride_enabled == \'timed\' ? \'btn-danger\' : \'btn-default\'\" ng-click=\"vm.overrideMomentary(door)\">Momentary Unlock</button></div></td><td ng-class=\"{\'text-danger\':door.status.alarmed}\">{{door.status.alarmed ? \"Alarm\" : \"Clear\"}}</td><td ng-class=\"{\'text-danger\':door.status.door_open}\">{{door.status.door_open ? \"Open\" : \"Closed\"}}</td><td ng-class=\"{\'text-danger\':door.status.door_locked}\">{{door.status.door_locked ? \"Locked\" : \"Unlocked\"}}</td><td ng-class=\"{\'text-danger\':door.status.battery_problem}\">{{door.status.tamper ? \"Alert\" : \"OK\"}}</td><td ng-class=\"{\'text-danger\':door.status.battery_problem}\">{{door.status.magnetic_tamper ? \"Alert\" : \"OK\"}}</td><td ng-class=\"{\'text-danger\':door.status.battery_problem}\">{{door.status.battery_problem ? \"Alert\" : \"OK\"}}</td><td ng-class=\"{\'text-danger\':!door.status.online}\">{{!door.status.online ? \"Offline\" : \"Online\"}}</td></tr><tr><td colspan=\"9\" ng-if=\"!vm.doorData.length\">No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredDoors.length}} of {{vm.doorData.length}} Doors</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></div></div></div></div></div>");
$templateCache.put("app/door-status/door-status.html","<div id=\"door_status_table\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bars\"></i> Door Status</h3></div><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.orderByKey = \'name\'; vm.orderReverse = !vm.orderReverse\">Door Name <span ng-show=\"vm.orderByKey == \'name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.override\'; vm.orderReverse = !vm.orderReverse\">Override <span ng-show=\"vm.orderByKey == \'status.override\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.override\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.alarmed\'; vm.orderReverse = !vm.orderReverse\">Door Alarm <span ng-show=\"vm.orderByKey == \'status.alarmed\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.alarmed\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.opened\'; vm.orderReverse = !vm.orderReverse\">Door Position <span ng-show=\"vm.orderByKey == \'status.opened\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.opened\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.locked\'; vm.orderReverse = !vm.orderReverse\">Door Lock <span ng-show=\"vm.orderByKey == \'status.locked\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.locked\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.breached\'; vm.orderReverse = !vm.orderReverse\">Door Breach <span ng-show=\"vm.orderByKey == \'status.breached\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.breached\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.propped\'; vm.orderReverse = !vm.orderReverse\">Door Propped <span ng-show=\"vm.orderByKey == \'status.propped\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.propped\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.egressed\'; vm.orderReverse = !vm.orderReverse\">Door Egress <span ng-show=\"vm.orderByKey == \'status.egressed\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.egressed\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'status.offline\'; vm.orderReverse = !vm.orderReverse\">Online Status <span ng-show=\"vm.orderByKey == \'status.offline\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'status.offline\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr dir-paginate=\"door in vm.filteredDoors = (vm.doorData | filter:vm.searchFilter | orderBy:vm.orderByKey | orderBy:\'+\':vm.orderReverse | itemsPerPage:15)\"><td><acronym title=\"ID: {{door.id}} - IP: {{ door.ip_address }}\">{{ door.name }}</acronym></td><td><div class=\"btn-group\" role=\"group\"><button class=\"btn btn-sm\" ng-class=\"door.status.override == 0 ? \'btn-success\' : \'btn-default\'\" ng-click=\"vm.overrideOff(door.id)\">Off</button> <button class=\"btn btn-sm\" ng-class=\"door.status.override == 1 ? \'btn-warning\' : \'btn-default\'\" ng-click=\"vm.overrideLocked(door.id)\">Locked</button> <button class=\"btn btn-sm\" ng-class=\"door.status.override == 2 ? \'btn-danger\' : \'btn-default\'\" ng-click=\"vm.overrideUnlocked(door.id)\">Unlocked</button></div></td><td ng-class=\"{\'text-danger\':door.status.alarmed}\">{{door.status.alarmed ? \"Alarm\" : \"Clear\"}}</td><td ng-class=\"{\'text-danger\':door.status.opened}\">{{door.status.opened ? \"Open\" : \"Closed\"}}</td><td ng-class=\"{\'text-danger\':door.status.locked}\">{{door.status.locked ? \"Locked\" : \"Unlocked\"}}</td><td ng-class=\"{\'text-danger\':door.status.breached}\">{{door.status.breached ? \"Breached\" : \"Not Breached\"}}</td><td ng-class=\"{\'text-danger\':door.status.propped}\">{{door.status.propped ? \"Propped\" : \"Not Propped\"}}</td><td ng-class=\"{\'text-danger\':door.status.egressed}\">{{door.status.egressed ? \"Active\" : \"Inactive\"}}</td><td ng-class=\"{\'text-danger\':door.status.offline}\">{{door.status.offline ? \"Offline\" : \"Online\"}}</td></tr><tr><td colspan=\"9\" ng-if=\"!vm.doorData.length\">No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredDoors.length}} of {{vm.doorData.length}} Doors</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></div></div></div></div></div>");
$templateCache.put("app/family/family-change.html","<wizard on-finish=\"vm.submitChange()\" name=\"familyMemberChange\" header-text=\"Change a Family Member\" header-icon=\"fa-users\" ladda-enabled=\"vm.ladda\" disable-submit=\"\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Family\" canexit=\"vm.stepSelectValid\"><h4 ng-if=\"vm.initalLoadComplete\">Select a Family Member</h4><h4 ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i> Loading...</h4><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control ng-pristine ng-valid ng-touched\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><p class=\"text-danger\" ng-if=\"(vm.selector == false) && vm.selectStepSubmitted\">Family Member selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Family Member Name</th><th>Keycard Code</th><th>Keypad Code</th></tr></thead><tbody><tr dir-paginate=\"familyMember in vm.filteredFamilyMember = (vm.familyMember | filter:vm.searchFilter | itemsPerPage:10)\"><td ng-class=\"{\'has-error\':((vm.selector == false) && vm.selectStepSubmitted)}\"><div><label><input type=\"radio\" name=\"resident_selector\" ng-model=\"vm.selector\" ng-value=\"familyMember\" ng-click=\"vm.loadFamilyMemberEvent(familyMember)\"> {{familyMember.first_name}} {{familyMember.last_name}}</label></div></td><td ng-class=\"{\'has-error\':((vm.selector == false) && vm.selectStepSubmitted)}\">{{familyMember.keycard ? familyMember.keycard : \"Not Assigned\"}}</td><td ng-class=\"{\'has-error\':((vm.selector == false) && vm.selectStepSubmitted)}\">{{familyMember.keypad ? familyMember.keypad : \"Not Assigned\"}}</td></tr><tr ng-hide=\"vm.familyMember.length\"><td colspan=\"3\">No Family Members Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredFamilyMember.length}} of {{vm.familyMember.length}} Family Members</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></wz-step><wz-step wz-title=\"Family Information\" canexit=\"vm.stepUserValid\"><h4>Family Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">First Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"first_name\" class=\"form-control\" ng-model=\"vm.formData.first_name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Last Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"last_name\" class=\"form-control\" ng-model=\"vm.formData.last_name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Associated Residents</label><div class=\"col-sm-10\"><ui-select name=\"associated_residents\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.associated_residents\"><ui-select-match>{{$item.first_name}} {{$item.last_name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.residents | filter:$select.search\">{{item.first_name}} {{item.last_name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Resident Bypass Allowed</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.formData.resident_bypass_allowed}\" ng-click=\"vm.formData.resident_bypass_allowed = false\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.formData.resident_bypass_allowed}\" ng-click=\"vm.formData.resident_bypass_allowed = true\">Active</button></div></div></div></wz-step><wz-step wz-disabled=\"{{!vm.systemLicense.wanderer_monitoring && !vm.systemLicense.access_control}}\" wz-title=\"Door Access\" canexit=\"vm.stepDoorValid\"><h4>Family Door Access</h4><div ng-show=\"vm.formData.door_access_level != 0\"><div class=\"form-group\"><label class=\"control-label col-sm-2\">Keycard Number</label><div class=\"col-sm-10\"><input type=\"number\" ignore-mouse-number=\"\" name=\"keycard\" class=\"form-control\" ng-model=\"vm.formData.keycard\" validate-on=\"dirty\" validator=\"vm.validateKeycard(vm.formData.keycard)\" invalid-message=\"vm.validateKeycardMsg(vm.formData.keycard)\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Enrolled Keycard</label><div class=\"col-sm-10\"><div class=\"input-group search-box\"><input type=\"text\" ng-disabled=\"true\" placeholder=\"Present Card at Enrollment Station to Enroll\" ignore-mouse-number=\"\" name=\"rawcard\" class=\"form-control\" ng-model=\"vm.formData.raw_card_data\" validate-on=\"dirty\" validator=\"vm.validateRawCard(vm.formData.raw_card_data)\" invalid-message=\"vm.validateRawCardMsg(vm.formData.raw_card_data)\"><div class=\"input-group-btn align-top\"><button class=\"btn\" type=\"button\" ng-click=\"vm.formData.raw_card_data = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Keypad Code</label><div class=\"col-sm-10\"><input type=\"number\" ignore-mouse-number=\"\" name=\"keypad\" class=\"form-control\" ng-model=\"vm.formData.keypad\" validate-on=\"dirty\" validator=\"vm.validateKeypad(vm.formData.keypad)\" invalid-message=\"vm.validateKeypadMsg(vm.formData.keypad)\"></div></div><div class=\"form-group\" ng-if=\"!vm.systemLicense.allegion_active\"><label class=\"control-label col-sm-2\">Quantum Access Groups</label><div class=\"col-sm-10\"><ui-select name=\"door_access_groups\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.systemLicense.allegion_active\"><label class=\"control-label col-sm-2\">Quantum Access Groups</label><div class=\"col-sm-10\"><ui-select name=\"door_access_groups\" multiple=\"\" ng-model=\"vm.formData.door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Quantum Access Schedules</label><div class=\"col-sm-10\" ng-class=\"{\'has-error\': !vm.validateDoorSchedule() && vm.form.door_access_schedules.$dirty}\"><ui-select name=\"door_access_schedules\" multiple=\"\" ng-model=\"vm.formData.schedules\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessSchedules | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select><label ng-if=\"!vm.validateDoorSchedule() && vm.form.door_access_schedules.$dirty\" class=\"control-label\">This field is required.</label></div></div><div class=\"form-group\" ng-if=\"vm.systemLicense.allegion_active\"><label class=\"control-label col-sm-2\">Allegion Access Groups</label><div class=\"col-sm-10\"><ui-select name=\"allegion_door_access_groups\" multiple=\"\" ng-model=\"vm.formData.allegion_door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.allegionAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.systemLicense.allegion_active\"><label class=\"control-label col-sm-2\">Allegion Apartment Access</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.formData.family_allowed_apt}\" ng-click=\"vm.formData.family_allowed_apt = false\">Disabled</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.formData.family_allowed_apt}\" ng-click=\"vm.formData.family_allowed_apt = true\">Enabled</button></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Access Expiration</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-change=\"vm.scheduleChange()\" ng-model=\"vm.accessExpiration\" ng-options=\"item.value as item.label for item in [{\'label\':\'Disabled\', \'value\':false},{\'label\':\'Enabled\', \'value\':true}]\"></select></div></div><div class=\"form-group\" ng-show=\"vm.accessExpiration\"><label class=\"control-label col-sm-2\">Valid Dates</label><div class=\"col-sm-10\"><input name=\"timeInterval\" ng-change=\"vm.scheduleChange()\" ng-model-options=\"{ debounce: 100 }\" placeholder=\"Select a Time Range Below\" type=\"daterange\" readonly=\"true\" opens=\"embed\" ng-model=\"vm.date\" class=\"form-control\" datepicker-options=\"vm.datepickerOptions\"></div></div></div></wz-step><wz-step wz-title=\"Review Information\"><h4>Review Family Member</h4><table class=\"table\"><thead><tr><th>Information Type</th><th>Previous Information</th><th>Updated Information</th></tr></thead><tbody><tr><td>Family Member Name</td><td>{{vm.selector.first_name}} {{vm.selector.last_name}}</td><td>{{vm.formData.first_name}} {{vm.formData.last_name}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Associated Residents</td><td><span ng-repeat=\"item in vm.residents | objectIdSearch:vm.selector.associated_residents\">{{item.first_name}} {{item.last_name}}{{$last ? \'\' : \', \'}}</span></td><td><span ng-repeat=\"item in vm.residents | objectIdSearch:vm.formData.associated_residents\">{{item.first_name}} {{item.last_name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Resident Bypass</td><td>{{(vm.selector.resident_bypass_allowed ? \"Yes\" : \"No\")}}</td><td>{{(vm.formData.resident_bypass_allowed ? \"Yes\" : \"No\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Keycard Number</td><td>{{(vm.selector.keycard ? vm.selector.keycard : \"Not Provided\")}}</td><td>{{(vm.formData.keycard ? vm.formData.keycard : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Enrolled Keycard</td><td>{{(vm.selector.raw_card_data ? \"Enrolled\" : \"Not Provided\")}}</td><td>{{(vm.formData.raw_card_data ? \"Enrolled\" : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Keypad Code</td><td>{{(vm.selector.keypad ? vm.selector.keypad : \"Not Provided\")}}</td><td>{{(vm.formData.keypad ? vm.formData.keypad : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Quantum Door Access Groups</td><td><span ng-if=\"!vm.selector.door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessGroups | objectIdSearch:vm.selector.door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td><td><span ng-if=\"!vm.formData.door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessGroups | objectIdSearch:vm.formData.door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Quantum Door Access Schedules</td><td><span ng-if=\"!vm.selector.schedules.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessSchedules | objectIdSearch:vm.selector.schedules\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td><td><span ng-if=\"!vm.formData.schedules.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessSchedules | objectIdSearch:vm.formData.schedules\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0 && vm.systemLicense.allegion_active\"><td>Allgion Door Access Groups</td><td><span ng-if=\"!vm.selector.allegion_door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.allegionAccessGroups | objectIdSearch:vm.selector.allegion_door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td><td><span ng-if=\"!vm.formData.allegion_door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.allegionAccessGroups | objectIdSearch:vm.formData.allegion_door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Access Expiration</td><td>{{(vm.selector.start_date ? \"Enabled\" : \"Disabled\")}}</td><td>{{(vm.accessExpiration ? \"Enabled\" : \"Disabled\")}}</td></tr><tr ng-if=\"vm.accessExpiration\"><td>Expiration Start Date</td><td>{{vm.selector.start_date | date:\'medium\'}}</td><td>{{vm.formData.start_date | date:\'medium\'}}</td></tr><tr ng-if=\"vm.accessExpiration\"><td>Expiration End Date</td><td>{{vm.selector.end_date | date:\'medium\'}}</td><td>{{vm.formData.end_date | date:\'medium\'}}</td></tr></tbody></table></wz-step></form></wizard>");
$templateCache.put("app/family/family-create.html","<wizard on-finish=\"vm.submitCreate()\" name=\"familyMemberCreate\" header-text=\"Create a Family Member\" header-icon=\"fa-users\" ladda-enabled=\"vm.ladda\" disable-submit=\"\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Family Information\" canexit=\"vm.stepUserValid\"><h4>Family Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">First Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"first_name\" class=\"form-control\" ng-model=\"vm.formData.first_name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Last Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"last_name\" class=\"form-control\" ng-model=\"vm.formData.last_name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Associated Residents</label><div class=\"col-sm-10\"><ui-select name=\"associated_residents\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.associated_residents\"><ui-select-match>{{$item.first_name}} {{$item.last_name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.residents | filter:$select.search\">{{item.first_name}} {{item.last_name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Resident Bypass Allowed</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.formData.resident_bypass_allowed}\" ng-click=\"vm.formData.resident_bypass_allowed = false\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.formData.resident_bypass_allowed}\" ng-click=\"vm.formData.resident_bypass_allowed = true\">Active</button></div></div></div></wz-step><wz-step wz-disabled=\"{{!vm.systemLicense.wanderer_monitoring && !vm.systemLicense.access_control}}\" wz-title=\"Door Access\" canexit=\"vm.stepDoorValid\"><h4>Family Door Access</h4><div ng-show=\"vm.formData.door_access_level != 0\"><div class=\"form-group\"><label class=\"control-label col-sm-2\">Keycard Number</label><div class=\"col-sm-10\"><input type=\"number\" ignore-mouse-number=\"\" name=\"keycard\" class=\"form-control\" ng-model=\"vm.formData.keycard\" validate-on=\"dirty\" validator=\"vm.validateKeycard(vm.formData.keycard)\" invalid-message=\"vm.validateKeycardMsg(vm.formData.keycard)\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Enrolled Keycard</label><div class=\"col-sm-10\"><div class=\"input-group search-box\"><input type=\"text\" ng-disabled=\"true\" placeholder=\"Present Card at Enrollment Station to Enroll\" ignore-mouse-number=\"\" name=\"rawcard\" class=\"form-control\" ng-model=\"vm.formData.raw_card_data\" validate-on=\"dirty\" validator=\"vm.validateRawCard(vm.formData.raw_card_data)\" invalid-message=\"vm.validateRawCardMsg(vm.formData.raw_card_data)\"><div class=\"input-group-btn align-top\"><button class=\"btn\" type=\"button\" ng-click=\"vm.formData.raw_card_data = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Keypad Code</label><div class=\"col-sm-10\"><input type=\"number\" ignore-mouse-number=\"\" name=\"keypad\" class=\"form-control\" ng-model=\"vm.formData.keypad\" validate-on=\"dirty\" validator=\"vm.validateKeypad(vm.formData.keypad)\" invalid-message=\"vm.validateKeypadMsg(vm.formData.keypad)\"></div></div><div class=\"form-group\" ng-if=\"!vm.systemLicense.allegion_active\"><label class=\"control-label col-sm-2\">Access Groups</label><div class=\"col-sm-10\"><ui-select name=\"door_access_groups\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.systemLicense.allegion_active\"><label class=\"control-label col-sm-2\">Quantum Access Groups</label><div class=\"col-sm-10\"><ui-select name=\"door_access_groups\" multiple=\"\" ng-model=\"vm.formData.door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Quantum Access Schedules</label><div class=\"col-sm-10\" ng-class=\"{\'has-error\': !vm.validateDoorSchedule() && vm.form.door_access_schedules.$dirty}\"><ui-select name=\"door_access_schedules\" multiple=\"\" ng-model=\"vm.formData.schedules\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessSchedules | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select><label ng-if=\"!vm.validateDoorSchedule() && vm.form.door_access_schedules.$dirty\" class=\"control-label\">This field is required.</label></div></div><div class=\"form-group\" ng-if=\"vm.systemLicense.allegion_active\"><label class=\"control-label col-sm-2\">Allegion Access Groups</label><div class=\"col-sm-10\"><ui-select name=\"allegion_door_access_groups\" multiple=\"\" ng-model=\"vm.formData.allegion_door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.allegionAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.systemLicense.allegion_active\"><label class=\"control-label col-sm-2\">Allegion Apartment Access</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.formData.family_allowed_apt}\" ng-click=\"vm.formData.family_allowed_apt = false\">Disabled</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.formData.family_allowed_apt}\" ng-click=\"vm.formData.family_allowed_apt = true\">Enabled</button></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Access Expiration</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-change=\"vm.scheduleChange()\" ng-model=\"vm.accessExpiration\" ng-options=\"item.value as item.label for item in [{\'label\':\'Disabled\', \'value\':false},{\'label\':\'Enabled\', \'value\':true}]\"></select></div></div><div class=\"form-group\" ng-show=\"vm.accessExpiration\"><label class=\"control-label col-sm-2\">Valid Dates</label><div class=\"col-sm-10\"><input name=\"timeInterval\" ng-change=\"vm.scheduleChange()\" ng-model-options=\"{ debounce: 100 }\" placeholder=\"Select a Time Range Below\" type=\"daterange\" readonly=\"true\" opens=\"embed\" ng-model=\"vm.date\" class=\"form-control\" datepicker-options=\"vm.datepickerOptions\"></div></div></div></wz-step><wz-step wz-title=\"Review Information\"><h4>Review Family Member</h4><table class=\"table\"><thead><tr><th>Information Type</th><th>Submitted Information</th></tr></thead><tbody><tr><td>Family Member Name</td><td>{{vm.formData.first_name}} {{vm.formData.last_name}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Associated Residents</td><td><span ng-repeat=\"item in vm.residents | objectIdSearch:vm.formData.associated_residents\">{{item.first_name}} {{item.last_name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Resident Bypass</td><td>{{(vm.formData.resident_bypass_allowed ? \"Yes\" : \"No\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Keycard Number</td><td>{{(vm.formData.keycard ? vm.formData.keycard : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Enrolled Keycard</td><td>{{(vm.formData.raw_card_data ? \"Enrolled\" : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Keypad Code</td><td>{{(vm.formData.keypad ? vm.formData.keypad : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Quantum Door Access Groups</td><td><span ng-if=\"!vm.formData.door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessGroups | objectIdSearch:vm.formData.door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Quantum Door Access Schedules</td><td><span ng-if=\"!vm.formData.schedules.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessSchedules | objectIdSearch:vm.formData.schedules\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0 && vm.systemLicense.allegion_active\"><td>Allegion Door Access Groups</td><td><span ng-if=\"!vm.formData.allegion_door_groups.length\">Not Provided</span> <span ng-repeat=\"item in vm.allegionAccessGroups | objectIdSearch:vm.formData.allegion_door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0 && vm.systemLicense.allegion_active\"><td>Allegion Apartment Access</td><td>{{(vm.formData.family_allowed_apt ? \"Enabled\" : \"Disabled\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Access Expiration</td><td>{{(vm.accessExpiration ? \"Enabled\" : \"Disabled\")}}</td></tr><tr ng-if=\"vm.accessExpiration\"><td>Expiration Start Date</td><td>{{vm.formData.start_date | date:\'medium\'}}</td></tr><tr ng-if=\"vm.accessExpiration\"><td>Expiration End Date</td><td>{{vm.formData.end_date | date:\'medium\'}}</td></tr></tbody></table></wz-step></form></wizard>");
$templateCache.put("app/family/family-remove.html","<wizard on-finish=\"vm.submitRemove()\" name=\"familyMemberRemove\" header-text=\"Remove a Family Member\" header-icon=\"fa-users\" ladda-enabled=\"vm.ladda\" disable-submit=\"\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Family\" canexit=\"vm.stepSelectValid\"><h4 ng-if=\"vm.initalLoadComplete\">Select a Family Member</h4><h4 ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i> Loading...</h4><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control ng-pristine ng-valid ng-touched\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><p class=\"text-danger\" ng-if=\"(vm.selector == false) && vm.selectStepSubmitted\">FamilyMember selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Resident Name</th><th>Keycard Code</th><th>Keypad Code</th></tr></thead><tbody><tr dir-paginate=\"familyMember in vm.filteredFamilyMember = (vm.familyMember | removeId:vm.userAuth.data.id | filter:vm.searchFilter | itemsPerPage:10)\"><td ng-class=\"{\'has-error\':((vm.selector == false) && vm.selectStepSubmitted)}\"><div><label><input type=\"radio\" name=\"resident_selector\" ng-model=\"vm.selector\" ng-value=\"familyMember\" ng-click=\"vm.loadFamilyMemberEvent(familyMember)\"> {{familyMember.first_name}} {{familyMember.last_name}}</label></div></td><td ng-class=\"{\'has-error\':((vm.selector == false) && vm.selectStepSubmitted)}\">{{familyMember.keycard ? familyMember.keycard : \"Not Assigned\"}}</td><td ng-class=\"{\'has-error\':((vm.selector == false) && vm.selectStepSubmitted)}\">{{familyMember.keypad ? familyMember.keypad : \"Not Assigned\"}}</td></tr><tr ng-hide=\"vm.familyMember.length\"><td colspan=\"3\">No Family Members Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredFamilyMember.length}} of {{vm.familyMember.length}} Family Members</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></wz-step><wz-step wz-title=\"Review Information\"><h4>Review Family</h4><table class=\"table\"><thead><tr><th>Information Type</th><th>Submitted Information</th></tr></thead><tbody><tr><td>Family Member Name</td><td>{{vm.formData.first_name}} {{vm.formData.last_name}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Associated Residents</td><td><span ng-repeat=\"item in vm.residents | objectIdSearch:vm.formData.associated_residents\">{{item.first_name}} {{item.last_name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Resident Bypass</td><td>{{(vm.formData.resident_bypass_allowed ? \"Yes\" : \"No\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Keycard Number</td><td>{{(vm.formData.keycard ? vm.formData.keycard : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Enrolled Keycard</td><td>{{(vm.formData.raw_card_data ? \"Enrolled\" : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Keypad Code</td><td>{{(vm.formData.keypad ? vm.formData.keypad : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Quantum Door Access Groups</td><td><span ng-if=\"!vm.formData.door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessGroups | objectIdSearch:vm.formData.door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Quantum Door Access Schedules</td><td><span ng-if=\"!vm.formData.schedules.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessSchedules | objectIdSearch:vm.formData.schedules\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0 && vm.systemLicense.allegion_active\"><td>Allegion Door Access Groups</td><td><span ng-if=\"!vm.formData.allegion_door_groups.length\">Not Provided</span> <span ng-repeat=\"item in vm.allegionAccessGroups | objectIdSearch:vm.formData.allegion_door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0 && vm.systemLicense.allegion_active\"><td>Allegion Apartment Access</td><td>{{(vm.formData.family_allowed_apt ? \"Enabled\" : \"Disabled\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Access Expiration</td><td>{{(vm.accessExpiration ? \"Enabled\" : \"Disabled\")}}</td></tr><tr ng-if=\"vm.accessExpiration\"><td>Expiration Start Date</td><td>{{vm.formData.start_date | date:\'medium\'}}</td></tr><tr ng-if=\"vm.accessExpiration\"><td>Expiration End Date</td><td>{{vm.formData.end_date | date:\'medium\'}}</td></tr></tbody></table></wz-step></form></wizard>");
$templateCache.put("app/fixed-device-status/fixed-device-status.html","<div class=\"pull-right\" style=\"padding-right: 5px;\"><button type=\"button\" class=\"btn\" ng-if=\"!vm.loading\" ng-csv=\"vm.cleanCsv()\" filename=\"{{vm.siteName}}_fixed_device_status.csv\" csv-header=\"vm.csvHeaders\" lazy-load=\"true\">Save CSV</button></div><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa\" ng-class=\"{ \'fa-bars\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=\"vm.initalLoadComplete\">Device Status</span><span ng-if=\"!vm.initalLoadComplete\">Loading...</span></h3></div><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.orderByKey = \'name\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Device Name <span ng-show=\"vm.orderByKey == \'name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'input\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Input <span ng-show=\"vm.orderByKey == \'input\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'input\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'apartment_name\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Apartment <span ng-show=\"vm.orderByKey == \'apartment_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'apartment_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'alarmed\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Alarm Status <span ng-show=\"vm.orderByKey == \'alarmed\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'alarmed\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'serial_number\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Serial Number <span ng-show=\"vm.orderByKey == \'serial_number\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'serial_number\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'type\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Type <span ng-show=\"vm.orderByKey == \'type\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'type\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'schedule\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Schedule <span ng-show=\"vm.orderByKey == \'schedule\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'schedule\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr dir-paginate=\"device in vm.filteredDevices = (vm.fixedDevices | apartmentSearch:vm.apartments | filter:vm.searchFilter | orderBy:\'+\':vm.orderReverse | itemsPerPage:15)\"><td><i class=\"fa fa-question-circle\" style=\"color: #e51400\" ng-if=\"device.missing\"></i> <i class=\"fa fa-battery-quarter\" style=\"color: #e51400\" ng-if=\"device.low_battery\"></i> {{device.name}}</td><td>{{device.input}}</td><td>{{device.apartment_name}}</td><td ng-class=\"{\'text-danger\':device.alarmed}\">{{device.alarmed ? \"Alarm\" : \"Clear\"}}</td><td><i class=\"fa fa-question-circle\" style=\"color: #e51400\" ng-if=\"device.missing\"></i> {{device.serial_number}}</td><td>{{device.type}}</td><td>{{device.schedule}}</td></tr><tr><td colspan=\"6\" ng-if=\"!vm.filteredDevices.length && vm.initalLoadComplete\">No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredDevices.length}} of {{vm.fixedDevices.length}} Devices</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/fixed-integrated-device/fixed-integrated-device.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.getDevices()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.devicesValid()\" ng-click=\"vm.saveDevices()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-bars\"></i>Device List</h3></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Device Name</th><th>Device ID</th></tr></thead><tbody><tr dir-paginate=\"device in (vm.filteredList = (vm.devices | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedDevice == device, \'danger\':!vm.deviceValid(device)}\" ng-if=\"!device.deleted\" ng-click=\"vm.selectedDevice = device\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedDevice) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedDevice) + 1])\"><td>{{device.name}}</td><td>{{device.device_id}}</td></tr><tr ng-if=\"!vm.filteredList.length\"><td colspan=\"2\">No Results Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Device Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedDevice\">No Device Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedDevice\"><thead><tr><th class=\"col-sm-2\">Property</th><th class=\"col-sm-10\">Value</th></tr></thead><tbody><tr><td>Device Name</td><td><input ng-disabled=\"vm.selectedDevice.id == 1\" type=\"text\" class=\"form-control\" ng-model=\"vm.selectedDevice.name\"></td></tr><tr><td>Device Active</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedDevice.active}\" ng-click=\"vm.selectedDevice.active = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedDevice.active}\" ng-click=\"vm.selectedDevice.active = true\">Active</button></div></td></tr><td>Apartment</td><td><ui-select name=\"output\" ng-model=\"vm.selectedDevice.apartment\" style=\"width: 100%;\"><ui-select-match>{{$select.selected.name}} <button class=\"btn-clear pull-right\" ng-click=\"vm.clearApt($event)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"apartment.id as apartment in vm.apartments | filter:$select.search\">{{apartment.name}}</ui-select-choices></ui-select></td><tr><td>Escalations</td><td><ui-select name=\"output\" multiple=\"\" ng-model=\"vm.selectedDevice.escalations\" style=\"width: 100%;\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalations | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></td></tr><tr><td>Corridor Light Active</td><td><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedDevice.corridor_light.active}\" ng-click=\"vm.corridorLightActive(vm.selectedDevice, false)\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedDevice.corridor_light.active}\" ng-click=\"vm.corridorLightActive(vm.selectedDevice, true)\" ng-disabled=\"!vm.corridorControllers.length\">{{vm.corridorControllers.length ? \'Active\':\'No Controllers Found\'}}</button></div></td></tr><tr ng-if=\"vm.selectedDevice.corridor_light.active\"><td>Light Controller</td><td><select class=\"form-control\" ng-options=\"controller.id as controller.name for controller in vm.corridorControllers\" ng-model=\"vm.selectedDevice.corridor_light.controller\" ng-change=\"vm.resetCorridorLight(vm.selectedDevice)\"></select></td></tr><tr ng-if=\"vm.selectedDevice.corridor_light.active\"><td>Light Address</td><td><select class=\"form-control\" ng-if=\"vm.interfaceType(vm.selectedDevice.corridor_light.controller) != 17\" ng-options=\"item for item in vm.range(0,31)\" ng-model=\"vm.selectedDevice.corridor_light.address\"></select><select class=\"form-control\" ng-if=\"vm.interfaceType(vm.selectedDevice.corridor_light.controller) == 17\" ng-options=\"item for item in vm.range(1,vm.maxAddress)\" ng-model=\"vm.selectedDevice.corridor_light.address\"></select></td></tr><tr ng-if=\"vm.selectedDevice.corridor_light.active && vm.interfaceType(vm.selectedDevice.corridor_light.controller) != 17\" \"=\"\"><td>Light Color</td><td><select class=\"form-control\" ng-options=\"color.relay as color.color for color in vm.corridorColors\" ng-model=\"vm.selectedDevice.corridor_light.relay\"></select></td></tr><tr ng-if=\"vm.selectedDevice.corridor_light.active\"><td>Light Flash Rate</td><td><select class=\"form-control\" ng-model=\"vm.selectedDevice.corridor_light.rate\"><option ng-if=\"vm.interfaceType(vm.selectedDevice.corridor_light.controller) == 17\" ng-repeat=\"item in [\'Constant\', \'Flash\']\">{{item}}</option><option ng-if=\"vm.interfaceType(vm.selectedDevice.corridor_light.controller) != 17\" ng-repeat=\"item in [\'Constant\']\">{{item}}</option></select></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/fixed-quantum-device/fixed-quantum-device-change.html","<wizard on-finish=\"vm.submitChangeWizard()\" name=\"fixedDevice\" header-text=\"Change a Fixed Device\" header-icon=\"fa-bars\" ladda-enabled=\"vm.ladda\" disable-submit=\"!vm.inputsActiveValid()\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Device\" canexit=\"vm.enrollStepVaild\"><h4 ng-if=\"vm.initalLoadComplete\">Select a Device</h4><h4 ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i> Loading...</h4><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><p class=\"text-danger\" ng-if=\"!vm.enrolledDeviceSelected && vm.enrollStepSubmitted\">Device selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Serial Number</th><th>Inputs</th><th>Device Type</th></tr></thead><tbody><tr dir-paginate=\"device in vm.filteredDevices = (vm.existingDevices | filter:vm.searchFilter | itemsPerPage:10)\"><td><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.enrolledDeviceSelected\" ng-value=\"device\" ng-click=\"vm.loadEnrolledDevice(device)\"> {{device.serial_number}}</label></div></td><td>{{vm.inputsFromDevice(device)}}</td><td>{{device.device_data.device_description}}</td></tr><tr ng-hide=\"vm.existingDevices.length\"><td colspan=\"3\">No Devices Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredDevices.length}} of {{vm.existingDevices.length}} Devices</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></wz-step><wz-step wz-title=\"Device Information\" canexit=\"vm.infoStepVaild\"><h4>Device Information</h4><div ng-if=\"vm.enrolledDeviceSelected.pti == 12\"><div class=\"form-group\"><label class=\"control-label col-sm-2\">Pull Cord Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"pullcordName\" class=\"form-control\" ng-model=\"vm.enrolledDeviceSelected.sub_devices[0].name\" ng-change=\"vm.enrolledDeviceSelected.sub_devices[1].name = vm.enrolledDeviceSelected.sub_devices[0].name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Apartment</label><div class=\"col-sm-10\"><ui-select name=\"apartment\" ng-model=\"vm.enrolledDeviceSelected.sub_devices[0].apartment\" on-select=\"vm.enrolledDeviceSelected.sub_devices[1].apartment = vm.enrolledDeviceSelected.sub_devices[0].apartment\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearApt($event, vm.enrolledDeviceSelected)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"apartment.id as apartment in vm.apartments | filter:$select.search\">{{apartment.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Pull Cord Escalation</label><div class=\"col-sm-10\"><ui-select name=\"escalations\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.enrolledDeviceSelected.sub_devices[0].escalations\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalations | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Supervisory Escalation</label><div class=\"col-sm-10\"><ui-select name=\"supescalation\" ng-model=\"vm.enrolledDeviceSelected.sub_devices[0].supervisory_escalation\" on-select=\"vm.enrolledDeviceSelected.sub_devices[1].supervisory_escalation = vm.enrolledDeviceSelected.sub_devices[0].supervisory_escalation\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearEscalation($event, vm.enrolledDeviceSelected)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"escalation.id as escalation in vm.escalations | filter:$select.search\">{{escalation.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.systemLicense.staff_assist\"><label class=\"control-label col-sm-2\">Staff Assist</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.enrolledDeviceSelected.sub_devices[1].active}\" ng-click=\"vm.staffAssistActive(vm.enrolledDeviceSelected.sub_devices[1], false)\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.enrolledDeviceSelected.sub_devices[1].active}\" ng-click=\"vm.staffAssistActive(vm.enrolledDeviceSelected.sub_devices[1], true)\">Active</button></div></div></div><div class=\"form-group\" ng-if=\"vm.enrolledDeviceSelected.sub_devices[1].active && vm.systemLicense.staff_assist\"><label class=\"control-label col-sm-2\">Staff Assist Escalation</label><div class=\"col-sm-10\"><ui-select name=\"staffEscalations\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.enrolledDeviceSelected.sub_devices[1].escalations\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalations | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></div><div ng-show=\"!vm.inputsActiveValid() && !vm.ladda\" class=\"alert alert-danger ng-scope\" aria-hidden=\"false\"><h4>No Inputs Active</h4>Please Activate At Least One Input to Enroll Device</div><div ng-if=\"vm.enrolledDeviceSelected.pti != 12\" ng-repeat=\"(key, subDevice) in vm.enrolledDeviceSelected.sub_devices\"><hr><h5>Input {{subDevice.input}}: {{subDevice.input_description}}</h5><div class=\"form-group\"><label class=\"control-label col-sm-2\">Input Active</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !subDevice.active}\" ng-click=\"vm.subDeviceActive(subDevice, false)\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : subDevice.active}\" ng-click=\"vm.subDeviceActive(subDevice, true)\">Active</button></div></div></div><div class=\"form-group\" ng-if=\"subDevice.active\"><label class=\"control-label col-sm-2\">Name</label><div class=\"col-sm-10\"><input type=\"text\" ng-disabled=\"!subDevice.active\" name=\"{{key}}-name\" class=\"form-control\" ng-model=\"subDevice.name\" ng-value=\"group\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\" ng-if=\"subDevice.active\"><label class=\"control-label col-sm-2\">Apartment</label><div class=\"col-sm-10\"><ui-select ng-disabled=\"!subDevice.active\" name=\"apartment\" ng-model=\"subDevice.apartment\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearApt($event, vm.enrolledDeviceSelected)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"apartment.id as apartment in vm.apartments | filter:$select.search\">{{apartment.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"subDevice.active\"><label class=\"control-label col-sm-2\">Escalation Group</label><div class=\"col-sm-10\"><ui-select ng-disabled=\"!subDevice.active\" name=\"{{key}}-escalation\" multiple=\"\" ui-select-required=\"\" ng-model=\"subDevice.escalations\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalations | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"subDevice.active\"><label class=\"control-label col-sm-2\">Supervisory Escalation</label><div class=\"col-sm-10\"><ui-select ng-disabled=\"!subDevice.active\" name=\"supescalation\" ng-model=\"subDevice.supervisory_escalation\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearEscalationSingle($event, subDevice)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"escalation.id as escalation in vm.escalations | filter:$select.search\">{{escalation.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"subDevice.active && vm.enrolledDeviceSelected.device_data.schedulable\"><label class=\"control-label col-sm-2\">Schedule</label><div class=\"col-sm-10\"><ui-select ng-disabled=\"!subDevice.active\" name=\"schedule\" ng-model=\"subDevice.schedule_id\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearSchedule($event, subDevice)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"schedule.id as schedule in vm.schedules | filter:$select.search\">{{schedule.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.enrolledDeviceSelected.device_data.latchable && subDevice.active\"><label class=\"control-label col-sm-2\">Latch Until Reset</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-info\' : !subDevice.latching}\" ng-disabled=\"!subDevice.active\" ng-click=\"subDevice.latching = false\">Not Latched</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-info\' : subDevice.latching}\" ng-disabled=\"!subDevice.active\" ng-click=\"subDevice.latching = true\">Latched</button></div></div></div></div></wz-step><wz-step wz-disabled=\"{{!vm.systemLicense.corridor_light}}\" wz-title=\"Corridor Lights\"><h4>Corridor Lights</h4><div ng-repeat=\"(key, subDevice) in vm.enrolledDeviceSelected.sub_devices\" ng-if=\"subDevice.active\"><hr><h5>Input {{subDevice.input}}: {{subDevice.input_description}}</h5><div class=\"form-group\"><label class=\"control-label col-sm-2\">Corridor Light Active</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !subDevice.corridor_light.active}\" ng-click=\"vm.corridorLightActive(subDevice, false)\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : subDevice.corridor_light.active}\" ng-click=\"vm.corridorLightActive(subDevice, true)\" ng-disabled=\"!vm.corridorControllers.length\">{{vm.corridorControllers.length ? \'Active\':\'No Controllers Found\'}}</button></div></div></div><div class=\"form-group\" ng-if=\"subDevice.corridor_light.active\"><label class=\"control-label col-sm-2\">Controller</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-options=\"controller.id as controller.name for controller in vm.corridorControllers\" ng-model=\"subDevice.corridor_light.controller\" ng-change=\"vm.resetCorridorLight(subDevice)\"></select></div></div><div class=\"form-group\" ng-if=\"subDevice.corridor_light.active\"><label class=\"control-label col-sm-2\">Address</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-if=\"vm.interfaceType(subDevice.corridor_light.controller) != 17\" ng-options=\"item for item in vm.range(0,31)\" ng-model=\"subDevice.corridor_light.address\"></select><select class=\"form-control\" ng-if=\"vm.interfaceType(subDevice.corridor_light.controller) == 17\" ng-options=\"item for item in vm.range(1,vm.maxAddress)\" ng-model=\"subDevice.corridor_light.address\"></select></div></div><div class=\"form-group\" ng-if=\"subDevice.corridor_light.active && vm.interfaceType(subDevice.corridor_light.controller) != 17\"><label class=\"control-label col-sm-2\">Color</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-options=\"color.relay as color.color for color in vm.corridorColors\" ng-model=\"subDevice.corridor_light.relay\"></select></div></div><div class=\"form-group\" ng-if=\"subDevice.corridor_light.active\"><label class=\"control-label col-sm-2\">Flash Rate</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"subDevice.corridor_light.rate\"><option ng-if=\"vm.interfaceType(subDevice.corridor_light.controller) == 17\" ng-repeat=\"item in [\'Constant\', \'Flash\']\">{{item}}</option><option ng-if=\"vm.interfaceType(subDevice.corridor_light.controller) != 17\" ng-repeat=\"item in [\'Constant\']\">{{item}}</option></select></div></div></div></wz-step><wz-step wz-title=\"Review Device\"><h4>Review Device</h4><div ng-if=\"vm.enrolledDeviceSelected.pti == 12\"><table class=\"table\"><thead><tr><th>Information Type</th><th>Submitted Information</th></tr></thead><tbody><tr><td>Pull Cord Name</td><td>{{vm.enrolledDeviceSelected.sub_devices[0].name}}</td></tr><tr><td>Apartment</td><td><span ng-if=\"vm.enrolledDeviceSelected.sub_devices[0].apartment\" ng-repeat=\"item in vm.apartments | findObject:vm.enrolledDeviceSelected.sub_devices[0].apartment\">{{item.name}}</span> <span ng-if=\"!vm.enrolledDeviceSelected.sub_devices[0].apartment\">Not Assigned</span></td></tr><tr><td>Pull Cord Escalation</td><td><span ng-repeat=\"item in vm.escalations | objectIdSearch:vm.enrolledDeviceSelected.sub_devices[0].escalations\">{{item.name}}</span></td></tr><tr ng-if=\"vm.enrolledDeviceSelected.sub_devices[1].active\"><td>Staff Assist Escalation</td><td><span ng-repeat=\"item in vm.escalations | objectIdSearch:vm.enrolledDeviceSelected.sub_devices[1].escalations\">{{item.name}}</span></td></tr><tr><td>Supervisory Escalation</td><td><span ng-if=\"vm.enrolledDeviceSelected.sub_devices[0].supervisory_escalation\" ng-repeat=\"item in vm.escalations | findObject:vm.enrolledDeviceSelected.sub_devices[0].supervisory_escalation\">{{item.name}}</span> <span ng-if=\"!vm.enrolledDeviceSelected.sub_devices[0].supervisory_escalation\">Not Assigned</span></td></tr><tr ng-if=\"vm.systemLicense.corridor_light\"><td>Pull Cord Corridor Light</td><td>{{vm.enrolledDeviceSelected.sub_devices[0].corridor_light.active ? vm.enrolledDeviceSelected.sub_devices[0].corridor_light.rate :\"Not Active\"}}</td></tr><tr ng-if=\"vm.systemLicense.corridor_light\"><td>Staff Assist Corridor Light</td><td>{{vm.enrolledDeviceSelected.sub_devices[1].corridor_light.active ? vm.enrolledDeviceSelected.sub_devices[1].corridor_light.rate :\"Not Active\"}}</td></tr></tbody></table></div><div ng-if=\"vm.enrolledDeviceSelected.pti != 12 && vm.inputsActiveValid()\" ng-repeat=\"subDevice in vm.enrolledDeviceSelected.sub_devices\"><hr><h5>Input {{subDevice.input}}: {{subDevice.input_description}}</h5><span ng-if=\"!subDevice.active\">Input Not Active</span><table class=\"table\" ng-if=\"subDevice.active\"><thead><tr><th>Information Type</th><th>Submitted Information</th></tr></thead><tbody><tr><td>Input Name</td><td>{{subDevice.name}}</td></tr><tr><td>Apartment</td><td><span ng-if=\"subDevice.apartment\" ng-repeat=\"item in vm.apartments | findObject:subDevice.apartment\">{{item.name}}</span> <span ng-if=\"!subDevice.apartment\">Not Assigned</span></td></tr><tr><td>Escalation Groups</td><td><span ng-repeat=\"item in vm.escalations | objectIdSearch:subDevice.escalations\">{{item.name}}</span></td></tr><tr><td>Supervisory Escalation</td><td ng-if=\"subDevice.supervisory_escalation\"><span ng-repeat=\"item in vm.escalations | findObject:subDevice.supervisory_escalation\">{{item.name}}</span></td><td ng-if=\"!subDevice.supervisory_escalation\"><span>Not Assigned</span></td></tr><tr><td>Schedule</td><td><span ng-repeat=\"item in vm.schedules | findObject:subDevice.schedule_id\" ng-if=\"subDevice.schedule_id\">{{item.name}}</span><span ng-if=\"!subDevice.schedule_id\">No Schedule</span></td></tr><tr><td>Latch Until Reset</td><td>{{subDevice.latching ? \"Latching\":\"Not Latching\"}}</td></tr><tr ng-if=\"vm.systemLicense.corridor_light\"><td>Corridor Light</td><td>{{subDevice.corridor_light.active ? subDevice.corridor_light.rate :\"Not Active\"}}</td></tr></tbody></table></div></wz-step></form></wizard>");
$templateCache.put("app/fixed-quantum-device/fixed-quantum-device-create.html","<wizard on-finish=\"vm.submitAddWizard()\" name=\"fixedDevice\" header-text=\"Add a Fixed Device\" header-icon=\"fa-bars\" ladda-enabled=\"vm.ladda\" disable-submit=\"!vm.inputsActiveValid()\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Enroll Device\" canexit=\"vm.enrollStepVaild\"><h4>Enroll a Device</h4><p class=\"text-danger\" ng-if=\"!vm.enrolledDeviceSelected && vm.enrollStepSubmitted\">Device selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Serial Number</th><th>Device Type</th></tr></thead><tbody><tr ng-repeat=\"device in vm.enrolledDevices | filter:vm.searchFilter\"><td><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.enrolledDeviceSelected\" ng-value=\"device\"> {{device.serial_number}}</label></div></td><td>{{device.device_data.device_description}}</td></tr><tr ng-hide=\"vm.enrolledDevices.length\"><td colspan=\"2\"><div class=\"radio\"><label><input type=\"radio\" ng-disabled=\"true\"> Reset Device to Enroll</label></div></td></tr></tbody></table></wz-step><wz-step wz-title=\"Device Information\" canexit=\"vm.infoStepVaild\"><h4>Device Information</h4><div ng-if=\"vm.enrolledDeviceSelected.pti == 12\"><div class=\"form-group\"><label class=\"control-label col-sm-2\">Pull Cord Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"pullcordName\" class=\"form-control\" ng-model=\"vm.enrolledDeviceSelected.sub_devices[0].name\" ng-change=\"vm.enrolledDeviceSelected.sub_devices[1].name = vm.enrolledDeviceSelected.sub_devices[0].name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Apartment</label><div class=\"col-sm-10\"><ui-select name=\"apartment\" ng-model=\"vm.enrolledDeviceSelected.sub_devices[0].apartment\" on-select=\"vm.enrolledDeviceSelected.sub_devices[1].apartment = vm.enrolledDeviceSelected.sub_devices[0].apartment\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearApt($event, vm.enrolledDeviceSelected)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"apartment.id as apartment in vm.apartments | filter:$select.search\">{{apartment.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Pull Cord Escalation</label><div class=\"col-sm-10\"><ui-select name=\"escalations\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.enrolledDeviceSelected.sub_devices[0].escalations\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalations | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Supervisory Escalation</label><div class=\"col-sm-10\"><ui-select name=\"supescalation\" ng-model=\"vm.enrolledDeviceSelected.sub_devices[0].supervisory_escalation\" on-select=\"vm.enrolledDeviceSelected.sub_devices[1].supervisory_escalation = vm.enrolledDeviceSelected.sub_devices[0].supervisory_escalation\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearEscalation($event, vm.enrolledDeviceSelected)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"escalation.id as escalation in vm.escalations | filter:$select.search\">{{escalation.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.systemLicense.staff_assist\"><label class=\"control-label col-sm-2\">Staff Assist</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.enrolledDeviceSelected.sub_devices[1].active}\" ng-click=\"vm.staffAssistActive(vm.enrolledDeviceSelected.sub_devices[1], false)\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.enrolledDeviceSelected.sub_devices[1].active}\" ng-click=\"vm.staffAssistActive(vm.enrolledDeviceSelected.sub_devices[1], true)\">Active</button></div></div></div><div class=\"form-group\" ng-if=\"vm.enrolledDeviceSelected.sub_devices[1].active && vm.systemLicense.staff_assist\"><label class=\"control-label col-sm-2\">Staff Assist Escalation</label><div class=\"col-sm-10\"><ui-select name=\"staffEscalations\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.enrolledDeviceSelected.sub_devices[1].escalations\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalations | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></div><div ng-show=\"!vm.inputsActiveValid() && !vm.ladda\" class=\"alert alert-danger ng-scope\" aria-hidden=\"false\"><h4>No Inputs Active</h4>Please Activate At Least One Input to Enroll Device</div><div ng-if=\"vm.enrolledDeviceSelected.pti != 12\" ng-repeat=\"(key, subDevice) in vm.enrolledDeviceSelected.sub_devices\"><hr><h5>Input {{subDevice.input}}: {{subDevice.input_description}}</h5><div class=\"form-group\"><label class=\"control-label col-sm-2\">Input Active</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !subDevice.active}\" ng-click=\"vm.subDeviceActive(subDevice, false)\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : subDevice.active}\" ng-click=\"vm.subDeviceActive(subDevice, true)\">Active</button></div></div></div><div class=\"form-group\" ng-if=\"subDevice.active\"><label class=\"control-label col-sm-2\">Name</label><div class=\"col-sm-10\"><input type=\"text\" ng-disabled=\"!subDevice.active\" name=\"{{key}}-name\" class=\"form-control\" ng-model=\"subDevice.name\" ng-value=\"group\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\" ng-if=\"subDevice.active\"><label class=\"control-label col-sm-2\">Apartment</label><div class=\"col-sm-10\"><ui-select ng-disabled=\"!subDevice.active\" name=\"apartment\" ng-model=\"subDevice.apartment\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearAptSingle($event, subDevice)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"apartment.id as apartment in vm.apartments | filter:$select.search\">{{apartment.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"subDevice.active\"><label class=\"control-label col-sm-2\">Escalation Group</label><div class=\"col-sm-10\"><ui-select ng-disabled=\"!subDevice.active\" name=\"{{key}}-escalation\" multiple=\"\" ui-select-required=\"\" ng-model=\"subDevice.escalations\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalations | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"subDevice.active\"><label class=\"control-label col-sm-2\">Supervisory Escalation</label><div class=\"col-sm-10\"><ui-select ng-disabled=\"!subDevice.active\" name=\"supescalation\" ng-model=\"subDevice.supervisory_escalation\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearEscalationSingle($event, subDevice)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"escalation.id as escalation in vm.escalations | filter:$select.search\">{{escalation.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"subDevice.active && vm.enrolledDeviceSelected.device_data.schedulable\"><label class=\"control-label col-sm-2\">Schedule</label><div class=\"col-sm-10\"><ui-select ng-disabled=\"!subDevice.active\" name=\"schedule\" ng-model=\"subDevice.schedule_id\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearSchedule($event, subDevice)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"schedule.id as schedule in vm.schedules | filter:$select.search\">{{schedule.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.enrolledDeviceSelected.device_data.latchable && subDevice.active\"><label class=\"control-label col-sm-2\">Latch Until Reset</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-info\' : !subDevice.latching}\" ng-disabled=\"!subDevice.active\" ng-click=\"subDevice.latching = false\">Not Latched</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-info\' : subDevice.latching}\" ng-disabled=\"!subDevice.active\" ng-click=\"subDevice.latching = true\">Latched</button></div></div></div></div></wz-step><wz-step wz-disabled=\"{{!vm.systemLicense.corridor_light}}\" wz-title=\"Corridor Lights\"><h4>Corridor Lights</h4><div ng-repeat=\"(key, subDevice) in vm.enrolledDeviceSelected.sub_devices\" ng-if=\"subDevice.active\"><hr><h5>Input {{subDevice.input}}: {{subDevice.input_description}}</h5><div class=\"form-group\"><label class=\"control-label col-sm-2\">Corridor Light Active</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !subDevice.corridor_light.active}\" ng-click=\"vm.corridorLightActive(subDevice, false)\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : subDevice.corridor_light.active}\" ng-click=\"vm.corridorLightActive(subDevice, true)\" ng-disabled=\"!vm.corridorControllers.length\">{{vm.corridorControllers.length ? \'Active\':\'No Controllers Found\'}}</button></div></div></div><div class=\"form-group\" ng-if=\"subDevice.corridor_light.active\"><label class=\"control-label col-sm-2\">Controller</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-options=\"controller.id as controller.name for controller in vm.corridorControllers\" ng-model=\"subDevice.corridor_light.controller\" ng-change=\"vm.resetCorridorLight(subDevice)\"></select></div></div><div class=\"form-group\" ng-if=\"subDevice.corridor_light.active\"><label class=\"control-label col-sm-2\">Address</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-if=\"vm.interfaceType(subDevice.corridor_light.controller) != 17\" ng-options=\"item for item in vm.range(0,31)\" ng-model=\"subDevice.corridor_light.address\"></select><select class=\"form-control\" ng-if=\"vm.interfaceType(subDevice.corridor_light.controller) == 17\" ng-options=\"item for item in vm.range(1,vm.maxAddress)\" ng-model=\"subDevice.corridor_light.address\"></select></div></div><div class=\"form-group\" ng-if=\"subDevice.corridor_light.active && vm.interfaceType(subDevice.corridor_light.controller) != 17\"><label class=\"control-label col-sm-2\">Color</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-options=\"color.relay as color.color for color in vm.corridorColors\" ng-model=\"subDevice.corridor_light.relay\"></select></div></div><div class=\"form-group\" ng-if=\"subDevice.corridor_light.active\"><label class=\"control-label col-sm-2\">Flash Rate</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"subDevice.corridor_light.rate\"><option ng-if=\"vm.interfaceType(subDevice.corridor_light.controller) == 17\" ng-repeat=\"item in [\'Constant\', \'Flash\']\">{{item}}</option><option ng-if=\"vm.interfaceType(subDevice.corridor_light.controller) != 17\" ng-repeat=\"item in [\'Constant\']\">{{item}}</option></select></div></div></div></wz-step><wz-step wz-title=\"Review Device\"><h4>Review Device</h4><div ng-if=\"vm.enrolledDeviceSelected.pti == 12\"><table class=\"table\"><thead><tr><th>Information Type</th><th>Submitted Information</th></tr></thead><tbody><tr><td>Pull Cord Name</td><td>{{vm.enrolledDeviceSelected.sub_devices[0].name}}</td></tr><tr><td>Apartment</td><td><span ng-if=\"vm.enrolledDeviceSelected.sub_devices[0].apartment\" ng-repeat=\"item in vm.apartments | findObject:vm.enrolledDeviceSelected.sub_devices[0].apartment\">{{item.name}}</span> <span ng-if=\"!vm.enrolledDeviceSelected.sub_devices[0].apartment\">Not Assigned</span></td></tr><tr><td>Pull Cord Escalation</td><td><span ng-repeat=\"item in vm.escalations | objectIdSearch:vm.enrolledDeviceSelected.sub_devices[0].escalations\">{{item.name}}</span></td></tr><tr ng-if=\"vm.enrolledDeviceSelected.sub_devices[1].active\"><td>Staff Assist Escalation</td><td><span ng-repeat=\"item in vm.escalations | objectIdSearch:vm.enrolledDeviceSelected.sub_devices[1].escalations\">{{item.name}}</span></td></tr><tr><td>Supervisory Escalation</td><td><span ng-if=\"vm.enrolledDeviceSelected.sub_devices[0].supervisory_escalation\" ng-repeat=\"item in vm.escalations | findObject:vm.enrolledDeviceSelected.sub_devices[0].supervisory_escalation\">{{item.name}}</span> <span ng-if=\"!vm.enrolledDeviceSelected.sub_devices[0].supervisory_escalation\">Not Assigned</span></td></tr><tr ng-if=\"vm.systemLicense.corridor_light\"><td>Pull Cord Corridor Light</td><td>{{vm.enrolledDeviceSelected.sub_devices[0].corridor_light.active ? vm.enrolledDeviceSelected.sub_devices[0].corridor_light.rate :\"Not Active\"}}</td></tr><tr ng-if=\"vm.systemLicense.corridor_light\"><td>Staff Assist Corridor Light</td><td>{{vm.enrolledDeviceSelected.sub_devices[1].corridor_light.active ? vm.enrolledDeviceSelected.sub_devices[1].corridor_light.rate :\"Not Active\"}}</td></tr></tbody></table></div><div ng-if=\"vm.enrolledDeviceSelected.pti != 12 && vm.inputsActiveValid()\" ng-repeat=\"subDevice in vm.enrolledDeviceSelected.sub_devices\"><hr><h5>Input {{subDevice.input}}: {{subDevice.input_description}}</h5><span ng-if=\"!subDevice.active\">Input Not Active</span><table class=\"table\" ng-if=\"subDevice.active\"><thead><tr><th>Information Type</th><th>Submitted Information</th></tr></thead><tbody><tr><td>Input Name</td><td>{{subDevice.name}}</td></tr><tr><td>Apartment</td><td><span ng-if=\"subDevice.apartment\" ng-repeat=\"item in vm.apartments | findObject:subDevice.apartment\">{{item.name}}</span> <span ng-if=\"!subDevice.apartment\">Not Assigned</span></td></tr><tr><td>Escalation Groups</td><td><span ng-repeat=\"item in vm.escalations | objectIdSearch:subDevice.escalations\">{{item.name}}</span></td></tr><tr><td>Supervisory Escalation</td><td ng-if=\"subDevice.supervisory_escalation\"><span ng-repeat=\"item in vm.escalations | findObject:subDevice.supervisory_escalation\">{{item.name}}</span></td><td ng-if=\"!subDevice.supervisory_escalation\"><span>Not Assigned</span></td></tr><tr><td>Schedule</td><td><span ng-repeat=\"item in vm.schedules | findObject:subDevice.schedule_id\" ng-if=\"subDevice.schedule_id\">{{item.name}}</span><span ng-if=\"!subDevice.schedule_id\">No Schedule</span></td></tr><tr><td>Latch Until Reset</td><td>{{subDevice.latching ? \"Latching\":\"Not Latching\"}}</td></tr><tr ng-if=\"vm.systemLicense.corridor_light\"><td>Corridor Light</td><td>{{subDevice.corridor_light.active ? subDevice.corridor_light.rate :\"Not Active\"}}</td></tr></tbody></table></div></wz-step></form></wizard>");
$templateCache.put("app/fixed-quantum-device/fixed-quantum-device-remove.html","<wizard on-finish=\"vm.submitRemoveWizard()\" name=\"fixedDevice\" header-text=\"Remove a Fixed Device\" header-icon=\"fa-bars\" ladda-enabled=\"vm.ladda\" disable-submit=\"!vm.inputsActiveValid()\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Device\" canexit=\"vm.enrollStepVaild\"><h4 ng-if=\"vm.initalLoadComplete\">Select a Device</h4><h4 ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i> Loading...</h4><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control ng-pristine ng-valid ng-touched\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><p class=\"text-danger\" ng-if=\"!vm.enrolledDeviceSelected && vm.enrollStepSubmitted\">Device selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Serial Number</th><th>Inputs</th><th>Device Type</th></tr></thead><tbody><tr dir-paginate=\"device in vm.filteredDevices = (vm.existingDevices | filter:vm.searchFilter | itemsPerPage:10)\"><td><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.enrolledDeviceSelected\" ng-value=\"device\" ng-click=\"vm.loadEnrolledDevice(device)\"> {{device.serial_number}}</label></div></td><td>{{vm.inputsFromDevice(device)}}</td><td>{{device.device_data.device_description}}</td></tr><tr ng-hide=\"vm.existingDevices.length\"><td colspan=\"3\">No Devices Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredDevices.length}} of {{vm.existingDevices.length}} Devices</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></wz-step><wz-step wz-title=\"Review Device\"><h4>Review Device</h4><div ng-if=\"vm.enrolledDeviceSelected.pti == 12\"><table class=\"table\"><thead><tr><th>Information Type</th><th>Submitted Information</th></tr></thead><tbody><tr><td>Pull Cord Name</td><td>{{vm.enrolledDeviceSelected.sub_devices[0].name}}</td></tr><tr><td>Apartment</td><td><span ng-if=\"vm.enrolledDeviceSelected.sub_devices[0].apartment\" ng-repeat=\"item in vm.apartments | findObject:vm.enrolledDeviceSelected.sub_devices[0].apartment\">{{item.name}}</span> <span ng-if=\"!vm.enrolledDeviceSelected.sub_devices[0].apartment\">Not Assigned</span></td></tr><tr><td>Pull Cord Escalation</td><td><span ng-repeat=\"item in vm.escalations | objectIdSearch:vm.enrolledDeviceSelected.sub_devices[0].escalations\">{{item.name}}</span></td></tr><tr ng-if=\"vm.enrolledDeviceSelected.sub_devices[1].active\"><td>Staff Assist Escalation</td><td><span ng-repeat=\"item in vm.escalations | objectIdSearch:vm.enrolledDeviceSelected.sub_devices[1].escalations\">{{item.name}}</span></td></tr><tr><td>Supervisory Escalation</td><td><span ng-if=\"vm.enrolledDeviceSelected.sub_devices[0].supervisory_escalation\" ng-repeat=\"item in vm.escalations | findObject:vm.enrolledDeviceSelected.sub_devices[0].supervisory_escalation\">{{item.name}}</span> <span ng-if=\"!vm.enrolledDeviceSelected.sub_devices[0].supervisory_escalation\">Not Assigned</span></td></tr><tr ng-if=\"vm.systemLicense.corridor_light\"><td>Pull Cord Corridor Light</td><td>{{vm.enrolledDeviceSelected.sub_devices[0].corridor_light.active ? vm.enrolledDeviceSelected.sub_devices[0].corridor_light.rate :\"Not Active\"}}</td></tr><tr ng-if=\"vm.systemLicense.corridor_light\"><td>Staff Assist Corridor Light</td><td>{{vm.enrolledDeviceSelected.sub_devices[1].corridor_light.active ? vm.enrolledDeviceSelected.sub_devices[1].corridor_light.rate :\"Not Active\"}}</td></tr></tbody></table></div><div ng-if=\"vm.enrolledDeviceSelected.pti != 12 && vm.inputsActiveValid()\" ng-repeat=\"subDevice in vm.enrolledDeviceSelected.sub_devices\"><hr><h5>Input {{subDevice.input}}: {{subDevice.input_description}}</h5><span ng-if=\"!subDevice.active\">Input Not Active</span><table class=\"table\" ng-if=\"subDevice.active\"><thead><tr><th>Information Type</th><th>Submitted Information</th></tr></thead><tbody><tr><td>Input Name</td><td>{{subDevice.name}}</td></tr><tr><td>Apartment</td><td><span ng-if=\"subDevice.apartment\" ng-repeat=\"item in vm.apartments | findObject:subDevice.apartment\">{{item.name}}</span> <span ng-if=\"!subDevice.apartment\">Not Assigned</span></td></tr><tr><td>Escalation Groups</td><td><span ng-repeat=\"item in vm.escalations | objectIdSearch:subDevice.escalations\">{{item.name}}</span></td></tr><tr><td>Supervisory Escalation</td><td ng-if=\"subDevice.supervisory_escalation\"><span ng-repeat=\"item in vm.escalations | objectIdSearch:subDevice.supervisory_escalation\">{{item.name}}</span></td><td ng-if=\"!subDevice.supervisory_escalation\"><span>Not Assigned</span></td></tr><tr><td>Schedule</td><td><span ng-repeat=\"item in vm.schedules | findObject:subDevice.schedule_id\" ng-if=\"subDevice.schedule_id\">{{item.name}}</span><span ng-if=\"!subDevice.schedule_id\">No Schedule</span></td></tr><tr><td>Latch Until Reset</td><td>{{subDevice.latching ? \"Latching\":\"Not Latching\"}}</td></tr><tr ng-if=\"vm.systemLicense.corridor_light\"><td>Corridor Light</td><td>{{subDevice.corridor_light.active ? subDevice.corridor_light.rate :\"Not Active\"}}</td></tr></tbody></table></div></wz-step></form></wizard>");
$templateCache.put("app/fixed-quantum-device/fixed-quantum-device-replace.html","<wizard on-finish=\"vm.submitReplaceWizard()\" name=\"fixedDevice\" header-text=\"Replace a Fixed Device\" header-icon=\"fa-bars\" ladda-enabled=\"vm.ladda\" disable-submit=\"!vm.inputsActiveValid()\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Device\" canexit=\"vm.enrollStepVaild\"><h4 ng-if=\"vm.initalLoadComplete\">Select a Device to Replace</h4><h4 ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i> Loading...</h4><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control ng-pristine ng-valid ng-touched\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><p class=\"text-danger\" ng-if=\"!vm.enrolledDeviceSelected && vm.enrollStepSubmitted\">Device selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Serial Number</th><th>Inputs</th><th>Device Type</th></tr></thead><tbody><tr dir-paginate=\"device in vm.filteredDevices = (vm.existingDevices | filter:vm.searchFilter | itemsPerPage:10)\"><td><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.enrolledDeviceSelected\" ng-value=\"device\" ng-click=\"vm.loadEnrolledDevice(device)\"> {{device.serial_number}}</label></div></td><td>{{vm.inputsFromDevice(device)}}</td><td>{{device.device_data.device_description}}</td></tr><tr ng-hide=\"vm.existingDevices.length\"><td colspan=\"3\">No Devices Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredDevices.length}} of {{vm.existingDevices.length}} Devices</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></wz-step><wz-step wz-title=\"Enroll Device\" canexit=\"vm.replaceStepVaild\"><h4>Enroll Replacement Device</h4><p class=\"text-danger\" ng-if=\"!vm.replacementDeviceSelected && vm.replacementStepSubmitted\">Device selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Serial Number</th><th>Device Type</th></tr></thead><tbody><tr ng-repeat=\"device in vm.enrolledDevices\"><td><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.replacementDeviceSelected\" ng-value=\"device\" ng-click=\"vm.loadEnrolledDevice(device)\"> {{device.serial_number}}</label></div></td><td>{{device.device_data.device_description}}</td></tr><tr ng-hide=\"vm.enrolledDevices.length\"><td colspan=\"2\"><div class=\"radio\"><label><input type=\"radio\" ng-disabled=\"true\"> Reset Device to Enroll</label></div></td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Device\"><h4>Review Device</h4><div><table class=\"table\"><thead><tr><th>Information Type</th><th>Submitted Information</th></tr></thead><tbody><tr><td>Device to Replace</td><td>{{vm.inputsFromDevice(vm.enrolledDeviceSelected)}}</td></tr><tr><td>Previous Serial Number</td><td>{{vm.enrolledDeviceSelected.serial_number}}</td></tr><tr><td>Replacement Serial Number</td><td>{{vm.replacementDeviceSelected.serial_number}}</td></tr></tbody></table></div></wz-step></form></wizard>");
$templateCache.put("app/fixed-third-party-device-change/fixed-third-party-device-change.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.getDevices()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.devicesValid()\" ng-click=\"vm.saveDevices()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-home\"></i>Third Party Device List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addDevice()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Device Name</th><th>Serial Number</th></tr></thead><tbody><tr dir-paginate=\"device in (vm.filteredList = (vm.devices | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedDevice == device, \'danger\':!vm.deviceValid(device)}\" ng-if=\"!device.deleted\" ng-click=\"vm.selectedDevice = device\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedDevice) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedDevice) + 1])\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeDevice($index, device)\"></i> {{device.sub_devices[0].name}}</td><td>{{device.serial_number}}</td></tr><tr ng-if=\"!vm.filteredList.length\"><td>No Devices Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Device Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedDevice\">No Device Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedDevice\"><thead><tr><th class=\"col-sm-2\">Property</th><th class=\"col-sm-10\">Value</th></tr></thead><tbody><tr><td>Device Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedDevice.sub_devices[0].name\"></td></tr><tr><td>Serial Number</td><td><input type=\"number\" class=\"form-control\" ng-disabled=\"vm.selectedDevice.acg_id\" ng-model=\"vm.selectedDevice.serial_number\"></td></tr><tr ng-if=\"vm.userAuth.data.network_coordinator_in_use\"><td>Device Type</td><td><div class=\"col-sm-6\"><button type=\"button\" ng-disabled=\"vm.selectedDevice.id\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedDevice.device_data.quantum_device_type == 3}\" ng-click=\"vm.selectedDevice.device_data.quantum_device_type = 3; vm.selectedDevice.device_data.pti = 254; vm.selectedDevice.pti = 254\">Pull Cord</button></div><div class=\"col-sm-6\"><button type=\"button\" ng-disabled=\"vm.selectedDevice.id\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedDevice.device_data.quantum_device_type == 4}\" ng-click=\"vm.selectedDevice.device_data.quantum_device_type = 4; vm.selectedDevice.device_data.pti = 300; vm.selectedDevice.pti = 300; vm.selectedDevice.sub_devices[0].corridor_light.active = false\">Fall Detection Unit</button></div></td></tr><td>Apartment</td><td><ui-select name=\"output\" ng-model=\"vm.selectedDevice.sub_devices[0].apartment\" style=\"width: 100%;\"><ui-select-match>{{$select.selected.name}} <button class=\"btn-clear pull-right\" ng-click=\"vm.clearApt($event)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"apartment.id as apartment in vm.apartments | filter:$select.search\">{{apartment.name}}</ui-select-choices></ui-select></td><tr><td>Escalations</td><td><ui-select name=\"output\" multiple=\"\" ng-model=\"vm.selectedDevice.sub_devices[0].escalations\" style=\"width: 100%;\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalations | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></td></tr><tr ng-if=\"vm.selectedDevice.device_data.quantum_device_type == 3\"><td>Corridor Light Active</td><td><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedDevice.sub_devices[0].corridor_light.active}\" ng-click=\"vm.corridorLightActive(vm.selectedDevice.sub_devices[0], false)\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedDevice.sub_devices[0].corridor_light.active}\" ng-click=\"vm.corridorLightActive(vm.selectedDevice.sub_devices[0], true)\" ng-disabled=\"!vm.corridorControllers.length\">{{vm.corridorControllers.length ? \'Active\':\'No Controllers Found\'}}</button></div></td></tr><tr ng-if=\"vm.selectedDevice.sub_devices[0].corridor_light.active\"><td>Light Controller</td><td><select class=\"form-control\" ng-options=\"controller.id as controller.name for controller in vm.corridorControllers\" ng-model=\"vm.selectedDevice.sub_devices[0].corridor_light.controller\" ng-change=\"vm.resetCorridorLight(vm.selectedDevice.sub_devices[0])\"></select></td></tr><tr ng-if=\"vm.selectedDevice.sub_devices[0].corridor_light.active\"><td>Light Address</td><td><select class=\"form-control\" ng-if=\"vm.interfaceType(vm.selectedDevice.sub_devices[0].corridor_light.controller) != 17\" ng-options=\"item for item in vm.range(0,31)\" ng-model=\"vm.selectedDevice.sub_devices[0].corridor_light.address\"></select><select class=\"form-control\" ng-if=\"vm.interfaceType(vm.selectedDevice.sub_devices[0].corridor_light.controller) == 17\" ng-options=\"item for item in vm.range(1, vm.maxAddress)\" ng-model=\"vm.selectedDevice.sub_devices[0].corridor_light.address\"></select></td></tr><tr ng-if=\"vm.selectedDevice.sub_devices[0].corridor_light.active && vm.interfaceType(vm.selectedDevice.sub_devices[0].corridor_light.controller) != 17\"><td>Light Color</td><td><select class=\"form-control\" ng-options=\"color.relay as color.color for color in vm.corridorColors\" ng-model=\"vm.selectedDevice.sub_devices[0].corridor_light.relay\"></select></td></tr><tr ng-if=\"vm.selectedDevice.sub_devices[0].corridor_light.active\"><td>Light Flash Rate</td><td><select class=\"form-control\" ng-model=\"vm.selectedDevice.sub_devices[0].corridor_light.rate\"><option ng-if=\"vm.interfaceType(vm.selectedDevice.sub_devices[0].corridor_light.controller) == 17\" ng-repeat=\"item in [\'Constant\', \'Flash\']\">{{item}}</option><option ng-if=\"vm.interfaceType(vm.selectedDevice.sub_devices[0].corridor_light.controller) != 17\" ng-repeat=\"item in [\'Constant\']\">{{item}}</option></select></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/login/login.html","<div class=\"wrapper\"><h1><a href=\"#\"><img src=\"assets/images/logo-big.png\">QUANTUM</a></h1><div class=\"login-body\" style=\"min-height:275px;\"><div class=\"alert alert-danger\" ng-if=\"vm.unsupportedBrowser\"><i class=\"fa fa-warning\"></i> Unsupported Web Browser. <a href=\"https://www.google.com/chrome/browser/desktop/\">Download Chrome</a></div><h2>SIGN IN</h2><form name=\"loginform\" ng-submit=\"vm.login(vm.userData)\"><div class=\"form-group\"><div class=\"email controls\"><input type=\"text\" ng-disabled=\"vm.unsupportedBrowser\" placeholder=\"User Name\" class=\"form-control\" ng-model=\"vm.userData.username\"></div></div><div class=\"form-group\"><div class=\"pw controls\"><input ng-disabled=\"vm.unsupportedBrowser\" type=\"password\" placeholder=\"Password\" class=\"form-control\" ng-model=\"vm.userData.password\"></div></div><div class=\"submit\" ng-if=\"!vm.unsupportedBrowser\"><input type=\"submit\" class=\"btn btn-primary\" value=\"Log In\"></div></form></div><div class=\"alert alert-success\" ng-if=\"vm.deviceDetector.device == \'android\'\"><i class=\"fa fa-download\"></i> <a href=\"../assets/mobile/quantum_mobile_6_2.apk\" target=\"_self\">Download Quantum Mobile</a></div></div>");
$templateCache.put("app/report-active-mobile-users/report-active-mobile-users.html","<div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> Active Mobile Users</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Staff Member</th><th>Alert Device</th><th>Logged In</th><th>Last Seen</th><th>Log Off User</th></tr></thead><tbody><tr ng-repeat=\"user in vm.users\"><td>{{vm.getStaffMember(user.staff_id).first_name}} {{vm.getStaffMember(user.staff_id).last_name}}</td><td>{{vm.getAlertDevice(user.alert_device_id).name}}</td><td>{{user.log_in_time | date:\'medium\':vm.systemStatus.data.offset}}</td><td>{{user.last_check_in | date:\'medium\':vm.systemStatus.data.offset}}</td><td><button type=\"button\" name=\"kick\" class=\"btn btn-danger\" ng-click=\"vm.kickUser(user)\">Log Off</button></td></tr><tr ng-if=\"!vm.users.length\"><td colspan=\"5\">No Active Users</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"pull-right\"><span style=\"cursor: pointer; padding: 5px 10px; border: 1px solid #ccc\"><i class=\"fa fa-calendar\"></i> <input ng-change=\"vm.loadHistory()\" type=\"daterange\" readonly=\"true\" opens=\"left\" single=\"true\" ng-model=\"vm.date\" max-date=\"vm.maxDate\" format=\"MMMM D, YYYY\" style=\"cursor: pointer; padding: 5px 10px; border: 0px solid #ccc; width:145px\"><b class=\"caret\" style=\"margin-left: -10px\"></b></span></div><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> Mobile User History</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Staff Member</th><th>Alert Device</th><th>Logged In</th><th>Loged Off</th><th>Logout Type</th></tr></thead><tbody><tr ng-repeat=\"item in vm.historyResults\"><td>{{vm.getStaffMember(item.staff_id).first_name}} {{vm.getStaffMember(item.staff_id).last_name}}</td><td>{{vm.getAlertDevice(item.alert_device_id).name}}</td><td>{{item.log_in_time | date:\'medium\':vm.systemStatus.data.offset}}</td><td>{{item.logout_time | date:\'medium\':vm.systemStatus.data.offset}}</td><td>{{vm.getLogoutTyoe(item.logout_method).name}}</td></tr><tr ng-if=\"!vm.historyResults.length\"><td colspan=\"5\">No Results</td></tr></tbody></table></div></div>");
$templateCache.put("app/map/map.html","<script type=\"text/ng-template\" id=\"legendTemplate.html\"><div style=\"vertical-align: top;display: inline-block;width: auto;white-space: normal; zoom: 1;\"> <p><i class=\"fa fa-unlock text-success\"></i> Door Unlocked</p> <p><i class=\"fa fa-lock text-warning\"></i> Door Locked</p> <p><i class=\"fa fa-exclamation-triangle text-danger\"></i> Alarm</p> </div></script><div class=\"col-md-3 pull-right\"><div class=\"actions pull-right\" style=\"cursor: pointer; padding: 5px 10px; border: 1px solid #ccc\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a uib-dropdown-toggle=\"\">{{vm.selectedMapName(vm.currentMap)}} <span class=\"caret\"></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li ng-repeat=\"map in vm.maps | orderBy:\'sort_order\'\"><a href=\"#\" ng-click=\"vm.mapChange(map.id)\">{{map.name}}</a></li></ul></div><div class=\"actions pull-right\" style=\"cursor: pointer; padding: 5px 10px; border: 0px\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a uib-dropdown-toggle=\"\"><i class=\"fa fa-gear\"></i> <span class=\"caret\"></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a href=\"#\" ng-click=\"vm.setPreference(\'see_all_doors\')\"><i class=\"fa fa-check\" ng-if=\"vm.mapPrefs.door_options.see_all_doors\"></i>See All Doors</a></li></ul></div><div class=\"actions pull-right\" style=\"cursor: pointer; padding: 5px 10px; border: 0px\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a uib-popover-template=\"\'legendTemplate.html\'\" popover-placement=\"left\" popover-title=\"Legend\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\"></i></a></div></div><div class=\"clearfix\"></div><div ng-repeat=\"map in vm.maps\" ng-if=\"map.id == vm.currentMap\"><leaflet style=\"margin-top: 10px; margin-bottom: 10px;\" defaults=\"vm.mapDefaults\" layers=\"map.map_data\" center=\"vm.center\" maxbounds=\"vm.maxBounds\" markers=\"vm.markerData\" width=\"100%\" height=\"600px\"></leaflet></div>");
$templateCache.put("app/report-alarm-history/report-alarm-history.html","<script type=\"text/ng-template\" id=\"alarmModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"vm.closeModal()\">×</button> <h4 class=\"modal-title\">{{vm.selectedAlarm.event}}</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <div ng-if=\"vm.selectedAlarm.notes.length\"> <h4>Alarm Notes</h4> <table class=\"table table-nomargin\"> <thead> <tr><th>Date</th><th>Note</th></tr> </thead> <tbody> <tr ng-repeat=\"note in vm.selectedAlarm.notes\"> <td> {{note.created_date | date:\'medium\':result.offset}} </td> <td> {{note.notes}} </td> </tr> <tr> <td colspan=\"2\" ng-if=\"!vm.filteredAudits.length\">No Results Found</td> </tr> </tbody> </table> <hr /> </div> <div ng-if=\"vm.selectedAlarm.additional_locations.length\"> <h4>Additional Locations</h4> <table class=\"table table-nomargin\"> <thead> <tr><th>Location Name</th></tr> </thead> <tbody> <tr ng-repeat=\"location in vm.selectedAlarm.additional_locations track by $index\"> <td> {{location}} </td> </tr> <tr> <td colspan=\"2\" ng-if=\"!vm.filteredAudits.length\">No Results Found</td> </tr> </tbody> </table> <hr /> </div> <button class=\"pull-right btn\" type=\"button\" name=\"button\" ng-csv=\"vm.cleanAuditCsv(vm.selectedAlarm.audit_results)\" filename=\"{{vm.siteName}}_alarm_audit.csv\" csv-header=\"vm.csvHeaders\" lazy-load=\"true\">Save CSV</button><h4>Alarm Details</h4> <table class=\"table table-nomargin\"> <thead> <tr><th>Date</th><th>Device</th><th>Message</th><th>Result</th></tr> </thead> <tbody> <tr dir-paginate=\"result in vm.filteredAudits = (vm.selectedAlarm.audit_results | itemsPerPage:10:\'audit\')\" pagination-id=\"audit\"> <td> {{result.time_handled | date:\'medium\':result.offset}} </td> <td> {{result.alert_device_description}} </td> <td> {{result.message_text}} </td> <td ng-if=\"result.twilio_status.length\" uib-popover-template=\"\'twilioTemplate.html\'\" popover-placement=\"left\" popover-title=\"Twilio Results\" popover-trigger=\"\'mouseenter\'\" ng-mouseover=\"vm.popoverData = result\"> {{result.message_result}} </td> <td ng-if=\"!result.twilio_status.length\"> {{result.message_result}} </td> </tr> <tr> <td colspan=\"2\" ng-if=\"!vm.filteredAudits.length\">No Results Found</td> </tr> </tbody> </table> <div class=\"row page-tools\"> <div class=\"col-md-6\" style=\"margin-top:30px;\"> Displaying {{vm.filteredAudits.length}} of {{vm.selectedAlarm.audit_results.length}} Results </div> <div class=\"col-md-6\"> <dir-pagination-controls class=\"pull-right\" style=\"margin:0;\" pagination-id=\"\'audit\'\"></dir-pagination-controls> </div> </div> </div> </div> </div></script><script type=\"text/ng-template\" id=\"twilioTemplate.html\"><table> <tr ng-repeat=\"status in vm.popoverData.twilio_status\"> <td>{{status.created | date:\'short\'}}</td><td>{{status.status}}</td> </tr> </table></script><script type=\"text/ng-template\" id=\"customFilterModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"vm.closeFilterModal()\">×</button> <h4 class=\"modal-title\">Saved Filters</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <h4>Save Current Filter</h4> <div class=\"input-group search-box\"> <input type=\"text\" ng-model=\"vm.filterName\" placeholder=\"Filter Name\" class=\"form-control\" aria-invalid=\"false\"> <div class=\"input-group-btn\"> <button class=\"btn\" type=\"button\" ng-click=\"vm.addCustomFilter(vm.filterName)\"><i class=\"fa fa-floppy-o text-muted\"></i></button> </div> </div> <hr /> <h4>Existing Filters</h4> <table class=\"table table-hover table-nomargin\"> <thead> <tr>Filter Name</tr> </thead> <tbody> <tr dir-paginate=\"result in vm.filteredCustomFilters = (vm.customFilters.data.alarm_history | itemsPerPage:10:\'customFilter\')\" ng-click=\"vm.loadFilter(result)\" pagination-id=\"customFilter\"> <td> <i class=\"fa fa-minus-circle \" ng-class=\"area.id == 1 || vm.assignedApt(area.id, true) ? \'text-muted\' : \'text-danger\'\" ng-click=\"vm.removeFilter(result)\"></i> {{result.name}} </td> <tr> <td colspan=\"2\" ng-if=\"!vm.filteredCustomFilters.length\">No Results Found</td> </tr> </tbody> </table> <div class=\"row page-tools\"> <div class=\"col-md-6\" style=\"margin-top:30px;\"> Displaying {{vm.filteredCustomFilters.length}} of {{vm.customFilters.data.alarm_history.length}} Results </div> <div class=\"col-md-6\"> <dir-pagination-controls class=\"pull-right\" style=\"margin:0;\" pagination-id=\"\'customFilter\'\"></dir-pagination-controls> </div> </div> </div> </div> </div></script><div class=\"pull-right\"><span ng-if=\"vm.loading\"><i class=\"fa fa-spin fa-spinner\"></i></span> <span style=\"cursor: pointer; padding: 5px 10px; border: 1px solid #ccc\"><i class=\"fa fa-calendar\"></i> <input ng-change=\"vm.getData()\" type=\"daterange\" readonly=\"true\" datepicker-options=\"vm.datepickerOptions\" ng-model=\"vm.date\" style=\"cursor: pointer; padding: 5px 10px; border: 0px solid #ccc; width:195px\"><b class=\"caret\" style=\"margin-left: -10px\"></b></span></div><div class=\"pull-right\" style=\"padding-right: 5px;\"><button type=\"button\" class=\"btn\" ng-click=\"vm.clearFilers()\" ng-if=\"vm.filters.event.length || vm.filters.name.length || vm.filters.location.length || vm.filters.area.length || vm.minDuration || vm.maxDuration\">Clear Filters</button> <button type=\"button\" class=\"btn\" ng-if=\"!vm.loading\" ng-click=\"vm.openFilterModal()\">Saved Filters</button> <button type=\"button\" ng-disabled=\"!vm.reportData.alarm_data.length\" ladda=\"vm.csvLadda\" class=\"btn\" ng-if=\"!vm.loading\" ng-click=\"vm.getCsv()\">Save Spreadsheet</button></div><div class=\"box\" ng-if=\"vm.reportData.alarm_data.length\"><div class=\"box-title\"><h3><i class=\"fa\" ng-class=\"{ \'fa-lightbulb-o\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=\"vm.initalLoadComplete\">Insights</span><span ng-if=\"!vm.initalLoadComplete\">Loading...</span></h3></div><div class=\"box-content nopadding\"><div class=\"col-md-3\"><div class=\"actions\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a uib-dropdown-toggle=\"\"><h5><span ng-if=\"!vm.showAlarmsByArea\"><b>Alarms By Type</b></span><span ng-if=\"vm.showAlarmsByArea\"><b>Alarms By Area</b></span> <span class=\"caret\"></span></h5></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a href=\"#\" ng-click=\"vm.showAlarmsByArea = false\">Alarms By Type</a></li><li><a href=\"#\" ng-click=\"vm.showAlarmsByArea = true\">Alarms By Area</a></li></ul></div><canvas ng-if=\"!vm.showAlarmsByArea\" id=\"doughnut\" class=\"chart chart-doughnut\" chart-click=\"vm.pieChartClick\" chart-data=\"vm.reportData.insight_data.alarm_type_values\" chart-labels=\"vm.reportData.insight_data.alarm_type_keys\" chart-options=\"{legend:{display:true, position: \'bottom\'}}\"></canvas><canvas ng-if=\"vm.showAlarmsByArea\" id=\"doughnut\" class=\"chart chart-doughnut\" chart-click=\"vm.pieChartClickArea\" chart-data=\"vm.reportData.insight_data.area_values\" chart-labels=\"vm.reportData.insight_data.area_keys\" chart-options=\"{legend:{display:true, position: \'bottom\'}}\"></canvas></div><div class=\"col-md-6\"><h5><b>Alarms By Hour</b></h5><canvas id=\"doughnut\" class=\"chart chart-bar\" chart-data=\"vm.reportData.insight_data.hourly_data\" chart-labels=\"vm.alarmByHourKeys\" chart-dataset-override=\"vm.chartDatasetOverride\" chart-options=\"{legend:{display:true, position: \'bottom\'}, scales: {yAxes: [{ticks: {beginAtZero: true}}]}}\"></canvas></div><div class=\"col-md-3\"><h5><b>Alarm Statistics</b></h5><table class=\"table\"><tbody><tr><td>Total Alarms</td><td><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.insight_data.total_alarms}}</span><span ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i></span></td></tr><tr><td>Most Active</td><td><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.insight_data.most_active.name}}</span><span ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i></span></td></tr></tbody></table><h5><b>Response Times</b></h5><table class=\"table\"><tbody><tr><td>Average</td><td><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.insight_data.total_response_time | number:0}}m</span><span ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i></span></td></tr><tr><td>Longest</td><td><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.insight_data.longest_duration | number:0}}m</span><span ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i></span></td></tr><tr class=\"alarm-ok\" ng-click=\"vm.setTimeFilter(null, 5)\"><td>0-5m Response</td><td><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.percentages.to_five | number:0}}%</span><span ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i></span></td></tr><tr class=\"alarm-warn-1\" ng-click=\"vm.setTimeFilter(6, 10)\"><td>6-10m Response</td><td><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.percentages.five_to_ten | number:0}}%</span><span ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i></span></td></tr><tr class=\"alarm-warn-2\" ng-click=\"vm.setTimeFilter(11, 15)\"><td>11-15m Response</td><td><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.percentages.ten_to_fifteen | number:0}}%</span><span ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i></span></td></tr><tr class=\"alarm-warn-3\" ng-click=\"vm.setTimeFilter(15, null)\"><td>Over 15m Response</td><td><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.percentages.over_fifteen | number:0}}%</span><span ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i></span></td></tr></tbody></table></div></div></div><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa\" ng-class=\"{ \'fa-bars\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=\"vm.initalLoadComplete\">Alarm Details</span><span ng-if=\"!vm.initalLoadComplete\">Loading...</span></h3></div><div class=\"box-content nopadding\"><div class=\"box-cont\"><div class=\"cover\" ng-show=\"vm.loading\"><i class=\"fa fa-spin fa-spinner\"></i></div><table class=\"table table-hover table-nomargin\" ng-class=\"{\'loading\':vm.loading}\"><thead><tr><th ng-click=\"vm.orderByKey = \'event\'; vm.orderReverse = !vm.orderReverse; vm.getData()\" class=\"col-md-2\">Alarm Type <span ng-show=\"vm.orderByKey == \'event\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'event\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'location\'; vm.orderReverse = !vm.orderReverse; vm.getData()\" class=\"col-md-2\">Location <span ng-show=\"vm.orderByKey == \'location\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'location\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'last_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\" class=\"col-md-2\">Resident Name <span ng-show=\"vm.orderByKey == \'last_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'last_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'area_description\'; vm.orderReverse = !vm.orderReverse; vm.getData()\" class=\"col-md-2\">Area <span ng-show=\"vm.orderByKey == \'area_description\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'area_description\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'alarm_start\'; vm.orderReverse = !vm.orderReverse; vm.getData()\" class=\"col-md-2\">Start Time <span ng-show=\"vm.orderByKey == \'alarm_start\' && vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'alarm_start\' && !vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'alarm_end\'; vm.orderReverse = !vm.orderReverse; vm.getData()\" class=\"col-md-2\">End Time <span ng-show=\"vm.orderByKey == \'alarm_end\' && vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'alarm_end\' && !vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'duration\'; vm.orderReverse = !vm.orderReverse; vm.getData()\" class=\"col-md-2\">Duration <span ng-show=\"vm.orderByKey == \'duration\' && vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'duration\' && !vm.orderReverse\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.events\" selected-model=\"vm.filters.event\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'event\', idProp: \'event_code\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.locations\" selected-model=\"vm.filters.location\" extra-settings=\"{enableSearch: true, displayProp: \'name\', idProp: \'location_data\', showCheckAll: false, scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.residents\" selected-model=\"vm.filters.resident\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'resident_id\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.areas\" selected-model=\"vm.filters.area\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'id\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th colspan=\"2\"></th><th><div class=\"btn-group\" uib-dropdown=\"\" is-open=\"status.isopen\"><button id=\"single-button\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" dropdown-append-to-body=\"\">Filter <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu=\"\"><li><div class=\"dropdown-header\"><input ng-model-options=\"{ debounce: 250 }\" type=\"number\" class=\"form-control searchField\" ng-click=\"$event.stopPropagation()\" ng-style=\"{width: \'100%\'}\" ng-model=\"vm.minDuration\" placeholder=\"Over (Min)\"></div></li><li class=\"divider\"></li><li><div class=\"dropdown-header\"><input ng-model-options=\"{ debounce: 250 }\" type=\"number\" class=\"form-control searchField\" ng-click=\"$event.stopPropagation()\" ng-style=\"{width: \'100%\'}\" ng-model=\"vm.maxDuration\" placeholder=\"Under (Min)\"></div></li></ul></div></th></tr></tbody><tbody><tr dir-paginate=\"alarm in vm.reportData.alarm_data | itemsPerPage:20\" current-page=\"vm.currentPage\" total-items=\"vm.reportData.insight_data.total_alarms\"><td><a ng-click=\"vm.openModal(alarm)\">{{alarm.event}}</a></td><td>{{alarm.location}}</td><td>{{alarm.name}}</td><td>{{alarm.area_name}}</td><td>{{alarm.start_time | date:\'medium\':event.start_offset }}</td><td>{{alarm.end_time | date:\'medium\':event.end_offset }}</td><td ng-class=\"{\'alarm-ok\':alarm.duration < 300, \'alarm-warn-1\':(alarm.duration >= 300 && alarm.duration <= 600), \'alarm-warn-2\':(alarm.duration >= 600 && alarm.duration <= 900), \'alarm-warn-3\':(alarm.duration >= 900)}\">{{alarm.duration ? \"About \" + vm.humanizeDuration(alarm.duration) : \"Alarm Active\"}}</td></tr><tr><td colspan=\"7\" ng-if=\"!vm.reportData.alarm_data.length && !vm.loading\">No Results Found</td></tr></tbody></table></div><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">{{vm.reportData.alarm_data.length}} Alarms Displayed of {{vm.reportData.insight_data.total_alarms}} Total Alarms</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\" on-page-change=\"vm.getData(true)\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/report-care/report-care.html","<script type=\"text/ng-template\" id=\"careModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"vm.closeModal()\">×</button> <h4 class=\"modal-title\">{{vm.selectedCare.resident_name}} - {{vm.selectedCare.completed_time | date:\'medium\'}}</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <div ng-if=\"vm.selectedCare.notes\"> <h4>Associated Alarm Notes</h4> <table class=\"table table-nomargin\"> <thead> <tr><th>Note</th></tr> </thead> <tbody> <td> {{vm.selectedCare.notes}} </td> </tr> </tbody> </table> </div> </div> </div></script><script type=\"text/ng-template\" id=\"customFilterModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"vm.closeFilterModal()\">×</button> <h4 class=\"modal-title\">Saved Filters</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <h4>Save Current Filter</h4> <div class=\"input-group search-box\"> <input type=\"text\" ng-model=\"vm.filterName\" placeholder=\"Filter Name\" class=\"form-control\" aria-invalid=\"false\"> <div class=\"input-group-btn\"> <button class=\"btn\" type=\"button\" ng-click=\"vm.addCustomFilter(vm.filterName)\"><i class=\"fa fa-floppy-o text-muted\"></i></button> </div> </div> <hr /> <h4>Existing Filters</h4> <table class=\"table table-hover table-nomargin\"> <thead> <tr>Filter Name</tr> </thead> <tbody> <tr dir-paginate=\"result in vm.filteredCustomFilters = (vm.customFilters.data.care | itemsPerPage:10:\'customFilter\')\" ng-click=\"vm.loadFilter(result)\" pagination-id=\"customFilter\"> <td> <i class=\"fa fa-minus-circle \" ng-class=\"area.id == 1 || vm.assignedApt(area.id, true) ? \'text-muted\' : \'text-danger\'\" ng-click=\"vm.removeFilter(result)\"></i> {{result.name}} </td> <tr> <td colspan=\"2\" ng-if=\"!vm.filteredCustomFilters.length\">No Results Found</td> </tr> </tbody> </table> <div class=\"row page-tools\"> <div class=\"col-md-6\" style=\"margin-top:30px;\"> Displaying {{vm.filteredCustomFilters.length}} of {{vm.customFilters.data.care.length}} Results </div> <div class=\"col-md-6\"> <dir-pagination-controls class=\"pull-right\" style=\"margin:0;\" pagination-id=\"\'customFilter\'\"></dir-pagination-controls> </div> </div> </div> </div> </div></script><div class=\"pull-right\"><span ng-if=\"vm.loading\"><i class=\"fa fa-spin fa-spinner\"></i></span> <span style=\"cursor: pointer; padding: 5px 10px; border: 1px solid #ccc\"><i class=\"fa fa-calendar\"></i> <input ng-change=\"vm.getData()\" type=\"daterange\" readonly=\"true\" datepicker-options=\"vm.datepickerOptions\" ng-model=\"vm.date\" style=\"cursor: pointer; padding: 5px 10px; border: 0px solid #ccc; width:195px\"><b class=\"caret\" style=\"margin-left: -10px\"></b></span></div><div class=\"pull-right\" style=\"padding-right: 5px;\"><button type=\"button\" class=\"btn\" ng-click=\"vm.clearFilers()\" ng-if=\"vm.filters.care.length || vm.filters.resident.length || vm.filters.staff.length || vm.filters.care_level.length || vm.filters.care_plan.length || vm.filters.area.length || vm.filters.apartment.length || vm.filters.has_alarm != 1\">Clear Filters</button> <button type=\"button\" class=\"btn\" ng-if=\"!vm.loading\" ng-click=\"vm.openFilterModal()\">Saved Filters</button> <button type=\"button\" ng-disabled=\"!vm.reportData.care_data.length\" class=\"btn\" ladda=\"vm.csvLadda\" ng-if=\"!vm.loading\" ng-click=\"vm.getCsv()\">Save CSV</button></div><div class=\"box\" ng-if=\"vm.reportData.care_data.length\"><div class=\"box-title\"><h3><i class=\"fa\" ng-class=\"{ \'fa-lightbulb-o\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=\"vm.initalLoadComplete\">Care Insights</span><span ng-if=\"!vm.initalLoadComplete\">Loading...</span></h3></div><div class=\"box-content nopadding\"><div class=\"col-md-3\"><div class=\"actions\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a uib-dropdown-toggle=\"\"><h5><span ng-if=\"vm.showCaresPie\">Care Details</span><span ng-if=\"!vm.showCaresPie\">Care Levels</span> <span class=\"caret\"></span></h5></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a href=\"#\" ng-click=\"vm.showCaresPie = false\">Care Levels</a></li><li><a href=\"#\" ng-click=\"vm.showCaresPie = true\">Care Details</a></li></ul></div><canvas ng-if=\"!vm.showCaresPie\" id=\"doughnut\" class=\"chart chart-doughnut\" chart-data=\"vm.reportData.level_count\" chart-labels=\"vm.reportData.level_labels\" chart-options=\"{legend:{display:true, position: \'bottom\'}}\"></canvas><canvas ng-if=\"vm.showCaresPie\" id=\"doughnut\" class=\"chart chart-doughnut\" chart-data=\"vm.reportData.care_count\" chart-labels=\"vm.reportData.care_labels\" chart-options=\"{legend:{display:true, position: \'bottom\'}}\"></canvas></div><div class=\"col-md-6\"><h5>Cares By Day</h5><canvas id=\"doughnut\" class=\"chart chart-bar\" chart-data=\"[vm.reportData.care_count_dated]\" chart-labels=\"vm.reportData.date_label\" chart-series=\"vm.chartSeries\" chart-options=\"{legend:{display:true, position: \'bottom\'}, scales: {yAxes: [{ticks: {beginAtZero: true}}]}}\"></canvas></div><div class=\"col-md-3\"><h5>Care Details</h5><div class=\"row insight-padding\"><div class=\"col-md-6 insight-container\"><div class=\"insight-content\"><div class=\"insight-text\"><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.total_cares}}</span><span ng-if=\"!vm.initalLoadComplete\"><h2><i class=\"fa fa-spin fa-spinner\"></i></h2></span><h4>Total Cares</h4></div></div></div><div class=\"col-md-6 insight-container\"><div class=\"insight-content\"><div class=\"insight-text\"><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.most_active_staff.name}}</span><span ng-if=\"!vm.initalLoadComplete\"><h2><i class=\"fa fa-spin fa-spinner\"></i></h2></span><h4>Busiest Staff</h4></div></div></div></div><h5>Most Active</h5><div class=\"row insight-padding\"><div class=\"col-md-6 insight-container\"><div class=\"insight-content\"><div class=\"insight-text\"><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.most_active_care.name}}</span><span ng-if=\"!vm.initalLoadComplete\"><h2><i class=\"fa fa-spin fa-spinner\"></i></h2></span><h4>Most Active Care</h4></div></div></div><div class=\"col-md-6 insight-container\"><div class=\"insight-content\"><div class=\"insight-text\"><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.most_active_level.name}}</span><span ng-if=\"!vm.initalLoadComplete\"><h2><i class=\"fa fa-spin fa-spinner\"></i></h2></span><h4>Most Active Level</h4></div></div></div></div></div></div></div><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa\" ng-class=\"{ \'fa-bars\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=\"vm.initalLoadComplete\">Care Details</span><span ng-if=\"!vm.initalLoadComplete\">Loading...</span></h3></div><div class=\"box-content nopadding\"><div class=\"box-cont\"><div class=\"cover\" ng-show=\"vm.loading\"><i class=\"fa fa-spin fa-spinner\"></i></div><table class=\"table table-hover table-nomargin\" ng-class=\"{\'loading\':vm.loading}\"><thead><tr><th ng-click=\"vm.orderByKey = \'completed_time\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Care Completed <span ng-show=\"vm.orderByKey == \'completed_time\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'completed_time\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'care_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Care Provided <span ng-show=\"vm.orderByKey == \'care_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'care_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'resident_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Resident <span ng-show=\"vm.orderByKey == \'resident_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'resident_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'staff_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Provided By <span ng-show=\"vm.orderByKey == \'staff_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'staff_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'level_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Care Level <span ng-show=\"vm.orderByKey == \'level_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'level_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'care_plan_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Care Plan <span ng-show=\"vm.orderByKey == \'care_plan_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'care_plan_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'area_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Area <span ng-show=\"vm.orderByKey == \'area_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'area_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'apartment_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Apartment <span ng-show=\"vm.orderByKey == \'apartment_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'apartment_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'alarm_id\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Alarm <span ng-show=\"vm.orderByKey == \'alarm_id\' && vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'alarm_id\' && !vm.orderReverse\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr><th></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.cares\" selected-model=\"vm.filters.care\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'id\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.residents\" selected-model=\"vm.filters.resident\" extra-settings=\"{enableSearch: true, displayProp: \'name\', idProp: \'resident_id\', showCheckAll: false, scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.staff\" selected-model=\"vm.filters.staff\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'id\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.care_levels\" selected-model=\"vm.filters.care_level\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'id\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.care_plans\" selected-model=\"vm.filters.care_plan\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'id\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.areas\" selected-model=\"vm.filters.area\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'id\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.apartments\" selected-model=\"vm.filters.apartment\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'id\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div class=\"btn-group\" uib-dropdown=\"\" is-open=\"status.isopen\"><button id=\"single-button\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" dropdown-append-to-body=\"\">Filter <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu=\"\"><li><select class=\"form-control\" ng-options=\"option.id as option.name for option in vm.filterData.care_alarm_association\" ng-model=\"vm.filters.has_alarm\" ng-change=\"vm.getData()\" ng-click=\"$event.stopPropagation()\"></select></li></ul></div></th></tr></tbody><tbody><tr dir-paginate=\"care in vm.reportData.care_data | itemsPerPage:20\" current-page=\"vm.currentPage\" total-items=\"vm.reportData.total_cares\"><td>{{care.completed_time | date:\'medium\'}}</td><td ng-if=\"!care.notes\">{{care.care_name}}</td><td ng-if=\"care.notes\"><span class=\"text-primary\"><i class=\"fa fa-pencil-square-o positive\"></i></span> <a ng-click=\"vm.openModal(care)\">{{care.care_name}}</a></td><td>{{care.resident_name}}</td><td>{{care.staff_name}}</td><td>{{care.level_name}}</td><td>{{care.care_plan_name}}</td><td>{{care.area_name}}</td><td>{{care.apartment_name}}</td><td>{{care.alarm_id ? \"Yes\":\"No\"}}</td></tr><tr><td colspan=\"7\" ng-if=\"!vm.reportData.care_data.length && !vm.loading\">No Results Found</td></tr></tbody></table></div><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">{{vm.reportData.care_data.length}} Cares Displayed of {{vm.reportData.total_cares}} Total Cares</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\" on-page-change=\"vm.getData(true)\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/report-credential/report-credential.html","<div class=\"pull-right\" style=\"padding-right: 5px;\"><button type=\"button\" class=\"btn\" ng-if=\"!vm.loading\" ng-csv=\"vm.cleanCsv(vm.credentialHolders)\" filename=\"{{vm.siteName}}_credential_report.csv\" csv-header=\"vm.csvHeaders\" lazy-load=\"true\">Save CSV</button></div><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa\" ng-class=\"{ \'fa-bars\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=\"vm.initalLoadComplete\">Credential Report</span><span ng-if=\"!vm.initalLoadComplete\">Loading...</span></h3></div><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.orderByKey = \'last_name\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Name <span ng-show=\"vm.orderByKey == \'last_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'last_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'user_type\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Credential Type <span ng-show=\"vm.orderByKey == \'user_type\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'user_type\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'keypad\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Keypad Code <span ng-show=\"vm.orderByKey == \'keypad\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'keypad\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'keycard\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Keycard Code <span ng-show=\"vm.orderByKey == \'keycard\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'keycard\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'keycard\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Enrolled Keycard <span ng-show=\"vm.orderByKey == \'keycard\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'keycard\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'location\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Last Known Location <span ng-show=\"vm.orderByKey == \'location\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'location\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'location_time\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Located <span ng-show=\"vm.orderByKey == \'location_time\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'location_time\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr dir-paginate=\"credentialHolder in vm.filteredcredentialHolders = (vm.credentialHolders | filter:vm.searchFilter | orderBy:\'+\':vm.orderReverse | itemsPerPage:15)\"><td>{{credentialHolder.first_name}} {{credentialHolder.last_name}}</td><td>{{credentialHolder.user_type}}</td><td>{{credentialHolder.keypad ? credentialHolder.keypad : \"None\"}}</td><td>{{credentialHolder.keycard ? credentialHolder.keycard : \"None\"}}</td><td>{{credentialHolder.raw_card_data ? \"Enrolled\" : \"None\"}}</td><td>{{credentialHolder.last_location_name ? credentialHolder.last_location_name : \"Unknown\"}}</td><td>{{credentialHolder.location_time ? (credentialHolder.location_time | timeago) : \"Unknown\"}}</td></tr><tr><td colspan=\"5\" ng-if=\"!vm.filteredcredentialHolders.length && vm.initalLoadComplete\">No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredcredentialHolders.length}} of {{vm.credentialHolders.length}} Credentials</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/report-daily-checkin/report-daily-checkin.html","<div class=\"pull-right\"><span class=\"daterangepicker-input\" style=\"cursor: pointer; padding: 5px 10px; border: 1px solid #ccc\"><i class=\"fa fa-calendar\"></i> <input ng-change=\"vm.loadCheckin(null, true)\" type=\"daterange\" readonly=\"true\" opens=\"left\" single=\"true\" ng-model=\"vm.date\" format=\"MMMM D, YYYY\" max-date=\"vm.maxDate\" style=\"cursor: pointer; padding: 5px 10px; border: 0px solid #ccc; width:145px\"><b class=\"caret\" style=\"margin-left: -10px\"></b></span></div><div class=\"pull-right\" style=\"padding-right: 5px;\"><button type=\"button\" class=\"btn\" name=\"button\" ng-click=\"vm.hideCheckedIn = !vm.hideCheckedIn\">{{vm.hideCheckedIn ? \"Show Checked In\":\"Hide Checked In\"}}</button></div><div class=\"row\" ng-if=\"vm.checkinData.length\" ng-repeat=\"checkinWindow in vm.checkinData\" ng-hide=\"vm.hideCheckedIn && !vm.missedCheckins(checkinWindow.missed_checkins)\"><div class=\"col-sm-12\"><div class=\"box box-color box-bordered\" ng-class=\"{\'red\':vm.missedCheckins(checkinWindow.missed_checkins) && checkinWindow.active != true, \'green\':(!vm.missedCheckins(checkinWindow.missed_checkins) && checkinWindow.complete == true), \'orange\':(checkinWindow.active == true || (!checkinWindow.active && !checkinWindow.complete))}\"><div class=\"box-title\"><h3><i class=\"fa fa-check-square-o\"></i> {{checkinWindow.schedule_name}} {{!checkinWindow.complete ? \"- Not Complete\":\" - Complete\"}}</h3></div><div class=\"box-content nopadding\" ng-if=\"checkinWindow.missed_checkins.length\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.orderByKey = \'apartment_name\'; vm.orderReverse = !vm.orderReverse\">Apartment <span ng-show=\"vm.orderByKey == \'apartment_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'apartment_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'checked_in\'; vm.orderReverse = !vm.orderReverse\">Checkin Status <span ng-show=\"vm.orderByKey == \'checked_in\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'checked_in\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'area_name\'; vm.orderReverse = !vm.orderReverse\">Area <span ng-show=\"vm.orderByKey == \'area_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'area_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th>Check-in Report Date</th></tr></thead><tbody><tr ng-repeat=\"checkin in checkinWindow.missed_checkins | orderBy:vm.orderByKey:vm.orderReverse\" ng-hide=\"checkin.checked_in && vm.hideCheckedIn\"><td>{{ checkin.apartment_name }}</td><td ng-class=\"{\'text-danger\':!checkin.checked_in, \'text-success\':checkin.checked_in}\">{{ checkin.checked_in ? \"Checked In\":\"Not Checked In\" }}</td><td>{{checkin.area_name}}</td><td>{{ vm.selectedDate() }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/report-door-configuration/report-door-configuration.html","<h3 ng-if=\"!vm.doors.length\">No Doors Found</h3><div class=\"box\" ng-repeat=\"door in vm.doors\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{door.name}} - {{door.serial_number}}</h3></div><div class=\"box-content nopadding\"><div class=\"row\"><div class=\"col-md-6\"><h4>Door Configuration</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th class=\"col-xs-3\">Property</th><th class=\"col-xs-3\">Value</th></tr></thead><tbody><tr><td>IP Address</td><td>{{door.ip_address}}</td></tr><tr><td>Door Use</td><td>{{vm.returnName(vm.doorUses ,door.use)}}</td></tr><tr><td>SDC Lock</td><td>{{door.settings.SCD_lock ? \"Yes\" : \"No\"}}</td></tr><tr><td>Buzzer Volume</td><td>{{door.settings.buzzer_volume}}</td></tr><tr><td>Bypass Time</td><td>{{door.settings.bypass_time}}</td></tr><tr><td>Max Temp</td><td>{{(door.settings.max_temp ? door.settings.max_temp : \"Disabled\")}}</td></tr><tr><td>Min Temp</td><td>{{(door.settings.min_temp ? door.settings.min_temp : \"Disabled\")}}</td></tr></tbody></table></div><div class=\"col-md-6\"><h4>Wandering Configuration</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th class=\"col-xs-3\">Property</th><th class=\"col-xs-3\">Value</th></tr></thead><tbody ng-if=\"door.use == 1\"><tr><td colspan=\"2\">Wanderer Monitoring Disabled</td></tr></tbody><tbody ng-if=\"door.use != 1\"><tr><td>Alarm Range</td><td>{{door.settings.alarm_range}}</td></tr><tr><td>Propped Door Time</td><td>{{door.settings.propped_door_time ? door.settings.propped_door_time : \"Disabled\"}}</td></tr><tr><td>Transmitter Disappear Time</td><td>{{door.settings.disappear_time}}</td></tr><tr><td>Loiter Time</td><td>{{door.settings.loiter_time ? door.settings.loiter_time : \"Disabled\"}}</td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-md-6\"><h4>Inputs</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th>Input Function</th><th>Input Number</th></tr></thead><tbody><tr ng-repeat=\"input in door.input\"><td>{{vm.returnName(vm.inputTypes, input.type_id)}}</td><td>Input {{input.input_number}}</td></tr></tbody></table></div><div class=\"col-md-6\"><h4>Outputs</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th>Output Function</th><th>Output Numbers</th><th>Sounder</th></tr></thead><tbody><tr ng-repeat=\"output in door.output\"><td>{{vm.returnName(vm.outputTypes, output.type_id)}}</td><td>Output {{output.output_number.join(\", \")}}</td><td>{{(output.sounder ? vm.returnName(vm.sounderTones, output.tone_id) : \"None\")}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/report-daily-event/report-daily-event.html","<script type=\"text/ng-template\" id=\"eventModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"vm.closeModal()\">×</button> <h4 class=\"modal-title\">{{vm.selectedEvent.event}}</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <div ng-repeat=\"note in vm.selectedEventNotes\"> <div ng-if=\"note.user_note\"> <h4>Note, {{note.date_entered | date:\'medium\'}}:</h4> {{note.user_note}} </div> <!-- Difference --> <div ng-if=\"note.differences.length\"> <h4>System Update, {{note.date_entered | date:\'medium\'}}:</h4> <table class=\"table table-nomargin\"> <thead> <tr><th>Item Changed</th><th>Original Value</th><th>Updated Value</th></tr> </thead> <tbody> <tr ng-repeat=\"change in note.differences\"> <td> {{change.key}} </td> <td> {{change.oldValue}} </td> <td> {{change.newValue}} </td> </tr> <tr> <td colspan=\"2\" ng-if=\"!note.differences.length\">No Results Found</td> </tr> </tbody> </table> </div> <!-- New --> <div ng-if=\"!note.differences.length && note.new_object\"> <h4>System Update, {{note.date_entered | date:\'medium\'}}:</h4> <table class=\"table table-nomargin\"> <thead> <tr><th>Item</th><th>Value</th></tr> </thead> <tbody> <tr ng-repeat=\"(key, value) in note.new_object\"> <td> {{key}} </td> <td> {{value}} </td> </tr> </tbody> </table> </div> <!-- Removed --> <div ng-if=\"!note.differences.length && note.old_object\"> <h4>System Update, {{note.date_entered | date:\'medium\'}}:</h4> <table class=\"table table-nomargin\"> <thead> <tr><th>Item</th><th>Value</th></tr> </thead> <tbody> <tr ng-repeat=\"(key, value) in note.old_object\"> <td> {{key}} </td> <td> {{value}} </td> </tr> </tbody> </table> <pre>{{note | json}}</pre> </div> <pre ng-if=\"vm.userAuth.data.debugMode\">{{note | json}}</pre> </div> </div> </div></script><div class=\"pull-right\"><span ng-if=\"vm.loading\"><i class=\"fa fa-spin fa-spinner\"></i></span> <span style=\"cursor: pointer; padding: 5px 10px; border: 1px solid #ccc\"><i class=\"fa fa-calendar\"></i> <input ng-change=\"vm.getData()\" type=\"daterange\" readonly=\"true\" datepicker-options=\"vm.datepickerOptions\" ng-model=\"vm.date\" style=\"cursor: pointer; padding: 5px 10px; border: 0px solid #ccc; width:195px\"><b class=\"caret\" style=\"margin-left: -10px\"></b></span></div><div class=\"pull-right\" style=\"padding-right: 5px;\"><button type=\"button\" class=\"btn\" ng-click=\"vm.clearFilters()\" ng-if=\"vm.filters.event.length || vm.filters.resident.length || vm.filters.location.length || vm.filters.staff.length\">Clear Filters</button> <button type=\"button\" ng-disabled=\"!vm.events.event_data.length\" class=\"btn\" ng-if=\"!vm.loading\" ladda=\"vm.csvLadda\" ng-click=\"vm.getCsv()\">Save CSV</button></div><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa\" ng-class=\"{ \'fa-bars\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=\"vm.initalLoadComplete\">Event Report</span><span ng-if=\"!vm.initalLoadComplete\">Loading...</span></h3></div><div class=\"box-content nopadding\"><div class=\"box-cont\"><div class=\"cover\" ng-show=\"vm.loading\"><i class=\"fa fa-spin fa-spinner\"></i></div><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.orderByKey = \'event_time\'; vm.orderReverse = !vm.orderReverse; vm.getData()\" class=\"col-md-2\">Event Time <span ng-show=\"vm.orderByKey == \'event_time\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'event_time\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'event\'; vm.orderReverse = !vm.orderReverse; vm.getData()\" class=\"col-md-2\">Event Type <span ng-show=\"vm.orderByKey == \'event\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'event\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'location\'; vm.orderReverse = !vm.orderReverse; vm.getData()\" class=\"col-md-2\">Location <span ng-show=\"vm.orderByKey == \'location\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'location\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'last_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\" class=\"col-md-2\">Resident Name <span ng-show=\"vm.orderByKey == \'last_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'last_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'staff_last_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\" class=\"col-md-2\">User Name <span ng-show=\"vm.orderByKey == \'staff_last_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'staff_last_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr><th></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.events\" selected-model=\"vm.filters.event\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'event\', idProp: \'event_code\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.locations\" selected-model=\"vm.filters.location\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'location_data\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.residents\" selected-model=\"vm.filters.resident\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'resident_id\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.staff\" selected-model=\"vm.filters.staff\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'id\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th></tr></tbody><tbody><tr dir-paginate=\"event in vm.events.event_data | itemsPerPage: 20\" current-page=\"vm.currentPage\" total-items=\"vm.events.total_events\"><td>{{event.event_time | date:\'medium\':event.offset }}</td><td ng-if=\"!event.note\">{{event.event}}</td><td ng-if=\"event.note\"><span class=\"text-primary\"><i class=\"fa fa-pencil-square-o positive\"></i></span> <a ng-click=\"vm.openModal(event)\">{{event.event}}</a></td><td>{{event.location}}</td><td>{{event.resident_name}}</td><td>{{event.staff_name}}</td></tr><tr><td colspan=\"6\" ng-if=\"!vm.events.event_data.length && vm.initalLoadComplete\">No Results Found</td></tr></tbody></table></div><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">{{vm.events.event_data.length}} Events Displayed of {{vm.events.total_events}} Total Events</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\" on-page-change=\"vm.getData(true)\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/report-duplicate-name/report-duplicate-name.html","<div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> Identically Named Devices</h3></div><div class=\"box-content nopadding\"><div class=\"row\"><div class=\"col-md-12\"><table class=\"table table-hover table-nomargin\"><thead><tr><th class=\"col-xs-3\">Duplicated Name</th><th class=\"col-xs-3\">Serial Numbers</th></tr></thead><tbody><tr ng-repeat=\"device in vm.duplicateDevices\"><td>{{device.name}}</td><td><p ng-repeat=\"serial in vm.getSerials(device.acg_ids)\">{{serial}}</p></td></tr><tr ng-if=\"!vm.duplicateDevices.length\"><td colspan=\"2\">No Results Found</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/report-staff-care/report-staff-care.html","<script type=\"text/ng-template\" id=\"careModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"vm.closeModal()\">×</button> <h4 class=\"modal-title\">{{vm.selectedCare.resident_name}} - {{vm.selectedCare.completed_time | date:\'medium\'}}</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <div ng-if=\"vm.selectedCare.notes\"> <h4>Associated Alarm Notes</h4> <table class=\"table table-nomargin\"> <thead> <tr><th>Note</th></tr> </thead> <tbody> <td> {{vm.selectedCare.notes}} </td> </tr> </tbody> </table> </div> </div> </div></script><script type=\"text/ng-template\" id=\"customFilterModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"vm.closeFilterModal()\">×</button> <h4 class=\"modal-title\">Saved Filters</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <h4>Save Current Filter</h4> <div class=\"input-group search-box\"> <input type=\"text\" ng-model=\"vm.filterName\" placeholder=\"Filter Name\" class=\"form-control\" aria-invalid=\"false\"> <div class=\"input-group-btn\"> <button class=\"btn\" type=\"button\" ng-click=\"vm.addCustomFilter(vm.filterName)\"><i class=\"fa fa-floppy-o text-muted\"></i></button> </div> </div> <hr /> <h4>Existing Filters</h4> <table class=\"table table-hover table-nomargin\"> <thead> <tr>Filter Name</tr> </thead> <tbody> <tr dir-paginate=\"result in vm.filteredCustomFilters = (vm.customFilters.data.staff_care | itemsPerPage:10:\'customFilter\')\" ng-click=\"vm.loadFilter(result)\" pagination-id=\"customFilter\"> <td> <i class=\"fa fa-minus-circle \" ng-class=\"area.id == 1 || vm.assignedApt(area.id, true) ? \'text-muted\' : \'text-danger\'\" ng-click=\"vm.removeFilter(result)\"></i> {{result.name}} </td> <tr> <td colspan=\"2\" ng-if=\"!vm.filteredCustomFilters.length\">No Results Found</td> </tr> </tbody> </table> <div class=\"row page-tools\"> <div class=\"col-md-6\" style=\"margin-top:30px;\"> Displaying {{vm.filteredCustomFilters.length}} of {{vm.customFilters.data.care.length}} Results </div> <div class=\"col-md-6\"> <dir-pagination-controls class=\"pull-right\" style=\"margin:0;\" pagination-id=\"\'customFilter\'\"></dir-pagination-controls> </div> </div> </div> </div> </div></script><div class=\"pull-right\"><span ng-if=\"vm.loading\"><i class=\"fa fa-spin fa-spinner\"></i></span> <span style=\"cursor: pointer; padding: 5px 10px; border: 1px solid #ccc\"><i class=\"fa fa-calendar\"></i> <input ng-change=\"vm.getData()\" type=\"daterange\" readonly=\"true\" datepicker-options=\"vm.datepickerOptions\" ng-model=\"vm.date\" style=\"cursor: pointer; padding: 5px 10px; border: 0px solid #ccc; width:195px\"><b class=\"caret\" style=\"margin-left: -10px\"></b></span></div><div class=\"pull-right\" style=\"padding-right: 5px;\"><button type=\"button\" class=\"btn\" ng-click=\"vm.clearFilers()\" ng-if=\"vm.filters.care.length || vm.filters.resident.length || vm.filters.staff.length || vm.filters.care_level.length || vm.filters.care_plan.length || vm.filters.area.length || vm.filters.apartment.length || vm.filters.has_alarm != 1 || vm.minDuration || vm.maxDuration\">Clear Filters</button> <button type=\"button\" class=\"btn\" ng-if=\"!vm.loading\" ng-click=\"vm.openFilterModal()\">Saved Filters</button> <button type=\"button\" ng-disabled=\"!vm.reportData.care_data.length\" ladda=\"vm.csvLadda\" class=\"btn\" ng-if=\"!vm.loading\" ng-click=\"vm.getCsv()\">Save CSV</button></div><div class=\"box\" ng-if=\"vm.reportData.care_data.length\"><div class=\"box-title\"><h3><i class=\"fa\" ng-class=\"{ \'fa-lightbulb-o\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=\"vm.initalLoadComplete\">Staff Insights</span><span ng-if=\"!vm.initalLoadComplete\">Loading...</span></h3></div><div class=\"box-content nopadding\"><div class=\"col-md-3\"><div class=\"actions\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a uib-dropdown-toggle=\"\"><h5><span ng-if=\"vm.showCaresPie\">Care Details</span><span ng-if=\"!vm.showCaresPie\">Care Levels</span> <span class=\"caret\"></span></h5></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a href=\"#\" ng-click=\"vm.showCaresPie = false\">Care Levels</a></li><li><a href=\"#\" ng-click=\"vm.showCaresPie = true\">Care Details</a></li></ul></div><canvas ng-if=\"!vm.showCaresPie\" id=\"doughnut\" class=\"chart chart-doughnut\" chart-data=\"vm.reportData.level_count\" chart-labels=\"vm.reportData.level_labels\" chart-options=\"{legend:{display:true, position: \'bottom\'}}\"></canvas><canvas ng-if=\"vm.showCaresPie\" id=\"doughnut\" class=\"chart chart-doughnut\" chart-data=\"vm.reportData.care_count\" chart-labels=\"vm.reportData.care_labels\" chart-options=\"{legend:{display:true, position: \'bottom\'}}\"></canvas></div><div class=\"col-md-6\"><h5>Cares By Day</h5><canvas id=\"doughnut\" class=\"chart chart-bar\" chart-data=\"[vm.reportData.care_count_dated, vm.reportData.daily_avg_response]\" chart-labels=\"vm.reportData.date_label\" chart-dataset-override=\"vm.chartDatasetOverride\" chart-options=\"{legend:{display:true, position: \'bottom\'}, scales: {yAxes: [{ticks: {beginAtZero: true}}]}}\"></canvas></div><div class=\"col-md-3\"><h5>Totals</h5><div class=\"row insight-padding\"><div class=\"col-md-6 insight-container\"><div class=\"insight-content\"><div class=\"insight-text\"><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.total_alarms | number:0}}</span><span ng-if=\"!vm.initalLoadComplete\"><h2><i class=\"fa fa-spin fa-spinner\"></i></h2></span><h4>Alarms</h4></div></div></div><div class=\"col-md-6 insight-container\"><div class=\"insight-content\"><div class=\"insight-text\"><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.total_cares | number:0}}</span><span ng-if=\"!vm.initalLoadComplete\"><h2><i class=\"fa fa-spin fa-spinner\"></i></h2></span><h4>Cares</h4></div></div></div></div><h5>Average Times</h5><div class=\"row insight-padding\"><div class=\"col-md-6 insight-container\"><div class=\"insight-content\"><div class=\"insight-text\"><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.avg_response_time | number:0}} Min.</span><span ng-if=\"!vm.initalLoadComplete\"><h2><i class=\"fa fa-spin fa-spinner\"></i></h2></span><h4>Time to Claim</h4></div></div></div><div class=\"col-md-6 insight-container\"><div class=\"insight-content\"><div class=\"insight-text\"><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.avg_claim_time | number:0}} Min.</span><span ng-if=\"!vm.initalLoadComplete\"><h2><i class=\"fa fa-spin fa-spinner\"></i></h2></span><h4>Response</h4></div></div></div></div></div></div></div><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa\" ng-class=\"{ \'fa-bars\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=\"vm.initalLoadComplete\">Staff Details</span><span ng-if=\"!vm.initalLoadComplete\">Loading...</span></h3></div><div class=\"box-content nopadding\"><div class=\"box-cont\"><div class=\"cover\" ng-show=\"vm.loading\"><i class=\"fa fa-spin fa-spinner\"></i></div><table class=\"table table-hover table-nomargin\" ng-class=\"{\'loading\':vm.loading}\"><thead><tr><th ng-click=\"vm.orderByKey = \'staff_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Staff Name <span ng-show=\"vm.orderByKey == \'staff_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'staff_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'alarm_start\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Alarm Start <span ng-show=\"vm.orderByKey == \'alarm_start\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'alarm_start\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'claimed_time\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Claim Time <span ng-show=\"vm.orderByKey == \'claimed_time\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'claimed_time\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'alarm_end\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Alarm End <span ng-show=\"vm.orderByKey == \'alarm_end\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'alarm_end\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'duration\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Total Time <span ng-show=\"vm.orderByKey == \'duration\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'duration\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'resident_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Resident <span ng-show=\"vm.orderByKey == \'resident_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'resident_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'apartment_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Apartment <span ng-show=\"vm.orderByKey == \'apartment_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'apartment_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'area_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Area <span ng-show=\"vm.orderByKey == \'area_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'area_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'care_name\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Care Provided <span ng-show=\"vm.orderByKey == \'care_name\' && vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'care_name\' && !vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'alarm_id\'; vm.orderReverse = !vm.orderReverse; vm.getData()\">Alarm <span ng-show=\"vm.orderByKey == \'alarm_id\' && vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'alarm_id\' && !vm.orderReverse\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.staff\" selected-model=\"vm.filters.staff\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'id\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th></th><th></th><th></th><th><div class=\"btn-group\" uib-dropdown=\"\" is-open=\"status.timeisopen\"><button id=\"single-button\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" dropdown-append-to-body=\"\">Filter <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu=\"\"><li><div class=\"dropdown-header\"><input ng-model-options=\"{ debounce: 250 }\" type=\"number\" class=\"form-control searchField\" ng-click=\"$event.stopPropagation()\" ng-style=\"{width: \'100%\'}\" ng-model=\"vm.minDuration\" placeholder=\"Over (Min)\"></div></li><li class=\"divider\"></li><li><div class=\"dropdown-header\"><input ng-model-options=\"{ debounce: 250 }\" type=\"number\" class=\"form-control searchField\" ng-click=\"$event.stopPropagation()\" ng-style=\"{width: \'100%\'}\" ng-model=\"vm.maxDuration\" placeholder=\"Under (Min)\"></div></li></ul></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.residents\" selected-model=\"vm.filters.resident\" extra-settings=\"{enableSearch: true, displayProp: \'name\', idProp: \'resident_id\', showCheckAll: false, scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.apartments\" selected-model=\"vm.filters.apartment\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'id\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.areas\" selected-model=\"vm.filters.area\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'id\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div ng-dropdown-multiselect=\"\" events=\"{onSelectionChanged: vm.getData, onItemDeselect:vm.getData, onSelectAll:vm.getData, onUnselectAll:vm.getData}\" options=\"vm.filterData.cares\" selected-model=\"vm.filters.care\" extra-settings=\"{enableSearch: true, showCheckAll: false, displayProp: \'name\', idProp: \'id\', scrollableHeight: \'200px\', scrollable: true}\" translation-texts=\"{buttonDefaultText:\'Filter\'}\"></div></th><th><div class=\"btn-group\" uib-dropdown=\"\" is-open=\"status.isopen\"><button id=\"single-button\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" dropdown-append-to-body=\"\">Filter <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu=\"\"><li><select class=\"form-control\" ng-options=\"option.id as option.name for option in vm.filterData.care_alarm_association\" ng-model=\"vm.filters.has_alarm\" ng-change=\"vm.getData()\" ng-click=\"$event.stopPropagation()\"></select></li></ul></div></th></tr></tbody><tbody><tr dir-paginate=\"care in vm.reportData.care_data | itemsPerPage:20\" current-page=\"vm.currentPage\" total-items=\"vm.reportData.total_cares\"><td ng-if=\"!care.notes\">{{care.staff_name}}</td><td ng-if=\"care.notes\"><span class=\"text-primary\"><i class=\"fa fa-pencil-square-o positive\"></i></span> <a ng-click=\"vm.openModal(care)\">{{care.staff_name}}</a></td><td>{{care.alarm_start | date:\'medium\'}}</td><td>{{care.claimed_time | date:\'medium\'}}</td><td>{{care.alarm_end | date:\'medium\'}}</td><td>{{(!care.duration && care.alarm_id ? \"Duplicate Alarm\":\"\")}} {{vm.humanizeDuration(care.duration)}}</td><td>{{care.resident_name}}</td><td>{{care.apartment_name}}</td><td>{{care.area_name}}</td><td>{{care.care_name}}</td><td>{{care.alarm_id ? \"Yes\":\"No\"}}</td></tr><tr><td colspan=\"7\" ng-if=\"!vm.reportData.care_data.length && !vm.loading\">No Results Found</td></tr></tbody></table></div><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">{{vm.reportData.care_data.length}} Cares Displayed of {{vm.reportData.total_cares}} Total Cares</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\" on-page-change=\"vm.getData(true)\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/report-serial-number/report-serial-number.html","<div class=\"pull-right\" style=\"padding-right: 5px;\"><button type=\"button\" class=\"btn\" ng-if=\"!vm.loading\" ng-csv=\"vm.cleanCsv()\" filename=\"{{vm.siteName}}_serial_number_report.csv\" csv-header=\"vm.csvHeaders\" lazy-load=\"true\">Save CSV</button></div><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.quantumPullCords.length}} Quantum Pull Cords</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.pcOrderByKey = \'serial_number\'; vm.pcOrderReverse = !vm.pcOrderReverse\">Serial Number <span ng-show=\"vm.pcOrderByKey == \'serial_number\' && !vm.pcOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.pcOrderByKey == \'serial_number\' && vm.pcOrderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.pcOrderByKey = \'name\'; vm.pcOrderReverse = !vm.pcOrderReverse\">Device Name <span ng-show=\"vm.pcOrderByKey == \'name\' && !vm.pcOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.pcOrderByKey == \'name\' && vm.pcOrderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.pcOrderByKey = \'device_type\'; vm.pcOrderReverse = !vm.pcOrderReverse\">Device Type <span ng-show=\"vm.pcOrderByKey == \'device_type\' && !vm.pcOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.pcOrderByKey == \'device_type\' && vm.pcOrderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.pcOrderByKey = \'staff_assist\'; vm.pcOrderReverse = !vm.pcOrderReverse\">Staff Assist Active <span ng-show=\"vm.pcOrderByKey == \'staff_assist\' && !vm.pcOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.pcOrderByKey == \'staff_assist\' && vm.pcOrderReverse\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr ng-repeat=\"pullcord in vm.quantumPullCords | orderBy:vm.pcOrderByKey | orderBy:\'+\':vm.pcOrderReverse\"><td>{{pullcord.serial_number}}</td><td>{{pullcord.name}}</td><td>{{pullcord.device_type}}</td><td>{{pullcord.staff_assist ? \"Yes\" : \"No\"}}</td></tr><tr ng-if=\"!vm.quantumPullCords.length\"><td colspan=\"4\">No Results Found</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.quantumOtherFixedDevices.length}} Other Quantum Fixed Devices</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.ofdOrderByKey = \'serial_number\'; vm.ofdOrderReverse = !vm.ofdOrderReverse\">Serial Number <span ng-show=\"vm.ofdOrderByKey == \'serial_number\' && !vm.ofdOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.ofdOrderByKey == \'serial_number\' && vm.ofdOrderReverse\" class=\"fa fa-caret-up\"></span></th><th>Device Name</th><th ng-click=\"vm.ofdOrderByKey = \'device_data.device_description\'; vm.ofdOrderReverse = !vm.ofdOrderReverse\">Device Type <span ng-show=\"vm.ofdOrderByKey == \'device_data.device_description\' && !vm.ofdOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.ofdOrderByKey == \'device_data.device_description\' && vm.ofdOrderReverse\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr ng-repeat=\"device in vm.quantumOtherFixedDevices | orderBy:vm.ofdOrderByKey | orderBy:\'+\':vm.ofdOrderReverse\"><td>{{device.serial_number}}</td><td><span ng-repeat=\"name in device.names\">{{name}}{{!$last ? \", \":\"\"}}</span></td><td>{{device.device_data.device_description}}</td></tr><tr ng-if=\"!vm.quantumOtherFixedDevices.length\"><td colspan=\"3\">No Results Found</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.callButtons.length}} Quantum Call Buttons</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr></tr><tr><th ng-click=\"vm.cbOrderByKey = \'serial_number\'; vm.cbdOrderReverse = !vm.cbdOrderReverse\">Serial Number <span ng-show=\"vm.cbOrderByKey == \'serial_number\' && !vm.cbdOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.cbOrderByKey == \'serial_number\' && vm.cbdOrderReverse\" class=\"fa fa-caret-up\"></span></th><th class=\"col-xs-6\">Device Type</th></tr></thead><tbody><tr ng-repeat=\"callbutton in vm.callButtons | orderBy:vm.cbOrderByKey | orderBy:\'+\':vm.cbOrderReverse\"><td>{{callbutton.serial_number}}</td><td>Quantum Call Button</td></tr><tr ng-if=\"!vm.callButtons.length\"><td colspan=\"2\">No Results Found</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.wandererTransmitters.length}} Quantum Wanderer Transmitters</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.wtOrderByKey = \'serial_number\'; vm.wtOrderReverse = !vm.wtOrderReverse\">Serial Number <span ng-show=\"vm.wtOrderByKey == \'serial_number\' && !vm.wtOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.wtOrderByKey == \'serial_number\' && vm.wtOrderReverse\" class=\"fa fa-caret-up\"></span></th><th class=\"col-xs-6\">Device Type</th></tr></thead><tbody><tr ng-repeat=\"transmitter in vm.wandererTransmitters | orderBy:vm.wtOrderByKey | orderBy:\'+\':vm.wtOrderReverse\"><td>{{transmitter.serial_number}}</td><td>Quantum Wanderer Transmitter</td></tr><tr ng-if=\"!vm.wandererTransmitters.length\"><td colspan=\"2\">No Results Found</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.fallDetection.length}} Quantum Fall Detection Units</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.fdOrderByKey = \'serial_number\'; vm.fdOrderReverse = !vm.fdOrderReverse\">Serial Number <span ng-show=\"vm.fdOrderByKey == \'serial_number\' && !vm.fdOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.fdOrderByKey == \'serial_number\' && vm.fdOrderReverse\" class=\"fa fa-caret-up\"></span></th><th class=\"col-xs-6\">Device Type</th></tr></thead><tbody><tr ng-repeat=\"unit in vm.fallDetection | orderBy:vm.fdOrderByKey | orderBy:\'+\':vm.fdOrderReverse\"><td>{{unit.serial_number}}</td><td>Quantum Fall Detection Unit</td></tr><tr ng-if=\"!vm.fallDetection.length\"><td colspan=\"2\">No Results Found</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.doors.length}} Quantum Door Controllers</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.drOrderByKey = \'serial_number\'; vm.drOrderReverse = !vm.drOrderReverse\">Serial Number <span ng-show=\"vm.drOrderByKey == \'serial_number\' && !vm.drOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.drOrderByKey == \'serial_number\' && vm.drOrderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.drOrderByKey = \'name\'; vm.drOrderReverse = !vm.drOrderReverse\">Device Name <span ng-show=\"vm.drOrderByKey == \'name\' && !vm.drOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.drOrderByKey == \'name\' && vm.drOrderReverse\" class=\"fa fa-caret-up\"></span></th><th class=\"col-xs-6\">Device Type</th></tr></thead><tbody><tr ng-repeat=\"door in vm.doors | orderBy:vm.drOrderByKey | orderBy:\'+\':vm.drOrderReverse\"><td>{{door.serial_number}}</td><td>{{door.name}}</td><td>Quantum Door Controller</td></tr><tr ng-if=\"!vm.doors.length\"><td colspan=\"3\">No Results Found</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.inovoincsRepeaters.length}} Quantum Inovonics Repeaters</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.rptOrderByKey = \'serial_number\'; vm.rptOrderReverse = !vm.rptOrderReverse\">Serial Number <span ng-show=\"vm.rptOrderByKey == \'serial_number\' && !vm.rptOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.rptOrderByKey == \'serial_number\' && vm.rptOrderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.rptOrderByKey = \'name\'; vm.rptOrderReverse = !vm.rptOrderReverse\">Device Name <span ng-show=\"vm.rptOrderByKey == \'name\' && !vm.rptOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.rptOrderByKey == \'name\' && vm.rptOrderReverse\" class=\"fa fa-caret-up\"></span></th><th class=\"col-xs-6\">Device Type</th></tr></thead><tbody><tr ng-repeat=\"repeater in vm.inovoincsRepeaters | orderBy:vm.rptOrderByKey | orderBy:\'+\':vm.rptOrderReverse\"><td>{{repeater.serial_number}}</td><td>{{repeater.name}}</td><td>Inovonics Repeater</td></tr><tr ng-if=\"!vm.inovoincsRepeaters.length\"><td colspan=\"3\">No Results Found</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.ioRepeaters.length}} Quantum IO Repeaters</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.qrptOrderByKey = \'serial_number\'; vm.qrptOrderReverse = !vm.qrptOrderReverse\">Serial Number <span ng-show=\"vm.qrptOrderByKey == \'serial_number\' && !vm.qrptOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.qrptOrderByKey == \'serial_number\' && vm.qrptOrderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.qrptOrderByKey = \'name\'; vm.qrptOrderReverse = !vm.qrptOrderReverse\">Device Name <span ng-show=\"vm.qrptOrderByKey == \'name\' && !vm.qrptOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.qrptOrderByKey == \'name\' && vm.qrptOrderReverse\" class=\"fa fa-caret-up\"></span></th><th class=\"col-xs-6\">Device Type</th></tr></thead><tbody><tr ng-repeat=\"repeater in vm.ioRepeaters | orderBy:vm.qrptOrderByKey | orderBy:\'+\':vm.qrptOrderReverse\"><td>{{repeater.serial_number}}</td><td>{{repeater.name}}</td><td>Quantum IO Repeater</td></tr><tr ng-if=\"!vm.ioRepeaters.length\"><td colspan=\"3\">No Results Found</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.enrollmentStations.length}} Quantum Tag Enrollment Stations</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.esOrderByKey = \'serial_number\'; vm.esOrderReverse = !vm.esOrderReverse\">Serial Number <span ng-show=\"vm.esOrderByKey == \'serial_number\' && !vm.esOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.esOrderByKey == \'serial_number\' && vm.esOrderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.esOrderByKey = \'name\'; vm.esOrderReverse = !vm.esOrderReverse\">Device Name <span ng-show=\"vm.esOrderByKey == \'name\' && !vm.esOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.esOrderByKey == \'name\' && vm.esOrderReverse\" class=\"fa fa-caret-up\"></span></th><th class=\"col-xs-6\">Device Type</th></tr></thead><tbody><tr ng-repeat=\"enrollmentStation in vm.enrollmentStations | orderBy:vm.esOrderByKey | orderBy:\'+\':vm.esOrderReverse\"><td>{{enrollmentStation.serial_number}}</td><td>{{enrollmentStation.name}}</td><td>Quantum Enrollment Station</td></tr><tr ng-if=\"!vm.enrollmentStations.length\"><td colspan=\"3\">No Results Found</td></tr></tbody></table></div></div><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.systemMonitors.length}} Quantum System Monitors</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.smOrderByKey = \'serial_number\'; vm.smOrderReverse = !vm.smOrderReverse\">Serial Number <span ng-show=\"vm.smOrderByKey == \'serial_number\' && !vm.smOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.smOrderByKey == \'serial_number\' && vm.smOrderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.smOrderByKey = \'name\'; vm.smOrderReverse = !vm.smOrderReverse\">Device Name <span ng-show=\"vm.smOrderByKey == \'name\' && !vm.smOrderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.smOrderByKey == \'name\' && vm.smOrderReverse\" class=\"fa fa-caret-up\"></span></th><th class=\"col-xs-6\">Device Type</th></tr></thead><tbody><tr ng-repeat=\"systemMonitor in vm.systemMonitors | orderBy:vm.smOrderByKey | orderBy:\'+\':vm.smOrderReverse\"><td>{{systemMonitor.serial_number}}</td><td>{{systemMonitor.name}}</td><td>Quantum System Monitor</td></tr><tr ng-if=\"!vm.systemMonitors.length\"><td colspan=\"3\">No Results Found</td></tr></tbody></table></div></div>");
$templateCache.put("app/report-system-status/report-system-status.html","<quantum-alarm-table></quantum-alarm-table><quantum-error-table></quantum-error-table><quantum-unmonitored-hardware-table></quantum-unmonitored-hardware-table><quantum-repeater-error-table></quantum-repeater-error-table><allegion-error-table></allegion-error-table><quantum-missing-device-table></quantum-missing-device-table><quantum-low-batt-table></quantum-low-batt-table><quantum-leave-table></quantum-leave-table><quantum-schedule-table></quantum-schedule-table>");
$templateCache.put("app/report-transmitter-history/report-transmitter-history.html","<script type=\"text/ng-template\" id=\"alarmModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"vm.closeModal()\">×</button> <h4 class=\"modal-title\">Transmitter: {{vm.selectedTransmitter.tag_id}} - {{vm.selectedTransmitter.minutes_in_use / 60 / 24 | number:0}} Days in Use</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <h4>Sessions</h4> <table class=\"table table-nomargin\"> <thead> <tr><th>Started</th><th>Last Seen</th><th>Ended</th><th>Days in Use</th></tr> </thead> <tbody> <tr pagination-id=\"\'modal\'\" dir-paginate=\"result in vm.selectedTransmitter.sessions | itemsPerPage:10\"> <td> {{result.date_start | date:\'medium\':vm.systemStatus.data.offset}} </td> <td> {{result.last_seen | date:\'medium\':vm.systemStatus.data.offset}} </td> <td> {{result.date_end | date:\'medium\':vm.systemStatus.data.offset}} </td> <td> {{result.minutes_in_use / 60 / 24 | number:0}} </td> </tr> </tbody> </table> <div class=\"row page-tools\"> <div class=\"col-md-6\" style=\"margin-top:30px;\"> Displaying {{vm.filteredSessions.length}} of {{vm.selectedTransmitter.sessions.length}} Results </div> <div class=\"col-md-6\"> <dir-pagination-controls class=\"pull-right\" style=\"margin:0;\" pagination-id=\"\'modal\'\"></dir-pagination-controls> </div> </div> </div> </div></script><div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{vm.enrollmentStations.length}} Wanderer Transmitters</h3></div><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control ng-pristine ng-valid ng-touched\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Serial Number</th><th>Device Type</th></tr></thead><tbody><tr dir-paginate=\"transmitter in vm.filteredTransmitters = (vm.transmitters | filter:vm.searchFilter | itemsPerPage:10)\"><td><a ng-click=\"vm.loadTransmitter(transmitter.tag_id)\">{{transmitter.tag_id}}</a></td><td>Quantum Wanderer Transmitter</td></tr><tr ng-if=\"!vm.transmitters.length\"><td colspan=\"3\">No Results Found</td></tr></tbody></table></div><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">{{vm.filteredTransmitters.length}} Transmitters Displayed of {{vm.transmitters.length}} Total Transmitters</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></div>");
$templateCache.put("app/report-transmitter-test/report-transmitter-test.html","<div class=\"pull-right\"><span class=\"daterangepicker-input\" style=\"cursor: pointer; padding: 5px 10px; border: 1px solid #ccc\"><i class=\"fa fa-calendar\"></i> <input ng-change=\"vm.loadReports()\" type=\"daterange\" readonly=\"true\" opens=\"left\" single=\"true\" ng-model=\"vm.date\" format=\"MMMM D, YYYY\" max-date=\"vm.maxDate\" style=\"cursor: pointer; padding: 5px 10px; border: 0px solid #ccc; width:145px\"><b class=\"caret\" style=\"margin-left: -10px\"></b></span></div><div class=\"pull-right\" style=\"padding-right: 5px;\"><button type=\"button\" class=\"btn\" name=\"button\" ng-click=\"vm.hideGoodTransmitters = !vm.hideGoodTransmitters\">{{vm.hideGoodTransmitters ? \"Show Passed\":\"Hide Passed\"}}</button></div><div class=\"pull-right\" style=\"padding-right: 5px;\"><button type=\"button\" class=\"btn\" name=\"button\" ng-click=\"vm.showDetails = !vm.showDetails\">{{vm.showDetails ? \"Show Summary\":\"Show Details\"}}</button></div><div class=\"row\" ng-if=\"!vm.showDetails || !vm.residentTests.length\"><div class=\"col-sm-12\"><div class=\"box box-color box-bordered\" ng-class=\"{\'green\':(!vm.transmitterErrors(vm.residentTests)), \'orange\':(vm.transmitterErrors(vm.residentTests))}\"><div class=\"box-title\"><h3><i class=\"fa fa-check-square-o\"></i> Transmitter Test for {{vm.selectedDate()}}</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Resident</th><th>Test Results</th><th>Report Date</th></tr></thead><tbody><tr ng-repeat=\"resident in vm.residentTests | orderBy:vm.orderByKey:vm.orderReverse\" ng-hide=\"resident.found && !resident.low_battery && vm.hideGoodTransmitters\"><td>{{ resident.resident_name ? resident.resident_name : \"Extra Transmitter\"}}</td><td ng-class=\"{\'text-danger\':!resident.found || resident.low_battery, \'text-success\':resident.found}\">{{ resident.found ? (resident.low_battery ? \"Low Battery\":\"Passed\") : \"Missing\" }}</td><td>{{ vm.selectedDate() }}</td></tr><tr ng-if=\"!vm.residentTests.length\"><td colspan=\"3\">No Tests Run</td></tr></tbody></table></div></div></div></div><div class=\"row\" ng-if=\"vm.showDetails\" ng-repeat=\"test in vm.residentTestDetails\"><div class=\"col-sm-12\"><div class=\"box box-color box-bordered\" ng-class=\"{\'green\':(!vm.transmitterErrors(vm.residentTests)), \'orange\':(vm.transmitterErrors(vm.residentTests))}\"><div class=\"box-title\"><h3><i class=\"fa fa-check-square-o\"></i> Transmitter Test - {{test.start_date | date:\'medium\'}} - Performed by {{test.staff_name}}</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Resident</th><th>Serial Number</th><th>Test Results</th><th>Report Date</th></tr></thead><tbody><tr ng-repeat=\"resident in test.results | orderBy:vm.orderByKey:vm.orderReverse\" ng-hide=\"resident.found && !resident.low_battery && vm.hideGoodTransmitters\"><td>{{ resident.resident_name ? resident.resident_name : \"Extra Transmitter\"}}</td><td>{{ resident.mac }}</td><td ng-class=\"{\'text-danger\':!resident.found || resident.low_battery, \'text-success\':resident.found}\">{{ resident.found ? (resident.low_battery ? \"Low Battery\":\"Passed\") : \"Missing\" }}</td><td>{{ vm.selectedDate() }}</td></tr><tr ng-if=\"!vm.residentTests.length\"><td colspan=\"3\">No Tests Run</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/report-untested-device/report-untested-device.html","<div class=\"box\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> Untested End User Devices</h3></div><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><div class=\"box-content nopadding\"><div class=\"row\"><div class=\"col-md-12\"><table class=\"table table-hover table-nomargin\"><thead><tr><th class=\"col-xs-3\">Device Name</th><th class=\"col-xs-3\">Device Type</th></tr></thead><tbody><tr ng-repeat=\"device in vm.untestedDevice.missed_end_user | filter:vm.searchFilter | orderBy:\'name\'\"><td>{{device.name}}</td><td>{{device.device_type}}</td></tr></tbody></table></div></div></div></div><div class=\"box\" ng-repeat=\"door in vm.untestedDevice.door_failure\"><div class=\"box-title print-enabled\"><h3><i class=\"fa fa-bars\"></i> {{door.name}} - Untested Function</h3></div><div class=\"box-content nopadding\"><div class=\"row\"><div class=\"col-md-12\"><table class=\"table table-hover table-nomargin\"><thead><tr><th class=\"col-xs-3\">Function</th><th class=\"col-xs-3\">Issue</th></tr></thead><tbody><tr ng-if=\"door.wandering_enabled && !door.tag_detected\"><td>Wanderer Monitoring</td><td>Transmitter Not Received</td></tr><tr ng-repeat=\"alarm in door.missing_expected_alarm\"><td>{{alarm.name}}</td><td>Alarm not Tested</td></tr><tr ng-repeat=\"input in door.missing_input\"><td>{{input.name}} - Physical Input {{input.physical_input}}</td><td>Input not Tested</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/resident/resident-admit.html","<wizard on-finish=\"vm.submitAdmitWizard()\" name=\"resident\" header-text=\"Admit a Resident\" header-icon=\"fa-user\" ladda-enabled=\"vm.ladda\" disable-submit=\"vm.deviceAssignmentValidation()\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Resident Information\" canexit=\"vm.stepInfoValid\"><h4>Resident Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">First Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"first_name\" class=\"form-control\" ng-model=\"vm.formData.first_name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Last Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"last_name\" class=\"form-control\" ng-model=\"vm.formData.last_name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Apartment</label><div class=\"col-sm-10\"><ui-select name=\"apartment\" ui-select-single-required=\"\" ng-model=\"vm.formData.apartment\"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"apartment.id as apartment in vm.apartmentData | filter:$select.search\">{{apartment.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Escalation Group</label><div class=\"col-sm-10\"><ui-select name=\"escalations\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.escalations\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalationData | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Supervisory Escalation</label><div class=\"col-sm-10\"><ui-select name=\"supervisory\" ng-model=\"vm.formData.supervisory_escalation\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearSupEscalation($event)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"escalation.id as escalation in vm.escalationData| filter:$select.search\">{{escalation.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.systemLicense.care_package\"><label class=\"control-label col-sm-2\">Care Plan</label><div class=\"col-sm-10\"><ui-select name=\"care-plan\" ng-model=\"vm.formData.care_plan\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearCarePlan($event)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"plan.id as plan in vm.carePlans| filter:$select.search\">{{plan.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Phone Number</label><div class=\"col-sm-10\"><input type=\"text\" name=\"phone_number\" class=\"form-control\" ng-model=\"vm.formData.phone_number\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Notes</label><div class=\"col-sm-10\"><input class=\"form-control\" ng-model=\"vm.formData.notes\"></div></div></wz-step><wz-step wz-disabled=\"{{!vm.systemLicense.nurse_call}}\" wz-title=\"Call Button\"><h4>Enroll a Call Button</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th>Serial Number</th><th>Device Type</th><th>Options</th></tr></thead><tbody><tr ng-if=\"!vm.callButtonEnrollment.length\"><td colspan=\"3\"><div class=\"radio\"><label><input type=\"radio\" disabled=\"\"> Alarm Then Reset New Call Button to Enroll</label></div></td></tr><tr ng-repeat=\"callButton in vm.callButtonEnrollment\"><td><div class=\"radio\"><label><input type=\"radio\" name=\"call_button\" ng-model=\"vm.formData.call_button\" ng-value=\"callButton\"> {{callButton.serial_number}}</label></div></td><td>{{callButton.device_data.device_description}}</td><td ng-if=\"callButton.device_data.pti != 93\">No Options</td><td ng-if=\"callButton.device_data.pti == 93\"><label><input type=\"checkbox\" ng-model=\"callButton.fall_active\" ng-true-value=\"true\" ng-false-value=\"false\"> Fall Detection Enabled</label></td></tr><tr><td colspan=\"3\"><div class=\"radio\"><label><input type=\"radio\" name=\"call_button\" ng-model=\"vm.formData.call_button\" ng-value=\"null\"> Do Not Assign a Call Button</label></div></td></tr></tbody></table></wz-step><wz-step wz-disabled=\"{{(!vm.systemLicense.nurse_call || !vm.systemLicense.fall_detection)}}\" wz-title=\"Fall Detection\"><h4>Enroll a Fall Detection Unit</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th>Serial Number</th><th>Device Type</th></tr></thead><tbody><tr ng-if=\"!vm.fallDetectionEnrollment.length\"><td colspan=\"2\"><div class=\"radio\"><label><input type=\"radio\" disabled=\"\"> Alarm Then Reset New Fall Detection Unit to Enroll</label></div></td></tr><tr ng-repeat=\"fallDetection in vm.fallDetectionEnrollment\"><td><div class=\"radio\"><label><input type=\"radio\" name=\"fall_detection\" ng-model=\"vm.formData.fall_detection\" ng-value=\"fallDetection\"> {{fallDetection.serial_number}}</label></div></td><td>{{fallDetection.device_data.device_description}}</td></tr><tr><td colspan=\"2\"><div class=\"radio\"><label><input type=\"radio\" name=\"fall_detection\" ng-model=\"vm.formData.fall_detection\" ng-value=\"null\"> Do Not Assign a Fall Detection Unit</label></div></td></tr></tbody></table></wz-step><wz-step wz-disabled=\"{{!vm.systemLicense.wanderer_monitoring || (vm.formData.door_access_permission == 3 && !vm.userAuth.data.system_license.allegion_active)}}\" wz-title=\"Wanderer Transmitter\"><h4>Enroll a Wanderer Transmitter</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th>Serial Number</th><th>Battery Status</th><th>Usage</th><th>Currently Assigned</th></tr></thead><tbody><tr ng-if=\"!vm.wandererTransmitterEnrollment.length\"><td colspan=\"4\"><div class=\"radio\"><label><input type=\"radio\" disabled=\"\"> Place Transmitter on Enrollment Station to Enroll</label></div></td></tr><tr ng-repeat=\"transmitter in vm.wandererTransmitterEnrollment\"><td><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.formData.wanderer_transmitter\" ng-value=\"transmitter\" ng-disabled=\"transmitter.battery_low || transmitter.assigned\" ng-click=\"vm.disableDoorAccess()\"> {{transmitter.serial_number}}</label></div></td><td ng-class=\"{\'text-danger\':transmitter.battery_low}\">{{(transmitter.battery_low ? \"Low\" : \"Good\")}}</td><td>{{transmitter.days_in_use | number:0}} Days Active</td><td ng-class=\"{\'text-danger\':transmitter.assigned}\">{{(transmitter.assigned ? transmitter.resident_name : \"Not Assigned\")}}</td></tr><tr><td colspan=\"4\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.formData.wanderer_transmitter\" ng-value=\"null\"> Do Not Assign a Wanderer Transmitter</label></div></td></tr></tbody></table></wz-step><wz-step wz-disabled=\"{{(!vm.systemLicense.access_control && !vm.systemLicense.wanderer_monitoring) || (vm.formData.wanderer_transmitter != null && !vm.userAuth.data.system_license.allegion_active)}}\" wz-title=\"Door Access\" canexit=\"vm.stepDoorValid\"><h4>Resident Door Access</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Door Access Level</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"vm.formData.door_access_permission\" ng-options=\"item.id as item.name for item in vm.doorPermissions\" ng-change=\"vm.doorAccessChange()\"></select></div></div><div ng-if=\"vm.formData.door_access_permission == 3\"><div class=\"form-group\"><label class=\"control-label col-sm-2\">Keycard Number</label><div class=\"col-sm-10\"><input type=\"number\" ignore-mouse-number=\"\" name=\"keycard\" class=\"form-control\" ng-model=\"vm.formData.resident_door_access.keycard\" validate-on=\"dirty\" validator=\"vm.validateKeycard(vm.formData.resident_door_access.keycard)\" invalid-message=\"vm.validateKeycardMsg(vm.formData.resident_door_access.keycard)\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Enrolled Keycard</label><div class=\"col-sm-10\"><div class=\"input-group search-box\"><input type=\"text\" ng-disabled=\"true\" placeholder=\"Present Card at Enrollment Station to Enroll\" ignore-mouse-number=\"\" name=\"rawcard\" class=\"form-control\" ng-model=\"vm.formData.resident_door_access.raw_card_data\" validate-on=\"dirty\" validator=\"vm.validateRawCard(vm.formData.resident_door_access.raw_card_data)\" invalid-message=\"vm.validateRawCardMsg(vm.formData.resident_door_access.raw_card_data)\"><div class=\"input-group-btn align-top\"><button class=\"btn\" type=\"button\" ng-click=\"vm.formData.resident_door_access.raw_card_data = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Keypad Code</label><div class=\"col-sm-10\"><input type=\"number\" ignore-mouse-number=\"\" name=\"keypad\" class=\"form-control\" ng-model=\"vm.formData.resident_door_access.keypad\" validate-on=\"dirty\" validator=\"vm.validateKeypad(vm.formData.resident_door_access.keypad)\" invalid-message=\"vm.validateKeypadMsg(vm.formData.resident_door_access.keypad)\"></div></div><div class=\"form-group\" ng-if=\"!vm.userAuth.data.system_license.allegion_active\"><label class=\"control-label col-sm-2\">Quantum Access Groups</label><div class=\"col-sm-10\"><ui-select name=\"door_access_groups\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.resident_door_access.door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.userAuth.data.system_license.allegion_active && vm.formData.wanderer_transmitter == null\"><label class=\"control-label col-sm-2\">Quantum Access Groups</label><div class=\"col-sm-10\"><ui-select name=\"door_access_group\" multiple=\"\" ng-model=\"vm.formData.resident_door_access.door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.formData.wanderer_transmitter == null\"><label class=\"control-label col-sm-2\">Quantum Access Schedules</label><div class=\"col-sm-10\" ng-class=\"{\'has-error\': !vm.validateDoorSchedule() && vm.form.door_access_schedules.$dirty}\"><ui-select name=\"door_access_schedules\" multiple=\"\" ng-model=\"vm.formData.resident_door_access.schedules\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessSchedules | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select><label ng-if=\"!vm.validateDoorSchedule() && vm.form.door_access_schedules.$dirty\" class=\"control-label\">This field is required.</label></div></div><div class=\"form-group\" ng-if=\"vm.userAuth.data.system_license.allegion_active\"><label class=\"control-label col-sm-2\">Allegion Access Groups</label><div class=\"col-sm-10\"><ui-select name=\"allegion_door_access_groups\" multiple=\"\" ng-model=\"vm.formData.resident_door_access.allegion_door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.allegionAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.userAuth.data.system_license.allegion_active\"><label class=\"control-label col-sm-2\">Allegion Room Access</label><div class=\"col-sm-10\">This Resident Will Always Have Access to Any Locks Assigned to Their Apartment</div></div></div></wz-step><wz-step wz-title=\"Review Resident\"><h4>Review Resident Information</h4><div ng-show=\"vm.deviceAssignmentValidation() && !vm.ladda\" class=\"alert alert-danger\"><h4>No Devices Assigned</h4>Please Assign a Call Button, Fall Detection Unit, Wanderer Transmitter, or Door Access.</div><table class=\"table\"><thead><tr><th>Information Type</th><th>Submitted Information</th></tr></thead><tbody><tr><td>Resident Name</td><td>{{vm.formData.first_name}} {{vm.formData.last_name}}</td></tr><tr><td>Apartment</td><td><span ng-repeat=\"item in vm.apartmentData | findObject:vm.formData.apartment\">{{item.name}}</span></td></tr><tr><td>Escalation Groups</td><td><span ng-repeat=\"item in vm.escalationData | objectIdSearch:vm.formData.escalations\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.supervisory_escalation\"><td>Supervisory Escalation</td><td><span ng-repeat=\"item in vm.escalationData | findObject:vm.formData.supervisory_escalation\">{{item.name}}</span></td></tr><tr ng-if=\"vm.formData.care_plan\"><td>Care Plan</td><td><span ng-repeat=\"item in vm.carePlans | findObject:vm.formData.care_plan\">{{item.name}}</span></td></tr><tr><td>Resident Phone Number</td><td><span ng-if=\"!vm.formData.phone_number\">Not Provided</span>{{vm.formData.phone_number}}</td></tr><tr><td>Notes</td><td><span ng-if=\"!vm.formData.notes\">Not Provided</span>{{vm.formData.notes}}</td></tr><tr><td>Call Button</td><td>{{(vm.formData.call_button ? \"Serial: \" + vm.formData.call_button.serial_number : \"Not Assigned\")}} <span ng-if=\"vm.formData.call_button.pti == 93 && vm.formData.call_button.fall_active\">(Fall Detection Active)</span><span ng-if=\"vm.formData.call_button.pti == 93 && !vm.formData.call_button.fall_active\">(Fall Detection Inactive)</span></td></tr><tr ng-if=\"vm.systemLicense.fall_detection\"><td>Fall Detection Unit</td><td>{{(vm.formData.fall_detection ? \"Serial: \" + vm.formData.fall_detection.serial_number : \"Not Assigned\")}}</td></tr><tr><td>Wanderer Transmitter</td><td>{{(vm.formData.wanderer_transmitter ? \"Serial: \" + vm.formData.wanderer_transmitter.serial_number : \"Not Assigned\")}}</td></tr><tr ng-if=\"vm.formData.door_access_permission == 3\"><td>Keycard Number</td><td>{{(vm.formData.resident_door_access.keycard ? vm.formData.resident_door_access.keycard : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_permission == 3\"><td>Enrolled Keycard</td><td>{{(vm.formData.resident_door_access.keycard ? \"Enrolled\" : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_permission == 3\"><td>Keypad Code</td><td>{{(vm.formData.resident_door_access.keypad ? vm.formData.resident_door_access.keypad : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_permission == 3\"><td>Quantum Door Access Groups</td><td><span ng-if=\"!vm.formData.resident_door_access.door_groups.length\">Not Provided</span> <span ng-repeat=\"item in vm.doorAccessGroups | objectIdSearch:vm.formData.resident_door_access.door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_permission == 3\"><td>Quantum Door Access Schedules</td><td><span ng-if=\"!vm.formData.resident_door_access.schedules.length\">Not Provided</span> <span ng-repeat=\"item in vm.doorAccessSchedules | objectIdSearch:vm.formData.resident_door_access.schedules\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_permission == 3 && vm.formData.door_access_level != 0 && vm.userAuth.data.system_license.allegion_active\"><td>Allegion Access Groups</td><td><span ng-if=\"!vm.formData.resident_door_access.allegion_door_groups.length\">Not Provided</span> <span ng-repeat=\"item in vm.allegionAccessGroups | objectIdSearch:vm.formData.resident_door_access.allegion_door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_permission == 1\"><td>Door Access</td><td>Not Assigned</td></tr><tr ng-if=\"vm.formData.door_access_permission == 2\"><td>Door Access</td><td>Family Access Only</td></tr></tbody></table></wz-step></form></wizard>");
$templateCache.put("app/resident/resident-change.html","<wizard on-finish=\"vm.submitChangeWizard()\" name=\"resident\" header-text=\"Change Resident Information\" header-icon=\"fa-user\" ladda-enabled=\"vm.ladda\" disable-submit=\"vm.deviceAssignmentValidation()\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Resident\" canexit=\"vm.stepSelectValid\"><h4 ng-if=\"vm.initalLoadComplete\">Select a Resident</h4><h4 ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i> Loading...</h4><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control ng-pristine ng-valid ng-touched\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><p class=\"text-danger\" ng-if=\"(vm.selector == false) && vm.selectStepSubmitted\">Resident selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Resident Name</th><th>Apartment</th></tr></thead><tbody><tr dir-paginate=\"resident in vm.filteredResidents = (vm.existingResidents | apartmentSearch:vm.apartmentData | filter:vm.searchFilter | itemsPerPage:10)\"><td ng-class=\"{\'has-error\':((vm.selector == false) && vm.selectStepSubmitted)}\"><div><label><input type=\"radio\" name=\"resident_selector\" ng-model=\"vm.selector\" ng-value=\"resident\" ng-click=\"vm.loadSelectedData(resident)\"> {{resident.first_name}} {{resident.last_name}}</label></div></td><td>{{resident.apartment_name}}</td></tr><tr ng-hide=\"vm.existingResidents.length\"><td colspan=\"2\">No Residents Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredResidents.length}} of {{vm.existingResidents.length}} Residents</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></wz-step><wz-step wz-title=\"Resident Information\" canexit=\"vm.stepInfoValid\"><h4>Resident Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">First Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"first_name\" class=\"form-control\" ng-model=\"vm.formData.first_name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Last Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"last_name\" class=\"form-control\" ng-model=\"vm.formData.last_name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Apartment</label><div class=\"col-sm-10\"><ui-select name=\"apartment\" ui-select-single-required=\"\" ng-model=\"vm.formData.apartment\"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"apartment.id as apartment in vm.apartmentData | filter:$select.search\">{{apartment.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Escalation Group</label><div class=\"col-sm-10\"><ui-select name=\"escalations\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.escalations\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.escalationData | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Supervisory Escalation</label><div class=\"col-sm-10\"><ui-select name=\"supervisory\" ng-model=\"vm.formData.supervisory_escalation\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearSupEscalation($event)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"escalation.id as escalation in vm.escalationData| filter:$select.search\">{{escalation.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.systemLicense.care_package\"><label class=\"control-label col-sm-2\">Care Plan</label><div class=\"col-sm-10\"><ui-select name=\"care-plan\" ng-model=\"vm.formData.care_plan\"><ui-select-match>{{$select.selected.name}} <button type=\"button\" class=\"btn-clear pull-right\" ng-click=\"vm.clearCarePlan($event)\"><i class=\"fa fa-times\"></i></button></ui-select-match><ui-select-choices repeat=\"plan.id as plan in vm.carePlans| filter:$select.search\">{{plan.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Phone Number</label><div class=\"col-sm-10\"><input type=\"text\" name=\"phone_number\" class=\"form-control\" ng-model=\"vm.formData.phone_number\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Notes</label><div class=\"col-sm-10\"><input class=\"form-control\" ng-model=\"vm.formData.notes\"></div></div></wz-step><wz-step wz-disabled=\"{{!vm.systemLicense.nurse_call}}\" wz-title=\"Call Button\"><h4>Enroll a Call Button</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th>Serial Number</th><th>Device Type</th><th>Options</th></tr></thead><tbody><tr ng-if=\"!vm.callButtonEnrollment.length\"><td colspan=\"3\"><div class=\"radio\"><label><input type=\"radio\" disabled=\"\"> Alarm Then Reset Call Button to Replace or Enroll</label></div></td></tr><tr ng-repeat=\"callButton in vm.callButtonEnrollment\"><td><div class=\"radio\"><label><input type=\"radio\" name=\"call_button\" ng-model=\"vm.formData.call_button\" ng-value=\"callButton\"> {{callButton.serial_number}}</label></div></td><td>{{callButton.device_data.device_description}}</td><td ng-if=\"callButton.device_data.pti != 93\">No Options</td><td ng-if=\"callButton.device_data.pti == 93\"><label><input type=\"checkbox\" ng-model=\"callButton.fall_active\" ng-true-value=\"true\" ng-false-value=\"false\"> Fall Detection Enabled</label></td></tr><tr ng-if=\"vm.selectedResident.call_button\"><td><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.formData.call_button\" ng-checked=\"true\" ng-value=\"vm.selectedResident.call_button\"> Keep Existing Call Button Serial: {{vm.selectedResident.call_button.serial_number}}</label></div></td><td>Existing Call Button</td><td ng-if=\"vm.selectedResident.call_button.pti != 93\">No Options</td><td ng-if=\"vm.selectedResident.call_button.pti == 93\"><label><input type=\"checkbox\" ng-model=\"vm.selectedResident.call_button.fall_active\" ng-true-value=\"true\" ng-false-value=\"false\" ng-change=\"vm.selectedResident.call_button.id = null\"> Fall Detection Enabled</label></td></tr><tr ng-if=\"vm.selectedResident.call_button\"><td colspan=\"3\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.formData.call_button\" ng-value=\"null\"> Remove Existing Call Button</label></div></td></tr><tr ng-if=\"!vm.selectedResident.call_button\"><td colspan=\"3\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.formData.call_button\" ng-value=\"null\"> Do Not Assign a Call Button</label></div></td></tr></tbody></table></wz-step><wz-step wz-disabled=\"{{(!vm.systemLicense.nurse_call || !vm.systemLicense.fall_detection)}}\" wz-title=\"Fall Detection\"><h4>Enroll a Fall Detection Unit</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th>Serial Number</th><th>Device Type</th></tr></thead><tbody><tr ng-if=\"!vm.fallDetectionEnrollment.length\"><td colspan=\"2\"><div class=\"radio\"><label><input type=\"radio\" disabled=\"\"> Alarm Then Reset Replacement Fall Detection Unit to Enroll</label></div></td></tr><tr ng-repeat=\"fallDetection in vm.fallDetectionEnrollment\"><td><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.formData.fall_detection\" ng-value=\"fallDetection\"> {{fallDetection.serial_number}}</label></div></td><td>{{fallDetection.device_data.device_description}}</td></tr><tr ng-if=\"vm.selectedResident.fall_detection\"><td><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.formData.fall_detection\" ng-value=\"vm.selectedResident.fall_detection\"> Keep Existing Fall Detection Unit, Serial: {{vm.selectedResident.fall_detection.serial_number}}</label></div></td><td>Existing Fall Detection Unit</td></tr><tr ng-if=\"vm.selectedResident.fall_detection\"><td colspan=\"2\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.formData.fall_detection\" ng-value=\"null\"> Remove Existing Fall Detection Unit</label></div></td></tr><tr ng-if=\"!vm.selectedResident.fall_detection\"><td colspan=\"2\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.formData.fall_detection\" ng-value=\"null\"> Do Not Assign a Fall Detection Unit</label></div></td></tr></tbody></table></wz-step><wz-step wz-disabled=\"{{!vm.systemLicense.wanderer_monitoring || (vm.formData.door_access_permission == 3 && !vm.userAuth.data.system_license.allegion_active)}}\" wz-title=\"Wanderer Transmitter\"><h4>Enroll a Wanderer Transmitter</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th>Serial Number</th><th>Battery Status</th><th>Usage</th><th>Currently Assigned</th></tr></thead><tbody><tr ng-if=\"!vm.wandererTransmitterEnrollment.length\"><td colspan=\"4\"><div class=\"radio\"><label><input type=\"radio\" disabled=\"\"> Place Transmitter on Enrollment Station to Enroll</label></div></td></tr><tr ng-repeat=\"transmitter in vm.wandererTransmitterEnrollment\"><td><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.formData.wanderer_transmitter\" ng-value=\"transmitter\" ng-disabled=\"transmitter.battery_low || transmitter.assigned\" ng-click=\"vm.disableDoorAccess()\"> {{transmitter.serial_number}}</label></div></td><td ng-class=\"{\'text-danger\':transmitter.battery_low}\">{{(transmitter.battery_low ? \"Low\" : \"Good\")}}</td><td>{{transmitter.days_in_use | number:0}} Days Active</td><td ng-class=\"{\'text-danger\':transmitter.assigned}\">{{(transmitter.assigned ? transmitter.resident_name : \"Not Assigned\")}}</td></tr><tr ng-if=\"vm.selectedResident.wanderer_transmitter\"><td colspan=\"4\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.formData.wanderer_transmitter\" ng-value=\"vm.selectedResident.wanderer_transmitter\"> Keep Existing Wanderer Transmitter, Serial: {{vm.selectedResident.wanderer_transmitter.serial_number}}</label></div></td></tr><tr ng-if=\"vm.selectedResident.wanderer_transmitter\"><td colspan=\"4\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.formData.wanderer_transmitter\" ng-value=\"null\"> Remove Existing Wanderer Transmitter</label></div></td></tr><tr ng-if=\"!vm.selectedResident.wanderer_transmitter\"><td colspan=\"4\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.formData.wanderer_transmitter\" ng-value=\"null\"> Do Not Assign a Wanderer Transmitter</label></div></td></tr></tbody></table></wz-step><wz-step wz-disabled=\"{{(!vm.systemLicense.access_control && !vm.systemLicense.wanderer_monitoring) || vm.formData.wanderer_transmitter != null}}\" wz-title=\"Door Access\" canexit=\"vm.stepDoorValid\"><h4>Resident Door Access</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Door Access Level</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"vm.formData.door_access_permission\" ng-options=\"item.id as item.name for item in vm.doorPermissions\" ng-change=\"vm.doorAccessChange()\"></select></div></div><div ng-if=\"vm.formData.door_access_permission == 3\"><div class=\"form-group\"><label class=\"control-label col-sm-2\">Keycard Number</label><div class=\"col-sm-10\"><input type=\"number\" ignore-mouse-number=\"\" name=\"keycard\" class=\"form-control\" ng-model=\"vm.formData.resident_door_access.keycard\" validate-on=\"dirty\" validator=\"vm.validateKeycard(vm.formData.resident_door_access.keycard)\" invalid-message=\"vm.validateKeycardMsg(vm.formData.resident_door_access.keycard)\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Enrolled Keycard</label><div class=\"col-sm-10\"><div class=\"input-group search-box\"><input type=\"text\" ng-disabled=\"true\" placeholder=\"Present Card at Enrollment Station to Enroll\" ignore-mouse-number=\"\" name=\"rawcard\" class=\"form-control\" ng-model=\"vm.formData.resident_door_access.raw_card_data\" validate-on=\"dirty\" validator=\"vm.validateRawCard(vm.formData.resident_door_access.raw_card_data)\" invalid-message=\"vm.validateRawCardMsg(vm.formData.resident_door_access.raw_card_data)\"><div class=\"input-group-btn align-top\"><button class=\"btn\" type=\"button\" ng-click=\"vm.formData.resident_door_access.raw_card_data = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Keypad Code</label><div class=\"col-sm-10\"><input type=\"number\" ignore-mouse-number=\"\" name=\"keypad\" class=\"form-control\" ng-model=\"vm.formData.resident_door_access.keypad\" validate-on=\"dirty\" validator=\"vm.validateKeypad(vm.formData.resident_door_access.keypad)\" invalid-message=\"vm.validateKeypadMsg(vm.formData.resident_door_access.keypad)\"></div></div><div class=\"form-group\" ng-if=\"!vm.userAuth.data.system_license.allegion_active\"><label class=\"control-label col-sm-2\">Quantum Access Groups</label><div class=\"col-sm-10\"><ui-select name=\"door_access_groups\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.resident_door_access.door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.userAuth.data.system_license.allegion_active && vm.formData.wanderer_transmitter == null\"><label class=\"control-label col-sm-2\">Quantum Access Groups</label><div class=\"col-sm-10\"><ui-select name=\"door_access_groups\" multiple=\"\" ng-model=\"vm.formData.resident_door_access.door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.formData.wanderer_transmitter == null\"><label class=\"control-label col-sm-2\">Quantum Access Schedules</label><div class=\"col-sm-10\" ng-class=\"{\'has-error\': !vm.validateDoorSchedule() && vm.form.door_access_schedules.$dirty}\"><ui-select name=\"door_access_schedules\" multiple=\"\" ng-model=\"vm.formData.resident_door_access.schedules\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessSchedules | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select><label ng-if=\"!vm.validateDoorSchedule() && vm.form.door_access_schedules.$dirty\" class=\"control-label\">This field is required.</label></div></div><div class=\"form-group\" ng-if=\"vm.userAuth.data.system_license.allegion_active\"><label class=\"control-label col-sm-2\">Allegion Access Groups</label><div class=\"col-sm-10\"><ui-select name=\"allegion_door_access_groups\" multiple=\"\" ng-model=\"vm.formData.resident_door_access.allegion_door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.allegionAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.userAuth.data.system_license.allegion_active\"><label class=\"control-label col-sm-2\">Allegion Room Access</label><div class=\"col-sm-10\">This Resident Will Always Have Access to Any Locks Assigned to Their Apartment</div></div></div></wz-step><wz-step wz-title=\"Review Resident\"><h4>Review Resident Information</h4><div ng-show=\"vm.deviceAssignmentValidation()\" class=\"alert alert-danger\"><h4>No Devices Assigned</h4>Please Assign a Call Button, Fall Detection Unit, or Wanderer Transmitter</div><table class=\"table\"><thead><tr><th>Information Type</th><th>Previous Information</th><th>Submitted Information</th></tr></thead><tbody><tr><td>Resident Name</td><td>{{vm.selectedResident.first_name}} {{vm.selectedResident.last_name}}</td><td>{{vm.formData.first_name}} {{vm.formData.last_name}}</td></tr><tr><td>Apartment</td><td><span ng-repeat=\"item in vm.apartmentData | findObject:vm.selectedResident.apartment\">{{item.name}}</span></td><td><span ng-repeat=\"item in vm.apartmentData | findObject:vm.formData.apartment\">{{item.name}}</span></td></tr><tr><td>Escalation Groups</td><td><span ng-repeat=\"item in vm.escalationData | objectIdSearch:vm.selectedResident.escalations\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td><td><span ng-repeat=\"item in vm.escalationData | objectIdSearch:vm.formData.escalations\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.supervisory_escalation\"><td>Supervisory Escalation</td><td><span ng-repeat=\"item in vm.escalationData | findObject:vm.selectedResident.supervisory_escalation\">{{item.name}}</span></td><td><span ng-repeat=\"item in vm.escalationData | findObject:vm.formData.supervisory_escalation\">{{item.name}}</span></td></tr><tr ng-if=\"vm.formData.care_plan\"><td>Supervisory Escalation</td><td><span ng-repeat=\"item in vm.carePlans | findObject:vm.selectedResident.care_plan\">{{item.name}}</span></td><td><span ng-repeat=\"item in vm.carePlans | findObject:vm.formData.care_plan\">{{item.name}}</span></td></tr><tr><td>Resident Phone Number</td><td><span ng-if=\"!vm.selectedResident.phone_number\">Not Provided</span>{{vm.selectedResident.phone_number}}</td><td><span ng-if=\"!vm.formData.phone_number\">Not Provided</span>{{vm.formData.phone_number}}</td></tr><tr><td>Resident Notes</td><td><span ng-if=\"!vm.selectedResident.notes\">Not Provided</span>{{vm.selectedResident.notes}}</td><td><span ng-if=\"!vm.formData.notes\">Not Provided</span>{{vm.formData.notes}}</td></tr><tr><td>Call Button</td><td>{{(vm.selectedResident.call_button ? \"Serial: \" + vm.selectedResident.call_button.serial_number : \"Not Assigned\")}}</td><td>{{(vm.formData.call_button ? \"Serial: \" + vm.formData.call_button.serial_number : \"Not Assigned\")}} <span ng-if=\"vm.formData.call_button.pti == 93 && vm.formData.call_button.fall_active\">(Fall Detection Active)</span><span ng-if=\"vm.formData.call_button.pti == 93 && !vm.formData.call_button.fall_active\">(Fall Detection Inactive)</span></td></tr><tr ng-if=\"vm.systemLicense.fall_detection\"><td>Fall Detection Unit</td><td>{{(vm.selectedResident.fall_detection ? \"Serial: \" + vm.selectedResident.fall_detection.serial_number : \"Not Assigned\")}}</td><td>{{(vm.formData.fall_detection ? \"Serial: \" + vm.formData.fall_detection.serial_number : \"Not Assigned\")}}</td></tr><tr><td>Wanderer Transmitter</td><td>{{(vm.selectedResident.wanderer_transmitter ? \"Serial: \" + vm.selectedResident.wanderer_transmitter.serial_number : \"Not Assigned\")}}</td><td>{{(vm.formData.wanderer_transmitter ? \"Serial: \" + vm.formData.wanderer_transmitter.serial_number : \"Not Assigned\")}}</td></tr><tr ng-if=\"vm.formData.door_access_permission == 3 && !vm.formData.wanderer_transmitter\"><td>Keycard Number</td><td>{{(vm.selectedResident.resident_door_access.keycard ? vm.selectedResident.resident_door_access.keycard : \"Not Provided\")}}</td><td>{{(vm.formData.resident_door_access.keycard ? vm.formData.resident_door_access.keycard : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_permission == 3 && !vm.formData.wanderer_transmitter\"><td>Enrolled Keycard</td><td>{{(vm.selectedResident.resident_door_access.raw_card_data ? \"Enrolled\" : \"Not Provided\")}}</td><td>{{(vm.formData.resident_door_access.raw_card_data ? \"Enrolled\" : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_permission == 3 && !vm.formData.wanderer_transmitter\"><td>Keypad Code</td><td>{{(vm.selectedResident.resident_door_access.keypad ? vm.selectedResident.resident_door_access.keypad : \"Not Provided\")}}</td><td>{{(vm.formData.resident_door_access.keypad ? vm.formData.resident_door_access.keypad : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_permission == 3 && !vm.formData.wanderer_transmitter\"><td>Quantum Door Access Groups</td><td><span ng-if=\"!vm.selectedResident.resident_door_access.door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessGroups | objectIdSearch:vm.selectedResident.resident_door_access.door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td><td><span ng-if=\"!vm.formData.resident_door_access.door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessGroups | objectIdSearch:vm.formData.resident_door_access.door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_permission == 3 && !vm.formData.wanderer_transmitter\"><td>Quantum Door Access Schedules</td><td><span ng-if=\"!vm.selectedResident.resident_door_access.schedules.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessSchedules | objectIdSearch:vm.selectedResident.resident_door_access.schedules\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td><td><span ng-if=\"!vm.formData.resident_door_access.schedules.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessSchedules | objectIdSearch:vm.formData.resident_door_access.schedules\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_permission == 3 && !vm.formData.wanderer_transmitter && vm.userAuth.data.system_license.allegion_active\"><td>Allegion Access Groups</td><td><span ng-if=\"!vm.selectedResident.resident_door_access.allegion_door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.allegionAccessGroups | objectIdSearch:vm.selectedResident.resident_door_access.allegion_door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td><td><span ng-if=\"!vm.formData.resident_door_access.allegion_door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.allegionAccessGroups | objectIdSearch:vm.formData.resident_door_access.allegion_door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_permission == 1 || vm.formData.wanderer_transmitter\"><td>Door Access</td><td>{{vm.selectedResident.door_access_permission == 1 ? \"Not Assigned\":(vm.selectedResident.door_access_permission == 2 ? \"Family Access Only\":\"Assigned\")}}</td><td>Not Assigned</td></tr><tr ng-if=\"vm.formData.door_access_permission == 2 && !vm.formData.wanderer_transmitter\"><td>Door Access</td><td>{{vm.selectedResident.door_access_permission == 1 ? \"Not Assigned\":(vm.selectedResident.door_access_permission == 2 ? \"Family Access Only\":\"Assigned\")}}</td><td>Family Access Only</td></tr></tbody></table></wz-step></form></wizard>");
$templateCache.put("app/resident/resident-discharge.html","<wizard on-finish=\"vm.submitDischargeWizard()\" name=\"resident\" header-text=\"Discharge a Resident\" header-icon=\"fa-user\" ladda-enabled=\"vm.ladda\" disable-submit=\"vm.deviceAssignmentValidation()\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Resident\" canexit=\"vm.stepSelectValid\"><h4 ng-if=\"vm.initalLoadComplete\">Select a Resident</h4><h4 ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i> Loading...</h4><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control ng-pristine ng-valid ng-touched\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><p class=\"text-danger\" ng-if=\"(vm.selector == false) && vm.selectStepSubmitted\">Resident selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Resident Name</th><th>Apartment</th></tr></thead><tbody><tr dir-paginate=\"resident in vm.filteredResidents = (vm.existingResidents | apartmentSearch:vm.apartmentData | filter:vm.searchFilter | itemsPerPage:10)\"><td ng-class=\"{\'has-error\':((vm.selector == false) && vm.selectStepSubmitted)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"resident_selector\" ng-model=\"vm.selector\" ng-value=\"resident\" ng-click=\"vm.loadSelectedData(resident)\"> {{resident.first_name}} {{resident.last_name}}</label></div></td><td>{{resident.apartment_name}}</td></tr><tr ng-hide=\"vm.existingResidents.length\"><td colspan=\"2\">No Residents Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredResidents.length}} of {{vm.existingResidents.length}} Residents</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></wz-step><wz-step wz-title=\"Review Resident\"><h4>Review Resident to Discharge</h4><div ng-if=\"vm.deviceAssignmentValidation()\" class=\"alert alert-danger\"><h4>No Devices Assigned</h4>Please Assign a Call Button, Fall Detection Unit, or Wanderer Transmitter</div><table class=\"table\"><thead><tr><th>Information Type</th><th>Submitted Information</th></tr></thead><tbody><tr><td>Resident Name</td><td>{{vm.selectedResident.first_name}} {{vm.selectedResident.last_name}}</td></tr><td>Apartment</td><td><span ng-repeat=\"item in vm.apartmentData | findObject:vm.selectedResident.apartment\">{{item.name}}</span></td><tr><td>Escalation Groups</td><td><span ng-repeat=\"item in vm.escalationData | objectIdSearch:vm.selectedResident.escalations\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.supervisory_escalation\"><td>Supervisory Escalation</td><td><span ng-repeat=\"item in vm.escalationData | findObject:vm.formData.supervisory_escalation\">{{item.name}}</span></td></tr><tr ng-if=\"vm.formData.care_plan\"><td>Care Plan</td><td><span ng-repeat=\"item in vm.carePlans | findObject:vm.formData.care_plan\">{{item.name}}</span></td></tr><tr><td>Resident Phone Number</td><td><span ng-if=\"!vm.selectedResident.phone_number\">Not Provided</span>{{vm.selectedResident.phone_number}}</td></tr><tr><td>Notes</td><td><span ng-if=\"!vm.selectedResident.notes\">Not Provided</span>{{vm.selectedResident.notes}}</td></tr><tr><td>Call Button</td><td>{{(vm.selectedResident.call_button ? \"Serial: \" + vm.selectedResident.call_button.serial_number : \"Not Assigned\")}}</td></tr><tr ng-if=\"vm.systemLicense.fall_detection\"><td>Fall Detection Unit</td><td>{{(vm.selectedResident.fall_detection ? \"Serial: \" + vm.selectedResident.fall_detection.serial_number : \"Not Assigned\")}}</td></tr><tr><td>Wanderer Transmitter</td><td>{{(vm.selectedResident.wanderer_transmitter ? \"Serial: \" + vm.selectedResident.wanderer_transmitter.serial_number : \"Not Assigned\")}}</td></tr><tr ng-if=\"vm.selectedResident.door_access_permission == 3\"><td>Keycard Number</td><td>{{(vm.selectedResident.resident_door_access.keycard ? vm.selectedResident.resident_door_access.keycard : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.selectedResident.door_access_permission == 3\"><td>Enrolled Keycard</td><td>{{(vm.selectedResident.resident_door_access.raw_card_data ? \"Enrolled\" : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.selectedResident.door_access_permission == 3\"><td>Keypad Code</td><td>{{(vm.selectedResident.resident_door_access.keypad ? vm.selectedResident.resident_door_access.keypad : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.selectedResident.door_access_permission == 3\"><td>Door Access Groups</td><td><span ng-if=\"!vm.selectedResident.resident_door_access.door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessGroups | objectIdSearch:vm.selectedResident.resident_door_access.door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.selectedResident.door_access_permission == 3\"><td>Door Access Schedules</td><td><span ng-if=\"!vm.selectedResident.resident_door_access.schedules.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessSchedules | objectIdSearch:vm.selectedResident.resident_door_access.schedules\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.selectedResident.door_access_permission == 3 vm.userAuth.data.system_license.allegion_active\"><td>Allegion Access Groups</td><td><span ng-if=\"vm.selectedResident.resident_door_access.allegion_door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.allegionAccessGroups | objectIdSearch:vm.selectedResident.resident_door_access.allegion_door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.selectedResident.door_access_permission == 1\"><td>Door Access</td><td>Not Assigned</td></tr><tr ng-if=\"vm.selectedResident.door_access_permission == 2\"><td>Door Access</td><td>Family Access Only</td></tr></tbody></table></wz-step></form></wizard>");
$templateCache.put("app/resident-insight/resident-insight.html","<div class=\"pull-right\" ng-if=\"vm.userAuth.data.system_license.care_package\"><span ng-if=\"vm.loading\"><i class=\"fa fa-spin fa-spinner\"></i></span> <span style=\"cursor: pointer; padding: 5px 10px; border: 1px solid #ccc\"><i class=\"fa fa-calendar\"></i> <input ng-change=\"vm.getData()\" type=\"daterange\" readonly=\"true\" datepicker-options=\"vm.datepickerOptions\" ng-model=\"vm.date\" style=\"cursor: pointer; padding: 5px 10px; border: 0px solid #ccc; width:195px\"><b class=\"caret\" style=\"margin-left: -10px\"></b></span></div><div class=\"box-cont\" ng-if=\"vm.userAuth.data.system_license.care_package\"><div class=\"cover-high\" ng-show=\"!vm.totalArray(vm.reportData.level_totals)\">No Care Reported</div><div class=\"box\" ng-if=\"vm.reportData\"><div class=\"box-title\"><h3><i class=\"fa\" ng-class=\"{ \'fa-lightbulb-o\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=\"vm.initalLoadComplete\">Insights for {{vm.reportData.meta_data.name}}</span><span ng-if=\"!vm.initalLoadComplete\">Loading...</span></h3></div><div class=\"box-content nopadding\"><div class=\"col-md-3\"><div class=\"actions\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a uib-dropdown-toggle=\"\"><h5><span ng-if=\"vm.showCaresPie\">Care Details</span><span ng-if=\"!vm.showCaresPie\">Care Levels</span> <span class=\"caret\"></span></h5></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a href=\"#\" ng-click=\"vm.showCaresPie = false\">Care Levels</a></li><li><a href=\"#\" ng-click=\"vm.showCaresPie = true\">Care Details</a></li></ul></div><canvas ng-if=\"!vm.showCaresPie\" id=\"doughnut\" class=\"chart chart-doughnut\" chart-data=\"vm.reportData.level_totals\" chart-labels=\"vm.reportData.level_labels\" chart-options=\"{legend:{display:true, position: \'bottom\'}}\"></canvas><canvas ng-if=\"vm.showCaresPie\" id=\"doughnut\" class=\"chart chart-doughnut\" chart-data=\"vm.reportData.care_count\" chart-labels=\"vm.reportData.care_labels\" chart-options=\"{legend:{display:true, position: \'bottom\'}}\"></canvas></div><div class=\"col-md-6\"><h5>Cares By Day</h5><canvas id=\"doughnut\" class=\"chart chart-bar\" chart-data=\"vm.reportData.dailyChartData\" chart-dataset-override=\"vm.chartOverrides\" chart-labels=\"vm.reportData.date_label\" chart-options=\"{legend:{display:true, position: \'bottom\'}, scales: {yAxes: [{ticks: {beginAtZero: true}}]}}\"></canvas></div><div class=\"col-md-3\"><h5>Care Details</h5><div class=\"row insight-padding\"><div class=\"col-md-6 insight-container\"><div class=\"insight-content\"><div class=\"insight-text\"><span ng-if=\"vm.initalLoadComplete\">{{vm.reportData.meta_data.care_plan}}</span><span ng-if=\"!vm.initalLoadComplete\"><h2><i class=\"fa fa-spin fa-spinner\"></i></h2></span><h4>Care Plan</h4></div></div></div><div class=\"col-md-6 insight-container\"><div class=\"insight-content\"><div class=\"insight-text\"><span ng-if=\"vm.initalLoadComplete\"><h2>{{vm.totalArray(vm.reportData.level_totals)}}</h2></span><span ng-if=\"!vm.initalLoadComplete\"><h2><i class=\"fa fa-spin fa-spinner\"></i></h2></span><h4>Total Cares</h4></div></div></div></div><h5>Most Active</h5><div class=\"row insight-padding\"><div class=\"col-md-6 insight-container\"><div class=\"insight-content\"><div class=\"insight-text\"><span ng-if=\"vm.initalLoadComplete\">{{vm.higestFromArrays(vm.reportData.level_totals, vm.reportData.level_labels)}}</span><span ng-if=\"!vm.initalLoadComplete\"><h2><i class=\"fa fa-spin fa-spinner\"></i></h2></span><h4>Care Level</h4></div></div></div><div class=\"col-md-6 insight-container\"><div class=\"insight-content\"><div class=\"insight-text\"><span ng-if=\"vm.initalLoadComplete\">{{vm.higestFromArrays(vm.reportData.care_count, vm.reportData.care_labels)}}</span><span ng-if=\"!vm.initalLoadComplete\"><h2><i class=\"fa fa-spin fa-spinner\"></i></h2></span><h4>Care Provided</h4></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><h4>Care Plan Events</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th>Date</th><th>Care Level</th><th>Event Type</th><th>Total Cares</th><th>Care Threshold</th></tr></thead><tbody><tr dir-paginate=\"event in vm.filteredEvents = (vm.reportData.care_plan_summary | itemsPerPage:15)\"><td>{{event.created_date | date:\'mediumDate\'}}</td><td>{{vm.levelById(event.care_plan_level)}}</td><td>{{vm.warningById(event.warning_type)}}</td><td>{{event.number_of_cares}}</td><td>{{event.threshold}}</td></tr><tr ng-if=\"!vm.filteredEvents.length\"><td colspan=\"5\">No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredEvents.length}} of {{vm.reportData.care_plan_summary.length}} Events</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><h4>Resident Information</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Resident Name</td><td>{{vm.residentData.first_name}} {{vm.residentData.last_name}}</td></tr><tr><td>Apartment</td><td>{{vm.reportData.meta_data.apartment}}</td></tr><tr><td>Area</td><td>{{vm.reportData.meta_data.area}}</td></tr><tr><td>Escalations</td><td>{{vm.reportData.meta_data.escalation.join(\", \")}}</td></tr><tr><td>Date Admitted</td><td>{{vm.reportData.meta_data.date_entered | date:\"medium\"}}</td></tr><tr><td>Notes</td><td>{{vm.residentData.notes ? vm.residentData.notes : \"None\"}}</td></tr><tr><td>Phone Number</td><td>{{vm.residentData.phone_number ? vm.residentData.phone_number : \"None\"}}</td></tr><tr><td>In Leave</td><td>{{vm.residentData.leave_status ? \"Yes\":\"No\"}}</td></tr></tbody></table></div><div class=\"col-md-6\"><h4>Call Button</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th>Device Type</th><th>Serial Number</th></tr></thead><tbody><tr ng-if=\"vm.residentData.call_button\"><td><i class=\"fa fa-question-circle\" style=\"color: #e51400\" ng-if=\"vm.residentData.call_button.missing\"></i> <i class=\"fa fa-battery-quarter\" style=\"color: #e51400\" ng-if=\"vm.residentData.call_button.low_battery\"></i> Call Button</td><td>{{vm.residentData.call_button.serial_number}}</td></tr><tr ng-if=\"!vm.residentData.call_button\"><td colspan=\"2\">No Results Found</td></tr></tbody></table><h4>Fall Detection</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th>Device Type</th><th>Serial Number</th></tr></thead><tbody><tr ng-if=\"vm.residentData.fall_detection\"><td><i class=\"fa fa-question-circle\" style=\"color: #e51400\" ng-if=\"vm.residentData.fall_detection.missing\"></i> <i class=\"fa fa-battery-quarter\" style=\"color: #e51400\" ng-if=\"vm.residentData.fall_detection.low_battery\"></i> Fall Detection Unit</td><td>{{vm.residentData.fall_detection.serial_number}}</td></tr><tr ng-if=\"!vm.residentData.fall_detection\"><td colspan=\"2\">No Results Found</td></tr></tbody></table><h4>Wanderer Transmitter</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th>Device Type</th><th>Serial Number</th><th>Days Active</th></tr></thead><tbody><tr ng-if=\"vm.residentData.wanderer_transmitter\"><td><i class=\"fa fa-question-circle\" style=\"color: #e51400\" ng-if=\"vm.residentData.wanderer_transmitter.missing\"></i> <i class=\"fa fa-battery-quarter\" style=\"color: #e51400\" ng-if=\"vm.residentData.wanderer_transmitter.low_battery\"></i> Wanderer Transmitter</td><td>{{vm.residentData.wanderer_transmitter.serial_number}}</td><td>{{vm.residentData.wanderer_transmitter.days_in_use | number:0}}</td></tr><tr ng-if=\"!vm.residentData.wanderer_transmitter\"><td colspan=\"2\">No Results Found</td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-md-6\"><h4>Door Access</h4><table class=\"table table-hover table-nomargin\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Door Access</td><td>{{vm.residentData.door_access_permission == 1 ? \"Not Permitted\":(vm.residentData.door_access_permission == 2 ? \"Family Access Only\":\"Permitted\")}}</td></tr><tr ng-if=\"vm.residentData.door_access_permission == 3\"><td>Keycard Code</td><td>{{vm.residentData.resident_door_access.keycard}}</td></tr><tr ng-if=\"vm.residentData.door_access_permission == 3\"><td>Keypad Code</td><td>{{vm.residentData.resident_door_access.keypad}}</td></tr><tr ng-if=\"vm.residentData.door_access_permission == 3\"><td>Enrolled Keycard</td><td>{{vm.residentData.resident_door_access.raw_card_data ? \"Enrolled\" : \"Not Enrolled\"}}</td></tr><tr ng-if=\"vm.residentData.door_access_permission == 3\"><td>Door Access Groups</td><td><span ng-repeat=\"item in vm.doorAccessGroups | objectIdSearch:vm.residentData.resident_door_access.door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.residentData.door_access_permission == 3\"><td>Access Schedules</td><td><span ng-repeat=\"item in vm.doorAccessSchedules | objectIdSearch:vm.residentData.resident_door_access.schedules\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr></tbody></table></div><div class=\"col-md-6\"><h4>Associated Family</h4><table class=\"table table-nomargin\"><thead><tr><th>Name</th><th>Bypass Permission</th><th>Keycard Code</th><th>Enrolled Code</th><th>Keypad Code</th></tr></thead><tbody><tr dir-paginate=\"family in vm.associatedFamily | itemsPerPage:10\" pagination-id=\"\'family\'\"><td>{{family.first_name}} {{family.last_name}}</td><td>{{family.resident_bypass_allowed ? \"Yes\":\"No\"}}</td><td>{{family.keypad ? family.keypad : \"None\"}}</td><td>{{family.raw_card_data ? \"Enrolled\" : \"Not Enrolled\"}}</td><td>{{family.keycard ? family.keycard : \"None\"}}</td></tr><tr><td colspan=\"2\" ng-if=\"!vm.associatedFamily.length\">No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\"></div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\" pagination-id=\"\'family\'\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/resident-scheduled-leave/resident-scheduled-leave-create.html","<wizard on-finish=\"vm.submitCreate()\" name=\"scheduleCreate\" header-text=\"Resident Scheduled Leave\" header-icon=\"fa-calendar\" ladda-enabled=\"vm.ladda\" disable-submit=\"\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Schedule\" canexit=\"vm.stepScheduleValid\"><h4>Select Schedule</h4><input name=\"timeInterval\" ng-change=\"vm.scheduleChange()\" ng-model-options=\"{ debounce: 100 }\" placeholder=\"Select a Time Range Below\" type=\"daterange\" readonly=\"true\" opens=\"embed\" ng-model=\"vm.date\" class=\"form-control\" datepicker-options=\"vm.datepickerOptions\"></wz-step><wz-step wz-title=\"Select Residents\" canexit=\"vm.stepResidentsValid\"><h4>Select Residents</h4><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control ng-pristine ng-valid ng-touched\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><p class=\"text-danger\" ng-if=\"(!vm.formData.residents.length) && vm.selectStepSubmitted\">Resident selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Resident Name</th><th>Apartment</th></tr></thead><tbody><tr dir-paginate=\"resident in vm.filteredResidents = (vm.residents | apartmentSearch:vm.apartmentData | filter:vm.searchFilter | itemsPerPage:10)\"><td ng-class=\"{\'has-error\':(!vm.formData.residents.length && vm.selectStepSubmitted)}\"><label class=\"radio\"><input type=\"checkbox\" checklist-model=\"vm.formData.residents\" checklist-value=\"resident.id\"> {{resident.first_name}} {{resident.last_name}}</label></td><td>{{resident.apartment_name}}</td></tr><tr ng-hide=\"vm.filteredResidents.length\"><td colspan=\"2\">No Residents Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredResidents.length}} of {{vm.residents.length}} Residents</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></wz-step><wz-step wz-title=\"Review Leave\"><h4>Review Leave</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Start Date:</strong></label> <span class=\"col-sm-10\">{{vm.formData.start_date | date : \'medium\'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>End Date:</strong></label> <span class=\"col-sm-10\">{{vm.formData.end_date | date : \'medium\'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Residents Selected:</strong></label> <span class=\"col-sm-10\" ng-repeat=\"resident in vm.residents | objectIdSearch:vm.formData.residents\">{{resident.first_name}} {{resident.last_name}}{{$last ? \'\' : \', \'}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/resident-scheduled-leave/resident-scheduled-leave-remove.html","<wizard on-finish=\"vm.submitRemove()\" name=\"scheduleCreate\" header-text=\"Remove A Scheduled Leave\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Schedule\" canexit=\"vm.stepSelectValid\"><h4>Select a Schedule</h4><p class=\"text-danger\" ng-if=\"!vm.selector && vm.form.group_selector.$dirty\">Schedule selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Resident Name</th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules\"><td ng-class=\"{\'has-error\':(!vm.selector && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"schedule\"> <span ng-repeat=\"resident in vm.residents | findObject:schedule.resident_id\">{{resident.first_name}} {{resident.last_name}}</span></label></div></td><td>{{schedule.start_date | date:\'medium\'}}</td><td>{{schedule.end_date | date:\'medium\'}}</td></tr><tr ng-hide=\"vm.schedules.length\"><td colspan=\"2\">No Schedules Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Schedule\"><h4>Review Leave</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Resident Name Name</strong></label> <span class=\"col-sm-10\"><span ng-repeat=\"resident in vm.residents | findObject:vm.selector.resident_id\">{{resident.first_name}} {{resident.last_name}}</span></span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Start Time</strong></label> <span class=\"col-sm-10\">{{vm.selector.start_date | date :\'medium\'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>End Time</strong></label> <span class=\"col-sm-10\">{{vm.selector.end_date | date :\'medium\'}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/resident-transmitter-power/resident-transmitter-power.html","<wizard on-finish=\"vm.submitWizard()\" name=\"wizard\" header-text=\"Turn Off Wanderer Transmitter\" header-icon=\"fa-wifi\" ladda-enabled=\"vm.ladda\" disable-submit=\"\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Transmitter\" canexit=\"vm.stepOneValid\"><h4>Select Wanderer Transmitter</h4><p class=\"text-danger\" ng-if=\"(vm.formData.wanderer_transmitter == null) && vm.selectStepSubmitted\">Transmitter selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Serial Number</th><th>Battery Status</th><th>Usage</th><th>Currently Assigned</th></tr></thead><tbody><tr ng-if=\"!vm.countActiveTransmitters(vm.wandererTransmitterEnrollment)\"><td colspan=\"4\"><div class=\"radio\"><label><input type=\"radio\" disabled=\"\"> Place Transmitter on Enrollment Station to Power Off</label></div></td></tr><tr ng-repeat=\"transmitter in vm.wandererTransmitterEnrollment\" ng-if=\"!transmitter.turn_off_complete\"><td><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.formData.wanderer_transmitter\" ng-value=\"transmitter\" ng-disabled=\"transmitter.assigned\"> {{transmitter.serial_number}}</label></div></td><td ng-class=\"{\'text-danger\':transmitter.battery_low}\">{{(transmitter.battery_low ? \"Low\" : \"Good\")}}</td><td>{{transmitter.days_in_use | number:0}} Days Active</td><td ng-class=\"{\'text-danger\':transmitter.assigned}\">{{(transmitter.assigned ? transmitter.resident_name : \"Not Assigned\")}}</td></tr></tbody></table></wz-step><wz-step wz-title=\"Turn Off Transmitter\"><h4>Review Transmitter</h4><h4 ng-if=\"vm.ladda\"><i class=\"fa fa-spin fa-spinner\"></i> Transmitter Shutdown in Progress. Please leave transmitter on enrollment station.</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Transmitter Serial</strong></label> <span class=\"col-sm-10\">{{vm.formData.wanderer_transmitter.serial_number}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/resident-status/resident-status.html","<div class=\"pull-right\" style=\"padding-right: 5px;\"><button type=\"button\" class=\"btn\" ng-if=\"!vm.loading\" ng-csv=\"vm.cleanCsv()\" filename=\"{{vm.siteName}}_resident_status.csv\" csv-header=\"vm.csvHeaders\" lazy-load=\"true\">Save CSV</button></div><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa\" ng-class=\"{ \'fa-bars\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=\"vm.initalLoadComplete\">Resident Status</span><span ng-if=\"!vm.initalLoadComplete\">Loading...</span></h3></div><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.orderByKey = \'last_name\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Resident Name <span ng-show=\"vm.orderByKey == \'last_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'last_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'apartment_name\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Apartment <span ng-show=\"vm.orderByKey == \'apartment_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'apartment_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'alarmed\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Alarm Status <span ng-show=\"vm.orderByKey == \'alarmed\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'alarmed\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'call_button.serial_number\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Call Button <span ng-show=\"vm.orderByKey == \'call_button.serial_number\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'call_button.serial_number\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'fall_detection.serial_number\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Fall Detection <span ng-show=\"vm.orderByKey == \'fall_detection.serial_number\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'fall_detection.serial_number\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'wanderer_transmitter.serial_number\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Wanderer Transmitter <span ng-show=\"vm.orderByKey == \'wanderer_transmitter.serial_number\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'wanderer_transmitter.serial_number\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'resident_door_access.keypad\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Keypad Code <span ng-show=\"vm.orderByKey == \'resident_door_access.keypad\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'resident_door_access.keypad\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'resident_door_access.keycard\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Keycard Code <span ng-show=\"vm.orderByKey == \'resident_door_access.keycard\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'resident_door_access.keycard\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'resident_door_access.keycard\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Enrolled Keycard <span ng-show=\"vm.orderByKey == \'resident_door_access.raw_card_data\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'resident_door_access.raw_card_data\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'leave_status\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Leave Status <span ng-show=\"vm.orderByKey == \'leave_status\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'leave_status\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'location\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Last Known Location <span ng-show=\"vm.orderByKey == \'location\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'location\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'location_time\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Located <span ng-show=\"vm.orderByKey == \'location_time\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'location_time\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr dir-paginate=\"resident in vm.filteredResidents = (vm.residents | apartmentSearch:vm.apartments | filter:vm.searchFilter | orderBy:\'+\':vm.orderReverse | itemsPerPage:15)\"><td><a ng-href=\"/resident-insight/{{resident.id}}\">{{resident.first_name}} {{resident.last_name}}</a></td><td>{{resident.apartment_name}}</td><td ng-class=\"{\'text-danger\':resident.alarmed}\">{{resident.alarmed ? \"Alarm\" : \"Clear\"}}</td><td><i class=\"fa fa-question-circle\" style=\"color: #e51400\" ng-if=\"resident.call_button.missing\"></i> <i class=\"fa fa-battery-quarter\" style=\"color: #e51400\" ng-if=\"resident.call_button.low_battery\"></i> {{resident.call_button ? resident.call_button.serial_number : \"Not Assigned\" }}</td><td><i class=\"fa fa-question-circle\" style=\"color: #e51400\" ng-if=\"resident.fall_detection.missing\"></i> <i class=\"fa fa-battery-quarter\" style=\"color: #e51400\" ng-if=\"resident.fall_detection.low_battery\"></i> {{resident.fall_detection ? resident.fall_detection.serial_number : \"Not Assigned\" }}</td><td><i class=\"fa fa-question-circle\" style=\"color: #e51400\" ng-if=\"resident.wanderer_transmitter.missing\"></i> <i class=\"fa fa-battery-quarter\" style=\"color: #e51400\" ng-if=\"resident.wanderer_transmitter.low_battery\"></i>{{resident.wanderer_transmitter ? resident.wanderer_transmitter.serial_number : \"Not Assigned\" }}</td><td>{{resident.resident_door_access.keypad ? resident.resident_door_access.keypad : \"Not Assigned\"}}</td><td>{{resident.resident_door_access.keycard ? resident.resident_door_access.keycard : \"Not Assigned\"}}</td><td>{{resident.resident_door_access.raw_card_data ? \"Enrolled\" : \"Not Assigned\"}}</td><td ng-class=\"{\'text-danger\':resident.leave_status}\">{{resident.leave_status ? \"In Leave\" : \"Not in Leave\"}}</td><td>{{resident.location ? resident.location : \"Unknown\"}}</td><td>{{resident.location_time ? (resident.location_time | timeago) : \"Unknown\"}}</td></tr><tr><td colspan=\"11\" ng-if=\"!vm.filteredResidents.length && vm.initalLoadComplete\">No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredResidents.length}} of {{vm.residents.length}} Residents</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/schedule-check-in/schedule-check-in-change.html","<wizard on-finish=\"vm.submitChange()\" name=\"scheduleCreate\" header-text=\"Change A Check-In Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Schedule\" canexit=\"vm.stepSelectValid\"><h4>Select a Schedule</h4><p class=\"text-danger\" ng-if=\"(vm.scheduleLoaded == false) && vm.form.group_selector.$dirty\">Schedule selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Schedule Name</th><th>Schedule Active</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules\"><td ng-class=\"{\'has-error\':(!vm.scheduleLoaded && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-disabled=\"schedule.active\" ng-model=\"vm.selector\" ng-value=\"schedule\" ng-click=\"vm.loadSelectedData(schedule)\"> {{schedule.name}}</label></div></td><td>{{schedule.active ? \"Active\" : \"Inactive\"}}</td></tr><tr ng-hide=\"vm.schedules.length\"><td>No Schedules Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Schedule Information\" canexit=\"vm.stepInfoValid\"><h4>Schedule Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Schedule Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"door_group_name\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div></wz-step><wz-step wz-title=\"Add Intervals\"><h4 class=\"pull-left\">Schedule Intervals</h4><table class=\"table\"><thead><tr><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td><interval-picker interval=\"interval.start\" disable-day=\"true\"></interval-picker></td><td><interval-picker interval=\"interval.end\" disable-day=\"true\"></interval-picker></td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-check-in/schedule-check-in-create.html","<wizard on-finish=\"vm.submitCreate()\" name=\"scheduleCreate\" header-text=\"Create A Check-In Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Schedule Information\" canexit=\"vm.stepInfoValid\"><h4>Schedule Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Schedule Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"door_group_name\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div></wz-step><wz-step wz-title=\"Add Intervals\"><h4 class=\"pull-left\">Schedule Intervals</h4><table class=\"table\"><thead><tr><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td><interval-picker interval=\"interval.start\" disable-day=\"true\"></interval-picker></td><td><interval-picker interval=\"interval.end\" disable-day=\"true\"></interval-picker></td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-check-in/schedule-check-in-remove.html","<wizard on-finish=\"vm.submitRemove()\" name=\"scheduleCreate\" header-text=\"Remove A Check-In Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Schedule\" canexit=\"vm.stepSelectValid\"><h4>Select a Schedule</h4><p class=\"text-danger\" ng-if=\"(vm.scheduleLoaded == false) && vm.form.group_selector.$dirty\">Schedule selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Schedule Name</th><th>In Use</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules\"><td ng-class=\"{\'has-error\':(!vm.scheduleLoaded && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" ng-disabled=\"schedule.in_use\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"schedule\" ng-click=\"vm.loadSelectedData(schedule)\"> {{schedule.name}}</label></div></td><td>{{(schedule.in_use ? \"Yes\":\"No\")}}</td></tr><tr ng-hide=\"vm.schedules.length\"><td>No Schedules Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-onetime/schedule-onetime-access.html","<wizard on-finish=\"vm.submitCreate()\" name=\"scheduleCreate\" header-text=\"One Time Access Control Unlock Schedule\" header-icon=\"fa-calendar\" ladda-enabled=\"vm.ladda\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Schedule Info\" canexit=\"vm.stepInfoValid\"><h4>Schedule Info</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Description</label><div class=\"col-sm-10\"><input type=\"text\" name=\"scheduleName\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Wanderer Monitroing</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"vm.formData.wandering_enabled\" ng-options=\"item.value as item.lable for item in [{lable: \'Wanderer Monitoring Enabled\', value: true },{ lable: \'Wanderer Monitoring Disabled\', value: false }]\"></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Time Range</label><div class=\"col-sm-10\"><input name=\"timeInterval\" ng-change=\"vm.scheduleChange()\" ng-model-options=\"{ debounce: 100 }\" placeholder=\"Select a Time Range Below\" type=\"daterange\" readonly=\"true\" opens=\"embed\" ng-model=\"vm.date\" class=\"form-control\" datepicker-options=\"vm.datepickerOptions\"></div></div></wz-step><wz-step wz-title=\"Door Selection\" canexit=\"vm.stepDoorValid\"><h4>Select Door to Unlock</h4><p class=\"text-danger\" ng-if=\"!vm.formData.door_id && vm.form.group_selector.$dirty\">Door selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Door Name</th></tr></thead><tbody><tr ng-repeat=\"door in vm.doors\"><td ng-class=\"{\'has-error\':(!vm.formData.door_id && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.formData.door_id\" ng-value=\"door.id\" ng-click=\"vm.loadSelectedData(door)\"> {{door.name}}</label></div></td></tr><tr ng-hide=\"vm.doors.length\"><td>No Doors Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Schedule\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Wanderer Monitoring</strong></label> <span class=\"col-sm-10\">{{vm.formData.wandering_enabled ? \"Enabled\" : \"Disabled\"}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Start Time</strong></label> <span class=\"col-sm-10\">{{vm.formData.start_date | date : \'medium\'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>End Time</strong></label> <span class=\"col-sm-10\">{{vm.formData.end_date | date : \'medium\'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Selected Door</strong></label> <span class=\"col-sm-10\" ng-repeat=\"door in vm.doors | findObject:vm.formData.door_id\">{{door.name}}{{$last ? \'\' : \', \'}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-onetime/schedule-onetime-remove.html","<wizard on-finish=\"vm.submitRemove()\" name=\"scheduleCreate\" header-text=\"Remove A One Time Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Schedule\" canexit=\"vm.stepSelectValid\"><h4>Select a Schedule</h4><p class=\"text-danger\" ng-if=\"!vm.selector && vm.form.group_selector.$dirty\">Schedule selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Schedule Name</th><th>Door Name</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules\"><td ng-class=\"{\'has-error\':(!vm.selector && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"schedule\"> {{schedule.name}}</label></div></td><td>{{schedule.door_name}}</td></tr><tr ng-hide=\"vm.schedules.length\"><td colspan=\"2\">No Schedules Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Schedule\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name</strong></label> <span class=\"col-sm-10\">{{vm.selector.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Wanderer Monitoring</strong></label> <span class=\"col-sm-10\">{{vm.selector.wandering_enabled ? \"Enabled\" : \"Disabled\"}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Start Time</strong></label> <span class=\"col-sm-10\">{{vm.selector.start_date | date : \'medium\'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>End Time</strong></label> <span class=\"col-sm-10\">{{vm.selector.end_date | date : \'medium\'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Selected Door</strong></label> <span class=\"col-sm-10\">{{vm.selector.door_name}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-onetime/schedule-onetime-wanderer.html","<wizard on-finish=\"vm.submitCreate()\" name=\"scheduleCreate\" header-text=\"One Time Wanderer Door Lock Schedule\" header-icon=\"fa-calendar\" ladda-enabled=\"vm.ladda\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Schedule Info\" canexit=\"vm.stepInfoValid\"><h4>Schedule Info</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Description</label><div class=\"col-sm-10\"><input type=\"text\" name=\"scheduleName\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Time Range</label><div class=\"col-sm-10\"><input name=\"timeInterval\" ng-change=\"vm.scheduleChange()\" ng-model-options=\"{ debounce: 100 }\" placeholder=\"Select a Time Range Below\" type=\"daterange\" readonly=\"true\" opens=\"embed\" ng-model=\"vm.date\" class=\"form-control\" datepicker-options=\"vm.datepickerOptions\"></div></div></wz-step><wz-step wz-title=\"Door Selection\" canexit=\"vm.stepDoorValid\"><h4>Select Door to Lock</h4><p class=\"text-danger\" ng-if=\"!vm.formData.door_id && vm.form.group_selector.$dirty\">Door selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Door Name</th></tr></thead><tbody><tr ng-repeat=\"door in vm.doors\"><td ng-class=\"{\'has-error\':(!vm.formData.door_id && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.formData.door_id\" ng-value=\"door.id\" ng-click=\"vm.loadSelectedData(door)\"> {{door.name}}</label></div></td></tr><tr ng-hide=\"vm.doors.length\"><td>No Doors Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Schedule\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Wanderer Monitoring</strong></label> <span class=\"col-sm-10\">{{vm.formData.wandering_enabled ? \"Enabled\" : \"Disabled\"}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Start Time</strong></label> <span class=\"col-sm-10\">{{vm.formData.start_date | date : \'medium\'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>End Time</strong></label> <span class=\"col-sm-10\">{{vm.formData.end_date | date : \'medium\'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Selected Door</strong></label> <span class=\"col-sm-10\" ng-repeat=\"door in vm.doors | findObject:vm.formData.door_id\">{{door.name}}{{$last ? \'\' : \', \'}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-io-repeater/schedule-io-repeater-change.html","<wizard on-finish=\"vm.submitChange()\" name=\"scheduleCreate\" header-text=\"Change A Fixed Device Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Schedule\" canexit=\"vm.stepSelectValid\"><h4>Select a Schedule</h4><p class=\"text-danger\" ng-if=\"(vm.scheduleLoaded == false) && vm.form.group_selector.$dirty\">Schedule selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Schedule Name</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules\"><td ng-class=\"{\'has-error\':(!vm.scheduleLoaded && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"schedule\" ng-click=\"vm.loadSelectedData(schedule)\"> {{schedule.name}}</label></div></td></tr><tr ng-hide=\"vm.schedules.length\"><td>No Schedules Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Schedule Information\" canexit=\"vm.stepInfoValid\"><h4>Schedule Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Schedule Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"door_group_name\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div></wz-step><wz-step wz-title=\"Add Intervals\"><h4 class=\"pull-left\">Schedule Intervals</h4><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-defaut\" ng-click=\"vm.addInterval()\">Add Interval</button></div><table class=\"table\"><thead><tr><th></th><th>Alarm Active Start Time</th><th>Alarm Active End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeInterval(interval)\" ng-hide=\"(vm.formData.schedule_intervals.length == 1)\"></i></td><td><interval-picker interval=\"interval.start\"></interval-picker></td><td><interval-picker interval=\"interval.end\"></interval-picker></td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Alarm Active Start Time</th><th>Alarm Active End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-io-repeater/schedule-io-repeater-create.html","<wizard on-finish=\"vm.submitCreate()\" name=\"scheduleCreate\" header-text=\"Create A Fixed Device Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Schedule Information\" canexit=\"vm.stepInfoValid\"><h4>Schedule Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Schedule Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"door_group_name\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div></wz-step><wz-step wz-title=\"Add Intervals\"><h4 class=\"pull-left\">Schedule Intervals</h4><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-defaut\" ng-click=\"vm.addInterval()\">Add Interval</button></div><table class=\"table\"><thead><tr><th></th><th>Alarm Active Start Time</th><th>Alarm Active End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeInterval(interval)\" ng-hide=\"(vm.formData.schedule_intervals.length == 1)\"></i></td><td><interval-picker interval=\"interval.start\"></interval-picker></td><td><interval-picker interval=\"interval.end\"></interval-picker></td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Alarm Active Start Time</th><th>Alarm Active End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-io-repeater/schedule-io-repeater-remove.html","<wizard on-finish=\"vm.submitRemove()\" name=\"scheduleCreate\" header-text=\"Remove A Fixed Device Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Schedule\" canexit=\"vm.stepSelectValid\"><h4>Select a Schedule</h4><p class=\"text-danger\" ng-if=\"(vm.scheduleLoaded == false) && vm.form.group_selector.$dirty\">Schedule selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Schedule Name</th><th>In Use</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules\"><td ng-class=\"{\'has-error\':(!vm.scheduleLoaded && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" ng-disabled=\"schedule.in_use\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"schedule\" ng-click=\"vm.loadSelectedData(schedule)\"> {{schedule.name}}</label></div></td><td>{{(schedule.in_use ? \"Yes\":\"No\")}}</td></tr><tr ng-hide=\"vm.schedules.length\"><td>No Schedules Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Alarm Active Start Time</th><th>Alarm Active End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-weekly-access-control/schedule-weekly-access-control-change.html","<wizard on-finish=\"vm.submitChange()\" name=\"scheduleCreate\" header-text=\"Change A Weekly Access Control Unlock Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Schedule\" canexit=\"vm.stepSelectValid\"><h4>Select a Schedule</h4><p class=\"text-danger\" ng-if=\"(vm.scheduleLoaded == false) && vm.form.group_selector.$dirty\">Schedule selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Schedule Name</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules\"><td ng-class=\"{\'has-error\':(!vm.scheduleLoaded && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"schedule\" ng-click=\"vm.loadSelectedData(schedule)\"> {{schedule.name}}</label></div></td></tr><tr ng-hide=\"vm.schedules.length\"><td>No Schedules Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Schedule Information\" canexit=\"vm.stepInfoValid\"><h4>Schedule Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Schedule Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"door_group_name\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Doors in Schedule</label><div class=\"col-sm-10\"><ui-select name=\"doors_in_group\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.doors\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doors | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></wz-step><wz-step wz-title=\"Add Intervals\"><h4 class=\"pull-left\">Schedule Intervals</h4><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-defaut\" ng-click=\"vm.addInterval()\">Add Interval</button></div><table class=\"table\"><thead><tr><th></th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeInterval(interval)\" ng-hide=\"(vm.formData.schedule_intervals.length == 1)\"></i></td><td><interval-picker interval=\"interval.start\"></interval-picker></td><td><interval-picker interval=\"interval.end\"></interval-picker></td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Schedule\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Doors in Schedule:</strong></label> <span class=\"col-sm-10\" ng-repeat=\"door in vm.doors | objectIdSearch:vm.formData.doors\">{{door.name}}{{$last ? \'\' : \', \'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-weekly-access-control/schedule-weekly-access-control-create.html","<wizard on-finish=\"vm.submitCreate()\" name=\"scheduleCreate\" header-text=\"Create A Weekly Access Control Unlock Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Schedule Information\" canexit=\"vm.stepInfoValid\"><h4>Access Control Door Unlock Schedule Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Schedule Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"door_group_name\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Doors in Schedule</label><div class=\"col-sm-10\"><ui-select name=\"doors_in_group\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.doors\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doors | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></wz-step><wz-step wz-title=\"Add Intervals\"><h4 class=\"pull-left\">Add Schedule Intervals</h4><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-defaut\" ng-click=\"vm.addInterval()\">Add Interval</button></div><table class=\"table\"><thead><tr><th></th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeInterval(interval)\" ng-hide=\"(vm.formData.schedule_intervals.length == 1)\"></i></td><td><interval-picker interval=\"interval.start\"></interval-picker></td><td><interval-picker interval=\"interval.end\"></interval-picker></td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Schedule\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Doors in Schedule:</strong></label> <span class=\"col-sm-10\" ng-repeat=\"door in vm.doors | objectIdSearch:vm.formData.doors\">{{door.name}}{{$last ? \'\' : \', \'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-weekly-access-control/schedule-weekly-access-control-remove.html","<wizard on-finish=\"vm.submitRemove()\" name=\"scheduleCreate\" header-text=\"Remove A Weekly Access Control Unlock Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Schedule\" canexit=\"vm.stepSelectValid\"><h4>Select a Wanderer Door Lock Schedule</h4><p class=\"text-danger\" ng-if=\"(vm.scheduleLoaded == false) && vm.form.group_selector.$dirty\">Schedule selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Schedule Name</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules\"><td ng-class=\"{\'has-error\':(!vm.scheduleLoaded && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"schedule\" ng-click=\"vm.loadSelectedData(schedule)\"> {{schedule.name}}</label></div></td></tr><tr ng-hide=\"vm.schedules.length\"><td>No Schedules Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Schedule\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Doors in Schedule:</strong></label> <span class=\"col-sm-10\" ng-repeat=\"door in vm.doors | objectIdSearch:vm.formData.doors\">{{door.name}}{{$last ? \'\' : \', \'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-weekly-staff/schedule-weekly-staff-change.html","<wizard on-finish=\"vm.submitChange()\" name=\"scheduleCreate\" header-text=\"Change A Weekly Door Access Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Schedule\" canexit=\"vm.stepSelectValid\"><h4>Select a Door Access Schedule</h4><p class=\"text-danger\" ng-if=\"(vm.scheduleLoaded == false) && vm.form.group_selector.$dirty\">Schedule selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Schedule Name</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules\"><td ng-if=\"!(schedule.id == 1)\" ng-class=\"{\'has-error\':(!vm.scheduleLoaded && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"schedule\" ng-click=\"vm.loadSelectedData(schedule)\"> {{schedule.name}}</label></div></td></tr><tr ng-hide=\"vm.schedules.length\"><td>No Schedules Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Schedule Information\" canexit=\"vm.stepInfoValid\"><h4>Schedule Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Schedule Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"door_group_name\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div></wz-step><wz-step wz-title=\"Add Intervals\"><h4 class=\"pull-left\">Schedule Intervals</h4><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-defaut\" ng-click=\"vm.addInterval()\">Add Interval</button></div><table class=\"table\"><thead><tr><th></th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeInterval(interval)\" ng-hide=\"(vm.formData.schedule_intervals.length == 1)\"></i></td><td><interval-picker interval=\"interval.start\"></interval-picker></td><td><interval-picker interval=\"interval.end\"></interval-picker></td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-weekly-staff/schedule-weekly-staff-create.html","<wizard on-finish=\"vm.submitCreate()\" name=\"scheduleCreate\" header-text=\"Create A Weekly Door Access Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Schedule Information\" canexit=\"vm.stepInfoValid\"><h4>Weekly Door Access Schedule Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Schedule Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"door_group_name\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div></wz-step><wz-step wz-title=\"Add Intervals\"><h4 class=\"pull-left\">Add Schedule Intervals</h4><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-defaut\" ng-click=\"vm.addInterval()\">Add Interval</button></div><table class=\"table\"><thead><tr><th></th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeInterval(interval)\" ng-hide=\"(vm.formData.schedule_intervals.length == 1)\"></i></td><td><interval-picker interval=\"interval.start\"></interval-picker></td><td><interval-picker interval=\"interval.end\"></interval-picker></td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-weekly-staff/schedule-weekly-staff-remove.html","<wizard on-finish=\"vm.submitRemove()\" name=\"scheduleCreate\" header-text=\"Remove A Weekly Door Access Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Schedule\" canexit=\"vm.stepSelectValid\"><h4>Remove a Door Access Schedule</h4><p class=\"text-danger\" ng-if=\"(vm.scheduleLoaded == false) && vm.form.group_selector.$dirty\">Schedule selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Schedule Name</th><th>Schedule In Use</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules\" ng-if=\"!(schedule.id == 1)\"><td ng-class=\"{\'has-error\':(!vm.scheduleLoaded && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-disabled=\"schedule.in_use\" ng-model=\"vm.selector\" ng-value=\"schedule\" ng-click=\"vm.loadSelectedData(schedule)\"> {{schedule.name}}</label></div></td><td>{{schedule.in_use ? \"In Use\":\"Not In Use\"}}</td></tr><tr ng-hide=\"vm.schedules.length\"><td>No Schedules Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/site-apartment/apartment.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.getApartments()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.apartmentsValid()\" ng-click=\"vm.saveApartments()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-home\"></i>Room List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addApartment()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Room Name</th></tr></thead><tbody><tr dir-paginate=\"apartment in (vm.filteredList = (vm.apartments | orderBy:\'name\' | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedApartment == apartment, \'danger\':!vm.apartmentValid(apartment)}\" ng-if=\"!apartment.deleted\" ng-click=\"vm.selectedApartment = apartment\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedApartment) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedApartment) + 1])\"><td><i class=\"fa fa-minus-circle text-muted\" ng-class=\"{\'text-danger\':!apartment.assigned_devices.length}\" ng-click=\"vm.removeApartment(vm.apartments.indexOf(apartment), apartment)\"></i> {{apartment.name}}</td></tr><tr><td colspan=\"2\" ng-if=\"!vm.filteredList.length\">No Results Found</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Room Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedApartment\">No Room Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedApartment\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Room Name</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedApartment.name\"></td></tr><tr><td>Phone Number</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedApartment.room_phone\"></td></tr><tr><td>Area</td><td><ui-select name=\"output\" ng-model=\"vm.selectedApartment.area\" style=\"width: 100%;\"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"area.id as area in vm.areas | filter:$select.search\">{{area.name}}</ui-select-choices></ui-select></td></tr><tr ng-if=\"vm.userAuth.data.system_license.resident_checkin\"><td>Check-In Active</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedApartment.checkin_active}\" ng-click=\"vm.selectedApartment.checkin_active = false\">Inactive</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedApartment.checkin_active}\" ng-click=\"vm.selectedApartment.checkin_active = true\">Active</button></div></td></tr><tr ng-if=\"vm.userAuth.data.system_license.resident_checkin\"><td>Check-In Schedules</td><td><ui-select name=\"checkin\" multiple=\"\" ng-model=\"vm.selectedApartment.checkin_schedule\" style=\"width: 100%;\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"schedule.id as schedule in vm.schedules | filter:$select.search\">{{schedule.name}}</ui-select-choices></ui-select></td></tr><tr><td>Type</td><td><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : !vm.selectedApartment.common_area}\" ng-click=\"vm.selectedApartment.common_area = false\">Apartment</button></div><div class=\"col-sm-6\"><button class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedApartment.common_area}\" ng-click=\"vm.selectedApartment.common_area = true\">Common Area</button></div></td></tr></tbody></table><h4 ng-if=\"vm.selectedApartment\">Associated Residents & Devices</h4><table class=\"table\" ng-if=\"vm.selectedApartment\"><thead><tr><th>Name</th><th>Type</th></tr></thead><tbody><tr ng-repeat=\"device in vm.selectedApartment.assigned_devices\"><td>{{device.name}}</td><td>{{(device.fixed_device ? \"Fixed Device\":\"Resident\")}}</td></tr><tr ng-if=\"!vm.selectedApartment.assigned_devices.length\"><td colspan=\"2\">No Devices Assigned</td></tr></tbody></table><h4 ng-if=\"vm.selectedApartment\">Associated Locations</h4><table class=\"table\" ng-if=\"vm.selectedApartment\"><thead><tr><th>ID</th><th>Name</th></tr></thead><tbody><tr ng-repeat=\"location in vm.selectedApartment.assigned_locations\"><td>{{location.id}}</td><td>{{location.name}}</td></tr><tr ng-if=\"!vm.selectedApartment.assigned_locations.length\"><td colspan=\"2\">No Devices Assigned</td></tr></tbody></table><div ng-if=\"vm.selectedApartment && vm.userAuth.data.system_license.allegion_active\"><h4 ng-if=\"vm.selectedApartment\">Assigned Locks</h4><table class=\"table\"><thead><tr><th>ID</th><th>Name</th></tr></thead><tbody><tr ng-repeat=\"lock in vm.selectedApartment.assigned_locks\"><td>{{lock.id}}</td><td>{{lock.name}}</td></tr><tr ng-if=\"!vm.selectedApartment.assigned_locks.length\"><td colspan=\"2\">No Locks Assigned</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/schedule-weekly-wanderer/schedule-weekly-wanderer-change.html","<wizard on-finish=\"vm.submitChange()\" name=\"scheduleCreate\" header-text=\"Change A Weekly Wanderer Door Lock Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Schedule\" canexit=\"vm.stepSelectValid\"><h4>Select a Staff Schedule</h4><p class=\"text-danger\" ng-if=\"(vm.scheduleLoaded == false) && vm.form.group_selector.$dirty\">Schedule selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Schedule Name</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules\"><td ng-class=\"{\'has-error\':(!vm.scheduleLoaded && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"schedule\" ng-click=\"vm.loadSelectedData(schedule)\"> {{schedule.name}}</label></div></td></tr><tr ng-hide=\"vm.schedules.length\"><td>No Schedules Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Schedule Information\" canexit=\"vm.stepInfoValid\"><h4>Schedule Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Schedule Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"door_group_name\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Doors in Schedule</label><div class=\"col-sm-10\"><ui-select name=\"doors_in_group\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.doors\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doors | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></wz-step><wz-step wz-title=\"Add Intervals\"><h4 class=\"pull-left\">Schedule Intervals</h4><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-defaut\" ng-click=\"vm.addInterval()\">Add Interval</button></div><table class=\"table\"><thead><tr><th></th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeInterval(interval)\" ng-hide=\"(vm.formData.schedule_intervals.length == 1)\"></i></td><td><interval-picker interval=\"interval.start\"></interval-picker></td><td><interval-picker interval=\"interval.end\"></interval-picker></td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Schedule\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Doors in Schedule:</strong></label> <span class=\"col-sm-10\" ng-repeat=\"door in vm.doors | objectIdSearch:vm.formData.doors\">{{door.name}}{{$last ? \'\' : \', \'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-weekly-wanderer/schedule-weekly-wanderer-create.html","<wizard on-finish=\"vm.submitCreate()\" name=\"scheduleCreate\" header-text=\"Create A Weekly Wanderer Door Lock Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Schedule Information\" canexit=\"vm.stepInfoValid\"><h4>Weekly Wanderer Door Lock Schedule Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Schedule Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"door_group_name\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Doors in Schedule</label><div class=\"col-sm-10\"><ui-select name=\"doors_in_group\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.doors\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doors | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></wz-step><wz-step wz-title=\"Add Intervals\"><h4 class=\"pull-left\">Add Schedule Intervals</h4><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-defaut\" ng-click=\"vm.addInterval()\">Add Interval</button></div><table class=\"table\"><thead><tr><th></th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeInterval(interval)\" ng-hide=\"(vm.formData.schedule_intervals.length == 1)\"></i></td><td><interval-picker interval=\"interval.start\"></interval-picker></td><td><interval-picker interval=\"interval.end\"></interval-picker></td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Schedule\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Doors in Schedule:</strong></label> <span class=\"col-sm-10\" ng-repeat=\"door in vm.doors | objectIdSearch:vm.formData.doors\">{{door.name}}{{$last ? \'\' : \', \'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/schedule-weekly-wanderer/schedule-weekly-wanderer-remove.html","<wizard on-finish=\"vm.submitRemove()\" name=\"scheduleCreate\" header-text=\"Remove A Weekly Wanderer Door Lock Schedule\" ladda-enabled=\"vm.ladda\" header-icon=\"fa-calendar\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Schedule\" canexit=\"vm.stepSelectValid\"><h4>Select a Wanderer Door Lock Schedule</h4><p class=\"text-danger\" ng-if=\"(vm.scheduleLoaded == false) && vm.form.group_selector.$dirty\">Schedule selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Schedule Name</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules\"><td ng-class=\"{\'has-error\':(!vm.scheduleLoaded && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"schedule\" ng-click=\"vm.loadSelectedData(schedule)\"> {{schedule.name}}</label></div></td></tr><tr ng-hide=\"vm.schedules.length\"><td>No Schedules Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Schedule\"><h4>Review Schedule</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Name:</strong></label> <span class=\"col-sm-10\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Doors in Schedule:</strong></label> <span class=\"col-sm-10\" ng-repeat=\"door in vm.doors | objectIdSearch:vm.formData.doors\">{{door.name}}{{$last ? \'\' : \', \'}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Schedule Intervals:</strong></label><div class=\"col-sm-10\"><table class=\"table\"><thead><tr><th>Interval</th><th>Start Time</th><th>End Time</th></tr></thead><tbody><tr ng-repeat=\"interval in vm.formData.schedule_intervals\"><td>Interval {{$index + 1}}</td><td>{{interval.start | intervalParser}}</td><td>{{interval.end | intervalParser}}</td></tr></tbody></table></div></div></wz-step></form></wizard>");
$templateCache.put("app/site-area/area.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.getAreas()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.areasValid()\" ng-click=\"vm.saveAreas()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-home\"></i>Area List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addArea()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Area Name</th></tr></thead><tbody><tr dir-paginate=\"area in (vm.filteredList = (vm.areas | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedArea == area}\" ng-if=\"!area.deleted\" ng-click=\"vm.selectedArea = area\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedArea) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedArea) + 1])\"><td><i class=\"fa fa-minus-circle\" ng-class=\"area.id == 1 || vm.assignedApt(area.id, true) ? \'text-muted\' : \'text-danger\'\" ng-click=\"vm.removeArea($index, area)\"></i> {{area.name}}</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Area Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedArea\">No Area Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedArea\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Area Name</td><td><input ng-disabled=\"vm.selectedArea.id == 1\" type=\"text\" class=\"form-control\" ng-model=\"vm.selectedArea.name\"></td></tr><tr ng-if=\"vm.userAuth.data.system_license.resident_checkin\"><td>Email Check-in Report</td><td><ui-select name=\"output\" multiple=\"\" ng-model=\"vm.selectedArea.checkin_staff\" style=\"width: 100%;\"><ui-select-match>{{$item.first_name}} {{$item.last_name}}</ui-select-match><ui-select-choices repeat=\"staff.id as staff in vm.staff | filter:$select.search\">{{staff.first_name}} {{staff.last_name}}</ui-select-choices></ui-select></td></tr><tr><td>Corridor Light Active</td><td><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.selectedArea.corridor_light.active}\" ng-click=\"vm.corridorLightActive(vm.selectedArea, false)\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.selectedArea.corridor_light.active}\" ng-click=\"vm.corridorLightActive(vm.selectedArea, true)\" ng-disabled=\"!vm.corridorControllers.length\">{{vm.corridorControllers.length ? \'Active\':\'No Controllers Found\'}}</button></div></td></tr><tr ng-if=\"vm.selectedArea.corridor_light.active\"><td>Light Controller</td><td><select class=\"form-control\" ng-options=\"controller.id as controller.name for controller in vm.corridorControllers\" ng-model=\"vm.selectedArea.corridor_light.controller\" ng-change=\"vm.resetCorridorLight(vm.selectedArea)\"></select></td></tr><tr ng-if=\"vm.selectedArea.corridor_light.active\"><td>Light Address</td><td><select class=\"form-control\" ng-if=\"vm.interfaceType(vm.selectedArea.corridor_light.controller) != 17\" ng-options=\"item for item in vm.range(0,31)\" ng-model=\"vm.selectedArea.corridor_light.address\"></select><select class=\"form-control\" ng-if=\"vm.interfaceType(vm.selectedArea.corridor_light.controller) == 17\" ng-options=\"item for item in vm.range(1, vm.maxAddress)\" ng-model=\"vm.selectedArea.corridor_light.address\"></select></td></tr><tr ng-if=\"vm.selectedArea.corridor_light.active && vm.interfaceType(vm.selectedArea.corridor_light.controller) != 17\"><td>Light Color</td><td><select class=\"form-control\" ng-options=\"color.relay as color.color for color in vm.corridorColors\" ng-model=\"vm.selectedArea.corridor_light.relay\"></select></td></tr><tr ng-if=\"vm.selectedArea.corridor_light.active\"><td>Light Flash Rate</td><td><select class=\"form-control\" ng-model=\"vm.selectedArea.corridor_light.rate\"><option ng-if=\"vm.interfaceType(vm.selectedArea.corridor_light.controller) == 17\" ng-repeat=\"item in [\'Constant\', \'Flash\']\">{{item}}</option><option ng-if=\"vm.interfaceType(vm.selectedArea.corridor_light.controller) != 17\" ng-repeat=\"item in [\'Constant\']\">{{item}}</option></select></td></tr></tbody></table><h4 ng-if=\"vm.selectedArea\">Associated Apartments</h4><table class=\"table\" ng-if=\"vm.selectedArea\"><thead><tr><th>Name</th><th>Check-In Active</th></tr></thead><tbody><tr ng-repeat=\"apartment in vm.assignedApt(vm.selectedArea.id, false)\"><td>{{apartment.name}}</td><td>{{(apartment.checkin_active ? \"Yes\":\"No\")}}</td></tr><tr ng-if=\"!vm.assignedApt(vm.selectedArea.id, true)\"><td colspan=\"2\">No Devices Assigned</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/staff/staff-change.html","<wizard on-finish=\"vm.submitChange()\" name=\"staffCreate\" header-text=\"Change a Staff Member\" header-icon=\"fa-bars\" ladda-enabled=\"vm.ladda\" disable-submit=\"\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Staff\" canexit=\"vm.stepSelectValid\"><h4 ng-if=\"vm.initalLoadComplete\">Select a Staff Member</h4><h4 ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i> Loading...</h4><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control ng-pristine ng-valid ng-touched\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><p class=\"text-danger\" ng-if=\"(vm.selector == false) && vm.selectStepSubmitted\">Staff selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Staff Name</th><th>Keycard Code</th><th>Keypad Code</th></tr></thead><tbody><tr dir-paginate=\"staff in vm.filteredStaff = (vm.staff | filter:vm.searchFilter | itemsPerPage:10)\"><td ng-class=\"{\'has-error\':((vm.selector == false) && vm.selectStepSubmitted)}\"><div><label><input type=\"radio\" name=\"resident_selector\" ng-model=\"vm.selector\" ng-value=\"staff\" ng-click=\"vm.loadStaffEvent(staff)\"> {{staff.first_name}} {{staff.last_name}}</label></div></td><td ng-class=\"{\'has-error\':((vm.selector == false) && vm.selectStepSubmitted)}\">{{staff.keycard ? staff.keycard : \"Not Assigned\"}}</td><td ng-class=\"{\'has-error\':((vm.selector == false) && vm.selectStepSubmitted)}\">{{staff.keypad ? staff.keypad : \"Not Assigned\"}}</td></tr><tr ng-hide=\"vm.staff.length\"><td colspan=\"3\">No Staff Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredStaff.length}} of {{vm.staff.length}} Staff</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></wz-step><wz-step wz-title=\"Staff Information\" canexit=\"vm.stepUserValid\"><h4>Staff Member Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">First Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"first_name\" class=\"form-control\" ng-model=\"vm.formData.first_name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Last Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"last_name\" class=\"form-control\" ng-model=\"vm.formData.last_name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Email Address</label><div class=\"col-sm-10\"><input type=\"text\" name=\"email\" class=\"form-control\" ng-model=\"vm.formData.email\" ng-change=\"vm.systemStatusChecker(vm.formData.email)\"></div></div><div class=\"form-group\" ng-if=\"vm.formData.email\"><label class=\"control-label col-sm-2\">Send System Status Report</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.formData.receive_system_status}\" ng-click=\"vm.formData.receive_system_status = false\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.formData.receive_system_status}\" ng-click=\"vm.formData.receive_system_status = true\">Active</button></div></div></div><div class=\"form-group\" ng-if=\"vm.formData.email\"><label class=\"control-label col-sm-2\">Transmitter Test Report</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.formData.receive_tag_test}\" ng-click=\"vm.formData.receive_tag_test = false\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.formData.receive_tag_test}\" ng-click=\"vm.formData.receive_tag_test = true\">Active</button></div></div></div></wz-step><wz-step wz-title=\"Software Access\" canexit=\"vm.stepUiValid\"><h4>Quantum Software Access</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Desktop Access Level</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"vm.formData.access_group\" ng-options=\"item.id as item.name for item in vm.staffAccessGroups\" ng-change=\"vm.staffAccessChange()\"></select></div></div><div class=\"form-group\" ng-if=\"vm.systemLicense.mobile_users\"><label class=\"control-label col-sm-2\">Mobile Access</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.formData.mobile_access}\" ng-click=\"vm.formData.mobile_access = false\">Disabled</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.formData.mobile_access}\" ng-click=\"vm.formData.mobile_access = true\">Enabled</button></div></div></div><div ng-if=\"vm.formData.access_group != 0 || vm.formData.mobile_access\"><div class=\"form-group\"><label class=\"control-label col-sm-2\">Username</label><div class=\"col-sm-10\"><input type=\"text\" name=\"user_name\" class=\"form-control\" ng-model=\"vm.formData.user_name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\" validator=\"vm.validateUsername(vm.formData.user_name)\" invalid-message=\"vm.validateUsernameMsg(vm.formData.user_name)\"></div></div><div class=\"form-group\" ng-if=\"vm.selector.user_name\"><label class=\"control-label col-sm-2\">Reset Password</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"vm.resetPassword\" ng-options=\"option.value as option.label for option in vm.passwordOptions\" ng-change=\"vm.passwordResetChange(vm.resetPassword)\"></select></div></div><div class=\"form-group\" ng-if=\"vm.resetPassword || !vm.selector.user_name\"><label class=\"control-label col-sm-2\">Password</label><div class=\"col-sm-10\"><input type=\"password\" name=\"user_password\" class=\"form-control\" ng-model=\"vm.formData.password\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\" ng-if=\"vm.formData.access_group != 0\"><label class=\"control-label col-sm-2\">Desktop Auto Logout</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"vm.formData.auto_logout\" ng-options=\"item.value as item.lable for item in vm.autoLogoutTimes\"></select></div></div><div class=\"form-group\" ng-if=\"vm.formData.access_group != 0\"><label class=\"control-label col-sm-2\">Desktop Alarm Sound</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.formData.desktop_sound}\" ng-click=\"vm.formData.desktop_sound = false\">Disabled</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.formData.desktop_sound}\" ng-click=\"vm.formData.desktop_sound = true\">Enabled</button></div></div></div></div></wz-step><wz-step wz-disabled=\"{{!vm.systemLicense.wanderer_monitoring && !vm.systemLicense.access_control}}\" wz-title=\"Door Access\" canexit=\"vm.stepDoorValid\"><h4>Quantum Door Access</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Door Access Level</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"vm.formData.door_access_level\" ng-options=\"item.value as item.lable for item in vm.doorAccessLevels\" ng-change=\"vm.doorAccessChange()\"></select></div></div><div ng-show=\"vm.formData.door_access_level != 0\"><div class=\"form-group\"><label class=\"control-label col-sm-2\">Keycard Number</label><div class=\"col-sm-10\"><input type=\"number\" ignore-mouse-number=\"\" name=\"keycard\" class=\"form-control\" ng-model=\"vm.formData.keycard\" validate-on=\"dirty\" validator=\"vm.validateKeycard(vm.formData.keycard)\" invalid-message=\"vm.validateKeycardMsg(vm.formData.keycard)\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Enrolled Keycard</label><div class=\"col-sm-10\"><div class=\"input-group search-box\"><input type=\"text\" ng-disabled=\"true\" placeholder=\"Present Card at Enrollment Station to Enroll\" ignore-mouse-number=\"\" name=\"rawcard\" class=\"form-control\" ng-model=\"vm.formData.raw_card_data\" validate-on=\"dirty\" validator=\"vm.validateRawCard(vm.formData.raw_card_data)\" invalid-message=\"vm.validateRawCardMsg(vm.formData.raw_card_data)\"><div class=\"input-group-btn align-top\"><button class=\"btn\" type=\"button\" ng-click=\"vm.formData.raw_card_data = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Keypad Code</label><div class=\"col-sm-10\"><input type=\"number\" ignore-mouse-number=\"\" name=\"keypad\" class=\"form-control\" ng-model=\"vm.formData.keypad\" validate-on=\"dirty\" validator=\"vm.validateKeypad(vm.formData.keypad)\" invalid-message=\"vm.validateKeypadMsg(vm.formData.keypad)\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Quantum Access Groups</label><div class=\"col-sm-10\" ng-class=\"{\'has-error\': !vm.validateDoorGroup() && vm.form.door_access_groups.$dirty}\"><ui-select name=\"door_access_groups\" multiple=\"\" ng-model=\"vm.formData.door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select><label ng-if=\"!vm.validateDoorGroup() && vm.form.door_access_groups.$dirty && vm.userAuth.data.system_license.allegion_active\" class=\"control-label\">Quantum or Allegion Access Group Required</label> <label ng-if=\"!vm.validateDoorGroup() && vm.form.door_access_groups.$dirty && !vm.userAuth.data.system_license.allegion_active\" class=\"control-label\">Access Group Required</label></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Quantum Access Schedules</label><div class=\"col-sm-10\" ng-class=\"{\'has-error\': !vm.validateDoorSchedule() && vm.form.door_access_schedules.$dirty}\"><ui-select name=\"door_access_schedules\" multiple=\"\" ng-model=\"vm.formData.schedules\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessSchedules | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select><label ng-if=\"!vm.validateDoorSchedule() && vm.form.door_access_schedules.$dirty\" class=\"control-label\">This field is required.</label></div></div><div class=\"form-group\" ng-if=\"vm.userAuth.data.system_license.allegion_active\"><label class=\"control-label col-sm-2\">Allegion Access Groups</label><div class=\"col-sm-10\" ng-class=\"{\'has-error\': !vm.validateDoorGroup() && vm.form.door_access_groups.$dirty}\"><ui-select name=\"allegion_door_access_groups\" multiple=\"\" title=\"true\" ng-model=\"vm.formData.allegion_door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.allegionAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select><label ng-if=\"!vm.validateDoorGroup() && vm.form.allegion_door_access_groups.$dirty\" class=\"control-label\">Quantum or Allegion Access Group Required</label></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Access Expiration</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-change=\"vm.scheduleChange()\" ng-model=\"vm.accessExpiration\" ng-options=\"item.value as item.label for item in [{\'label\':\'Disabled\', \'value\':false},{\'label\':\'Enabled\', \'value\':true}]\"></select></div></div><div class=\"form-group\" ng-show=\"vm.accessExpiration\"><label class=\"control-label col-sm-2\">Valid Dates</label><div class=\"col-sm-10\"><input name=\"timeInterval\" ng-change=\"vm.scheduleChange()\" ng-model-options=\"{ debounce: 100 }\" placeholder=\"Select a Time Range Below\" type=\"daterange\" readonly=\"true\" opens=\"embed\" ng-model=\"vm.date\" class=\"form-control\" datepicker-options=\"vm.datepickerOptions\"></div></div></div></wz-step><wz-step wz-title=\"Review Information\"><h4>Review Staff Member</h4><table class=\"table\"><thead><tr><th>Information Type</th><th>Previous Information</th><th>Updated Information</th></tr></thead><tbody><tr><td>Staff Member Name</td><td>{{vm.selector.first_name}} {{vm.selector.last_name}}</td><td>{{vm.formData.first_name}} {{vm.formData.last_name}}</td></tr><tr><td>Email Address</td><td>{{(vm.selector.email ? vm.selector.email : \"Not Provided\")}}</td><td>{{(vm.formData.email ? vm.formData.email : \"Not Provided\")}}</td></tr><tr><td>Software Access Level</td><td><span ng-repeat=\"item in vm.staffAccessGroups | findObject:vm.selector.access_group\">{{item.name}}</span></td><td><span ng-repeat=\"item in vm.staffAccessGroups | findObject:vm.formData.access_group\">{{item.name}}</span></td></tr><tr ng-if=\"vm.formData.access_group != 0\"><td>Username</td><td>{{(vm.selector.user_name)}}</td><td>{{(vm.formData.user_name)}}</td></tr><tr ng-if=\"vm.formData.access_group != 0\"><td>Auto Logout</td><td><span ng-repeat=\"item in vm.autoLogoutTimes | findObject:vm.selector.auto_logout\">{{item.lable}}</span></td><td><span ng-repeat=\"item in vm.autoLogoutTimes | findObject:vm.formData.auto_logout\">{{item.lable}}</span></td></tr><tr ng-if=\"vm.formData.access_group != 0\"><td>Desktop Alarm Sound</td><td>{{(vm.selector.desktop_sound ? \"Enabled\" : \"Disabled\")}}</td><td>{{(vm.formData.desktop_sound ? \"Enabled\" : \"Disabled\")}}</td></tr><tr><td>Door Access Level</td><td><span ng-repeat=\"item in vm.doorAccessLevels | findObject:vm.selector.door_access_level\">{{item.lable}}</span></td><td><span ng-repeat=\"item in vm.doorAccessLevels | findObject:vm.formData.door_access_level\">{{item.lable}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Keycard Number</td><td>{{(vm.selector.keycard ? vm.selector.keycard : \"Not Provided\")}}</td><td>{{(vm.formData.keycard ? vm.formData.keycard : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Enrolled Keycard</td><td>{{(vm.selector.raw_card_data ? \"Enrolled\" : \"Not Provided\")}}</td><td>{{(vm.formData.raw_card_data ? \"Enrolled\" : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Keypad Code</td><td>{{(vm.selector.keypad ? vm.selector.keypad : \"Not Provided\")}}</td><td>{{(vm.formData.keypad ? vm.formData.keypad : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Quantum Door Access Groups</td><td><span ng-if=\"!vm.selector.door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessGroups | objectIdSearch:vm.selector.door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td><td><span ng-if=\"!vm.formData.door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessGroups | objectIdSearch:vm.formData.door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Quantum Door Access Schedules</td><td><span ng-if=\"!vm.selector.schedules.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessSchedules | objectIdSearch:vm.selector.schedules\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td><td><span ng-if=\"!vm.formData.schedules.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessSchedules | objectIdSearch:vm.formData.schedules\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0 && vm.userAuth.data.system_license.allegion_active\"><td>Allegion Access Groups</td><td><span ng-if=\"!vm.selector.allegion_door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.allegionAccessGroups | objectIdSearch:vm.selector.allegion_door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td><td><span ng-if=\"!vm.formData.allegion_door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.allegionAccessGroups | objectIdSearch:vm.formData.allegion_door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Access Expiration</td><td></td><td>{{(vm.accessExpiration ? \"Enabled\" : \"Disabled\")}}</td></tr><tr ng-if=\"vm.accessExpiration\"><td>Expiration Start Date</td><td>{{vm.selector.start_date | date:\'medium\'}}</td><td>{{vm.formData.start_date | date:\'medium\'}}</td></tr><tr ng-if=\"vm.accessExpiration\"><td>Expiration End Date</td><td>{{vm.selector.end_date | date:\'medium\'}}</td><td>{{vm.formData.end_date | date:\'medium\'}}</td></tr></tbody></table></wz-step></form></wizard>");
$templateCache.put("app/staff/staff-create.html","<wizard on-finish=\"vm.submitCreate()\" name=\"staffCreate\" header-text=\"Create a Staff Member\" header-icon=\"fa-bars\" ladda-enabled=\"vm.ladda\" disable-submit=\"\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Staff Information\" canexit=\"vm.stepUserValid\"><h4>Staff Member Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">First Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"first_name\" class=\"form-control\" ng-model=\"vm.formData.first_name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Last Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"last_name\" class=\"form-control\" ng-model=\"vm.formData.last_name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Email Address</label><div class=\"col-sm-10\"><input type=\"text\" name=\"email\" class=\"form-control\" ng-model=\"vm.formData.email\" ng-change=\"vm.systemStatusChecker(vm.formData.email)\"></div></div><div class=\"form-group\" ng-if=\"vm.formData.email\"><label class=\"control-label col-sm-2\">Send System Status Report</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.formData.receive_system_status}\" ng-click=\"vm.formData.receive_system_status = false\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.formData.receive_system_status}\" ng-click=\"vm.formData.receive_system_status = true\">Active</button></div></div></div><div class=\"form-group\" ng-if=\"vm.formData.email\"><label class=\"control-label col-sm-2\">Transmitter Test Report</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.formData.receive_tag_test}\" ng-click=\"vm.formData.receive_tag_test = false\">Inactive</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.formData.receive_tag_test}\" ng-click=\"vm.formData.receive_tag_test = true\">Active</button></div></div></div></wz-step><wz-step wz-title=\"Software Access\" canexit=\"vm.stepUiValid\"><h4>Quantum Software Access</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Desktop Access Level</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"vm.formData.access_group\" ng-options=\"item.id as item.name for item in vm.staffAccessGroups\" ng-change=\"vm.staffAccessChange()\"></select></div></div><div class=\"form-group\" ng-if=\"vm.systemLicense.mobile_users\"><label class=\"control-label col-sm-2\">Mobile Access</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.formData.mobile_access}\" ng-click=\"vm.formData.mobile_access = false\">Disabled</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.formData.mobile_access}\" ng-click=\"vm.formData.mobile_access = true\">Enabled</button></div></div></div><div ng-if=\"vm.formData.access_group != 0 || vm.formData.mobile_access\"><div class=\"form-group\"><label class=\"control-label col-sm-2\">Username</label><div class=\"col-sm-10\"><input type=\"text\" name=\"user_name\" class=\"form-control\" ng-model=\"vm.formData.user_name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\" validator=\"vm.validateUsername(vm.formData.user_name)\" invalid-message=\"vm.validateUsernameMsg(vm.formData.user_name)\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Password</label><div class=\"col-sm-10\"><input type=\"password\" name=\"user_password\" class=\"form-control\" ng-model=\"vm.formData.password\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\" ng-if=\"vm.formData.access_group != 0\"><label class=\"control-label col-sm-2\">Desktop Auto Logout</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"vm.formData.auto_logout\" ng-options=\"item.value as item.lable for item in vm.autoLogoutTimes\"></select></div></div><div class=\"form-group\" ng-if=\"vm.formData.access_group != 0\"><label class=\"control-label col-sm-2\">Desktop Alarm Sound</label><div class=\"col-sm-10\"><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-warning\' : !vm.formData.desktop_sound}\" ng-click=\"vm.formData.desktop_sound = false\">Disabled</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn-block btn\" ng-class=\"{\'btn-success\' : vm.formData.desktop_sound}\" ng-click=\"vm.formData.desktop_sound = true\">Enabled</button></div></div></div></div></wz-step><wz-step wz-disabled=\"{{!vm.systemLicense.wanderer_monitoring && !vm.systemLicense.access_control}}\" wz-title=\"Door Access\" canexit=\"vm.stepDoorValid\"><h4>Quantum Door Access</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Door Access Level</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"vm.formData.door_access_level\" ng-options=\"item.value as item.lable for item in vm.doorAccessLevels\" ng-change=\"vm.doorAccessChange()\"></select></div></div><div ng-show=\"vm.formData.door_access_level != 0\"><div class=\"form-group\"><label class=\"control-label col-sm-2\">Keycard Number</label><div class=\"col-sm-10\"><input type=\"number\" ignore-mouse-number=\"\" name=\"keycard\" class=\"form-control\" ng-model=\"vm.formData.keycard\" validate-on=\"dirty\" validator=\"vm.validateKeycard(vm.formData.keycard)\" invalid-message=\"vm.validateKeycardMsg(vm.formData.keycard)\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Enrolled Keycard</label><div class=\"col-sm-10\"><div class=\"input-group search-box\"><input type=\"text\" ng-disabled=\"true\" placeholder=\"Present Card at Enrollment Station to Enroll\" ignore-mouse-number=\"\" name=\"rawcard\" class=\"form-control\" ng-model=\"vm.formData.raw_card_data\" validate-on=\"dirty\" validator=\"vm.validateRawCard(vm.formData.raw_card_data)\" invalid-message=\"vm.validateRawCardMsg(vm.formData.raw_card_data)\"><div class=\"input-group-btn align-top\"><button class=\"btn\" type=\"button\" ng-click=\"vm.formData.raw_card_data = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Keypad Code</label><div class=\"col-sm-10\"><input type=\"number\" ignore-mouse-number=\"\" name=\"keypad\" class=\"form-control\" ng-model=\"vm.formData.keypad\" validate-on=\"dirty\" validator=\"vm.validateKeypad(vm.formData.keypad)\" invalid-message=\"vm.validateKeypadMsg(vm.formData.keypad)\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Quantum Access Groups</label><div class=\"col-sm-10\" ng-class=\"{\'has-error\': !vm.validateDoorGroup() && vm.form.door_access_groups.$dirty}\"><ui-select name=\"door_access_groups\" multiple=\"\" ng-model=\"vm.formData.door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select><label ng-if=\"!vm.validateDoorGroup() && vm.form.door_access_groups.$dirty && vm.userAuth.data.system_license.allegion_active\" class=\"control-label\">Quantum or Allegion Access Group Required</label> <label ng-if=\"!vm.validateDoorGroup() && vm.form.door_access_groups.$dirty && !vm.userAuth.data.system_license.allegion_active\" class=\"control-label\">Access Group Required</label></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Quantum Access Schedules</label><div class=\"col-sm-10\" ng-class=\"{\'has-error\': !vm.validateDoorSchedule() && vm.form.door_access_schedules.$dirty}\"><ui-select name=\"door_access_schedules\" multiple=\"\" ng-model=\"vm.formData.schedules\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.doorAccessSchedules | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select><label ng-if=\"!vm.validateDoorSchedule() && vm.form.door_access_schedules.$dirty\" class=\"control-label\">This field is required.</label></div></div><div class=\"form-group\" ng-if=\"vm.userAuth.data.system_license.allegion_active\"><label class=\"control-label col-sm-2\">Allegion Access Groups</label><div class=\"col-sm-10\" ng-class=\"{\'has-error\': !vm.validateDoorGroup() && vm.form.door_access_groups.$dirty}\"><ui-select name=\"allegion_door_access_groups\" multiple=\"\" title=\"true\" ng-model=\"vm.formData.allegion_door_groups\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.allegionAccessGroups | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select><label ng-if=\"!vm.validateDoorGroup() && vm.form.allegion_door_access_groups.$dirty\" class=\"control-label\">Quantum or Allegion Access Group Required</label></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Access Expiration</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-change=\"vm.scheduleChange()\" ng-model=\"vm.accessExpiration\" ng-options=\"item.value as item.label for item in [{\'label\':\'Disabled\', \'value\':false},{\'label\':\'Enabled\', \'value\':true}]\"></select></div></div><div class=\"form-group\" ng-show=\"vm.accessExpiration\"><label class=\"control-label col-sm-2\">Valid Dates</label><div class=\"col-sm-10\"><input name=\"timeInterval\" ng-change=\"vm.scheduleChange()\" ng-model-options=\"{ debounce: 100 }\" placeholder=\"Select a Time Range Below\" type=\"daterange\" readonly=\"true\" opens=\"embed\" ng-model=\"vm.date\" class=\"form-control\" datepicker-options=\"vm.datepickerOptions\"></div></div></div></wz-step><wz-step wz-title=\"Review Information\"><h4>Review Staff Member</h4><table class=\"table\"><thead><tr><th>Information Type</th><th>Submitted Information</th></tr></thead><tbody><tr><td>Staff Member Name</td><td>{{vm.formData.first_name}} {{vm.formData.last_name}}</td></tr><tr><td>Email Address</td><td>{{(vm.formData.email ? vm.formData.email : \"Not Provided\")}}</td></tr><tr><td>Software Access Level</td><td><span ng-repeat=\"item in vm.staffAccessGroups | findObject:vm.formData.access_group\">{{item.name}}</span></td></tr><tr ng-if=\"vm.formData.access_group != 0\"><td>Username</td><td>{{(vm.formData.user_name)}}</td></tr><tr ng-if=\"vm.formData.access_group != 0\"><td>Auto Logout</td><td><span ng-repeat=\"item in vm.autoLogoutTimes | findObject:vm.formData.auto_logout\">{{item.lable}}</span></td></tr><tr ng-if=\"vm.formData.access_group != 0\"><td>Desktop Alarm Sound</td><td>{{(vm.formData.desktop_sound ? \"Enabled\" : \"Disabled\")}}</td></tr><tr><td>Door Access Level</td><td><span ng-repeat=\"item in vm.doorAccessLevels | findObject:vm.formData.door_access_level\">{{item.lable}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Keycard Number</td><td>{{(vm.formData.keycard ? vm.formData.keycard : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Enrolled Keycard</td><td>{{(vm.formData.raw_card_data ? \"Enrolled\" : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Keypad Code</td><td>{{(vm.formData.keypad ? vm.formData.keypad : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Quantum Door Access Groups</td><td><span ng-if=\"!vm.formData.door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessGroups | objectIdSearch:vm.formData.door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Quantum Door Access Schedules</td><td><span ng-if=\"!vm.formData.schedules.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessSchedules | objectIdSearch:vm.formData.schedules\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0 && vm.userAuth.data.system_license.allegion_active\"><td>Allegion Access Groups</td><td><span ng-if=\"!vm.formData.allegion_door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.allegionAccessGroups | objectIdSearch:vm.formData.allegion_door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Access Expiration</td><td>{{(vm.accessExpiration ? \"Enabled\" : \"Disabled\")}}</td></tr><tr ng-if=\"vm.accessExpiration\"><td>Expiration Start Date</td><td>{{vm.formData.start_date | date:\'medium\'}}</td></tr><tr ng-if=\"vm.accessExpiration\"><td>Expiration End Date</td><td>{{vm.formData.end_date | date:\'medium\'}}</td></tr></tbody></table></wz-step></form></wizard>");
$templateCache.put("app/staff/staff-remove.html","<wizard on-finish=\"vm.submitRemove()\" name=\"staffRemove\" header-text=\"Remove a Staff Member\" header-icon=\"fa-bars\" ladda-enabled=\"vm.ladda\" disable-submit=\"\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Staff\" canexit=\"vm.stepSelectValid\"><h4 ng-if=\"vm.initalLoadComplete\">Select a Staff Member</h4><h4 ng-if=\"!vm.initalLoadComplete\"><i class=\"fa fa-spin fa-spinner\"></i> Loading...</h4><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control ng-pristine ng-valid ng-touched\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><p class=\"text-danger\" ng-if=\"(vm.selector == false) && vm.selectStepSubmitted\">Staff selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Staff Name</th><th>Keycard Code</th><th>Keypad Code</th></tr></thead><tbody><tr dir-paginate=\"staff in vm.filteredStaff = (vm.staff | removeId:vm.userAuth.data.id | filter:vm.searchFilter | itemsPerPage:10)\"><td ng-class=\"{\'has-error\':((vm.selector == false) && vm.selectStepSubmitted)}\"><div><label><input type=\"radio\" name=\"resident_selector\" ng-model=\"vm.selector\" ng-value=\"staff\" ng-click=\"vm.loadStaffEvent(staff)\"> {{staff.first_name}} {{staff.last_name}}</label></div></td><td ng-class=\"{\'has-error\':((vm.selector == false) && vm.selectStepSubmitted)}\">{{staff.keycard ? staff.keycard : \"Not Assigned\"}}</td><td ng-class=\"{\'has-error\':((vm.selector == false) && vm.selectStepSubmitted)}\">{{staff.keypad ? staff.keypad : \"Not Assigned\"}}</td></tr><tr ng-hide=\"vm.staff.length\"><td colspan=\"3\">No Staff Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredStaff.length}} of {{vm.staff.length}} Staff</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></wz-step><wz-step wz-title=\"Review Information\"><h4>Review Staff Member</h4><table class=\"table\"><thead><tr><th>Information Type</th><th>Submitted Information</th></tr></thead><tbody><tr><td>Staff Member Name</td><td>{{vm.formData.first_name}} {{vm.formData.last_name}}</td></tr><tr><td>Email Address</td><td>{{(vm.formData.email ? vm.formData.email : \"Not Provided\")}}</td></tr><tr><td>Software Access Level</td><td><span ng-repeat=\"item in vm.staffAccessGroups | findObject:vm.formData.access_group\">{{item.name}}</span></td></tr><tr ng-if=\"vm.formData.access_group != 0\"><td>Username</td><td>{{(vm.formData.user_name)}}</td></tr><tr ng-if=\"vm.formData.access_group != 0\"><td>Auto Logout</td><td><span ng-repeat=\"item in vm.autoLogoutTimes | findObject:vm.formData.auto_logout\">{{item.lable}}</span></td></tr><tr ng-if=\"vm.formData.access_group != 0\"><td>Desktop Alarm Sound</td><td>{{(vm.formData.desktop_sound ? \"Enabled\" : \"Disabled\")}}</td></tr><tr><td>Door Access Level</td><td><span ng-repeat=\"item in vm.doorAccessLevels | findObject:vm.formData.door_access_level\">{{item.lable}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Keycard Number</td><td>{{(vm.formData.keycard ? vm.formData.keycard : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Enrolled Keycard</td><td>{{(vm.formData.raw_card_data ? \"Enrolled\" : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Keypad Code</td><td>{{(vm.formData.keypad ? vm.formData.keypad : \"Not Provided\")}}</td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Quantum Door Access Groups</td><td><span ng-if=\"!vm.formData.door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessGroups | objectIdSearch:vm.formData.door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Quantum Door Access Schedules</td><td><span ng-if=\"!vm.formData.schedules.length\">Not Provided</span><span ng-repeat=\"item in vm.doorAccessSchedules | objectIdSearch:vm.formData.schedules\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0 && vm.userAuth.data.system_license.allegion_active\"><td>Allegion Access Groups</td><td><span ng-if=\"!vm.formData.allegion_door_groups.length\">Not Provided</span><span ng-repeat=\"item in vm.allegionAccessGroups | objectIdSearch:vm.formData.allegion_door_groups\">{{item.name}}{{$last ? \'\' : \', \'}}</span></td></tr><tr ng-if=\"vm.formData.door_access_level != 0\"><td>Access Expiration</td><td>{{(vm.accessExpiration ? \"Enabled\" : \"Disabled\")}}</td></tr><tr ng-if=\"vm.accessExpiration\"><td>Expiration Start Date</td><td>{{vm.formData.start_date | date:\'medium\'}}</td></tr><tr ng-if=\"vm.accessExpiration\"><td>Expiration End Date</td><td>{{vm.formData.end_date | date:\'medium\'}}</td></tr></tbody></table></wz-step></form></wizard>");
$templateCache.put("app/staff-messenger/staff-messenger.html","<div class=\"row\"><div class=\"col-sm-12\"><span class=\"pull-right\"><button class=\"btn\" ng-click=\"vm.getConversations()\">Cancel</button> <button class=\"btn btn-success\" ladda=\"vm.ladda\" data-spinner-size=\"20\" ng-disabled=\"!vm.conversationsValid()\" ng-click=\"vm.saveConversations()\">Save</button></span></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-home\"></i>Conversation List</h3><div class=\"actions\"><a class=\"btn btn-mini\" ng-click=\"vm.addConversation()\"><i class=\"fa fa-plus\"></i></a></div></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Conversation Name</th></tr></thead><tbody><tr dir-paginate=\"conversation in (vm.filteredList = (vm.conversations | filter:vm.searchFilter)) | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedConversation == conversation, \'danger\':!vm.conversationValid(conversation)}\" ng-if=\"!conversation.deleted\" ng-click=\"vm.selectedConversation = conversation\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedConversation) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedConversation) + 1])\"><td><i class=\"fa fa-minus-circle\" ng-class=\"conversation.id == 1 ? \'text-muted\' : \'text-danger\'\" ng-click=\"vm.removeConversation($index, conversation)\"></i> {{conversation.name}}</td></tr></tbody></table><div class=\"center-pagination\"><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-pencil-square-o\"></i> Conversation Editor</h3></div><div class=\"box-content\"><span ng-hide=\"vm.selectedConversation\">No Conversation Selected</span><table class=\"table table-hover\" ng-if=\"vm.selectedConversation\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Conversation Name</td><td><input ng-disabled=\"vm.selectedConversation.id == 1\" type=\"text\" class=\"form-control\" ng-model=\"vm.selectedConversation.name\"></td></tr><td>Email Check-in Report</td><td><ui-select name=\"output\" multiple=\"\" ng-model=\"vm.selectedConversation.checkin_staff\" style=\"width: 100%;\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"staff.id as staff in vm.staff | filter:$select.search\">{{staff.name}}</ui-select-choices></ui-select></td></tbody></table></div></div></div></div>");
$templateCache.put("app/staff-messenger-group/staff-messenger-group-change.html","<wizard on-finish=\"vm.submitWizardChange()\" name=\"accessGroup\" header-icon=\"fa-lock\" header-text=\"Change a Staff Messenger Group\" ladda-enabled=\"vm.laddaEnabled\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Select Group\" canexit=\"vm.stepSelectValid\"><h4>Select a Messenger Group</h4><p class=\"text-danger\" ng-if=\"(vm.selector == false) && vm.form.group_selector.$dirty\">Group selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Group Name</th></tr></thead><tbody><tr ng-repeat=\"group in vm.existingGroups\" ng-if=\"group.id != 1\"><td ng-class=\"{\'has-error\':(!vm.formData.name && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"group\" ng-click=\"vm.loadSelectedData(group)\"> {{group.name}}</label></div></td></tr><tr ng-hide=\"vm.existingGroups.length > 1\"><td>No Groups Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Group Information\" canexit=\"vm.stepInfoValid\"><h4>Staff Messenger Group Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Group Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Staff in Group</label><div class=\"col-sm-10\"><ui-select name=\"staff_data\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.staff_data\"><ui-select-match>{{$item.first_name}} {{$item.last_name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.staff | filter:$select.search\">{{item.first_name}} {{item.last_name}}</ui-select-choices></ui-select></div></div></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Staff Messenger Group</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Group Name:</strong></label> <span id=\"name\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Staff in Group:</strong></label> <span ng-repeat=\"staff in vm.staff | objectIdSearch:vm.formData.staff_data\">{{staff.first_name}} {{staff.last_name}}{{$last ? \'\' : \', \'}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/staff-messenger-group/staff-messenger-group-create.html","<wizard on-finish=\"vm.submitWizardCreate()\" name=\"accessGroup\" header-icon=\"fa-lock\" header-text=\"Create a Staff Messenger Group\" ladda-enabled=\"vm.laddaEnabled\"><form angular-validator=\"\" name=\"vm.form\"><wz-step wz-title=\"Group Information\" canexit=\"vm.stepInfoValid\"><h4>Staff Messenger Group Information</h4><div class=\"form-group\"><label class=\"control-label col-sm-2\">Group Name</label><div class=\"col-sm-10\"><input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.formData.name\" validate-on=\"dirty\" required=\"\" required-message=\"\'This field is required.\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Staff in Group</label><div class=\"col-sm-10\"><ui-select name=\"staff_data\" multiple=\"\" ui-select-required=\"\" ng-model=\"vm.formData.staff_data\"><ui-select-match>{{$item.first_name}} {{$item.last_name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.staff | filter:$select.search\">{{item.first_name}} {{item.last_name}}</ui-select-choices></ui-select></div></div></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Staff Messenger Group</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Group Name:</strong></label> <span id=\"name\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Staff in Group:</strong></label> <span ng-repeat=\"staff in vm.staff | objectIdSearch:vm.formData.staff_data\">{{staff.first_name}} {{staff.last_name}}{{$last ? \'\' : \', \'}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/staff-messenger-group/staff-messenger-group-remove.html","<wizard on-finish=\"vm.submitWizardRemove()\" name=\"accessGroup\" header-icon=\"fa-lock\" header-text=\"Remove a Staff Messenger Group\" ladda-enabled=\"vm.laddaEnabled\"><form name=\"vm.form\"><wz-step wz-title=\"Select Group\" canexit=\"vm.stepSelectValid\"><h4>Select a Messenger Group</h4><p class=\"text-danger\" ng-if=\"(vm.selector == false) && vm.form.group_selector.$dirty\">Group selection required.</p><table class=\"table table-hover table-nomargin\"><thead><tr><th>Group Name</th></tr></thead><tbody><tr ng-repeat=\"group in vm.existingGroups\" ng-if=\"group.id != 1\"><td ng-class=\"{\'has-error\':(!vm.formData.name && vm.form.group_selector.$dirty)}\"><div class=\"radio\"><label><input type=\"radio\" name=\"group_selector\" ng-model=\"vm.selector\" ng-value=\"group\" ng-click=\"vm.loadSelectedData(group)\"> {{group.name}}</label></div></td></tr><tr ng-hide=\"vm.existingGroups.length > 1\"><td>No Groups Found</td></tr></tbody></table></wz-step><wz-step wz-title=\"Review Group\"><h4>Review Staff Messenger Group</h4><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Group Name:</strong></label> <span id=\"name\">{{vm.formData.name}}</span></div><div class=\"form-group\"><label class=\"col-sm-2\"><strong>Staff in Group:</strong></label> <span ng-repeat=\"staff in vm.staff | objectIdSearch:vm.formData.staff_data\">{{staff.first_name}} {{staff.last_name}}{{$last ? \'\' : \', \'}}</span></div></wz-step></form></wizard>");
$templateCache.put("app/staff-send-message/staff-send-message.html","<div class=\"col-sm-5\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-list\"></i> Select Alert Devices</h3></div><div class=\"box-content\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table\"><tbody ng-repeat=\"interface in vm.interfaces | orderBy:\'name\'\" ng-if=\"interface.connection_type != 13\"><tr ng-if=\"interface.alert_devices.length\"><th colspan=\"2\">Interface: {{interface.name}}</th></tr><tr ng-repeat=\"device in interface.alert_devices | filter:vm.searchFilter | orderBy:\'name\'\"><td><label><input type=\"checkbox\" checklist-model=\"vm.formData.selectedAlertDevices\" checklist-value=\"device\"> {{device.name}}</label></td><td>{{device.contact_value}}</td></tr></tbody></table></div></div></div><div class=\"col-sm-7\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-comments-o\"></i> Compose Message</h3></div><div class=\"box-content\"><div class=\"form-group\"><textarea class=\"form-control\" ng-model=\"vm.formData.msg\" rows=\"5\" id=\"comment\"></textarea></div><div class=\"pull-right\"><button type=\"button\" name=\"button\" class=\"btn\" ng-click=\"vm.initForm()\">Cancel</button> <button type=\"button\" name=\"button\" class=\"btn btn-success\" ng-click=\"vm.submitMsg()\" ng-disabled=\"!vm.formData.selectedAlertDevices.length || !vm.formData.msg\">Send</button></div></div></div><div class=\"clearfix\"></div><div class=\"box\" ng-if=\"vm.messageResults.length\"><div class=\"box-title\"><h4>Recent Messages</h4></div><div class=\"box-content\"><table class=\"table\"><thead><tr><th>Device</th><th>Message</th><th>Status</th></tr></thead><tbody><tr ng-repeat=\"result in vm.messageResults\"><td>{{result.alert_device}}</td><td>{{result.message_text}}</td><td><span ng-hide=\"result.response\"><i class=\"fa fa-spin fa-spinner\"></i></span> {{(result.response ? result.response : \"Pending\")}}</td></tr><tr ng-if=\"!vm.messageResults.length\"><td colspan=\"3\">No Current Results</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/staff-status/staff-status.html","<div class=\"pull-right\" style=\"padding-right: 5px;\"><button type=\"button\" class=\"btn\" ng-if=\"!vm.loading\" ng-csv=\"vm.cleanCsv()\" filename=\"{{vm.siteName}}_staff_status.csv\" csv-header=\"vm.csvHeaders\" lazy-load=\"true\">Save CSV</button></div><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa\" ng-class=\"{ \'fa-bars\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=\"vm.initalLoadComplete\">Staff Status</span><span ng-if=\"!vm.initalLoadComplete\">Loading...</span></h3></div><div class=\"input-group search-box\"><input type=\"text\" ng-model=\"vm.searchFilter\" placeholder=\"Search\" class=\"form-control\" aria-invalid=\"false\"><div class=\"input-group-btn\"><button class=\"btn\" type=\"button\" ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th ng-click=\"vm.orderByKey = \'last_name\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Staff Name <span ng-show=\"vm.orderByKey == \'last_name\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'last_name\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'keypad\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Keypad Code <span ng-show=\"vm.orderByKey == \'keypad\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'keypad\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'keycard\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Keycard Code <span ng-show=\"vm.orderByKey == \'keycard\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'keycard\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'Enrolled Keycard\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Enrolled Keycard <span ng-show=\"vm.orderByKey == \'raw_card_data\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'raw_card_data\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'corporate_id\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Type <span ng-show=\"vm.orderByKey == \'corporate_id\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'corporate_id\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'location\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Last Known Location <span ng-show=\"vm.orderByKey == \'location\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'location\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.orderByKey = \'location_time\'; vm.orderReverse = !vm.orderReverse; vm.resort()\">Located <span ng-show=\"vm.orderByKey == \'location_time\' && !vm.orderReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.orderByKey == \'location_time\' && vm.orderReverse\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr dir-paginate=\"staff in vm.filteredStaff = (vm.staff | filter:vm.searchFilter | orderBy:\'+\':vm.orderReverse | itemsPerPage:15)\"><td>{{staff.first_name}} {{staff.last_name}}</td><td>{{staff.keypad ? staff.keypad : \"None\"}}</td><td>{{staff.keycard ? staff.keycard : \"None\"}}</td><td>{{staff.raw_card_data ? \"Enrolled\" : \"None\"}}</td><td>{{staff.corporate_id ? \"Corporate\" : \"Local\"}}</td><td>{{staff.location_name ? staff.location_name : \"Unknown\"}}</td><td>{{staff.location_time ? (staff.location_time | timeago) : \"Unknown\"}}</td></tr><tr><td colspan=\"5\" ng-if=\"!vm.filteredStaff.length && vm.initalLoadComplete\">No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=\"col-md-6\" style=\"margin-top:30px;\">Displaying {{vm.filteredStaff.length}} of {{vm.staff.length}} Staff</div><div class=\"col-md-6\"><dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/components/directiveAllegionErrorTable/allegionErrorTable.html","<div class=\"row\"><div class=\"col-sm-12\"><div class=\"box box-color box-bordered red\"><div class=\"box-title\"><h3><i class=\"fa fa-exclamation-circle\"></i> Allegion Errors</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Lock Name</th><th>Battery Status</th><th>Tamper</th><th>Magnetic Tamper</th></tr></thead><tbody><tr ng-repeat=\"error in vm.systemStatus.data.allegion_error\"><td>{{ error.name }}</td><td><span class=\"text-capitalize\">{{ error.allegion_battery }}</span></td><td>{{ (error.is_tampered ? \"Alert\" : \"Clear\")}}</td><td>{{ (error.mag_tamper ? \"Alert\" : \"Clear\")}}</td></tr><tr ng-hide=\"vm.systemStatus.data.allegion_error.length\"><td colspan=\"5\">No Results Found</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/components/directiveAlarmTable/alarmTable.html","<script type=\"text/ng-template\" id=\"alarmModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"vm.closeModal()\">×</button> <button type=\"button\" class=\"btn btn-small pull-right\" style=\"margin-right:20px\" uib-popover-template=\"\'snoozeTemplate.html\'\" popover-placement=\"bottom-right\" popover-title=\"Snooze Alarm\" popover-trigger=\"outsideClick\" popover-is-open=\"vm.popoverIsOpen\" ng-if=\"!vm.selectedAlarm.is_snoozed && vm.userAuth.data.access_level.reset_alarms && !vm.selectedAlarm.alarm_complete\">Snooze Alarm</button> <button type=\"button\" class=\"btn btn-small pull-right\" style=\"margin-right:20px\" ng-if=\"vm.selectedAlarm.is_snoozed && vm.userAuth.data.access_level.reset_alarms && !vm.selectedAlarm.alarm_complete\" ng-click=\"vm.clearSnooze()\">Clear Snooze</button> <h4 class=\"modal-title\"><i class=\"fa fa-bell-slash\" style=\"color: #e51400\" ng-if=\"vm.selectedAlarm.is_snoozed\"></i> {{vm.selectedAlarm.event}}</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <div ng-if=\"vm.selectedAlarm.additional_locations.length\"> <h4>Additional Locations</h4> <table class=\"table table-nomargin\"> <thead> <tr><th>Location Name</th></tr> </thead> <tbody> <tr ng-repeat=\"location in vm.selectedAlarm.additional_locations track by $index\"> <td> {{location}} </td> </tr> <tr> <td colspan=\"2\" ng-if=\"!vm.filteredAudits.length\">No Results Found</td> </tr> </tbody> </table> <hr /> </div> <h4>Alarm Details</h4> <table class=\"table table-nomargin\"> <thead> <tr><th>Date</th><th>Device</th><th>Message</th><th>Result</th></tr> </thead> <tbody> <tr dir-paginate=\"result in vm.filteredAudits = (vm.selectedAlarm.audit_results | itemsPerPage:10)\"> <td> {{result.time_handled | date:\'medium\':vm.systemStatus.data.offset}} </td> <td> {{result.alert_device_description}} </td> <td> {{result.message_text}} </td> <td> {{result.message_result}} </td> </tr> </tbody> </table> <div class=\"row page-tools\"> <div class=\"col-md-6\" style=\"margin-top:30px;\"> Displaying {{vm.filteredAudits.length}} of {{vm.selectedAlarm.audit_results.length}} Results </div> <div class=\"col-md-6\"> <dir-pagination-controls class=\"pull-right\" style=\"margin:0;\"></dir-pagination-controls> </div> </div> </div> </div></script><script type=\"text/ng-template\" id=\"snoozeTemplate.html\"><form ng-submit=\"vm.snooze()\"> <div class=\"form-group\"> <select class=\"form-control\" ng-model=\"vm.snoozeObject.snooze_time\" ng-options=\"duration.value as duration.label for duration in vm.snoozeDurations\"></select> </div> <div class=\"form-group\"> <input type=\"password\" class=\"form-control input-sm\" placeholder=\"Enter Password\" style=\"padding-right: 24px;\" ng-model=\"vm.snoozeObject.password\"> </div> <button class=\"btn btn-danger btn-block\">Snooze Alarm</button> </form></script><div class=\"row\"><div class=\"col-sm-12\"><div class=\"box box-color box-bordered red\"><div class=\"box-title\"><h3><i class=\"fa fa-warning\"></i> Active Alarms</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th class=\"hidden-480\">Alarm Time</th><th>Event</th><th>Location</th><th>Resident Name</th><th class=\"hidden-480\">Alarm Duration</th></tr></thead><tbody><tr ng-repeat=\"alarm in vm.systemStatus.data.active_alarm\"><td class=\"hidden-480\"><i class=\"fa fa-bell-slash\" style=\"color: #e51400\" ng-if=\"alarm.is_snoozed\"></i> <i class=\"fa fa-user-md\" style=\"color: #368ee0\" ng-if=\"alarm.is_claimed\"></i> {{ alarm.start_time | date:\'medium\':vm.systemStatus.data.offset}}</td><td><a ng-click=\"vm.openModal(alarm)\">{{ alarm.event }}</a></td><td>{{ alarm.location }}</td><td>{{ alarm.name }}</td><td class=\"hidden-480\">{{ vm.calculateDuration(alarm.start_time) }}</td></tr><tr ng-hide=\"vm.systemStatus.data.active_alarm.length\"><td colspan=\"5\">No Results Found</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/components/directiveButtonbar/buttonbar.html","<script type=\"text/ng-template\" id=\"connectionModal.html\"><div class=\"modal-content\" ng-cloak> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myModalLabel\">Server Connection Lost</h4> </div> <!-- /.modal-header --> <div class=\"modal-body\"> <h5><i class=\"fa fa-spinner fa-spin\"></i> Attempting to reconnect, please wait.</h5> </div> </div></script><div class=\"page-header\"><div class=\"pull-left\"><ul class=\"minitiles\"><li id=\"lock_icon\" ng-class=\"(!vm.systemStatus.data.lockdown_status ? \'lightgrey\' : \'red\')\" uib-popover-template=\"\'lockdownTemplate.html\'\" popover-placement=\"right\" popover-title=\"Change Lockdown Status\" popover-trigger=\"outsideClick\" ng-if=\"vm.userAuth.data.access_level.facility_lockdown\"><a><i class=\"fa fa-lock\"></i></a></li></ul></div><script type=\"text/ng-template\" id=\"lockdownTemplate.html\"><form ng-submit=\"vm.lockdownToggle(vm.password)\"> <div style=\"vertical-align: top;display: inline-block;width: auto;white-space: normal; zoom: 1;\"> <input type=\"password\" name=\"lockdown_password\" class=\"form-control input-sm\" placeholder=\"Enter Password\" style=\"padding-right: 24px;\" ng-model=\"vm.password\"> </div> <div style=\"display: inline-block; vertical-align: top; margin-left: 7px; zoom: 1;\"> <button class=\"btn btn-default\"><i class=\"fa fa-check-circle-o\"></i></button> </div> </form></script><div class=\"pull-right\"><ul class=\"stats\"><li ng-show=\"vm.systemStatus.data.repeater_enroll_active\" class=\"red\"><i class=\"fa fa-exclamation-triangle\"></i><div class=\"details\"><span class=\"big\">Config Alert</span> <span>Repeater Enroll Active</span></div></li><li ng-show=\"vm.systemStatus.data.broadcast_active\" class=\"red\"><i class=\"fa fa-exclamation-triangle\"></i><div class=\"details\"><span class=\"big\">Config Alert</span> <span>Broadcast Active</span></div></li><li ng-show=\"vm.systemStatus.data.active_alarm.length\" class=\"red\"><i class=\"fa fa-exclamation-triangle\"></i><div class=\"details\"><span class=\"big\">{{vm.systemStatus.data.active_alarm.length}} Total</span> <span>Active<ng-pluralize count=\"vm.systemStatus.data.active_alarm.length\" when=\"{\'1\': \' Alarm\',\'other\': \' Alarms\'}\"></ng-pluralize></span></div></li><li ng-show=\"vm.systemStatus.data.active_leave.length\" class=\"orange\"><i class=\"fa fa-bell-slash\"></i><div class=\"details\"><span class=\"big\">{{vm.systemStatus.data.active_leave.length}} Total</span> <span>Active<ng-pluralize count=\"vm.systemStatus.data.active_leave.length\" when=\"{\'1\': \' Leave\',\'other\': \' Leaves\'}\"></ng-pluralize></span></div></li><li ng-show=\"vm.systemStatus.data.active_onetime_schedule.length\" class=\"orange\"><i class=\"fa fa-calendar\"></i><div class=\"details\"><span class=\"big\">{{vm.systemStatus.data.active_onetime_schedule.length}} Total</span> <span>Active<ng-pluralize count=\"vm.systemStatus.data.active_onetime_schedule.length\" when=\"{\'1\': \' Schedule\',\'other\': \' Schedules\'}\"></ng-pluralize></span></div></li><li ng-class=\"(!vm.systemStatus.data.low_battery.length && !vm.systemStatus.data.system_error.length) ? \'satgreen\' : (!(vm.systemStatus.data.system_error.length || !vm.systemStatus.server_running == false) ? \'orange\' : \'red\')\"><i class=\"fa fa-check-circle-o\" ng-if=\"!(vm.systemStatus.data.system_error.length || !vm.systemStatus.server_running == false) && !vm.systemStatus.data.low_battery.length\"></i> <i class=\"fa fa fa-battery-quarter\" ng-if=\"!(vm.systemStatus.data.system_error.length || !vm.systemStatus.server_running == false) && vm.systemStatus.data.low_battery.length\"></i> <i class=\"fa fa-exclamation-circle\" ng-if=\"(vm.systemStatus.data.system_error.length || !vm.systemStatus.server_running == false)\"></i><div class=\"details\"><span id=\"system_status_text\" class=\"big\">{{ ((!vm.systemStatus.data.low_battery.length && !(vm.systemStatus.data.system_error.length || !vm.systemStatus.server_running == false)) ? \"System Operational\" : (!(vm.systemStatus.data.system_error.length || !vm.systemStatus.server_running == false) ? \"Low Batteries\" : \"System Error\")) }}</span> <span id=\"system_clock\">{{ vm.systemStatus.data.server_time | date:\'short\':vm.systemStatus.data.offset }}</span></div></li></ul></div></div>");
$templateCache.put("app/components/directiveEventTable/eventTable.html","<div class=\"row\"><div class=\"col-sm-12\"><div class=\"box\"><div class=\"box-title\"><h3><i class=\"fa fa-spin fa-gear\" ng-click=\"vm.enableDebug()\"></i> <span>Recent Events <span ng-if=\"vm.debugMode\">(DEBUG MODE)</span></span></h3></div><div class=\"box-content nopadding\"><div class=\"form-group\" ng-if=\"vm.debugMode\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.eventSearch\" placeholder=\"Search\"></div><table class=\"table table-hover table-nomargin\"><thead><tr><th class=\"hidden-480\">Event Time</th><th>Event</th><th>Location</th><th>Resident Name</th><th>User Name</th></tr></thead><tbody><tr ng-repeat=\"event in vm.eventList | orderBy:vm.eventList.id | filter:vm.eventSearch\" class=\"ngfade\"><td class=\"hidden-480\">{{ event.event_time | date:\'medium\':vm.systemStatus.data.offset}}</td><td>{{ event.event_text }}</td><td>{{ event.location }}</td><td>{{ event.resident_name }}</td><td>{{ event.staff_name }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/components/directiveErrorTable/errorTable.html","<div class=\"row\"><div class=\"col-sm-12\"><div class=\"box box-color box-bordered red\"><div class=\"box-title\"><h3><i class=\"fa fa-exclamation-circle\"></i> System Errors</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Error Description</th><th>Hardware Name</th><th>Hardware IP Address</th><th>Hardware ID</th></tr></thead><tbody><tr ng-repeat=\"error in vm.systemStatus.data.system_error\"><td>{{ error.error_description }}</td><td>{{ error.name }}</td><td>{{ error.ip_address }}</td><td>{{ error.id }}</td></tr><tr ng-hide=\"vm.systemStatus.data.system_error.length\"><td colspan=\"5\">No Results Found</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/components/directiveIntervalPicker/intervalPicker.html","<select ng-disabled=\"vm.disableDay\" ng-model=\"vm.interval.day\" ng-options=\"item.value as item.label for item in vm.days\"></select><select ng-model=\"vm.interval.hour\" ng-options=\"item.value as item.label for item in vm.hours()\"></select><select ng-model=\"vm.interval.minute\" ng-options=\"item.value as item.label for item in vm.minutes\"></select><select ng-model=\"vm.pm\" ng-options=\"item.value as item.label for item in vm.amOrPm\"></select>");
$templateCache.put("app/components/directiveLeaveTable/leaveTable.html","<div class=\"row\"><div class=\"col-sm-12\"><div class=\"box box-color box-bordered orange\"><div class=\"box-title\"><h3><i class=\"fa fa-bell-slash\"></i> Active Scheduled Leaves</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Resident Name</th><th>Start Time</th><th>End Time</th><th ng-if=\"vm.showId\">Leave ID</th></tr></thead><tbody><tr ng-repeat=\"leave in vm.systemStatus.data.active_leave\"><td>{{ leave.name }}</td><td>{{ leave.start_time | date:\'medium\':vm.systemStatus.data.offset }}</td><td>{{ leave.end_time | date:\'medium\':vm.systemStatus.data.offset }}</td><td ng-if=\"vm.showId\">{{ leave.id }}</td></tr><tr ng-hide=\"vm.systemStatus.data.active_leave.length\"><td colspan=\"4\">No Results Found</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/components/directiveLowBattTable/lowBattTable.html","<div class=\"row\"><div class=\"col-sm-12\"><div class=\"box box-color box-bordered orange\"><div class=\"box-title\"><h3><i class=\"fa fa-battery-quarter\"></i> Low Batteries</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Name</th><th>Serial Number</th><th>Device Type</th><th>Device ID</th></tr></thead><tbody><tr ng-repeat=\"alert in vm.systemStatus.data.low_battery\"><td>{{ alert.name }}</td><td>{{ alert.serial_number }}</td><td>{{ alert.device_type }}</td><td>{{ alert.id }}</td></tr><tr ng-hide=\"vm.systemStatus.data.low_battery.length\"><td colspan=\"5\">No Results Found</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/components/directiveMissingDeviceTable/missingDeviceTable.html","<div class=\"row\"><div class=\"col-sm-12\"><div class=\"box box-color box-bordered red\"><div class=\"box-title\"><h3><i class=\"fa fa-question-circle\"></i> Missing Devices</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Name</th><th>Serial Number</th><th>Device Type</th><th>Device ID</th></tr></thead><tbody><tr ng-repeat=\"alert in vm.systemStatus.data.missing_device\"><td>{{ alert.name }}</td><td>{{ alert.serial_number }}</td><td>{{ alert.device_type }}</td><td>{{ alert.id }}</td></tr><tr ng-hide=\"vm.systemStatus.data.missing_device.length\"><td colspan=\"5\">No Results Found</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/components/directiveRepeaterErrorTable/repeaterErrorTable.html","<div class=\"row\"><div class=\"col-sm-12\"><div class=\"box box-color box-bordered red\"><div class=\"box-title\"><h3><i class=\"fa fa-exclamation-circle\"></i> Repeater Errors</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Repeater Name</th><th>Serial Number</th><th>Offline</th><th>Power Loss</th><th>Battery Low</th></tr></thead><tbody><tr ng-repeat=\"error in vm.systemStatus.data.repeater_error\"><td>{{ error.name }}</td><td>{{ error.serial_number }}</td><td>{{ (error.offline ? \"Alert\" : \"Clear\")}}</td><td>{{ (error.power_loss ? \"Alert\" : \"Clear\")}}</td><td>{{ (error.battery_low ? \"Alert\" : \"Clear\")}}</td></tr><tr ng-hide=\"vm.systemStatus.data.repeater_error.length\"><td colspan=\"5\">No Results Found</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/components/directiveNavbar/navbar.html","<div id=\"navigation\"><div class=\"container-fluid\"><a href=\"#\" class=\"toggle-mobile hidden-md hidden-lg hidden-sm\" ng-init=\"navCollapsed = true\" ng-click=\"navCollapsed = !navCollapsed\"><i class=\"fa fa-bars\"></i></a> <a href=\"/\" id=\"brand\">QUANTUM</a><ul class=\"main-nav hidden-xs\"><li uib-dropdown=\"\" ng-repeat=\"topNav in vm.navItems.leftNavigationItems\"><a ng-if=\"topNav.subNav\" uib-dropdown-toggle=\"\" href=\"{{ topNav.link }}\"><span>{{ topNav.name }}</span> <span ng-if=\"topNav.subNav\" class=\"caret\"></span></a> <a ng-if=\"!topNav.subNav\" href=\"{{ topNav.link }}\"><span>{{ topNav.name }}</span> <span ng-if=\"topNav.subNav\" class=\"caret\"></span></a><ul ng-if=\"topNav.subNav\" uib-dropdown-menu=\"\" class=\"dropdown-menu\"><li ng-repeat=\"item in topNav.subNav\" ng-class=\"{\'dropdown-submenu\': item.flyout}\"><a ng-href=\"{{ item.link }}\">{{item.name}}</a><ul ng-if=\"item.flyout\" class=\"dropdown-menu\"><li ng-repeat=\"flyoutItem in item.flyout\"><a ng-href=\"{{ flyoutItem.link }}\">{{ flyoutItem.name }}</a></li></ul></li></ul></li></ul><div class=\"user\"><ul class=\"icon-nav\"><li uib-dropdown=\"topNav.subNav\" on-toggle=\"toggled(open)\" ng-repeat=\"topNav in vm.navItems.rightNavigationItems\"><a uib-dropdown-toggle=\"topNav.subNav\" ng-href=\"{{ topNav.link }}\"><i ng-if=\"topNav.icon\" ng-class=\"topNav.icon\"></i> <span ng-if=\"topNav.name\">{{ topNav.name }}</span> <span ng-if=\"topNav.subNav\" class=\"caret\"></span></a><ul ng-if=\"topNav.subNav\" uib-dropdown-menu=\"\" class=\"dropdown-menu pull-right theme-settings\"><li ng-repeat=\"item in topNav.subNav\"><a ng-if=\"item.download\" target=\"_blank\" ng-href=\"{{item.link}}\" ng-click=\"item.function()\">{{item.name}}</a> <a ng-if=\"!item.download\" ng-href=\"{{item.link}}\" ng-click=\"item.function()\">{{item.name}}</a></li></ul></li></ul></div></div><div class=\"hidden-md hidden-lg hidden-sm\"><div class=\"collapse navbar-collapse\" ng-class=\"!navCollapsed && \'in\'\"><ul class=\"mobile-nav open\"><li uib-dropdown=\"\" ng-repeat=\"topNav in vm.navItems.leftNavigationItems\"><a ng-if=\"topNav.subNav\" uib-dropdown-toggle=\"\" href=\"{{ topNav.link }}\" ng-click=\"vm.openMobileNav = topNav.subNav\"><span>{{ topNav.name }}</span> <span ng-if=\"topNav.subNav\" class=\"caret\"></span></a> <a ng-if=\"!topNav.subNav\" href=\"{{ topNav.link }}\"><span>{{ topNav.name }}</span> <span ng-if=\"topNav.subNav\" class=\"caret\"></span></a><ul ng-if=\"topNav.subNav\" ng-class=\"{\'open\': vm.openMobileNav == topNav.subNav}\"><li ng-repeat=\"item in topNav.subNav\"><a ng-href=\"{{ item.link }}\">{{item.name}}</a><ul ng-if=\"item.flyout\"><li ng-repeat=\"flyoutItem in item.flyout\"><a ng-href=\"{{ flyoutItem.link }}\">{{ flyoutItem.name }}</a></li></ul></li></ul></li></ul></div></div></div>");
$templateCache.put("app/components/directiveScheduleTable/scheduleTable.html","<div class=\"row\"><div class=\"col-sm-12\"><div class=\"box box-color box-bordered orange\"><div class=\"box-title\"><h3><i class=\"fa fa-calendar\"></i> Active One Time Door Schedules</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Schedule Name</th><th>Hardware Name</th><th>Start Time</th><th>End Time</th><th>Schedule Type</th><th ng-if=\"vm.showId\">Schedule ID</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.systemStatus.data.active_onetime_schedule\"><td><i class=\"fa fa-bell-slash\" style=\"color: #e51400\" ng-if=\"!schedule.wandering_enabled\"></i> {{ schedule.name }}</td><td>{{ schedule.door_name }}</td><td>{{ schedule.start_date | date:\'medium\':vm.systemStatus.data.offset }}</td><td>{{ schedule.end_date | date:\'medium\':vm.systemStatus.data.offset }}</td><td>{{ (schedule.access_control_schedule ? \"Access Control Door Unlock\" : \"Wanderer Door Lock\") }}</td><td ng-if=\"vm.showId\">{{ schedule.id }}</td></tr><tr ng-hide=\"vm.systemStatus.data.active_onetime_schedule.length\"><td colspan=\"6\">No Results Found</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/components/directiveSidebar/sidebar.html","<div id=\"left\" class=\"hidden-xs\"><div class=\"subnav\"><div class=\"subnav-title\"><span>Last 24 Hours</span></div><div class=\"subnav-content\"><div class=\"alarm-status-value\">{{vm.systemStatus.alarmSummary.avg_response | number:0}} Minute</div><div class=\"alarm-status-header\">Average Response</div><div class=\"alarm-status-value\">{{vm.systemStatus.alarmSummary.longest_alarm | number:0}} Minute</div><div class=\"alarm-status-header\">Longest Alarm</div><div class=\"alarm-status-value\">{{vm.systemStatus.alarmSummary.number_of_alarms | number:0}} Alarm<span ng-if=\"vm.systemStatus.alarmSummary.number_of_alarms != 1\">s</span></div><div class=\"alarm-status-header\">Total Count</div></div></div><hr class=\"sidebar-hr\"><div class=\"subnav\"><div class=\"subnav-title\"><span>Status Alerts</span></div><div class=\"subnav-subtitle\" ng-show=\"vm.statusClear()\"><span><i class=\"fa fa-check-circle-o\" style=\"color: #56af45;\"></i> No Status Alerts</span></div><div class=\"subnav-subtitle\" ng-show=\"vm.systemStatus.data.active_alarm.length\"><span><ng-pluralize count=\"vm.systemStatus.data.active_alarm.length\" when=\"{\'one\': \'1 Active Alarm\', \'other\': \'{} Active Alarms\'}\"></ng-pluralize></span><ul class=\"subnav-menu\"><li ng-repeat=\"alarm in vm.systemStatus.data.active_alarm\"><a><i class=\"fa fa-bell-slash\" style=\"color: #e51400\" ng-if=\"alarm.is_snoozed\"></i> <i class=\"fa fa-user-md\" style=\"color: #368ee0\" ng-if=\"alarm.is_claimed\"></i> <i class=\"fa fa-warning\" style=\"color: #e51400\" ng-if=\"!alarm.is_snoozed && !alarm.is_claimed\"></i> {{ (alarm.name ? alarm.name:alarm.location) }}</a></li></ul></div><div class=\"subnav-subtitle\" ng-show=\"vm.systemStatus.data.missing_device.length\"><span><ng-pluralize count=\"vm.systemStatus.data.missing_device.length\" when=\"{\'one\': \'1 Missing Device\', \'other\': \'{} Missing Devices\'}\"></ng-pluralize></span><ul class=\"subnav-menu\"><li ng-repeat=\"device in vm.systemStatus.data.missing_device\"><a><i class=\"fa fa-question-circle\" style=\"color: #e51400\"></i> {{device.name}}</a></li></ul></div><div class=\"subnav-subtitle\" ng-show=\"vm.systemStatus.data.low_battery.length\"><span><ng-pluralize count=\"vm.systemStatus.data.low_battery.length\" when=\"{\'one\': \'1 Low Battery\', \'other\': \'{} Low Batteries\'}\"></ng-pluralize></span><ul class=\"subnav-menu\"><li ng-repeat=\"device in vm.systemStatus.data.low_battery\"><a><i class=\"fa fa-battery-quarter\" style=\"color: #e51400\"></i> {{device.name}}</a></li></ul></div><div class=\"subnav-subtitle\" ng-show=\"vm.systemStatus.data.allegion_error.length\"><span><ng-pluralize count=\"vm.systemStatus.data.allegion_error.length\" when=\"{\'one\': \'1 Allegion Error\', \'other\': \'{} Allegion Errors\'}\"></ng-pluralize></span><ul class=\"subnav-menu\"><li ng-repeat=\"device in vm.systemStatus.data.allegion_error\"><a><i class=\"fa fa-magnet\" style=\"color: #e51400\" ng-if=\"device.mag_tamper\"></i> <i class=\"fa fa-battery-quarter\" style=\"color: #e51400\" ng-if=\"device.allegion_battery == \'low\'\"></i> <i class=\"fa fa-battery-empty\" style=\"color: #e51400\" ng-if=\"device.allegion_battery == \'critical\'\"></i> <i class=\"fa fa-exclamation-triangle\" style=\"color: #e51400\" ng-if=\"device.is_tampered\"></i> {{device.name}}</a></li></ul></div><div class=\"subnav-subtitle\" ng-show=\"vm.systemStatus.data.repeater_error.length\"><span><ng-pluralize count=\"vm.systemStatus.data.repeater_error.length\" when=\"{\'one\': \'1 Repeater Error\', \'other\': \'{} Repeater Errors\'}\"></ng-pluralize></span><ul class=\"subnav-menu\"><li ng-repeat=\"device in vm.systemStatus.data.repeater_error\"><a><i class=\"fa fa-battery-quarter\" style=\"color: #e51400\" ng-if=\"device.battery_low\"></i> <i class=\"fa fa-power-off\" style=\"color: #e51400\" ng-if=\"device.power_loss\"></i> <i class=\"fa fa-question-circle\" style=\"color: #e51400\" ng-if=\"device.offline\"></i> {{device.name}}</a></li></ul></div><div class=\"subnav-subtitle\" ng-show=\"vm.systemStatus.data.active_leave.length\"><span><ng-pluralize count=\"vm.systemStatus.data.active_leave.length\" when=\"{\'one\': \'1 Active Leave\', \'other\': \'{} Active Leaves\'}\"></ng-pluralize></span><ul class=\"subnav-menu\"><li ng-repeat=\"leave in vm.systemStatus.data.active_leave\"><a><i class=\"fa fa-bell-slash\" style=\"color: #e51400\"></i> {{ leave.name }}</a></li></ul></div></div></div>");
$templateCache.put("app/components/directiveUnmonitoredHardwareTable/unmonitoredHardware.html","<div class=\"row\"><div class=\"col-sm-12\"><div class=\"box box-color box-bordered red\"><div class=\"box-title\"><h3><i class=\"fa fa-exclamation-circle\"></i> Unmonitored Hardware</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Hardware ID</th><th>Hardware Name</th></tr></thead><tbody><tr ng-repeat=\"harware in vm.systemStatus.data.unmonitored_hardware\"><td>{{ harware.id }}</td><td>{{ harware.name }}</td></tr><tr ng-hide=\"vm.systemStatus.data.unmonitored_hardware.length\"><td colspan=\"5\">No Results Found</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/components/directiveWarningBar/warningBar.html","<div class=\"warning-bar\" ng-if=\"!vm.systemStatus.data.install_complete\"><button ng-disabled=\"!vm.userAuth.data.access_level.system_config\" type=\"button\" name=\"button\" class=\"pull-right btn\" ng-click=\"vm.activateSystemRedirect()\">System Configuration</button><h3><i class=\"fa fa-warning\"></i> ALERT: INSTALL NOT COMPLETE</h3></div><div class=\"warning-bar\" ng-if=\"vm.systemStatus.data.unmonitored_hardware.length\"><button type=\"button\" name=\"button\" class=\"pull-right btn\" ng-click=\"vm.systemStatusRedirect()\">System Status</button><h3><i class=\"fa fa-warning\"></i> WARNING: UNMONITORED HARDWARE</h3></div>");}]);